/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

type UtilRequiredKeys<T, K extends keyof T> = Omit<T, K> & Required<Pick<T, K>>;

/**
* 2 = Approved
3 = Reproved
4 = Rejected
* @format int32
*/
export enum WorkflowPreApprovalOption {
  Approved = 2,
  Reproved = 3,
  Rejected = 4,
}

/**
* 0 = Oldest
1 = Newest
2 = Username
3 = TrainingName
* @format int32
*/
export enum WorkflowApprovalsOrderBy {
  Oldest = 0,
  Newest = 1,
  Username = 2,
  TrainingName = 3,
}

/**
* 1 = Registration
2 = Survey
3 = Evaluation
4 = DirectMessage
5 = TrainingInfo
* @format int32
*/
export enum WelcomeDialogs {
  Registration = 1,
  Survey = 2,
  Evaluation = 3,
  DirectMessage = 4,
  TrainingInfo = 5,
}

/**
* 0 = Internal
1 = External
2 = System
3 = Admin
4 = Api
* @format int32
*/
export enum UserType {
  Internal = 0,
  External = 1,
  System = 2,
  Admin = 3,
  Api = 4,
}

/**
* 0 = CurrentMainManagers
1 = CurrentSecondaryManagers
2 = CurrentApprovers
3 = Any
* @format int32
*/
export enum UserSuggestionsType {
  CurrentMainManagers = 0,
  CurrentSecondaryManagers = 1,
  CurrentApprovers = 2,
  Any = 3,
}

/**
* 0 = Active
1 = ActiveWithLoginBlocked
2 = Inactive
3 = Deleted
4 = WaitingApproval
* @format int32
*/
export enum UserStatus {
  Active = 0,
  ActiveWithLoginBlocked = 1,
  Inactive = 2,
  Deleted = 3,
  WaitingApproval = 4,
}

/**
* 1 = Linkedin
2 = Facebook
3 = Twitter
4 = Instagram
* @format int32
*/
export enum UserSocialNetworkType {
  Linkedin = 1,
  Facebook = 2,
  Twitter = 3,
  Instagram = 4,
}

/**
* 1 = User
2 = Group
3 = Unit
4 = Topic
5 = Tag
6 = Role
7 = QuickFilter
8 = Channel
9 = PublicationChannel
10 = UserPublicationRecommendation
11 = UserManager
12 = UserApprover
13 = QuesionGroup
14 = UserMention
17 = Assessment
* @format int32
*/
export enum UserSelectionEntityType {
  User = 1,
  Group = 2,
  Unit = 3,
  Topic = 4,
  Tag = 5,
  Role = 6,
  QuickFilter = 7,
  Channel = 8,
  PublicationChannel = 9,
  UserPublicationRecommendation = 10,
  UserManager = 11,
  UserApprover = 12,
  QuesionGroup = 13,
  UserMention = 14,
  Assessment = 17,
}

/**
* 0 = Relevance
1 = Name
2 = Publications
* @format int32
*/
export enum UserSearchOrderBy {
  Relevance = 0,
  Name = 1,
  Publications = 2,
}

/**
* 1 = Work
2 = Personal
3 = Mobile
4 = Residential
5 = Main
6 = Fax
7 = WhatsApp
* @format int32
*/
export enum UserPhoneType {
  Work = 1,
  Personal = 2,
  Mobile = 3,
  Residential = 4,
  Main = 5,
  Fax = 6,
  WhatsApp = 7,
}

/**
* 1 = Block
2 = GeneralInfo
3 = AdditionalInfo
4 = Managers
5 = Groups
6 = Units
7 = Topics
8 = Tags
9 = Roles
10 = BroadcastMessage
* @format int32
*/
export enum UserOperationType {
  Block = 1,
  GeneralInfo = 2,
  AdditionalInfo = 3,
  Managers = 4,
  Groups = 5,
  Units = 6,
  Topics = 7,
  Tags = 8,
  Roles = 9,
  BroadcastMessage = 10,
}

/**
* 1 = Add
2 = Replace
3 = Remove
* @format int32
*/
export enum UserOperationAction {
  Add = 1,
  Replace = 2,
  Remove = 3,
}

/**
* 1 = Basic
2 = Intermediate
3 = Advanced
4 = Proficient
* @format int32
*/
export enum UserIdiomProficiencyType {
  Basic = 1,
  Intermediate = 2,
  Advanced = 3,
  Proficient = 4,
}

/**
* 0 = OneMonth
1 = ThreeMonths
2 = SixMonths
3 = OneYear
4 = ThreeYears
5 = FiveYears
6 = MoreThan5Years
* @format int32
*/
export enum UserIdiomAbroadExperienceTime {
  OneMonth = 0,
  ThreeMonths = 1,
  SixMonths = 2,
  OneYear = 3,
  ThreeYears = 4,
  FiveYears = 5,
  MoreThan5Years = 6,
}

/**
* 1 = PositionsHeld
2 = ProfessionalExperience
3 = WorkProjects
4 = AcademicBackground
5 = Research
6 = PaperOrPublication
7 = InternationalActivity
8 = VolunteerWork
* @format int32
*/
export enum UserCredentialType {
  PositionsHeld = 1,
  ProfessionalExperience = 2,
  WorkProjects = 3,
  AcademicBackground = 4,
  Research = 5,
  PaperOrPublication = 6,
  InternationalActivity = 7,
  VolunteerWork = 8,
}

/**
* 0 = Match
1 = NotMatch
2 = Expired
* @format int32
*/
export enum TwoFactorEmailValidationResult {
  Match = 0,
  NotMatch = 1,
  Expired = 2,
}

/**
* 0 = None
1 = Email
2 = AppAuthenticator
* @format int32
*/
export enum TwoFactorAuthMethods {
  None = 0,
  Email = 1,
  AppAuthenticator = 2,
}

/**
* 0 = Like
1 = Unlike
2 = Bookmark
3 = RemoveBookmark
* @format int32
*/
export enum TrainingUserInteractionOption {
  Like = 0,
  Unlike = 1,
  Bookmark = 2,
  RemoveBookmark = 3,
}

/**
* 0 = Course
1 = ExternalCourse
2 = LearningPath
* @format int32
*/
export enum TrainingType {
  Course = 0,
  ExternalCourse = 1,
  LearningPath = 2,
}

/**
* 0 = NoShow
1 = Optional
2 = Required
* @format int32
*/
export enum TrainingThreeStateInfo {
  NoShow = 0,
  Optional = 1,
  Required = 2,
}

/**
* 0 = Denied
1 = TargetAudience
2 = AnyUser
* @format int32
*/
export enum TrainingShareOption {
  Denied = 0,
  TargetAudience = 1,
  AnyUser = 2,
}

/**
* 0 = Any
1 = Immediate
2 = Next7
3 = Next30
4 = Over30
5 = Custom
* @format int32
*/
export enum TrainingSearchStart {
  Any = 0,
  Immediate = 1,
  Next7 = 2,
  Next30 = 3,
  Over30 = 4,
  Custom = 5,
}

/**
* 0 = All
2 = Title
* @format int32
*/
export enum TrainingSearchRestriction {
  All = 0,
  Title = 2,
}

/**
* 0 = Any
1 = Last24Hours
2 = LastWeek
3 = LastMonth
4 = LastYear
5 = OverYear
6 = Custom
* @format int32
*/
export enum TrainingSearchPublication {
  Any = 0,
  Last24Hours = 1,
  LastWeek = 2,
  LastMonth = 3,
  LastYear = 4,
  OverYear = 5,
  Custom = 6,
}

/**
* 0 = Any
1 = Until5
2 = Between5And30
3 = Between30And60
4 = Between60And300
5 = Between300And600
6 = Over600
* @format int32
*/
export enum TrainingSearchDuration {
  Any = 0,
  Until5 = 1,
  Between5And30 = 2,
  Between30And60 = 3,
  Between60And300 = 4,
  Between300And600 = 5,
  Over600 = 6,
}

/**
* 0 = Default
1 = Maximized
3 = Custom
* @format int32
*/
export enum TrainingScormPlayerWindowOption {
  Default = 0,
  Maximized = 1,
  Custom = 3,
}

/**
* 0 = Title
1 = MoreRecent
* @format int32
*/
export enum TrainingRelationshipSelectorOrderBy {
  Title = 0,
  MoreRecent = 1,
}

/**
* 0 = MostRecent
1 = HighestRating
2 = LowestRating
* @format int32
*/
export enum TrainingRatingsOrderBy {
  MostRecent = 0,
  HighestRating = 1,
  LowestRating = 2,
}

/**
* 0 = Denied
1 = AnyTime
2 = AfterFinalization
* @format int32
*/
export enum TrainingRatingOption {
  Denied = 0,
  AnyTime = 1,
  AfterFinalization = 2,
}

/**
* 0 = Approved
1 = Reproved
2 = NotAttended
3 = NotAttendedOrReproved
* @format int32
*/
export enum TrainingPreRequisiteOption {
  Approved = 0,
  Reproved = 1,
  NotAttended = 2,
  NotAttendedOrReproved = 3,
}

/**
* 0 = TrainingPanel
1 = Team
2 = Tutor
* @format int32
*/
export enum TrainingPanelType {
  TrainingPanel = 0,
  Team = 1,
  Tutor = 2,
}

/**
* 0 = Ascending
1 = Descending
* @format int32
*/
export enum TrainingPanelOrderDirection {
  Ascending = 0,
  Descending = 1,
}

/**
* 0 = TargetTrainings
1 = TrainingsAcceptEnrolls
2 = TargetUsers
3 = MandatoryAudienceUsers
* @format int32
*/
export enum TrainingPanelIndicatorDimension {
  TargetTrainings = 0,
  TrainingsAcceptEnrolls = 1,
  TargetUsers = 2,
  MandatoryAudienceUsers = 3,
}

/**
* 0 = Trainings
1 = Classrooms
2 = Enrolls
3 = Topics
4 = TopicTrainings
* @format int32
*/
export enum TrainingPanelDrillOption {
  Trainings = 0,
  Classrooms = 1,
  Enrolls = 2,
  Topics = 3,
  TopicTrainings = 4,
}

/**
* 0 = Trainings
1 = ApprovalRate
2 = CancelationRate
3 = OpinionRate
4 = Likes
5 = MandatoryNotEnrolled
6 = MandatoryInProgress
7 = MandatoryNotConcluded
8 = MandatoryConcluded
9 = MandatoryExempt
10 = MandatoryLapsed
11 = CertificationValid
12 = CertificationExpiring
13 = CertificationExpiredLong
14 = CertificationExpiredShort
15 = CertificationRecertification
16 = EngagementInAudience
17 = EngagementFinalized
18 = EngagementNotFinalized
19 = EngagementApproved
20 = EngagementNotApproved
21 = StatusNotStarted
22 = StatusInProgress
23 = StatusReproved
24 = StatusApproved
25 = StatusCanceled
26 = StatusDelayed
27 = StatusLapsed
28 = FinalizationApprovedScoreAvg
29 = FinalizationCompletionApproved
30 = FinalizationCompletionReproved
31 = FinalizationConcludedOnTime
32 = FinalizationConcludedDelayed
* @format int32
*/
export enum TrainingPanelAnalyseDimension {
  Trainings = 0,
  ApprovalRate = 1,
  CancelationRate = 2,
  OpinionRate = 3,
  Likes = 4,
  MandatoryNotEnrolled = 5,
  MandatoryInProgress = 6,
  MandatoryNotConcluded = 7,
  MandatoryConcluded = 8,
  MandatoryExempt = 9,
  MandatoryLapsed = 10,
  CertificationValid = 11,
  CertificationExpiring = 12,
  CertificationExpiredLong = 13,
  CertificationExpiredShort = 14,
  CertificationRecertification = 15,
  EngagementInAudience = 16,
  EngagementFinalized = 17,
  EngagementNotFinalized = 18,
  EngagementApproved = 19,
  EngagementNotApproved = 20,
  StatusNotStarted = 21,
  StatusInProgress = 22,
  StatusReproved = 23,
  StatusApproved = 24,
  StatusCanceled = 25,
  StatusDelayed = 26,
  StatusLapsed = 27,
  FinalizationApprovedScoreAvg = 28,
  FinalizationCompletionApproved = 29,
  FinalizationCompletionReproved = 30,
  FinalizationConcludedOnTime = 31,
  FinalizationConcludedDelayed = 32,
}

/**
* 0 = Always
1 = WhenFinalizedCurrentVersion
2 = WhenApprovedSinceDate
3 = WhenFinalizedSinceDays
4 = Never
* @format int32
*/
export enum TrainingLearnPathReuseOption {
  Always = 0,
  WhenFinalizedCurrentVersion = 1,
  WhenApprovedSinceDate = 2,
  WhenFinalizedSinceDays = 3,
  Never = 4,
}

/**
* 0 = Never
1 = FirstComponentOnly
2 = NextComponent
3 = All
* @format int32
*/
export enum TrainingLearnPathComponentAutoEnrollOption {
  Never = 0,
  FirstComponentOnly = 1,
  NextComponent = 2,
  All = 3,
}

/**
* 1 = Pending
2 = InProgress
3 = Concluded
4 = Exempt
* @format int32
*/
export enum TrainingIndexTrainingClassification {
  Pending = 1,
  InProgress = 2,
  Concluded = 3,
  Exempt = 4,
}

/**
* 0 = Best
1 = Worst
* @format int32
*/
export enum TrainingIndexOrderBy {
  Best = 0,
  Worst = 1,
}

/**
* 1 = General
2 = Units
3 = Team
4 = Personal
* @format int32
*/
export enum TrainingIndexOptions {
  General = 1,
  Units = 2,
  Team = 3,
  Personal = 4,
}

/**
* 0 = None
1 = ByManager
2 = BySpecificApprover
* @format int32
*/
export enum TrainingExternalCourseApprovalOption {
  None = 0,
  ByManager = 1,
  BySpecificApprover = 2,
}

/**
* 0 = AnyTime
1 = UntilSpecifedDate
2 = UntilDaysAfterStartTraining
* @format int32
*/
export enum TrainingDueDateOption {
  AnyTime = 0,
  UntilSpecifedDate = 1,
  UntilDaysAfterStartTraining = 2,
}

/**
* 0 = Web
1 = WebAndLive
2 = LivePresential
3 = LiveOnline
4 = LiveMix
5 = Evaluation
7 = Activity
8 = Game
9 = LearnPath
10 = ExternalCourse
* @format int32
*/
export enum TrainingContentType {
  Web = 0,
  WebAndLive = 1,
  LivePresential = 2,
  LiveOnline = 3,
  LiveMix = 4,
  Evaluation = 5,
  Activity = 7,
  Game = 8,
  LearnPath = 9,
  ExternalCourse = 10,
}

/**
* 0 = Post
1 = Sco
2 = Evaluation
3 = Meeting
4 = Activity
5 = Phase
6 = LearnPathTraining
* @format int32
*/
export enum TrainingComponentType {
  Post = 0,
  Sco = 1,
  Evaluation = 2,
  Meeting = 3,
  Activity = 4,
  Phase = 5,
  LearnPathTraining = 6,
}

/**
* 0 = Denied
1 = UntilSpecifedDate
2 = UntilDaysAfterRegistration
3 = AnyTime
* @format int32
*/
export enum TrainingCancellationOption {
  Denied = 0,
  UntilSpecifedDate = 1,
  UntilDaysAfterRegistration = 2,
  AnyTime = 3,
}

/**
* 0 = Reaction
1 = UserEfficacy
2 = ManagerEfficacy
* @format int32
*/
export enum TraininPanelAssDataset {
  Reaction = 0,
  UserEfficacy = 1,
  ManagerEfficacy = 2,
}

/**
* 0 = MostViewed
1 = Latest
2 = Registered
3 = SearchText
* @format int32
*/
export enum TopicSubscriptionFilterBy {
  MostViewed = 0,
  Latest = 1,
  Registered = 2,
  SearchText = 3,
}

/**
* 0 = List
1 = Hierarchical
2 = Breadcrumbs
* @format int32
*/
export enum TopicSelectorType {
  List = 0,
  Hierarchical = 1,
  Breadcrumbs = 2,
}

/**
* 0 = Manage
1 = Normal
* @format int32
*/
export enum TopicSelectorMode {
  Manage = 0,
  Normal = 1,
}

/**
* 0 = Relevance
1 = Name
2 = Publications
* @format int32
*/
export enum TopicSearchOrderBy {
  Relevance = 0,
  Name = 1,
  Publications = 2,
}

/**
* 1 = Manual
2 = Discovery
* @format int32
*/
export enum TopicRelationOrigin {
  Manual = 1,
  Discovery = 2,
}

/**
* 0 = Bundler
1 = Knowledge
2 = Skill
3 = Competency
* @format int32
*/
export enum TopicCategory {
  Bundler = 0,
  Knowledge = 1,
  Skill = 2,
  Competency = 3,
}

/**
* 2 = MonthlyUsers
3 = LicensedUsers
* @format int32
*/
export enum TenantBillingType {
  MonthlyUsers = 2,
  LicensedUsers = 3,
}

/**
* 1 = User
2 = UserInterest
4 = Unit
8 = Group
16 = Topic
32 = Learning
64 = Assessment
128 = Publication
* @format int32
*/
export enum TagUsage {
  User = 1,
  UserInterest = 2,
  Unit = 4,
  Group = 8,
  Topic = 16,
  Learning = 32,
  Assessment = 64,
  Publication = 128,
}

/**
* 0 = Active
1 = Forbidden
* @format int32
*/
export enum TagRestriction {
  Active = 0,
  Forbidden = 1,
}

/**
* 0 = None
1 = Reached80
2 = Reached90
3 = Reached100
* @format int32
*/
export enum SystemUsageThreshold {
  None = 0,
  Reached80 = 1,
  Reached90 = 2,
  Reached100 = 3,
}

/**
* 0 = All
1 = Nobody
2 = ByAudience
* @format int32
*/
export enum SystemSettingIaTargetUser {
  All = 0,
  Nobody = 1,
  ByAudience = 2,
}

/**
* 0 = Unknown
1 = FoundationUser
2 = FoundationGroup
3 = FoundationSystemUser
6 = FoundationTopic
7 = FoundationUserProfileBackground
8 = FoundationLink
9 = FoundationBannerBackground
16 = FoundationVideoEncoding
17 = FoundationVideoMp4
19 = KnowledgeChannel
20 = KnowledgeListFavorite
21 = KnowledgeListSeeLater
32 = KnowledgePublicationTypeList
33 = KnowledgePublicationTypePost
34 = KnowledgePublicationTypeQuestion
36 = KnowledgePublicationTypePoll
37 = KnowledgePublicationTypeAudio
38 = KnowledgePublicationTypeDocument
39 = KnowledgePublicationTypeFile
40 = KnowledgePublicationTypeLink
42 = KnowledgePublicationTypeArticle
48 = LmsContentTypeActivity
49 = LmsContentTypeEvaluation
51 = LmsContentTypeWebAndLive
52 = LmsContentTypeLiveMix
53 = LmsContentTypeLivePresential
54 = LmsContentTypeLiveOnline
55 = LmsContentTypeCourseWeb
56 = LmsContentTypeLearnPath
57 = LmsContentTypeExternalCourse
59 = LmsStudentLibrary
64 = AssEvaluation
65 = AssSurvey
80 = AwardBadge
* @format int32
*/
export enum SystemImages {
  Unknown = 0,
  FoundationUser = 1,
  FoundationGroup = 2,
  FoundationSystemUser = 3,
  FoundationTopic = 6,
  FoundationUserProfileBackground = 7,
  FoundationLink = 8,
  FoundationBannerBackground = 9,
  FoundationVideoEncoding = 16,
  FoundationVideoMp4 = 17,
  KnowledgeChannel = 19,
  KnowledgeListFavorite = 20,
  KnowledgeListSeeLater = 21,
  KnowledgePublicationTypeList = 32,
  KnowledgePublicationTypePost = 33,
  KnowledgePublicationTypeQuestion = 34,
  KnowledgePublicationTypePoll = 36,
  KnowledgePublicationTypeAudio = 37,
  KnowledgePublicationTypeDocument = 38,
  KnowledgePublicationTypeFile = 39,
  KnowledgePublicationTypeLink = 40,
  KnowledgePublicationTypeArticle = 42,
  LmsContentTypeActivity = 48,
  LmsContentTypeEvaluation = 49,
  LmsContentTypeWebAndLive = 51,
  LmsContentTypeLiveMix = 52,
  LmsContentTypeLivePresential = 53,
  LmsContentTypeLiveOnline = 54,
  LmsContentTypeCourseWeb = 55,
  LmsContentTypeLearnPath = 56,
  LmsContentTypeExternalCourse = 57,
  LmsStudentLibrary = 59,
  AssEvaluation = 64,
  AssSurvey = 65,
  AwardBadge = 80,
}

/**
* 0 = Challenge
10 = DevelopmentPlan
11 = UserProgress
12 = UserAwards
13 = UserProfileView
20 = TrainingNome
21 = TrainingCatalog
22 = MeetingCalendar
23 = TrainingLibrary
24 = TrainingHistory
25 = UserProfileEdit
30 = KnowledgeHome
31 = KnowledgeInterests
32 = KnowledgeShorts
33 = KnowledgeSeeLater
34 = KnowledgeFavorites
35 = KnowledgeQA
36 = KnowledgeCreatePublication
37 = PerformaManageGoal
38 = PerformaManageAd
* @format int32
*/
export enum SystemFeature {
  Challenge = 0,
  DevelopmentPlan = 10,
  UserProgress = 11,
  UserAwards = 12,
  UserProfileView = 13,
  TrainingNome = 20,
  TrainingCatalog = 21,
  MeetingCalendar = 22,
  TrainingLibrary = 23,
  TrainingHistory = 24,
  UserProfileEdit = 25,
  KnowledgeHome = 30,
  KnowledgeInterests = 31,
  KnowledgeShorts = 32,
  KnowledgeSeeLater = 33,
  KnowledgeFavorites = 34,
  KnowledgeQA = 35,
  KnowledgeCreatePublication = 36,
  PerformaManageGoal = 37,
  PerformaManageAd = 38,
}

/**
* 0 = Modify
1 = ReviewAnswers
2 = ReviewResults
* @format int32
*/
export enum SurveyReviewBehaviorBeforeExpire {
  Modify = 0,
  ReviewAnswers = 1,
  ReviewResults = 2,
}

/**
* 0 = NoAccess
1 = ReviewAnswers
2 = ReviewResults
* @format int32
*/
export enum SurveyReviewBehaviorAfterExpire {
  NoAccess = 0,
  ReviewAnswers = 1,
  ReviewResults = 2,
}

/**
* 0 = Name
1 = Recent
1 = Recent
* @format int32
*/
export enum SurveyListOrderByQuery {
  Name = 0,
  Recent = 1,
  StoreSize = 1,
}

/**
* 1 = Name
2 = StartDate
3 = EndDate
* @format int32
*/
export enum SurveyDeployListOrderByQuery {
  Name = 1,
  StartDate = 2,
  EndDate = 3,
}

/**
* 1 = Name
2 = MostRecent
3 = MostOlder
* @format int32
*/
export enum SurveyDeployFilterOrder {
  Name = 1,
  MostRecent = 2,
  MostOlder = 3,
}

/**
* 0 = Instructor
1 = Coordinator
* @format int32
*/
export enum SupervisorTrainingsQueryMode {
  Instructor = 0,
  Coordinator = 1,
}

/**
* 0 = WithPendings
1 = TrainingName
2 = FinalizationDate
* @format int32
*/
export enum SupervisorTrainingsOrderBy {
  WithPendings = 0,
  TrainingName = 1,
  FinalizationDate = 2,
}

/**
* 0 = Status
1 = Progress
2 = Grade
3 = Deadline
4 = ComponentConclusion
5 = ComponentGrade
6 = Assessment
* @format int32
*/
export enum SupervisorStatisticsChart {
  Status = 0,
  Progress = 1,
  Grade = 2,
  Deadline = 3,
  ComponentConclusion = 4,
  ComponentGrade = 5,
  Assessment = 6,
}

/**
* 0 = Name
1 = Score
2 = DeliveryDate
* @format int32
*/
export enum SupervisorRegisterActivityScoreOrderBy {
  Name = 0,
  Score = 1,
  DeliveryDate = 2,
}

/**
* 0 = Name
1 = Status
2 = Progress
3 = Score
4 = Finalization
5 = TimeSpent
* @format int32
*/
export enum SupervisorEnrollmentOrderBy {
  Name = 0,
  Status = 1,
  Progress = 2,
  Score = 3,
  Finalization = 4,
  TimeSpent = 5,
}

/**
* 0 = All
1 = Next
* @format int32
*/
export enum SupervisorClassroomMeetingOption {
  All = 0,
  Next = 1,
}

/**
* 0 = Discussion
1 = Mention
* @format int32
*/
export enum SupervisorClassroomDiscussionOption {
  Discussion = 0,
  Mention = 1,
}

/**
* 0 = UserDefined
1 = Urgent
2 = Highlight
3 = Obsolete
256 = Mandatory
257 = Recommended
* @format int32
*/
export enum StickerType {
  UserDefined = 0,
  Urgent = 1,
  Highlight = 2,
  Obsolete = 3,
  Mandatory = 256,
  Recommended = 257,
}

/**
* 1 = High
2 = Indifferent
3 = Low
* @format int32
*/
export enum StickerPriority {
  High = 1,
  Indifferent = 2,
  Low = 3,
}

/**
* 1 = Publication
2 = Training
3 = Survey
* @format int32
*/
export enum StickerAppliesTo {
  Publication = 1,
  Training = 2,
  Survey = 3,
}

/**
* 0 = Done
1 = NotFound
3 = EmailNotSend
4 = InvalidAuth
* @format int32
*/
export enum StandardAccountSendResetPasswordStatus {
  Done = 0,
  NotFound = 1,
  EmailNotSend = 3,
  InvalidAuth = 4,
}

/**
* 0 = Done
1 = NotFound
3 = Expired
* @format int32
*/
export enum StandardAccountResetPasswordStatus {
  Done = 0,
  NotFound = 1,
  Expired = 3,
}

/**
* 0 = Done
1 = NotFound
3 = EmailNotSend
4 = AlreadyConfirmed
* @format int32
*/
export enum StandardAccountResendConfirmationStatus {
  Done = 0,
  NotFound = 1,
  EmailNotSend = 3,
  AlreadyConfirmed = 4,
}

/**
* 0 = Done
1 = NotFound
2 = DuplicateKey
3 = EmailNotSend
4 = AlreadyConfirmed
* @format int32
*/
export enum StandardAccountRenewConfirmationStatus {
  Done = 0,
  NotFound = 1,
  DuplicateKey = 2,
  EmailNotSend = 3,
  AlreadyConfirmed = 4,
}

/**
* 0 = Done
1 = NotFound
2 = AlreadyConfirmed
3 = Expired
4 = ConfirmedButWaitingApproval
* @format int32
*/
export enum StandardAccountConfirmStatus {
  Done = 0,
  NotFound = 1,
  AlreadyConfirmed = 2,
  Expired = 3,
  ConfirmedButWaitingApproval = 4,
}

/**
* 0 = Done
1 = NotFound
2 = Expired
3 = InvalidAgreement
* @format int32
*/
export enum StandardAccountAgreeStatus {
  Done = 0,
  NotFound = 1,
  Expired = 2,
  InvalidAgreement = 3,
}

/**
* 1 = Title
2 = MoreRecent
3 = MoreViews
4 = MoreLikes
5 = MoreComments
6 = DueDate
* @format int32
*/
export enum ShortVideoListOrderBy {
  Title = 1,
  MoreRecent = 2,
  MoreViews = 3,
  MoreLikes = 4,
  MoreComments = 5,
  DueDate = 6,
}

/**
* 0 = Channel
1 = List
* @format int32
*/
export enum ShareTrainingTarget {
  Channel = 0,
  List = 1,
}

/**
* 1 = Sent
2 = Received
* @format int32
*/
export enum SelectMessageDirect {
  Sent = 1,
  Received = 2,
}

/**
* 0 = Equals
1 = GreaterThan
2 = LessThan
3 = GreaterOrEqual
4 = LessOrEqual
* @format int32
*/
export enum SearchValueRule {
  Equals = 0,
  GreaterThan = 1,
  LessThan = 2,
  GreaterOrEqual = 3,
  LessOrEqual = 4,
}

/**
* 0 = Equals
1 = Contains
2 = StartWith
* @format int32
*/
export enum SearchTextRule {
  Equals = 0,
  Contains = 1,
  StartWith = 2,
}

/**
* 0 = Replace
1 = CreateNew
* @format int32
*/
export enum ScoModuleAction {
  Replace = 0,
  CreateNew = 1,
}

/**
* 0 = NeverRun
1 = LastRunSuccess
2 = LastRunFailed
3 = Running
* @format int32
*/
export enum SchedulerStatus {
  NeverRun = 0,
  LastRunSuccess = 1,
  LastRunFailed = 2,
  Running = 3,
}

/**
* 0 = CleanupStorage
1 = CleanupAccountAccess
2 = CleanupUserOperations
3 = CleanupCarouselCache
4 = CleanupJobAndQueue
5 = CleanupScoDebugLog
6 = GroupDynamic
7 = OpenIdDictCleanup
8 = RebuildPermissions
9 = UserBlockExpiredAccess
10 = StorageContentAnalysisQueue
11 = YouTubeContentAnalisysQueue
12 = RecommendationScoreUpdate
13 = ScheduledImportUsers
14 = ScheduleReport
15 = ComputeBilling
16 = ComputeStreamingUsage
17 = ConsolidateStreamingUsage
18 = NotifySystemUsageExceeded
19 = NotifyUserBrithday
20 = RecommendationModelEnqueue
21 = RecommendationModelInspector
22 = AwardComputeBadge
23 = AwardReprocessPoints
24 = AssessmentCleanUp
25 = AssessmentInstanceClearPreview
26 = AssessmentPendingCorrectionReminder
27 = NotifyReminderAnswerSurvey
28 = NotifyAnswerNewSurvey
29 = NotifyReminderAnswerChallenge
30 = ChannelUserSubscriptionQueue
31 = CheckLossProvenKnowledgeSeal
32 = GrantProvenKnowledgeSeal
33 = UpdateProvenKnowledge
34 = CreatePublicationClassification
35 = PublicationClearTrash
36 = PublicationCouldAnswerQuestion
37 = PublicationAnswerQuestionIA
38 = PublicationRevalidatePeriod
39 = PublicationTrendScoreLast12Hours
40 = PublicationTrendScoreLast5Days
41 = PublicationWorkflow
42 = ActivityCheckExpiration
43 = AutoRenrollmentLearnPath
44 = CloseEnrollments
45 = EnrollCertificateRulesReprocess
46 = EnrollOperationCleanUp
47 = EnrollTrainingCheckValidate
48 = EnrollPreApprovalExpired
49 = MandatoryTrainingsReminder
50 = MeetingCheckActionPendings
51 = MeetingOnlinePresenceList
52 = NotifyActvityReminder
53 = NotifyEnrollCertificateExpiring
54 = NotifyMeetingLongReminder
55 = NotifyMeetingRecordingPublication
56 = NotifyMeetingShortReminder
57 = NotifyRemiderContinueTraining
58 = NotifyTrainingChanged
59 = NotifyTrainingDelayed
60 = NotifyTrainingDueDateEnding
61 = NotifyTrainingWillAutoConclude
62 = NotifyTrainingStarting
63 = NotifyTrainingStarted
64 = NotifyEnrollmentAvailable
65 = NotifyLearnPathPhaseEnabled
66 = SendNotices
67 = TrainingCleanupExpiredStickers
68 = TrainingTrendScore
69 = TutoringReminder
70 = UpdateEnrollmentsTrainingChanged
71 = InspectUserTrainingAudienceChanges
72 = TrainingIndexUpdate
73 = TrainingIndexCleanup
74 = DevPlanArchive
75 = DevPlanCheckCompletion
76 = NotifyDevPlanReminder
77 = NotifyDevPlanChanged
78 = NotifyDevPlanCompletionReminder
79 = NotifyDevPlanArchivingReminder
80 = NotifyDevPlanActivityDeadlineReminder
81 = SmtpQueue
82 = PushQueue
83 = GroupMemberQueue
84 = TopicUserSubscriptionQueue
85 = SecurityRoleDynamicGroupQueue
86 = SecurityRoleDynamicUserQueue
87 = ImageCognitiveAnalysisQueue
88 = CreateUserRecommendationQueue
89 = MediaEncodeInspectorQueue
90 = MediaEncodeQueue
91 = MediaIndexerInspectorQueue
92 = MediaIndexerQueue
93 = NotificationQueue
94 = PublicationContentCognitiveAnalysisQueue
95 = PublicationContentEmbeddingsQueue
96 = PublicationUrgentNotificationQueue
97 = BatchPublicationQueue
98 = ReportQueue
99 = LoadUserQueue
100 = LoadUnitQueue
101 = LoadTrainingQueue
102 = LoadEnrollQueue
103 = TrainingIndexExecutionQueue
* @format int32
*/
export enum SchedulerJobType {
  CleanupStorage = 0,
  CleanupAccountAccess = 1,
  CleanupUserOperations = 2,
  CleanupCarouselCache = 3,
  CleanupJobAndQueue = 4,
  CleanupScoDebugLog = 5,
  GroupDynamic = 6,
  OpenIdDictCleanup = 7,
  RebuildPermissions = 8,
  UserBlockExpiredAccess = 9,
  StorageContentAnalysisQueue = 10,
  YouTubeContentAnalisysQueue = 11,
  RecommendationScoreUpdate = 12,
  ScheduledImportUsers = 13,
  ScheduleReport = 14,
  ComputeBilling = 15,
  ComputeStreamingUsage = 16,
  ConsolidateStreamingUsage = 17,
  NotifySystemUsageExceeded = 18,
  NotifyUserBrithday = 19,
  RecommendationModelEnqueue = 20,
  RecommendationModelInspector = 21,
  AwardComputeBadge = 22,
  AwardReprocessPoints = 23,
  AssessmentCleanUp = 24,
  AssessmentInstanceClearPreview = 25,
  AssessmentPendingCorrectionReminder = 26,
  NotifyReminderAnswerSurvey = 27,
  NotifyAnswerNewSurvey = 28,
  NotifyReminderAnswerChallenge = 29,
  ChannelUserSubscriptionQueue = 30,
  CheckLossProvenKnowledgeSeal = 31,
  GrantProvenKnowledgeSeal = 32,
  UpdateProvenKnowledge = 33,
  CreatePublicationClassification = 34,
  PublicationClearTrash = 35,
  PublicationCouldAnswerQuestion = 36,
  PublicationAnswerQuestionIA = 37,
  PublicationRevalidatePeriod = 38,
  PublicationTrendScoreLast12Hours = 39,
  PublicationTrendScoreLast5Days = 40,
  PublicationWorkflow = 41,
  ActivityCheckExpiration = 42,
  AutoRenrollmentLearnPath = 43,
  CloseEnrollments = 44,
  EnrollCertificateRulesReprocess = 45,
  EnrollOperationCleanUp = 46,
  EnrollTrainingCheckValidate = 47,
  EnrollPreApprovalExpired = 48,
  MandatoryTrainingsReminder = 49,
  MeetingCheckActionPendings = 50,
  MeetingOnlinePresenceList = 51,
  NotifyActvityReminder = 52,
  NotifyEnrollCertificateExpiring = 53,
  NotifyMeetingLongReminder = 54,
  NotifyMeetingRecordingPublication = 55,
  NotifyMeetingShortReminder = 56,
  NotifyRemiderContinueTraining = 57,
  NotifyTrainingChanged = 58,
  NotifyTrainingDelayed = 59,
  NotifyTrainingDueDateEnding = 60,
  NotifyTrainingWillAutoConclude = 61,
  NotifyTrainingStarting = 62,
  NotifyTrainingStarted = 63,
  NotifyEnrollmentAvailable = 64,
  NotifyLearnPathPhaseEnabled = 65,
  SendNotices = 66,
  TrainingCleanupExpiredStickers = 67,
  TrainingTrendScore = 68,
  TutoringReminder = 69,
  UpdateEnrollmentsTrainingChanged = 70,
  InspectUserTrainingAudienceChanges = 71,
  TrainingIndexUpdate = 72,
  TrainingIndexCleanup = 73,
  DevPlanArchive = 74,
  DevPlanCheckCompletion = 75,
  NotifyDevPlanReminder = 76,
  NotifyDevPlanChanged = 77,
  NotifyDevPlanCompletionReminder = 78,
  NotifyDevPlanArchivingReminder = 79,
  NotifyDevPlanActivityDeadlineReminder = 80,
  SmtpQueue = 81,
  PushQueue = 82,
  GroupMemberQueue = 83,
  TopicUserSubscriptionQueue = 84,
  SecurityRoleDynamicGroupQueue = 85,
  SecurityRoleDynamicUserQueue = 86,
  ImageCognitiveAnalysisQueue = 87,
  CreateUserRecommendationQueue = 88,
  MediaEncodeInspectorQueue = 89,
  MediaEncodeQueue = 90,
  MediaIndexerInspectorQueue = 91,
  MediaIndexerQueue = 92,
  NotificationQueue = 93,
  PublicationContentCognitiveAnalysisQueue = 94,
  PublicationContentEmbeddingsQueue = 95,
  PublicationUrgentNotificationQueue = 96,
  BatchPublicationQueue = 97,
  ReportQueue = 98,
  LoadUserQueue = 99,
  LoadUnitQueue = 100,
  LoadTrainingQueue = 101,
  LoadEnrollQueue = 102,
  TrainingIndexExecutionQueue = 103,
}

/**
* 0 = Add
1 = Replace
2 = Keep
* @format int32
*/
export enum RoleMergeOption {
  Add = 0,
  Replace = 1,
  Keep = 2,
}

/**
* 0 = Subscribed
1 = PendingApproval
2 = Denied
3 = InvalidPassword
4 = AlreadySubscribed
* @format int32
*/
export enum RequestChannelSubscriptionResult {
  Subscribed = 0,
  PendingApproval = 1,
  Denied = 2,
  InvalidPassword = 3,
  AlreadySubscribed = 4,
}

/**
* 0 = Montly
1 = Weekly
* @format int32
*/
export enum ReportScheduleFrequency {
  Montly = 0,
  Weekly = 1,
}

/**
* 1 = Text
2 = Numeric
3 = Boolean
4 = DateTime
5 = Date
6 = Time
8 = ValueSelection
9 = ObjectSelection
* @format int32
*/
export enum ReportParamType {
  Text = 1,
  Numeric = 2,
  Boolean = 3,
  DateTime = 4,
  Date = 5,
  Time = 6,
  ValueSelection = 8,
  ObjectSelection = 9,
}

/**
* 1 = User
2 = Group
3 = Tag
4 = Topic
5 = Unit
6 = UnitType
7 = Role
8 = Workplace
9 = BlockReason
10 = Sticker
12 = Manager
13 = DirectSubordinateAsManager
30 = Channel
31 = PublicationAuthor
32 = Publication
50 = LmsTraining
51 = LmsClassroom
60 = AssEvaluation
61 = AssSurvey
62 = AssDeploy
100 = FreeTextCollection
* @format int32
*/
export enum ReportParamObjectType {
  User = 1,
  Group = 2,
  Tag = 3,
  Topic = 4,
  Unit = 5,
  UnitType = 6,
  Role = 7,
  Workplace = 8,
  BlockReason = 9,
  Sticker = 10,
  Manager = 12,
  DirectSubordinateAsManager = 13,
  Channel = 30,
  PublicationAuthor = 31,
  Publication = 32,
  LmsTraining = 50,
  LmsClassroom = 51,
  AssEvaluation = 60,
  AssSurvey = 61,
  AssDeploy = 62,
  FreeTextCollection = 100,
}

/**
* 1 = Success
2 = Deactivated
3 = Failed
* @format int32
*/
export enum RemoveUserStatus {
  Success = 1,
  Deactivated = 2,
  Failed = 3,
}

/**
* 0 = Name
1 = Score
2 = Attended
* @format int32
*/
export enum RegisterMeetingAttendedOrderBy {
  Name = 0,
  Score = 1,
  Attended = 2,
}

/**
* 0 = Pending
1 = Retry
2 = Failed
3 = Done
4 = Running
* @format int32
*/
export enum QueueStatus {
  Pending = 0,
  Retry = 1,
  Failed = 2,
  Done = 3,
  Running = 4,
}

/**
* 0 = Smtp
1 = PushNotification
2 = StorageContentAnalysis
3 = YoutubeContentAnalysis
4 = MediaIndexer
5 = MediaIndexerInspector
6 = MediaEncode
7 = MediaEncodeInspector
8 = ImageCognitiveAnalysis
9 = PublicationContentAnalysis
10 = PublicationContentEmbeddings
11 = ProcessUrgentPublications
12 = CreateUserRecommendations
13 = RecommendationRetraining
14 = BatchPublication
15 = BatchNotification
16 = LoadUser
17 = LoadUnit
18 = LoadTraining
19 = LoadEnrollHistory
20 = RunReport
21 = TrainingIndexExecution
* @format int32
*/
export enum QueueObjectType {
  Smtp = 0,
  PushNotification = 1,
  StorageContentAnalysis = 2,
  YoutubeContentAnalysis = 3,
  MediaIndexer = 4,
  MediaIndexerInspector = 5,
  MediaEncode = 6,
  MediaEncodeInspector = 7,
  ImageCognitiveAnalysis = 8,
  PublicationContentAnalysis = 9,
  PublicationContentEmbeddings = 10,
  ProcessUrgentPublications = 11,
  CreateUserRecommendations = 12,
  RecommendationRetraining = 13,
  BatchPublication = 14,
  BatchNotification = 15,
  LoadUser = 16,
  LoadUnit = 17,
  LoadTraining = 18,
  LoadEnrollHistory = 19,
  RunReport = 20,
  TrainingIndexExecution = 21,
}

/**
* 1 = SimpleChoice
2 = MultipleChoice
3 = FillInText
4 = Dropdown
5 = Essay
6 = Star
7 = FillInNumber
* @format int32
*/
export enum QuestionType {
  SimpleChoice = 1,
  MultipleChoice = 2,
  FillInText = 3,
  Dropdown = 4,
  Essay = 5,
  Star = 6,
  FillInNumber = 7,
}

/**
* 0 = Recent
1 = Point
2 = Title
* @format int32
*/
export enum QuestionSelectListOrderByQuery {
  Recent = 0,
  Point = 1,
  Title = 2,
}

/**
* 0 = Recent
1 = Point
2 = Title
* @format int32
*/
export enum QuestionListOrderByQuery {
  Recent = 0,
  Point = 1,
  Title = 2,
}

/**
* 0 = Evaluation
1 = Survey
* @format int32
*/
export enum QuestionClass {
  Evaluation = 0,
  Survey = 1,
}

/**
* 1 = Post
2 = Question
3 = Answer
4 = Poll
5 = List
6 = Binder
257 = TrainingPost
258 = TrainingActivity
259 = TrainingNotice
513 = DevPlanActivity
* @format int32
*/
export enum PublicationType {
  Post = 1,
  Question = 2,
  Answer = 3,
  Poll = 4,
  List = 5,
  Binder = 6,
  TrainingPost = 257,
  TrainingActivity = 258,
  TrainingNotice = 259,
  DevPlanActivity = 513,
}

/**
* 0 = AddListItem
1 = Any
* @format int32
*/
export enum PublicationSelectorType {
  AddListItem = 0,
  Any = 1,
}

/**
* 0 = Title
1 = Latest
* @format int32
*/
export enum PublicationSelectorOrder {
  Title = 0,
  Latest = 1,
}

/**
* 0 = Publication
1 = Training
* @format int32
*/
export enum PublicationRelationshipOptions {
  Publication = 0,
  Training = 1,
}

/**
* 1 = Favorite
2 = SeeLater
10 = Custom
* @format int32
*/
export enum PublicationListType {
  Favorite = 1,
  SeeLater = 2,
  Custom = 10,
}

/**
* 1 = List
2 = Poll
3 = Question
4 = Video
5 = Audio
6 = Presentation
7 = Article
8 = Link
9 = Image
10 = Document
11 = File
20 = Post
21 = Answer
22 = Binder
* @format int32
*/
export enum PublicationClassificationType {
  List = 1,
  Poll = 2,
  Question = 3,
  Video = 4,
  Audio = 5,
  Presentation = 6,
  Article = 7,
  Link = 8,
  Image = 9,
  Document = 10,
  File = 11,
  Post = 20,
  Answer = 21,
  Binder = 22,
}

/**
* 0 = Unknown
1 = Image
2 = Video
3 = Audio
4 = Document
5 = File
10 = YouTube
11 = Vimeo
12 = Twitter
13 = WebSite
20 = PerformaPublication
30 = PerformaTraining
* @format int32
*/
export enum PublicationAttachType {
  Unknown = 0,
  Image = 1,
  Video = 2,
  Audio = 3,
  Document = 4,
  File = 5,
  YouTube = 10,
  Vimeo = 11,
  Twitter = 12,
  WebSite = 13,
  PerformaPublication = 20,
  PerformaTraining = 30,
}

/**
* 1 = Approved
2 = Rejected
3 = Canceled
10 = PendingCognitiveAnalysis
11 = PendingModeratorAction
* @format int32
*/
export enum PublicationApprovalStatus {
  Approved = 1,
  Rejected = 2,
  Canceled = 3,
  PendingCognitiveAnalysis = 10,
  PendingModeratorAction = 11,
}

/**
* 1 = ReportIncorrectInformation
2 = ReportInappropriateLanguage
3 = ReportInappropriateContent
4 = ReportCopyrightInfringement
5 = ReportSpam
6 = ReportOther
10 = RepassQuestion
11 = CouldAnswerTheQuestion
21 = ApprovalWorkflow
22 = ApprovalWithoutWorkflow
30 = Unblock
40 = PublicationAdjust
* @format int32
*/
export enum PublicationActionType {
  ReportIncorrectInformation = 1,
  ReportInappropriateLanguage = 2,
  ReportInappropriateContent = 3,
  ReportCopyrightInfringement = 4,
  ReportSpam = 5,
  ReportOther = 6,
  RepassQuestion = 10,
  CouldAnswerTheQuestion = 11,
  ApprovalWorkflow = 21,
  ApprovalWithoutWorkflow = 22,
  Unblock = 30,
  PublicationAdjust = 40,
}

/**
* 1 = ApprovePublication
2 = RejectPublication
3 = ReportBlockPublication
4 = ReportPublicationObsolete
5 = ReportIgnore
6 = ReportExcludeComment
7 = ReportExcludePublication
* @format int32
*/
export enum PublicationActionResponse {
  ApprovePublication = 1,
  RejectPublication = 2,
  ReportBlockPublication = 3,
  ReportPublicationObsolete = 4,
  ReportIgnore = 5,
  ReportExcludeComment = 6,
  ReportExcludePublication = 7,
}

/**
* 0 = Normal
1 = Review
2 = Demo
* @format int32
*/
export enum PlayerMode {
  Normal = 0,
  Review = 1,
  Demo = 2,
}

/**
* 1 = User
2 = Group
3 = Unit
4 = GeneralAdmin
5 = Topic
6 = Knowledge
7 = Training
8 = Assessment
9 = Others
* @format int32
*/
export enum PermissionCategory {
  User = 1,
  Group = 2,
  Unit = 3,
  GeneralAdmin = 4,
  Topic = 5,
  Knowledge = 6,
  Training = 7,
  Assessment = 8,
  Others = 9,
}

/**
* 0 = Undefined
1 = FoundationAccountWelcome
2 = FoundationAccountValidation
3 = FoundationAccountResetPassword
4 = FoundationAccountResetPasswordMobile
5 = FoundationImportUsers
6 = FoundationImportUnits
7 = FoundationSpyLogin
8 = FoundationDirectMessageNew
9 = FoundationUserAutoRegister
10 = FoundationScheduledReport
11 = FoundationUserBirthday
12 = FoundationUserAutoRegisterApproved
13 = FoundationUserAutoRegisterRejected
14 = FoundationUserAutoRegisterForApproval
15 = KnowledgeMentionPublication
16 = KnowledgeQuestionNewAnswer
17 = KnowledgeQuestionNewAnswerFollow
18 = KnowledgeQuestionCouldYouAnswer
19 = KnowledgeUserSentNewQuestion
20 = KnowledgeUserRepassQuestion
21 = KnowledgeUserNewFollower
22 = KnowledgeUserSharePublication
23 = KnowledgePublicationNewThread
24 = KnowledgeCommentNewAnswerYourComment
25 = KnowledgeCommentNewYourPublication
26 = KnowledgeCommentDeletedPublication
27 = KnowledgeChannelSubscriptionApproved
28 = KnowledgeChannelSubscriptionRejected
29 = KnowledgeChannelCancelMember
30 = KnowledgeChannelInvite
31 = KnowledgePublicationBlocked
32 = KnowledgePublicationExcluded
33 = KnowledgePublicationEdited
34 = KnowledgePublicationRejected
35 = KnowledgePublicationApproved
36 = KnowledgeRequesterReportAnalysed
37 = KnowledgeRequesterCommentReportAnalysed
38 = KnowledgePublicationPendingApproval
39 = KnowledgeChannelPendingSubscription
40 = KnowledgeRequestUnblockPublication
41 = KnowledgeChannelNewPublication
42 = KnowledgeChannelNewOwner
43 = KnowledgeChannelNewOwnerSelected
44 = KnowledgeChannelNewModerator
45 = KnowledgeChannelNewModeratorSelected
46 = KnowledgeChannelDeleted
47 = KnowledgeListNewPublicationFollower
48 = KnowledgePublicationLike
49 = KnowledgePublicationUrgent
50 = KnowledgeAuthorReportAnalysed
51 = KnowledgeAuthorCommentReportAnalysed
52 = KnowledgeNewPublication
53 = KnowledgeChannelNewMember
54 = KnowledgeAuthorNewPublication
55 = KnowledgeTopicNewPublication
56 = KnowledgeBatchPublication
57 = KnowledgeChannelRequestAccess
58 = LmsUserEnrolled
59 = LmsEnrollCourseRecycling
60 = LmsEnrollLearnPathRecycling
61 = LmsLearnPathNextEnrollManual
62 = LmsLearnPathNextEnrollAutomatic
63 = LmsActivityDueDateChanged
64 = LmsActivityWillExpire
65 = LmsTrainingDueDateEnding
66 = LmsEnrollExtraTimeGiven
67 = LmsTrainingStarted
68 = LmsTrainingStarting
69 = LmsTrainingDelayed
70 = LmsTrainingExpiring
71 = LmsLearnPathPhaseEnabled
72 = LmsMeetingStartShort
73 = LmsMeetingStartLong
74 = LmsMeetingRegisterScore
75 = LmsActivityRegisterScore
76 = AssInstanceFinishedEssayCorrection
77 = AssDeployReactionSurvey
78 = AssDeployEfficacySurvey
79 = AssManagerEfficacy
80 = AssDeployAnswerNewSurvey
81 = LmsNotice
82 = LmsActivityCancelled
83 = LmsMeetingRecordingPublished
84 = LmsMeetingRecordingChanged
85 = LmsMeetingCalendarChanged
86 = LmsMeetingCancelled
87 = LmsTrainingContentChangedStudent
88 = LmsEnrollExempt
89 = LmsEnrollApproved
90 = LmsEnrollReproved
91 = LmsEnrollCancelled
92 = LmsEnrollDeleted
93 = LmsEnrollRevoked
94 = LmsEnrollUndoRevoked
95 = LmsCertificateCreated
96 = LmsCertificateExpired
97 = LmsCertificateExpiring
98 = LmsDiscussionMentionEnroller
99 = LmsDiscussionReplyMentionEnroller
100 = LmsDiscussionMentionInstructor
101 = LmsDiscussionReplyMentionInstructor
102 = LmsDiscussionReplyMentionClassroom
103 = LmsWorkflowPreApprovalApproved
104 = LmsWorkflowPreApprovalReproved
105 = LmsWorkflowPreApprovalExpired
106 = LmsWorkflowConclusionFormApproved
107 = LmsWorkflowConclusionFormReproved
108 = LmsWorkflowConclusionFormRejected
109 = LmsWorkflowPreApprovalRequestInspection
110 = LmsWorkflowConclusionFormRequestInspection
111 = AssEssayPendingCorrection
112 = LmsUserShareTraining
113 = LmsEnrollCreated
114 = LmsTrainingMandatoryReminder
115 = LmsTrainingReminderContinue
116 = LmsAppointmentConflictCreatedCoordinator
117 = LmsTrainingContentChangedCoordinator
118 = LmsTrainingAddCoordinator
119 = LmsTrainingRemoveCoordinator
120 = LmsTutoringReminder
121 = LmsAppointmentConflictCreatedInstructor
122 = LmsTrainingContentChangedInstructor
123 = LmsTrainingAddInstructor
124 = LmsTrainingRemoveInstructor
125 = LmsClassroomAddInstructor
126 = LmsClassroomRemoveInstructor
127 = LmsTrainingInstructorBlocked
128 = LmsMeetingAddInstructor
129 = LmsMeetingRemoveInstructor
130 = LmsTrainingAvailable
131 = LmsDevPlanChangedByManager
132 = LmsDevPlanChangedByOwner
133 = LmsDevPlanApproved
134 = LmsDevPlanArchived
135 = LmsDevPlanConcluded
136 = LmsDevPlanCreatedManager
137 = LmsDevPlanNewDiscussionOwner
138 = LmsDevPlanNewDiscussionManager
139 = LmsDevPlanDiscussionMention
140 = LmsDevPlanCompletionSoon
141 = LmsDevPlanArchivingSoon
142 = LmsDevPlanActivityDelayed
143 = LmsDevPlanActivityDeadline
144 = LmsDevPlanCreatedOwnUser
145 = LmsDevPlanDelayed
146 = LmsImportTrainings
147 = LmsImportEnrollments
148 = AwardLmsTrainingEnrolled
149 = AwardLmsTrainingApproved
150 = AwardChallenge
151 = AwardCreatePublication
152 = AwardAnswerQuestion
153 = AwardBadge
154 = FoundationTopicSpecialistByManager
155 = FoundationTopicGrantSealProvenKnowledge
156 = FoundationTopicLostSealProvenKnowledge
157 = FoundationTopicKeepSealProvenKnowledge
158 = FoundationTopicEndorsement
159 = FoundationReminderAnswerChallenge
160 = PriorityKnowledgeModerationPendings
161 = PriorityLmsApprovalPendings
162 = PriorityAssCorrectionPendings
163 = PriorityDirectMessagesNotRead
164 = PriorityTutoringPendings
165 = PriorityDirectMessagePendings
166 = PriorityManagerEfficacyPendings
167 = PriorityUserAutoRegisterPendings
* @format int32
*/
export enum NotificationType {
  Undefined = 0,
  FoundationAccountWelcome = 1,
  FoundationAccountValidation = 2,
  FoundationAccountResetPassword = 3,
  FoundationAccountResetPasswordMobile = 4,
  FoundationImportUsers = 5,
  FoundationImportUnits = 6,
  FoundationSpyLogin = 7,
  FoundationDirectMessageNew = 8,
  FoundationUserAutoRegister = 9,
  FoundationScheduledReport = 10,
  FoundationUserBirthday = 11,
  FoundationUserAutoRegisterApproved = 12,
  FoundationUserAutoRegisterRejected = 13,
  FoundationUserAutoRegisterForApproval = 14,
  KnowledgeMentionPublication = 15,
  KnowledgeQuestionNewAnswer = 16,
  KnowledgeQuestionNewAnswerFollow = 17,
  KnowledgeQuestionCouldYouAnswer = 18,
  KnowledgeUserSentNewQuestion = 19,
  KnowledgeUserRepassQuestion = 20,
  KnowledgeUserNewFollower = 21,
  KnowledgeUserSharePublication = 22,
  KnowledgePublicationNewThread = 23,
  KnowledgeCommentNewAnswerYourComment = 24,
  KnowledgeCommentNewYourPublication = 25,
  KnowledgeCommentDeletedPublication = 26,
  KnowledgeChannelSubscriptionApproved = 27,
  KnowledgeChannelSubscriptionRejected = 28,
  KnowledgeChannelCancelMember = 29,
  KnowledgeChannelInvite = 30,
  KnowledgePublicationBlocked = 31,
  KnowledgePublicationExcluded = 32,
  KnowledgePublicationEdited = 33,
  KnowledgePublicationRejected = 34,
  KnowledgePublicationApproved = 35,
  KnowledgeRequesterReportAnalysed = 36,
  KnowledgeRequesterCommentReportAnalysed = 37,
  KnowledgePublicationPendingApproval = 38,
  KnowledgeChannelPendingSubscription = 39,
  KnowledgeRequestUnblockPublication = 40,
  KnowledgeChannelNewPublication = 41,
  KnowledgeChannelNewOwner = 42,
  KnowledgeChannelNewOwnerSelected = 43,
  KnowledgeChannelNewModerator = 44,
  KnowledgeChannelNewModeratorSelected = 45,
  KnowledgeChannelDeleted = 46,
  KnowledgeListNewPublicationFollower = 47,
  KnowledgePublicationLike = 48,
  KnowledgePublicationUrgent = 49,
  KnowledgeAuthorReportAnalysed = 50,
  KnowledgeAuthorCommentReportAnalysed = 51,
  KnowledgeNewPublication = 52,
  KnowledgeChannelNewMember = 53,
  KnowledgeAuthorNewPublication = 54,
  KnowledgeTopicNewPublication = 55,
  KnowledgeBatchPublication = 56,
  KnowledgeChannelRequestAccess = 57,
  LmsUserEnrolled = 58,
  LmsEnrollCourseRecycling = 59,
  LmsEnrollLearnPathRecycling = 60,
  LmsLearnPathNextEnrollManual = 61,
  LmsLearnPathNextEnrollAutomatic = 62,
  LmsActivityDueDateChanged = 63,
  LmsActivityWillExpire = 64,
  LmsTrainingDueDateEnding = 65,
  LmsEnrollExtraTimeGiven = 66,
  LmsTrainingStarted = 67,
  LmsTrainingStarting = 68,
  LmsTrainingDelayed = 69,
  LmsTrainingExpiring = 70,
  LmsLearnPathPhaseEnabled = 71,
  LmsMeetingStartShort = 72,
  LmsMeetingStartLong = 73,
  LmsMeetingRegisterScore = 74,
  LmsActivityRegisterScore = 75,
  AssInstanceFinishedEssayCorrection = 76,
  AssDeployReactionSurvey = 77,
  AssDeployEfficacySurvey = 78,
  AssManagerEfficacy = 79,
  AssDeployAnswerNewSurvey = 80,
  LmsNotice = 81,
  LmsActivityCancelled = 82,
  LmsMeetingRecordingPublished = 83,
  LmsMeetingRecordingChanged = 84,
  LmsMeetingCalendarChanged = 85,
  LmsMeetingCancelled = 86,
  LmsTrainingContentChangedStudent = 87,
  LmsEnrollExempt = 88,
  LmsEnrollApproved = 89,
  LmsEnrollReproved = 90,
  LmsEnrollCancelled = 91,
  LmsEnrollDeleted = 92,
  LmsEnrollRevoked = 93,
  LmsEnrollUndoRevoked = 94,
  LmsCertificateCreated = 95,
  LmsCertificateExpired = 96,
  LmsCertificateExpiring = 97,
  LmsDiscussionMentionEnroller = 98,
  LmsDiscussionReplyMentionEnroller = 99,
  LmsDiscussionMentionInstructor = 100,
  LmsDiscussionReplyMentionInstructor = 101,
  LmsDiscussionReplyMentionClassroom = 102,
  LmsWorkflowPreApprovalApproved = 103,
  LmsWorkflowPreApprovalReproved = 104,
  LmsWorkflowPreApprovalExpired = 105,
  LmsWorkflowConclusionFormApproved = 106,
  LmsWorkflowConclusionFormReproved = 107,
  LmsWorkflowConclusionFormRejected = 108,
  LmsWorkflowPreApprovalRequestInspection = 109,
  LmsWorkflowConclusionFormRequestInspection = 110,
  AssEssayPendingCorrection = 111,
  LmsUserShareTraining = 112,
  LmsEnrollCreated = 113,
  LmsTrainingMandatoryReminder = 114,
  LmsTrainingReminderContinue = 115,
  LmsAppointmentConflictCreatedCoordinator = 116,
  LmsTrainingContentChangedCoordinator = 117,
  LmsTrainingAddCoordinator = 118,
  LmsTrainingRemoveCoordinator = 119,
  LmsTutoringReminder = 120,
  LmsAppointmentConflictCreatedInstructor = 121,
  LmsTrainingContentChangedInstructor = 122,
  LmsTrainingAddInstructor = 123,
  LmsTrainingRemoveInstructor = 124,
  LmsClassroomAddInstructor = 125,
  LmsClassroomRemoveInstructor = 126,
  LmsTrainingInstructorBlocked = 127,
  LmsMeetingAddInstructor = 128,
  LmsMeetingRemoveInstructor = 129,
  LmsTrainingAvailable = 130,
  LmsDevPlanChangedByManager = 131,
  LmsDevPlanChangedByOwner = 132,
  LmsDevPlanApproved = 133,
  LmsDevPlanArchived = 134,
  LmsDevPlanConcluded = 135,
  LmsDevPlanCreatedManager = 136,
  LmsDevPlanNewDiscussionOwner = 137,
  LmsDevPlanNewDiscussionManager = 138,
  LmsDevPlanDiscussionMention = 139,
  LmsDevPlanCompletionSoon = 140,
  LmsDevPlanArchivingSoon = 141,
  LmsDevPlanActivityDelayed = 142,
  LmsDevPlanActivityDeadline = 143,
  LmsDevPlanCreatedOwnUser = 144,
  LmsDevPlanDelayed = 145,
  LmsImportTrainings = 146,
  LmsImportEnrollments = 147,
  AwardLmsTrainingEnrolled = 148,
  AwardLmsTrainingApproved = 149,
  AwardChallenge = 150,
  AwardCreatePublication = 151,
  AwardAnswerQuestion = 152,
  AwardBadge = 153,
  FoundationTopicSpecialistByManager = 154,
  FoundationTopicGrantSealProvenKnowledge = 155,
  FoundationTopicLostSealProvenKnowledge = 156,
  FoundationTopicKeepSealProvenKnowledge = 157,
  FoundationTopicEndorsement = 158,
  FoundationReminderAnswerChallenge = 159,
  PriorityKnowledgeModerationPendings = 160,
  PriorityLmsApprovalPendings = 161,
  PriorityAssCorrectionPendings = 162,
  PriorityDirectMessagesNotRead = 163,
  PriorityTutoringPendings = 164,
  PriorityDirectMessagePendings = 165,
  PriorityManagerEfficacyPendings = 166,
  PriorityUserAutoRegisterPendings = 167,
}

/**
* 0 = None
1 = Knowledge
2 = Lms
3 = Award
* @format int32
*/
export enum NotificationTab {
  None = 0,
  Knowledge = 1,
  Lms = 2,
  Award = 3,
}

/**
* 0 = None
1 = Immediate
2 = Resume
* @format int32
*/
export enum NotificationSendMailOption {
  None = 0,
  Immediate = 1,
  Resume = 2,
}

/**
* 0 = None
1 = Foundation
2 = Knowledge
3 = Lms
4 = Assessment
99 = Confidential
-1 = All
* @format int32
*/
export enum NotificationModule {
  None = 0,
  Foundation = 1,
  Knowledge = 2,
  Lms = 3,
  Assessment = 4,
  Confidential = 99,
  All = -1,
}

/**
* 0 = KnowledgeMention
1 = KnowledgeAnswerQuestion
2 = KnowledgeQuestionYou
3 = KnowledgeFollower
4 = KnowledgeShare
5 = KnowledgePublicationSequence
6 = KnowledgeComment
7 = KnowledgeChannel
8 = KnowledgePublicationInterations
9 = KnowledgePublicationApproved
10 = KnowledgeApprovals
11 = KnowledgeNewPub
12 = LmsEnroll
13 = LmsReminder
14 = LmsMeeting
15 = LmsGrade
16 = LmsNotice
17 = LmsContentUpdate
18 = LmsConclusion
19 = LmsCertificate
20 = LmsComments
21 = LmsRequestsUpdating
22 = LmsApprovals
23 = LmsInterest
24 = LmsRecommendation
25 = LmsDevPlan
26 = AwardMedalWon
27 = AwardSpecialist
28 = AwardEndorsement
29 = MailAndPushOnly
30 = MailOnly
31 = Mandatory
* @format int32
*/
export enum NotificationGroup {
  KnowledgeMention = 0,
  KnowledgeAnswerQuestion = 1,
  KnowledgeQuestionYou = 2,
  KnowledgeFollower = 3,
  KnowledgeShare = 4,
  KnowledgePublicationSequence = 5,
  KnowledgeComment = 6,
  KnowledgeChannel = 7,
  KnowledgePublicationInterations = 8,
  KnowledgePublicationApproved = 9,
  KnowledgeApprovals = 10,
  KnowledgeNewPub = 11,
  LmsEnroll = 12,
  LmsReminder = 13,
  LmsMeeting = 14,
  LmsGrade = 15,
  LmsNotice = 16,
  LmsContentUpdate = 17,
  LmsConclusion = 18,
  LmsCertificate = 19,
  LmsComments = 20,
  LmsRequestsUpdating = 21,
  LmsApprovals = 22,
  LmsInterest = 23,
  LmsRecommendation = 24,
  LmsDevPlan = 25,
  AwardMedalWon = 26,
  AwardSpecialist = 27,
  AwardEndorsement = 28,
  MailAndPushOnly = 29,
  MailOnly = 30,
  Mandatory = 31,
}

/**
* 0 = Up
1 = Down
* @format int32
*/
export enum MoveComponentDirection {
  Up = 0,
  Down = 1,
}

/**
* 0 = Up
1 = Down
* @format int32
*/
export enum MoveCarouselModuleLineOption {
  Up = 0,
  Down = 1,
}

/**
* 1 = User
2 = Topic
3 = Channel
4 = Publication
5 = Trainning
* @format int32
*/
export enum MentionType {
  User = 1,
  Topic = 2,
  Channel = 3,
  Publication = 4,
  Trainning = 5,
}

/**
* 1 = User
2 = Group
* @format int32
*/
export enum MemberType {
  User = 1,
  Group = 2,
}

/**
* 1 = Add
2 = Delete
* @format int32
*/
export enum MemberOperation {
  Add = 1,
  Delete = 2,
}

/**
* 0 = Presential
1 = Teams
2 = Zoom
3 = Other
* @format int32
*/
export enum MeetingType {
  Presential = 0,
  Teams = 1,
  Zoom = 2,
  Other = 3,
}

/**
* 0 = ByInstructor
1 = ByQrCode
2 = ByIntegration
3 = ByRecordingView
4 = BySystem
* @format int32
*/
export enum MeetingAttendanceRegisterMode {
  ByInstructor = 0,
  ByQrCode = 1,
  ByIntegration = 2,
  ByRecordingView = 3,
  BySystem = 4,
}

/**
* 0 = Older
1 = Recently
2 = Name
* @format int32
*/
export enum ManagerEfficacyUserOrderBy {
  Older = 0,
  Recently = 1,
  Name = 2,
}

/**
* 1 = Name
2 = RequiredLink
3 = GreaterKnowledge
5 = MoreEndorsements
* @format int32
*/
export enum ManagedUserTopicsOrderBy {
  Name = 1,
  RequiredLink = 2,
  GreaterKnowledge = 3,
  MoreEndorsements = 5,
}

/**
* 0 = Name
1 = ModifiedDate
* @format int32
*/
export enum ManagedUserListOrderByQuery {
  Name = 0,
  ModifiedDate = 1,
}

/**
* 0 = Active
1 = Adding
2 = Deleting
* @format int32
*/
export enum ManagedUserGroupsQueryStatus {
  Active = 0,
  Adding = 1,
  Deleting = 2,
}

/**
* 0 = OnlyDirectUsers
1 = DirectAndIndirectUsers
* @format int32
*/
export enum ManagedUnitUserType {
  OnlyDirectUsers = 0,
  DirectAndIndirectUsers = 1,
}

/**
* 0 = Name
1 = MostRecent
2 = MoreEnrollments
3 = GreatestStorageSize
* @format int32
*/
export enum ManagedTrainingsListOrderBy {
  Name = 0,
  MostRecent = 1,
  MoreEnrollments = 2,
  GreatestStorageSize = 3,
}

/**
* 1 = Name
2 = RequiredLink
3 = GreaterKnowledge
5 = MoreEndorsements
* @format int32
*/
export enum ManagedTopicUsersOrderBy {
  Name = 1,
  RequiredLink = 2,
  GreaterKnowledge = 3,
  MoreEndorsements = 5,
}

/**
* 0 = List
1 = Hierarchical
2 = Breadcrumbs
* @format int32
*/
export enum ManagedTopicListType {
  List = 0,
  Hierarchical = 1,
  Breadcrumbs = 2,
}

/**
* 0 = Standard
1 = Blocked
2 = Custom
* @format int32
*/
export enum ManagedRoleUserStatus {
  Standard = 0,
  Blocked = 1,
  Custom = 2,
}

/**
* 0 = Standard
1 = Custom
* @format int32
*/
export enum ManagedRoleGroupStatus {
  Standard = 0,
  Custom = 1,
}

/**
* 0 = OnlyActive
1 = OnlyInactive
2 = ActiveAndInactive
* @format int32
*/
export enum ManagedReportListStatusView {
  OnlyActive = 0,
  OnlyInactive = 1,
  ActiveAndInactive = 2,
}

/**
* 0 = Name
1 = MostAccessed
2 = LessAcessed
* @format int32
*/
export enum ManagedQuickAccessOrderBy {
  Name = 0,
  MostAccessed = 1,
  LessAcessed = 2,
}

/**
* 0 = All
1 = Channel
2 = Topic
3 = List
4 = Author
* @format int32
*/
export enum ManagedQuickAccessFilterBy {
  All = 0,
  Channel = 1,
  Topic = 2,
  List = 3,
  Author = 4,
}

/**
* 0 = Hierarchical
1 = Breadcrumbs
2 = Record
* @format int32
*/
export enum ManagedQuestionGroupListType {
  Hierarchical = 0,
  Breadcrumbs = 1,
  Record = 2,
}

/**
* 0 = Name
1 = MoreClasses
2 = LessClasses
3 = NextEventDate
* @format int32
*/
export enum ManagedInstructorListOrderBy {
  Name = 0,
  MoreClasses = 1,
  LessClasses = 2,
  NextEventDate = 3,
}

/**
* 0 = Name
1 = DueDate
* @format int32
*/
export enum ManagedInstructorClassesOrderBy {
  Name = 0,
  DueDate = 1,
}

/**
* 0 = MeetingName
1 = MeetingDate
2 = TrainingName
* @format int32
*/
export enum ManagedInstructorAppointmentsOrderBy {
  MeetingName = 0,
  MeetingDate = 1,
  TrainingName = 2,
}

/**
* 0 = Name
1 = CreatedOn
* @format int32
*/
export enum ManagedEnrollmentTrainingsListOrderBy {
  Name = 0,
  CreatedOn = 1,
}

/**
* 0 = OnlyActive
1 = OnlyInactive
2 = ActiveAndInactive
* @format int32
*/
export enum ManagedCustomFieldListStatusView {
  OnlyActive = 0,
  OnlyInactive = 1,
  ActiveAndInactive = 2,
}

/**
* 0 = Name
1 = MostRecent
2 = MoreEnrollment
* @format int32
*/
export enum ManagedClassroomOrderByQuery {
  Name = 0,
  MostRecent = 1,
  MoreEnrollment = 2,
}

/**
* 0 = Name
1 = Role
* @format int32
*/
export enum ManagedChannelMembersListOrderBy {
  Name = 0,
  Role = 1,
}

/**
* 1 = Name
2 = MorePublications
3 = MoreMembers
4 = GreaterStorage
* @format int32
*/
export enum ManagedChannelListOrderBy {
  Name = 1,
  MorePublications = 2,
  MoreMembers = 3,
  GreaterStorage = 4,
}

/**
* 0 = Knowledge
1 = Lms
* @format int32
*/
export enum ManagedBadgeGroupAction {
  Knowledge = 0,
  Lms = 1,
}

/**
* 0 = Oldest
1 = Newest
* @format int32
*/
export enum ManagedAutoRegisterOrder {
  Oldest = 0,
  Newest = 1,
}

/**
* 1 = Enrollment
2 = Cancel
3 = AllowExtraTime
4 = Revoke
5 = UndoRevoke
7 = ReEnrollForRecycling
8 = Exclude
9 = Finalize
* @format int32
*/
export enum ManageEnrollOperation {
  Enrollment = 1,
  Cancel = 2,
  AllowExtraTime = 3,
  Revoke = 4,
  UndoRevoke = 5,
  ReEnrollForRecycling = 7,
  Exclude = 8,
  Finalize = 9,
}

/**
* 0 = None
1 = And
2 = Or
* @format int32
*/
export enum LogicOperator {
  None = 0,
  And = 1,
  Or = 2,
}

/**
* 0 = None
1 = Open
2 = Close
* @format int32
*/
export enum LogicBraces {
  None = 0,
  Open = 1,
  Close = 2,
}

/**
* 1 = Name
2 = MostRecent
3 = MostEnrolls
4 = BestRated
* @format int32
*/
export enum LmsTrainingOrder {
  Name = 1,
  MostRecent = 2,
  MostEnrolls = 3,
  BestRated = 4,
}

/**
* 0 = EnrollmentDiscussion
1 = EnrollmentMaterialList
2 = EnrollmentNotices
* @format int32
*/
export enum LmsCalloutType {
  EnrollmentDiscussion = 0,
  EnrollmentMaterialList = 1,
  EnrollmentNotices = 2,
}

/**
* 0 = MostFollowed
1 = LatestUpdate
2 = Registered
3 = SearchText
* @format int32
*/
export enum ListSubscriptionFilterBy {
  MostFollowed = 0,
  LatestUpdate = 1,
  Registered = 2,
  SearchText = 3,
}

/**
* 0 = Title
1 = MostRecent
* @format int32
*/
export enum LibraryTrainingsOrderBy {
  Title = 0,
  MostRecent = 1,
}

/**
* 0 = Bookmarked
1 = Liked
* @format int32
*/
export enum LibraryTrainingsOption {
  Bookmarked = 0,
  Liked = 1,
}

/**
* 0 = FixedPoints
1 = ProportionalToScore
2 = ApproachToLeader
3 = UserScore
* @format int32
*/
export enum LearnPathGameScoreOverrideOption {
  FixedPoints = 0,
  ProportionalToScore = 1,
  ApproachToLeader = 2,
  UserScore = 3,
}

/**
* 0 = None
1 = PointsEarnedLessEqualThan
2 = PointsEarnedGreaterEqualThan
3 = PointWonLastPhaseLessEqualThan
4 = PointWonLastPhaseGreaterEqualThan
5 = DistanceToFirstRankedLessEqualThan
6 = DistanceToFirstRankedGreaterEqualThan
* @format int32
*/
export enum LearnPathGameAdditionalCondition {
  None = 0,
  PointsEarnedLessEqualThan = 1,
  PointsEarnedGreaterEqualThan = 2,
  PointWonLastPhaseLessEqualThan = 3,
  PointWonLastPhaseGreaterEqualThan = 4,
  DistanceToFirstRankedLessEqualThan = 5,
  DistanceToFirstRankedGreaterEqualThan = 6,
}

/**
* 0 = Always
1 = WhenPreviousItemCompleted
2 = WhenPreviousPhaseCompleted
3 = OnDate
4 = WhenComponentListCompleted
* @format int32
*/
export enum LearnPathComponentEnableOption {
  Always = 0,
  WhenPreviousItemCompleted = 1,
  WhenPreviousPhaseCompleted = 2,
  OnDate = 3,
  WhenComponentListCompleted = 4,
}

/**
* 0 = All
1 = AuthorAndManagersOnly
2 = ManagersOnly
* @format int32
*/
export enum KnowledgeViewsPrivacy {
  All = 0,
  AuthorAndManagersOnly = 1,
  ManagersOnly = 2,
}

/**
* 1 = StickerRelevance
2 = DirectQuestion
3 = SharedPublication
4 = RecommendedIA
5 = RepassedQuestion
6 = ChannelSubscription
7 = FollowingAuthor
8 = TopicSubscription
9 = InHigh
10 = QuestionIA
11 = NotSubscribed
12 = Urgent
* @format int32
*/
export enum KnowledgeUserMixPublicationSource {
  StickerRelevance = 1,
  DirectQuestion = 2,
  SharedPublication = 3,
  RecommendedIA = 4,
  RepassedQuestion = 5,
  ChannelSubscription = 6,
  FollowingAuthor = 7,
  TopicSubscription = 8,
  InHigh = 9,
  QuestionIA = 10,
  NotSubscribed = 11,
  Urgent = 12,
}

/**
* 0 = Channel
1 = Topic
2 = Author
3 = List
4 = Question
* @format int32
*/
export enum KnowledgeSubscriptionType {
  Channel = 0,
  Topic = 1,
  Author = 2,
  List = 3,
  Question = 4,
}

/**
* 0 = All
1 = TitleAndContent
2 = Title
* @format int32
*/
export enum KnowledgeSearchRestriction {
  All = 0,
  TitleAndContent = 1,
  Title = 2,
}

/**
* 0 = Any
1 = Last24Hours
2 = LastWeek
3 = LastMonth
4 = LastYear
5 = OverYear
6 = Custom
* @format int32
*/
export enum KnowledgeSearchPeriod {
  Any = 0,
  Last24Hours = 1,
  LastWeek = 2,
  LastMonth = 3,
  LastYear = 4,
  OverYear = 5,
  Custom = 6,
}

/**
* 0 = All
1 = Documents
2 = Videos
* @format int32
*/
export enum KnowledgeSearchOption {
  All = 0,
  Documents = 1,
  Videos = 2,
}

/**
* 0 = Any
1 = Until5
2 = Between5And20
3 = Between20And60
4 = OverOneHour
* @format int32
*/
export enum KnowledgeSearchAttachVideoDuration {
  Any = 0,
  Until5 = 1,
  Between5And20 = 2,
  Between20And60 = 3,
  OverOneHour = 4,
}

/**
* 0 = Any
1 = Pdf
2 = Word
3 = Excel
4 = PowerPoint
5 = Others
* @format int32
*/
export enum KnowledgeSearchAttachDocumentType {
  Any = 0,
  Pdf = 1,
  Word = 2,
  Excel = 3,
  PowerPoint = 4,
  Others = 5,
}

/**
* 1 = LastWeek
2 = LastMonth
3 = Liked
4 = CoworkerLiked
5 = Institutional
6 = Recommended
7 = Trending
8 = Presentation
9 = Video
10 = Audio
11 = Question
12 = Poll
13 = ContainAttach
14 = UserSubcriptions
15 = UserMentioned
16 = Highlights
17 = Urgent
18 = RestrictedAccess
19 = PublishedByYou
20 = MentioningYou
21 = LastYear
22 = AuthorsYouFollow
23 = List
24 = TopicsYourInterest
25 = ChannelsYouAreSubscribed
26 = Binder
91 = CustomTopic
92 = CustomChannel
93 = CustomSticker
94 = CustomTag
* @format int32
*/
export enum KnowledgeQuickFilterType {
  LastWeek = 1,
  LastMonth = 2,
  Liked = 3,
  CoworkerLiked = 4,
  Institutional = 5,
  Recommended = 6,
  Trending = 7,
  Presentation = 8,
  Video = 9,
  Audio = 10,
  Question = 11,
  Poll = 12,
  ContainAttach = 13,
  UserSubcriptions = 14,
  UserMentioned = 15,
  Highlights = 16,
  Urgent = 17,
  RestrictedAccess = 18,
  PublishedByYou = 19,
  MentioningYou = 20,
  LastYear = 21,
  AuthorsYouFollow = 22,
  List = 23,
  TopicsYourInterest = 24,
  ChannelsYouAreSubscribed = 25,
  Binder = 26,
  CustomTopic = 91,
  CustomChannel = 92,
  CustomSticker = 93,
  CustomTag = 94,
}

/**
* 0 = ForYou
1 = Channel
2 = Topic
3 = Author
* @format int32
*/
export enum KnowledgeQuickFilterScope {
  ForYou = 0,
  Channel = 1,
  Topic = 2,
  Author = 3,
}

/**
* 0 = UserPublished
1 = UserAnswers
2 = UserViewsReceived
3 = UserLikesReceived
4 = UserAccessedPublications
5 = ChannelPublished
6 = ChannelAnswers
7 = ChannelViewsReceived
8 = PublishedMostViewed
9 = PublishedMostLiked
10 = PublishedMostCommented
* @format int32
*/
export enum KnowledgePanelAnalysisType {
  UserPublished = 0,
  UserAnswers = 1,
  UserViewsReceived = 2,
  UserLikesReceived = 3,
  UserAccessedPublications = 4,
  ChannelPublished = 5,
  ChannelAnswers = 6,
  ChannelViewsReceived = 7,
  PublishedMostViewed = 8,
  PublishedMostLiked = 9,
  PublishedMostCommented = 10,
}

/**
* 1 = MostRelevant
2 = Latest
3 = MostViewed
4 = MostLiked
5 = MostCommented
6 = GreatestStorageSize
7 = Title
* @format int32
*/
export enum KnowledgeFeedOrder {
  MostRelevant = 1,
  Latest = 2,
  MostViewed = 3,
  MostLiked = 4,
  MostCommented = 5,
  GreatestStorageSize = 6,
  Title = 7,
}

/**
* 1 = LmsAttendingTrainings
2 = LmsMandatoryTrainings
3 = KnowledgeChallenge
4 = DevelopmentPlan
5 = PerformaGoals
6 = PerformaPerformanceEvaluation
* @format int32
*/
export enum IndicatorType {
  LmsAttendingTrainings = 1,
  LmsMandatoryTrainings = 2,
  KnowledgeChallenge = 3,
  DevelopmentPlan = 4,
  PerformaGoals = 5,
  PerformaPerformanceEvaluation = 6,
}

/**
* 0 = None
1 = LmsMandatoryTrainings
2 = LmsAttendingTrainings
3 = LmsCatalog
4 = KnowledgeChallenge
5 = LmsDevelopmentPlan
6 = LmsMyDevelopmentPlan
7 = DashboardUserEvolutionChallenge
8 = PerformaGoals
9 = PerformaPerformanceEvaluation
* @format int32
*/
export enum IndicatorCardActionType {
  None = 0,
  LmsMandatoryTrainings = 1,
  LmsAttendingTrainings = 2,
  LmsCatalog = 3,
  KnowledgeChallenge = 4,
  LmsDevelopmentPlan = 5,
  LmsMyDevelopmentPlan = 6,
  DashboardUserEvolutionChallenge = 7,
  PerformaGoals = 8,
  PerformaPerformanceEvaluation = 9,
}

/**
* 1 = SetError
2 = Keep
3 = SetUndefined
* @format int32
*/
export enum ImportUserRolesManagerErrorAction {
  SetError = 1,
  Keep = 2,
  SetUndefined = 3,
}

/**
* 1 = Cancel
2 = Keep
3 = Delete
* @format int32
*/
export enum ImportUserRolesInactivateTrainingAction {
  Cancel = 1,
  Keep = 2,
  Delete = 3,
}

/**
* 1 = Tab
2 = Comma
3 = Semicolon
* @format int32
*/
export enum ImportRulesDataSeparator {
  Tab = 1,
  Comma = 2,
  Semicolon = 3,
}

/**
* 0 = Ok
1 = NoAccess
2 = DailyQuotaExceed
3 = MonthlyQuotaExceed
4 = SystemQuotaExceed
* @format int32
*/
export enum IaRequestCallingStatus {
  Ok = 0,
  NoAccess = 1,
  DailyQuotaExceed = 2,
  MonthlyQuotaExceed = 3,
  SystemQuotaExceed = 4,
}

/**
* 0 = AllDay
1 = Morning
2 = Afternoon
* @format int32
*/
export enum HolidayPeriodOfDay {
  AllDay = 0,
  Morning = 1,
  Afternoon = 2,
}

/**
* 0 = MostRecent
1 = TrainingName
2 = Status
3 = ValidityDate
* @format int32
*/
export enum HistoryOrderBy {
  MostRecent = 0,
  TrainingName = 1,
  Status = 2,
  ValidityDate = 3,
}

/**
* 0 = None
1 = Administration
2 = Training
4 = SubscribeChannelMembers
8 = ContentSharing
-1 = All
* @format int32
*/
export enum GroupUsages {
  None = 0,
  Administration = 1,
  Training = 2,
  SubscribeChannelMembers = 4,
  ContentSharing = 8,
  All = -1,
}

/**
* 1 = Static
2 = Dynamic
100 = AllUsers
101 = InternalUsers
102 = ExternalUsers
110 = UnitUsers
111 = UnitAllUsers
120 = OwnUser
121 = DirectSubordinates
122 = AllSubordinates
123 = ConnectedUsers
130 = TopicRequiredUsers
131 = TopicOptionalUsers
140 = ChannelUsers
150 = TrainingApprovedUsers
151 = TrainingEnrolledUsers
152 = TrainingAttendingUsers
200 = SystemGroup
* @format int32
*/
export enum GroupType {
  Static = 1,
  Dynamic = 2,
  AllUsers = 100,
  InternalUsers = 101,
  ExternalUsers = 102,
  UnitUsers = 110,
  UnitAllUsers = 111,
  OwnUser = 120,
  DirectSubordinates = 121,
  AllSubordinates = 122,
  ConnectedUsers = 123,
  TopicRequiredUsers = 130,
  TopicOptionalUsers = 131,
  ChannelUsers = 140,
  TrainingApprovedUsers = 150,
  TrainingEnrolledUsers = 151,
  TrainingAttendingUsers = 152,
  SystemGroup = 200,
}

/**
* 0 = Equal
1 = StartsWith
2 = EndsWith
3 = Contains
4 = GreatherThan
5 = LessThan
6 = GreatherOrEqualThan
7 = LessOrEqualThan
8 = OneOfOptions
9 = AllOptions
10 = Between
* @format int32
*/
export enum GroupDynamicSpecFieldOperators {
  Equal = 0,
  StartsWith = 1,
  EndsWith = 2,
  Contains = 3,
  GreatherThan = 4,
  LessThan = 5,
  GreatherOrEqualThan = 6,
  LessOrEqualThan = 7,
  OneOfOptions = 8,
  AllOptions = 9,
  Between = 10,
}

/**
* 0 = Relevance
1 = Recent
2 = Viewed
3 = Liked
* @format int32
*/
export enum GlobalSearchOrderBy {
  Relevance = 0,
  Recent = 1,
  Viewed = 2,
  Liked = 3,
}

/**
* 0 = None
1 = StaticMap
2 = Video
* @format int32
*/
export enum GameMapType {
  None = 0,
  StaticMap = 1,
  Video = 2,
}

/**
* 0 = Any
1 = Startup
10 = Answers
21 = Following
30 = HighlightsNews
31 = HighlightsOnHigh
40 = History
50 = List
51 = ListViewer
52 = ListSystemViewer
60 = MyContributions
61 = MyDraft
62 = MyAnswers
63 = MyLists
70 = QuestionRecent
71 = QuestionToYou
72 = QuestionFollowing
80 = ModeratePublications
81 = ModerateReports
82 = ModerateChannelSubscriptions
90 = Channel
91 = Topic
92 = Author
100 = UserProfile
120 = SearchPublications
121 = SearchValidPublication
130 = ShortExplorer
200 = PublicationAdmin
500 = ContentPage
501 = ThreadItemContentPage
502 = PlaybackContentListPage
503 = ContentDialog
* @format int32
*/
export enum FeedType {
  Any = 0,
  Startup = 1,
  Answers = 10,
  Following = 21,
  HighlightsNews = 30,
  HighlightsOnHigh = 31,
  History = 40,
  List = 50,
  ListViewer = 51,
  ListSystemViewer = 52,
  MyContributions = 60,
  MyDraft = 61,
  MyAnswers = 62,
  MyLists = 63,
  QuestionRecent = 70,
  QuestionToYou = 71,
  QuestionFollowing = 72,
  ModeratePublications = 80,
  ModerateReports = 81,
  ModerateChannelSubscriptions = 82,
  Channel = 90,
  Topic = 91,
  Author = 92,
  UserProfile = 100,
  SearchPublications = 120,
  SearchValidPublication = 121,
  ShortExplorer = 130,
  PublicationAdmin = 200,
  ContentPage = 500,
  ThreadItemContentPage = 501,
  PlaybackContentListPage = 502,
  ContentDialog = 503,
}

/**
* 0 = All
1 = WithoutAnswers
2 = WithAnswers
* @format int32
*/
export enum FeedQuestionViewAs {
  All = 0,
  WithoutAnswers = 1,
  WithAnswers = 2,
}

/**
* 0 = BestRated
1 = MostRecent
* @format int32
*/
export enum FeedQuestionQueryOrderBy {
  BestRated = 0,
  MostRecent = 1,
}

/**
* 0 = All
1 = CreatedByYou
2 = Collaborator
3 = Follower
* @format int32
*/
export enum FeedMyListsType {
  All = 0,
  CreatedByYou = 1,
  Collaborator = 2,
  Follower = 3,
}

/**
* 0 = MostRecent
1 = Title
2 = TotalItems
* @format int32
*/
export enum FeedMyListsOrderBy {
  MostRecent = 0,
  Title = 1,
  TotalItems = 2,
}

/**
* 0 = Oldest
1 = Newest
* @format int32
*/
export enum FeedModerationOrder {
  Oldest = 0,
  Newest = 1,
}

/**
* 0 = DisplayOrder
1 = MostRecent
2 = MostViewed
3 = MostLiked
* @format int32
*/
export enum FeedListQueryOrderBy {
  DisplayOrder = 0,
  MostRecent = 1,
  MostViewed = 2,
  MostLiked = 3,
}

/**
* 0 = Viewed
1 = Liked
2 = Commented
* @format int32
*/
export enum FeedHistoryType {
  Viewed = 0,
  Liked = 1,
  Commented = 2,
}

/**
* 0 = NoActionNecessary
1 = LoadContentInDemand
2 = AllContentLoaded
* @format int32
*/
export enum FeedContentLoadStatus {
  NoActionNecessary = 0,
  LoadContentInDemand = 1,
  AllContentLoaded = 2,
}

/**
* 1 = Publication
2 = Mention
* @format int32
*/
export enum FeedAuthorSelectionType {
  Publication = 1,
  Mention = 2,
}

/**
* 0 = TrainingComponent
1 = TrainingReaction
2 = TrainingUserEfficacy
3 = TrainingManagerEfficacy
4 = AssDeploy
* @format int32
*/
export enum ExclusiveUsage {
  TrainingComponent = 0,
  TrainingReaction = 1,
  TrainingUserEfficacy = 2,
  TrainingManagerEfficacy = 3,
  AssDeploy = 4,
}

/**
* 0 = All
1 = Approved
2 = Reproved
3 = InProgress
* @format int32
*/
export enum EvolutionTrainingFilterBy {
  All = 0,
  Approved = 1,
  Reproved = 2,
  InProgress = 3,
}

/**
* 0 = All
1 = OnlyCertificateValid
2 = OnlyCertificateExpired
* @format int32
*/
export enum EvolutionTrainingCertificatesFilterBy {
  All = 0,
  OnlyCertificateValid = 1,
  OnlyCertificateExpired = 2,
}

/**
* 0 = Training
1 = TrainingIndex
2 = Challenge
3 = Knowledge
4 = Award
5 = Goal
6 = Performance
* @format int32
*/
export enum EvolutionPermissions {
  Training = 0,
  TrainingIndex = 1,
  Challenge = 2,
  Knowledge = 3,
  Award = 4,
  Goal = 5,
  Performance = 6,
}

/**
* 0 = Name
1 = Recent
1 = Recent
* @format int32
*/
export enum EvaluationListOrderByQuery {
  Name = 0,
  Recent = 1,
  StoreSize = 1,
}

/**
* 0 = Name
1 = PendingCorrection
* @format int32
*/
export enum EssayCorrectionUserListQueryOrderBy {
  Name = 0,
  PendingCorrection = 1,
}

/**
* 0 = Name
1 = PendingCorrection
* @format int32
*/
export enum EssayCorrectionListQueryOrderBy {
  Name = 0,
  PendingCorrection = 1,
}

/**
* 0 = NotStarted
1 = Pending
2 = Approved
3 = Reproved
4 = Rejected
5 = Cancelled
* @format int32
*/
export enum EnrollmentWorkflowStatus {
  NotStarted = 0,
  Pending = 1,
  Approved = 2,
  Reproved = 3,
  Rejected = 4,
  Cancelled = 5,
}

/**
* 1 = Attending
2 = Approved
3 = Reproved
4 = ExpireDate
5 = ExpireDateOrCertificationRenewal
6 = Canceled
7 = Revoked
* @format int32
*/
export enum EnrollmentStatusFilterOptions {
  Attending = 1,
  Approved = 2,
  Reproved = 3,
  ExpireDate = 4,
  ExpireDateOrCertificationRenewal = 5,
  Canceled = 6,
  Revoked = 7,
}

/**
* 1 = NeverEnroll
2 = NeverApproved
3 = NeverEnrollOrNeverApproved
4 = Approved
5 = Reproved
* @format int32
*/
export enum EnrollmentHistoryFilterOptions {
  NeverEnroll = 1,
  NeverApproved = 2,
  NeverEnrollOrNeverApproved = 3,
  Approved = 4,
  Reproved = 5,
}

/**
* 0 = Meeting
1 = TrainingStart
2 = TrainingFinalization
3 = DeliveryActivity
4 = TrainingReviewDeadline
5 = TrainingCancelDeadline
6 = TrainingExpirationDeadline
7 = TrainingValidityDeadline
* @format int32
*/
export enum EnrollmentCalendarType {
  Meeting = 0,
  TrainingStart = 1,
  TrainingFinalization = 2,
  DeliveryActivity = 3,
  TrainingReviewDeadline = 4,
  TrainingCancelDeadline = 5,
  TrainingExpirationDeadline = 6,
  TrainingValidityDeadline = 7,
}

/**
* 0 = All
1 = Active
2 = Enrolled
3 = Completed
* @format int32
*/
export enum EnrolledUsersOption {
  All = 0,
  Active = 1,
  Enrolled = 2,
  Completed = 3,
}

/**
* 0 = Undefined
1 = NotStarted
2 = InProgress
3 = PresumedApproved
4 = Approved
5 = Reproved
6 = WaitingPreApproval
7 = PreApprovalRejected
8 = WaitingScore
10 = Lapsed
11 = WaitingConclusionFormApproval
12 = ConclusionFormRejected
20 = Excluded
21 = Canceled
22 = Revoked
23 = Exempt
* @format int32
*/
export enum EnrollStatus {
  Undefined = 0,
  NotStarted = 1,
  InProgress = 2,
  PresumedApproved = 3,
  Approved = 4,
  Reproved = 5,
  WaitingPreApproval = 6,
  PreApprovalRejected = 7,
  WaitingScore = 8,
  Lapsed = 10,
  WaitingConclusionFormApproval = 11,
  ConclusionFormRejected = 12,
  Excluded = 20,
  Canceled = 21,
  Revoked = 22,
  Exempt = 23,
}

/**
* 0 = AutoEnroll
1 = ManagerEnroll
* @format int32
*/
export enum EnrollRegistrationMode {
  AutoEnroll = 0,
  ManagerEnroll = 1,
}

/**
* 0 = Public
1 = Private
2 = Instructor
* @format int32
*/
export enum DiscussionType {
  Public = 0,
  Private = 1,
  Instructor = 2,
}

/**
* 0 = Recent
1 = Relevance
2 = Oldest
* @format int32
*/
export enum DiscussionListOrderBy {
  Recent = 0,
  Relevance = 1,
  Oldest = 2,
}

/**
* 0 = All
1 = Unviewed
2 = CreatedByYou
3 = MentionYou
4 = MentionInstructors
5 = Private
* @format int32
*/
export enum DiscussionListFilter {
  All = 0,
  Unviewed = 1,
  CreatedByYou = 2,
  MentionYou = 3,
  MentionInstructors = 4,
  Private = 5,
}

/**
* 0 = All
1 = AllSubordinates
2 = DirectSubordinates
* @format int32
*/
export enum DevPlanUsersListViewMode {
  All = 0,
  AllSubordinates = 1,
  DirectSubordinates = 2,
}

/**
* 0 = Checked
1 = Error
2 = Muted
3 = Highlight
* @format int32
*/
export enum DevPlanStateIndicator {
  Checked = 0,
  Error = 1,
  Muted = 2,
  Highlight = 3,
}

/**
* 0 = OwnUser
1 = Manager
* @format int32
*/
export enum DevPlanListViewMode {
  OwnUser = 0,
  Manager = 1,
}

/**
* 0 = Training
1 = Publication
2 = Other
* @format int32
*/
export enum DevPlanItemType {
  Training = 0,
  Publication = 1,
  Other = 2,
}

/**
* 0 = OwnUser
1 = Manager
* @format int32
*/
export enum DevPlanCreationMode {
  OwnUser = 0,
  Manager = 1,
}

/**
* 0 = AdHoc
1 = LmsUserReaction
2 = LmsUserEfficacy
3 = LmsManagerEfficacy
* @format int32
*/
export enum DeployApplicationType {
  AdHoc = 0,
  LmsUserReaction = 1,
  LmsUserEfficacy = 2,
  LmsManagerEfficacy = 3,
}

/**
* 0 = lg
1 = xl
* @format int32
*/
export enum DefaultImagesThumbSize {
  Lg = 0,
  Xl = 1,
}

/**
* 0 = Sunday
1 = Monday
2 = Tuesday
3 = Wednesday
4 = Thursday
5 = Friday
6 = Saturday
* @format int32
*/
export enum DayOfWeek {
  Sunday = 0,
  Monday = 1,
  Tuesday = 2,
  Wednesday = 3,
  Thursday = 4,
  Friday = 5,
  Saturday = 6,
}

/**
* 1 = All
2 = Last7Days
3 = Last30Days
4 = Last90Days
* @format int32
*/
export enum DashChallengeParticipationPeriod {
  All = 1,
  Last7Days = 2,
  Last30Days = 3,
  Last90Days = 4,
}

/**
* 1 = ProvenKnowledge
2 = Trust
3 = HighConfidenceWrongTrust
4 = HighConfidenceCorrectTrust
5 = Retention
6 = AccuracyRate
* @format int32
*/
export enum DashChallengeAnalysisOption {
  ProvenKnowledge = 1,
  Trust = 2,
  HighConfidenceWrongTrust = 3,
  HighConfidenceCorrectTrust = 4,
  Retention = 5,
  AccuracyRate = 6,
}

/**
* 0 = Month
1 = Day
* @format int32
*/
export enum DashAwardPointsStatementFilterBy {
  Month = 0,
  Day = 1,
}

/**
* 0 = Large
1 = Medium
2 = Small
* @format int32
*/
export enum CustomFieldWidth {
  Large = 0,
  Medium = 1,
  Small = 2,
}

/**
* 0 = BasicInformation
1 = CorporateInformation
2 = PersonInformation
3 = AdditionalInformation
* @format int32
*/
export enum CustomFieldUserDisplayArea {
  BasicInformation = 0,
  CorporateInformation = 1,
  PersonInformation = 2,
  AdditionalInformation = 3,
}

/**
* 0 = User
1 = Unit
2 = CourseTraining
3 = ExternalCourseTraining
4 = LearnPathTraining
* @format int32
*/
export enum CustomFieldUsages {
  User = 0,
  Unit = 1,
  CourseTraining = 2,
  ExternalCourseTraining = 3,
  LearnPathTraining = 4,
}

/**
* 1 = Text
2 = Numeric
3 = Boolean
4 = DateTime
5 = Date
6 = Time
7 = Uuid
8 = ValueSelection
9 = ObjectSelection
* @format int32
*/
export enum CustomFieldType {
  Text = 1,
  Numeric = 2,
  Boolean = 3,
  DateTime = 4,
  Date = 5,
  Time = 6,
  Uuid = 7,
  ValueSelection = 8,
  ObjectSelection = 9,
}

/**
* 0 = None
1 = CPF
2 = CNPJ
3 = PIS
* @format int32
*/
export enum CustomFieldPreDefinedType {
  None = 0,
  CPF = 1,
  CNPJ = 2,
  PIS = 3,
}

/**
* 1 = User
2 = Group
3 = Tag
4 = Topic
* @format int32
*/
export enum CustomFieldObjectType {
  User = 1,
  Group = 2,
  Tag = 3,
  Topic = 4,
}

/**
* 0 = ReadWrite
1 = Readonly
2 = Confidential
* @format int32
*/
export enum CustomFieldFillConstraint {
  ReadWrite = 0,
  Readonly = 1,
  Confidential = 2,
}

/**
* 0 = Always
1 = WhenAllAboveCompleted
2 = DaysAfterClassAvailability
3 = WhenComponentListCompleted
* @format int32
*/
export enum CourseComponentEnableOption {
  Always = 0,
  WhenAllAboveCompleted = 1,
  DaysAfterClassAvailability = 2,
  WhenComponentListCompleted = 3,
}

/**
* 300 = UserIncludeBlockedUsers
301 = UserTags
302 = UserUnits
303 = UserGroups
304 = UserWorkplaces
305 = UserWorkplaceText
306 = UserCustomField
307 = UserIncludeInactive
308 = UserIncludeDeleted
309 = UserIsManager
310 = UserManagerDirectSubordinates
311 = UserManagerAllSubordinates
312 = UserSpecific
313 = UserInternal
314 = UserExternal
315 = UserTopicOptional
316 = UserTopicRequired
317 = UserChannelMembers
318 = UserTrainingAttending
319 = UserTrainingApproved
320 = UserTrainingReproved
321 = UserInterestTag
323 = UserBlockReason
324 = UserAndDirectSubordinates
325 = UserAndAllSubordinates
326 = UserHasSealProvenKnowledgeTopic
327 = UserIsSpecialistInTopic
328 = UserLastAccessBeforeOf
329 = UserLastAccessAfterOf
330 = UserPermission
331 = UserRoles
332 = UserSuspendedAccounts
333 = UserHasNotActiveDevPlan
334 = UserHasActiveDevPlan
335 = UserHasDraftDevPlan
336 = UserHasDelayedDevPlan
337 = UserHasPendingApprovalDevPlan
338 = UserOnlyBlocked
339 = UserOnlyInactive
340 = UsersOnlyDeleted
341 = UserIsExternal
342 = UserTrainingAudience
343 = UserTrainingMandatoryAudience
344 = UserOnlyUnblocked
401 = TrainingTopic
402 = TrainingSticker
403 = TrainingPublishPeriod
404 = TrainingWorkload
405 = TrainingBestRated
406 = TrainingWithAvailableClassrooms
407 = TrainingStartNow
408 = TrainingInLearnPath
409 = TrainingCoordinator
410 = TrainingSpecific
411 = TrainingTypeCourseWeb
412 = TrainingTypeLive
413 = TrainingTypeExternalCourse
414 = TrainingTypeAssessment
415 = TrainingTypeActivity
416 = TrainingTypeLearnPath
417 = TrainingTypeGame
418 = TrainingRequiredAudienceContain
419 = TrainingOptionalAudienceContain
420 = TrainingContentType
421 = TrainingCustomField
422 = TrainingLanguage
423 = TrainingInstructor
424 = TrainingNeverEnroll
425 = TrainingTag
426 = TrainingCurrentUserMandatory
427 = TrainingCurrentUserOptional
428 = TrainingCurrentUserAssigned
429 = TrainingCurrentUserRegisterTeamMembers
430 = TrainingCurrentUserTopicInterest
431 = TrainingNameContain
432 = TrainingAuthorContain
433 = TrainingExternalCodeContain
434 = TrainingWithUsersInProgress
436 = TrainingWithClasses
437 = TrainingWithUsersInterest
438 = TrainingCreatedOn
439 = TrainingModifiedOn
440 = TrainingIsBuilding
441 = TrainingCreatedByYou
442 = TrainingCreatedByUser
443 = TrainingWithMeeting
444 = TrainingNameOrExternalCodeContain
445 = TrainingWithRenovationWindowEnrolls
446 = TrainingWithInvalidatedEnrolls
447 = TrainingWithHideConcludedEnrolls
448 = TrainingValidateExpiringOrExpired
449 = TrainingValidateExpired
450 = TrainingAvailableOnApp
460 = ClassroomWithActiveUsers
461 = ClassroomExecutionPeriod
462 = ClassroomNameContain
463 = ClassroomExternalCodeContain
464 = ClassroomUsersInProgress
465 = ClassroomWithOpenEnrollment
466 = ClassroomWithAudience
467 = ClassroomExpired
468 = ClassroomInstructor
469 = ClassroomCreatedOn
470 = ClassroomModifiedOn
472 = ClassroomCreatedByYou
473 = ClassroomCreatedByUser
500 = EnrollPeriodEnrolled
501 = EnrollPeriodConclusion
502 = EnrollPeriodFirstAccess
503 = EnrollPeriodLastAccess
504 = EnrollPeriodHistoric
505 = EnrollStartedMoreThanDays
506 = EnrollInProgress
507 = EnrollNotStart
508 = EnrollDelayed
509 = EnrollFinalized
510 = EnrollApproved
511 = EnrollReproved
512 = EnrollInRenovationWindow
513 = EnrollInvalidated
514 = EnrollRejected
515 = EnrollMandatoryAudience
516 = EnrollOptionalAudience
517 = EnrollOutOfAudience
518 = EnrollDoesCertificationExpire
520 = EnrollCertificationExpiringIn30Days
521 = EnrollCertificationExpiringIn60Days
522 = EnrollBlockedUsersOnly
523 = EnrollExcludeInactiveUser
524 = EnrollSpecificClassroom
525 = EnrollTrainingMandatory
526 = EnrollCanceledOrRevoked
527 = EnrollHideInvalidated
528 = EnrollHideConcluded
529 = EnrollContainsStatus
530 = EnrollRegistrationMode
531 = EnrollUsername
600 = BannerWithAudience
601 = BannerNotAudience
602 = BannerForUser
700 = KnowledgeQuickFilter
701 = KnowledgeChannel
702 = KnowledgeTopic
703 = KnowledgeAuthor
704 = KnowledgeSticker
705 = KnowledgeTopicsYourInterest
706 = KnowledgeChannelsYouAreSubscribed
707 = KnowledgeInstitutional
708 = KnowledgeNonInstitutional
709 = KnowledgePublishedByYou
710 = KnowledgeUserFollowingAuthor
711 = KnowledgeContainVideo
712 = KnowledgeContainAudio
713 = KnowledgeContainImage
714 = KnowledgeContainLink
715 = KnowledgeContainDocument
716 = KnowledgeContainMention
717 = KnowledgeContainShorts
718 = KnowledgeTitleContains
719 = KnowledgePeriod
720 = KnowledgeCreatedOn
721 = KnowledgeModifiedOn
722 = KnowledgeExpired
723 = KnowledgeAvailableInTheFuture
724 = KnowledgeLiked
725 = KnowledgeLikedCoworks
726 = KnowledgeRecommended
727 = KnowledgeTrending
728 = KnowledgeMentioningYou
729 = KnowledgeRestrictedAccess
730 = KnowledgeContent
731 = KnowledgeModifiedByManagerOrSupervisor
732 = KnowledgeBlocked
733 = KnowledgeViewsCount
734 = KnowledgeLikesCount
735 = KnowledgeCommentsCount
736 = KnowledgeSeenByYou
737 = KnowledgeNotSeenByYou
738 = KnowledgeMentioning
739 = KnowledgeMentioningUser
740 = KnowledgeMentioningTopic
741 = KnowledgeMentioningChannel
742 = KnowledgeMentioningPublication
743 = KnowledgePost
744 = KnowledgeQuestion
745 = KnowledgeList
746 = KnowledgePoll
747 = KnowledgeModerationPending
748 = KnowledgeIsRejected
749 = KnowledgeAvailableOnly
750 = KnowledgeNonVisiblePubs
751 = KnowledgeContainsPresentation
752 = KnowledgeBinder
753 = KnowledgePublicationTag
800 = SurveyTypeAdHoc
801 = SurveyTypeEfficacy
802 = SurveyTypeReaction
803 = SurveyPeriod
804 = SurveySticker
805 = SurveyStatusAnswered
806 = SurveyStatusNotAnswered
900 = ChannelCreatedBySelf
901 = ChannelOwner
902 = ChannelOwnerGroup
903 = ChannelOwnerUnit
904 = ChannelPublic
905 = ChannelPrivate
1000 = EnrollOperationAudienceOption
1001 = EnrollOperationClassroom
1002 = EnrollOperationStatusEnrollment
1003 = EnrollOperationEnrollmentHistory
1004 = EnrollOperationAudienceMandatoryToEnrollOption
1100 = DashboardUserMandatoryAudience
1200 = AssessmentTopic
1201 = AssessmentLanguage
1202 = AssessmentTag
1203 = AssessmentNameContain
1204 = AssessmentAuthorContain
1205 = AssessmentCodeContain
1206 = AssessmentCreatedOn
1207 = AssessmentModifiedOn
1208 = AssessmentIsBuilding
1209 = AssessmentCreatedByYou
1210 = AssessmentCreatedByUser
1211 = AssessmentModifiedByUser
1300 = GroupContainsMember
1301 = GroupTags
1302 = GroupUsage
1303 = GroupUnit
1304 = GroupActiveAndInactive
1305 = GroupInactiveOnly
1306 = GroupSuspendedOnly
1400 = UnitUser
1401 = UnitTag
1402 = UnitCustomField
1500 = TopicSubTopic
1501 = TopicTags
1502 = TopicKnowledge
1503 = TopicSkill
1504 = TopicCompetency
1505 = TopicBundler
1506 = TopicWithPublications
1507 = TopicWithChallenge
1508 = TopicWithTraining
1509 = TopicWithSpecialist
1510 = TopicWithoutPublications
1511 = TopicWithoutChallenge
1512 = TopicWithoutTraining
1513 = TopicWithoutSpecialist
1514 = TopicActiveAndInactive
1515 = TopicInactiveOnly
1550 = TopicUserRequiredLink
1551 = TopicUserOptionalLink
1552 = TopicUserWithEndorsement
1553 = TopicUserWithProvenKnowledge
1554 = TopicUserIsVerifiedKnower
1555 = TopicUserIsSpecialist
1600 = RoleContainPermision
1601 = RoleAssignedUser
1700 = SchedulerRunning
1701 = SchedulerNeverRun
1702 = SchedulerSuccess
1703 = SchedulerFailed
1704 = SchedulerEnabledOnly
1705 = SchedulerDisabledOnly
1706 = SchedulerQueueObjectType
1750 = SchedulerMessagingFromDate
1751 = SchedulerMessagingPushOnly
1752 = SchedulerMessagingSmtpOnly
1753 = SchedulerMessagingStatusDone
1754 = SchedulerMessagingStatusFailed
1755 = SchedulerMessagingStatusPending
1756 = SchedulerMessagingStatusRunning
1757 = SchedulerMessagingToDate
1758 = SchedulerMessagingUser
1800 = MeetingActiveAndInactive
99000 = GeneralCombineUsingOR
*/
export enum CoreFilterCommand {
  UserIncludeBlockedUsers = "UserIncludeBlockedUsers",
  UserTags = "UserTags",
  UserUnits = "UserUnits",
  UserGroups = "UserGroups",
  UserWorkplaces = "UserWorkplaces",
  UserWorkplaceText = "UserWorkplaceText",
  UserCustomField = "UserCustomField",
  UserIncludeInactive = "UserIncludeInactive",
  UserIncludeDeleted = "UserIncludeDeleted",
  UserIsManager = "UserIsManager",
  UserManagerDirectSubordinates = "UserManagerDirectSubordinates",
  UserManagerAllSubordinates = "UserManagerAllSubordinates",
  UserSpecific = "UserSpecific",
  UserInternal = "UserInternal",
  UserExternal = "UserExternal",
  UserTopicOptional = "UserTopicOptional",
  UserTopicRequired = "UserTopicRequired",
  UserChannelMembers = "UserChannelMembers",
  UserTrainingAttending = "UserTrainingAttending",
  UserTrainingApproved = "UserTrainingApproved",
  UserTrainingReproved = "UserTrainingReproved",
  UserInterestTag = "UserInterestTag",
  UserBlockReason = "UserBlockReason",
  UserAndDirectSubordinates = "UserAndDirectSubordinates",
  UserAndAllSubordinates = "UserAndAllSubordinates",
  UserHasSealProvenKnowledgeTopic = "UserHasSealProvenKnowledgeTopic",
  UserIsSpecialistInTopic = "UserIsSpecialistInTopic",
  UserLastAccessBeforeOf = "UserLastAccessBeforeOf",
  UserLastAccessAfterOf = "UserLastAccessAfterOf",
  UserPermission = "UserPermission",
  UserRoles = "UserRoles",
  UserSuspendedAccounts = "UserSuspendedAccounts",
  UserHasNotActiveDevPlan = "UserHasNotActiveDevPlan",
  UserHasActiveDevPlan = "UserHasActiveDevPlan",
  UserHasDraftDevPlan = "UserHasDraftDevPlan",
  UserHasDelayedDevPlan = "UserHasDelayedDevPlan",
  UserHasPendingApprovalDevPlan = "UserHasPendingApprovalDevPlan",
  UserOnlyBlocked = "UserOnlyBlocked",
  UserOnlyInactive = "UserOnlyInactive",
  UsersOnlyDeleted = "UsersOnlyDeleted",
  UserIsExternal = "UserIsExternal",
  UserTrainingAudience = "UserTrainingAudience",
  UserTrainingMandatoryAudience = "UserTrainingMandatoryAudience",
  UserOnlyUnblocked = "UserOnlyUnblocked",
  TrainingTopic = "TrainingTopic",
  TrainingSticker = "TrainingSticker",
  TrainingPublishPeriod = "TrainingPublishPeriod",
  TrainingWorkload = "TrainingWorkload",
  TrainingBestRated = "TrainingBestRated",
  TrainingWithAvailableClassrooms = "TrainingWithAvailableClassrooms",
  TrainingStartNow = "TrainingStartNow",
  TrainingInLearnPath = "TrainingInLearnPath",
  TrainingCoordinator = "TrainingCoordinator",
  TrainingSpecific = "TrainingSpecific",
  TrainingTypeCourseWeb = "TrainingTypeCourseWeb",
  TrainingTypeLive = "TrainingTypeLive",
  TrainingTypeExternalCourse = "TrainingTypeExternalCourse",
  TrainingTypeAssessment = "TrainingTypeAssessment",
  TrainingTypeActivity = "TrainingTypeActivity",
  TrainingTypeLearnPath = "TrainingTypeLearnPath",
  TrainingTypeGame = "TrainingTypeGame",
  TrainingRequiredAudienceContain = "TrainingRequiredAudienceContain",
  TrainingOptionalAudienceContain = "TrainingOptionalAudienceContain",
  TrainingContentType = "TrainingContentType",
  TrainingCustomField = "TrainingCustomField",
  TrainingLanguage = "TrainingLanguage",
  TrainingInstructor = "TrainingInstructor",
  TrainingNeverEnroll = "TrainingNeverEnroll",
  TrainingTag = "TrainingTag",
  TrainingCurrentUserMandatory = "TrainingCurrentUserMandatory",
  TrainingCurrentUserOptional = "TrainingCurrentUserOptional",
  TrainingCurrentUserAssigned = "TrainingCurrentUserAssigned",
  TrainingCurrentUserRegisterTeamMembers = "TrainingCurrentUserRegisterTeamMembers",
  TrainingCurrentUserTopicInterest = "TrainingCurrentUserTopicInterest",
  TrainingNameContain = "TrainingNameContain",
  TrainingAuthorContain = "TrainingAuthorContain",
  TrainingExternalCodeContain = "TrainingExternalCodeContain",
  TrainingWithUsersInProgress = "TrainingWithUsersInProgress",
  TrainingWithClasses = "TrainingWithClasses",
  TrainingWithUsersInterest = "TrainingWithUsersInterest",
  TrainingCreatedOn = "TrainingCreatedOn",
  TrainingModifiedOn = "TrainingModifiedOn",
  TrainingIsBuilding = "TrainingIsBuilding",
  TrainingCreatedByYou = "TrainingCreatedByYou",
  TrainingCreatedByUser = "TrainingCreatedByUser",
  TrainingWithMeeting = "TrainingWithMeeting",
  TrainingNameOrExternalCodeContain = "TrainingNameOrExternalCodeContain",
  TrainingWithRenovationWindowEnrolls = "TrainingWithRenovationWindowEnrolls",
  TrainingWithInvalidatedEnrolls = "TrainingWithInvalidatedEnrolls",
  TrainingWithHideConcludedEnrolls = "TrainingWithHideConcludedEnrolls",
  TrainingValidateExpiringOrExpired = "TrainingValidateExpiringOrExpired",
  TrainingValidateExpired = "TrainingValidateExpired",
  TrainingAvailableOnApp = "TrainingAvailableOnApp",
  ClassroomWithActiveUsers = "ClassroomWithActiveUsers",
  ClassroomExecutionPeriod = "ClassroomExecutionPeriod",
  ClassroomNameContain = "ClassroomNameContain",
  ClassroomExternalCodeContain = "ClassroomExternalCodeContain",
  ClassroomUsersInProgress = "ClassroomUsersInProgress",
  ClassroomWithOpenEnrollment = "ClassroomWithOpenEnrollment",
  ClassroomWithAudience = "ClassroomWithAudience",
  ClassroomExpired = "ClassroomExpired",
  ClassroomInstructor = "ClassroomInstructor",
  ClassroomCreatedOn = "ClassroomCreatedOn",
  ClassroomModifiedOn = "ClassroomModifiedOn",
  ClassroomCreatedByYou = "ClassroomCreatedByYou",
  ClassroomCreatedByUser = "ClassroomCreatedByUser",
  EnrollPeriodEnrolled = "EnrollPeriodEnrolled",
  EnrollPeriodConclusion = "EnrollPeriodConclusion",
  EnrollPeriodFirstAccess = "EnrollPeriodFirstAccess",
  EnrollPeriodLastAccess = "EnrollPeriodLastAccess",
  EnrollPeriodHistoric = "EnrollPeriodHistoric",
  EnrollStartedMoreThanDays = "EnrollStartedMoreThanDays",
  EnrollInProgress = "EnrollInProgress",
  EnrollNotStart = "EnrollNotStart",
  EnrollDelayed = "EnrollDelayed",
  EnrollFinalized = "EnrollFinalized",
  EnrollApproved = "EnrollApproved",
  EnrollReproved = "EnrollReproved",
  EnrollInRenovationWindow = "EnrollInRenovationWindow",
  EnrollInvalidated = "EnrollInvalidated",
  EnrollRejected = "EnrollRejected",
  EnrollMandatoryAudience = "EnrollMandatoryAudience",
  EnrollOptionalAudience = "EnrollOptionalAudience",
  EnrollOutOfAudience = "EnrollOutOfAudience",
  EnrollDoesCertificationExpire = "EnrollDoesCertificationExpire",
  EnrollCertificationExpiringIn30Days = "EnrollCertificationExpiringIn30Days",
  EnrollCertificationExpiringIn60Days = "EnrollCertificationExpiringIn60Days",
  EnrollBlockedUsersOnly = "EnrollBlockedUsersOnly",
  EnrollExcludeInactiveUser = "EnrollExcludeInactiveUser",
  EnrollSpecificClassroom = "EnrollSpecificClassroom",
  EnrollTrainingMandatory = "EnrollTrainingMandatory",
  EnrollCanceledOrRevoked = "EnrollCanceledOrRevoked",
  EnrollHideInvalidated = "EnrollHideInvalidated",
  EnrollHideConcluded = "EnrollHideConcluded",
  EnrollContainsStatus = "EnrollContainsStatus",
  EnrollRegistrationMode = "EnrollRegistrationMode",
  EnrollUsername = "EnrollUsername",
  BannerWithAudience = "BannerWithAudience",
  BannerNotAudience = "BannerNotAudience",
  BannerForUser = "BannerForUser",
  KnowledgeQuickFilter = "KnowledgeQuickFilter",
  KnowledgeChannel = "KnowledgeChannel",
  KnowledgeTopic = "KnowledgeTopic",
  KnowledgeAuthor = "KnowledgeAuthor",
  KnowledgeSticker = "KnowledgeSticker",
  KnowledgeTopicsYourInterest = "KnowledgeTopicsYourInterest",
  KnowledgeChannelsYouAreSubscribed = "KnowledgeChannelsYouAreSubscribed",
  KnowledgeInstitutional = "KnowledgeInstitutional",
  KnowledgeNonInstitutional = "KnowledgeNonInstitutional",
  KnowledgePublishedByYou = "KnowledgePublishedByYou",
  KnowledgeUserFollowingAuthor = "KnowledgeUserFollowingAuthor",
  KnowledgeContainVideo = "KnowledgeContainVideo",
  KnowledgeContainAudio = "KnowledgeContainAudio",
  KnowledgeContainImage = "KnowledgeContainImage",
  KnowledgeContainLink = "KnowledgeContainLink",
  KnowledgeContainDocument = "KnowledgeContainDocument",
  KnowledgeContainMention = "KnowledgeContainMention",
  KnowledgeContainShorts = "KnowledgeContainShorts",
  KnowledgeTitleContains = "KnowledgeTitleContains",
  KnowledgePeriod = "KnowledgePeriod",
  KnowledgeCreatedOn = "KnowledgeCreatedOn",
  KnowledgeModifiedOn = "KnowledgeModifiedOn",
  KnowledgeExpired = "KnowledgeExpired",
  KnowledgeAvailableInTheFuture = "KnowledgeAvailableInTheFuture",
  KnowledgeLiked = "KnowledgeLiked",
  KnowledgeLikedCoworks = "KnowledgeLikedCoworks",
  KnowledgeRecommended = "KnowledgeRecommended",
  KnowledgeTrending = "KnowledgeTrending",
  KnowledgeMentioningYou = "KnowledgeMentioningYou",
  KnowledgeRestrictedAccess = "KnowledgeRestrictedAccess",
  KnowledgeContent = "KnowledgeContent",
  KnowledgeModifiedByManagerOrSupervisor = "KnowledgeModifiedByManagerOrSupervisor",
  KnowledgeBlocked = "KnowledgeBlocked",
  KnowledgeViewsCount = "KnowledgeViewsCount",
  KnowledgeLikesCount = "KnowledgeLikesCount",
  KnowledgeCommentsCount = "KnowledgeCommentsCount",
  KnowledgeSeenByYou = "KnowledgeSeenByYou",
  KnowledgeNotSeenByYou = "KnowledgeNotSeenByYou",
  KnowledgeMentioning = "KnowledgeMentioning",
  KnowledgeMentioningUser = "KnowledgeMentioningUser",
  KnowledgeMentioningTopic = "KnowledgeMentioningTopic",
  KnowledgeMentioningChannel = "KnowledgeMentioningChannel",
  KnowledgeMentioningPublication = "KnowledgeMentioningPublication",
  KnowledgePost = "KnowledgePost",
  KnowledgeQuestion = "KnowledgeQuestion",
  KnowledgeList = "KnowledgeList",
  KnowledgePoll = "KnowledgePoll",
  KnowledgeModerationPending = "KnowledgeModerationPending",
  KnowledgeIsRejected = "KnowledgeIsRejected",
  KnowledgeAvailableOnly = "KnowledgeAvailableOnly",
  KnowledgeNonVisiblePubs = "KnowledgeNonVisiblePubs",
  KnowledgeContainsPresentation = "KnowledgeContainsPresentation",
  KnowledgeBinder = "KnowledgeBinder",
  KnowledgePublicationTag = "KnowledgePublicationTag",
  SurveyTypeAdHoc = "SurveyTypeAdHoc",
  SurveyTypeEfficacy = "SurveyTypeEfficacy",
  SurveyTypeReaction = "SurveyTypeReaction",
  SurveyPeriod = "SurveyPeriod",
  SurveySticker = "SurveySticker",
  SurveyStatusAnswered = "SurveyStatusAnswered",
  SurveyStatusNotAnswered = "SurveyStatusNotAnswered",
  ChannelCreatedBySelf = "ChannelCreatedBySelf",
  ChannelOwner = "ChannelOwner",
  ChannelOwnerGroup = "ChannelOwnerGroup",
  ChannelOwnerUnit = "ChannelOwnerUnit",
  ChannelPublic = "ChannelPublic",
  ChannelPrivate = "ChannelPrivate",
  EnrollOperationAudienceOption = "EnrollOperationAudienceOption",
  EnrollOperationClassroom = "EnrollOperationClassroom",
  EnrollOperationStatusEnrollment = "EnrollOperationStatusEnrollment",
  EnrollOperationEnrollmentHistory = "EnrollOperationEnrollmentHistory",
  EnrollOperationAudienceMandatoryToEnrollOption = "EnrollOperationAudienceMandatoryToEnrollOption",
  DashboardUserMandatoryAudience = "DashboardUserMandatoryAudience",
  AssessmentTopic = "AssessmentTopic",
  AssessmentLanguage = "AssessmentLanguage",
  AssessmentTag = "AssessmentTag",
  AssessmentNameContain = "AssessmentNameContain",
  AssessmentAuthorContain = "AssessmentAuthorContain",
  AssessmentCodeContain = "AssessmentCodeContain",
  AssessmentCreatedOn = "AssessmentCreatedOn",
  AssessmentModifiedOn = "AssessmentModifiedOn",
  AssessmentIsBuilding = "AssessmentIsBuilding",
  AssessmentCreatedByYou = "AssessmentCreatedByYou",
  AssessmentCreatedByUser = "AssessmentCreatedByUser",
  AssessmentModifiedByUser = "AssessmentModifiedByUser",
  GroupContainsMember = "GroupContainsMember",
  GroupTags = "GroupTags",
  GroupUsage = "GroupUsage",
  GroupUnit = "GroupUnit",
  GroupActiveAndInactive = "GroupActiveAndInactive",
  GroupInactiveOnly = "GroupInactiveOnly",
  GroupSuspendedOnly = "GroupSuspendedOnly",
  UnitUser = "UnitUser",
  UnitTag = "UnitTag",
  UnitCustomField = "UnitCustomField",
  TopicSubTopic = "TopicSubTopic",
  TopicTags = "TopicTags",
  TopicKnowledge = "TopicKnowledge",
  TopicSkill = "TopicSkill",
  TopicCompetency = "TopicCompetency",
  TopicBundler = "TopicBundler",
  TopicWithPublications = "TopicWithPublications",
  TopicWithChallenge = "TopicWithChallenge",
  TopicWithTraining = "TopicWithTraining",
  TopicWithSpecialist = "TopicWithSpecialist",
  TopicWithoutPublications = "TopicWithoutPublications",
  TopicWithoutChallenge = "TopicWithoutChallenge",
  TopicWithoutTraining = "TopicWithoutTraining",
  TopicWithoutSpecialist = "TopicWithoutSpecialist",
  TopicActiveAndInactive = "TopicActiveAndInactive",
  TopicInactiveOnly = "TopicInactiveOnly",
  TopicUserRequiredLink = "TopicUserRequiredLink",
  TopicUserOptionalLink = "TopicUserOptionalLink",
  TopicUserWithEndorsement = "TopicUserWithEndorsement",
  TopicUserWithProvenKnowledge = "TopicUserWithProvenKnowledge",
  TopicUserIsVerifiedKnower = "TopicUserIsVerifiedKnower",
  TopicUserIsSpecialist = "TopicUserIsSpecialist",
  RoleContainPermision = "RoleContainPermision",
  RoleAssignedUser = "RoleAssignedUser",
  SchedulerRunning = "SchedulerRunning",
  SchedulerNeverRun = "SchedulerNeverRun",
  SchedulerSuccess = "SchedulerSuccess",
  SchedulerFailed = "SchedulerFailed",
  SchedulerEnabledOnly = "SchedulerEnabledOnly",
  SchedulerDisabledOnly = "SchedulerDisabledOnly",
  SchedulerQueueObjectType = "SchedulerQueueObjectType",
  SchedulerMessagingFromDate = "SchedulerMessagingFromDate",
  SchedulerMessagingPushOnly = "SchedulerMessagingPushOnly",
  SchedulerMessagingSmtpOnly = "SchedulerMessagingSmtpOnly",
  SchedulerMessagingStatusDone = "SchedulerMessagingStatusDone",
  SchedulerMessagingStatusFailed = "SchedulerMessagingStatusFailed",
  SchedulerMessagingStatusPending = "SchedulerMessagingStatusPending",
  SchedulerMessagingStatusRunning = "SchedulerMessagingStatusRunning",
  SchedulerMessagingToDate = "SchedulerMessagingToDate",
  SchedulerMessagingUser = "SchedulerMessagingUser",
  MeetingActiveAndInactive = "MeetingActiveAndInactive",
  GeneralCombineUsingOR = "GeneralCombineUsingOR",
}

/**
* 0 = Low
1 = Medium
2 = High
* @format int32
*/
export enum ConfidenceLevel {
  Low = 0,
  Medium = 1,
  High = 2,
}

/**
* 0 = Registration
1 = PreRequisites
2 = Execution
3 = InstructorsActions
4 = ApprovalActions
5 = Assessments
6 = Agreement
7 = Interaction
8 = Certificate
9 = Award
10 = ConclusionForm
* @format int32
*/
export enum ClassroomTargetRule {
  Registration = 0,
  PreRequisites = 1,
  Execution = 2,
  InstructorsActions = 3,
  ApprovalActions = 4,
  Assessments = 5,
  Agreement = 6,
  Interaction = 7,
  Certificate = 8,
  Award = 9,
  ConclusionForm = 10,
}

/**
* 0 = Performance
1 = Goals
2 = ManageAD
3 = ManageGoal
* @format int32
*/
export enum ChooseLandingPageOptions {
  Performance = 0,
  Goals = 1,
  ManageAD = 2,
  ManageGoal = 3,
}

/**
* 0 = TopicInterest
1 = MostActive
2 = Latest
3 = Registered
4 = SearchText
* @format int32
*/
export enum ChannelSubscriptionFilterBy {
  TopicInterest = 0,
  MostActive = 1,
  Latest = 2,
  Registered = 3,
  SearchText = 4,
}

/**
* 0 = Relevance
1 = Name
2 = Publications
* @format int32
*/
export enum ChannelSearchOrderBy {
  Relevance = 0,
  Name = 1,
  Publications = 2,
}

/**
* 0 = Guest
1 = Contributor
2 = Supervisor
3 = Manager
4 = Owner
* @format int32
*/
export enum ChannelRoles {
  Guest = 0,
  Contributor = 1,
  Supervisor = 2,
  Manager = 3,
  Owner = 4,
}

/**
* 0 = All
1 = OnlyPrivate
2 = OnlyPublic
* @format int32
*/
export enum ChannelPublicationsCountOption {
  All = 0,
  OnlyPrivate = 1,
  OnlyPublic = 2,
}

/**
* 0 = Free
1 = Forbidden
2 = ByApproval
* @format int32
*/
export enum ChannelAutoRegisterMode {
  Free = 0,
  Forbidden = 1,
  ByApproval = 2,
}

/**
* 0 = None
1 = AI
2 = Required
* @format int32
*/
export enum ChannelApprovalMode {
  None = 0,
  AI = 1,
  Required = 2,
}

/**
* 0 = Up
1 = Down
* @format int32
*/
export enum ChangeStickerPriorityOption {
  Up = 0,
  Down = 1,
}

/**
* 0 = Default
1 = Retention
* @format int32
*/
export enum ChallengeMode {
  Default = 0,
  Retention = 1,
}

/**
* 0 = Valid
1 = Expiring
2 = ExpiredLong
3 = ExpiredShort
* @format int32
*/
export enum CertificateStatus {
  Valid = 0,
  Expiring = 1,
  ExpiredLong = 2,
  ExpiredShort = 3,
}

/**
* 0 = All
1 = PublicationOnly
2 = TrainingOnly
* @format int32
*/
export enum CarouselPubTrainingOption {
  All = 0,
  PublicationOnly = 1,
  TrainingOnly = 2,
}

/**
* 0 = Up
1 = Down
2 = Left
3 = Right
4 = NewLineUp
5 = NewLineDown
6 = Exclude
* @format int32
*/
export enum CarouselOperationOption {
  Up = 0,
  Down = 1,
  Left = 2,
  Right = 3,
  NewLineUp = 4,
  NewLineDown = 5,
  Exclude = 6,
}

/**
* 1 = Home
2 = LMS
* @format int32
*/
export enum CarouselModule {
  Home = 1,
  LMS = 2,
}

/**
* 1 = LmsActivitiesToComplete
2 = LmsGamesAvailable
3 = LmsPendingApproval
4 = LmsTrainingMandatory
5 = LmsFromUserPosition
7 = LmsAssignedToUser
8 = LmsCoworkers
9 = LmsDevPlan
51 = BasedOnUserKnowledgesTests
52 = AssessmentList
100 = Attending
101 = Recommendations
102 = Trending
103 = MostViewed
104 = MostRecent
200 = UserTopics
201 = UserLists
202 = UserTeam
203 = UserManagers
204 = UserInterest
250 = PubShorts
256 = HomePriorities
* @format int32
*/
export enum CarouselListType {
  LmsActivitiesToComplete = 1,
  LmsGamesAvailable = 2,
  LmsPendingApproval = 3,
  LmsTrainingMandatory = 4,
  LmsFromUserPosition = 5,
  LmsAssignedToUser = 7,
  LmsCoworkers = 8,
  LmsDevPlan = 9,
  BasedOnUserKnowledgesTests = 51,
  AssessmentList = 52,
  Attending = 100,
  Recommendations = 101,
  Trending = 102,
  MostViewed = 103,
  MostRecent = 104,
  UserTopics = 200,
  UserLists = 201,
  UserTeam = 202,
  UserManagers = 203,
  UserInterest = 204,
  PubShorts = 250,
  HomePriorities = 256,
}

/**
* 0 = Feature
1 = ExternalLink
2 = IFrame
* @format int32
*/
export enum CarouselLinkType {
  Feature = 0,
  ExternalLink = 1,
  IFrame = 2,
}

/**
* 0 = InternalList
1 = ContentList
2 = TopicList
3 = PublicationFilter
4 = TrainingFilter
5 = AssessmentFilter
6 = Links
* @format int32
*/
export enum CarouselContentType {
  InternalList = 0,
  ContentList = 1,
  TopicList = 2,
  PublicationFilter = 3,
  TrainingFilter = 4,
  AssessmentFilter = 5,
  Links = 6,
}

/**
* 0 = Training
1 = Assessment
2 = Publication
3 = Topic
* @format int32
*/
export enum CarouselContentListType {
  Training = 0,
  Assessment = 1,
  Publication = 2,
  Topic = 3,
}

/**
* 0 = Default
1 = Link
2 = CounterInfo
* @format int32
*/
export enum CarouselCardRenderMode {
  Default = 0,
  Link = 1,
  CounterInfo = 2,
}

/**
* 0 = Standard
1 = Avatar
* @format int32
*/
export enum CardThumbnailDisplayMode {
  Standard = 0,
  Avatar = 1,
}

/**
* 0 = caption
1 = title
2 = titleAlt
3 = displayName
4 = line
5 = lineWrap
6 = link
7 = linkAlt
8 = sticker
9 = iconText
* @format int32
*/
export enum CardTextVariant {
  Caption = 0,
  Title = 1,
  TitleAlt = 2,
  DisplayName = 3,
  Line = 4,
  LineWrap = 5,
  Link = 6,
  LinkAlt = 7,
  Sticker = 8,
  IconText = 9,
}

/**
* 0 = Standard
1 = Compact
2 = LearnPathTraining
* @format int32
*/
export enum CardRenderMode {
  Standard = 0,
  Compact = 1,
  LearnPathTraining = 2,
}

/**
* 0 = Lock
1 = ThumbsUp
2 = Bookmark
3 = CircleExclamationCheck
4 = CircleXmark
5 = CircleCheck
6 = CircleMinus
7 = Circle
* @format int32
*/
export enum CardIconVariant {
  Lock = 0,
  ThumbsUp = 1,
  Bookmark = 2,
  CircleExclamationCheck = 3,
  CircleXmark = 4,
  CircleCheck = 5,
  CircleMinus = 6,
  Circle = 7,
}

/**
* 0 = Info
1 = Success
2 = Warning
3 = Error
4 = Muted
5 = MutedDark
6 = White
7 = Black
8 = Cancel
9 = Highlight
* @format int32
*/
export enum CardColor {
  Info = 0,
  Success = 1,
  Warning = 2,
  Error = 3,
  Muted = 4,
  MutedDark = 5,
  White = 6,
  Black = 7,
  Cancel = 8,
  Highlight = 9,
}

/**
* 0 = None
1 = LmsRegistration
2 = LmsRegistrationView
3 = LmsRegistrationOneClick
4 = LmsTrainingInfo
5 = LmsEnrollmentView
6 = LmsFillConclusionForm
7 = LmsEditConclusionForm
8 = LmsShowWorkflowStatus
9 = LmsAddToLibrary
10 = LmsRateAndWriteComment
11 = LmsShareInChannel
12 = LmsShareInList
13 = LmsNewConclusionForm
14 = LmsTutoring
15 = LmsCoordinating
16 = LmsPreApproval
17 = LmsConclusionFormApproval
18 = LmsBookmarkedReaction
19 = LmsLikedReaction
20 = LmsOpenAssessment
21 = LmsLibraryView
22 = OpenMeetingLink
23 = OpenSurvey
24 = OpenEvaluation
25 = OpenManagerEfficacy
26 = DeclineSurvey
27 = PublicationView
28 = PublicationAddToList
29 = PublicationAddToViewLater
30 = PublishAndShare
31 = KnowledgeTests
32 = KnowledgeCustomList
33 = KnowledgeSeeLater
34 = KnowledgeFavorites
35 = KnowledgeShorts
36 = KnowledgeModeration
37 = ExternalLink
38 = IFrameContent
39 = TopicTrainingsView
40 = TopicPublicationsView
41 = MoreUserInfo
42 = AskToUser
43 = DirectMessage
44 = LinkFeature
45 = UserInterests
46 = UserProfile
47 = UserIndicators
48 = ActionSetDeadline
49 = Reorder
50 = Remove
51 = PublicationPreview
52 = DevPlanActivityView
53 = DevPlanActivityEdit
54 = DevPlanActivityResetProgress
55 = MeetingView
56 = FoundationUserWaitingApproval
* @format int32
*/
export enum CardActionType {
  None = 0,
  LmsRegistration = 1,
  LmsRegistrationView = 2,
  LmsRegistrationOneClick = 3,
  LmsTrainingInfo = 4,
  LmsEnrollmentView = 5,
  LmsFillConclusionForm = 6,
  LmsEditConclusionForm = 7,
  LmsShowWorkflowStatus = 8,
  LmsAddToLibrary = 9,
  LmsRateAndWriteComment = 10,
  LmsShareInChannel = 11,
  LmsShareInList = 12,
  LmsNewConclusionForm = 13,
  LmsTutoring = 14,
  LmsCoordinating = 15,
  LmsPreApproval = 16,
  LmsConclusionFormApproval = 17,
  LmsBookmarkedReaction = 18,
  LmsLikedReaction = 19,
  LmsOpenAssessment = 20,
  LmsLibraryView = 21,
  OpenMeetingLink = 22,
  OpenSurvey = 23,
  OpenEvaluation = 24,
  OpenManagerEfficacy = 25,
  DeclineSurvey = 26,
  PublicationView = 27,
  PublicationAddToList = 28,
  PublicationAddToViewLater = 29,
  PublishAndShare = 30,
  KnowledgeTests = 31,
  KnowledgeCustomList = 32,
  KnowledgeSeeLater = 33,
  KnowledgeFavorites = 34,
  KnowledgeShorts = 35,
  KnowledgeModeration = 36,
  ExternalLink = 37,
  IFrameContent = 38,
  TopicTrainingsView = 39,
  TopicPublicationsView = 40,
  MoreUserInfo = 41,
  AskToUser = 42,
  DirectMessage = 43,
  LinkFeature = 44,
  UserInterests = 45,
  UserProfile = 46,
  UserIndicators = 47,
  ActionSetDeadline = 48,
  Reorder = 49,
  Remove = 50,
  PublicationPreview = 51,
  DevPlanActivityView = 52,
  DevPlanActivityEdit = 53,
  DevPlanActivityResetProgress = 54,
  MeetingView = 55,
  FoundationUserWaitingApproval = 56,
}

/**
* 0 = Primary
1 = Secondary
2 = Button
3 = Overflow
4 = Thumbnail
5 = Title
6 = Card
* @format int32
*/
export enum CardActionLocation {
  Primary = 0,
  Secondary = 1,
  Button = 2,
  Overflow = 3,
  Thumbnail = 4,
  Title = 5,
  Card = 6,
}

/**
* 0 = All
1 = Instructor
2 = Participant
* @format int32
*/
export enum CalendarFilterBy {
  All = 0,
  Instructor = 1,
  Participant = 2,
}

/**
* 0 = MeetingDate
1 = MeetingName
2 = TrainingName
* @format int32
*/
export enum CalendarAppointmentsOrderBy {
  MeetingDate = 0,
  MeetingName = 1,
  TrainingName = 2,
}

/**
* 0 = CustomMessage
1 = WelcomeMessage
* @format int32
*/
export enum BroadcastMessageType {
  CustomMessage = 0,
  WelcomeMessage = 1,
}

/**
* 1 = MonthlyInvoice
2 = BoughtPackage
* @format int32
*/
export enum BillingPaymentSource {
  MonthlyInvoice = 1,
  BoughtPackage = 2,
}

/**
* 1 = PublicationFeed
2 = TrainingCatalog
* @format int32
*/
export enum BannerTopicGoToType {
  PublicationFeed = 1,
  TrainingCatalog = 2,
}

/**
* 1 = AlignLeft
2 = AlignCenter
3 = Resize
* @format int32
*/
export enum BannerPanoramicOption {
  AlignLeft = 1,
  AlignCenter = 2,
  Resize = 3,
}

/**
* 1 = All
2 = Welcome
3 = Training
4 = knowlegde
* @format int32
*/
export enum BannerPageViewType {
  All = 1,
  Welcome = 2,
  Training = 3,
  Knowlegde = 4,
}

/**
* 1 = Name
2 = CreateDate
3 = Hits
* @format int32
*/
export enum BannerListQueryOrderBy {
  Name = 1,
  CreateDate = 2,
  Hits = 3,
}

/**
* 1 = Publication
2 = Topic
3 = System
4 = Link
5 = Training
6 = Assessment
7 = ImageOnly
* @format int32
*/
export enum BannerContentType {
  Publication = 1,
  Topic = 2,
  System = 3,
  Link = 4,
  Training = 5,
  Assessment = 6,
  ImageOnly = 7,
}

/**
* 1 = NoDeadline
2 = Week
3 = Month
* @format int32
*/
export enum BadgeRulePeriod {
  NoDeadline = 1,
  Week = 2,
  Month = 3,
}

/**
* 0 = NoLimit
1 = First
3 = Top3
5 = Top5
10 = Top10
20 = Top20
50 = Top50
* @format int32
*/
export enum BadgeRuleActionLimits {
  NoLimit = 0,
  First = 1,
  Top3 = 3,
  Top5 = 5,
  Top10 = 10,
  Top20 = 20,
  Top50 = 50,
}

/**
* 1 = CreatePost
2 = CreateQuestion
3 = AnswerQuestion
4 = PublicationStickerManager
5 = PromoteShortManager
6 = PublicationLiked
257 = TrainingComplete
258 = TrainingSetComplete
259 = ChallengeComplete
260 = GrantProvenKnowledgeSeal
* @format int32
*/
export enum BadgeRuleAction {
  CreatePost = 1,
  CreateQuestion = 2,
  AnswerQuestion = 3,
  PublicationStickerManager = 4,
  PromoteShortManager = 5,
  PublicationLiked = 6,
  TrainingComplete = 257,
  TrainingSetComplete = 258,
  ChallengeComplete = 259,
  GrantProvenKnowledgeSeal = 260,
}

/**
* 257 = CreatePost
258 = AnswerQuestion
259 = DeletePost
260 = TrashOutPost
261 = RetrievePost
262 = DeleteAnswer
513 = SelfEnrollTraining
514 = ApprovalTraining
515 = SelfEnrollTrainingPointsChanged
516 = ApprovalTrainingPointsChanged
517 = ExcludeSelfEnrollTraining
518 = ExcludeApprovalTraining
519 = CancelSelfEnrollTraining
520 = CancelApprovalTraining
521 = RevokeSelfEnrollTraining
522 = RevokeApprovalTraining
523 = UnrevokeSelfEnrollTraining
524 = UnrevokeApprovalTraining
769 = ChallengeCompleted
1025 = BadgeGranted
* @format int32
*/
export enum AwardTransaction {
  CreatePost = 257,
  AnswerQuestion = 258,
  DeletePost = 259,
  TrashOutPost = 260,
  RetrievePost = 261,
  DeleteAnswer = 262,
  SelfEnrollTraining = 513,
  ApprovalTraining = 514,
  SelfEnrollTrainingPointsChanged = 515,
  ApprovalTrainingPointsChanged = 516,
  ExcludeSelfEnrollTraining = 517,
  ExcludeApprovalTraining = 518,
  CancelSelfEnrollTraining = 519,
  CancelApprovalTraining = 520,
  RevokeSelfEnrollTraining = 521,
  RevokeApprovalTraining = 522,
  UnrevokeSelfEnrollTraining = 523,
  UnrevokeApprovalTraining = 524,
  ChallengeCompleted = 769,
  BadgeGranted = 1025,
}

/**
* 1 = AllUsers
2 = Coworkers
3 = UsersSameUnit
* @format int32
*/
export enum AwardParticipantsType {
  AllUsers = 1,
  Coworkers = 2,
  UsersSameUnit = 3,
}

/**
* 0 = MostFollowed
1 = MostViewed
2 = Registered
3 = SearchText
* @format int32
*/
export enum AuthorSubscriptionFilterBy {
  MostFollowed = 0,
  MostViewed = 1,
  Registered = 2,
  SearchText = 3,
}

/**
* 256 = UserCreated
257 = UserUpdated
258 = UserDeleted
259 = UserDisplayNameChanged
260 = UserEmailNameChanged
261 = UserManagerChanged
262 = UserApproverChanged
263 = UserExternal
264 = UserBlocked
265 = UserUnblocked
266 = UserInactivated
267 = UserReactivated
268 = UserPasswordChanged
269 = UserPersonalDataChanged
270 = UserCustomFieldChanged
271 = UserUnitAdded
272 = UserUnitRemoved
273 = UserSecondaryManagerAdded
274 = UserSecondaryManagerRemoved
275 = UserRoleAdded
276 = UserRoleRemoved
277 = UserTagAdded
278 = UserTagRemoved
279 = UserFileAdded
280 = UserFileRemoved
281 = UserPersonalInterestAdded
282 = UserPersonalInterestRemoved
283 = UserCredentialAdded
284 = UserCredentialChanged
285 = UserCredentialRemoved
286 = UserLanguageAdded
287 = UserLanguageChanged
288 = UserLanguageRemoved
289 = UserNameChanged
290 = UserPreferredLanguageChanged
291 = UserWorkplaceChanged
292 = UserAccessExpirationChanged
293 = UserThumbnailChanged
294 = UserRoleDesactivate
295 = UserRoleReactivate
296 = UserCorporateInfoChanged
297 = UserLogin
298 = UserLogout
299 = UserTrainingExempt
300 = UserTrainingExemptRevoke
317 = UserSpyLoginAuthorized
318 = UserSpyLogin
319 = UserSpyLogout
320 = UserAccountLocked
321 = UserAccountUnlocked
322 = UserApproved
323 = UserRejected
324 = UserAccountConfirmed
325 = UserMessageToApprover
512 = GroupCreated
513 = GroupUpdated
514 = GroupDeleted
515 = GroupMemberAdded
516 = GroupMemberRemoved
517 = GroupRulesChanged
518 = GroupReproccessed
519 = GroupSuspendeUpdates
520 = GroupTagAdded
521 = GroupTagRemoved
768 = RoleCreated
769 = RoleUpdated
770 = RoleDeleted
771 = RolePermissiedAdded
772 = RolePermissiedRemoved
773 = RoleRestrictionsChanged
1024 = UnitCreated
1025 = UnitUpdated
1026 = UnitDeleted
1027 = UnitTagAdded
1028 = UnitTagRemoved
1029 = UnitCustomFieldChanged
1280 = TopicCreated
1281 = TopicUpdated
1282 = TopicDeleted
1283 = TopicDynamicGroupAdded
1284 = TopicDynamicGroupRemoved
1285 = TopicUserAdded
1286 = TopicUserRemoved
1287 = TopicSpecialistAdded
1288 = TopicSpecialistRemoved
1289 = TopicTagAdded
1290 = TopicTagRemoved
1536 = BannerCreated
1537 = BannerUpdated
1538 = BannerDeleted
1539 = BannerImageAdded
1540 = BannerAudienceAdded
1541 = BannerAudienceRemoved
1792 = ChannelCreated
1793 = ChannelUpdated
1794 = ChannelDeleted
1795 = ChannelMemberAdded
1796 = ChannelMemberRemoved
1797 = ChannelMemberPermissionChanged
1798 = ChannelRequestAccess
1799 = ChannelCustomQuickFilterAdded
1800 = ChannelCustomQuickFilterDeleted
1893 = ChannelJoin
2048 = PublicationCreated
2049 = PublicationUpdated
2050 = PublicationDeleted
2051 = PublicationTitleChanged
2052 = PublicationContentChanged
2053 = PublicationDraft
2054 = PublicationPublished
2055 = PublicationTrashRecover
2056 = PublicationSentTrash
2057 = PublicationShortPromote
2058 = PublicationSendToIAModeration
2059 = PublicationSendToModerator
2060 = PublicationSendToEncode
2061 = PublicationEncoded
2062 = PublicationApprovedByIA
2063 = PublicationSuspiciusByIA
2064 = PublicationApproved
2065 = PublicationRejected
2066 = PublicationBlocked
2067 = PublicationUnblockRequested
2068 = PublicationSetThumbnail
2069 = PublicationFileAdded
2070 = PublicationFileRemoved
2071 = PublicationErrorOrAbuseReported
2072 = PublicationErrorOrAbuseAnalysed
2073 = PublicationSetAccessRestriction
2074 = PublicationSetInstitutional
2075 = PublicationSetAnonymous
2076 = PublicationSetPublic
2077 = PublicationChannelChanged
2078 = PublicationTopicAdded
2079 = PublicationTopicRemoved
2080 = PublicationStickerAdded
2081 = PublicationStickerRemoved
2082 = PublicationListItemAdded
2083 = PublicationListItemRemoved
2084 = PublicationContentRelationAdded
2085 = PublicationContentRelationRemoved
2086 = PublicationSendToCoginitiveAnalysis
2087 = PublicationCoginitiveAnalysisPassed
2088 = PublicationCoginitiveAnalysisRefused
2089 = PublicationApprovedBySystem
2090 = PublicationApprovedByAuthor
2091 = PublicationEditJustification
2092 = PublicationNameEntities
2093 = PublicationKeyWords
2304 = TrainingCreated
2305 = TrainingUpdated
2306 = TrainingDeleted
2307 = TrainingNameChanged
2308 = TrainingDescriptionChanged
2309 = TrainingObjectiveChanged
2310 = TrainingMultipleClassrooms
2311 = TrainingActivate
2312 = TrainingGamified
2313 = TrainingCredits
2314 = TrainingOwnerAdded
2315 = TrainingOwnerRemoved
2316 = TrainingCoordinatorAdded
2317 = TrainingCoordinatorRemoved
2318 = TrainingInstructorAdded
2319 = TrainingInstructorRemoved
2320 = TrainingSpecialistAdded
2321 = TrainingSpecialistRemoved
2322 = TrainingEquivalenceAdded
2323 = TrainingEquivalenceRemoved
2324 = TrainingRelationshipAdded
2325 = TrainingRelationshipRemoved
2326 = TrainingAudienceAdded
2327 = TrainingAudienceRemoved
2328 = TrainingAudienceBelongEveryone
2329 = TrainingCustomFieldChanged
2330 = TrainingTopicAdded
2331 = TrainingTopicRemoved
2332 = TrainingStickerAdded
2333 = TrainingStickerRemoved
2335 = TrainingTagAdded
2336 = TrainingTagRemoved
2337 = TrainingRulesChanged
2338 = TrainingCertificateChanged
2339 = TrainigGamificationPropsChanged
2340 = TrainingComponentAdded
2341 = TrainingComponentRemoved
2342 = TrainingComponentUpdated
2343 = TrainingComponentPropsChanged
2344 = TrainingMaterialListAdded
2345 = TrainingMaterialListRemoved
2346 = TrainingNewContentVersion
2347 = TrainingNewComponentVersion
2348 = TrainingSetReactionAssessment
2349 = TrainingSetUserEfficacyAssessment
2350 = TrainingSetManagerEfficacyAssessment
2351 = TrainingPresentationVideoChanged
2352 = TrainingScormPackageCreated
2353 = TrainingScormPackageUpdated
2354 = TrainingScormPackageRemoved
2560 = ClassroomCreated
2561 = ClassroomUpdated
2562 = ClassroomDeleted
2563 = ClassroomNameChanged
2564 = ClassroomActivate
2565 = ClassroomMaterialListAdded
2566 = ClassroomMaterialListRemoved
2567 = ClassroomMaterialListBlocked
2568 = ClassroomSetAssReaction
2569 = ClassroomSetAssUserEfficacy
2570 = ClassroomSetAssManagerEfficacy
2571 = ClassroomCertificateChanged
2572 = ClassroomRulesChanged
2573 = ClassroomOwnerAdded
2574 = ClassroomOwnerRemoved
2575 = ClassroomInstructorAdded
2576 = ClassroomInstructorRemoved
2577 = ClassroomAudienceAdded
2578 = ClassroomAudienceRemoved
2579 = ClassroomAudienceBelongsAll
2580 = ClassroomCustomFieldChanged
2581 = ClassroomMaterialListUnblocked
2816 = EnrollCreated
2818 = EnrollDeleted
2819 = EnrollFirstAccess
2820 = EnrollCanceled
2821 = EnrollApproved
2822 = EnrollReproved
2823 = EnrollCertificate
2824 = EnrollExpired
2825 = EnrollRevoked
2826 = EnrollUndoRevoke
2827 = EnrollReopened
2828 = EnrollSetEventPresence
2829 = EnrollSetEventScore
2830 = EnrollSetActivityScore
2831 = EnrollSetAssessmentyScore
2832 = EnrollAdditionalDays
2833 = EnrollAward
2834 = EnrollRequested
2835 = EnrollRequestApproved
2836 = EnrollConclusionFormRequested
2837 = EnrollConclusionRequestApproved
2838 = EnrollConclusionRequestReproved
2839 = EnrollConclusionRequestRejected
2840 = EnrollReservation
2841 = EnrollExempt
2848 = EnrollImported
3072 = MeetingCreated
3073 = MeetingUpdated
3074 = MeetingDeleted
3075 = MeetingNameChanged
3076 = MeetingTimeChanged
3077 = MeetingLinkChanged
3078 = MeetingLocalChanged
3079 = MeetingRecordPubished
3080 = MeetingCanceled
3081 = MeetingInstructorAdded
3082 = MeetingInstructorRemoved
3083 = MeetingAgendaConflicted
3084 = MeetingUndoCancel
3328 = ActivityCreated
3329 = ActivityUpdated
3330 = ActivityDeleted
3331 = ActivityNameChanged
3332 = ActivityDescriptionChanged
3333 = ActivityDueDateChanged
3334 = ActivityCheckListItemAdded
3335 = ActivityCheckListItemRemoved
3584 = AssCreated
3585 = AssUpdated
3586 = AssDeleted
3587 = AssNameChanged
3588 = AssInstructionsChanged
3589 = AssBlockSelection
3590 = AssSendToRepository
3591 = AssRevisionOptionsChanged
3592 = AssExecutionOptionsChanged
3593 = AssPrivacyOptionsChanged
3594 = AssQuestionAdded
3595 = AssQuestionRemoved
3596 = AssOwnerAdded
3597 = AssOwnerRemoved
3598 = AssTopicAdded
3599 = AssTopicRemoved
3600 = AssTagAdded
3601 = AssTagRemoved
3840 = AssDeployCreated
3841 = AssDeployUpdated
3842 = AssDeployDeleted
3843 = AssDeployNameChanged
3844 = AssDeploySurveySelected
3845 = AssDeployAudienceAdded
3846 = AssDeployAudienceRemoved
3847 = AssDeployStickerAdded
3848 = AssDeployStickerRemoved
4096 = AwardCreated
4097 = AwardUpdated
4098 = AwardDeleted
4099 = AwardValueChanged
4100 = AwardRuleChanged
4101 = AwardAudienceAdded
4102 = AwardAudienceRemoved
4355 = TopicChallengeSuspended
4356 = TopicChallengeAudienceAdded
4357 = TopicChallengeAudienceRemoved
4358 = TopicChallengeAdded
4359 = TopicChallengeRemoved
4360 = TopicChallengeSealProvenKnowledge
4361 = TopicChallengeQuestionAdded
4362 = TopicChallengeQuestionRemoved
4363 = TopicChallengeGroupAdded
4364 = TopicChallengeGroupRemoved
4608 = CarouseAdded
4609 = CarouseUpdated
4610 = CarouselDeleted
4611 = CarouselIndicatorAdded
4612 = CarouseIndicatorRemoved
4864 = SystemSettingsUpdated
4865 = SystemSettingsAuthenticationUpdated
4866 = SystemSettingsAuthSAMLUpdated
4867 = SystemSettingsAuthSSOUpdated
4868 = SystemSettingsUserUpdated
4869 = SystemSettingsRecommendationUpdated
4870 = SystemSettingsImageUpdated
4871 = SystemSettingsAccessAgreementUpdated
4872 = SystemSettingsTrainingAgreementUpdated
4873 = SystemSettingsImportUserUpdated
4874 = SystemSettingsImportUserExceptionAdded
4875 = SystemSettingsImportUserExceptionDeleted
4876 = SystemSettingsImportUserRemoteUpdated
4877 = SystemSettingsAzureAppUpdated
4878 = SystemSettingsOnlineMeeting
4879 = SystemSettingsImportUpdated
4880 = SystemSettingsPerformaUpdated
5120 = LmsSettingsUpdated
5121 = LmsSettingsReminderUpdated
5123 = LmsSettingsTrainingIndexUpdated
5125 = LmsSettingsChallengeUpdated
5126 = LmsSettingsAwardUpdated
5376 = KnowledgeSettingsUpdated
5377 = KnowledgeSettingsAwardUpdated
5378 = KnowledgeQuickFilterAdded
5379 = KnowledgeQuickFilterDeleted
5632 = UnitTypeCreated
5633 = UnitTypeUpdated
5634 = UnitTypeDeleted
5888 = StickerCreated
5889 = StickerUpdated
5890 = StickerDeleted
6144 = RankingCreated
6145 = RankingUpdated
6146 = RankingDeleted
6400 = TagCreated
6401 = TagUpdated
6402 = TagDeleted
6403 = TagJoined
6656 = MailTemplateCreated
6657 = MailTemplateUpdated
6659 = CustomFieldCreated
6660 = CustomFieldUpdated
6661 = CustomFieldDeleted
6912 = AccessTimeRuleCreated
6913 = AccessTimeRuleUpdated
6914 = AccessTimeRuleDeleted
7168 = ShortVideoCreated
7169 = ShortVideoUpdated
7170 = ShortVideoDeleted
7424 = QuestionBankCreated
7425 = QuestionBankUpdated
7426 = QuestionBankDeleted
7680 = QuestionCreated
7681 = QuestionUpdated
7682 = QuestionDeleted
7683 = QuestionBlocked
7684 = QuestionAllowInKnowledgeTests
7936 = DevPlanCreated
7937 = DevPlanUpdated
7938 = DevPlanDeleted
7939 = DevPlanGroupAdded
7940 = DevPlanGroupRemoved
7941 = DevPlanActivityAdded
7942 = DevPlanActivityRemoved
7943 = DevPlanCompletionDeadlineChanged
7944 = DevPlanActivityCompletionDeadlineChanged
7945 = DevPlanArchived
7946 = DevPlanUnarchived
7947 = DevPlanPublished
7948 = DevPlanApproved
* @format int32
*/
export enum AuditLogEventId {
  UserCreated = 256,
  UserUpdated = 257,
  UserDeleted = 258,
  UserDisplayNameChanged = 259,
  UserEmailNameChanged = 260,
  UserManagerChanged = 261,
  UserApproverChanged = 262,
  UserExternal = 263,
  UserBlocked = 264,
  UserUnblocked = 265,
  UserInactivated = 266,
  UserReactivated = 267,
  UserPasswordChanged = 268,
  UserPersonalDataChanged = 269,
  UserCustomFieldChanged = 270,
  UserUnitAdded = 271,
  UserUnitRemoved = 272,
  UserSecondaryManagerAdded = 273,
  UserSecondaryManagerRemoved = 274,
  UserRoleAdded = 275,
  UserRoleRemoved = 276,
  UserTagAdded = 277,
  UserTagRemoved = 278,
  UserFileAdded = 279,
  UserFileRemoved = 280,
  UserPersonalInterestAdded = 281,
  UserPersonalInterestRemoved = 282,
  UserCredentialAdded = 283,
  UserCredentialChanged = 284,
  UserCredentialRemoved = 285,
  UserLanguageAdded = 286,
  UserLanguageChanged = 287,
  UserLanguageRemoved = 288,
  UserNameChanged = 289,
  UserPreferredLanguageChanged = 290,
  UserWorkplaceChanged = 291,
  UserAccessExpirationChanged = 292,
  UserThumbnailChanged = 293,
  UserRoleDesactivate = 294,
  UserRoleReactivate = 295,
  UserCorporateInfoChanged = 296,
  UserLogin = 297,
  UserLogout = 298,
  UserTrainingExempt = 299,
  UserTrainingExemptRevoke = 300,
  UserSpyLoginAuthorized = 317,
  UserSpyLogin = 318,
  UserSpyLogout = 319,
  UserAccountLocked = 320,
  UserAccountUnlocked = 321,
  UserApproved = 322,
  UserRejected = 323,
  UserAccountConfirmed = 324,
  UserMessageToApprover = 325,
  GroupCreated = 512,
  GroupUpdated = 513,
  GroupDeleted = 514,
  GroupMemberAdded = 515,
  GroupMemberRemoved = 516,
  GroupRulesChanged = 517,
  GroupReproccessed = 518,
  GroupSuspendeUpdates = 519,
  GroupTagAdded = 520,
  GroupTagRemoved = 521,
  RoleCreated = 768,
  RoleUpdated = 769,
  RoleDeleted = 770,
  RolePermissiedAdded = 771,
  RolePermissiedRemoved = 772,
  RoleRestrictionsChanged = 773,
  UnitCreated = 1024,
  UnitUpdated = 1025,
  UnitDeleted = 1026,
  UnitTagAdded = 1027,
  UnitTagRemoved = 1028,
  UnitCustomFieldChanged = 1029,
  TopicCreated = 1280,
  TopicUpdated = 1281,
  TopicDeleted = 1282,
  TopicDynamicGroupAdded = 1283,
  TopicDynamicGroupRemoved = 1284,
  TopicUserAdded = 1285,
  TopicUserRemoved = 1286,
  TopicSpecialistAdded = 1287,
  TopicSpecialistRemoved = 1288,
  TopicTagAdded = 1289,
  TopicTagRemoved = 1290,
  BannerCreated = 1536,
  BannerUpdated = 1537,
  BannerDeleted = 1538,
  BannerImageAdded = 1539,
  BannerAudienceAdded = 1540,
  BannerAudienceRemoved = 1541,
  ChannelCreated = 1792,
  ChannelUpdated = 1793,
  ChannelDeleted = 1794,
  ChannelMemberAdded = 1795,
  ChannelMemberRemoved = 1796,
  ChannelMemberPermissionChanged = 1797,
  ChannelRequestAccess = 1798,
  ChannelCustomQuickFilterAdded = 1799,
  ChannelCustomQuickFilterDeleted = 1800,
  ChannelJoin = 1893,
  PublicationCreated = 2048,
  PublicationUpdated = 2049,
  PublicationDeleted = 2050,
  PublicationTitleChanged = 2051,
  PublicationContentChanged = 2052,
  PublicationDraft = 2053,
  PublicationPublished = 2054,
  PublicationTrashRecover = 2055,
  PublicationSentTrash = 2056,
  PublicationShortPromote = 2057,
  PublicationSendToIAModeration = 2058,
  PublicationSendToModerator = 2059,
  PublicationSendToEncode = 2060,
  PublicationEncoded = 2061,
  PublicationApprovedByIA = 2062,
  PublicationSuspiciusByIA = 2063,
  PublicationApproved = 2064,
  PublicationRejected = 2065,
  PublicationBlocked = 2066,
  PublicationUnblockRequested = 2067,
  PublicationSetThumbnail = 2068,
  PublicationFileAdded = 2069,
  PublicationFileRemoved = 2070,
  PublicationErrorOrAbuseReported = 2071,
  PublicationErrorOrAbuseAnalysed = 2072,
  PublicationSetAccessRestriction = 2073,
  PublicationSetInstitutional = 2074,
  PublicationSetAnonymous = 2075,
  PublicationSetPublic = 2076,
  PublicationChannelChanged = 2077,
  PublicationTopicAdded = 2078,
  PublicationTopicRemoved = 2079,
  PublicationStickerAdded = 2080,
  PublicationStickerRemoved = 2081,
  PublicationListItemAdded = 2082,
  PublicationListItemRemoved = 2083,
  PublicationContentRelationAdded = 2084,
  PublicationContentRelationRemoved = 2085,
  PublicationSendToCoginitiveAnalysis = 2086,
  PublicationCoginitiveAnalysisPassed = 2087,
  PublicationCoginitiveAnalysisRefused = 2088,
  PublicationApprovedBySystem = 2089,
  PublicationApprovedByAuthor = 2090,
  PublicationEditJustification = 2091,
  PublicationNameEntities = 2092,
  PublicationKeyWords = 2093,
  TrainingCreated = 2304,
  TrainingUpdated = 2305,
  TrainingDeleted = 2306,
  TrainingNameChanged = 2307,
  TrainingDescriptionChanged = 2308,
  TrainingObjectiveChanged = 2309,
  TrainingMultipleClassrooms = 2310,
  TrainingActivate = 2311,
  TrainingGamified = 2312,
  TrainingCredits = 2313,
  TrainingOwnerAdded = 2314,
  TrainingOwnerRemoved = 2315,
  TrainingCoordinatorAdded = 2316,
  TrainingCoordinatorRemoved = 2317,
  TrainingInstructorAdded = 2318,
  TrainingInstructorRemoved = 2319,
  TrainingSpecialistAdded = 2320,
  TrainingSpecialistRemoved = 2321,
  TrainingEquivalenceAdded = 2322,
  TrainingEquivalenceRemoved = 2323,
  TrainingRelationshipAdded = 2324,
  TrainingRelationshipRemoved = 2325,
  TrainingAudienceAdded = 2326,
  TrainingAudienceRemoved = 2327,
  TrainingAudienceBelongEveryone = 2328,
  TrainingCustomFieldChanged = 2329,
  TrainingTopicAdded = 2330,
  TrainingTopicRemoved = 2331,
  TrainingStickerAdded = 2332,
  TrainingStickerRemoved = 2333,
  TrainingTagAdded = 2335,
  TrainingTagRemoved = 2336,
  TrainingRulesChanged = 2337,
  TrainingCertificateChanged = 2338,
  TrainigGamificationPropsChanged = 2339,
  TrainingComponentAdded = 2340,
  TrainingComponentRemoved = 2341,
  TrainingComponentUpdated = 2342,
  TrainingComponentPropsChanged = 2343,
  TrainingMaterialListAdded = 2344,
  TrainingMaterialListRemoved = 2345,
  TrainingNewContentVersion = 2346,
  TrainingNewComponentVersion = 2347,
  TrainingSetReactionAssessment = 2348,
  TrainingSetUserEfficacyAssessment = 2349,
  TrainingSetManagerEfficacyAssessment = 2350,
  TrainingPresentationVideoChanged = 2351,
  TrainingScormPackageCreated = 2352,
  TrainingScormPackageUpdated = 2353,
  TrainingScormPackageRemoved = 2354,
  ClassroomCreated = 2560,
  ClassroomUpdated = 2561,
  ClassroomDeleted = 2562,
  ClassroomNameChanged = 2563,
  ClassroomActivate = 2564,
  ClassroomMaterialListAdded = 2565,
  ClassroomMaterialListRemoved = 2566,
  ClassroomMaterialListBlocked = 2567,
  ClassroomSetAssReaction = 2568,
  ClassroomSetAssUserEfficacy = 2569,
  ClassroomSetAssManagerEfficacy = 2570,
  ClassroomCertificateChanged = 2571,
  ClassroomRulesChanged = 2572,
  ClassroomOwnerAdded = 2573,
  ClassroomOwnerRemoved = 2574,
  ClassroomInstructorAdded = 2575,
  ClassroomInstructorRemoved = 2576,
  ClassroomAudienceAdded = 2577,
  ClassroomAudienceRemoved = 2578,
  ClassroomAudienceBelongsAll = 2579,
  ClassroomCustomFieldChanged = 2580,
  ClassroomMaterialListUnblocked = 2581,
  EnrollCreated = 2816,
  EnrollDeleted = 2818,
  EnrollFirstAccess = 2819,
  EnrollCanceled = 2820,
  EnrollApproved = 2821,
  EnrollReproved = 2822,
  EnrollCertificate = 2823,
  EnrollExpired = 2824,
  EnrollRevoked = 2825,
  EnrollUndoRevoke = 2826,
  EnrollReopened = 2827,
  EnrollSetEventPresence = 2828,
  EnrollSetEventScore = 2829,
  EnrollSetActivityScore = 2830,
  EnrollSetAssessmentyScore = 2831,
  EnrollAdditionalDays = 2832,
  EnrollAward = 2833,
  EnrollRequested = 2834,
  EnrollRequestApproved = 2835,
  EnrollConclusionFormRequested = 2836,
  EnrollConclusionRequestApproved = 2837,
  EnrollConclusionRequestReproved = 2838,
  EnrollConclusionRequestRejected = 2839,
  EnrollReservation = 2840,
  EnrollExempt = 2841,
  EnrollImported = 2848,
  MeetingCreated = 3072,
  MeetingUpdated = 3073,
  MeetingDeleted = 3074,
  MeetingNameChanged = 3075,
  MeetingTimeChanged = 3076,
  MeetingLinkChanged = 3077,
  MeetingLocalChanged = 3078,
  MeetingRecordPubished = 3079,
  MeetingCanceled = 3080,
  MeetingInstructorAdded = 3081,
  MeetingInstructorRemoved = 3082,
  MeetingAgendaConflicted = 3083,
  MeetingUndoCancel = 3084,
  ActivityCreated = 3328,
  ActivityUpdated = 3329,
  ActivityDeleted = 3330,
  ActivityNameChanged = 3331,
  ActivityDescriptionChanged = 3332,
  ActivityDueDateChanged = 3333,
  ActivityCheckListItemAdded = 3334,
  ActivityCheckListItemRemoved = 3335,
  AssCreated = 3584,
  AssUpdated = 3585,
  AssDeleted = 3586,
  AssNameChanged = 3587,
  AssInstructionsChanged = 3588,
  AssBlockSelection = 3589,
  AssSendToRepository = 3590,
  AssRevisionOptionsChanged = 3591,
  AssExecutionOptionsChanged = 3592,
  AssPrivacyOptionsChanged = 3593,
  AssQuestionAdded = 3594,
  AssQuestionRemoved = 3595,
  AssOwnerAdded = 3596,
  AssOwnerRemoved = 3597,
  AssTopicAdded = 3598,
  AssTopicRemoved = 3599,
  AssTagAdded = 3600,
  AssTagRemoved = 3601,
  AssDeployCreated = 3840,
  AssDeployUpdated = 3841,
  AssDeployDeleted = 3842,
  AssDeployNameChanged = 3843,
  AssDeploySurveySelected = 3844,
  AssDeployAudienceAdded = 3845,
  AssDeployAudienceRemoved = 3846,
  AssDeployStickerAdded = 3847,
  AssDeployStickerRemoved = 3848,
  AwardCreated = 4096,
  AwardUpdated = 4097,
  AwardDeleted = 4098,
  AwardValueChanged = 4099,
  AwardRuleChanged = 4100,
  AwardAudienceAdded = 4101,
  AwardAudienceRemoved = 4102,
  TopicChallengeSuspended = 4355,
  TopicChallengeAudienceAdded = 4356,
  TopicChallengeAudienceRemoved = 4357,
  TopicChallengeAdded = 4358,
  TopicChallengeRemoved = 4359,
  TopicChallengeSealProvenKnowledge = 4360,
  TopicChallengeQuestionAdded = 4361,
  TopicChallengeQuestionRemoved = 4362,
  TopicChallengeGroupAdded = 4363,
  TopicChallengeGroupRemoved = 4364,
  CarouseAdded = 4608,
  CarouseUpdated = 4609,
  CarouselDeleted = 4610,
  CarouselIndicatorAdded = 4611,
  CarouseIndicatorRemoved = 4612,
  SystemSettingsUpdated = 4864,
  SystemSettingsAuthenticationUpdated = 4865,
  SystemSettingsAuthSAMLUpdated = 4866,
  SystemSettingsAuthSSOUpdated = 4867,
  SystemSettingsUserUpdated = 4868,
  SystemSettingsRecommendationUpdated = 4869,
  SystemSettingsImageUpdated = 4870,
  SystemSettingsAccessAgreementUpdated = 4871,
  SystemSettingsTrainingAgreementUpdated = 4872,
  SystemSettingsImportUserUpdated = 4873,
  SystemSettingsImportUserExceptionAdded = 4874,
  SystemSettingsImportUserExceptionDeleted = 4875,
  SystemSettingsImportUserRemoteUpdated = 4876,
  SystemSettingsAzureAppUpdated = 4877,
  SystemSettingsOnlineMeeting = 4878,
  SystemSettingsImportUpdated = 4879,
  SystemSettingsPerformaUpdated = 4880,
  LmsSettingsUpdated = 5120,
  LmsSettingsReminderUpdated = 5121,
  LmsSettingsTrainingIndexUpdated = 5123,
  LmsSettingsChallengeUpdated = 5125,
  LmsSettingsAwardUpdated = 5126,
  KnowledgeSettingsUpdated = 5376,
  KnowledgeSettingsAwardUpdated = 5377,
  KnowledgeQuickFilterAdded = 5378,
  KnowledgeQuickFilterDeleted = 5379,
  UnitTypeCreated = 5632,
  UnitTypeUpdated = 5633,
  UnitTypeDeleted = 5634,
  StickerCreated = 5888,
  StickerUpdated = 5889,
  StickerDeleted = 5890,
  RankingCreated = 6144,
  RankingUpdated = 6145,
  RankingDeleted = 6146,
  TagCreated = 6400,
  TagUpdated = 6401,
  TagDeleted = 6402,
  TagJoined = 6403,
  MailTemplateCreated = 6656,
  MailTemplateUpdated = 6657,
  CustomFieldCreated = 6659,
  CustomFieldUpdated = 6660,
  CustomFieldDeleted = 6661,
  AccessTimeRuleCreated = 6912,
  AccessTimeRuleUpdated = 6913,
  AccessTimeRuleDeleted = 6914,
  ShortVideoCreated = 7168,
  ShortVideoUpdated = 7169,
  ShortVideoDeleted = 7170,
  QuestionBankCreated = 7424,
  QuestionBankUpdated = 7425,
  QuestionBankDeleted = 7426,
  QuestionCreated = 7680,
  QuestionUpdated = 7681,
  QuestionDeleted = 7682,
  QuestionBlocked = 7683,
  QuestionAllowInKnowledgeTests = 7684,
  DevPlanCreated = 7936,
  DevPlanUpdated = 7937,
  DevPlanDeleted = 7938,
  DevPlanGroupAdded = 7939,
  DevPlanGroupRemoved = 7940,
  DevPlanActivityAdded = 7941,
  DevPlanActivityRemoved = 7942,
  DevPlanCompletionDeadlineChanged = 7943,
  DevPlanActivityCompletionDeadlineChanged = 7944,
  DevPlanArchived = 7945,
  DevPlanUnarchived = 7946,
  DevPlanPublished = 7947,
  DevPlanApproved = 7948,
}

/**
* 0 = Unknown
1 = User
2 = Group
3 = SecurityRole
4 = Unit
5 = UnitType
6 = Topic
7 = Challenge
8 = Sticker
9 = Ranking
10 = Tag
11 = MailTemplate
12 = CustomField
13 = AccessTimeRule
14 = Banner
15 = Carousel
16 = SystemSettings
17 = SystemSettingsAuth
18 = SystemSettingsAuthSSO
19 = SystemSettingsAuthSAML
20 = SystemSettingsRecommendation
21 = SystemSettingsImage
22 = SystemSettingsUser
23 = SystemSettingsImport
24 = SystemSettingsImportUser
25 = SystemSettingsImportUserRemote
26 = SystemSettingsPerforma
27 = SystemSettingsAccessAgreement
28 = SystemSettingsTrainingAgreement
29 = SystemSettingAzureApp
30 = SystemSettingsOnlineMeeting
31 = Channel
32 = Publication
33 = KnowledgeSetting
34 = KnowledgeAwardChannel
35 = KnowledgeQuickFilter
36 = KnowledgeShortVideo
37 = Training
38 = Classroom
39 = Enrollment
40 = Meeting
41 = Activity
42 = LmsSetting
43 = LmsSettingAward
44 = LmsSettingChallenge
45 = LmsSettingDefault
46 = LmsSettingReminder
47 = LmsSettingTrainingIndex
48 = Award
49 = Assessment
50 = AssDeploy
51 = QuestionBank
52 = Question
53 = DevPlan
* @format int32
*/
export enum AuditLogEntityType {
  Unknown = 0,
  User = 1,
  Group = 2,
  SecurityRole = 3,
  Unit = 4,
  UnitType = 5,
  Topic = 6,
  Challenge = 7,
  Sticker = 8,
  Ranking = 9,
  Tag = 10,
  MailTemplate = 11,
  CustomField = 12,
  AccessTimeRule = 13,
  Banner = 14,
  Carousel = 15,
  SystemSettings = 16,
  SystemSettingsAuth = 17,
  SystemSettingsAuthSSO = 18,
  SystemSettingsAuthSAML = 19,
  SystemSettingsRecommendation = 20,
  SystemSettingsImage = 21,
  SystemSettingsUser = 22,
  SystemSettingsImport = 23,
  SystemSettingsImportUser = 24,
  SystemSettingsImportUserRemote = 25,
  SystemSettingsPerforma = 26,
  SystemSettingsAccessAgreement = 27,
  SystemSettingsTrainingAgreement = 28,
  SystemSettingAzureApp = 29,
  SystemSettingsOnlineMeeting = 30,
  Channel = 31,
  Publication = 32,
  KnowledgeSetting = 33,
  KnowledgeAwardChannel = 34,
  KnowledgeQuickFilter = 35,
  KnowledgeShortVideo = 36,
  Training = 37,
  Classroom = 38,
  Enrollment = 39,
  Meeting = 40,
  Activity = 41,
  LmsSetting = 42,
  LmsSettingAward = 43,
  LmsSettingChallenge = 44,
  LmsSettingDefault = 45,
  LmsSettingReminder = 46,
  LmsSettingTrainingIndex = 47,
  Award = 48,
  Assessment = 49,
  AssDeploy = 50,
  QuestionBank = 51,
  Question = 52,
  DevPlan = 53,
}

/**
* 1 = Training
2 = Classroom
* @format int32
*/
export enum AudienceTargetType {
  Training = 1,
  Classroom = 2,
}

/**
* 1 = ContainsAudience
2 = NotContainsAudience
3 = ContainsRequiredAudience
4 = ContainsNotRequiredAudience
* @format int32
*/
export enum AudienceFilterOptions {
  ContainsAudience = 1,
  NotContainsAudience = 2,
  ContainsRequiredAudience = 3,
  ContainsNotRequiredAudience = 4,
}

/**
* 0 = Evaluation
1 = Survey
2 = TopicChallenge
* @format int32
*/
export enum AssessmentType {
  Evaluation = 0,
  Survey = 1,
  TopicChallenge = 2,
}

/**
* 1 = NewInstance
2 = Resume
3 = Update
4 = UserReview
5 = NoAccess
6 = FinalResult
* @format int32
*/
export enum AssessmentPlayerMode {
  NewInstance = 1,
  Resume = 2,
  Update = 3,
  UserReview = 4,
  NoAccess = 5,
  FinalResult = 6,
}

/**
* 0 = Evaluation
1 = Survey
2 = Challenge
* @format int32
*/
export enum AssessmentMode {
  Evaluation = 0,
  Survey = 1,
  Challenge = 2,
}

/**
* 1 = Question
2 = RuleAllQuestion
3 = RuleRaffleQuestion
* @format int32
*/
export enum AssessmentItemType {
  Question = 1,
  RuleAllQuestion = 2,
  RuleRaffleQuestion = 3,
}

/**
* 1 = Correct
2 = Wrong
* @format int32
*/
export enum AssCorrectionResult {
  Correct = 1,
  Wrong = 2,
}

/**
* 0 = ASC
1 = DESC
* @format int32
*/
export enum AssAnalysisDetailsOrderBy {
  ASC = 0,
  DESC = 1,
}

/**
* 1 = SystemAccess
2 = TrainingAccess
* @format int32
*/
export enum AgreementType {
  SystemAccess = 1,
  TrainingAccess = 2,
}

/**
* 0 = Name
1 = ModifiedDate
* @format int32
*/
export enum AdminGroupListOrderByQuery {
  Name = 0,
  ModifiedDate = 1,
}

/**
* 0 = Current
1 = Next
2 = Previous
* @format int32
*/
export enum ActionPlayerSelectQuestion {
  Current = 0,
  Next = 1,
  Previous = 2,
}

/**
* 0 = Valid
1 = NotFound
2 = NonValidUser
3 = Inactive
4 = AccountExpired
5 = WrongPassword
6 = PasswordExpired
7 = DuplicateKey
8 = NotConfirmed
9 = AuthFieldDisabled
10 = Lockedout
11 = PasswordAttemptWindow
12 = ResetWindowExpired
13 = AccessTimeRestriction
14 = WaitingApproval
20 = NotAgreement
21 = AgreementUpdated
30 = TokenExpired
31 = SecurityStampExpired
32 = SecurityStampNotFound
33 = Disabled
40 = BadSamlUser
41 = BadSamlClaims
99 = Failed
100 = NoAccount
101 = CannotCreateOrUpdateUser
102 = MontlyUserLimitsExceeded
* @format int32
*/
export enum AccountLoginCheckResult {
  Valid = 0,
  NotFound = 1,
  NonValidUser = 2,
  Inactive = 3,
  AccountExpired = 4,
  WrongPassword = 5,
  PasswordExpired = 6,
  DuplicateKey = 7,
  NotConfirmed = 8,
  AuthFieldDisabled = 9,
  Lockedout = 10,
  PasswordAttemptWindow = 11,
  ResetWindowExpired = 12,
  AccessTimeRestriction = 13,
  WaitingApproval = 14,
  NotAgreement = 20,
  AgreementUpdated = 21,
  TokenExpired = 30,
  SecurityStampExpired = 31,
  SecurityStampNotFound = 32,
  Disabled = 33,
  BadSamlUser = 40,
  BadSamlClaims = 41,
  Failed = 99,
  NoAccount = 100,
  CannotCreateOrUpdateUser = 101,
  MontlyUserLimitsExceeded = 102,
}

/**
* 1 = Standard
2 = Saml
3 = Token
4 = ApiKey
* @format int32
*/
export enum AccountAccessType {
  Standard = 1,
  Saml = 2,
  Token = 3,
  ApiKey = 4,
}

/**
* 1 = Authentication
2 = RequiredTraining
* @format int32
*/
export enum AccessTimeConstraintType {
  Authentication = 1,
  RequiredTraining = 2,
}

/**
* 0 = None
1 = Global
2 = Units
4 = Groups
8 = SelfUser
16 = SelfUserUnitType
32 = SelfUserSubordinates
64 = SelfUserOwnedObjects
128 = SelfUserConnectedUsers
-1 = All
* @format int32
*/
export enum AcceptedConstraints {
  None = 0,
  Global = 1,
  Units = 2,
  Groups = 4,
  SelfUser = 8,
  SelfUserUnitType = 16,
  SelfUserSubordinates = 32,
  SelfUserOwnedObjects = 64,
  SelfUserConnectedUsers = 128,
  All = -1,
}

export interface AboutInfoDto {
  version: string;
  copyright: string;
  product: string;
  company: string;
  buildDate: string;
  hash: string;
}

export type AboutInfoDtoIEquatable = object;

export interface AbsenceTypeSelectorQuery {
  appliesToUserStatus: UserStatus | null;
}

export interface AbsenceTypeSelectorResponse {
  /** @format uuid */
  absenceTypeId: string;
  name: string;
}

export type AbsenceTypeSelectorResponseIEquatable = object;

export type AbsenceTypeSelectorResponseListIRequest = object;

export interface AcceptChannelSubscriptionCommand {
  /** @format uuid */
  channelId: string;
  /** @format uuid */
  userId: string;
  message: string | null;
}

export interface AccessTimeAffectedUsersQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  accessTimeRuleId: string;
  searchText: string | null;
}

export interface AccessTimeRuleItem {
  /** @format uuid */
  accessTimeRuleId: string;
  name: string;
}

export type AccessTimeRuleItemIEquatable = object;

export interface AccessTimeRuleItemPaginatedList {
  items: AccessTimeRuleItem[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export interface AccessTimeRuleModel {
  isActive: boolean;
}

export interface AccountLoginDto {
  accessType: AccountAccessType;
  /** @format uuid */
  accountId: string;
  /** @format uuid */
  userId: string;
  name: string;
  displayName: string;
  culture: string;
  email: string | null;
  thumbnailUrl: string | null;
  userType: UserType;
  keepConnected: boolean;
  signedAggrement: boolean;
  continueAuthStamp: string | null;
  permissions: string[];
  samlPrincipalName: string | null;
}

export type AccountLoginDtoIEquatable = object;

export interface ActivityCheckListItem {
  /** @format uuid */
  itemId: string;
  name: string;
  /** @format double */
  score: number;
}

export interface ActivityComponentDto {
  /** @format date-time */
  dueDate: Date | null;
  /** @format uuid */
  publicationId: string | null;
  digitalDelivery: boolean;
  /** @format date-time */
  deliveryDate: Date | null;
  scorePending: boolean | null;
  /** @format double */
  scorePercent: number | null;
  /** @format date-time */
  correctedOn: Date | null;
  timezoneId: string;
  isCancelled: boolean;
  /** @format int32 */
  daysLeft: number | null;
  showDaysLeft: boolean;
  expired: boolean;
}

export type ActivityComponentDtoIEquatable = object;

export interface ActivityEnrollmentItemQuery {
  /** @format uuid */
  componentId: string;
  /** @format uuid */
  enrollmentId: string | null;
  /** @format uuid */
  classroomId: string | null;
}

export interface ActivityItemQuery {
  /** @format uuid */
  componentId: string;
}

export interface ActivityQuery {
  /** @format uuid */
  publicationId: string;
  createClone: boolean;
}

export interface AdHocSurveyDeclineCommand {
  /** @format uuid */
  deployId: string;
}

export interface AddAbuseReportPublicationCommand {
  /** @format uuid */
  publicationId: string;
  /** @format uuid */
  commentId: string | null;
  actionType: PublicationActionType;
  message: string | null;
}

export interface AddAllUserEnrollOperationCommand {
  /** @format uuid */
  trainingId: string;
  /** @format uuid */
  classroomId: string | null;
  operation: ManageEnrollOperation;
  useImportedUsers: boolean;
  searchText: string | null;
  filter: AdvCoreFilter[];
}

export interface AddAllUsersOperationCommand {
  operation: UserOperationType;
  action: UserOperationAction | null;
  /** @format uuid */
  objectId: string | null;
  useImportedUsers: boolean;
  searchText: string | null;
  filter: AdvCoreFilter[];
}

export interface AddAssessmentComponentCommand {
  /** @format uuid */
  trainingId: string;
  /** @format int32 */
  versionNumber: number;
  /** @format uuid */
  assessmentId: string;
  addFinalScore: boolean;
}

export interface AddAssessmentExclusiveTrainingCommand {
  /** @format uuid */
  trainingId: string;
  /** @format int32 */
  versionNumber: number;
  /** @format uuid */
  assessmentId: string;
  addFinalScore: boolean;
}

export interface AddChannelToPromoteSettingsCommand {
  /** @format uuid */
  channelId: string;
}

export interface AddComponentAccessCommand {
  /** @format uuid */
  enrollmentId: string;
  /** @format uuid */
  componentId: string;
}

export interface AddEnrollmentExtraTimeCommand {
  enrollmentIds: string[];
  /** @format int32 */
  extraDays: number;
}

export interface AddListItemCommand {
  /** @format uuid */
  listPublicationId: string;
  /** @format uuid */
  itemPublicationId: string;
}

export interface AddMaterialListItemCommand {
  /** @format uuid */
  materialListId: string;
  /** @format uuid */
  publicationId: string;
}

export interface AddMemberStaticGroupCommand {
  /** @format uuid */
  groupId: string;
  members: RegisterMemberGroupRequest[];
}

export interface AddMembersChannelCommand {
  /** @format uuid */
  channelId: string;
  memberType: MemberType;
  members: string[];
  role: ChannelRoles;
}

export interface AddOrRemoveLikeCommand {
  /** @format uuid */
  publicationId: string;
}

export interface AddOrUpdateReportGroupCommand {
  /** @format uuid */
  reportGroupId: string;
  nameR: ResourceModel[];
}

export type AddOrUpdateReportGroupCommandIEquatable = object;

export interface AddPollAnswerCommand {
  /** @format uuid */
  publicationId: string;
  /** @format uuid */
  answerId: string;
}

export interface AddRatingEnrollmentCommand {
  /** @format uuid */
  enrollmentId: string;
  /** @format int32 */
  ratingStars: number;
  ratingComment: string | null;
}

export interface AddRecommendationPublicationCommand {
  /** @format uuid */
  publicationId: string;
  memberType: MemberType;
  memberIds: string[];
  comments: string | null;
}

export interface AddRelationshipPublicationCommand {
  /** @format uuid */
  publicationId: string;
  /** @format uuid */
  relatedPublicationId: string;
}

export interface AddRelationshipTrainingCommand {
  /** @format uuid */
  publicationId: string;
  /** @format uuid */
  relatedTrainingId: string;
}

export interface AddRuleAllAssCommand {
  /** @format uuid */
  assessmentId: string;
  /** @format uuid */
  questionGroupId: string;
}

export interface AddRuleRaffleAssCommand {
  /** @format uuid */
  assessmentId: string;
  /** @format uuid */
  questionGroupId: string;
  /** @format int32 */
  numberOfQuestion: number;
  tags: string[];
}

export interface AddToListFavoritesCommand {
  /** @format uuid */
  publicationId: string;
}

export interface AddToListSeeLaterCommand {
  /** @format uuid */
  publicationId: string;
}

export interface AddTopicChallengeCommand {
  /** @format uuid */
  topicId: string;
}

export type AddTopicChallengeCommandIEquatable = object;

export interface AddTopicToPromoteSettingsCommand {
  /** @format uuid */
  topicId: string;
}

export interface AddTrainingInterestCommand {
  /** @format uuid */
  trainingId: string;
}

export interface AddTrainingRecommendationCommand {
  /** @format uuid */
  trainingId: string;
  memberType: MemberType;
  memberIds: string[];
  comments: string | null;
}

export interface AddUserEnrollOperationCommand {
  /** @format uuid */
  trainingId: string;
  operation: ManageEnrollOperation;
  userIds: string[];
}

export interface AddUserOperationCommand {
  operation: UserOperationType;
  userIds: string[];
}

export interface AddressModel {
  address1: string;
  address2: string | null;
  city: string;
  state: string;
  zipCode: string;
}

export type AddressModelIEquatable = object;

export interface AdvCoreFilter {
  command:
    | "UserIncludeBlockedUsers"
    | "UserTags"
    | "UserUnits"
    | "UserGroups"
    | "UserWorkplaces"
    | "UserWorkplaceText"
    | "UserCustomField"
    | "UserIncludeInactive"
    | "UserIncludeDeleted"
    | "UserIsManager"
    | "UserManagerDirectSubordinates"
    | "UserManagerAllSubordinates"
    | "UserSpecific"
    | "UserInternal"
    | "UserExternal"
    | "UserTopicOptional"
    | "UserTopicRequired"
    | "UserChannelMembers"
    | "UserTrainingAttending"
    | "UserTrainingApproved"
    | "UserTrainingReproved"
    | "UserInterestTag"
    | "UserBlockReason"
    | "UserAndDirectSubordinates"
    | "UserAndAllSubordinates"
    | "UserHasSealProvenKnowledgeTopic"
    | "UserIsSpecialistInTopic"
    | "UserLastAccessBeforeOf"
    | "UserLastAccessAfterOf"
    | "UserPermission"
    | "UserRoles"
    | "UserSuspendedAccounts"
    | "UserHasNotActiveDevPlan"
    | "UserHasActiveDevPlan"
    | "UserHasDraftDevPlan"
    | "UserHasDelayedDevPlan"
    | "UserHasPendingApprovalDevPlan"
    | "UserOnlyBlocked"
    | "UserOnlyInactive"
    | "UsersOnlyDeleted"
    | "UserIsExternal"
    | "UserTrainingAudience"
    | "UserTrainingMandatoryAudience"
    | "UserOnlyUnblocked"
    | "TrainingTopic"
    | "TrainingSticker"
    | "TrainingPublishPeriod"
    | "TrainingWorkload"
    | "TrainingBestRated"
    | "TrainingWithAvailableClassrooms"
    | "TrainingStartNow"
    | "TrainingInLearnPath"
    | "TrainingCoordinator"
    | "TrainingSpecific"
    | "TrainingTypeCourseWeb"
    | "TrainingTypeLive"
    | "TrainingTypeExternalCourse"
    | "TrainingTypeAssessment"
    | "TrainingTypeActivity"
    | "TrainingTypeLearnPath"
    | "TrainingTypeGame"
    | "TrainingRequiredAudienceContain"
    | "TrainingOptionalAudienceContain"
    | "TrainingContentType"
    | "TrainingCustomField"
    | "TrainingLanguage"
    | "TrainingInstructor"
    | "TrainingNeverEnroll"
    | "TrainingTag"
    | "TrainingCurrentUserMandatory"
    | "TrainingCurrentUserOptional"
    | "TrainingCurrentUserAssigned"
    | "TrainingCurrentUserRegisterTeamMembers"
    | "TrainingCurrentUserTopicInterest"
    | "TrainingNameContain"
    | "TrainingAuthorContain"
    | "TrainingExternalCodeContain"
    | "TrainingWithUsersInProgress"
    | "TrainingWithClasses"
    | "TrainingWithUsersInterest"
    | "TrainingCreatedOn"
    | "TrainingModifiedOn"
    | "TrainingIsBuilding"
    | "TrainingCreatedByYou"
    | "TrainingCreatedByUser"
    | "TrainingWithMeeting"
    | "TrainingNameOrExternalCodeContain"
    | "TrainingWithRenovationWindowEnrolls"
    | "TrainingWithInvalidatedEnrolls"
    | "TrainingWithHideConcludedEnrolls"
    | "TrainingValidateExpiringOrExpired"
    | "TrainingValidateExpired"
    | "TrainingAvailableOnApp"
    | "ClassroomWithActiveUsers"
    | "ClassroomExecutionPeriod"
    | "ClassroomNameContain"
    | "ClassroomExternalCodeContain"
    | "ClassroomUsersInProgress"
    | "ClassroomWithOpenEnrollment"
    | "ClassroomWithAudience"
    | "ClassroomExpired"
    | "ClassroomInstructor"
    | "ClassroomCreatedOn"
    | "ClassroomModifiedOn"
    | "ClassroomCreatedByYou"
    | "ClassroomCreatedByUser"
    | "EnrollPeriodEnrolled"
    | "EnrollPeriodConclusion"
    | "EnrollPeriodFirstAccess"
    | "EnrollPeriodLastAccess"
    | "EnrollPeriodHistoric"
    | "EnrollStartedMoreThanDays"
    | "EnrollInProgress"
    | "EnrollNotStart"
    | "EnrollDelayed"
    | "EnrollFinalized"
    | "EnrollApproved"
    | "EnrollReproved"
    | "EnrollInRenovationWindow"
    | "EnrollInvalidated"
    | "EnrollRejected"
    | "EnrollMandatoryAudience"
    | "EnrollOptionalAudience"
    | "EnrollOutOfAudience"
    | "EnrollDoesCertificationExpire"
    | "EnrollCertificationExpiringIn30Days"
    | "EnrollCertificationExpiringIn60Days"
    | "EnrollBlockedUsersOnly"
    | "EnrollExcludeInactiveUser"
    | "EnrollSpecificClassroom"
    | "EnrollTrainingMandatory"
    | "EnrollCanceledOrRevoked"
    | "EnrollHideInvalidated"
    | "EnrollHideConcluded"
    | "EnrollContainsStatus"
    | "EnrollRegistrationMode"
    | "EnrollUsername"
    | "BannerWithAudience"
    | "BannerNotAudience"
    | "BannerForUser"
    | "KnowledgeQuickFilter"
    | "KnowledgeChannel"
    | "KnowledgeTopic"
    | "KnowledgeAuthor"
    | "KnowledgeSticker"
    | "KnowledgeTopicsYourInterest"
    | "KnowledgeChannelsYouAreSubscribed"
    | "KnowledgeInstitutional"
    | "KnowledgeNonInstitutional"
    | "KnowledgePublishedByYou"
    | "KnowledgeUserFollowingAuthor"
    | "KnowledgeContainVideo"
    | "KnowledgeContainAudio"
    | "KnowledgeContainImage"
    | "KnowledgeContainLink"
    | "KnowledgeContainDocument"
    | "KnowledgeContainMention"
    | "KnowledgeContainShorts"
    | "KnowledgeTitleContains"
    | "KnowledgePeriod"
    | "KnowledgeCreatedOn"
    | "KnowledgeModifiedOn"
    | "KnowledgeExpired"
    | "KnowledgeAvailableInTheFuture"
    | "KnowledgeLiked"
    | "KnowledgeLikedCoworks"
    | "KnowledgeRecommended"
    | "KnowledgeTrending"
    | "KnowledgeMentioningYou"
    | "KnowledgeRestrictedAccess"
    | "KnowledgeContent"
    | "KnowledgeModifiedByManagerOrSupervisor"
    | "KnowledgeBlocked"
    | "KnowledgeViewsCount"
    | "KnowledgeLikesCount"
    | "KnowledgeCommentsCount"
    | "KnowledgeSeenByYou"
    | "KnowledgeNotSeenByYou"
    | "KnowledgeMentioning"
    | "KnowledgeMentioningUser"
    | "KnowledgeMentioningTopic"
    | "KnowledgeMentioningChannel"
    | "KnowledgeMentioningPublication"
    | "KnowledgePost"
    | "KnowledgeQuestion"
    | "KnowledgeList"
    | "KnowledgePoll"
    | "KnowledgeModerationPending"
    | "KnowledgeIsRejected"
    | "KnowledgeAvailableOnly"
    | "KnowledgeNonVisiblePubs"
    | "KnowledgeContainsPresentation"
    | "KnowledgeBinder"
    | "KnowledgePublicationTag"
    | "SurveyTypeAdHoc"
    | "SurveyTypeEfficacy"
    | "SurveyTypeReaction"
    | "SurveyPeriod"
    | "SurveySticker"
    | "SurveyStatusAnswered"
    | "SurveyStatusNotAnswered"
    | "ChannelCreatedBySelf"
    | "ChannelOwner"
    | "ChannelOwnerGroup"
    | "ChannelOwnerUnit"
    | "ChannelPublic"
    | "ChannelPrivate"
    | "EnrollOperationAudienceOption"
    | "EnrollOperationClassroom"
    | "EnrollOperationStatusEnrollment"
    | "EnrollOperationEnrollmentHistory"
    | "EnrollOperationAudienceMandatoryToEnrollOption"
    | "DashboardUserMandatoryAudience"
    | "AssessmentTopic"
    | "AssessmentLanguage"
    | "AssessmentTag"
    | "AssessmentNameContain"
    | "AssessmentAuthorContain"
    | "AssessmentCodeContain"
    | "AssessmentCreatedOn"
    | "AssessmentModifiedOn"
    | "AssessmentIsBuilding"
    | "AssessmentCreatedByYou"
    | "AssessmentCreatedByUser"
    | "AssessmentModifiedByUser"
    | "GroupContainsMember"
    | "GroupTags"
    | "GroupUsage"
    | "GroupUnit"
    | "GroupActiveAndInactive"
    | "GroupInactiveOnly"
    | "GroupSuspendedOnly"
    | "UnitUser"
    | "UnitTag"
    | "UnitCustomField"
    | "TopicSubTopic"
    | "TopicTags"
    | "TopicKnowledge"
    | "TopicSkill"
    | "TopicCompetency"
    | "TopicBundler"
    | "TopicWithPublications"
    | "TopicWithChallenge"
    | "TopicWithTraining"
    | "TopicWithSpecialist"
    | "TopicWithoutPublications"
    | "TopicWithoutChallenge"
    | "TopicWithoutTraining"
    | "TopicWithoutSpecialist"
    | "TopicActiveAndInactive"
    | "TopicInactiveOnly"
    | "TopicUserRequiredLink"
    | "TopicUserOptionalLink"
    | "TopicUserWithEndorsement"
    | "TopicUserWithProvenKnowledge"
    | "TopicUserIsVerifiedKnower"
    | "TopicUserIsSpecialist"
    | "RoleContainPermision"
    | "RoleAssignedUser"
    | "SchedulerRunning"
    | "SchedulerNeverRun"
    | "SchedulerSuccess"
    | "SchedulerFailed"
    | "SchedulerEnabledOnly"
    | "SchedulerDisabledOnly"
    | "SchedulerQueueObjectType"
    | "SchedulerMessagingFromDate"
    | "SchedulerMessagingPushOnly"
    | "SchedulerMessagingSmtpOnly"
    | "SchedulerMessagingStatusDone"
    | "SchedulerMessagingStatusFailed"
    | "SchedulerMessagingStatusPending"
    | "SchedulerMessagingStatusRunning"
    | "SchedulerMessagingToDate"
    | "SchedulerMessagingUser"
    | "MeetingActiveAndInactive"
    | "GeneralCombineUsingOR";
  value: any;
  text?: string | null;
  period?: AdvFilterPeriod | null;
  range?: AdvFilterRange | null;
  customField?: AdvFilterCustomField | null;
  includeDescendants?: boolean | null;
  /** @format uuid */
  unitTypeId?: string | null;
}

export type AdvCoreFilterIEquatable = object;

export interface AdvFilterCustomField {
  fieldId: string;
  searchValueRule: SearchValueRule | null;
  searchTextRule: SearchTextRule | null;
  value: string;
}

export type AdvFilterCustomFieldIEquatable = object;

export interface AdvFilterPeriod {
  /** @format date-time */
  startDate: Date | null;
  /** @format date-time */
  endDate: Date | null;
}

export type AdvFilterPeriodIEquatable = object;

export interface AdvFilterRange {
  /** @format int32 */
  minValue: number | null;
  /** @format int32 */
  maxValue: number | null;
}

export type AdvFilterRangeIEquatable = object;

export interface AdvancedOptionsCreationSettingsResponse {
  allowInstitutional: boolean;
  allowStickers: boolean;
}

export type AdvancedOptionsCreationSettingsResponseIEquatable = object;

export type AdvancedOptionsCreationSettingsResponseIRequest = object;

export interface AgreementAutoCompleteDataModelDto {
  key: any;
  label: string;
  thumbnailUrl?: string | null;
  canDelete?: boolean | null;
  fixed?: boolean | null;
  selectable?: boolean | null;
  fromHistory?: boolean;
  text: string | null;
}

export type AgreementAutoCompleteDataModelDtoIEquatable = object;

export type AgreementAutoCompleteDataModelDtoIRequest = object;

export interface AgreementAutoCompleteDataModelDtoPaginatedList {
  items: AgreementAutoCompleteDataModelDto[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type AgreementAutoCompleteDataModelDtoPaginatedListIRequest = object;

export interface AgreementDto {
  /** @format uuid */
  agreementId: string;
  name: string;
  text: string | null;
}

export type AgreementDtoIEquatable = object;

export interface AgreementSuggestionsQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  searchText: string | null;
}

export interface AiAnalysisDto {
  recommended: boolean;
  analysisWords: string[] | null;
  analysisReasons: string[] | null;
}

export interface AllowKnowledgeTestAllQuestionGroupCommand {
  /** @format uuid */
  questionGroupId: string;
  allowKnowledgeTest: boolean;
}

export interface AndroidDefinition {
  androidPackageName: string;
  androidSha256CertFingerprints: string[];
}

export interface AnswersAlternativeDto {
  /** @format uuid */
  userId: string;
  name: string;
  /** @format uuid */
  thumbnailId: string | null;
  thumbnailUrl: string;
  /** @format int32 */
  totalAnswer: number;
  /** @format double */
  numericAnswer: number | null;
}

export type AnswersAlternativeDtoIEquatable = object;

export interface AnswersAlternativeDtoPaginatedList {
  items: AnswersAlternativeDto[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type AnswersAlternativeDtoPaginatedListIRequest = object;

export interface AppAuthSettingsModel {
  enabled: boolean;
  /** @format uuid */
  tenantId: string | null;
  primaryDomainName: string | null;
  /** @format uuid */
  applicationId: string | null;
  /** @format uuid */
  objectId: string | null;
  secret: string | null;
}

export type AppAuthenticatorPrepareSetupCommand = object;

export interface AppAuthenticatorPrepareSetupResponse {
  deepLinkUrl: string | null;
}

export type AppAuthenticatorPrepareSetupResponseIEquatable = object;

export type AppAuthenticatorPrepareSetupResponseIRequest = object;

export type AppAuthenticatorResetCommand = object;

export interface AppAuthenticatorSetupConfirmCommand {
  pinCode: string;
}

export interface AppAuthenticatorValidateCodeCommand {
  pinCode: string;
}

export interface AppLogParams {
  message: string;
  stack: string;
}

export type AppLogParamsIEquatable = object;

export interface AppSettingsResponse {
  samlOptions: SamlOptions | null;
  authOptions: AuthOptions | null;
  twoFactorOptions: TwoFactorOptions | null;
  performaIntegrationEnabled: boolean;
  defaultEmailAddress: string;
  defaultLocale: string;
  supportedLocales: string[];
  /** @format uuid */
  tenantId: string;
  defaultTimezone: TimezoneDto;
  tenantUIConfig: TenantUIConfig;
  inputLocales: InputLocaleDefinition[];
  timezones: TimezoneDto[];
  mobileInfo: TenantMobileInfo;
  webServerUrl: string;
}

export type AppSettingsResponseIEquatable = object;

export interface AppUserView {
  /** @format uuid */
  userId: string;
  name: string;
}

export interface AppointmentDayDto {
  /** @format date */
  day: Date;
  isConflicted: boolean;
  isBlocked: boolean;
}

export type AppointmentDayDtoIEquatable = object;

export type AppointmentDayDtoListIRequest = object;

export interface AppointmentDto {
  /** @format uuid */
  appointmentId: string;
  subject: string;
  /** @format date-time */
  startDate: Date;
  /** @format date-time */
  endDate: Date;
  occursNext48Hours: boolean;
  finished: boolean;
  hasConflict: boolean;
  meeting: AppointmentMeetingDto | null;
}

export interface AppointmentDtoPaginatedList {
  items: AppointmentDto[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type AppointmentDtoPaginatedListIRequest = object;

export interface AppointmentMeetingDto {
  /** @format uuid */
  meetingId: string;
  meetingType: MeetingType;
  meetingTypeName: string;
  thumbnailUrl: string | null;
  locationName: string | null;
  /** @format date-time */
  startDateBooked: Date | null;
  /** @format date-time */
  endDateBooked: Date | null;
  bookedAdditionalTime: boolean;
  isCancelled: boolean;
  /** @format uuid */
  componentId: string;
  /** @format uuid */
  classroomId: string;
  classroomName: string;
  multipleClasses: boolean;
  /** @format uuid */
  trainingId: string;
  trainingType: TrainingType;
  trainingName: string;
  canMonitoringClass: boolean;
  canEditClass: boolean;
  canEditTraining: boolean;
  canEditMeeting: boolean;
  /** @format uuid */
  enrollmentId: string | null;
  isMeetingInstructor: boolean;
  hasAnyAssignedAttendance: boolean;
}

export type AppointmentMeetingDtoIEquatable = object;

export interface ArchiveDevPlanCommand {
  /** @format uuid */
  devPlanId: string;
}

export interface AssAddQuestionCommand {
  /** @format uuid */
  assessmentId: string;
  questionIds: string[];
}

export interface AssAnalysisGroupPeopleListQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  groupId: string;
  orderBy: AssAnalysisDetailsOrderBy;
}

export interface AssAnalysisGroupQuestionListQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  groupId: string;
  orderBy: AssAnalysisDetailsOrderBy;
}

export interface AssAnalysisGroupQuestionResumeQuery {
  /** @format uuid */
  groupId: string;
}

export interface AssAnalysisGroupQuestionResumeResponse {
  /** @format int32 */
  totalUsers: number;
  /** @format int32 */
  totalAnswers: number;
  /** @format double */
  successRate: number;
}

export type AssAnalysisGroupQuestionResumeResponseIEquatable = object;

export type AssAnalysisGroupQuestionResumeResponseIRequest = object;

export interface AssAnalysisPeopleResponse {
  /** @format int32 */
  rowNumber: number;
  user: UserShortView;
  /** @format double */
  valuePercent: number;
  name: string;
}

export interface AssAnalysisPeopleResponsePaginatedList {
  items: AssAnalysisPeopleResponse[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type AssAnalysisPeopleResponsePaginatedListIRequest = object;

export interface AssAnalysisQuestionsResponse {
  /** @format int32 */
  rowNumber: number;
  /** @format uuid */
  questionId: string;
  questionText: string;
  questionType: QuestionType;
  /** @format double */
  value: number;
}

export interface AssAnalysisQuestionsResponsePaginatedList {
  items: AssAnalysisQuestionsResponse[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type AssAnalysisQuestionsResponsePaginatedListIRequest = object;

export interface AssAnalysisResultsPeopleListQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  assessmentId: string;
  orderBy: AssAnalysisDetailsOrderBy;
}

export interface AssAnalysisResultsQuestionsListQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  assessmentId: string;
  orderBy: AssAnalysisDetailsOrderBy;
}

export interface AssAnalysisResultsResumeQuery {
  /** @format uuid */
  assessmentId: string;
}

export interface AssAnalysisResultsResumeResponse {
  /** @format int32 */
  totalUsers: number;
  /** @format double */
  attemptsAverage: number;
  /** @format double */
  scoreAverage: number;
  /** @format double */
  scoreMedian: number;
  /** @format timespan */
  elapsedTimeAverage: string;
  /** @format double */
  elapsedTimeAverageMs: number;
  /** @format double */
  maxScore: number | null;
  /** @format double */
  minScore: number | null;
}

export type AssAnalysisResultsResumeResponseIEquatable = object;

export type AssAnalysisResultsResumeResponseIRequest = object;

export interface AssDeployAudienceQuery {
  /** @format uuid */
  assDeployId: string;
}

export interface AssDeployAudienceRequest {
  groups: GroupInfo[];
}

export type AssDeployAudienceRequestIEquatable = object;

export type AssDeployAudienceRequestIRequest = object;

export interface AssDeploySelectorQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  searchText: string | null;
  /** @format uuid */
  ignoreDeployId: string | null;
  usePermission: boolean;
}

export interface AssDeploySelectorResponse {
  /** @format uuid */
  deployId: string;
  name: string;
  thumbnailUrl: string;
}

export type AssDeploySelectorResponseIEquatable = object;

export interface AssDeploySelectorResponsePaginatedList {
  items: AssDeploySelectorResponse[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type AssDeploySelectorResponsePaginatedListIRequest = object;

export interface AssDeploySuggestionsQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  searchText: string | null;
}

export interface AssessmentAlternativeDto {
  /** @format uuid */
  alternativeId: string;
  text: string;
  /** @format int32 */
  displayOrder: number;
  dropdownAnswers: string[];
  revision: AssessmentAlternativeRevisionDto | null;
}

export interface AssessmentAlternativeRevisionDto {
  /** @format uuid */
  alternativeId: string;
  correctionResult: AssCorrectionResult | null;
  correctAnswer: string | null;
  feedback: string | null;
  /** @format double */
  averageResult: number | null;
  /** @format int32 */
  totalAnswers: number | null;
  confidenceLevel: ConfidenceLevel | null;
}

export interface AssessmentAlternativeSaveDto {
  /** @format uuid */
  alternativeId: string;
  answer: string;
  /** @format double */
  numericAnswer: number | null;
}

export interface AssessmentChallengeRevisionDto {
  challengeMode: ChallengeMode;
  /** @format double */
  scorePercent: number;
  /** @format int32 */
  awardPoints: number;
  /** @format double */
  topicKnowledgePercent: number;
  hasProvenKnowledgeSeal: boolean;
  topicName: string;
  topicThumbnailUrl: string | null;
  topicGrantSealProvenKnowledge: boolean;
  /** @format int32 */
  knowledgeTestsLeft: number;
}

export type AssessmentChallengeRevisionDtoIRequest = object;

export interface AssessmentDuplicateItemCommand {
  /** @format uuid */
  assessmentId: string;
  /** @format uuid */
  itemId: string;
}

export interface AssessmentGeneralDTO {
  userID: string;
  lastDateAssessment: string;
  /** @format double */
  finalResult: number | null;
  finalResultColor: string;
  isPercent: boolean;
}

export interface AssessmentGroupDto {
  /** @format uuid */
  groupId: string;
  name: string;
  type: GroupType;
}

export type AssessmentGroupDtoIEquatable = object;

export interface AssessmentInstanceDto {
  /** @format uuid */
  instanceId: string | null;
  playerMode: AssessmentPlayerMode;
  deployApplicationType: DeployApplicationType;
  title: string;
  assessmentType: AssessmentType;
  mode: AssessmentMode;
  instructions: string | null;
  thumbnailUrl: string | null;
  /** @format int32 */
  totalQuestions: number;
  /** @format int32 */
  tryNumber: number;
  /** @format double */
  elapsedTime: number | null;
  /** @format date-time */
  endTime: Date | null;
  /** @format uuid */
  lastQuestionAnsweredId: string | null;
  pendingCorrection: boolean;
  eval: InstanceEvaluationDto | null;
  surv: InstanceSurveyDto | null;
  survRevision: AssessmentSurveyRevisionDto | null;
  deploy: InstanceDeployDto | null;
}

export type AssessmentInstanceDtoIRequest = object;

export interface AssessmentInstanceResultDto {
  /** @format uuid */
  instanceId: string;
  /** @format int32 */
  totalPoints: number;
  /** @format double */
  totalAnswerPoints: number;
  /** @format int32 */
  minFinalScore: number;
  hasEssay: boolean;
  timeOver: boolean;
}

export type AssessmentInstanceResultDtoIRequest = object;

export interface AssessmentItemDto {
  /** @format uuid */
  assessmentId: string;
  name: string;
  thumbnailUrl: string;
}

export type AssessmentItemDtoIEquatable = object;

export interface AssessmentItemDtoPaginatedList {
  items: AssessmentItemDto[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type AssessmentItemDtoPaginatedListIRequest = object;

export interface AssessmentListDTO {
  userId: string;
  thumbnailUrl: string | null;
  userName: string;
  distributionName: string;
  distributionPeriod: string;
  stepCurrentDescription: string;
  status: string;
  statusColor: string;
  stepUserDate: string;
  stepUserDateColor: string;
}

export interface AssessmentPropsDto {
  nameOverride: string | null;
  allowReview: boolean;
  isPreTest: boolean;
}

export type AssessmentPropsDtoIEquatable = object;

export interface AssessmentPropsQuery {
  /** @format uuid */
  trainingId: string;
  /** @format int32 */
  versionNumber: number;
  /** @format uuid */
  componentId: string;
}

export interface AssessmentQuestionDto {
  /** @format uuid */
  questionId: string;
  /** @format int32 */
  version: number;
  questionType: QuestionType;
  questionClass: QuestionClass;
  questionText: string;
  remarks: string | null;
  /** @format int32 */
  displayOrder: number;
  /** @format int32 */
  maxLen: number | null;
  attach: QuestionAttachDto | null;
  placeholderText: string | null;
  /** @format int32 */
  points: number | null;
  alternativesSideBySide: boolean;
  required: boolean;
  /** @format int32 */
  fillInMinValue: number;
  /** @format int32 */
  fillInMaxValue: number;
  alternatives: AssessmentAlternativeDto[];
  answers: AssessmentAlternativeSaveDto[];
  revision: AssessmentQuestionRevisionDto | null;
}

export type AssessmentQuestionDtoIRequest = object;

export interface AssessmentQuestionRevisionDto {
  isCorrect: boolean;
  feedback: string | null;
  /** @format double */
  answerPoints: number | null;
  /** @format int32 */
  percentPoints: number | null;
  /** @format int32 */
  totalAnswers: number | null;
  /** @format double */
  averagePoints: number | null;
  /** @format double */
  totalPoints: number | null;
  /** @format int32 */
  totalAnswersVersions: number | null;
  identifyAnswers: boolean | null;
  alternatives: AssessmentAlternativeRevisionDto[];
}

export interface AssessmentQuestionUsedQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  searchText: string | null;
  /** @format uuid */
  questionId: string;
}

export interface AssessmentSaveResultDto {
  success: boolean;
  questionResult: AssessmentQuestionDto | null;
  nextQuestion: AssessmentQuestionDto | null;
  instanceResult: AssessmentInstanceResultDto | null;
}

export type AssessmentSaveResultDtoIRequest = object;

export interface AssessmentSelectorDto {
  /** @format uuid */
  assessmentId: string;
  name: string;
  assessmentType: AssessmentType;
  exclusiveUsage: ExclusiveUsage;
  /** @format uuid */
  exclusiveRelatedId: string | null;
  thumbnailUrl: string;
  selected: boolean;
}

export type AssessmentSelectorDtoIEquatable = object;

export interface AssessmentSelectorDtoPaginatedList {
  items: AssessmentSelectorDto[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type AssessmentSelectorDtoPaginatedListIRequest = object;

export interface AssessmentSelectorQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  searchText: string | null;
  assessmentType: AssessmentType;
  /** @format uuid */
  assessmentId: string | null;
}

export interface AssessmentStartPlayerDto {
  /** @format uuid */
  deployId: string | null;
  /** @format uuid */
  instanceId: string | null;
  /** @format uuid */
  participantId: string | null;
  /** @format date-time */
  startDate: Date;
  /** @format date-time */
  endDate: Date;
  playerMode: AssessmentPlayerMode;
  message: string | null;
}

export type AssessmentStartPlayerDtoIRequest = object;

export interface AssessmentSurveyRevisionDto {
  /** @format date-time */
  startDate: Date | null;
  /** @format date-time */
  endDate: Date | null;
  /** @format int32 */
  totalParticipants: number;
  /** @format double */
  averagePlayTime: number | null;
  /** @format double */
  averagePoints: number | null;
  /** @format double */
  averagePointsPercent: number | null;
}

export interface AsyncUploadResult {
  uploadId: string;
  mainFile: FileUploadResultDto;
  thumbnail: FileUploadResultDto | null;
  error: string | null;
}

export type AsyncUploadResultIEquatable = object;

export interface AttendingTrainingsQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  searchText: string | null;
  browserTimeZoneId: string;
}

export interface AudienceDto {
  /** @format uuid */
  audienceId: string;
  needsAll: boolean;
  isMandatory: boolean;
  canUserManagerDismiss: boolean;
  canManagerEnrollSubordinates: boolean;
  groups: AudienceGroupDto[];
}

export type AudienceDtoIEquatable = object;

export type AudienceDtoIRequest = object;

export interface AudienceGroupDto {
  /** @format uuid */
  groupId: string;
  name: string;
  type: GroupType;
  isMandatory: boolean;
  canUserManagerDismiss: boolean;
  canManagerEnrollSubordinates: boolean;
}

export type AudienceGroupDtoIEquatable = object;

export interface AuditLogDetailQuery {
  /** @format uuid */
  id: string;
}

export interface AuditLogDto {
  /** @format uuid */
  id: string;
  eventId: AuditLogEventId;
  entityType: AuditLogEntityType;
  isDelete: boolean;
  entityKey: string[] | null;
  reference: string | null;
  referenceDetailed: boolean;
  referenceEntityKey: string[] | null;
  viewPermissions: string[] | null;
  viewDetailPermissions: string[] | null;
  ipAddress: string | null;
  /** @format date-time */
  createdOn: Date;
  /** @format uuid */
  creatorId: string;
  creatorName: string;
  /** @format uuid */
  spyId: string | null;
  spyName: string;
  eventIdName: string;
  entityTypeName: string;
}

export interface AuditLogDtoPaginatedList {
  items: AuditLogDto[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type AuditLogDtoPaginatedListIRequest = object;

export interface AuditLogEntityTypeResponse {
  entityType: AuditLogEntityType;
  name: string;
}

export type AuditLogEntityTypeResponseIEquatable = object;

export type AuditLogEntityTypeResponseListIRequest = object;

export interface AuditLogEntityTypesQuery {
  deleteOnly: boolean;
}

export interface AuditLogEventResponse {
  eventId: AuditLogEventId;
  name: string;
}

export type AuditLogEventResponseIEquatable = object;

export interface AuditLogQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  deletedOnly: boolean;
  searchText: string | null;
  eventId: AuditLogEventId | null;
  entityType: AuditLogEntityType | null;
  entityKey: string[] | null;
  ipAddress: string | null;
}

export interface AuditLogRecord {
  /** @format uuid */
  id: string;
  eventId: AuditLogEventId;
  entityType: AuditLogEntityType;
  isDelete: boolean;
  entityKey: string[] | null;
  reference: string | null;
  referenceDetailed: boolean;
  referenceEntityKey: string[] | null;
  viewPermissions: string[] | null;
  viewDetailPermissions: string[] | null;
  ipAddress: string | null;
  /** @format date-time */
  createdOn: Date;
  /** @format uuid */
  creatorId: string;
  creatorName: string;
  /** @format uuid */
  spyId: string | null;
  spyName: string;
}

export interface AuthFieldsSettingsResponse {
  possibleAuthFields: PossibleAuthFieldModel[];
}

export type AuthFieldsSettingsResponseIEquatable = object;

export interface AuthOptions {
  enableAutoRegister: boolean;
  enablePasswordRecovery: boolean;
  requireAccountConfirmation: boolean;
  captchaSitekey: string | null;
  identifierInstructions: string | null;
  registerFormMode: string | null;
  registerFormExternalUrl: string | null;
}

export type AuthOptionsIEquatable = object;

export interface AuthorSubscriptionResponse {
  /** @format uuid */
  authorId: string;
  name: string;
  thumbnailUrl: string | null;
  registered: boolean;
  hideQuickAccess: boolean | null;
  /** @format int32 */
  publicationCount: number;
  /** @format int32 */
  subscriptionCount: number;
}

export type AuthorSubscriptionResponseIEnumerableIRequest = object;

export type AuthorSubscriptionResponseIEquatable = object;

export interface AuthorSubscriptionsQuery {
  /** @format int32 */
  takeRecords: number;
  searchText: string | null;
  filterBy: AuthorSubscriptionFilterBy;
}

export interface AuthorSuggestionsQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  searchText: string | null;
}

export interface AutoCompleteDataModelDto {
  key: any;
  label: string;
  thumbnailUrl?: string | null;
  canDelete?: boolean | null;
  fixed?: boolean | null;
  selectable?: boolean | null;
  fromHistory?: boolean;
}

export type AutoCompleteDataModelDtoIEnumerableIRequest = object;

export type AutoCompleteDataModelDtoIEquatable = object;

export type AutoCompleteDataModelDtoListIRequest = object;

export interface AutoCompleteDataModelDtoPaginatedList {
  items: AutoCompleteDataModelDto[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type AutoCompleteDataModelDtoPaginatedListIRequest = object;

export interface AutoCompleteHierarchicalModelDto {
  key: any;
  label: string;
  thumbnailUrl?: string | null;
  canDelete?: boolean | null;
  fixed?: boolean | null;
  selectable?: boolean | null;
  fromHistory?: boolean;
  includeDescendants: boolean;
  hasChild: boolean;
  allowAssociates: boolean;
  tooltip: string | null;
  tree: AutoCompleteHierarchicalTreeModelDto[];
}

export type AutoCompleteHierarchicalModelDtoIEquatable = object;

export interface AutoCompleteHierarchicalModelDtoPaginatedList {
  items: AutoCompleteHierarchicalModelDto[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type AutoCompleteHierarchicalModelDtoPaginatedListIRequest = object;

export interface AutoCompleteHierarchicalTreeModelDto {
  /** @format uuid */
  parentKey: string;
  parentLabel: string;
  parentHasChild: boolean;
  parentAllowAssociates: boolean;
}

export type AutoCompleteHierarchicalTreeModelDtoIEquatable = object;

export interface AutoCompleteModel {
  key: any;
  label: string;
  thumbnailUrl?: string | null;
  canDelete?: boolean | null;
  fixed?: boolean | null;
  selectable?: boolean | null;
}

export type AutoCompleteModelIEquatable = object;

export interface AutoRegisterSettingsResponse {
  identifiers: CustomFieldValueDto[];
  emailSenderAddress: string;
  emailSenderName: string;
  emailIsRequired: boolean;
  /** @format int32 */
  passwordMinLength: number;
  passwordRequiresOneUpperLetter: boolean;
  passwordRequiresOneNumber: boolean;
  passwordRequiresOneSymbol: boolean;
  passwordAllowNameParts: boolean;
  isWorkplaceFreeText: boolean;
  workplaceLabel: string;
  sendWelcomeEmail: boolean;
  agreementMustBeAssigned: boolean;
  workplaceRequired: boolean;
  autoRegisterRequireApproval: boolean;
}

export type AutoRegisterSettingsResponseIEquatable = object;

export interface AvailableReportResponse {
  reports: AvailableReportResponseItem[];
  lastestReports: AvailableReportResponseItem[];
}

export type AvailableReportResponseIRequest = object;

export interface AvailableReportResponseItem {
  /** @format uuid */
  reportId: string;
  name: string;
  groupName: string;
  /** @format date-time */
  lastRun: Date | null;
  schedules: AvailableReportScheduleItem[];
}

export interface AvailableReportScheduleItem {
  /** @format uuid */
  reportScheduleId: string;
  name: string;
}

export interface AvailableReportsQuery {
  searchText: string;
}

export interface AvailableStickersQueryResponse {
  /** @format uuid */
  stickerId: string;
  name: string;
  requiredDeadline: boolean;
}

export type AvailableStickersQueryResponseIEquatable = object;

export interface AvailableTrainingsQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  searchText: string | null;
  browserTimeZoneId: string;
}

export interface AwardChartTuple {
  /** @format date-time */
  dtref: Date;
  /** @format int32 */
  value: number;
}

export type AwardChartTupleIEquatable = object;

export interface AwardRankingDto {
  /** @format uuid */
  rankingId: string;
  name: string;
}

export interface AwardResumeBadgeDto {
  /** @format uuid */
  badgeId: string;
  name: string;
  thumbnailUrl: string;
}

export type AwardResumeBadgeDtoIEquatable = object;

export interface AwardResumeQuery {
  currentMonth: boolean;
}

export interface AwardResumeResponse {
  /** @format int32 */
  ranking: number;
  rankingName: string | null;
  /** @format int32 */
  points: number;
  badges: AwardResumeBadgeDto[];
}

export type AwardResumeResponseIEquatable = object;

export type AwardResumeResponseIRequest = object;

export interface AwardUserRankingDto {
  /** @format uuid */
  userId: string;
  name: string | null;
  thumbnailUrl: string | null;
  /** @format int32 */
  points: number;
  /** @format int32 */
  ranking: number;
}

export type AwardUserRankingDtoIEquatable = object;

export interface AzureTranslationTextQuery {
  text: string;
  fromLanguage: string;
  toLanguages: string[];
}

export interface AzureTranslationTextResponse {
  translations: AzureTranslationTextResult[] | null;
  error: string | null;
}

export type AzureTranslationTextResponseIRequest = object;

export interface AzureTranslationTextResult {
  text: string;
  to: string;
}

export type AzureTranslationTextResultIEquatable = object;

export interface BadgeInfoQuery {
  /** @format uuid */
  badgeId: string;
  /** @format uuid */
  userId: string | null;
}

export interface BadgeInfoResponse {
  /** @format uuid */
  badgeId: string;
  name: string;
  descriptionBeforeWin: string | null;
  descriptionAfterWin: string | null;
  /** @format int32 */
  grantPoints: number | null;
  thumbnailUrl: string;
  /** @format int32 */
  grantedCount: number;
  /** @format date-time */
  lastGrantedOn: Date | null;
}

export type BadgeInfoResponseIEquatable = object;

export type BadgeInfoResponseIRequest = object;

export interface BadgeRuleActionLimitsItemDto {
  ruleActionLimit: BadgeRuleActionLimits;
  name: string;
}

export type BadgeRuleActionLimitsItemDtoIEquatable = object;

export interface BadgeRuleItemDto {
  ruleAction: BadgeRuleAction;
  name: string;
}

export type BadgeRuleItemDtoIEquatable = object;

export interface BadgeRulePeriodItemDto {
  rulePeriod: BadgeRulePeriod;
  name: string;
}

export type BadgeRulePeriodItemDtoIEquatable = object;

export interface BadgeSystemListQuery {
  groupAction: ManagedBadgeGroupAction;
}

export interface BadgeSystemListResponse {
  badgeRules: BadgeRuleItemDto[];
  badgeRulePeriods: BadgeRulePeriodItemDto[];
  badgeRuleActionLimits: BadgeRuleActionLimitsItemDto[];
}

export type BadgeSystemListResponseIEquatable = object;

export type BadgeSystemListResponseIRequest = object;

export interface BannerListQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  searchText: string | null;
  filter: AdvCoreFilter[];
  includeExpired: boolean;
  orderBy: BannerListQueryOrderBy;
}

export interface BannerListResponse {
  /** @format uuid */
  bannerId: string;
  name: string;
  /** @format date-time */
  startDate: Date | null;
  /** @format date-time */
  endDate: Date | null;
  /** @format int32 */
  hits: number;
  /** @format int32 */
  totalRows: number;
  expired: boolean;
  active: boolean;
  /** @format int32 */
  priority: number;
  contentAudience: boolean;
  thumbnailUrl: string | null;
}

export type BannerListResponseIEquatable = object;

export interface BannerListResponsePaginatedList {
  items: BannerListResponse[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type BannerListResponsePaginatedListIRequest = object;

export interface BannerQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  bannerId: string | null;
  pageView: BannerPageViewType | null;
}

export interface BannerResponse {
  /** @format uuid */
  bannerId: string;
  contentType: BannerContentType;
  linkOnOpen: boolean | null;
  linkUrl: string | null;
  openLinkOnNewBrowserTab: boolean | null;
  panoramicOption: BannerPanoramicOption | null;
  /** @format int32 */
  containerHeight: number;
  rotationAutomatic: boolean;
  viewRandom: boolean;
  /** @format int32 */
  interval: number;
  publicationType: PublicationType | null;
  topicGoTo: BannerTopicGoToType | null;
  systemFeature: SystemFeature | null;
  title: string;
  subTitle: string | null;
  headLine: string;
  imageUrl: string;
  /** @format int32 */
  imageWidth: number;
  /** @format int32 */
  imageHeight: number;
  isWideImage: boolean;
  /** @format uuid */
  id: string | null;
  survey: BannerSurveyResponse | null;
}

export type BannerResponseIEquatable = object;

export interface BannerResponsePaginatedList {
  items: BannerResponse[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type BannerResponsePaginatedListIRequest = object;

export interface BannerSurveyResponse {
  /** @format uuid */
  assessmentId: string;
}

export type BannerSurveyResponseIEquatable = object;

export interface BillingExtractHistoryDto {
  /** @format date */
  dateRef: Date | null;
  /** @format date */
  invoiceDate: Date;
  source: BillingPaymentSource;
  sourceName: string;
  /** @format double */
  amount: number;
}

export interface BillingExtractHistoryDtoPaginatedList {
  items: BillingExtractHistoryDto[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type BillingExtractHistoryDtoPaginatedListIRequest = object;

export interface BillingHistoryData {
  /** @format date */
  billingStartDate: Date | null;
  usersLast12: KPTupleLong[];
  storageLast12: KPTupleLong[];
  streamingLast12: KPTupleLong[];
  iaLast12: KPTupleLong[];
  invoiceLast12: KPTupleDouble[];
}

export type BillingHistoryDataIEquatable = object;

export interface BillingHistoryDto {
  /** @format uuid */
  tenantId: string;
  /** @format date */
  dateRef: Date;
  billingType: TenantBillingType;
  /** @format int32 */
  maxUsers: number;
  /** @format int32 */
  maxStorageGb: number;
  /** @format int32 */
  maxStreamingHours: number;
  /** @format int32 */
  maxIaRequests: number;
  /** @format double */
  contractAmount: number;
  /** @format double */
  costExtraUser: number;
  /** @format double */
  costExtraStorage: number;
  /** @format double */
  costExtraStreaming: number;
  /** @format double */
  costExtraIa: number;
  blockExtraUser: boolean;
  blockExtraStorage: boolean;
  blockExtraStreaming: boolean;
  blockExtraIa: boolean;
  /** @format int32 */
  startPackMonthlyUsers: number;
  /** @format int32 */
  startPackStreamingHours: number;
  /** @format int32 */
  startPackIaRequests: number;
  /** @format int32 */
  consUsers: number;
  /** @format int32 */
  consStorageGb: number;
  /** @format int32 */
  consStreamingHours: number;
  /** @format int32 */
  consIaRequests: number;
  /** @format int32 */
  consExtraUsers: number;
  /** @format int32 */
  consExtraStorageGb: number;
  /** @format int32 */
  consExtraStreamingHours: number;
  /** @format int32 */
  consExtraIaRequests: number;
  /** @format int32 */
  consPackMonthlyUsers: number;
  /** @format int32 */
  consPackStreamingHours: number;
  /** @format int32 */
  consPackIaRequests: number;
  /** @format double */
  consExtraTotal: number;
  /** @format int32 */
  newBalancePackIaRequests: number;
  /** @format int32 */
  newBalancePackStreamingHours: number;
  /** @format int32 */
  newBalancePackUsers: number;
  /** @format date */
  invoiceDate: Date;
  /** @format double */
  extraAmount: number;
  /** @format double */
  invoiceAmount: number;
}

export type BillingHistoryDtoIEquatable = object;

export type BillingHistoryDtoIRequest = object;

export interface BillingIaExportCommand {
  /** @format date-time */
  dateRef: Date;
}

export interface BillingIaQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format date-time */
  dateRef: Date;
}

export interface BillingInvoiceExtractQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export interface BillingInvoiceQuery {
  /** @format date */
  dateRef: Date | null;
}

export interface BillingPanelIaUserDto {
  /** @format uuid */
  userId: string;
  name: string;
  thumbnailUrl: string;
  /** @format int32 */
  requests: number;
}

export type BillingPanelIaUserDtoIEquatable = object;

export interface BillingPanelIaUserDtoPaginatedList {
  items: BillingPanelIaUserDto[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type BillingPanelIaUserDtoPaginatedListIRequest = object;

export interface BillingPanelStorageDto {
  /** @format int64 */
  knowledgeUserPublications: number;
  /** @format int64 */
  knowledgeInstitutionalPublications: number;
  /** @format int64 */
  trainings: number;
  /** @format int64 */
  banners: number;
  /** @format int64 */
  assessments: number;
  /** @format int64 */
  others: number;
}

export type BillingPanelStorageDtoIEquatable = object;

export interface BillingPanelStreamingFileDto {
  /** @format uuid */
  fileId: string;
  name: string;
  /** @format int32 */
  loadTime: number;
  /** @format int32 */
  totalViews: number;
}

export type BillingPanelStreamingFileDtoIEquatable = object;

export interface BillingPanelStreamingFileDtoPaginatedList {
  items: BillingPanelStreamingFileDto[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type BillingPanelStreamingFileDtoPaginatedListIRequest = object;

export interface BillingPanelUserDto {
  /** @format uuid */
  userId: string;
  name: string;
  thumbnailUrl: string;
  ipAddress: string | null;
  /** @format date-time */
  accessOn: Date | null;
}

export type BillingPanelUserDtoIEquatable = object;

export interface BillingPanelUserDtoPaginatedList {
  items: BillingPanelUserDto[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type BillingPanelUserDtoPaginatedListIRequest = object;

export interface BillingQuotaDto {
  /** @format uuid */
  tenantId: string;
  /** @format date */
  hiringDate: Date;
  /** @format int32 */
  users: number;
  /** @format int32 */
  streamingHours: number;
  /** @format int32 */
  iaRequests: number;
  /** @format double */
  userCost: number;
  /** @format double */
  streamingCost: number;
  /** @format double */
  iaCost: number;
  /** @format double */
  discount: number;
  /** @format double */
  packageAmount: number;
}

export type BillingQuotaDtoIRequest = object;

export interface BillingQuotaQuery {
  /** @format date */
  hiringDate: Date;
}

export interface BillingResumeResponse {
  billingType: TenantBillingType;
  ia: ResourceResume;
  storage: ResourceResume;
  streaming: ResourceResume;
  user: ResourceResume;
  historyData: BillingHistoryData;
}

export type BillingResumeResponseIEquatable = object;

export interface BillingStreamingDetailsDto {
  /** @format uuid */
  fileId: string;
  name: string;
  /** @format int64 */
  duration: number;
  /** @format int64 */
  loadTime: number;
  /** @format int32 */
  totalViews: number;
  /** @format date-time */
  createdOn: Date;
  creatorName: string;
  creator: UserShortView | null;
  isDeleted: boolean;
  publication: PublicationContextDto | null;
  training: TrainingContextDto | null;
  question: QuestionContextDto | null;
  devPlan: DevPlanContextDto | null;
}

export type BillingStreamingDetailsDtoIEquatable = object;

export type BillingStreamingDetailsDtoIRequest = object;

export interface BillingStreamingDetailsQuery {
  /** @format uuid */
  fileId: string;
}

export interface BillingStreamingExportCommand {
  /** @format date-time */
  dateRef: Date;
}

export interface BillingStreamingQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format date-time */
  dateRef: Date;
}

export interface BillingUsersExportCommand {
  /** @format date-time */
  dateRef: Date;
}

export interface BillingUsersQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format date-time */
  dateRef: Date;
}

export interface BlockOrUnblockAllQuestionGroupCommand {
  /** @format uuid */
  questionGroupId: string;
  block: boolean;
}

export interface BlockOrUnblockMaterialListCommand {
  /** @format uuid */
  classroomId: string;
  /** @format uuid */
  materialListId: string;
  block: boolean;
}

export interface BlockOrUnblockMaterialListItemCommand {
  /** @format uuid */
  classroomId: string;
  /** @format uuid */
  materialListId: string;
  /** @format uuid */
  materialListItemId: string;
  block: boolean;
}

export interface BlockOrUnblockQuestionCommand {
  /** @format uuid */
  questionId: string;
}

export interface BlockPublicationCommand {
  /** @format uuid */
  publicationId: string;
  blockMessage: string | null;
}

export interface BlockReasonSelectorResponse {
  /** @format uuid */
  blockReasonId: string;
  name: string;
  appliesToUserStatus: UserStatus;
  isReserved: boolean;
}

export type BlockReasonSelectorResponseIEquatable = object;

export type BooleanIRequest = object;

export interface CalendarAppointmentsQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  searchText: string | null;
  /** @format date-time */
  meetingDate: Date | null;
  onlySpecificDay: boolean;
  includePast: boolean;
  filterBy: CalendarFilterBy;
  orderBy: CalendarAppointmentsOrderBy;
}

export interface CalendarQuery {
  /** @format date-time */
  meetingDate: Date;
  includePast: boolean;
  filterBy: CalendarFilterBy;
  browerTimeZoneId: string;
}

export interface CalendarSuggestionQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  searchText: string | null;
}

export interface CalloutDto {
  id: string;
  active: boolean;
  /** @format int32 */
  total?: number | null;
}

export type CalloutDtoIEquatable = object;

export type CalloutDtoListIRequest = object;

export interface CancelBatchEnrollmentCommand {
  enrollmentIds: string[];
  /** @format uuid */
  cancelReasonId: string;
  cancelRemarks: string | null;
}

export interface CancelClassroomMeetingCommand {
  /** @format uuid */
  componentId: string;
  /** @format uuid */
  classroomId: string;
}

export interface CancelEnrollReasonDto {
  /** @format uuid */
  cancelEnrollReasonId: string;
  name: string;
  nameR: ResourceModel[];
  isReserved: boolean;
}

export type CancelEnrollReasonDtoIEquatable = object;

export interface CancelEnrollmentCommand {
  /** @format uuid */
  enrollmentId: string;
}

export interface CardAction {
  text: string;
  icon: CardIcon | null;
  actionType: CardActionType;
  location: CardActionLocation;
  /** @format int32 */
  locationGroup: number;
  actionButtonState: boolean | null;
  linkFeature: SystemFeature | null;
  /** @format uuid */
  carouselLinkId: string;
  notConvertActionToLink: boolean;
  ignoreMobile: boolean;
}

export interface CardDto {
  /** @format uuid */
  uniqueId: string;
  disabled: boolean;
  title: string;
  thumbnail: CardThumbnail | null;
  stickerLeft: CardSticker | null;
  stickerRight: CardSticker | null;
  primaryStickerSubtitle: CardSticker | null;
  lines: CardText[];
  actions: CardAction[];
  data: Record<string, any>;
  mobileRenderMode: CardRenderMode;
}

export type CardDtoIEnumerableIRequest = object;

export interface CardDtoPaginatedList {
  items: CardDto[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type CardDtoPaginatedListIRequest = object;

export interface CardIcon {
  variant: CardIconVariant;
  color: CardColor | null;
  tooltip: string | null;
}

export interface CardSticker {
  text: string;
  foregroundColor: string | null;
  backgroundColor: string | null;
  backgroundColorVariant: CardColor | null;
  preIcon: CardIcon | null;
  postIcon: CardIcon | null;
}

export interface CardText {
  text: string;
  variant: CardTextVariant;
  color: CardColor | null;
  preIcon: CardIcon | null;
  postIcon: CardIcon | null;
  reverse: boolean;
}

export interface CardThumbnail {
  url: string;
  displayMode: CardThumbnailDisplayMode;
}

export interface CarouselAudienceGetDto {
  /** @format uuid */
  groupId: string;
  name: string;
  type: GroupType;
}

export type CarouselAudienceGetDtoIEquatable = object;

export interface CarouselCheckNewSensitiveDataQuery {
  module: CarouselModule;
}

export interface CarouselConfigDto {
  items: CarouselConfigItemDto[][];
  /** @format date-time */
  createdOn: Date;
  /** @format date-time */
  expiresOn: Date;
}

export type CarouselConfigDtoIEquatable = object;

export type CarouselConfigDtoIRequest = object;

export interface CarouselConfigItemDto {
  /** @format uuid */
  carouselId: string;
  name: string;
  renderMode: CarouselCardRenderMode;
}

export type CarouselConfigItemDtoIEquatable = object;

export interface CarouselConfigQuery {
  module: CarouselModule;
}

export interface CarouselContentFilter {
  searchText: string;
  filters: AdvCoreFilter[];
  /** @format int32 */
  orderBy: number;
}

export interface CarouselContentListItem {
  /** @format uuid */
  itemId: string;
  listType: CarouselContentListType;
  name: string;
  /** @format int32 */
  displayOrder: number;
}

export type CarouselContentListItemIEquatable = object;

export interface CarouselDataQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  carouselId: string;
  forceRefresh: boolean;
  searchText: string | null;
  browserTimeZoneId: string;
}

export interface CarouselDataResponse {
  items: CardDto[];
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageOffset: number;
  hasPreviousPage: boolean;
  hasNextPage: boolean;
  /** @format date-time */
  expiresOn: Date;
}

export type CarouselDataResponseIRequest = object;

export interface CarouselGetDto {
  /** @format uuid */
  carouselId: string;
  names: ResourceModel[];
  module: CarouselModule;
  contentType: CarouselContentType;
  contentParameters: CarouselContentFilter | null;
  listType: CarouselListType | null;
  mixPubTrainingOption: CarouselPubTrainingOption | null;
  audiences: CarouselAudienceGetDto[];
  links: CarouselLinkGetDto[];
  contentList: CarouselContentListItem[];
  recordInfo: RecordInfoDto | null;
}

export type CarouselGetDtoIEquatable = object;

export type CarouselGetDtoIRequest = object;

export interface CarouselLinkGetDto {
  /** @format uuid */
  carouselLinkId: string;
  linkType: CarouselLinkType;
  titleR: ResourceModel[];
  subtitleR: ResourceModel[];
  url: string | null;
  iframeContent: string | null;
  openSameWindow: boolean | null;
  thumbnail: FileGetDto | null;
  linkFeature: SystemFeature | null;
  /** @format int32 */
  displayOrder: number;
}

export type CarouselLinkGetDtoIEquatable = object;

export interface CarouselLinkInfoDto {
  /** @format uuid */
  carouselLinkId: string;
  linkType: CarouselLinkType;
  title: string;
  subtitle: string | null;
  url: string | null;
  iframeContent: string | null;
  iframeSource: string | null;
  openSameWindow: boolean | null;
  thumbnail: FileGetDto | null;
  linkFeature: SystemFeature | null;
}

export type CarouselLinkInfoDtoIEquatable = object;

export type CarouselLinkInfoDtoIRequest = object;

export interface CarouselLinkInfoQuery {
  /** @format uuid */
  carouselLinkId: string;
}

export interface CarouselLinkItem {
  /** @format uuid */
  carouselLinkId: string;
  linkType: CarouselLinkType;
  titleR: ResourceModel[];
  subtitleR: ResourceModel[];
  url: string | null;
  iframeContent: string | null;
  openSameWindow: boolean | null;
  /** @format uuid */
  thumbnailId: string | null;
  linkFeature: SystemFeature | null;
}

export type CarouselLinkItemIEquatable = object;

export interface CarouselListItem {
  /** @format uuid */
  itemId: string;
  listType: CarouselContentListType;
}

export type CarouselListItemIEquatable = object;

export interface CarouselOperationResult {
  success: boolean;
  items: ManageCarouselListResponse[] | null;
}

export type CarouselOperationResultIEquatable = object;

export type CarouselOperationResultIRequest = object;

export interface CarouselSystemListQuery {
  module: CarouselModule;
}

export interface CarouselSystemListResponse {
  listType: CarouselListType;
  name: string;
  isMixTrainingAndPub: boolean;
}

export type CarouselSystemListResponseIEquatable = object;

export type CarouselSystemListResponseListIRequest = object;

export interface CarouselTrainingAttendingQuery {
  searchText: string | null;
  browserTimeZoneId: string;
}

export interface CarouselTrainingMandatoryQuery {
  searchText: string | null;
  browserTimeZoneId: string;
}

export interface CatalogQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  browserTimeZoneId: string;
  searchText: string | null;
  filters: AdvCoreFilter[];
  order: LmsTrainingOrder;
}

export interface CatalogSetupResponse {
  stickers: StickerSelectorAdvFilterResponse[];
  isManager: boolean;
}

export type CatalogSetupResponseIEquatable = object;

export interface ChallengeLmsSettingsResponse {
  /** @format uuid */
  lmsSettingId: string;
  headlineR: ResourceModel[];
  thumbnail: FileGetDto | null;
}

export type ChallengeLmsSettingsResponseIEquatable = object;

export interface ChallengePendingTopicResponse {
  result: ChallengePendingTopicResult | null;
}

export type ChallengePendingTopicResponseIEquatable = object;

export interface ChallengePendingTopicResult {
  /** @format uuid */
  instanceId: string;
  /** @format uuid */
  topicId: string;
  topicName: string;
  topicThumbnailUrl: string | null;
  challengeMode: ChallengeMode;
}

export type ChallengePendingTopicResultIEquatable = object;

export interface ChallengeUserTopicDto {
  /** @format uuid */
  topicId: string;
  name: string;
  /** @format int32 */
  availableQuestions: number;
  disableChallenge: boolean;
  isRetention: boolean;
  /** @format int32 */
  pendingQuestions: number;
  grantSealProvenKnowledge: boolean;
}

export type ChallengeUserTopicDtoIEquatable = object;

export interface ChallengeUserTopicListQuery {
  top3: boolean;
  /** @format uuid */
  firstTopicId: string | null;
}

export interface ChallengeUserTopicResponse {
  topics: ChallengeUserTopicDto[];
  /** @format int32 */
  totalTopics: number;
  /** @format int32 */
  estimatedTime: number;
  /** @format int32 */
  points: number;
}

export type ChallengeUserTopicResponseIEquatable = object;

export type ChallengeUserTopicResponseIRequest = object;

export interface ChangeChallengeStatusCommand {
  /** @format uuid */
  topicId: string;
  disableChallenge: boolean;
}

export interface ChangeMemberRoleCommand {
  /** @format uuid */
  channelId: string;
  /** @format uuid */
  memberId: string;
  memberType: MemberType;
  role: ChannelRoles;
}

export interface ChangeNotificationConfigCommand {
  groupId: NotificationGroup;
  mailOption: NotificationSendMailOption | null;
  showWorkspaceNotification: boolean | null;
  sendPushNotification: boolean | null;
}

export interface ChangePasswordCommand {
  /** @format uuid */
  userId: string;
  newPassword: string;
  blockStandardAccount: boolean;
}

export interface ChangeScormDebugCommand {
  /** @format uuid */
  trainingId: string;
  enableDebug: boolean;
}

export type ChangeScormDebugCommandIEquatable = object;

export interface ChangeTagRestrictionCommand {
  /** @format uuid */
  tagId: string;
  restriction: TagRestriction;
}

export interface ChangeUserStatusCommand {
  /** @format uuid */
  userId: string;
  /** @format uuid */
  blockReasonId: string | null;
  /** @format date-time */
  unblockAt: Date | null;
  /** @format date-time */
  accessExpiresOn: Date | null;
}

export interface ChannelAddMembersSuggestionsQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  searchText: string | null;
  exceptChannelIds: string[] | null;
}

export interface ChannelAutoCompleteDataModelDto {
  key: any;
  label: string;
  thumbnailUrl?: string | null;
  canDelete?: boolean | null;
  fixed?: boolean | null;
  selectable?: boolean | null;
  fromHistory?: boolean;
  usersGroup: GroupInfo;
  isPrivate: boolean;
  requirePublicationEditJustification: boolean;
}

export type ChannelAutoCompleteDataModelDtoIEquatable = object;

export interface ChannelAutoCompleteDataModelDtoPaginatedList {
  items: ChannelAutoCompleteDataModelDto[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type ChannelAutoCompleteDataModelDtoPaginatedListIRequest = object;

export interface ChannelMemberGroupsSuggestionQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  channelId: string;
  searchText: string | null;
}

export interface ChannelMemberSuggestionQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  channelId: string;
  searchText: string | null;
}

export interface ChannelMemberUsersSuggestionQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  channelId: string;
  searchText: string | null;
}

export interface ChannelPanelDto {
  /** @format uuid */
  channelId: string;
  name: string;
}

export type ChannelPanelDtoIEquatable = object;

export type ChannelPanelDtoListIRequest = object;

export interface ChannelPermissionsResponse {
  channelName: string;
  canAddMembers: boolean;
  canManagePublications: boolean;
}

export type ChannelPermissionsResponseIEquatable = object;

export interface ChannelRolesSelectorResponse {
  id: ChannelRoles;
  name: string;
}

export type ChannelRolesSelectorResponseIEquatable = object;

export interface ChannelSearchDto {
  /** @format uuid */
  channelId: string;
  name: string;
  description: string | null;
  thumbnailUrl: string | null;
  isPrivate: boolean;
  /** @format int32 */
  totalPublications: number;
  /** @format int32 */
  totalSubscriptions: number;
}

export type ChannelSearchDtoIEquatable = object;

export interface ChannelSearchDtoPaginatedList {
  items: ChannelSearchDto[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type ChannelSearchDtoPaginatedListIRequest = object;

export interface ChannelSearchQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  searchText: string;
  orderBy: ChannelSearchOrderBy;
}

export interface ChannelSelectorQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  searchText: string | null;
  ignoreSelectionHistory: boolean;
}

export interface ChannelSelectorResponse {
  /** @format uuid */
  channelId: string;
  name: string;
  thumbnailUrl: string;
  isPrivate: boolean;
  fromHistory: boolean;
}

export type ChannelSelectorResponseIEquatable = object;

export interface ChannelSelectorResponsePaginatedList {
  items: ChannelSelectorResponse[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type ChannelSelectorResponsePaginatedListIRequest = object;

export interface ChannelSubscriptionRequestDto {
  /** @format uuid */
  userId: string;
  username: string;
  userThumbnailUrl: string;
  /** @format uuid */
  channelId: string;
  channelName: string;
  message: string;
}

export type ChannelSubscriptionRequestDtoIEquatable = object;

export interface ChannelSubscriptionRequestDtoPaginatedList {
  items: ChannelSubscriptionRequestDto[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type ChannelSubscriptionRequestDtoPaginatedListIRequest = object;

export interface ChannelSubscriptionResponse {
  /** @format uuid */
  channelId: string;
  name: string;
  thumbnailUrl: string | null;
  autoRegisterMode: ChannelAutoRegisterMode;
  isPrivate: boolean;
  directMember: boolean;
  indirectMember: boolean;
  pendingApproval: boolean;
  acceptSubscription: boolean;
  registered: boolean;
  hideQuickAccess: boolean | null;
  /** @format int32 */
  publicationCount: number;
  /** @format int32 */
  subscriptionCount: number;
}

export type ChannelSubscriptionResponseIEnumerableIRequest = object;

export type ChannelSubscriptionResponseIEquatable = object;

export interface ChannelSubscriptionsForApprovalQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  searchText: string | null;
  order: FeedModerationOrder;
}

export interface ChannelSubscriptionsQuery {
  /** @format int32 */
  takeRecords: number;
  searchText: string | null;
  filterBy: ChannelSubscriptionFilterBy;
}

export interface ChannelSubscriptionsSettingsQuery {
  /** @format uuid */
  channelId: string;
}

export interface ChannelSubscriptionsSettingsResponse {
  dismissApprovalWithPassword: boolean;
}

export type ChannelSubscriptionsSettingsResponseIEquatable = object;

export type ChannelSubscriptionsSettingsResponseIRequest = object;

export interface ChannelSuggestionsQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  searchText: string | null;
  freeSelection: boolean;
  onlyAutoRegister: boolean;
}

export interface ChannelUsersMembersSuggestionQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  channelId: string;
  searchText: string | null;
}

export interface CheckAliveCommand {
  ticks: string | null;
}

export interface CheckReuseECourseUnmanagedCommand {
  /** @format uuid */
  trainingId: string;
  /** @format uuid */
  masterEnrollmentId: string;
}

export interface CheckTrainingAgreementUsageQuery {
  /** @format uuid */
  agreementId: string;
}

export interface ChooseLandingpageCommand {
  landingPage: ChooseLandingPageOptions;
}

export interface ChooseLandingpageResponse {
  url: string;
}

export type ChooseLandingpageResponseIEquatable = object;

export type ChooseLandingpageResponseIRequest = object;

export interface ClassroomAudienceQuery {
  /** @format uuid */
  classroomId: string;
}

export interface ClassroomAudienceUsersQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  classroomId: string;
  searchText: string | null;
  needAll: boolean;
  groupIds: string[];
}

export interface ClassroomComponentsQuery {
  /** @format uuid */
  classroomId: string;
}

export interface ClassroomCourseRulesQuery {
  /** @format uuid */
  classroomId: string;
}

export interface ClassroomDiscussionListQuery {
  /** @format int64 */
  startSequenceNum: number | null;
  /** @format int32 */
  take: number;
  /** @format uuid */
  discussionId: string | null;
  /** @format uuid */
  parentId: string | null;
  orderBy: DiscussionListOrderBy;
  filter: DiscussionListFilter | null;
  /** @format uuid */
  enrollmentId: string | null;
  /** @format uuid */
  classroomId: string | null;
  /** @format date-time */
  lastView: Date;
}

export interface ClassroomECourseRulesQuery {
  /** @format uuid */
  classroomId: string;
}

export interface ClassroomInfoQuery {
  /** @format uuid */
  classroomId: string;
}

export interface ClassroomInstructorSuggestionsQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  trainingId: string;
  /** @format uuid */
  classroomId: string | null;
  searchText: string | null;
}

export interface ClassroomLearnPathRulesQuery {
  /** @format uuid */
  classroomId: string;
}

export interface ClassroomMeetingAttendanceQuery {
  /** @format uuid */
  classroomId: string;
  /** @format uuid */
  componentId: string;
  isQrCodeAttendance: boolean;
}

export interface ClassroomMeetingAttendanceResponse {
  meetingName: string;
  trainingName: string;
  className: string;
  multipleClasses: boolean;
  /** @format date-time */
  startDate: Date;
  /** @format date-time */
  endDate: Date;
  instructors: string[];
  assistants: string[];
  /** @format uuid */
  logoId: string | null;
  students: string[];
  /** @format date-time */
  qrCodeStartDate: Date;
  /** @format date-time */
  qrCodeEndDate: Date;
}

export type ClassroomMeetingAttendanceResponseIEquatable = object;

export type ClassroomMeetingAttendanceResponseIRequest = object;

export interface ClassroomRecordInfoDto {
  creator: RecordInfoActorDto;
  revisor: RecordInfoActorDto;
  deleter: RecordInfoActorDto | null;
  /** @format double */
  starRatingAvg: number;
  /** @format double */
  starRatingCount: number;
}

export type ClassroomRecordInfoDtoIEquatable = object;

export interface ClassroomScheduleActivityResponse {
  title: string;
  digitalDelivery: boolean;
  /** @format date-time */
  dueDate: Date | null;
  composeFinalScore: boolean;
}

export type ClassroomScheduleActivityResponseIEquatable = object;

export interface ClassroomScheduleMeetingResponse {
  meetingType: MeetingType;
  meetingTypeName: string;
  title: string;
  isMandatory: boolean;
  /** @format date-time */
  startDate: Date | null;
  /** @format date-time */
  endDate: Date | null;
  locationName: string | null;
  timezoneId: string;
  address: string | null;
  composeFinalScore: boolean;
}

export type ClassroomScheduleMeetingResponseIEquatable = object;

export interface ClassroomScheduleQuery {
  /** @format uuid */
  classroomId: string;
}

export interface ClassroomScheduleResponse {
  /** @format uuid */
  trainingId: string;
  trainingName: string;
  className: string;
  multipleClasses: boolean;
  /** @format date-time */
  enrollAvailableFrom: Date | null;
  /** @format date-time */
  enrollAvailableUntil: Date | null;
  /** @format date-time */
  realizationStartDate: Date | null;
  /** @format date-time */
  realizationDueDate: Date | null;
  /** @format int32 */
  realizationDueDays: number | null;
  meetings: ClassroomScheduleMeetingResponse[];
  activities: ClassroomScheduleActivityResponse[];
}

export type ClassroomScheduleResponseIEquatable = object;

export type ClassroomScheduleResponseIRequest = object;

export interface ClassroomSelectorDto {
  /** @format uuid */
  classroomId: string;
  name: string;
}

export type ClassroomSelectorDtoIEquatable = object;

export interface ClassroomSuggestionsQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  trainingId: string;
  searchText: string | null;
  onlyActive: boolean;
}

export interface ClassroomViewDto {
  /** @format uuid */
  classroomId: string;
  name: string;
  timezoneId: string;
  /** @format date-time */
  registrationEnrollAvailableFrom: Date | null;
  /** @format date-time */
  registrationEnrollAvailableUntil: Date | null;
  registrationOneClickEnroll: boolean;
  registrationCancellationOption: TrainingCancellationOption;
  /** @format date-time */
  registrationCancellationUntilDate: Date | null;
  /** @format int32 */
  registrationCancellationUntilDaysAfterEnroll: number | null;
  registrationPreApprovalByUserManagerOrApprover: boolean | null;
  /** @format date-time */
  executionStartDate: Date | null;
  executionDueDateOption: TrainingDueDateOption;
  /** @format date-time */
  executionDueDate: Date | null;
  /** @format int32 */
  executionDueDays: number | null;
  /** @format uuid */
  nextTrainingId: string | null;
  nextTrainingName: string | null;
  /** @format int32 */
  trainingDurationMinutes: number;
  trainingDurationFormated: string;
  generateCertificate: boolean;
  /** @format uuid */
  certificateFileId: string | null;
  certificateEnableTrainingValidity: boolean | null;
  /** @format int32 */
  certificateTrainingValidityMonthDay: number | null;
  /** @format int32 */
  certificateTrainingValidityDays: number | null;
  certificateComputeValidityDaysFromLastCertification: boolean | null;
  /** @format int32 */
  certificateRenovationWindowDays: number | null;
  ratingOption: TrainingRatingOption;
  shareOption: TrainingShareOption;
  enableLike: boolean;
  enableViewEnrolledUsers: boolean;
  isMandatory: boolean;
  fullManaged: boolean;
  /** @format int32 */
  awardEnrollPoints: number | null;
  /** @format int32 */
  awardApprovalPoints: number | null;
  /** @format double */
  ratingAvg: number;
  /** @format int32 */
  ratingStars: number;
  /** @format int32 */
  ratingCount: number;
  /** @format int32 */
  activeEnrollmentsCount: number;
  /** @format int32 */
  usersEnrolledCount: number;
  trainingPreReqs: any[] | null;
  trainingSeatsPassed: boolean | null;
  approvers: UserShortView[] | null;
  instructors: UserShortView[] | null;
}

export type ClassroomViewDtoIEnumerableIRequest = object;

export interface ClassroomViewQuery {
  /** @format uuid */
  trainingId: string;
  /** @format uuid */
  classroomId: string | null;
  /** @format uuid */
  masterEnrollmentId: string | null;
  availableOnly: boolean;
  ignoreChecks: boolean;
}

export interface ClearImportedUsersEnrollOperationCommand {
  /** @format uuid */
  trainingId: string;
  operation: ManageEnrollOperation;
}

export interface ClearImportedUsersOperationCommand {
  operation: UserOperationType;
}

export interface ClearItemsAssessmentCommand {
  /** @format uuid */
  assessmentId: string;
}

export interface ClearListItemsCommand {
  /** @format uuid */
  listPublicationId: string;
}

export interface ClearUsersEnrollOperationCommand {
  /** @format uuid */
  trainingId: string;
  operation: ManageEnrollOperation;
}

export interface ClearUsersOperationCommand {
  operation: UserOperationType;
}

export interface ClearWorkspaceNotificationsCommand {
  /** @format uuid */
  userId: string;
}

export interface CloneEvaluationCommand {
  /** @format uuid */
  assessmentId: string;
  name: string;
}

export interface CloneRoleCommand {
  /** @format uuid */
  roleId: string;
}

export interface CloneSurveyCommand {
  /** @format uuid */
  assessmentId: string;
  name: string;
}

export interface CloseEnrollmentCommand {
  /** @format uuid */
  enrollmentId: string;
  forced: boolean;
}

export interface CloseEnrollmentDto {
  success: boolean;
  approved: boolean | null;
  /** @format int32 */
  awardPoints: number | null;
  canReview: boolean | null;
}

export type CloseEnrollmentDtoIEquatable = object;

export type CloseEnrollmentDtoIRequest = object;

export interface CollaboratorsItem {
  /** @format uuid */
  memberId: string;
  memberType: MemberType;
}

export interface CommentLikeCommand {
  /** @format uuid */
  publicationId: string;
  /** @format uuid */
  commentId: string;
  like: boolean;
}

export type CommentLikeCommandIEquatable = object;

export interface CommentListQuery {
  /** @format int64 */
  startSequenceNum: number | null;
  /** @format int32 */
  take: number;
  /** @format uuid */
  discussionId: string | null;
  /** @format uuid */
  parentId: string | null;
  orderBy: DiscussionListOrderBy;
  filter: DiscussionListFilter | null;
  /** @format uuid */
  publicationId: string;
}

export interface CompetencysChartDTO {
  /** @format int32 */
  competencyID: number;
  competencyName: string;
  /** @format double */
  competencyPerc: number | null;
  competencyPercColor: string;
}

export interface ComponentWeightItem {
  /** @format uuid */
  componentId: string;
  /** @format int32 */
  weight: number | null;
  /** @format int32 */
  minGrade: number | null;
  /** @format int32 */
  maxGrade: number | null;
}

export type ComponentWeightItemIEquatable = object;

export interface ConclusionFormDto {
  settings: ConclusionFormSettingsDto;
  formData: ConclusionFormGetDto;
}

export type ConclusionFormDtoIEquatable = object;

export type ConclusionFormDtoIRequest = object;

export interface ConclusionFormGetDto {
  institutionOrProvider: string | null;
  /** @format date-time */
  startDate: Date | null;
  /** @format date-time */
  endDate: Date | null;
  /** @format int32 */
  durationHours: number | null;
  /** @format int32 */
  durationMinutes: number | null;
  /** @format double */
  finalScore: number | null;
  /** @format double */
  attendancePercent: number | null;
  /** @format double */
  pricePaid: number | null;
  remarks: string | null;
  approved: boolean | null;
  certificate: FileGetDto | null;
}

export type ConclusionFormGetDtoIEquatable = object;

export interface ConclusionFormSaveDto {
  institutionOrProvider: string | null;
  /** @format date-time */
  startDate: Date | null;
  /** @format date-time */
  endDate: Date | null;
  /** @format int32 */
  durationHours: number | null;
  /** @format int32 */
  durationMinutes: number | null;
  /** @format double */
  finalScore: number | null;
  /** @format double */
  attendencePercent: number | null;
  /** @format double */
  pricePaid: number | null;
  /** @format uuid */
  certificateFileId: string | null;
  remarks: string | null;
  approved: boolean | null;
}

export interface ConclusionFormSettingsDto {
  trainingName: string;
  fullManaged: boolean;
  institutionOrProviderOptions: string[] | null;
  institutionOrProvider: TrainingThreeStateInfo;
  coursePeriod: TrainingThreeStateInfo;
  courseDuration: TrainingThreeStateInfo;
  attendancePercent: TrainingThreeStateInfo;
  certificate: TrainingThreeStateInfo;
  finalScore: TrainingThreeStateInfo;
  finalScoreIsPercent: boolean | null;
  /** @format double */
  finalScoreMin: number | null;
  /** @format double */
  finalScoreMax: number | null;
  pricePaid: TrainingThreeStateInfo;
  approvalOption: TrainingExternalCourseApprovalOption;
  approver: UserShortView | null;
}

export type ConclusionFormSettingsDtoIEquatable = object;

export interface ContentMetadata {
  provider: string;
  title: string;
  type: string;
  url: string | null;
  siteName: string | null;
  description: string | null;
  /** @format int32 */
  width: number | null;
  /** @format int32 */
  height: number | null;
  /** @format int64 */
  duration: number | null;
  authorUrl: string | null;
  authorName: string | null;
  thumbnailUrl: string | null;
  /** @format int32 */
  thumbnailWidth: number | null;
  /** @format int32 */
  thumbnailHeight: number | null;
  embedHtml: string | null;
  externalId: string | null;
  /** @format date-time */
  creationDate: Date | null;
}

export interface ContentPostItemQuery {
  /** @format uuid */
  publicationId: string;
}

export interface ContextualSearchMetadata {
  keywordsExtracted: string[];
  searchMethod: string | null;
  /** @format int32 */
  totalTurns: number;
  conversationTopic: string | null;
  /** @format float */
  averageContextRelevance: number;
}

export interface CopyQuestionsToNewGroupCommand {
  /** @format uuid */
  questionGroupId: string;
  questionIds: string[];
}

export type CoreFilterCommandAdvFilterDtoIEquatable = object;

export interface CourseComponentWeightsQuery {
  /** @format uuid */
  trainingId: string;
  /** @format int32 */
  versionNumber: number;
}

export interface CourseComponentWeightsResponse {
  /** @format uuid */
  componentId: string;
  componentType: TrainingComponentType;
  name: string;
  /** @format int32 */
  weight: number | null;
  /** @format int32 */
  minGrade: number | null;
  /** @format int32 */
  maxGrade: number | null;
  composeFinalScore: boolean;
}

export type CourseComponentWeightsResponseIEquatable = object;

export type CourseComponentWeightsResponseListIRequest = object;

export interface CourseComponentsQuery {
  /** @format uuid */
  trainingId: string;
  /** @format int32 */
  versionNumber: number;
}

export interface CourseConclusionFormQuery {
  /** @format uuid */
  classroomId: string;
  /** @format uuid */
  enrollmentId: string | null;
}

export interface CourseEnrollmentViewQuery {
  /** @format uuid */
  enrollmentId: string;
}

export interface CourseLearnPathPropsDto {
  enableOnComponentsCompleted: AutoCompleteDataModelDto[];
}

export type CourseLearnPathPropsDtoIEquatable = object;

export interface CoursePropsDto {
  enableOption: CourseComponentEnableOption;
  /** @format int32 */
  daysAfterClassAvailability: number | null;
  computeProgress: boolean;
  enableOnComponentsCompleted: AutoCompleteDataModelDto[];
}

export type CoursePropsDtoIEquatable = object;

export type CoursePropsDtoIRequest = object;

export interface CoursePropsQuery {
  /** @format uuid */
  trainingId: string;
  /** @format int32 */
  versionNumber: number;
  /** @format uuid */
  componentId: string;
}

export interface CourseRulesDto {
  /** @format uuid */
  trainingId: string;
  trainingType: TrainingType;
  name: string;
  timezoneId: string;
  multipleClasses: boolean;
  hasActiveEnrollments: boolean;
  hasClosedEnrollments: boolean;
  /** @format date-time */
  createdOn: Date;
  allowRegistrationOverride: boolean;
  allowReservationsOverride: boolean;
  allowPreRequisitesOverride: boolean;
  allowExecutionOverride: boolean;
  allowAssessmentOverride: boolean;
  allowCerticateOverride: boolean;
  allowAgreementOverride: boolean;
  allowInteractionOverride: boolean;
  allowAwardOverride: boolean;
  agreement: TrainingRulesAgreementDto;
  assessment: TrainingRulesAssessmentDto;
  autoEnrollLimits: TrainingRulesAutoEnrollLimitsDto;
  award: TrainingRulesAwardDto;
  certificate: TrainingRulesCertificateDto;
  execution: TrainingRulesExecutionDto;
  interaction: TrainingRulesInteractionDto;
  registration: TrainingRulesRegistrationDto;
  seats: TrainingRulesSeatsDto;
  preRequisites: TrainingRulesPreRequisitesDto;
  allowApprovalRulesOverride: boolean;
  allowInstructorActionOverride: boolean;
  approvalRules: TrainingRulesApprovalRulesDto;
  instructor: TrainingRulesInstructorActionDto;
}

export type CourseRulesDtoIEquatable = object;

export type CourseRulesDtoIRequest = object;

export interface CourseRulesQuery {
  /** @format uuid */
  trainingId: string;
}

export interface CourseTrainingQuery {
  /** @format uuid */
  trainingId: string;
}

export interface CreateAbsenceTypeCommand {
  nameR: ResourceModel[];
}

export type CreateAbsenceTypeCommandIEquatable = object;

export interface CreateAccessAgreementCommand {
  assignRequired: boolean;
  text: string;
  /** @format uuid */
  fileId: string | null;
}

export interface CreateAccessTimeRuleCommand {
  name: string;
  description: string | null;
  constraintType: AccessTimeConstraintType;
  /** @format date-time */
  startedOn: Date;
  /** @format date-time */
  finishedOn: Date | null;
  weekDays: number[];
  allowAccessToCorporateIPS: boolean;
  /** @format uuid */
  denyAccessOnHolidaysCalendarId: string | null;
  denyAccessOnUserWorkplaceHolidaysCalendar: boolean;
  accessDeniedMessages: ResourceModel[];
  units: string[];
  groups: string[];
  exceptionGroups: string[];
  /**
   * @format time
   * @example ""13:45:42.0000000""
   */
  startTime: string;
  /**
   * @format time
   * @example ""13:45:42.0000000""
   */
  endTime: string;
}

export type CreateAccessTimeRuleCommandIEquatable = object;

export type CreateAllTrainingModelsCommand = object;

export interface CreateBatchPublicationCommand {
  /** @format uuid */
  zipFileId: string;
  /** @format uuid */
  channelId: string;
  topics: string[];
  advancedOptions: PublicationAdvancedItem;
  editJustification: string | null;
}

export interface CreateBlockReasonCommand {
  nameR: ResourceModel[];
  isTemporary: boolean;
}

export interface CreateChallengeInstanceCommand {
  /** @format uuid */
  assessmentId: string;
  challengeMode: ChallengeMode;
  preview: boolean;
}

export interface CreateClassroomDiscussionCommand {
  /** @format uuid */
  parentId: string | null;
  /** @format uuid */
  replyId: string | null;
  message: string;
  /** @format uuid */
  classroomId: string;
  discussionType: DiscussionType;
}

export type CreateClassroomDiscussionCommandIEquatable = object;

export interface CreateClassroomMaterialListCommand {
  /** @format uuid */
  classroomId: string;
  name: string;
}

export interface CreateCommentCommand {
  /** @format uuid */
  publicationId: string;
  /** @format uuid */
  parentId: string | null;
  /** @format uuid */
  replyId: string | null;
  message: string;
}

export type CreateCommentCommandIEquatable = object;

export interface CreateCustomFieldCommand {
  fieldId: string;
  fieldType: CustomFieldType;
  usage: CustomFieldUsages;
  usageSubType: string | null;
  labelR: ResourceModel[];
  placeholderTextR: ResourceModel[];
  validationErrorMessageR: ResourceModel[];
  defaultValue: string | null;
  isActive: boolean;
  isRequired: boolean;
  isUnique: boolean;
  isClaim: boolean;
  keepHistory: boolean;
  showConcealed: boolean;
  /** @format int32 */
  sequenceOrder: number;
  fillConstraint: CustomFieldFillConstraint;
  showWidth: CustomFieldWidth;
  isVisibleToSelfUser: boolean | null;
  isEditableToSelfUser: boolean | null;
  showOnUserProfile: boolean | null;
  isPersonalInformation: boolean | null;
  userDisplayArea: CustomFieldUserDisplayArea | null;
  canBeUsedOnEmailTemplates: boolean;
  canBeUsedInFilters: boolean;
  textField: TextFieldDto | null;
  numericField: NumericFieldDto | null;
  valueSelectionField: ValueSelectionFieldDto | null;
  objectSelectionField: ObjectSelectionFieldDto | null;
}

export interface CreateDevPlanDiscussionCommand {
  /** @format uuid */
  parentId: string | null;
  /** @format uuid */
  replyId: string | null;
  message: string;
  /** @format uuid */
  devPlanId: string;
  discussionType: DiscussionType;
}

export type CreateDevPlanDiscussionCommandIEquatable = object;

export type CreateDiscussionDtoIEquatable = object;

export interface CreateDynamicGroupCommand {
  usages: GroupUsages | null;
  name: string;
  description: string | null;
  /** @format uuid */
  thumbnailId: string | null;
  /** @format uuid */
  unitId: string;
  active: boolean;
  /** @format int32 */
  priority: number;
  spec: GroupDynamicSpec;
  pauseProcessing: boolean;
  tags: string[];
}

export interface CreateEnrollCommand {
  /** @format uuid */
  trainingId: string;
  /** @format uuid */
  classroomId: string | null;
  /** @format uuid */
  masterEnrollmentId: string | null;
  /** @format uuid */
  userId: string;
  messageToApprover: string | null;
}

export interface CreateEnrollResults {
  /** @format uuid */
  enrollmentId: string;
  enrollStatus: EnrollStatus;
  reused: boolean;
}

export type CreateEnrollResultsIEquatable = object;

export type CreateEnrollResultsIRequest = object;

export interface CreateEvalInstanceCommand {
  /** @format uuid */
  assessmentId: string;
  preview: boolean;
  /** @format int32 */
  minFinalScore: number | null;
  /** @format uuid */
  enrollmentId: string | null;
  /** @format uuid */
  componentId: string | null;
  /** @format uuid */
  deployId: string | null;
  /** @format uuid */
  deployParticipantId: string | null;
}

export interface CreateEvaluationAIQuestionCommand {
  questions: QuestionOpenAIDto[];
  evaluation: SaveQuestionEvaluationDto | null;
  survey: SaveQuestionSurveyDto | null;
  tags: string[];
  /** @format uuid */
  trainingId: string;
  /** @format int32 */
  versionNumber: number;
  /** @format uuid */
  publicationId: string;
}

export interface CreateExclusiveScormCourseCommand {
  /** @format uuid */
  trainingId: string;
  /** @format int32 */
  versionNumber: number;
  /** @format uuid */
  fileId: string;
  organizationIdentifier: string;
  organizationTitle: string;
}

export interface CreateExemptEnrollCommand {
  /** @format uuid */
  trainingId: string;
  /** @format uuid */
  userId: string;
}

export interface CreateExpressClassroomCommand {
  /** @format uuid */
  trainingId: string;
  name: string;
  /** @format date-time */
  dueDate: Date | null;
}

export interface CreateHolidayCommand {
  /** @format uuid */
  calendarId: string;
  /** @format date */
  day: Date;
  name: string;
  periodOfDay: HolidayPeriodOfDay;
}

export interface CreateLearnPathTrainingComponentCommand {
  /** @format uuid */
  trainingId: string;
  /** @format int32 */
  versionNumber: number;
  /** @format uuid */
  trainingItemId: string;
}

export interface CreateMeetingRoomCommand {
  name: string;
  address1: string;
  address2: string | null;
  city: string;
  state: string;
  zipCode: string;
  timezoneId: string;
  isActive: boolean;
}

export interface CreateNewTrainingVersionCommand {
  /** @format uuid */
  trainingId: string;
}

export interface CreateOrUpdateActivityComponentCommand {
  /** @format uuid */
  publicationId: string;
  content: string | null;
  contentUnformatted: string | null;
  /** @format uuid */
  threadId: string | null;
  /** @format uuid */
  publisherId?: string | null;
  title: string;
  attachs: PublicationAttachFileItem[];
  presentation: PublicationPresentationItem | null;
  /** @format date-time */
  dueDate: Date | null;
  /** @format int32 */
  maxFileSize: number | null;
  digitalDelivery: boolean;
  hasCheckList: boolean;
  assignScoreByCheckList: boolean;
  checkList: ActivityCheckListItem[];
  /** @format uuid */
  trainingId: string;
  /** @format int32 */
  versionNumber: number;
  /** @format uuid */
  replaceComponentId: string | null;
}

export interface CreateOrUpdateActivityExclusiveTrainingCommand {
  /** @format uuid */
  publicationId: string;
  content: string | null;
  contentUnformatted: string | null;
  /** @format uuid */
  threadId: string | null;
  /** @format uuid */
  publisherId?: string | null;
  title: string;
  attachs: PublicationAttachFileItem[];
  presentation: PublicationPresentationItem | null;
  /** @format date-time */
  dueDate: Date | null;
  /** @format int32 */
  maxFileSize: number | null;
  digitalDelivery: boolean;
  hasCheckList: boolean;
  assignScoreByCheckList: boolean;
  checkList: ActivityCheckListItem[];
  /** @format uuid */
  trainingId: string;
  /** @format int32 */
  versionNumber: number;
  /** @format uuid */
  replaceComponentId: string | null;
}

export interface CreateOrUpdateAnswerCommand {
  /** @format uuid */
  publicationId: string;
  content: string | null;
  contentUnformatted: string | null;
  /** @format uuid */
  threadId: string | null;
  /** @format uuid */
  publisherId?: string | null;
  /** @format uuid */
  questionId: string;
  isAnonymous: boolean;
  attachs: PublicationAttachFileItem[];
  presentation: PublicationPresentationItem | null;
}

export interface CreateOrUpdateAppointmentCommand {
  /** @format uuid */
  appointmentId: string | null;
  /** @format uuid */
  instructorId: string;
  subject: string;
  /** @format date-time */
  startDate: Date;
  /** @format date-time */
  endDate: Date;
  timeZoneId: string;
}

export interface CreateOrUpdateAppointmentResult {
  success: boolean;
  /** @format uuid */
  appointmentId: string | null;
  hasConflict: boolean;
}

export type CreateOrUpdateAppointmentResultIEquatable = object;

export type CreateOrUpdateAppointmentResultIRequest = object;

export interface CreateOrUpdateAssDeployCommand {
  /** @format uuid */
  deployId: string | null;
  /** @format uuid */
  assessmentId: string;
  groups: GroupInfo[];
  name: string;
  timezoneId: string;
  /** @format date-time */
  startDate: Date;
  /** @format date-time */
  endDate: Date;
  sticker: SelectedStickerDto | null;
}

export type CreateOrUpdateAssDeployCommandIEquatable = object;

export interface CreateOrUpdateAwardRankingCommand {
  /** @format uuid */
  rankingId: string | null;
  nameR: ResourceModel[];
  /** @format uuid */
  unitTypeId: string;
  participants: AwardParticipantsType;
  /** @format uuid */
  unitId: string | null;
  showUserNames: boolean;
  isDefault: boolean;
}

export interface CreateOrUpdateBadgeCommand {
  /** @format uuid */
  badgeId: string | null;
  nameR: ResourceModel[];
  descriptionBeforeWinR: ResourceModel[];
  descriptionAfterWinR: ResourceModel[];
  /** @format int32 */
  grantPoints: number;
  /** @format date-time */
  startDate: Date | null;
  /** @format date-time */
  endDate: Date | null;
  timezoneId: string;
  isActive: boolean;
  /** @format uuid */
  thumbnailId: string | null;
  action: BadgeRuleAction;
  period: BadgeRulePeriod | null;
  /** @format int32 */
  minActions: number | null;
  actionLimit: BadgeRuleActionLimits | null;
  onlyOnce: boolean | null;
  maxUsersPerPeriod: boolean | null;
  /** @format int32 */
  awardMaxTopRanking: number | null;
  /** @format uuid */
  channelId: string | null;
  /** @format uuid */
  topicId: string | null;
  topicIncludeDescendants: boolean | null;
  stickers: string[];
  trainings: string[];
  audiencesNeedAll: boolean;
  groups: string[];
}

export interface CreateOrUpdateBannerCommand {
  /** @format uuid */
  bannerId: string | null;
  name: string | null;
  userContainsAllGroups: boolean;
  headline: ResourceModel[];
  useOwnSticker: boolean;
  contentType: BannerContentType;
  title: ResourceModel[];
  subtitle: ResourceModel[];
  /** @format uuid */
  storageFileId: string | null;
  useContentImage: boolean;
  /** @format int32 */
  priority: number;
  /** @format date-time */
  startDate: Date | null;
  /** @format date-time */
  endDate: Date | null;
  timeZoneId: string | null;
  audienceList: string[];
  useTitleSticker: boolean;
  useSubTitleSticker: boolean;
  /** @format uuid */
  stickerId: string | null;
  /** @format uuid */
  publicationId: string | null;
  /** @format uuid */
  trainingId: string | null;
  /** @format uuid */
  assDeployId: string | null;
  /** @format uuid */
  topicId: string | null;
  topicGoTo: BannerTopicGoToType | null;
  systemFeature: SystemFeature | null;
  linkUrl: string | null;
  openLinkOnNewBrowserTab: boolean | null;
  panoramicOption: BannerPanoramicOption | null;
}

export interface CreateOrUpdateBinderCommand {
  /** @format uuid */
  publicationId: string;
  content: string | null;
  contentUnformatted: string | null;
  /** @format uuid */
  threadId: string | null;
  /** @format uuid */
  publisherId?: string | null;
  title: string;
  /** @format uuid */
  channelId: string;
  topics: string[];
  isDraft: boolean;
  editJustification: string | null;
  advancedOptions: PublicationAdvancedItem;
  attachs: PublicationAttachFileItem[];
  presentation: PublicationPresentationItem | null;
}

export interface CreateOrUpdateChannelCommand {
  /** @format uuid */
  channelId: string | null;
  name: string;
  description: string | null;
  /** @format uuid */
  thumbnailId: string | null;
  /** @format uuid */
  moderatorId: string;
  preferModerationByManager: boolean;
  approvalMode: ChannelApprovalMode;
  enableVideoModeration: boolean;
  isPrivate: boolean;
  denyExternalUsers: boolean;
  autoRegisterMode: ChannelAutoRegisterMode;
  dismissApprovalForUnits: boolean;
  dismissApprovalWithPassword: string | null;
  allowInvite: boolean;
  autoRegisterRole: ChannelRoles;
  allowNonMemberComments: boolean;
  requirePublicationEditJustification: boolean;
  allowSupervisorEdit: boolean;
  enableIaQuestionAnswering: boolean;
  containsConfidentialInfo: boolean;
  useCustomQuickFilter: boolean;
  topicsSuggested: string[];
  unitsDismissedGroupIds: string[];
}

export interface CreateOrUpdateClassroomCommand {
  /** @format uuid */
  trainingId: string;
  /** @format uuid */
  classroomId: string;
  name: string;
  instructors: string[] | null;
  owners: string[];
  timezoneId: string;
  externalCode: string | null;
  isActive: boolean;
  customFields: FieldValueItem[] | null;
}

export interface CreateOrUpdateCourseTrainingCommand {
  /** @format uuid */
  trainingId: string;
  name: string;
  description: string | null;
  objectives: string | null;
  author: string | null;
  externalCode: string | null;
  /** @format uuid */
  thumbnailId: string | null;
  /** @format uuid */
  promotionVideoId: string | null;
  isActive: boolean;
  language: string | null;
  /** @format int32 */
  trainingDurationHours: number | null;
  /** @format int32 */
  trainingDurationMinutes: number | null;
  timezoneId: string;
  /** @format uuid */
  stickerId: string | null;
  /** @format date-time */
  viewStickerUntil: Date | null;
  indexAndUseTagsInGlobalSearch: boolean;
  availableOnMobile: boolean;
  topics: string[];
  tags: string[];
  owners: string[];
  equivalents: string[] | null;
  specialists: string[] | null;
  coordinators: string[] | null;
  seeAlsoTrainings: string[] | null;
  customFields: FieldValueItem[] | null;
  multipleClasses: boolean;
  multipleClassesPrefix: string | null;
  instructors: string[];
  equivalentsNeedAll: boolean;
  equivalentCreateReverse: boolean;
}

export interface CreateOrUpdateDevPlanCommand {
  /** @format uuid */
  devPlanId: string | null;
  /** @format uuid */
  userId: string;
  name: string;
  description: string | null;
  /** @format date-time */
  availableStarting: Date | null;
  /** @format date-time */
  completionDeadline: Date | null;
  /** @format date-time */
  archivingDeadline: Date | null;
  /** @format uuid */
  attachId: string | null;
}

export interface CreateOrUpdateDevPlanGroupCommand {
  /** @format uuid */
  devPlanId: string;
  /** @format uuid */
  devPlanGroupId: string | null;
  name: string;
  description: string | null;
  /** @format uuid */
  topicId: string | null;
}

export interface CreateOrUpdateEvaluationComponentCommand {
  /** @format uuid */
  trainingId: string;
  /** @format int32 */
  versionNumber: number;
  /** @format uuid */
  replacementComponentId: string | null;
  evaluation: SaveEvaluationDto;
  addFinalScore: boolean;
}

export interface CreateOrUpdateEvaluationExclusiveTrainingCommand {
  /** @format uuid */
  trainingId: string;
  /** @format int32 */
  versionNumber: number;
  /** @format uuid */
  replacementComponentId: string | null;
  evaluation: SaveEvaluationDto;
  addFinalScore: boolean;
}

export interface CreateOrUpdateExternalCourseTrainingCommand {
  /** @format uuid */
  trainingId: string;
  name: string;
  description: string | null;
  objectives: string | null;
  author: string | null;
  externalCode: string | null;
  /** @format uuid */
  thumbnailId: string | null;
  /** @format uuid */
  promotionVideoId: string | null;
  isActive: boolean;
  language: string | null;
  /** @format int32 */
  trainingDurationHours: number | null;
  /** @format int32 */
  trainingDurationMinutes: number | null;
  timezoneId: string;
  /** @format uuid */
  stickerId: string | null;
  /** @format date-time */
  viewStickerUntil: Date | null;
  indexAndUseTagsInGlobalSearch: boolean;
  availableOnMobile: boolean;
  topics: string[];
  tags: string[];
  owners: string[];
  equivalents: string[] | null;
  specialists: string[] | null;
  coordinators: string[] | null;
  seeAlsoTrainings: string[] | null;
  customFields: FieldValueItem[] | null;
  manageEnroll: boolean;
  multipleClasses: boolean;
  multipleClassesPrefix: string | null;
  equivalentsNeedAll: boolean;
  equivalentCreateReverse: boolean;
}

export interface CreateOrUpdateLearnPathTrainingCommand {
  /** @format uuid */
  trainingId: string;
  name: string;
  description: string | null;
  objectives: string | null;
  author: string | null;
  externalCode: string | null;
  /** @format uuid */
  thumbnailId: string | null;
  /** @format uuid */
  promotionVideoId: string | null;
  isActive: boolean;
  language: string | null;
  /** @format int32 */
  trainingDurationHours: number | null;
  /** @format int32 */
  trainingDurationMinutes: number | null;
  timezoneId: string;
  /** @format uuid */
  stickerId: string | null;
  /** @format date-time */
  viewStickerUntil: Date | null;
  indexAndUseTagsInGlobalSearch: boolean;
  availableOnMobile: boolean;
  topics: string[];
  tags: string[];
  owners: string[];
  equivalents: string[] | null;
  specialists: string[] | null;
  coordinators: string[] | null;
  seeAlsoTrainings: string[] | null;
  customFields: FieldValueItem[] | null;
  progressByCredits: boolean;
  gamified: boolean;
}

export interface CreateOrUpdateListCommand {
  /** @format uuid */
  publicationId: string;
  content: string | null;
  contentUnformatted: string | null;
  /** @format uuid */
  threadId: string | null;
  /** @format uuid */
  publisherId?: string | null;
  isPublicList: boolean;
  title: string;
  /** @format uuid */
  channelId: string | null;
  topics: string[];
  isPrivate: boolean;
  allowCollaboration: boolean;
  /** @format uuid */
  thumbnailId: string | null;
  openInPlayback: boolean;
  collaborators: CollaboratorsItem[] | null;
  advancedOptions: PublicationAdvancedItem;
}

export interface CreateOrUpdateLpGameAwardRankingCommand {
  /** @format uuid */
  trainingId: string;
  /** @format uuid */
  learnPathGameRankingId: string;
  /** @format int32 */
  rankPosition: number;
  /** @format int32 */
  points: number;
}

export interface CreateOrUpdateLpGameRankingCommand {
  /** @format uuid */
  trainingId: string;
  /** @format uuid */
  learnPathGameRakingId: string | null;
  name: string;
  /** @format uuid */
  unitTypeId: string;
  /** @format uuid */
  unitId: string | null;
  showUserNames: boolean;
  isDefault: boolean;
}

export interface CreateOrUpdateLpGameScoreCommand {
  /** @format uuid */
  trainingId: string;
  /** @format uuid */
  componentId: string;
  option: LearnPathGameScoreOverrideOption;
  /** @format float */
  optionValue: number;
}

export interface CreateOrUpdateManagerTypeCommand {
  /** @format uuid */
  managerTypeId: string | null;
  nameR: ResourceModel[];
}

export interface CreateOrUpdateMaterialListPostCommand {
  /** @format uuid */
  publicationId: string;
  content: string | null;
  contentUnformatted: string | null;
  /** @format uuid */
  threadId: string | null;
  /** @format uuid */
  publisherId?: string | null;
  title: string;
  attachs: PublicationAttachFileItem[];
  presentation: PublicationPresentationItem | null;
  /** @format uuid */
  originId: string | null;
  /** @format uuid */
  materialListId: string;
}

export interface CreateOrUpdateMeetingComponentCommand {
  description: string | null;
  assignPresenceAfterViewRecording: boolean;
  hasScore: boolean;
  /** @format int32 */
  minPermanence: number | null;
  meetingType: MeetingType;
  /** @format uuid */
  roomId: string | null;
  locationName: string | null;
  address: AddressModel | null;
  timezoneId: string | null;
  /** @format date-time */
  startDate: Date | null;
  /** @format date-time */
  endDate: Date | null;
  externalUrl: string | null;
  instructors: string[] | null;
  assistants: string[] | null;
  /** @format timespan */
  bookAdditionalTimeBefore: string | null;
  /** @format timespan */
  bookAdditionalTimeAfter: string | null;
  /** @format uuid */
  meetingId: string;
  name: string;
  /** @format uuid */
  thumbnailId: string | null;
  /** @format uuid */
  trainingId: string;
  /** @format int32 */
  versionNumber: number;
  /** @format uuid */
  replaceComponentId: string | null;
}

export interface CreateOrUpdateMeetingExclusiveTrainingCommand {
  description: string | null;
  assignPresenceAfterViewRecording: boolean;
  hasScore: boolean;
  /** @format int32 */
  minPermanence: number | null;
  meetingType: MeetingType;
  /** @format uuid */
  roomId: string | null;
  locationName: string | null;
  address: AddressModel | null;
  timezoneId: string | null;
  /** @format date-time */
  startDate: Date | null;
  /** @format date-time */
  endDate: Date | null;
  externalUrl: string | null;
  instructors: string[] | null;
  assistants: string[] | null;
  /** @format timespan */
  bookAdditionalTimeBefore: string | null;
  /** @format timespan */
  bookAdditionalTimeAfter: string | null;
  /** @format uuid */
  meetingId: string;
  name: string;
  /** @format uuid */
  thumbnailId: string | null;
  /** @format uuid */
  trainingId: string;
  /** @format int32 */
  versionNumber: number;
  /** @format uuid */
  replaceComponentId: string | null;
}

export interface CreateOrUpdateModuleComponentCommand {
  /** @format uuid */
  trainingId: string;
  /** @format int32 */
  versionNumber: number;
  /** @format uuid */
  componentId: string | null;
  name: string;
}

export interface CreateOrUpdateNoticeCommand {
  /** @format uuid */
  publicationId: string;
  content: string | null;
  contentUnformatted: string | null;
  /** @format uuid */
  threadId: string | null;
  /** @format uuid */
  publisherId?: string | null;
  title: string;
  attachs: PublicationAttachFileItem[];
  presentation: PublicationPresentationItem | null;
  /** @format date-time */
  availableFrom: Date | null;
  /** @format date-time */
  availableTo: Date | null;
  /** @format uuid */
  classroomId: string;
}

export interface CreateOrUpdatePhaseComponentCommand {
  /** @format uuid */
  trainingId: string;
  /** @format int32 */
  versionNumber: number;
  /** @format uuid */
  componentId: string | null;
  name: string;
  phaseProps: LearnPathPhaseProps;
  /** @format uuid */
  replaceComponentId: string | null;
}

export type CreateOrUpdatePhaseComponentCommandIEquatable = object;

export interface CreateOrUpdatePhaseLearnPathCommand {
  /** @format uuid */
  trainingId: string;
  /** @format int32 */
  versionNumber: number;
  /** @format uuid */
  componentId: string | null;
  course: SaveCoursePhasePropsDto;
  phase: SavePhasePropsDto;
}

export interface CreateOrUpdatePollCommand {
  /** @format uuid */
  publicationId: string;
  content: string | null;
  contentUnformatted: string | null;
  /** @format uuid */
  threadId: string | null;
  /** @format uuid */
  publisherId?: string | null;
  title: string;
  /** @format uuid */
  channelId: string;
  topics: string[];
  isPrivate: boolean;
  anonymousAnswers: boolean;
  answers: PollItemModel[];
  /** @format date-time */
  allowAnswersUntil: Date | null;
  advancedOptions: PublicationAdvancedItem;
}

export interface CreateOrUpdatePollThreadCommand {
  /** @format uuid */
  publicationId: string;
  content: string | null;
  contentUnformatted: string | null;
  /** @format uuid */
  threadId: string;
  /** @format uuid */
  publisherId?: string | null;
  title: string;
  anonymousAnswers: boolean;
  answers: PollItemModel[];
  /** @format date-time */
  allowAnswersUntil: Date | null;
}

export interface CreateOrUpdatePostCommand {
  /** @format uuid */
  publicationId: string;
  content: string | null;
  contentUnformatted: string | null;
  /** @format uuid */
  threadId: string | null;
  /** @format uuid */
  publisherId?: string | null;
  title: string;
  /** @format uuid */
  channelId: string;
  topics: string[];
  isDraft: boolean;
  editJustification: string | null;
  advancedOptions: PublicationAdvancedItem;
  attachs: PublicationAttachFileItem[];
  presentation: PublicationPresentationItem | null;
}

export interface CreateOrUpdatePostComponentCommand {
  /** @format uuid */
  publicationId: string;
  content: string | null;
  contentUnformatted: string | null;
  /** @format uuid */
  threadId: string | null;
  /** @format uuid */
  publisherId?: string | null;
  title: string;
  attachs: PublicationAttachFileItem[];
  presentation: PublicationPresentationItem | null;
  /** @format uuid */
  originId: string | null;
  /** @format uuid */
  trainingId: string;
  /** @format int32 */
  versionNumber: number;
  /** @format uuid */
  replaceComponentId: string | null;
}

export interface CreateOrUpdatePostExclusiveTrainingCommand {
  /** @format uuid */
  publicationId: string;
  content: string | null;
  contentUnformatted: string | null;
  /** @format uuid */
  threadId: string | null;
  /** @format uuid */
  publisherId?: string | null;
  title: string;
  attachs: PublicationAttachFileItem[];
  presentation: PublicationPresentationItem | null;
  /** @format uuid */
  originId: string | null;
  /** @format uuid */
  trainingId: string;
  /** @format int32 */
  versionNumber: number;
  /** @format uuid */
  replaceComponentId: string | null;
}

export interface CreateOrUpdatePostListExclusiveCommand {
  /** @format uuid */
  publicationId: string;
  content: string | null;
  contentUnformatted: string | null;
  /** @format uuid */
  threadId: string | null;
  /** @format uuid */
  publisherId?: string | null;
  title: string;
  /** @format uuid */
  listExclusiveId: string;
  attachs: PublicationAttachFileItem[];
  presentation: PublicationPresentationItem | null;
  editJustification: string | null;
}

export interface CreateOrUpdatePostThreadCommand {
  /** @format uuid */
  publicationId: string;
  content: string | null;
  contentUnformatted: string | null;
  /** @format uuid */
  threadId: string;
  /** @format uuid */
  publisherId?: string | null;
  title: string;
  isDraft: boolean;
  attachs: PublicationAttachFileItem[];
  presentation: PublicationPresentationItem | null;
}

export interface CreateOrUpdateQuestionCommand {
  /** @format uuid */
  publicationId: string;
  content: string | null;
  contentUnformatted: string | null;
  /** @format uuid */
  threadId: string | null;
  /** @format uuid */
  publisherId?: string | null;
  title: string;
  /** @format uuid */
  channelId: string;
  topics: string[];
  isPrivate: boolean;
  isAnonymous: boolean;
  attachs: PublicationAttachFileItem[];
  presentation: PublicationPresentationItem | null;
  /** @format uuid */
  responderId: string | null;
  advancedOptions: PublicationAdvancedItem;
}

export interface CreateOrUpdateReportCommand {
  /** @format uuid */
  reportId: string;
  name: string;
  /** @format uuid */
  reportGroupId: string;
  isActive: boolean;
  sqlExpression: string;
  orderByValues: KeyLabelModel[];
  parameters: ReportParamDto[];
}

export type CreateOrUpdateReportCommandIEquatable = object;

export interface CreateOrUpdateReportScheduleCommand {
  /** @format uuid */
  reportId: string;
  /** @format uuid */
  reportScheduleId: string | null;
  name: string;
  /**
   * @format time
   * @example ""13:45:42.0000000""
   */
  runAt: string;
  /** @format int32 */
  dayOfMonth: number | null;
  daysOfWeek: DayOfWeek[] | null;
  recipients: string[];
  reportParams: ReportParamStore[];
  orderBy: string;
}

export interface CreateOrUpdateScoModulesCommand {
  /** @format uuid */
  trainingId: string;
  /** @format int32 */
  versionNumber: number;
  /** @format uuid */
  fileId: string;
  organizationIdentifier: string;
  action: ScoModuleAction;
}

export interface CreateOrUpdateScormPlayerSettingsCommand {
  /** @format uuid */
  trainingId: string;
  /** @format int32 */
  versionNumber: number;
  windowOption: TrainingScormPlayerWindowOption;
  /** @format int32 */
  windowWidth: number | null;
  /** @format int32 */
  windowHeight: number | null;
  enableScoDataLog: boolean;
}

export interface CreateOrUpdateShortVideoCommand {
  /** @format uuid */
  shortVideoId: string;
  /** @format uuid */
  attachId: string;
  settings: ShortVideoSettingsDto;
}

export interface CreateOrUpdateTrainingAgreementCommand {
  /** @format uuid */
  agreementId: string;
  name: string;
  text: string;
}

export interface CreateOtherActivityCommand {
  /** @format uuid */
  publicationId: string;
  content: string | null;
  contentUnformatted: string | null;
  /** @format uuid */
  threadId: string | null;
  /** @format uuid */
  publisherId?: string | null;
  title: string;
  attachs: PublicationAttachFileItem[];
  presentation: PublicationPresentationItem | null;
  /** @format uuid */
  devPlanGroupId: string;
}

export interface CreatePostComponentFromPublicationCommand {
  /** @format uuid */
  trainingId: string;
  /** @format int32 */
  versionNumber: number;
  /** @format uuid */
  publicationId: string;
}

export interface CreatePostExclusiveTrainingFromPublicationCommand {
  /** @format uuid */
  trainingId: string;
  /** @format int32 */
  versionNumber: number;
  /** @format uuid */
  publicationId: string;
}

export interface CreatePrivateListCommand {
  title: string;
  /** @format uuid */
  itemId: string;
}

export interface CreatePublicationActivityCommand {
  /** @format uuid */
  devPlanGroupId: string;
  /** @format uuid */
  publicationId: string;
}

export interface CreateQuestionGroupCommand {
  name: string;
  /** @format uuid */
  parentGroupId: string | null;
  forSurvey: boolean;
  /** @format int32 */
  defaultPoints: number;
  defaultAllowInKnowledgeTests: boolean;
}

export interface CreateQuickFilterCommand {
  scope: KnowledgeQuickFilterScope;
  /** @format uuid */
  scopeRef: string | null;
  filterType: KnowledgeQuickFilterType;
  /** @format uuid */
  itemId: string;
  /** @format date-time */
  dueDate: Date | null;
  nameR: ResourceModel[] | null;
}

export interface CreateRoleCommand {
  nameR: ResourceModel[];
  descriptionR: ResourceModel[];
  isFreelyAssignable: boolean;
  externalCode: string | null;
  assignmentDependencyRoleIds: string[];
  defaultConstraints: PermissionConstraintModel;
  permissions: SecurityRolePermissionItem[];
}

export interface CreateStandardAccountCommand {
  name: string;
  displayName: string;
  email: string | null;
  workplaceText: string | null;
  /** @format uuid */
  workplaceId: string | null;
  password: string;
  customFields: FieldValueItem[] | null;
  preferredLocale: string | null;
  messageToApprover: string | null;
}

export type CreateStandardAccountCommandIEquatable = object;

export type CreateStandardAccountRequestIEquatable = object;

export interface CreateStandardAccountResponse {
  /** @format uuid */
  userId: string;
  confirmationRequired: boolean;
}

export type CreateStandardAccountResponseIEquatable = object;

export type CreateStandardAccountResponseIRequest = object;

export interface CreateStaticGroupCommand {
  usages: GroupUsages | null;
  name: string;
  description: string | null;
  /** @format uuid */
  thumbnailId: string | null;
  /** @format uuid */
  unitId: string;
  active: boolean;
  tags: string[];
}

export interface CreateStickerCommand {
  applyTo: StickerAppliesTo;
  nameR: ResourceModel[];
  color: string;
  priority: StickerPriority;
  restrictedUse: boolean;
  requiredDeadline: boolean;
}

export type CreateStickerCommandIEquatable = object;

export interface CreateSurvInstanceCommand {
  /** @format uuid */
  assessmentId: string;
  preview: boolean;
  /** @format uuid */
  deployId: string | null;
  /** @format uuid */
  deployParticipantId: string | null;
}

export interface CreateTagCommand {
  name: string;
  usage: TagUsage;
  restriction: TagRestriction;
}

export interface CreateTokenAccessCommand {
  /** @format uuid */
  userId: string;
}

export type CreateTokenAccessCommandIEquatable = object;

export interface CreateTokenAccessResponse {
  token: string;
  alternateToken: string;
  /** @format date-time */
  expiresAt: Date;
}

export type CreateTokenAccessResponseIEquatable = object;

export type CreateTokenAccessResponseIRequest = object;

export interface CreateTopicCommand {
  category: TopicCategory;
  /** @format uuid */
  parentId: string | null;
  nameR: ResourceModel[];
  descriptionR: ResourceModel[];
  akaNames: string[] | null;
  /** @format uuid */
  thumbnailId: string | null;
  isActive: boolean;
  allowUserAutoInterest: boolean;
  isAvailableForExternalUsers: boolean;
  tags: string[] | null;
}

export interface CreateTrainingActivityCommand {
  /** @format uuid */
  devPlanGroupId: string;
  /** @format uuid */
  trainingId: string;
  ignoreApprovedEnrollment: boolean;
}

export interface CreateTrainingMaterialListCommand {
  /** @format uuid */
  trainingId: string;
  name: string;
}

export interface CreateUnitCommand {
  /** @format uuid */
  unitTypeId: string | null;
  /** @format uuid */
  parentId: string;
  nameR: ResourceModel[];
  description: string | null;
  /** @format uuid */
  defaultUserWorkplaceId: string | null;
  defaultUserWorkplace: string | null;
  defaultUserLocale: string | null;
  externalCode: string | null;
  allowAssociates: boolean;
  tags: string[];
  customFields: FieldValueItem[] | null;
}

export type CreateUnitCommandIEquatable = object;

export interface CreateUnitTypeCommand {
  nameR: ResourceModel[];
  branchNameR: ResourceModel[];
  externalCode: string;
  isRequired: boolean;
  allowMultiSelection: boolean;
  showOnUserProfile: boolean;
  defineJobsAndPositions: boolean;
  /** @format uuid */
  thumbnailId: string | null;
}

export type CreateUnitTypeCommandIEquatable = object;

export interface CreateUserCommand {
  name: string;
  displayName: string;
  email: string | null;
  preferredLocale: string | null;
  /** @format uuid */
  thumbnailId: string | null;
  /** @format uuid */
  workplaceId: string | null;
  workplaceText: string | null;
  /** @format uuid */
  blockReasonId: string | null;
  /** @format date-time */
  unblockAt: Date | null;
  /** @format uuid */
  managerId: string | null;
  /** @format uuid */
  approverId: string | null;
  /** @format date-time */
  accessExpiresOn: Date | null;
  /** @format date */
  admissionDate: Date | null;
  /** @format date */
  dismissedDate: Date | null;
  /** @format date */
  birthDate: Date | null;
  allowUserConnections: boolean;
  receiveDailySummaryEmail: boolean;
  userType: UserType;
  units: string[];
  customFields: FieldValueItem[] | null;
  secondaryManagers: UserSecondaryManagerItem[] | null;
  phones: UserPhoneItem[] | null;
  socialNetworks: UserSocialNetworkItem[] | null;
  tags: string[] | null;
  generatePassword: boolean;
  password: string | null;
}

export interface CreateWorkplaceCommand {
  name: string;
}

export type CustomFieldEntityIRequest = object;

export interface CustomFieldFillConstraintSelectorResponse {
  fillConstraint: CustomFieldFillConstraint;
  name: string;
}

export type CustomFieldFillConstraintSelectorResponseIEquatable = object;

export interface CustomFieldFilter {
  fieldId: string;
  type: CustomFieldType;
  searchValueRule: SearchValueRule | null;
  searchTextRule: SearchTextRule | null;
  value: string;
}

export type CustomFieldFilterIEquatable = object;

export interface CustomFieldObjectTypeSelectorResponse {
  type: CustomFieldObjectType;
  name: string;
}

export type CustomFieldObjectTypeSelectorResponseIEquatable = object;

export interface CustomFieldPredefinedTypeSelectorResponse {
  preDefinedType: CustomFieldPreDefinedType;
  name: string;
  /** @format int32 */
  maxLen: number | null;
  inputMask: string | null;
  displayFormat: string | null;
  regex: string | null;
}

export type CustomFieldPredefinedTypeSelectorResponseIEquatable = object;

export interface CustomFieldSelectorQuery {
  usage: CustomFieldUsages;
  viewUsedInFilters: boolean;
}

export interface CustomFieldTextDef {
  /** @format int32 */
  length: number | null;
  inputMask: string | null;
  displayFormat: string | null;
  validation: string | null;
  multiline: boolean;
  preDefinedType: CustomFieldPreDefinedType;
}

export interface CustomFieldTypeSelectorResponse {
  type: CustomFieldType;
  name: string;
}

export type CustomFieldTypeSelectorResponseIEquatable = object;

export interface CustomFieldUsageSelectorResponse {
  usage: CustomFieldUsages;
  /** @format uuid */
  subUsageId: string | null;
  name: string;
}

export type CustomFieldUsageSelectorResponseIEquatable = object;

export interface CustomFieldUserDisplayAreaSelectorResponse {
  displayArea: CustomFieldUserDisplayArea;
  name: string;
}

export type CustomFieldUserDisplayAreaSelectorResponseIEquatable = object;

export interface CustomFieldValue {
  fieldId: string;
  fieldValue: string;
}

export interface CustomFieldValueBasicDto {
  fieldId: string;
  label: string;
  fieldValue: string | null;
  fieldType: CustomFieldType;
}

export type CustomFieldValueBasicDtoIEquatable = object;

export interface CustomFieldValueDto {
  fieldId: string;
  fieldValue: string | null;
  usage: CustomFieldUsages;
  fieldType: CustomFieldType;
  label: string;
  placeholderText: string | null;
  validationErrorMessage: string | null;
  defaultValue: string | null;
  isRequired: boolean;
  isUnique: boolean;
  /** @format int32 */
  sequenceOrder: number;
  showConcealed: boolean;
  showOnUserProfile: boolean | null;
  fillConstraint: CustomFieldFillConstraint;
  isVisibleToSelfUser: boolean | null;
  isEditableToSelfUser: boolean | null;
  userDisplayArea: CustomFieldUserDisplayArea | null;
  showWidth: CustomFieldWidth;
  textField: TextFieldDto | null;
  numericField: NumericFieldDto | null;
  valueSelectionField: ValueSelectionFieldDto | null;
  objectSelectionField: ObjectSelectionFieldDto | null;
  isReadonly: boolean;
}

export type CustomFieldValueDtoIEquatable = object;

export type CustomFieldValueDtoListIRequest = object;

export type CustomFieldValueIEquatable = object;

export interface CustomFieldWidthSelectorResponse {
  width: CustomFieldWidth;
  name: string;
}

export type CustomFieldWidthSelectorResponseIEquatable = object;

export interface DashAwardBadgesListQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format int32 */
  yearMonth: number;
  /** @format uuid */
  userId: string | null;
  filter: AdvCoreFilter[];
}

export interface DashAwardBadgesQuery {
  filter: AdvCoreFilter[];
}

export interface DashAwardChartDto {
  months: DashAwardMonthDto[];
}

export type DashAwardChartDtoIEquatable = object;

export type DashAwardChartDtoIRequest = object;

export interface DashAwardExportBadgesCommand {
  /** @format int32 */
  yearMonth: number;
  filter: AdvCoreFilter[];
}

export interface DashAwardExportReasonsCommand {
  /** @format int32 */
  yearMonth: number;
  filter: AdvCoreFilter[];
}

export interface DashAwardExportUsersBadgesCommand {
  /** @format int32 */
  yearMonth: number;
  filter: AdvCoreFilter[];
}

export interface DashAwardExportUsersRankingCommand {
  /** @format int32 */
  yearMonth: number;
  filter: AdvCoreFilter[];
}

export interface DashAwardMonthDto {
  /** @format int32 */
  yearMonth: number;
  /** @format int32 */
  total: number;
}

export type DashAwardMonthDtoIEquatable = object;

export interface DashAwardPointsQuery {
  filter: AdvCoreFilter[];
}

export interface DashAwardPointsStatementListQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  filterBy: DashAwardPointsStatementFilterBy;
  /** @format date-time */
  dateRef: Date | null;
  /** @format uuid */
  userId: string;
}

export interface DashAwardPointsStatementResponse {
  /** @format date-time */
  creationDate: Date;
  transaction: AwardTransaction;
  /** @format int32 */
  points: number;
  name: string;
  /** @format uuid */
  publicationId: string | null;
  publicationType: PublicationType | null;
  /** @format uuid */
  trainingId: string | null;
  /** @format uuid */
  topicId: string | null;
  /** @format uuid */
  badgeId: string | null;
  subtitle: string | null;
}

export type DashAwardPointsStatementResponseIEquatable = object;

export interface DashAwardPointsStatementResponsePaginatedList {
  items: DashAwardPointsStatementResponse[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type DashAwardPointsStatementResponsePaginatedListIRequest = object;

export interface DashAwardReasonsListQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format int32 */
  yearMonth: number;
  filter: AdvCoreFilter[];
}

export interface DashAwardReasonsResponse {
  /** @format int32 */
  rowNumber: number;
  transaction: AwardTransaction;
  name: string;
  /** @format int32 */
  points: number;
}

export type DashAwardReasonsResponseIEquatable = object;

export interface DashAwardReasonsResponsePaginatedList {
  items: DashAwardReasonsResponse[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type DashAwardReasonsResponsePaginatedListIRequest = object;

export interface DashAwardResumeQuery {
  filter: AdvCoreFilter[];
}

export interface DashAwardResumeResponse {
  /** @format int32 */
  pointsHistory: number | null;
  /** @format int32 */
  pointsLast30Days: number | null;
  /** @format int32 */
  badgesHistory: number | null;
  /** @format int32 */
  badgesLast30Days: number | null;
}

export type DashAwardResumeResponseIEquatable = object;

export type DashAwardResumeResponseIRequest = object;

export interface DashAwardUsersBadgesListQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format int32 */
  yearMonth: number;
  /** @format uuid */
  badgeId: string | null;
  filter: AdvCoreFilter[];
}

export interface DashAwardUsersRankingListQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format int32 */
  yearMonth: number;
  transaction: AwardTransaction | null;
  filter: AdvCoreFilter[];
}

export interface DashChallengeExportTopicsAnalysisCommand {
  /** @format uuid */
  searchTopicId: string | null;
  searchTopicDescendant: boolean | null;
  filter: AdvCoreFilter[];
  option: DashChallengeAnalysisOption;
  searchText: string | null;
}

export interface DashChallengeExportUsersAnalysisCommand {
  /** @format uuid */
  searchTopicId: string | null;
  searchTopicDescendant: boolean | null;
  filter: AdvCoreFilter[];
  option: DashChallengeAnalysisOption;
  searchText: string | null;
}

export interface DashChallengeIndicatorsQuery {
  /** @format uuid */
  searchTopicId: string | null;
  searchTopicDescendant: boolean | null;
  filter: AdvCoreFilter[];
}

export interface DashChallengeIndicatorsResponse {
  /** @format int32 */
  provenKnowledgePercent: number | null;
  /** @format int32 */
  confidenceLevelPercent: number | null;
  /** @format int32 */
  accuracyRatePercent: number | null;
  /** @format int32 */
  provenRetentionPercent: number | null;
  /** @format int32 */
  totalUsers: number;
  /** @format int32 */
  totalUsersEligibleParticipate: number;
  /** @format int32 */
  usersEligibleParticipatePerc: number | null;
  /** @format int32 */
  totalUserAnsweredChallenge: number;
}

export type DashChallengeIndicatorsResponseIEquatable = object;

export type DashChallengeIndicatorsResponseIRequest = object;

export interface DashChallengeInsightsQuery {
  /** @format uuid */
  searchTopicId: string | null;
  searchTopicDescendant: boolean | null;
  filter: AdvCoreFilter[];
}

export interface DashChallengeInsightsResponse {
  /** @format int32 */
  provenKnowledgeSeal: number;
  /** @format int32 */
  topicsBeginTested: number;
  /** @format int32 */
  answersCorrectFirstAttempt: number | null;
  /** @format int32 */
  incorrectAnswersHighFrequency: number;
}

export type DashChallengeInsightsResponseIEquatable = object;

export type DashChallengeInsightsResponseIRequest = object;

export interface DashChallengeParticipationQuery {
  /** @format uuid */
  searchTopicId: string | null;
  searchTopicDescendant: boolean | null;
  filter: AdvCoreFilter[];
  period: DashChallengeParticipationPeriod;
}

export interface DashChallengeParticipationResponse {
  /** @format int32 */
  totalUsers: number;
  /** @format int32 */
  totalUserAnsweredChallenge: number;
  /** @format int32 */
  userAnsweredChallengePerc: number | null;
}

export type DashChallengeParticipationResponseIEquatable = object;

export type DashChallengeParticipationResponseIRequest = object;

export interface DashChallengeQuestionIncorrectQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  searchTopicId: string | null;
  searchTopicDescendant: boolean | null;
  filter: AdvCoreFilter[];
  searchText: string | null;
}

export interface DashChallengeTopicsAnalysisQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  searchTopicId: string | null;
  searchTopicDescendant: boolean | null;
  filter: AdvCoreFilter[];
  option: DashChallengeAnalysisOption;
  /** @format uuid */
  userId: string | null;
  searchText: string | null;
}

export interface DashChallengeUserAnsweredQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  searchTopicId: string | null;
  searchTopicDescendant: boolean | null;
  filter: AdvCoreFilter[];
  searchText: string | null;
  period: DashChallengeParticipationPeriod;
}

export interface DashChallengeUserEligibleParticipateQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  searchTopicId: string | null;
  searchTopicDescendant: boolean | null;
  filter: AdvCoreFilter[];
  searchText: string | null;
}

export interface DashChallengeUserTopicDto {
  /** @format uuid */
  userId: string;
  name: string;
  thumbnailUrl: string;
  topicName: string;
}

export type DashChallengeUserTopicDtoIEquatable = object;

export interface DashChallengeUserTopicDtoPaginatedList {
  items: DashChallengeUserTopicDto[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type DashChallengeUserTopicDtoPaginatedListIRequest = object;

export interface DashChallengeUsersAnalysisQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  searchTopicId: string | null;
  searchTopicDescendant: boolean | null;
  filter: AdvCoreFilter[];
  option: DashChallengeAnalysisOption;
  /** @format uuid */
  topicId: string | null;
  searchText: string | null;
}

export interface DashChallengeUsersTopicsSealsQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  searchTopicId: string | null;
  searchTopicDescendant: boolean | null;
  filter: AdvCoreFilter[];
  searchText: string | null;
}

export interface DashListItemDto {
  /** @format int32 */
  rowNumber: number;
  /** @format uuid */
  id: string;
  name: string;
  displayName: string | null;
  thumbnailUrl: string;
  /** @format int32 */
  counter: number;
  /** @format double */
  value: number;
  /** @format int32 */
  quantity: number | null;
  /** @format int32 */
  total: number | null;
}

export type DashListItemDtoIEquatable = object;

export interface DashListItemDtoPaginatedList {
  items: DashListItemDto[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type DashListItemDtoPaginatedListIRequest = object;

export interface DashboardGoal {
  generalResult: GeneralResult | null;
  listGoals: GoalItem[] | null;
}

export interface DashboardPerformanceReviews {
  assessmentGeneral: AssessmentGeneralDTO;
  competencysChart: CompetencysChartDTO[];
  assessmentList: AssessmentListDTO[];
}

export type DashboardPerformanceReviewsIEquatable = object;

export interface DateRange {
  /** @format date-time */
  start: Date;
  /** @format date-time */
  end: Date;
}

export type DateRangeIEquatable = object;

export type DateTimeNullableIRequest = object;

export interface DefaultImagesResponse {
  /** @format uuid */
  id: string;
  systemImage: SystemImages;
  name: string;
  url: string;
  fallbackImageUrl: string;
  isDefault: boolean;
  revisor: UserShortView | null;
  thumbSize: DefaultImagesThumbSize;
}

export type DefaultImagesResponseIEquatable = object;

export type DefaultImagesResponseIRequest = object;

export interface DeleteAbsenceTypeCommand {
  /** @format uuid */
  absenceTypeId: string;
}

export type DeleteAbsenceTypeCommandIEquatable = object;

export interface DeleteAllMemberStaticGroupCommand {
  /** @format uuid */
  groupId: string;
}

export interface DeleteAppointmentCommand {
  /** @format uuid */
  appointmentId: string;
  /** @format uuid */
  instructorId: string;
}

export interface DeleteAssDeployCommand {
  /** @format uuid */
  assDeployId: string;
}

export type DeleteAssDeployCommandIEquatable = object;

export interface DeleteAssessmentCommand {
  /** @format uuid */
  assessmentId: string;
}

export interface DeleteAwardRankingCommand {
  /** @format uuid */
  rankingId: string;
}

export type DeleteAwardRankingCommandIEquatable = object;

export interface DeleteBadgeCommand {
  /** @format uuid */
  badgeId: string;
}

export type DeleteBadgeCommandIEquatable = object;

export interface DeleteBadgeResponse {
  errorMessage: string | null;
}

export type DeleteBadgeResponseIEquatable = object;

export type DeleteBadgeResponseIRequest = object;

export interface DeleteChannelCommand {
  /** @format uuid */
  channelId: string;
}

export interface DeleteChannelToPromoteSettingsCommand {
  /** @format uuid */
  channelId: string;
}

export interface DeleteClassroomCommand {
  /** @format uuid */
  classroomId: string;
}

export interface DeleteClassroomDiscussionCommand {
  /** @format uuid */
  classroomId: string;
  /** @format uuid */
  discussionId: string;
}

export type DeleteClassroomDiscussionCommandIEquatable = object;

export interface DeleteClassroomMaterialListCommand {
  /** @format uuid */
  classroomId: string;
  /** @format uuid */
  materialListId: string;
}

export interface DeleteClassroomMaterialListItemCommand {
  /** @format uuid */
  classroomId: string;
  /** @format uuid */
  materialListId: string;
  /** @format uuid */
  materialItemId: string;
}

export interface DeleteClassroomNoticeCommand {
  /** @format uuid */
  classroomId: string;
  /** @format uuid */
  publicationId: string;
}

export interface DeleteCommentCommand {
  /** @format uuid */
  publicationId: string;
  /** @format uuid */
  commentId: string;
}

export type DeleteCommentCommandIEquatable = object;

export interface DeleteComponentCommand {
  /** @format uuid */
  trainingId: string;
  /** @format int32 */
  versionNumber: number;
  /** @format uuid */
  componentId: string;
}

export interface DeleteDevPlanCommand {
  /** @format uuid */
  devPlanId: string;
}

export interface DeleteDevPlanDiscussionCommand {
  /** @format uuid */
  devPlanId: string;
  /** @format uuid */
  discussionId: string;
}

export type DeleteDevPlanDiscussionCommandIEquatable = object;

export interface DeleteDevPlanGroupCommand {
  /** @format uuid */
  devPlanGroupId: string;
}

export interface DeleteDevPlanItemCommand {
  /** @format uuid */
  devPlanItemId: string;
}

export interface DeleteDirectMessageCommand {
  messageIds: string[];
}

export interface DeleteDiscussionDto {
  /** @format int32 */
  totalComments: number;
  deletedComments: DeleteDiscussionItem[];
  changedComments: DeleteDiscussionItem[];
}

export type DeleteDiscussionDtoIEquatable = object;

export type DeleteDiscussionDtoIRequest = object;

export interface DeleteDiscussionItem {
  /** @format uuid */
  discussionId: string;
  /** @format uuid */
  referenceId: string;
  /** @format uuid */
  parentId: string | null;
  /** @format uuid */
  replyId: string | null;
}

export interface DeleteExemptEnrollCommand {
  /** @format uuid */
  enrollmentId: string;
}

export interface DeleteGroupCommand {
  /** @format uuid */
  groupId: string;
}

export type DeleteGroupCommandIEquatable = object;

export interface DeleteHolidayCommand {
  /** @format uuid */
  calendarId: string;
  /** @format date */
  day: Date;
}

export interface DeleteIndicatorCommand {
  indicatorType: IndicatorType;
}

export interface DeleteLpGameAwardRankingCommand {
  /** @format uuid */
  trainingId: string;
  /** @format uuid */
  learnPathGameRankingId: string;
  /** @format int32 */
  rankPosition: number;
}

export interface DeleteLpGameRankingCommand {
  /** @format uuid */
  trainingId: string;
  /** @format uuid */
  learnPathGameRankingId: string;
}

export interface DeleteLpGameScoreCommand {
  /** @format uuid */
  trainingId: string;
  /** @format uuid */
  componentId: string;
}

export interface DeleteMeeetingRoomCommand {
  /** @format uuid */
  roomId: string;
}

export interface DeleteMemberChannelCommand {
  /** @format uuid */
  channelId: string;
  memberType: MemberType;
  /** @format uuid */
  memberId: string;
}

export interface DeleteMemberStaticGroupCommand {
  /** @format uuid */
  memberId: string;
  memberType: MemberType;
  /** @format uuid */
  groupId: string;
}

export interface DeletePreviewAssInstanceCommand {
  /** @format uuid */
  instanceId: string;
}

export interface DeletePublicationCommand {
  /** @format uuid */
  publicationId: string;
  permanently: boolean;
}

export interface DeleteQuestionCommand {
  /** @format uuid */
  questionId: string;
}

export interface DeleteQuestionGroupCommand {
  /** @format uuid */
  questionGroupId: string;
}

export interface DeleteQuickFilterCommand {
  /** @format uuid */
  quickFilterId: string;
}

export interface DeleteReportCommand {
  /** @format uuid */
  reportId: string;
}

export interface DeleteReportGroupCommand {
  /** @format uuid */
  reportGroupId: string;
}

export type DeleteReportGroupCommandIEquatable = object;

export interface DeleteReportScheduleCommand {
  /** @format uuid */
  reportId: string;
  /** @format uuid */
  reportScheduleId: string;
}

export interface DeleteRoleCommand {
  /** @format uuid */
  roleId: string;
}

export type DeleteRoleCommandIEquatable = object;

export interface DeleteShortVideoCommand {
  /** @format uuid */
  shortVideoId: string;
}

export interface DeleteTagCommand {
  /** @format uuid */
  tagId: string;
}

export interface DeleteTopicCommand {
  /** @format uuid */
  topicId: string;
}

export interface DeleteTopicToPromoteSettingsCommand {
  /** @format uuid */
  topicId: string;
}

export interface DeleteTrainingAgreementCommand {
  /** @format uuid */
  agreementId: string;
}

export interface DeleteTrainingCommand {
  /** @format uuid */
  trainingId: string;
}

export interface DeleteTrainingMaterialListCommand {
  /** @format uuid */
  trainingId: string;
  /** @format uuid */
  materialListId: string;
}

export interface DeleteTrainingMaterialListItemCommand {
  /** @format uuid */
  trainingId: string;
  /** @format uuid */
  materialListId: string;
  /** @format uuid */
  materialItemId: string;
}

export interface DeleteUnitCommand {
  /** @format uuid */
  unitId: string;
}

export interface DeleteUnitTypeCommand {
  /** @format uuid */
  unitTypeId: string;
}

export type DeleteUnitTypeCommandIEquatable = object;

export interface DeleteUserCommand {
  /** @format uuid */
  userId: string;
}

export interface DeleteUserCommandResponse {
  statusCode: RemoveUserStatus;
  message: string | null;
}

export type DeleteUserCommandResponseIRequest = object;

export interface DeliveryActivityCommand {
  /** @format uuid */
  enrollmentId: string;
  /** @format uuid */
  componentId: string;
  /** @format uuid */
  fileId: string;
}

export interface DevPlanActivityContentDto {
  /** @format uuid */
  publicationId: string;
  title: string;
  content: string | null;
  contentLoadStatus: FeedContentLoadStatus;
  author: UserShortView;
  /** @format date-time */
  publishedOn: Date | null;
  /** @format date-time */
  editedOn: Date | null;
  /** @format date-time */
  contentModifiedDate: Date | null;
  presentation: PublicationPresentation | null;
  attachs: FeedAttachDto[] | null;
  mentions: FeedMentionDto[] | null;
}

export type DevPlanActivityContentDtoIEquatable = object;

export type DevPlanActivityContentDtoIRequest = object;

export interface DevPlanActivityContentQuery {
  /** @format uuid */
  publicationId: string;
}

export interface DevPlanContextDto {
  /** @format uuid */
  devPlanId: string;
  devPlanName: string;
}

export type DevPlanContextDtoIEquatable = object;

export interface DevPlanDiscussionListQuery {
  /** @format int64 */
  startSequenceNum: number | null;
  /** @format int32 */
  take: number;
  /** @format uuid */
  discussionId: string | null;
  /** @format uuid */
  parentId: string | null;
  orderBy: DiscussionListOrderBy;
  filter: DiscussionListFilter | null;
  /** @format uuid */
  devPlanId: string;
}

export interface DevPlanDto {
  /** @format uuid */
  devPlanId: string;
  name: string;
  description: string | null;
  /** @format date-time */
  availableStarting: Date | null;
  /** @format date-time */
  completionDeadline: Date | null;
  /** @format date-time */
  archivingDeadline: Date | null;
  attach: FileGetDto | null;
}

export type DevPlanDtoIRequest = object;

export interface DevPlanGroupDto {
  /** @format uuid */
  devPlanGroupId: string;
  name: string;
  description: string | null;
  /** @format int32 */
  itemsCount: number;
  topic: AutoCompleteDataModelDto | null;
}

export type DevPlanGroupDtoIRequest = object;

export type DevPlanGroupDtoListIRequest = object;

export interface DevPlanGroupQuery {
  /** @format uuid */
  devPlanId: string;
  /** @format uuid */
  devPlanGroupId: string;
}

export interface DevPlanGroupsListQuery {
  /** @format uuid */
  devPlanId: string;
}

export interface DevPlanItemCardDto {
  /** @format uuid */
  devPlanItemId: string;
  stateIndicator: DevPlanStateIndicator | null;
  card: CardDto;
}

export type DevPlanItemCardDtoIEquatable = object;

export interface DevPlanItemDto {
  /** @format uuid */
  devPlanItemId: string;
  title: string;
}

export type DevPlanItemDtoListIRequest = object;

export interface DevPlanItemsListQuery {
  /** @format uuid */
  devPlanGroupId: string;
}

export interface DevPlanItemsQuery {
  /** @format uuid */
  devPlanId: string;
  browserTimeZoneId: string;
  editMode: boolean;
}

export interface DevPlanItemsResponse {
  groups: DevPlansGroupsDto[];
}

export type DevPlanItemsResponseIEquatable = object;

export type DevPlanItemsResponseIRequest = object;

export interface DevPlanItemsSummaryDto {
  /** @format int32 */
  totalDelayed: number;
  /** @format int32 */
  totalPending: number;
}

export interface DevPlanOtherActivityQuery {
  /** @format uuid */
  publicationId: string;
}

export interface DevPlanPermissionResponse {
  isManager: boolean;
  canViewAllPlans: boolean;
}

export type DevPlanPermissionResponseIEquatable = object;

export interface DevPlanQuery {
  /** @format uuid */
  devPlanId: string;
}

export interface DevPlanTrainingApprovedQuery {
  /** @format uuid */
  userId: string;
  /** @format uuid */
  trainingId: string;
}

export interface DevPlanTrainingSelectorQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  searchText: string | null;
  /** @format uuid */
  userId: string;
}

export interface DevPlanUserDiscussionSuggestionsQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  devPlanId: string;
  searchText: string | null;
  selectionHistoryType: UserSelectionEntityType | null;
  discussionType: DiscussionType;
  ignoreSelectionHistory: boolean;
}

export interface DevPlanUserDto {
  /** @format uuid */
  userId: string;
  name: string;
  thumbnailUrl: string;
  hasDraft: boolean;
  hasPendingApproval: boolean;
  /** @format int32 */
  totalPlans: number;
  /** @format int32 */
  totalItems: number;
  /** @format int32 */
  totalCompletedItems: number;
  /** @format int32 */
  totalDelayedItems: number;
  /** @format date-time */
  planAvailableOn: Date | null;
  canViewDashboard: boolean;
  /** @format double */
  completePercent: number;
}

export type DevPlanUserDtoIEquatable = object;

export interface DevPlanUserDtoPaginatedList {
  items: DevPlanUserDto[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type DevPlanUserDtoPaginatedListIRequest = object;

export interface DevPlanUserListResponse {
  /** @format uuid */
  devPlanId: string;
  name: string;
  isDraft: boolean;
  isArchived: boolean;
  isApproved: boolean;
  pendingStart: boolean;
  /** @format date-time */
  availableStarting: Date | null;
  creationMode: DevPlanCreationMode;
  /** @format double */
  completionPercent: number;
  /** @format int32 */
  totalItems: number;
  /** @format int32 */
  totalDelayedItems: number;
  canManage: boolean;
}

export type DevPlanUserListResponseIEquatable = object;

export interface DevPlanUserListResponsePaginatedList {
  items: DevPlanUserListResponse[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type DevPlanUserListResponsePaginatedListIRequest = object;

export interface DevPlanUserPermissionResponse {
  name: string;
  canCreateNewPlan: boolean;
}

export type DevPlanUserPermissionResponseIEquatable = object;

export type DevPlanUserPermissionResponseIRequest = object;

export interface DevPlanUserPermissionsQuery {
  /** @format uuid */
  userId: string;
}

export interface DevPlanUsersListQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  searchText: string | null;
  filters: AdvCoreFilter[];
  viewMode: DevPlanUsersListViewMode;
}

export interface DevPlanViewActionDto {
  accessReadonly: boolean;
  canEdit: boolean;
  canView: boolean;
  canReview: boolean;
  canAccess: boolean;
}

export interface DevPlanViewDto {
  /** @format uuid */
  devPlanId: string;
  /** @format uuid */
  userId: string;
  name: string;
  userName: string;
  thumbnailUrl: string;
  description: string | null;
  /** @format date-time */
  completionDeadline: Date | null;
  /** @format double */
  completionPercent: number;
  /** @format date-time */
  archivedOn: Date | null;
  attach: FileGetDto | null;
  recordInfo: RecordInfoDto;
  isApproved: boolean;
  isReadonly: boolean;
  readonlyBy: string | null;
  /** @format date-time */
  startedOn: Date;
  /** @format date-time */
  publishedOn: Date | null;
  creationMode: DevPlanCreationMode;
  summary: DevPlanItemsSummaryDto;
  actions: DevPlanViewActionDto;
}

export type DevPlanViewDtoIRequest = object;

export interface DevPlanViewQuery {
  /** @format uuid */
  devPlanId: string;
}

export interface DevPlansGroupsDto {
  /** @format uuid */
  devPlanGroupId: string;
  name: string;
  description: string | null;
  topicName: string | null;
  items: DevPlanItemCardDto[];
}

export type DevPlansGroupsDtoIEquatable = object;

export interface DevPlansListQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  userId: string;
  includeArchived: boolean;
  viewMode: DevPlanListViewMode;
}

export interface DirectManagerSuggestionQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  searchText: string;
}

export interface DirectMessageDto {
  /** @format uuid */
  messageId: string;
  sender: UserShortView;
  recipient: UserShortView;
  subject: string;
  body: string;
  /** @format date-time */
  createdOn: Date;
  read: boolean;
}

export interface DirectMessageDtoPaginatedList {
  items: DirectMessageDto[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type DirectMessageDtoPaginatedListIRequest = object;

export interface DirectMessageListQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  selectMessage: SelectMessageDirect;
}

export interface DirectMessageQuery {
  /** @format uuid */
  messageId: string;
}

export interface DirectMessageResponse {
  message: DirectMessageDto | null;
}

export type DirectMessageResponseIEquatable = object;

export type DirectMessageResponseIRequest = object;

export interface DirectMessageToClassroomCommand {
  /** @format uuid */
  classroomId: string;
  subject: string;
  body: string;
  searchText: string | null;
  filter: AdvCoreFilter[];
}

export interface DiscardMaxTriesAssEnrollmentCommand {
  /** @format uuid */
  enrollmentId: string;
  /** @format uuid */
  componentId: string;
}

export interface DiscardTrainingContentCommand {
  /** @format uuid */
  trainingId: string;
}

export interface DiscardTrainingContentResponse {
  success: boolean;
  hasAnyVersionPublished: boolean;
}

export type DiscardTrainingContentResponseIEquatable = object;

export type DiscardTrainingContentResponseIRequest = object;

export interface DiscoverUserTrainingInfoQuery {
  /** @format uuid */
  trainingId: string;
}

export interface DiscoverUserTrainingInfoResponse {
  actions: CardAction[];
  data: Record<string, any>;
  /** @format uuid */
  trainingId: string;
  trainingType: TrainingType;
  contentType: TrainingContentType;
  name: string;
  isActive: boolean;
  isDeleted: boolean;
  published: boolean;
  exclusiveLearnPathTraining: boolean;
}

export type DiscoverUserTrainingInfoResponseIEquatable = object;

export type DiscoverUserTrainingInfoResponseIRequest = object;

export interface DiscussionItemActionsDto {
  canLike: boolean;
  canReportAbuse: boolean;
  canEdit: boolean;
  canDelete: boolean;
}

export interface DiscussionItemInteractionDto {
  /** @format int32 */
  likes: number;
  liked: boolean;
  hasNews: boolean;
}

export interface DynamicGroupsFieldsSpecOperators {
  /** @format int32 */
  key: number;
  operator: GroupDynamicSpecFieldOperators;
  label: string;
}

export type DynamicGroupsFieldsSpecOperatorsIEquatable = object;

export interface DynamicGroupsFieldsSpecSelectorResponse {
  specFieldId: string;
  specFieldType: string;
  name: string;
  customFieldType: CustomFieldType | null;
  customFieldObjectType: CustomFieldObjectType | null;
  selectionList: string[] | null;
  operators: DynamicGroupsFieldsSpecOperators[];
}

export type DynamicGroupsFieldsSpecSelectorResponseIEquatable = object;

export interface ECourseEnrollmentViewQuery {
  /** @format uuid */
  enrollmentId: string;
}

export type EmailAuthenticatorSendCodeCommand = object;

export interface EmailAuthenticatorValidateCodeCommand {
  pinCode: string;
}

export interface EnrollOperationCancelProps {
  /** @format uuid */
  reasonId: string;
  remarks: string | null;
}

export type EnrollOperationCancelPropsIEquatable = object;

export interface EnrollOperationEnrollmentProps {
  forcePrerequisites: boolean;
  sendNotification: boolean;
}

export type EnrollOperationEnrollmentPropsIEquatable = object;

export interface EnrollOperationExcludeProps {
  latest: boolean;
  reason: string;
  sendNotification: boolean;
}

export type EnrollOperationExcludePropsIEquatable = object;

export interface EnrollOperationExtraTimeProps {
  /** @format int32 */
  aditionalDays: number;
  /** @format date-time */
  untilDate: Date | null;
}

export type EnrollOperationExtraTimePropsIEquatable = object;

export interface EnrollOperationReEnrollProps {
  revokePrevVersion: boolean;
  reuseComponent: boolean;
}

export type EnrollOperationReEnrollPropsIEquatable = object;

export interface EnrollOperationRevokeProps {
  reason: string;
}

export type EnrollOperationRevokePropsIEquatable = object;

export interface EnrollSubordinateFailed {
  name: string;
  reason: string;
}

export interface EnrollSubordinatesCommand {
  /** @format uuid */
  trainingId: string;
  /** @format uuid */
  classroomId: string | null;
  subordinates: string[];
}

export interface EnrollSubordinatesResult {
  /** @format int32 */
  success: number;
  fails: EnrollSubordinateFailed[];
}

export type EnrollSubordinatesResultIRequest = object;

export interface EnrolledUsersQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  trainingId: string;
  /** @format uuid */
  classroomId: string | null;
  searchText: string | null;
  option: EnrolledUsersOption;
}

export interface EnrollmentCalendarItemResponse {
  /** @format date */
  day: Date;
  type: EnrollmentCalendarType;
  name: string | null;
  isMandatory: boolean | null;
}

export type EnrollmentCalendarItemResponseIEquatable = object;

export interface EnrollmentCalendarQuery {
  /** @format uuid */
  enrollmentId: string | null;
  /** @format uuid */
  classroomId: string | null;
  /** @format date-time */
  date: Date | null;
  timezoneId: string;
}

export interface EnrollmentCalendarResponse {
  /** @format date */
  day: Date;
  finished: boolean;
  items: EnrollmentCalendarItemResponse[];
}

export type EnrollmentCalendarResponseIEquatable = object;

export type EnrollmentCalendarResponseListIRequest = object;

export interface EnrollmentCalloutsQuery {
  /** @format uuid */
  enrollmentId: string;
}

export interface EnrollmentComponentDto {
  /** @format uuid */
  componentId: string;
  componentType: TrainingComponentType;
  title: string;
  /** @format int32 */
  displayOrder: number;
  composeFinalScore: boolean;
  computeProgress: boolean;
  completed: boolean;
  failed: boolean;
  enabled: boolean;
  /** @format int32 */
  groupNumber: number | null;
  isCurrentComponent: boolean;
  enableOption: CourseComponentEnableOption;
  /** @format date-time */
  enableOn: Date | null;
  enableOnComponentsComplete: string[] | null;
  postComponent: PostComponentDto | null;
  activityComponent: ActivityComponentDto | null;
  scoComponent: ScoComponentDto | null;
  assessmentComponent: TrainingAssessmentItemDto | null;
  meetingComponent: TrainingMeetingItemDto | null;
  trainingComponent: LpTrainingComponentDto | null;
}

export type EnrollmentComponentDtoIEquatable = object;

export interface EnrollmentFinalResultQuery {
  /** @format uuid */
  enrollmentId: string;
  /** @format double */
  currentScore: number | null;
  /** @format double */
  currentProgress: number | null;
  /** @format double */
  currentCredits: number | null;
}

export interface EnrollmentFinalResultsResponse {
  finalStatus: EnrollStatus;
  progressOrScoreChanged: boolean;
}

export type EnrollmentFinalResultsResponseIEquatable = object;

export type EnrollmentFinalResultsResponseIRequest = object;

export interface EnrollmentHistoryDto {
  /** @format uuid */
  enrollmentId: string;
  status: EnrollStatus;
  statusName: string;
  /** @format date-time */
  actionDate: Date;
  actionRemarks: string | null;
  isMandatory: boolean;
  /** @format double */
  scorePercent: number | null;
  /** @format date-time */
  certificateValidUntil: Date | null;
  /** @format uuid */
  certificateFileId: string | null;
  /** @format uuid */
  trainingId: string;
  trainingType: TrainingType;
  trainingThumbnailUrl: string;
  trainingName: string;
  trainingContentType: TrainingContentType;
  trainingContentTypeName: string;
  masterEnrollmentTrainingName: string | null;
  /** @format uuid */
  classroomId: string | null;
  className: string | null;
  multipleClasses: boolean;
  canReview: boolean;
  canReenroll: boolean;
  canReportNewConclusionForm: boolean;
  canRating: boolean;
}

export type EnrollmentHistoryDtoIEquatable = object;

export type EnrollmentHistoryDtoIRequest = object;

export interface EnrollmentHistoryDtoPaginatedList {
  items: EnrollmentHistoryDto[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type EnrollmentHistoryDtoPaginatedListIRequest = object;

export interface EnrollmentNoticesQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  enrollmentId: string | null;
  /** @format uuid */
  classroomId: string | null;
}

export interface EnrollmentProgressDetailQuery {
  /** @format uuid */
  enrollmentId: string;
}

export interface EnrollmentProgressDetailResponse {
  summary: EnrollmentSummaryDto;
  scoreComponents: ScoreComponentDto[];
}

export type EnrollmentProgressDetailResponseIEquatable = object;

export type EnrollmentProgressDetailResponseIRequest = object;

export interface EnrollmentRatingResponse {
  /** @format int32 */
  ratingStars: number;
  ratingComment: string | null;
  training: TrainingHeaderInfoDto | null;
}

export type EnrollmentRatingResponseIEquatable = object;

export interface EnrollmentScoreDetailQuery {
  /** @format uuid */
  enrollmentId: string;
}

export interface EnrollmentScoreDetailResponse {
  trainingName: string;
  status: EnrollStatus;
  isFinalized: boolean;
  /** @format int32 */
  minFinalScore: number;
  /** @format double */
  scorePercent: number;
  /** @format int32 */
  totalItems: number;
  /** @format int32 */
  totalCompletedItems: number;
  scoreComponents: ScoreComponentDto[];
}

export type EnrollmentScoreDetailResponseIEquatable = object;

export type EnrollmentScoreDetailResponseIRequest = object;

export interface EnrollmentSummaryDto {
  /** @format uuid */
  enrollmentId: string;
  trainingName: string;
  masterEnrollmentTrainingName: string | null;
  /** @format uuid */
  classroomId: string | null;
  classroomName: string | null;
  /** @format date-time */
  enrolledOn: Date;
  enroller: UserShortView;
  /** @format date-time */
  firstAccess: Date | null;
  /** @format date-time */
  lastAccess: Date | null;
  /** @format timespan */
  timeSpent: string | null;
  /** @format date-time */
  startDate: Date | null;
  /** @format date-time */
  dueDate: Date | null;
  enrolledByManager: boolean;
  isMandatoryEnroll: boolean;
  status: EnrollStatus;
  fullManaged: boolean;
  /** @format int32 */
  progressPercent: number;
  /** @format int32 */
  minProgress: number;
  progressByCredits: boolean;
  /** @format int32 */
  credits: number | null;
  /** @format int32 */
  minCredits: number | null;
  /** @format int32 */
  maxCredits: number | null;
  /** @format int32 */
  totalMandatoryComponents: number;
  /** @format int32 */
  totalCompletedMandatoryComponents: number;
  /** @format int32 */
  progressTotalItems: number;
  /** @format int32 */
  progressTotalCompletedItems: number;
  /** @format double */
  scorePercent: number;
  scoreIsPercent: boolean;
  /** @format int32 */
  minScore: number;
  /** @format int32 */
  scoreTotalItems: number;
  /** @format int32 */
  scoreTotalCompletedItems: number;
  /** @format date-time */
  conclusionFormReportedOn: Date | null;
  isFinalized: boolean;
  /** @format date-time */
  finalizationDate: Date | null;
  canReview: boolean;
  /** @format date-time */
  reviewUntil: Date | null;
  /** @format date-time */
  certificateValidUntil: Date | null;
  /** @format uuid */
  certificateFileId: string | null;
  /** @format date-time */
  expireDate: Date | null;
  approvers: UserShortView[] | null;
  certificateExpired: boolean;
  hasScore: boolean;
  reprovedByExpireDate: boolean;
}

export type EnrollmentSummaryDtoIEquatable = object;

export interface EnrollmentTrainingAgreementQuery {
  /** @format uuid */
  enrollmentId: string;
}

export interface EnrollmentTrainingAgreementResponse {
  /** @format uuid */
  agreementId: string;
  text: string;
}

export type EnrollmentTrainingAgreementResponseIEquatable = object;

export type EnrollmentTrainingAgreementResponseIRequest = object;

export interface EnrollmentViewCourseData {
  hasPublicationContent: boolean;
  components: EnrollmentComponentDto[];
  singleComponent: boolean;
  /** @format uuid */
  currentComponentId: string;
}

export type EnrollmentViewCourseDataIEquatable = object;

export interface EnrollmentViewDto {
  /** @format uuid */
  enrollmentId: string;
  isPreview: boolean;
  /** @format uuid */
  trainingId: string;
  trainingType: TrainingType;
  trainingContentType: TrainingContentType;
  /** @format uuid */
  classroomId: string;
  classroomName: string;
  multipleClasses: boolean;
  trainingName: string;
  trainingThumbnailUrl: string | null;
  /** @format uuid */
  masterEnrollmentId: string | null;
  masterEnrollmentTrainingName: string | null;
  status: EnrollStatus;
  /** @format date-time */
  dueDate: Date | null;
  /** @format date-time */
  expireDate: Date | null;
  /** @format date-time */
  finalizationDate: Date | null;
  /** @format date-time */
  conclusionDate: Date | null;
  isDelayed: boolean;
  isExpired: boolean;
  /** @format uuid */
  certificateId: string | null;
  /** @format date-time */
  certificateValidUntil: Date | null;
  /** @format int32 */
  approvalPoints: number | null;
  /** @format double */
  progressPercent: number | null;
  /** @format double */
  scorePercent: number | null;
  canReview: boolean;
  /** @format date-time */
  reviewUntil: Date | null;
  timezoneId: string;
  /** @format int32 */
  minProgress: number;
  /** @format int32 */
  minFinalScore: number;
  canReEnroll: boolean;
  canFinish: boolean;
  canCancel: boolean;
  canForceFinish: boolean;
  canEnrollSubordinates: boolean;
  /** @format date-time */
  nextAutoEnrollDate: Date | null;
  allowTrainingReview: boolean;
  discussionEnable: boolean;
  discussionPrivate: boolean;
  shareOption: TrainingShareOption;
  enableLike: boolean;
  enableShareInChannelAndLists: boolean;
  enableViewEnrolledUsers: boolean;
  hasAudienceDefined: boolean;
  hasMaterialList: boolean;
  hasNotices: boolean;
  readOnly: boolean;
  /** @format int32 */
  likeCount: number;
  liked: boolean;
  bookmarked: boolean;
  /** @format int32 */
  totalComponents: number;
  /** @format int32 */
  totalCompletedComponents: number;
  /** @format int32 */
  totalScoredComponents: number;
  /** @format int32 */
  totalCompletedScoredComponents: number;
  /** @format int32 */
  totalComputeProgressComponents: number;
  /** @format int32 */
  totalCompletedComputeProgressComponents: number;
  hasScore: boolean;
  hasCertificate: boolean;
  certificateExpired: boolean;
  reprovedByExpireDate: boolean;
  course: EnrollmentViewCourseData | null;
  eCourse: EnrollmentViewECourseData | null;
  learnPath: EnrollmentViewLearnPathData | null;
  wasFinalized: boolean;
}

export type EnrollmentViewDtoIEquatable = object;

export type EnrollmentViewDtoIRequest = object;

export interface EnrollmentViewECourseData {
  /** @format date-time */
  lastSubmit: Date | null;
  needWorkflow: boolean;
  showInstitutionOrProvider: boolean;
  institutionOrProvider: string | null;
  showFinalScore: boolean;
  /** @format double */
  finalScore: number | null;
  finalScoreIsPercent: boolean | null;
  approved: boolean | null;
  showAttendancePercent: boolean;
  /** @format double */
  attendancePercent: number | null;
  showPricePaid: boolean;
  /** @format double */
  pricePaid: number | null;
  showCoursePeriod: boolean;
  /** @format date-time */
  startDate: Date | null;
  /** @format date-time */
  endDate: Date | null;
  showCourseDuration: boolean;
  /** @format int32 */
  duration: number | null;
  showCertificate: boolean;
  /** @format uuid */
  externalCertificateId: string | null;
  approverMessage: string | null;
  approver: UserShortView | null;
  approvalWorkflowStatus: EnrollmentWorkflowStatus | null;
}

export type EnrollmentViewECourseDataIEquatable = object;

export interface EnrollmentViewLearnPathData {
  gamified: boolean;
  progressByCredits: boolean;
  /** @format double */
  credits: number | null;
  /** @format int32 */
  minCredits: number | null;
  /** @format int32 */
  maxCredits: number | null;
  /** @format int32 */
  totalMandatoryComponents: number;
  /** @format int32 */
  totalCompletedMandatoryComponents: number;
  newDiscussion: boolean;
  newNotices: boolean;
  anyComponentInProgress: boolean;
}

export type EnrollmentViewLearnPathDataIEquatable = object;

export interface EnrollmentViewPreChecksRequest {
  /** @format uuid */
  enrollmentId: string;
  checkAccessTimeRules: boolean;
}

export interface EnrollmentViewPreChecksResponse {
  blockReason: string | null;
  trainingAgreementPending: boolean;
  trainingAccessTimeRestriction: TrainingAccessTimeResult | null;
}

export type EnrollmentViewPreChecksResponseIEquatable = object;

export interface EnrollmentWorkflowStatusQuery {
  /** @format uuid */
  enrollmentId: string;
}

export interface EnrollmentWorkflowStatusResponse {
  /** @format date-time */
  actionRequestedOn: Date;
  /** @format date-time */
  actionCompletedOn: Date | null;
  status: EnrollmentWorkflowStatus;
  statusName: string;
  approver: UserShortView;
}

export type EnrollmentWorkflowStatusResponseIEnumerableIRequest = object;

export type EnrollmentWorkflowStatusResponseIEquatable = object;

export interface EssayCorrectionDto {
  /** @format uuid */
  assessmentId: string;
  name: string;
  thumbnailUrl: string;
  /** @format int32 */
  pendingCorrection: number;
  /** @format uuid */
  evaluatedId: string | null;
  evaluatedName: string | null;
}

export type EssayCorrectionDtoIEquatable = object;

export interface EssayCorrectionDtoPaginatedList {
  items: EssayCorrectionDto[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type EssayCorrectionDtoPaginatedListIRequest = object;

export interface EssayCorrectionInstanceDto {
  /** @format uuid */
  instanceId: string;
  /** @format uuid */
  questionId: string;
  /** @format int32 */
  version: number;
  questionText: string;
  remarks: string | null;
  /** @format int32 */
  maxPoints: number | null;
  answer: string;
  /** @format double */
  answerPoints: number | null;
  feedback: string | null;
  attach: QuestionAttachDto | null;
  /** @format date-time */
  answerDate: Date;
  readonly: boolean;
  hasScore: boolean;
  trainingName: string;
  classroomName: string | null;
  enrollIsFinalized: boolean;
  isEvaluator: boolean;
  /** @format uuid */
  evaluatorId: string | null;
  evaluatorName: string | null;
}

export type EssayCorrectionInstanceDtoIEquatable = object;

export interface EssayCorrectionListQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  classroomId: string | null;
  searchText: string | null;
  onlyPending: boolean;
  orderBy: EssayCorrectionListQueryOrderBy;
}

export interface EssayCorrectionQuestionListQuery {
  /** @format uuid */
  assessmentId: string;
  /** @format uuid */
  userId: string;
  onlyPending: boolean;
}

export interface EssayCorrectionQuestionResponse {
  instances: EssayCorrectionInstanceDto[][] | null;
}

export type EssayCorrectionQuestionResponseIEquatable = object;

export type EssayCorrectionQuestionResponseIRequest = object;

export interface EssayCorrectionUserListQuery {
  /** @format uuid */
  assessmentId: string;
  /** @format uuid */
  classroomId: string | null;
  searchText: string | null;
  onlyPending: boolean;
  orderBy: EssayCorrectionUserListQueryOrderBy;
}

export interface EssayCorrectionUsersResponse {
  /** @format uuid */
  userId: string;
  name: string;
  thumbnailUrl: string | null;
  /** @format int32 */
  pendingCorrection: number;
  /** @format int32 */
  totalCorrected: number;
}

export type EssayCorrectionUsersResponseIEquatable = object;

export type EssayCorrectionUsersResponseListIRequest = object;

export interface EssayRegisterCorrectionCommand {
  /** @format uuid */
  instanceId: string;
  /** @format uuid */
  questionId: string;
  /** @format int32 */
  version: number;
  /** @format double */
  answerPoints: number | null;
  feedback: string | null;
}

export interface EvaluationInfoQuery {
  /** @format uuid */
  assessmentId: string;
}

export interface EvaluationInfoResponse {
  /** @format uuid */
  assessmentId: string;
  name: string;
}

export type EvaluationInfoResponseIRequest = object;

export interface EvaluationSuggestionsQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  searchText: string | null;
}

export interface EvolutionAwardBadgeDto {
  /** @format uuid */
  badgeId: string;
  name: string;
  thumbnailUrl: string;
  granted: boolean;
}

export type EvolutionAwardBadgeDtoIEquatable = object;

export type EvolutionAwardBadgeDtoListIRequest = object;

export interface EvolutionAwardBadgesListQuery {
  /** @format uuid */
  userId: string;
}

export interface EvolutionAwardRankingListQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  userId: string;
  /** @format uuid */
  rankingId: string;
  /** @format int32 */
  yearMonth: number | null;
}

export interface EvolutionAwardRankingResponse {
  items: AwardUserRankingDto[];
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageOffset: number;
  hasPreviousPage: boolean;
  hasNextPage: boolean;
  /** @format int32 */
  userPoints: number;
  /** @format int32 */
  userRanking: number | null;
}

export type EvolutionAwardRankingResponseIRequest = object;

export interface EvolutionAwardResumeQuery {
  /** @format uuid */
  userId: string;
}

export interface EvolutionAwardResumeResponse {
  rankings: AwardRankingDto[];
  awardLast12: AwardChartTuple[];
  awardLast30: AwardChartTuple[];
}

export type EvolutionAwardResumeResponseIEquatable = object;

export type EvolutionAwardResumeResponseIRequest = object;

export interface EvolutionChallengeResumeQuery {
  /** @format uuid */
  userId: string;
}

export interface EvolutionChallengeResumeResponse {
  /** @format int32 */
  provenKnowledgePercent: number | null;
  /** @format int32 */
  confidenceLevelPercent: number | null;
  /** @format int32 */
  accuracyRatePercent: number | null;
  /** @format int32 */
  provenKnowledgeRecallDays: number | null;
  /** @format int32 */
  totalTopics: number;
}

export type EvolutionChallengeResumeResponseIEquatable = object;

export type EvolutionChallengeResumeResponseIRequest = object;

export interface EvolutionChallengeTopicsListQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  userId: string;
  option: DashChallengeAnalysisOption;
}

export interface EvolutionChallengeTopicsResponse {
  /** @format int32 */
  rowNumber: number;
  /** @format uuid */
  topicId: string;
  name: string;
  thumbnailUrl: string;
  isSpecialist: boolean;
  hasProvenKnowledgeSeal: boolean;
  /** @format int32 */
  pendingQuestions: number;
  /** @format double */
  percent: number;
}

export type EvolutionChallengeTopicsResponseIEquatable = object;

export interface EvolutionChallengeTopicsResponsePaginatedList {
  items: EvolutionChallengeTopicsResponse[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type EvolutionChallengeTopicsResponsePaginatedListIRequest = object;

export interface EvolutionKnowledgeChannelResponse {
  /** @format uuid */
  channelId: string;
  name: string;
  /** @format int32 */
  total: number;
}

export type EvolutionKnowledgeChannelResponseIEquatable = object;

export interface EvolutionKnowledgeDrillQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  publicationId: string;
  analysisType: KnowledgePanelAnalysisType;
  searchText: string | null;
}

export interface EvolutionKnowledgeListQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  userId: string;
  analysisType: KnowledgePanelAnalysisType;
}

export interface EvolutionKnowledgeResumeQuery {
  /** @format uuid */
  userId: string;
}

export interface EvolutionKnowledgeResumeResponse {
  /** @format int32 */
  totalPublications: number;
  /** @format int32 */
  totalAnswers: number;
  /** @format int32 */
  totalViewsReceived: number;
  /** @format int32 */
  totalLikesReceived: number;
  publicationsLast12: KPTupleLong[];
  channels: EvolutionKnowledgeChannelResponse[];
}

export type EvolutionKnowledgeResumeResponseIEquatable = object;

export type EvolutionKnowledgeResumeResponseIRequest = object;

export interface EvolutionPermissionQuery {
  /** @format uuid */
  userId: string;
}

export interface EvolutionPermissionResponse {
  permissions: EvolutionPermissions[];
}

export type EvolutionPermissionResponseIEquatable = object;

export type EvolutionPermissionResponseIRequest = object;

export interface EvolutionTrainingCertificateCounters {
  /** @format int32 */
  total: number;
  /** @format int32 */
  valid: number;
  /** @format int32 */
  expired: number;
}

export interface EvolutionTrainingCertificateItemResponse {
  /** @format uuid */
  trainingId: string;
  trainingType: TrainingType;
  name: string;
  thumbnailUrl: string;
  contentTypeName: string;
  /** @format date-time */
  certificateValidUntil: Date | null;
  newCertificateInProgress: boolean;
  certificateStatus: CertificateStatus;
  /** @format uuid */
  inProgressEnrollmentId: string | null;
  /** @format uuid */
  certificateEnrollmentId: string;
}

export type EvolutionTrainingCertificateItemResponseIEquatable = object;

export interface EvolutionTrainingCertificatesListQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  userId: string;
  filterBy: EvolutionTrainingCertificatesFilterBy;
}

export interface EvolutionTrainingCertificatesResponse {
  items: EvolutionTrainingCertificateItemResponse[];
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageOffset: number;
  hasPreviousPage: boolean;
  hasNextPage: boolean;
  counters: EvolutionTrainingCertificateCounters;
}

export type EvolutionTrainingCertificatesResponseIRequest = object;

export interface EvolutionTrainingCounters {
  /** @format int32 */
  total: number;
  /** @format int32 */
  approved: number;
  /** @format int32 */
  reproved: number;
  /** @format int32 */
  inProgress: number;
}

export interface EvolutionTrainingItemResponse {
  /** @format uuid */
  enrollmentId: string;
  status: EnrollStatus;
  trainingName: string;
  trainingThumbnailUrl: string;
  trainingContentTypeName: string;
  /** @format date-time */
  finalizationDate: Date;
  /** @format date-time */
  dueDate: Date | null;
  /** @format date-time */
  certificateValidUntil: Date | null;
  certificateStatus: CertificateStatus | null;
  /** @format double */
  scorePercent: number | null;
}

export type EvolutionTrainingItemResponseIEquatable = object;

export interface EvolutionTrainingResponse {
  items: EvolutionTrainingItemResponse[];
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageOffset: number;
  hasPreviousPage: boolean;
  hasNextPage: boolean;
  counters: EvolutionTrainingCounters;
}

export type EvolutionTrainingResponseIRequest = object;

export interface EvolutionTrainingResumeQuery {
  /** @format uuid */
  userId: string;
}

export interface EvolutionTrainingResumeResponse {
  /** @format double */
  trainingIndex: number | null;
  /** @format int32 */
  finishedCount: number;
  /** @format int32 */
  approvedCount: number;
  /** @format int32 */
  certificateCount: number;
  /** @format int32 */
  expiredCount: number;
  /** @format int32 */
  deadlineCount: number;
  /** @format double */
  scoreAvg: number | null;
  /** @format double */
  approvalTax: number;
  /** @format double */
  deadlineTax: number;
  topics: EvolutionTrainingTopicResponse[];
  certificateTotals: TrainingPanelCertificationFields;
}

export type EvolutionTrainingResumeResponseIEquatable = object;

export type EvolutionTrainingResumeResponseIRequest = object;

export interface EvolutionTrainingTopicResponse {
  /** @format uuid */
  topicId: string;
  name: string;
  /** @format int32 */
  approvedCount: number;
  /** @format int32 */
  certificateCount: number;
}

export type EvolutionTrainingTopicResponseIEquatable = object;

export interface EvolutionTrainingsListQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  userId: string;
  filterBy: EvolutionTrainingFilterBy;
}

export type ExcelExportResultIRequest = object;

export interface ExecuteOperationCommand {
  /** @format uuid */
  carouselId: string;
  option: CarouselOperationOption;
}

export interface ExecuteUserOperationCommand {
  operation: UserOperationType;
  userIds: string[];
  options: ExecuteUserOperationOptions;
}

export interface ExecuteUserOperationOptions {
  tag: UserOperationTagProps | null;
  group: UserOperationGroupProps | null;
  topic: UserOperationTopicProps | null;
  role: UserOperationRoleProps | null;
  unit: UserOperationUnitProps | null;
  management: UserOperationManagementProps | null;
  generalInfo: UserOperationGeneralInfoProps | null;
  additionalInfo: UserOperationAdditionalInfoProps | null;
  block: UserOperationBlockProps | null;
  broadcastMessage: UserOperationBroadcastMessageProps | null;
}

export type ExecuteUserOperationOptionsIEquatable = object;

export interface ExportAssAnalysisGroupPeopleListCommand {
  /** @format uuid */
  groupId: string;
}

export interface ExportAssAnalysisGroupQuestionListCommand {
  /** @format uuid */
  groupId: string;
}

export interface ExportAssAnalysisPeopleListCommand {
  /** @format uuid */
  assessmentId: string;
}

export interface ExportAssAnalysisQuestionListCommand {
  /** @format uuid */
  assessmentId: string;
}

export interface ExportEvolutionChallengeTopicsCommand {
  /** @format uuid */
  userId: string;
  option: DashChallengeAnalysisOption;
}

export interface ExportITGeneralTopicsListCommand {
  /** @format int32 */
  yearMonth: number;
}

export interface ExportITGeneralUnitsListCommand {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format int32 */
  yearMonth: number;
  searchText: string;
  orderBy: TrainingIndexOrderBy;
  onlyDeleted: boolean;
}

export interface ExportITGeneralUsersListCommand {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format int32 */
  yearMonth: number;
  orderBy: TrainingIndexOrderBy;
  searchText: string | null;
}

export interface ExportITTeamEvolutionCommand {
  /** @format uuid */
  managerId: string;
  /** @format uuid */
  topicId: string | null;
  allSubordinates: boolean;
}

export interface ExportITTeamTopicsListCommand {
  /** @format uuid */
  managerId: string;
  /** @format int32 */
  yearMonth: number;
  allSubordinates: boolean;
}

export interface ExportITTeamUsersListCommand {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  managerId: string;
  /** @format int32 */
  yearMonth: number;
  searchText: string | null;
  allSubordinates: boolean;
  isAggregated: boolean;
  /** @format uuid */
  topicId: string | null;
}

export interface ExportITTopicEvolutionCommand {
  /** @format uuid */
  topicId: string;
}

export interface ExportITTopicUnitsListCommand {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  topicId: string;
  /** @format int32 */
  yearMonth: number;
  searchText: string;
  orderBy: TrainingIndexOrderBy;
}

export interface ExportITTopicUsersListCommand {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  topicId: string;
  /** @format int32 */
  yearMonth: number;
  orderBy: TrainingIndexOrderBy;
  searchText: string | null;
}

export interface ExportITUnitEvolutionCommand {
  /** @format uuid */
  unitId: string;
  /** @format uuid */
  topicId: string | null;
  isAggregated: boolean;
}

export interface ExportITUnitTopicsListCommand {
  /** @format uuid */
  unitId: string;
  /** @format int32 */
  yearMonth: number;
  isAggregated: boolean;
}

export interface ExportITUnitUsersListCommand {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  unitId: string;
  /** @format int32 */
  yearMonth: number;
  orderBy: TrainingIndexOrderBy;
  searchText: string | null;
  includeDescendants: boolean;
  /** @format uuid */
  topicId: string | null;
}

export interface ExportITUserEvolutionCommand {
  /** @format uuid */
  userId: string;
  /** @format uuid */
  topicId: string | null;
}

export interface ExportITUserTopicsListCommand {
  /** @format uuid */
  userId: string;
  /** @format int32 */
  yearMonth: number;
}

export interface ExportITUserTrainingsCommand {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  userId: string;
  /** @format uuid */
  topicId: string | null;
}

export interface ExportTrainingPanelAnalysisCommand {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  cacheId: string;
  /** @format uuid */
  trainingId: string | null;
  /** @format uuid */
  classroomId: string | null;
  /** @format uuid */
  topicId: string | null;
  dataset: TrainingPanelAnalyseDimension;
  drillOption: TrainingPanelDrillOption;
  orderDirection: TrainingPanelOrderDirection;
  enrollFilter: TrainingPanelEnrollFilter | null;
}

export interface ExportTrainingPanelAssAnalysisPeopleListCommand {
  /** @format uuid */
  cacheId: string;
}

export interface ExportTrainingPanelAssAnalysisQuestionListCommand {
  /** @format uuid */
  cacheId: string;
}

export interface ExternalCourseRulesDto {
  /** @format uuid */
  trainingId: string;
  trainingType: TrainingType;
  name: string;
  timezoneId: string;
  multipleClasses: boolean;
  hasActiveEnrollments: boolean;
  hasClosedEnrollments: boolean;
  /** @format date-time */
  createdOn: Date;
  allowRegistrationOverride: boolean;
  allowReservationsOverride: boolean;
  allowPreRequisitesOverride: boolean;
  allowExecutionOverride: boolean;
  allowAssessmentOverride: boolean;
  allowCerticateOverride: boolean;
  allowAgreementOverride: boolean;
  allowInteractionOverride: boolean;
  allowAwardOverride: boolean;
  agreement: TrainingRulesAgreementDto;
  assessment: TrainingRulesAssessmentDto;
  autoEnrollLimits: TrainingRulesAutoEnrollLimitsDto;
  award: TrainingRulesAwardDto;
  certificate: TrainingRulesCertificateDto;
  execution: TrainingRulesExecutionDto;
  interaction: TrainingRulesInteractionDto;
  registration: TrainingRulesRegistrationDto;
  seats: TrainingRulesSeatsDto;
  preRequisites: TrainingRulesPreRequisitesDto;
  fullManaged: boolean;
  allowConclusionFormOverride: boolean;
  conclusionForm: TrainingRulesConclusionFormDto;
}

export type ExternalCourseRulesDtoIEquatable = object;

export type ExternalCourseRulesDtoIRequest = object;

export interface ExternalCourseRulesQuery {
  /** @format uuid */
  trainingId: string;
}

export interface ExternalCourseTrainingQuery {
  /** @format uuid */
  trainingId: string;
}

export interface FavoriteActionResult {
  success: boolean;
  /** @format uuid */
  listId: string;
  name: string;
}

export type FavoriteActionResultIRequest = object;

export interface FeedAnswerDefinition {
  /** @format uuid */
  questionId: string;
  questionIsAvailable: boolean;
  isBestAnswer: boolean;
  questionHasDetail: boolean;
  /** @format int32 */
  answerCount: number;
}

export interface FeedAttachDto {
  /** @format uuid */
  attachId: string;
  attachType: PublicationAttachType;
  isEmbed: boolean;
  caption: string | null;
  binderPageRefId: string | null;
  streamingExceeded: boolean;
  /** @format uuid */
  fileId: string | null;
  fileMimeType: string | null;
  fileTitle: string | null;
  fileName: string | null;
  fileDescription: string | null;
  filePosterUrl: string | null;
  /** @format int64 */
  fileDuration: number | null;
  /** @format int32 */
  fileWidth: number | null;
  /** @format int32 */
  fileHeight: number | null;
  fileEncodedUrls: MediaServicePublishUrls | null;
  fileMediaTracks: MediaTrackModel[] | null;
  aiAnalysis: AiAnalysisDto | null;
  /** @format uuid */
  thumbnailId: string | null;
  /** @format int32 */
  thumbnailWidth: number | null;
  /** @format int32 */
  thumbnailHeight: number | null;
  /** @format uuid */
  cardImageId: string | null;
  /** @format int32 */
  cardWidth: number | null;
  /** @format int32 */
  cardHeight: number | null;
  linkProvider: string | null;
  linkExternalId: string | null;
  linkType: string | null;
  linkSourceUrl: string | null;
  linkTitle: string | null;
  linkDescription: string | null;
  linkAuthorName: string | null;
  linkThumbnailUrl: string | null;
  /** @format int64 */
  linkDuration: number | null;
  /** @format int32 */
  linkWidth: number | null;
  /** @format int32 */
  linkHeight: number | null;
  hasTranscription: boolean;
  hasSearchData: boolean;
  mediaCompleted: boolean | null;
  /** @format int64 */
  lastMediaPosition: number | null;
  playable: boolean | null;
}

export interface FeedBestAnswer {
  content: string | null;
  contentLoadStatus: FeedContentLoadStatus;
  /** @format uuid */
  thumbnailId: string | null;
}

export interface FeedBlock {
  blocker: UserShortView;
  /** @format date-time */
  blockedOn: Date;
  message: string | null;
  firstAccessAfterBlock: boolean;
  unblockRequest: FeedUnblock | null;
}

export interface FeedChannel {
  /** @format uuid */
  id: string;
  name: string;
  isActive: boolean;
}

export interface FeedChannelHeaderQuery {
  /** @format uuid */
  channelId: string;
}

export interface FeedChannelHeaderResponse {
  /** @format uuid */
  channelId: string;
  name: string;
  description: string | null;
  thumbnailUrl: string;
  /** @format int32 */
  totalPublications: number;
  /** @format int32 */
  totalSubscribers: number;
  muted: boolean;
  autoRegisterMode: ChannelAutoRegisterMode;
  directMember: boolean;
  indirectMember: boolean;
  pendingApproval: boolean;
  pendingSubscription: boolean;
  registered: boolean;
  isOwnerChannel: boolean;
  allowInviteUser: boolean;
  allowManageMember: boolean;
  allowManageChannel: boolean;
  allowManagePublication: boolean;
  allowJoinChannel: boolean;
  allowDelete: boolean;
  allowCreatePublication: boolean;
}

export type FeedChannelHeaderResponseIEquatable = object;

export type FeedChannelHeaderResponseIRequest = object;

export interface FeedChannelPanelTopicsMentionQuery {
  /** @format uuid */
  channelId: string;
}

export interface FeedChannelPanelUsersMostPublicationQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  channelId: string;
  searchText: string | null;
}

export interface FeedChannelQuery {
  /** @format int32 */
  startIndex: number;
  /** @format int32 */
  endIndex: number;
  /** @format uuid */
  channelId: string;
  /** @format uuid */
  startPublicationId: string | null;
  filters: KnowledgeFeedFilter[] | null;
  order: KnowledgeFeedOrder | null;
  searchText: string | null;
}

export interface FeedChannelQuickFilterQuery {
  /** @format uuid */
  channelId: string;
}

export interface FeedChannelSuggestionsQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  searchText: string | null;
}

export interface FeedDataDto {
  /** @format int32 */
  totalRows: number;
  items: FeedItemDto[];
}

export type FeedDataDtoIRequest = object;

export interface FeedHistoryQuery {
  /** @format int32 */
  startIndex: number;
  /** @format int32 */
  endIndex: number;
  /** @format uuid */
  startPublicationId: string | null;
  searchText: string | null;
  type: FeedHistoryType;
}

export interface FeedIdName {
  /** @format uuid */
  id: string;
  name: string;
}

export interface FeedInstitutionalInfo {
  /** @format uuid */
  thumbnailId: string | null;
  thumbnailUrl: string;
  name: string;
}

export interface FeedInteractionDto {
  allowEdit: boolean;
  allowDelete: boolean;
  allowBlock: boolean;
  allowUnblock: boolean;
  allowClassify: boolean;
  allowChannelPinned: boolean;
  allowPromoteVideo: boolean;
  allowDownloadVideoOrAudio: boolean;
  allowViewHistory: boolean;
  allowWhoView: boolean;
  allowWhoLikes: boolean;
  allowCreateQuestion: boolean;
  allowRelatedContent: boolean;
  allowShare: boolean;
  allowAddLists: boolean;
  allowLike: boolean;
  allowReorder: boolean;
  allowAddThread: boolean;
  allowIaExplains: boolean;
  canDeletePermanently: boolean;
  allowGenerateAIQuestion: boolean;
  listInteraction: FeedListInteractionDto | null;
  hasLiked: boolean;
  hasCommented: boolean;
  hasFavorited: boolean;
  isNewPublication: boolean;
  reclassified: boolean;
  followingPublication: boolean;
  recomended: boolean | null;
  pendingTask: FeedTaskDto | null;
  isVisible: boolean;
}

export interface FeedItemDto {
  /** @format int32 */
  rowNumber: number;
  /** @format uuid */
  publicationId: string;
  publicationType: PublicationType;
  classificationType: PublicationClassificationType;
  classificationTypeName: string;
  /** @format date-time */
  deletedOn: Date | null;
  thumbnailUrl: string | null;
  masterPublication: MasterPublicationDto | null;
  listExclusive: ListExclusiveDto | null;
  channel: FeedChannel | null;
  sticker: FeedSticker | null;
  topics: FeedIdName[] | null;
  author: UserShortView;
  /** @format date-time */
  createdOn: Date;
  /** @format date-time */
  modifiedOn: Date;
  /** @format date-time */
  publishedOn: Date | null;
  /** @format date-time */
  contentModifiedDate: Date | null;
  /** @format date-time */
  editedOn: Date | null;
  supervisor: UserShortView | null;
  /** @format date-time */
  viewPeriodStart: Date | null;
  /** @format date-time */
  viewPeriodEnd: Date | null;
  expired: boolean;
  availableInTheFuture: boolean;
  /** @format date-time */
  viewStickerUntil: Date | null;
  approvalStatus: PublicationApprovalStatus | null;
  /** @format date-time */
  firstApprovalDate: Date | null;
  blocked: FeedBlock | null;
  rejected: FeedModerationRejected | null;
  readOnly: boolean;
  isPrivate: boolean | null;
  isAnonymous: boolean | null;
  isDraft: boolean | null;
  isThread: boolean;
  institutional: FeedInstitutionalInfo | null;
  /** @format date-time */
  channelPinnedOn: Date | null;
  publicationSource: KnowledgeUserMixPublicationSource | null;
  publicationSourceName: string | null;
  title: string;
  language: string | null;
  content: string | null;
  contentLoadStatus: FeedContentLoadStatus;
  /** @format uuid */
  firstImageAttachId: string | null;
  presentation: PublicationPresentation | null;
  attachs: FeedAttachDto[] | null;
  mentions: FeedMentionDto[] | null;
  shortVideo: FeedShortVideoDto | null;
  otherInfo: FeedOtherInfoDto;
  listDefinition: FeedListDefinition | null;
  answerDefinition: FeedAnswerDefinition | null;
  questionDefinition: FeedQuestionDefinition | null;
  pollDefinition: FeedPollDefinition | null;
  interaction: FeedInteractionDto;
  moderateReport: FeedModerateReportDto | null;
  moderatePublication: FeedModeratePublicationDto | null;
  /** @format int32 */
  totalRows: number;
}

export type FeedItemDtoIEnumerableIRequest = object;

export type FeedItemDtoIRequest = object;

export interface FeedItemDtoPaginatedList {
  items: FeedItemDto[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type FeedItemDtoPaginatedListIRequest = object;

export interface FeedItemQuery {
  /** @format uuid */
  publicationId: string;
  markRead?: boolean | null;
  loadContent?: boolean | null;
}

export interface FeedListByTypeQuery {
  listType: PublicationListType;
}

export interface FeedListDefinition {
  listType: PublicationListType;
  isPublic: boolean;
  /** @format int32 */
  itemCount: number;
  openInPlayback: boolean;
  thumbnailUrl: string;
  /** @format date-time */
  lastUpdateItemsDate: Date | null;
  isCollaborator: boolean;
  /** @format int32 */
  followersCount: number;
}

export interface FeedListInteractionDto {
  allowAddItems: boolean;
  allowClearOrReorder: boolean;
  allowCollaboration: boolean;
}

export interface FeedListQuery {
  /** @format int32 */
  startIndex: number;
  /** @format int32 */
  endIndex: number;
  /** @format uuid */
  startPublicationId: string | null;
  /** @format uuid */
  listPublicationId: string;
  /** @format uuid */
  itemPublicationId: string | null;
  searchText: string | null;
  orderBy: FeedListQueryOrderBy;
}

export interface FeedMentionDto {
  /** @format uuid */
  mentionId: string | null;
  mentionType: MentionType;
}

export interface FeedModeratePublicationDto {
  /** @format uuid */
  actionId: string;
  aiAnalysis: AiAnalysisDto;
}

export interface FeedModerateReportCommentDto {
  /** @format uuid */
  commentId: string;
  /** @format date-time */
  createdOn: Date;
  content: string;
  contentLoadStatus: FeedContentLoadStatus;
  author: UserShortView;
}

export interface FeedModerateReportDto {
  /** @format uuid */
  actionId: string;
  requester: UserShortView;
  /** @format date-time */
  requestedOn: Date;
  reason: PublicationActionType;
  reasonName: string;
  message: string | null;
  comment: FeedModerateReportCommentDto | null;
  /** @format int32 */
  otherCount: number;
  analysed: boolean;
}

export interface FeedModerationRejected {
  moderator: UserShortView;
  /** @format date-time */
  rejectedOn: Date;
  message: string | null;
  firstAccessAfterRejected: boolean;
}

export interface FeedMyAnswersQuery {
  /** @format int32 */
  startIndex: number;
  /** @format int32 */
  endIndex: number;
  /** @format uuid */
  startPublicationId: string | null;
  searchText: string | null;
  isBlocked: boolean | null;
  moderationPending: boolean | null;
  isRejected: boolean | null;
  orderBy: KnowledgeFeedOrder;
}

export interface FeedMyContributionsQuery {
  /** @format int32 */
  startIndex: number;
  /** @format int32 */
  endIndex: number;
  /** @format uuid */
  startPublicationId: string | null;
  searchText: string | null;
  isBlocked: boolean | null;
  moderationPending: boolean | null;
  isRejected: boolean | null;
  expiredPeriod: boolean | null;
  futurePeriod: boolean | null;
  isInstitutional: boolean | null;
  nonInstitutional: boolean | null;
  orderBy: KnowledgeFeedOrder;
}

export interface FeedMyDraftsQuery {
  /** @format int32 */
  startIndex: number;
  /** @format int32 */
  endIndex: number;
  /** @format uuid */
  startPublicationId: string | null;
  searchText: string | null;
  orderBy: KnowledgeFeedOrder;
}

export interface FeedMyListsQuery {
  /** @format int32 */
  startIndex: number;
  /** @format int32 */
  endIndex: number;
  /** @format uuid */
  startPublicationId: string | null;
  searchText: string | null;
  type: FeedMyListsType;
  orderBy: FeedMyListsOrderBy;
}

export interface FeedOtherInfoDto {
  /** @format int32 */
  likeCount: number;
  /** @format int32 */
  commentCount: number;
  /** @format int32 */
  viewCount: number;
  /** @format int32 */
  shareCount: number;
  /** @format int32 */
  followerCount: number;
  /** @format int32 */
  approvalCount: number;
  /** @format int32 */
  reportCount: number;
  /** @format int64 */
  totalStorageSize: number;
  /** @format double */
  trendingScore: number | null;
}

export interface FeedPanelUserCredentialsQuery {
  /** @format uuid */
  userId: string;
}

export interface FeedPanelUserCredentialsResponse {
  /** @format uuid */
  credentialId: string;
  credentialType: UserCredentialType;
  title: string;
  description: string | null;
  /** @format date-time */
  startedOn: Date | null;
  /** @format date-time */
  finishedOn: Date | null;
}

export type FeedPanelUserCredentialsResponseIEquatable = object;

export type FeedPanelUserCredentialsResponseListIRequest = object;

export interface FeedPanelUserFollowersQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  userId: string;
  searchText: string | null;
}

export interface FeedPanelUserFollowingQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  userId: string;
  searchText: string | null;
}

export interface FeedPanelUserStatisticQuery {
  /** @format uuid */
  userId: string;
}

export interface FeedPanelUsersSameInterestTagQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  tagId: string;
  searchText: string | null;
}

export interface FeedPollAnswerResults {
  /** @format uuid */
  id: string;
  /** @format int32 */
  voteCount: number;
}

export interface FeedPollDefinition {
  allowNewAnswers: boolean;
  /** @format date-time */
  allowAnswersUntil: Date | null;
  anonymousAnswers: boolean;
  /** @format uuid */
  selectedAnswerId: string | null;
  answerOptions: PollItemModel[];
  results: FeedPollResults;
}

export interface FeedPollResults {
  /** @format int32 */
  answerCount: number;
  answerResults: FeedPollAnswerResults[];
}

export type FeedPollResultsIRequest = object;

export interface FeedPublicationAdminQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  filters: KnowledgeFeedFilter[] | null;
  order: KnowledgeFeedOrder | null;
  searchText: string | null;
  onlyTrashedOut: boolean;
  includeBlockedExpiredOrAvailableInFuture: boolean;
  includeChannelsAdminPermission: boolean;
}

export interface FeedPublicationAdminRestrictionsQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  filters: KnowledgeFeedFilter[] | null;
  searchText: string | null;
  includeBlockedExpiredOrAvailableInFuture: boolean;
}

export interface FeedQuestionDefinition {
  /** @format uuid */
  bestAnswerId: string | null;
  /** @format date-time */
  lastAnswerDate: Date | null;
  hasDetail: boolean;
  /** @format int32 */
  answerCount: number;
  answer: FeedBestAnswer | null;
}

export interface FeedQuestionFollowingQuery {
  /** @format int32 */
  startIndex: number;
  /** @format int32 */
  endIndex: number;
  /** @format uuid */
  startPublicationId: string | null;
  searchText: string | null;
  viewAs: FeedQuestionViewAs;
}

export interface FeedQuestionQuery {
  /** @format int32 */
  startIndex: number;
  /** @format int32 */
  endIndex: number;
  /** @format uuid */
  questionPublicationId: string;
  /** @format uuid */
  answerId: string | null;
  searchText: string | null;
  /** @format uuid */
  startPublicationId: string | null;
  orderBy: FeedQuestionQueryOrderBy;
}

export interface FeedQuestionRecentQuery {
  /** @format int32 */
  startIndex: number;
  /** @format int32 */
  endIndex: number;
  /** @format uuid */
  startPublicationId: string | null;
  searchText: string | null;
  viewAs: FeedQuestionViewAs;
}

export interface FeedQuestionToYouQuery {
  /** @format int32 */
  startIndex: number;
  /** @format int32 */
  endIndex: number;
  /** @format uuid */
  startPublicationId: string | null;
  searchText: string | null;
  viewAs: FeedQuestionViewAs;
}

export interface FeedShortVideoDto {
  /** @format uuid */
  attachId: string;
  /** @format int64 */
  startTime: number;
  /** @format int64 */
  endTime: number;
  played: boolean;
}

export interface FeedShortVideoQuery {
  /** @format int32 */
  startIndex: number;
  /** @format int32 */
  endIndex: number;
}

export interface FeedStartupQuery {
  /** @format int32 */
  startIndex: number;
  /** @format int32 */
  endIndex: number;
  /** @format uuid */
  startPublicationId: string | null;
  filters: KnowledgeFeedFilter[] | null;
  order: KnowledgeFeedOrder | null;
  searchText: string | null;
}

export interface FeedSticker {
  /** @format uuid */
  id: string;
  name: string;
  textColor: string;
  backgroundColor: string;
}

export interface FeedTaskDto {
  owner: UserShortView;
  /** @format date-time */
  dueDate: Date | null;
  ownerComment: string | null;
}

export interface FeedThreadItemsQuery {
  /** @format uuid */
  masterPublicationId: string;
}

export interface FeedTopicHeaderQuery {
  /** @format uuid */
  topicId: string;
}

export interface FeedTopicHeaderResponse {
  /** @format uuid */
  topicId: string;
  name: string;
  description: string | null;
  thumbnailUrl: string;
  /** @format int32 */
  publicationCount: number;
  /** @format int32 */
  subscriptionCount: number;
  required: boolean;
  registered: boolean;
  muted: boolean;
  allowUserAutoInterest: boolean;
  isDirectUser: boolean;
  hasChallengeToAnswer: boolean;
  pendingChallengeName: string | null;
  /** @format uuid */
  challengeInstanceId: string | null;
  hasChildren: boolean;
  allowManageUser: boolean;
  allowManageRelated: boolean;
  allowManageTopic: boolean;
  allowChallenge: boolean;
  allowJoin: boolean;
  allowDelete: boolean;
}

export type FeedTopicHeaderResponseIEquatable = object;

export type FeedTopicHeaderResponseIRequest = object;

export interface FeedTopicPanelChannelMostMentionQuery {
  /** @format uuid */
  topicId: string;
}

export interface FeedTopicPanelRelationQuery {
  /** @format uuid */
  topicId: string;
}

export interface FeedTopicPanelSpecialistInterestQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  topicId: string;
  searchText: string | null;
}

export interface FeedTopicQuery {
  /** @format int32 */
  startIndex: number;
  /** @format int32 */
  endIndex: number;
  /** @format uuid */
  topicId: string;
  /** @format uuid */
  startPublicationId: string | null;
  filters: KnowledgeFeedFilter[] | null;
  order: KnowledgeFeedOrder | null;
  searchText: string | null;
  includeDescendants: boolean;
}

export interface FeedTopicQuickFilterQuery {
  /** @format uuid */
  topicId: string;
}

export interface FeedUnblock {
  message: string | null;
  /** @format date-time */
  requestedOn: Date;
}

export interface FeedUserPanelPersonalInterestQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  userId: string;
  searchText: string | null;
}

export interface FeedUserPanelProfessionalInterestQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  userId: string;
  searchText: string | null;
}

export interface FeedUserProfileQuery {
  /** @format int32 */
  startIndex: number;
  /** @format int32 */
  endIndex: number;
  /** @format uuid */
  userId: string;
  /** @format uuid */
  startPublicationId: string | null;
  filters: KnowledgeFeedFilter[] | null;
  order: KnowledgeFeedOrder | null;
  searchText: string | null;
  selectionType: FeedAuthorSelectionType;
}

export interface FeedUserQuickFilterQuery {
  /** @format uuid */
  userId: string;
  isPublication: boolean;
}

export interface FieldValueItem {
  fieldId: string;
  fieldValue: string | null;
}

export type FieldValueItemIEquatable = object;

export interface FileGetDto {
  /** @format uuid */
  fileId: string;
  url: string;
  mimetype: string;
  /** @format date-time */
  createdOn?: Date;
  metadata: StorageMetadataModel;
  mediaTracks?: MediaTrackModel[] | null;
  posterUrl?: string | null;
}

export type FileGetDtoIEquatable = object;

export type FilePostDtoIEquatable = object;

export interface FileUploadResultDto {
  /** @format uuid */
  fileId: string;
  url: string;
  mimetype: string;
  metadata: ParsedFileResult;
}

export type FileUploadResultDtoIEquatable = object;

export interface FinishAssInstanceCommand {
  /** @format uuid */
  instanceId: string;
  /** @format double */
  elapsedTime: number | null;
}

export interface FinishedTrainingsQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  searchText: string | null;
  browserTimeZoneId: string;
}

export interface FtpConnectionTestCommand {
  settings: ImportUserRemoteModel;
}

export interface GeneralResult {
  final: string | null;
  finalColor: string | null;
  isFinalPercent: boolean | null;
  partial: string | null;
  partialColor: string | null;
  isPartialPercent: boolean | null;
  correctiveActions: string | null;
  correctiveActionsColor: string | null;
  correctiveDelayed: string | null;
  correctiveDelayedColor: string | null;
}

export interface GetAdvancedOptionsSettingsQuery {
  /** @format uuid */
  channelId: string;
}

export interface GetAnswerPublicationDto {
  /** @format uuid */
  publicationId: string;
  publicationType: PublicationType;
  title: string;
  content: string | null;
  attachs: GetPublicationAttachDto[];
  presentation: GetPublicationPresentationDto | null;
  isAnonymous: boolean;
  isDraft: boolean;
}

export type GetAnswerPublicationDtoIRequest = object;

export interface GetAnswerPublicationQuery {
  /** @format uuid */
  publicationId: string;
}

export interface GetAssessmentPropsDto {
  course: CoursePropsDto;
  assessment: AssessmentPropsDto;
}

export type GetAssessmentPropsDtoIEquatable = object;

export type GetAssessmentPropsDtoIRequest = object;

export interface GetAttachTranscriptionQuery {
  /** @format uuid */
  attachId: string;
  searchText: string | null;
}

export interface GetBinderPublicationDto {
  /** @format uuid */
  publicationId: string;
  publicationType: PublicationType;
  title: string;
  content: string | null;
  attachs: GetPublicationAttachDto[];
  presentation: GetPublicationPresentationDto | null;
  channel: GetPublicationChannelDto;
  topics: TopicAutoCompleteHierarchicalModelDto[];
  isDraft: boolean;
  editJustification: string | null;
  advancedOptions: GetPublicationAdvancedOptionsDto;
}

export type GetBinderPublicationDtoIRequest = object;

export interface GetBinderPublicationQuery {
  /** @format uuid */
  publicationId: string;
}

export interface GetChallengeInstanceQuery {
  /** @format uuid */
  instanceId: string;
}

export interface GetChallengeResultQuery {
  /** @format uuid */
  instanceId: string;
}

export interface GetComponentPropsDto {
  itemTraining: ItemTrainingDto;
  phase: PhasePropsDto | null;
  course: CourseLearnPathPropsDto;
  learnPath: LearnPathPropsDto;
}

export type GetComponentPropsDtoIEquatable = object;

export type GetComponentPropsDtoIRequest = object;

export interface GetCourseTrainingDto {
  /** @format uuid */
  trainingId: string;
  trainingType: TrainingType;
  trainingContentType: TrainingContentType;
  name: string;
  description: string | null;
  objectives: string | null;
  author: string | null;
  externalCode: string | null;
  language: string | null;
  /** @format int32 */
  trainingDurationHours: number | null;
  /** @format int32 */
  trainingDurationMinutes: number | null;
  thumbnail: FileGetDto | null;
  initialThumbnailUrl: string;
  promotionVideoThumbnailUrl: string | null;
  promotionVideo: FileGetDto | null;
  isActive: boolean;
  timezoneId: string;
  /** @format uuid */
  uniqueClassroomId: string | null;
  /** @format date-time */
  publishedOn: Date | null;
  sticker: SelectedStickerDto | null;
  indexAndUseTagsInGlobalSearch: boolean;
  topics: TopicAutoCompleteHierarchicalModelDto[];
  tags: TagAutoCompleteDataModelDto[];
  specialists: AutoCompleteDataModelDto[];
  coordinators: AutoCompleteDataModelDto[];
  owners: AutoCompleteDataModelDto[];
  equivalents: AutoCompleteDataModelDto[];
  seeAlsoTrainings: AutoCompleteDataModelDto[];
  recordInfo: RecordInfoDto | null;
  customFields: CustomFieldValueDto[];
  hasAnyVersionPublished: boolean;
  /** @format int32 */
  activeEnrollmentsCount: number;
  /** @format int32 */
  closedEnrollmentsCount: number;
  isExclusive: boolean;
  /** @format double */
  ratingAvg: number;
  /** @format int32 */
  ratingStars: number;
  /** @format int32 */
  ratingCount: number;
  availableOnMobile: boolean;
  multipleClasses: boolean;
  multipleClassesPrefix: string | null;
  instructors: AutoCompleteDataModelDto[];
  equivalentsNeedAll: boolean;
  equivalentCreateReverse: boolean;
  hasMettingsOrActivityWithDateDefinined: boolean;
}

export type GetCourseTrainingDtoIRequest = object;

export interface GetCreationSettingsQuery {
  /** @format uuid */
  defaultChannelId: string | null;
  /** @format uuid */
  defaultTopicId: string | null;
  /** @format uuid */
  exclusiveListId: string | null;
}

export interface GetCurrentAgreementQueryResponse {
  /** @format uuid */
  agreementId: string;
  text: string;
  /** @format uuid */
  fileId: string | null;
  fileMimetype: string | null;
  fileUrl: string | null;
}

export type GetCurrentAgreementQueryResponseIEquatable = object;

export type GetCurrentAppAuthenticatorInfoQuery = object;

export interface GetCurrentAppAuthenticatorInfoResponse {
  twoFactorAppActived: boolean;
}

export type GetCurrentAppAuthenticatorInfoResponseIEquatable = object;

export type GetCurrentAppAuthenticatorInfoResponseIRequest = object;

export interface GetDeployQuestionQuery {
  /** @format uuid */
  deployId: string;
  /** @format uuid */
  instanceId: string | null;
  /** @format uuid */
  questionIdRef: string | null;
  /** @format int32 */
  versionRef: number | null;
  action: ActionPlayerSelectQuestion;
}

export interface GetDeploySummaryQuery {
  /** @format uuid */
  deployId: string;
  /** @format uuid */
  instanceId: string | null;
}

export interface GetDevPlanActivityPublicationDto {
  /** @format uuid */
  publicationId: string;
  publicationType: PublicationType;
  title: string;
  content: string | null;
  attachs: GetPublicationAttachDto[];
  presentation: GetPublicationPresentationDto | null;
}

export type GetDevPlanActivityPublicationDtoIRequest = object;

export interface GetDiscussionDto {
  /** @format uuid */
  discussionId: string;
  /** @format uuid */
  parentId: string | null;
  /** @format uuid */
  replyId: string | null;
  /** @format int64 */
  sequenceNum: number;
  message: string;
  summary: string | null;
  lazyLoadContent: boolean;
  /** @format date-time */
  createdOn: Date;
  /** @format date-time */
  modifiedOn: Date;
  createdBy: UserShortView;
  repliedBy: UserShortView | null;
  deletedBy: UserShortView | null;
  interactions: DiscussionItemInteractionDto;
  actions: DiscussionItemActionsDto;
  deleted: boolean;
  /** @format int32 */
  answerCount: number;
  abuseReported: boolean;
  discussionType: DiscussionType;
  /** @format int32 */
  totalRows: number;
}

export type GetDiscussionDtoIEquatable = object;

export type GetDiscussionDtoIRequest = object;

export interface GetEvalInstanceQuery {
  /** @format uuid */
  instanceId: string;
}

export interface GetEvalResultInstanceQuery {
  /** @format uuid */
  instanceId: string;
}

export interface GetEvaluationDto {
  /** @format uuid */
  assessmentId: string;
  name: string;
  isBlocked: boolean;
  thumbnail: FileGetDto | null;
  instructions: string | null;
  /** @format int32 */
  applyCount: number;
  /** @format date-time */
  publishedOn: Date | null;
  makeAvailable: boolean;
  canManage: boolean;
  externalCode: string | null;
  language: string | null;
  author: string | null;
  topics: TopicAutoCompleteHierarchicalModelDto[];
  tags: TagAutoCompleteDataModelDto[];
  owners: AutoCompleteDataModelDto[];
  isRecovery: boolean;
  allowGoback: boolean;
  allowContinueAbortedEvaluation: boolean;
  showQuestionPoints: boolean;
  hasTimeToComplete: boolean;
  /** @format timespan */
  timeToComplete: string | null;
  freezeChronometer: boolean;
  /** @format int32 */
  maxTries: number | null;
  showCorrection: boolean;
  showCorrectAnswer: boolean;
  showFeedback: boolean;
  essayEvaluator: AutoCompleteDataModelDto[];
  description: string | null;
  randomized: boolean;
}

export type GetEvaluationDtoIRequest = object;

export interface GetExternalCourseTrainingDto {
  /** @format uuid */
  trainingId: string;
  trainingType: TrainingType;
  trainingContentType: TrainingContentType;
  name: string;
  description: string | null;
  objectives: string | null;
  author: string | null;
  externalCode: string | null;
  language: string | null;
  /** @format int32 */
  trainingDurationHours: number | null;
  /** @format int32 */
  trainingDurationMinutes: number | null;
  thumbnail: FileGetDto | null;
  initialThumbnailUrl: string;
  promotionVideoThumbnailUrl: string | null;
  promotionVideo: FileGetDto | null;
  isActive: boolean;
  timezoneId: string;
  /** @format uuid */
  uniqueClassroomId: string | null;
  /** @format date-time */
  publishedOn: Date | null;
  sticker: SelectedStickerDto | null;
  indexAndUseTagsInGlobalSearch: boolean;
  topics: TopicAutoCompleteHierarchicalModelDto[];
  tags: TagAutoCompleteDataModelDto[];
  specialists: AutoCompleteDataModelDto[];
  coordinators: AutoCompleteDataModelDto[];
  owners: AutoCompleteDataModelDto[];
  equivalents: AutoCompleteDataModelDto[];
  seeAlsoTrainings: AutoCompleteDataModelDto[];
  recordInfo: RecordInfoDto | null;
  customFields: CustomFieldValueDto[];
  hasAnyVersionPublished: boolean;
  /** @format int32 */
  activeEnrollmentsCount: number;
  /** @format int32 */
  closedEnrollmentsCount: number;
  isExclusive: boolean;
  /** @format double */
  ratingAvg: number;
  /** @format int32 */
  ratingStars: number;
  /** @format int32 */
  ratingCount: number;
  availableOnMobile: boolean;
  fullManaged: boolean;
  multipleClasses: boolean;
  multipleClassesPrefix: string | null;
  equivalentsNeedAll: boolean;
  equivalentCreateReverse: boolean;
  /** @format int32 */
  enrollmentsCount: number;
}

export type GetExternalCourseTrainingDtoIRequest = object;

export interface GetLearnPathTrainingDto {
  /** @format uuid */
  trainingId: string;
  trainingType: TrainingType;
  trainingContentType: TrainingContentType;
  name: string;
  description: string | null;
  objectives: string | null;
  author: string | null;
  externalCode: string | null;
  language: string | null;
  /** @format int32 */
  trainingDurationHours: number | null;
  /** @format int32 */
  trainingDurationMinutes: number | null;
  thumbnail: FileGetDto | null;
  initialThumbnailUrl: string;
  promotionVideoThumbnailUrl: string | null;
  promotionVideo: FileGetDto | null;
  isActive: boolean;
  timezoneId: string;
  /** @format uuid */
  uniqueClassroomId: string | null;
  /** @format date-time */
  publishedOn: Date | null;
  sticker: SelectedStickerDto | null;
  indexAndUseTagsInGlobalSearch: boolean;
  topics: TopicAutoCompleteHierarchicalModelDto[];
  tags: TagAutoCompleteDataModelDto[];
  specialists: AutoCompleteDataModelDto[];
  coordinators: AutoCompleteDataModelDto[];
  owners: AutoCompleteDataModelDto[];
  equivalents: AutoCompleteDataModelDto[];
  seeAlsoTrainings: AutoCompleteDataModelDto[];
  recordInfo: RecordInfoDto | null;
  customFields: CustomFieldValueDto[];
  hasAnyVersionPublished: boolean;
  /** @format int32 */
  activeEnrollmentsCount: number;
  /** @format int32 */
  closedEnrollmentsCount: number;
  isExclusive: boolean;
  /** @format double */
  ratingAvg: number;
  /** @format int32 */
  ratingStars: number;
  /** @format int32 */
  ratingCount: number;
  availableOnMobile: boolean;
  progressByCredits: boolean;
  gamified: boolean;
  componentsAvailableOnMobile: boolean;
}

export type GetLearnPathTrainingDtoIRequest = object;

export interface GetListClassifyPublicationDto {
  /** @format uuid */
  publicationId: string;
  title: string;
  content: string;
  channel: GetPublicationChannelDto;
  topics: TopicAutoCompleteHierarchicalModelDto[];
  isPrivate: boolean;
  advancedOptions: GetPublicationAdvancedOptionsDto;
}

export type GetListClassifyPublicationDtoIRequest = object;

export interface GetListClassifyPublicationQuery {
  /** @format uuid */
  publicationId: string;
}

export interface GetListPermissionsQuery {
  /** @format uuid */
  publicationId: string;
}

export interface GetListPermissionsResponse {
  canAddItems: boolean;
  canCreateExclusive: boolean;
  canEdit: boolean;
}

export type GetListPermissionsResponseIEquatable = object;

export type GetListPermissionsResponseIRequest = object;

export interface GetListPublicationDto {
  /** @format uuid */
  publicationId: string;
  publicationType: PublicationType;
  title: string;
  content: string | null;
  attachs: GetPublicationAttachDto[];
  presentation: GetPublicationPresentationDto | null;
  channel: GetPublicationChannelDto | null;
  topics: TopicAutoCompleteHierarchicalModelDto[];
  isPublicList: boolean;
  isPrivate: boolean;
  allowCollaboration: boolean;
  /** @format uuid */
  firstImageAttach: string | null;
  thumbnail: FileGetDto | null;
  openInPlayback: boolean;
  advancedOptions: GetPublicationAdvancedOptionsDto;
  collaborators: MemberAutoCompleteDataModelDto[];
  hasExclusiveItems: boolean;
}

export type GetListPublicationDtoIRequest = object;

export interface GetListPublicationInPlaybackQuery {
  /** @format uuid */
  listPublicationId: string;
}

export interface GetListPublicationInPlaybackResponse {
  list: FeedItemDto;
  hasSupressed: boolean;
  listItems: ListPublicationItemsDto[];
}

export type GetListPublicationInPlaybackResponseIEquatable = object;

export type GetListPublicationInPlaybackResponseIRequest = object;

export interface GetListPublicationItemsDisplayOrderQuery {
  /** @format uuid */
  listPublicationId: string;
}

export interface GetListPublicationItemsDisplayOrderResponse {
  /** @format uuid */
  publicationId: string;
  title: string;
  /** @format int32 */
  displayOrder: number;
}

export type GetListPublicationItemsDisplayOrderResponseIEnumerableIRequest =
  object;

export type GetListPublicationItemsDisplayOrderResponseIEquatable = object;

export interface GetListPublicationQuery {
  /** @format uuid */
  publicationId: string;
}

export interface GetMeetingRoomQuery {
  /** @format uuid */
  roomId: string | null;
}

export interface GetOpenAIQuestionsFromPubQuery {
  /** @format int32 */
  maxAlternatives: number;
  createFeedback: boolean;
  /** @format int32 */
  numberOfQuestions: number;
  /** @format uuid */
  publicationId: string;
}

export interface GetOpenAIQuestionsRequest {
  /** @format int32 */
  maxAlternatives: number;
  createFeedback: boolean;
  forSurvey: boolean;
  subject: string;
  /** @format int32 */
  numberOfQuestions: number;
}

export interface GetOpenAIQuestionsResponse {
  questions: QuestionOpenAIDto[];
  messageContent: string;
}

export type GetOpenAIQuestionsResponseIRequest = object;

export interface GetPeopleInterestedQuery {
  /** @format uuid */
  publicationId: string;
  /** @format uuid */
  topicId: string | null;
}

export interface GetPeopleInterestedResponse {
  /** @format uuid */
  userId: string;
  name: string;
  thumbnailUrl: string | null;
}

export type GetPeopleInterestedResponseIEquatable = object;

export type GetPeopleInterestedResponseListIRequest = object;

export interface GetPhasePropsDto {
  course: CourseLearnPathPropsDto;
  phase: PhasePropsDto;
}

export type GetPhasePropsDtoIEquatable = object;

export type GetPhasePropsDtoIRequest = object;

export interface GetPollClassifyPublicationDto {
  /** @format uuid */
  publicationId: string;
  title: string;
  content: string;
  channel: GetPublicationChannelDto;
  topics: TopicAutoCompleteHierarchicalModelDto[];
  isPrivate: boolean;
  advancedOptions: GetPublicationAdvancedOptionsDto;
}

export type GetPollClassifyPublicationDtoIRequest = object;

export interface GetPollClassifyPublicationQuery {
  /** @format uuid */
  publicationId: string;
}

export interface GetPollPublicationDto {
  /** @format uuid */
  publicationId: string;
  publicationType: PublicationType;
  title: string;
  content: string | null;
  attachs: GetPublicationAttachDto[];
  presentation: GetPublicationPresentationDto | null;
  anonymousAnswers: boolean;
  /** @format date-time */
  allowAnswersUntil: Date | null;
  channel: GetPublicationChannelDto;
  topics: TopicAutoCompleteHierarchicalModelDto[];
  isPrivate: boolean;
  hasAnswers: boolean;
  advancedOptions: GetPublicationAdvancedOptionsDto;
  answers: PollItemModel[];
}

export type GetPollPublicationDtoIRequest = object;

export interface GetPollPublicationQuery {
  /** @format uuid */
  publicationId: string;
}

export interface GetPollResultsQuery {
  /** @format uuid */
  publicationId: string;
}

export interface GetPollThreadPublicationDto {
  /** @format uuid */
  publicationId: string;
  publicationType: PublicationType;
  title: string;
  content: string | null;
  attachs: GetPublicationAttachDto[];
  presentation: GetPublicationPresentationDto | null;
  /** @format uuid */
  threadId: string;
  anonymousAnswers: boolean;
  /** @format date-time */
  allowAnswersUntil: Date | null;
  hasAnswers: boolean;
  answers: PollItemModel[];
}

export type GetPollThreadPublicationDtoIRequest = object;

export interface GetPollThreadPublicationQuery {
  /** @format uuid */
  publicationId: string;
}

export interface GetPostClassifyPublicationDto {
  /** @format uuid */
  publicationId: string;
  title: string;
  content: string;
  channel: GetPublicationChannelDto;
  topics: TopicAutoCompleteHierarchicalModelDto[];
  isPrivate: boolean;
  advancedOptions: GetPublicationAdvancedOptionsDto;
}

export type GetPostClassifyPublicationDtoIRequest = object;

export interface GetPostClassifyPublicationQuery {
  /** @format uuid */
  publicationId: string;
}

export interface GetPostListExclusivePublicationDto {
  /** @format uuid */
  publicationId: string;
  publicationType: PublicationType;
  title: string;
  content: string | null;
  attachs: GetPublicationAttachDto[];
  presentation: GetPublicationPresentationDto | null;
  /** @format uuid */
  listExclusiveId: string | null;
  listTitle: string | null;
  editJustification: string | null;
}

export type GetPostListExclusivePublicationDtoIRequest = object;

export interface GetPostListExclusivePublicationQuery {
  /** @format uuid */
  publicationId: string;
}

export interface GetPostPropsDto {
  course: CoursePropsDto;
  post: PostPropsDto;
}

export type GetPostPropsDtoIEquatable = object;

export type GetPostPropsDtoIRequest = object;

export interface GetPostPublicationDto {
  /** @format uuid */
  publicationId: string;
  publicationType: PublicationType;
  title: string;
  content: string | null;
  attachs: GetPublicationAttachDto[];
  presentation: GetPublicationPresentationDto | null;
  channel: GetPublicationChannelDto;
  topics: TopicAutoCompleteHierarchicalModelDto[];
  isDraft: boolean;
  editJustification: string | null;
  advancedOptions: GetPublicationAdvancedOptionsDto;
}

export type GetPostPublicationDtoIRequest = object;

export interface GetPostPublicationQuery {
  /** @format uuid */
  publicationId: string;
}

export interface GetPostThreadPublicationDto {
  /** @format uuid */
  publicationId: string;
  publicationType: PublicationType;
  title: string;
  content: string | null;
  attachs: GetPublicationAttachDto[];
  presentation: GetPublicationPresentationDto | null;
  /** @format uuid */
  threadId: string;
  isDraft: boolean;
}

export type GetPostThreadPublicationDtoIRequest = object;

export interface GetPostThreadPublicationQuery {
  /** @format uuid */
  publicationId: string;
}

export interface GetPublicationAdvancedOptionsDto {
  isInstitutional: boolean;
  /** @format date-time */
  viewPeriodStart: Date | null;
  /** @format date-time */
  viewPeriodEnd: Date | null;
  /** @format date-time */
  viewStickerUntil: Date | null;
  sticker: GetPublicationStickerDto | null;
  tags: PublicationTagDto[];
}

export interface GetPublicationAttachDto {
  /** @format uuid */
  attachId: string;
  attachType: PublicationAttachType;
  file: FileGetDto | null;
  linkMetadata: ContentMetadata | null;
  thumbnail: FileGetDto | null;
  cardImage: FileGetDto | null;
  isEmbed: boolean;
  caption: string | null;
  videoProcessed: boolean | null;
  binderPageRefId: string | null;
}

export interface GetPublicationChannelDto {
  /** @format uuid */
  channelId: string;
  name: string;
  isPrivate: boolean;
  requirePublicationEditJustification: boolean;
  thumbnailUrl: string;
}

export interface GetPublicationCommentContentQuery {
  /** @format uuid */
  commentId: string;
}

export interface GetPublicationFollowersQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  publicationId: string;
  searchText: string | null;
}

export interface GetPublicationPresentationDto {
  /** @format int32 */
  rotationInterval: number;
  orderedItems: string[];
}

export interface GetPublicationStickerDto {
  /** @format uuid */
  stickerId: string;
  name: string;
  requiredDeadline: boolean;
}

export interface GetPublicationThreadSequenceQuery {
  /** @format uuid */
  masterPublicationId: string;
}

export interface GetPublicationThreadSequenceResponse {
  /** @format uuid */
  publicationId: string;
  /** @format int32 */
  sequenceIndex: number;
  title: string;
}

export type GetPublicationThreadSequenceResponseIEnumerableIRequest = object;

export type GetPublicationThreadSequenceResponseIEquatable = object;

export interface GetQuestionAssInstanceQuery {
  /** @format uuid */
  instanceId: string;
  /** @format uuid */
  questionIdRef: string | null;
  /** @format int32 */
  versionRef: number | null;
  playerMode: AssessmentPlayerMode;
  action: ActionPlayerSelectQuestion;
}

export interface GetQuestionClassifyPublicationDto {
  /** @format uuid */
  publicationId: string;
  title: string;
  content: string;
  channel: GetPublicationChannelDto;
  topics: TopicAutoCompleteHierarchicalModelDto[];
  isPrivate: boolean;
  advancedOptions: GetPublicationAdvancedOptionsDto;
}

export type GetQuestionClassifyPublicationDtoIRequest = object;

export interface GetQuestionClassifyPublicationQuery {
  /** @format uuid */
  publicationId: string;
}

export interface GetQuestionPublicationDto {
  /** @format uuid */
  publicationId: string;
  publicationType: PublicationType;
  title: string;
  content: string | null;
  attachs: GetPublicationAttachDto[];
  presentation: GetPublicationPresentationDto | null;
  channel: GetPublicationChannelDto;
  topics: TopicAutoCompleteHierarchicalModelDto[];
  isAnonymous: boolean;
  isPrivate: boolean;
  advancedOptions: GetPublicationAdvancedOptionsDto;
}

export type GetQuestionPublicationDtoIRequest = object;

export interface GetQuestionPublicationQuery {
  /** @format uuid */
  publicationId: string;
}

export interface GetRelatedPublicationsQuery {
  /** @format uuid */
  publicationId: string;
}

export interface GetRelatedPublicationsResponse {
  /** @format uuid */
  id: string;
  title: string;
  publicationType: PublicationType | null;
  publicationClassificationType: PublicationClassificationType | null;
  trainingContentType: TrainingContentType | null;
  classificationName: string;
}

export type GetRelatedPublicationsResponseIEquatable = object;

export type GetRelatedPublicationsResponseListIRequest = object;

export interface GetRelationshipPublicationQuery {
  /** @format uuid */
  publicationId: string;
  option: PublicationRelationshipOptions;
}

export interface GetRelationshipPublicationResponse {
  /** @format uuid */
  id: string;
  title: string;
}

export type GetRelationshipPublicationResponseIEnumerableIRequest = object;

export type GetRelationshipPublicationResponseIEquatable = object;

export interface GetRevisionEssaySurveyListQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  deployId: string | null;
  /** @format uuid */
  instanceId: string | null;
  /** @format uuid */
  questionId: string;
}

export interface GetScoPropsDto {
  course: CoursePropsDto;
  sco: ScoPropsDto;
}

export type GetScoPropsDtoIEquatable = object;

export type GetScoPropsDtoIRequest = object;

export interface GetShortVideoQuery {
  /** @format uuid */
  shortVideoId: string;
}

export interface GetSupervisorActivityPublicationDto {
  canModify: boolean;
  canCancel: boolean;
  timezoneId: string;
  /** @format date-time */
  dueDate: Date | null;
  /** @format int32 */
  maxFileSize: number | null;
  digitalDelivery: boolean;
  hasCheckList: boolean;
  assignScoreByCheckList: boolean;
  isCancelled: boolean;
  checkList: ActivityCheckListItem[];
}

export type GetSupervisorActivityPublicationDtoIRequest = object;

export interface GetSurveyDto {
  /** @format uuid */
  assessmentId: string;
  name: string;
  isBlocked: boolean;
  thumbnail: FileGetDto | null;
  instructions: string | null;
  /** @format int32 */
  applyCount: number;
  /** @format date-time */
  publishedOn: Date | null;
  makeAvailable: boolean;
  canManage: boolean;
  externalCode: string | null;
  language: string | null;
  author: string | null;
  topics: TopicAutoCompleteHierarchicalModelDto[];
  tags: TagAutoCompleteDataModelDto[];
  owners: AutoCompleteDataModelDto[];
  isRecovery: boolean;
  resultWithPoints: boolean;
  allowReview: boolean;
  beforeExpireBehavior: SurveyReviewBehaviorBeforeExpire;
  afterExpireBehavior: SurveyReviewBehaviorAfterExpire;
  /** @format int32 */
  daysToReviewResults: number | null;
  /** @format int32 */
  daysToReviewAnswers: number | null;
  identifyUsers: boolean;
  identifyAnswers: boolean;
  identifyForManagersOnly: boolean;
  groups: AssessmentGroupDto[];
}

export type GetSurveyDtoIRequest = object;

export interface GetSurveyInstanceQuery {
  /** @format uuid */
  instanceId: string;
  playerMode: AssessmentPlayerMode;
}

export interface GetThumbnailPublicationQuery {
  /** @format uuid */
  publicationId: string;
}

export interface GetTopicPeopleInterestedQuery {
  /** @format uuid */
  publicationId: string;
}

export interface GetTopicPeopleInterestedResponse {
  /** @format uuid */
  topicId: string;
  name: string;
}

export type GetTopicPeopleInterestedResponseIEquatable = object;

export type GetTopicPeopleInterestedResponseListIRequest = object;

export interface GetTrainingActivityPublicationDto {
  /** @format uuid */
  publicationId: string;
  publicationType: PublicationType;
  title: string;
  content: string | null;
  attachs: GetPublicationAttachDto[];
  presentation: GetPublicationPresentationDto | null;
  /** @format date-time */
  dueDate: Date | null;
  /** @format int32 */
  maxFileSize: number | null;
  digitalDelivery: boolean;
  hasCheckList: boolean;
  assignScoreByCheckList: boolean;
  checkList: ActivityCheckListItem[];
}

export type GetTrainingActivityPublicationDtoIRequest = object;

export interface GetTrainingNoticePublicationDto {
  /** @format uuid */
  publicationId: string;
  publicationType: PublicationType;
  title: string;
  content: string | null;
  attachs: GetPublicationAttachDto[];
  presentation: GetPublicationPresentationDto | null;
  /** @format date-time */
  availableFrom: Date | null;
  /** @format date-time */
  availableTo: Date | null;
}

export type GetTrainingNoticePublicationDtoIRequest = object;

export interface GetTrainingPostPublicationDto {
  /** @format uuid */
  publicationId: string;
  publicationType: PublicationType;
  title: string;
  content: string | null;
  attachs: GetPublicationAttachDto[];
  presentation: GetPublicationPresentationDto | null;
}

export type GetTrainingPostPublicationDtoIRequest = object;

export interface GetUnblockRequestPublicationQuery {
  /** @format uuid */
  publicationId: string;
}

export interface GetUnblockRequestPublicationResponse {
  /** @format uuid */
  publicationActionId: string;
  message: string;
}

export type GetUnblockRequestPublicationResponseIEquatable = object;

export type GetUnblockRequestPublicationResponseIRequest = object;

export interface GetUserListsQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  publicationId: string;
  publicListsOnly: boolean;
  searchText: string | null;
}

export interface GetUserListsResponse {
  /** @format uuid */
  listId: string;
  type: PublicationListType;
  name: string;
  isPublicList: boolean;
  selected: boolean;
}

export type GetUserListsResponseIEquatable = object;

export interface GetUserListsResponsePaginatedList {
  items: GetUserListsResponse[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type GetUserListsResponsePaginatedListIRequest = object;

export interface GlobalSearchAttachDto {
  /** @format uuid */
  attachId: string;
  attachType: PublicationAttachType;
  attachTypeName: string;
  headline: string;
  /** @format int64 */
  duration: number | null;
  filename: string | null;
  /** @format uuid */
  fileId: string | null;
  fileTypeName: string | null;
}

export type GlobalSearchAttachDtoIEquatable = object;

export interface GlobalSearchContentDto {
  rowType: string;
  /** @format uuid */
  id: string;
  subType: string;
  title: string;
  thumbnailUrl: string;
  /** @format date-time */
  lastUpdate: Date | null;
  /** @format uuid */
  authorId: string | null;
  authorName: string | null;
  /** @format uuid */
  linkedPublicationId: string | null;
  publicationType: PublicationType | null;
}

export type GlobalSearchContentDtoIEquatable = object;

export interface GlobalSearchDto {
  user: UtilRequiredKeys<
    UserSearchDtoPaginatedList,
    "items" | "totalPages" | "totalRows" | "pageNumber" | "pageSize"
  > & {
    items: UserSearchDto[];
    /** @format int32 */
    totalPages: number;
    /** @format int32 */
    totalRows: number;
    /** @format int32 */
    pageNumber: number;
    /** @format int32 */
    pageSize: number;
  };
  topic: UtilRequiredKeys<
    TopicSearchDtoPaginatedList,
    "items" | "totalPages" | "totalRows" | "pageNumber" | "pageSize"
  > & {
    items: TopicSearchDto[];
    /** @format int32 */
    totalPages: number;
    /** @format int32 */
    totalRows: number;
    /** @format int32 */
    pageNumber: number;
    /** @format int32 */
    pageSize: number;
  };
  channel: UtilRequiredKeys<
    ChannelSearchDtoPaginatedList,
    "items" | "totalPages" | "totalRows" | "pageNumber" | "pageSize"
  > & {
    items: ChannelSearchDto[];
    /** @format int32 */
    totalPages: number;
    /** @format int32 */
    totalRows: number;
    /** @format int32 */
    pageNumber: number;
    /** @format int32 */
    pageSize: number;
  };
  training: TrainingSearchResponse;
  knowledgeSearch: KnowledgeSearchResponse;
  knowledgeVideos: KnowledgeSearchResponse;
  knowledgeDocs: KnowledgeSearchResponse;
}

export type GlobalSearchDtoIEquatable = object;

export type GlobalSearchDtoIRequest = object;

export interface GlobalSearchPreviewDto {
  others: GlobalSearchContentDto[];
  users: UserSearchDto[];
  topics: TopicSearchDto[];
  channels: ChannelSearchDto[];
  trainings: TrainingSearchDto[];
}

export type GlobalSearchPreviewDtoIEquatable = object;

export type GlobalSearchPreviewDtoIRequest = object;

export interface GlobalSearchPreviewQuery {
  searchText: string;
}

export interface GlobalSearchQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  searchText: string;
}

export interface GoalDashboardCommand {
  /** @format uuid */
  userId: string;
}

export interface GoalDashboardResponse {
  /** @format uuid */
  userId: string;
  performanceReviews: DashboardGoal | null;
}

export type GoalDashboardResponseIEquatable = object;

export type GoalDashboardResponseIRequest = object;

export interface GoalItem {
  /** @format int32 */
  categoryID: number;
  categoryName: string | null;
  /** @format int32 */
  objectiveID: number;
  objectiveName: string | null;
  /** @format int32 */
  indicativeID: number;
  indicativeName: string | null;
  /** @format double */
  weight: number;
  /** @format double */
  progress: number;
  partialResult: string | null;
  partialResultColor: string | null;
  finalResult: string | null;
  finalResultColor: string | null;
  isMasterGoal: boolean;
  isPercent: boolean;
  isApproved: boolean;
}

export interface GoogleSearchImageItem {
  /** @format int32 */
  contentSize: number;
  contentUrl: string;
  description: string;
  thumbnailUrl: string;
  name: string;
  /** @format int32 */
  width: number | null;
  /** @format int32 */
  height: number | null;
  encodingFormat: string;
  filename: string;
}

export type GoogleSearchImageItemIEquatable = object;

export interface GoogleSearchImageResult {
  /** @format int32 */
  count: number;
  /** @format int64 */
  nextOffset: number;
  items: GoogleSearchImageItem[];
  /** @format int64 */
  total: number;
}

export type GoogleSearchImageResultIEquatable = object;

export type GoogleSearchImageResultIRequest = object;

export interface GoogleSearchImagesQuery {
  search: string;
  /** @format int64 */
  maxSize: number | null;
  /** @format int64 */
  offset: number;
  /** @format int32 */
  take: number;
}

export interface GroupDynamicSpec {
  items: GroupDynamicSpecOperand[];
  sets: GroupDynamicSpecSet[];
  infixExpression: string;
}

export interface GroupDynamicSpecOperand {
  id: string;
  fieldSpec: string;
  operator: GroupDynamicSpecFieldOperators;
  negate: boolean;
}

export type GroupDynamicSpecSet = object;

export interface GroupInfo {
  /** @format uuid */
  id: string;
  name: string;
  groupType: GroupType;
}

export type GroupInfoIEquatable = object;

export interface GroupIsUsedQuery {
  /** @format uuid */
  groupId: string;
}

export interface GroupItemDto {
  /** @format uuid */
  groupId: string;
  name: string;
  thumbnailUrl: string;
}

export type GroupItemDtoIEquatable = object;

export interface GroupItemDtoPaginatedList {
  items: GroupItemDto[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type GroupItemDtoPaginatedListIRequest = object;

export interface GroupMembersExportQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  groupId: string | null;
}

export interface GroupMembersExportResponse {
  /** @format uuid */
  userId: string;
  name: string;
  displayName: string;
  email: string;
  fields: CustomFieldValue[];
}

export type GroupMembersExportResponseIEquatable = object;

export interface GroupMembersExportResponsePaginatedList {
  items: GroupMembersExportResponse[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type GroupMembersExportResponsePaginatedListIRequest = object;

export interface GroupMembersQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  groupId: string;
  searchText: string | null;
  expanded: boolean;
}

export interface GroupMembersQueryResponse {
  /** @format uuid */
  memberId: string;
  name: string;
  thumbnailUrl: string;
  memberType: MemberType;
}

export type GroupMembersQueryResponseIEquatable = object;

export interface GroupMembersQueryResponsePaginatedList {
  items: GroupMembersQueryResponse[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type GroupMembersQueryResponsePaginatedListIRequest = object;

export interface GroupQuery {
  /** @format uuid */
  groupId: string | null;
  groupUsages: GroupUsages | null;
  groupType: GroupType | null;
}

export interface GroupResponse {
  /** @format uuid */
  groupId: string;
  name: string;
  thumbnailUrl: string | null;
  groupType: GroupType;
}

export type GroupResponseIEquatable = object;

export type GroupResponseListIRequest = object;

export interface GroupRuleLoginStatusSuggestionsQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  name: string | null;
}

export interface GroupRuleLoginStatusSuggestionsResponse {
  key: any;
  label: string;
  thumbnailUrl?: string | null;
  canDelete?: boolean | null;
  fixed?: boolean | null;
  selectable?: boolean | null;
  fromHistory?: boolean;
}

export type GroupRuleLoginStatusSuggestionsResponseIEquatable = object;

export interface GroupRuleLoginStatusSuggestionsResponsePaginatedList {
  items: GroupRuleLoginStatusSuggestionsResponse[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type GroupRuleLoginStatusSuggestionsResponsePaginatedListIRequest =
  object;

export interface GroupSelectorQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  searchText: string | null;
  groupTypes: GroupType[] | null;
  ignoreSelectionHistory: boolean;
  groupUsages: GroupUsages | null;
  exceptGroupIds: string[];
  includeAllInternalExternalUserGroups: boolean | null;
}

export interface GroupSelectorResponse {
  /** @format uuid */
  groupId: string;
  name: string;
  thumbnailUrl: string | null;
  groupType: GroupType;
  fromHistory: boolean;
}

export type GroupSelectorResponseIEquatable = object;

export interface GroupSelectorResponsePaginatedList {
  items: GroupSelectorResponse[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type GroupSelectorResponsePaginatedListIRequest = object;

export interface GroupSuggestionsPayload {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  searchText: string | null;
  groupType: GroupType | null;
  groupUsages: GroupUsages | null;
  exceptGroupIds: string[];
  includeAllInternalExternalUserGroups: boolean | null;
}

export interface GroupUnitSuggestionsQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  groupType: GroupType;
  /** @format uuid */
  parentId: string | null;
  searchText: string | null;
  trySelectionHistory: boolean;
  allowIncludeDescendants: boolean;
  ignoreAllowAssociates: boolean;
  showRoot: boolean;
}

export interface GroupUsagesSelectorQuery {
  searchText: string | null;
}

export interface GroupUsagesSelectorResponse {
  /** @format int32 */
  value: number;
  name: string;
}

export type GroupUsagesSelectorResponseIEquatable = object;

export type GroupUsagesSelectorResponseListIRequest = object;

export interface GroupsAudienceUsersQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  groupsId: string[];
  audiencesNeedAll: boolean;
  searchText: string | null;
}

export type GuidIRequest = object;

export type GuidNullableIRequest = object;

export interface HidePublicationCommand {
  /** @format uuid */
  publicationId: string;
}

export interface HideWorkspaceNotificationCommand {
  /** @format uuid */
  userId: string;
  /** @format uuid */
  notificationId: string;
}

export interface HistoryItemQuery {
  /** @format uuid */
  enrollmentId: string;
}

export interface HistoryQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  searchText: string | null;
  filter: AdvCoreFilter[];
  orderBy: HistoryOrderBy;
}

export interface HolidayPeriodOfDaySelectorResponse {
  id: HolidayPeriodOfDay;
  name: string;
}

export type HolidayPeriodOfDaySelectorResponseIEquatable = object;

export interface IAppUser {
  /** @format uuid */
  userId?: string;
  name?: string;
}

export interface IAssessmentProps {
  allowReview: boolean;
  isPreTest: boolean;
  nameOverride: string | null;
}

export interface IAuditLogRecord {
  /** @format uuid */
  id: string;
  eventId: AuditLogEventId;
  isDelete: boolean;
  viewPermissions: string[] | null;
  viewDetailPermissions: string[] | null;
  entityType: AuditLogEntityType;
  entityKey: string[] | null;
  reference: string | null;
  referenceDetailed: boolean;
  referenceEntityKey: string[] | null;
  ipAddress: string | null;
  /** @format date-time */
  createdOn: Date;
  /** @format uuid */
  creatorId: string;
  creatorName: string;
  /** @format uuid */
  spyId: string | null;
  spyName: string | null;
}

export type IBaseRequest = object;

export interface IClassroomMeeting {
  /** @format uuid */
  componentId: string;
  /** @format uuid */
  classroomId: string;
}

export interface ICourseProps {
  computeProgress: boolean;
  /** @format int32 */
  daysAfterClassAvailability: number | null;
  enableOption: CourseComponentEnableOption;
}

export interface ICreateInstance {
  /** @format uuid */
  assessmentId: string;
  preview: boolean;
}

export interface IDashChallenge {
  filter: AdvCoreFilter[];
  /** @format uuid */
  searchTopicId: string | null;
  searchTopicDescendant: boolean | null;
}

export interface IEnrollOperationFilter {
  useImportedUsers: boolean;
  searchText: string | null;
  filter: AdvCoreFilter[];
  operation: ManageEnrollOperation;
}

export interface IEnrollOperationImportUser {
  /** @format uuid */
  trainingId: string;
  operation: ManageEnrollOperation;
  filtered: boolean;
}

export interface IEnrollmentStatus {
  status: EnrollStatus;
  /** @format date-time */
  dueDate: Date | null;
  /** @format date-time */
  finalizationDate: Date | null;
  /** @format date-time */
  expireDate: Date | null;
  canReview: boolean;
  /** @format date-time */
  reviewUntil: Date | null;
  certificateExpired: boolean;
  hasCertificate: boolean;
  /** @format date-time */
  certificateValidUntil: Date | null;
  hasScore: boolean;
  reprovedByExpireDate: boolean;
  /** @format date-time */
  nextAutoEnrollDate: Date | null;
}

export interface ILearnPathApprovalRulesProps {
  /** @format int32 */
  minProgress: number | null;
  /** @format int32 */
  minCredits: number | null;
  needsMinCreditsOnAllPhases: boolean | null;
  autoEnrollFinish: boolean;
  autoEnrollFinishNeedAllComponents: boolean;
  /** @format int32 */
  minFinalScore: number;
  studentCanFinishEnroll: boolean;
}

export interface ILearnPathComponentRegistrationProps {
  autoEnrollOption: TrainingLearnPathComponentAutoEnrollOption;
  allowTrainingReuse: boolean;
  ignoreAudience: boolean;
  ignoreAutoEnrollLimits: boolean;
  ignorePreRequisites: boolean;
  ignoreApproval: boolean;
}

export interface ILearnPathPhaseProps {
  access: LearnPathAccessProps;
  /** @format int32 */
  maxCredits: number | null;
  /** @format int32 */
  minCredits: number | null;
  skipPhaseOnCertificationRenewal: boolean;
}

export interface ILearnPathReEnrollProps {
  conditionsChanged: boolean;
  onlyIfBelongAudience: boolean;
  revokePreviousApproval: boolean;
}

export interface IMaterialListPublication {
  /** @format uuid */
  materialListId: string;
  /** @format uuid */
  publicationId: string;
}

export interface IMeetingCommonOthers {
  description: string | null;
  assignPresenceAfterViewRecording: boolean;
  hasScore: boolean;
  /** @format int32 */
  minPermanence: number | null;
}

export interface IMeetingCommonWhenAndWhere {
  meetingType: MeetingType;
  /** @format uuid */
  roomId: string | null;
  locationName: string | null;
  address: AddressModel | null;
  timezoneId: string | null;
  /** @format date-time */
  startDate: Date | null;
  /** @format date-time */
  endDate: Date | null;
  externalUrl: string | null;
}

export interface IMeetingCommonWho {
  instructors: string[] | null;
  assistants: string[] | null;
  /** @format timespan */
  bookAdditionalTimeBefore: string | null;
  /** @format timespan */
  bookAdditionalTimeAfter: string | null;
}

export interface IPhaseProps {
  learnPathProps: LearnPathPhaseProps | null;
  name: string;
}

export interface IPostProps {
  completeOnAttachOpened: boolean;
  completeOnFullMediaPlayed: boolean;
  /** @format timespan */
  completeOnMinTime: string | null;
  disableMediaSeek: boolean;
}

export interface IPublicationAdvancedItem {
  advancedOptions: PublicationAdvancedItem;
}

export interface IPublicationAnonymousItem {
  isAnonymous: boolean;
}

export interface IPublicationAttachsItem {
  attachs: PublicationAttachFileItem[];
  presentation: PublicationPresentationItem | null;
}

export interface IPublicationChannelItem {
  /** @format uuid */
  channelId: string;
}

export interface IPublicationComment {
  /** @format uuid */
  publicationId: string;
  /** @format uuid */
  commentId: string;
}

export interface IPublicationDraftItem {
  isDraft: boolean;
}

export interface IPublicationEditJustificationItem {
  editJustification: string | null;
}

export interface IPublicationListExclusiveItem {
  /** @format uuid */
  listExclusiveId: string;
}

export interface IPublicationOptionalChannelItem {
  /** @format uuid */
  channelId: string | null;
}

export interface IPublicationThreadItem {
  /** @format uuid */
  threadId: string;
}

export interface IPublicationTitleItem {
  title: string;
}

export interface IPublicationTopicsItem {
  topics: string[];
}

export interface IScoProps {
  nameOverride: string | null;
  nameOverrided: boolean;
}

export interface ISupervisorBaseFilter {
  searchText: string | null;
  filter: AdvCoreFilter[];
  pendingOnly: boolean;
  includeClassroomsFinalized: boolean;
  queryMode: SupervisorTrainingsQueryMode;
}

export interface ITrainingAgreement {
  enableTrainingAgreement: boolean;
  /** @format uuid */
  trainingAgreementId: string | null;
}

export interface ITrainingApprovalRules {
  /** @format int32 */
  minProgress: number;
  /** @format int32 */
  minFinalScore: number;
  studentCanFinishEnroll: boolean;
  autoEnrollFinish: boolean;
  autoEnrollFinishIgnoreEvalTries: boolean | null;
}

export interface ITrainingAutoEnrollLimits {
  /** @format int32 */
  maxTries: number | null;
  /** @format int32 */
  retryIntervalDays: number | null;
  denyIfCertificateValid: boolean;
}

export interface ITrainingAward {
  mandatoryAudience: TrainingAwardPointsProps;
  optionalAudience: TrainingAwardPointsProps | null;
  sameAwardsAllAudiences: boolean;
}

export interface ITrainingCertificate {
  generateCertificate: boolean;
  /** @format uuid */
  certificateFileId: string | null;
  computeValidityDaysFromLastCertification: boolean;
  enableTrainingValidity: boolean;
  /** @format int32 */
  renovationWindowDays: number | null;
  /** @format int32 */
  trainingValidityDays: number | null;
  /** @format int32 */
  trainingValidityMonthDay: number | null;
}

export interface ITrainingConclusionFormProps {
  institutionOrProvider: TrainingThreeStateInfo;
  institutionOrProviderOptions: string[] | null;
  coursePeriod: TrainingThreeStateInfo;
  courseDuration: TrainingThreeStateInfo;
  attendancePercent: TrainingThreeStateInfo;
  certificate: TrainingThreeStateInfo;
  pricePaid: TrainingThreeStateInfo;
  approvalOption: TrainingExternalCourseApprovalOption;
  finalScore: TrainingThreeStateInfo;
  finalScoreIsPercent: boolean | null;
  /** @format double */
  finalScoreMin: number | null;
  /** @format double */
  finalScoreMax: number | null;
  /** @format uuid */
  approverId: string | null;
}

export interface ITrainingDiscussion {
  allowPrivateMessageOnly: boolean | null;
  continueInteractionAfterFinalization: boolean | null;
  /** @format int32 */
  continueInteractionAfterFinalizationDays: number | null;
  enableDiscussion: boolean;
  ratingOption: TrainingRatingOption;
}

export interface ITrainingExecution {
  accessOnlyOnCorporateNetwork: boolean;
  /** @format uuid */
  afterApprovalRegisterOnTrainingId: string | null;
  allowTrainingReview: boolean;
  /** @format date-time */
  dueDate: Date | null;
  dueDateOption: TrainingDueDateOption;
  /** @format int32 */
  dueDays: number | null;
  /** @format int32 */
  expireDaysAfterDueDate: number | null;
  /** @format int32 */
  reviewDaysLimit: number | null;
  /** @format date-time */
  startDate: Date | null;
}

export interface ITrainingInstructorAction {
  canModifyEventAndActivity: boolean;
  canCancelEventAndActivity: boolean;
  canExtendDueDate: boolean;
  canCancelEnrollment: boolean;
}

export interface ITrainingInteraction {
  enableLike: boolean;
  enableViewEnrolledUsers: boolean;
  shareOption: TrainingShareOption;
  enableShareInChannelAndLists: boolean;
}

export interface ITrainingMaterialList {
  allowInstructorAddMaterial: boolean;
  allowInstructorBlockMaterial: boolean;
}

export interface ITrainingPublication {
  /** @format uuid */
  trainingId: string;
  /** @format uuid */
  publicationId: string;
}

export interface ITrainingRegistration {
  allowCancellationIfEnrolledByManager: boolean;
  cancellationOption: TrainingCancellationOption;
  /** @format date-time */
  cancellationUntilDate: Date | null;
  /** @format int32 */
  cancellationUntilDaysAfterEnroll: number | null;
  /** @format date-time */
  enrollAvailableFrom: Date | null;
  /** @format date-time */
  enrollAvailableUntil: Date | null;
  enrollSuspended: boolean;
  oneClickEnroll: boolean;
  preApprovalByUserManagerOrApprover: boolean;
  requiredApprovalWhenEnrolledByManager: boolean;
  /** @format uuid */
  trainingApproverId: string | null;
}

export interface ITrainingVersion {
  /** @format uuid */
  trainingId: string;
  /** @format int32 */
  versionNumber: number;
}

export interface ITrainingVersionComponent {
  /** @format uuid */
  trainingId?: string;
  /** @format int32 */
  versionNumber?: number;
  /** @format uuid */
  componentId: string;
}

export interface ITrainingViewDto {
  /** @format date-time */
  registrationEnrollAvailableFrom: Date | null;
  /** @format date-time */
  registrationEnrollAvailableUntil: Date | null;
  registrationOneClickEnroll: boolean;
  registrationCancellationOption: TrainingCancellationOption;
  /** @format date-time */
  registrationCancellationUntilDate: Date | null;
  /** @format int32 */
  registrationCancellationUntilDaysAfterEnroll: number | null;
  registrationPreApprovalByUserManagerOrApprover: boolean | null;
  /** @format date-time */
  executionStartDate: Date | null;
  executionDueDateOption: TrainingDueDateOption;
  /** @format date-time */
  executionDueDate: Date | null;
  /** @format int32 */
  executionDueDays: number | null;
  /** @format uuid */
  nextTrainingId: string | null;
  nextTrainingName: string | null;
  generateCertificate: boolean;
  /** @format uuid */
  certificateFileId: string | null;
  certificateEnableTrainingValidity: boolean | null;
  /** @format int32 */
  certificateTrainingValidityMonthDay: number | null;
  /** @format int32 */
  certificateTrainingValidityDays: number | null;
  certificateComputeValidityDaysFromLastCertification: boolean | null;
  /** @format int32 */
  certificateRenovationWindowDays: number | null;
  ratingOption: TrainingRatingOption;
  shareOption: TrainingShareOption;
  enableLike: boolean;
  enableViewEnrolledUsers: boolean;
  /** @format int32 */
  trainingDurationMinutes: number;
  trainingDurationFormated: string;
  /** @format int32 */
  awardEnrollPoints: number | null;
  /** @format int32 */
  awardApprovalPoints: number | null;
  /** @format double */
  ratingAvg: number;
  /** @format int32 */
  ratingStars: number;
  /** @format int32 */
  ratingCount: number;
  /** @format int32 */
  activeEnrollmentsCount: number;
  /** @format int32 */
  usersEnrolledCount: number;
  isMandatory: boolean;
  fullManaged: boolean;
  approvers: UserShortView[] | null;
  instructors: UserShortView[] | null;
}

export interface IUser {
  /** @format uuid */
  userId: string;
}

export interface IUserBaseInfo {
  name?: string;
  displayName?: string;
  email?: string | null;
}

export interface IUserCreation {
  preferredLocale: string | null;
  /** @format uuid */
  thumbnailId: string | null;
  /** @format uuid */
  workplaceId: string | null;
  workplaceText: string | null;
  /** @format uuid */
  blockReasonId: string | null;
  /** @format uuid */
  managerId: string | null;
  /** @format uuid */
  approverId: string | null;
  /** @format date-time */
  accessExpiresOn: Date | null;
  /** @format date */
  admissionDate: Date | null;
  /** @format date */
  dismissedDate: Date | null;
  userType: UserType;
  units: string[];
  customFields: FieldValueItem[] | null;
  secondaryManagers: UserSecondaryManagerItem[] | null;
}

export interface IUserDisplayName {
  displayName: string;
}

export interface IUserEmail {
  email: string | null;
}

export interface IUserName {
  name: string;
}

export interface IUserOperationGroupProps {
  action: UserOperationAction;
  /** @format uuid */
  groupId: string;
}

export interface IUserOperationTagProps {
  action: UserOperationAction;
  /** @format uuid */
  tagId: string;
}

export interface IaModel {
  /** @format int32 */
  aiRecommendationThreshold: number;
  allowSubjectOutsideKb: boolean;
  searchSubjects: string[];
  targetUsers: SystemSettingIaTargetUser;
  /** @format int32 */
  sharedMonthlyRequests: number | null;
  /** @format int32 */
  maxUserDailyRequests: number | null;
  audience: GroupInfo[];
  limitedAudience: GroupInfo[];
  anySearchSubject: boolean;
}

export interface IaSettingsResponse {
  settings: IaModel;
  /** @format int64 */
  limitIaRequests: number | null;
  /** @format date-time */
  lastTrainingUpdate: Date | null;
  /** @format date-time */
  lastPublicationUpdate: Date | null;
}

export type IaSettingsResponseIEquatable = object;

export interface ImportEnrollCommand {
  /** @format uuid */
  fileId: string;
}

export type ImportEnrollCommandIEquatable = object;

export interface ImportModel {
  locale: string;
  timezoneId: string;
  dataSeparator: ImportRulesDataSeparator;
  /** @format int32 */
  auditDays: number;
}

export interface ImportQuestionFileCommand {
  /** @format uuid */
  questionGroupId: string;
  /** @format uuid */
  fileId: string;
  evaluation: SaveQuestionEvaluationDto | null;
  tags: string[];
}

export interface ImportTrainingCommand {
  /** @format uuid */
  fileId: string;
  trainingType: TrainingType;
}

export type ImportTrainingCommandIEquatable = object;

export interface ImportUnitCommand {
  /** @format uuid */
  fileId: string;
  /** @format uuid */
  unitTypeId: string;
}

export type ImportUnitCommandIEquatable = object;

export interface ImportUserAdhocCommand {
  /** @format uuid */
  file: string;
}

export type ImportUserAdhocCommandIEquatable = object;

export interface ImportUserFileEnrollOperationCommand {
  /** @format uuid */
  trainingId: string;
  operation: ManageEnrollOperation;
  filtered: boolean;
  /** @format uuid */
  fileId: string;
}

export interface ImportUserFileUserOperationCommand {
  operation: UserOperationType;
  filtered: boolean;
  /** @format uuid */
  fileId: string;
}

export interface ImportUserListEnrollOperationCommand {
  /** @format uuid */
  trainingId: string;
  operation: ManageEnrollOperation;
  filtered: boolean;
  userAuthFieldValues: string[];
}

export interface ImportUserListUserOperationCommand {
  operation: UserOperationType;
  filtered: boolean;
  userAuthFieldValues: string[];
}

export interface ImportUserMemberToStaticGroupCommand {
  /** @format uuid */
  groupId: string;
  userAuthFieldValues: string[];
}

export interface ImportUserModel {
  /** @format uuid */
  blockReasonTempId: string | null;
  /** @format uuid */
  blockReasonId: string | null;
  trainingAction: ImportUserRolesInactivateTrainingAction;
  /** @format uuid */
  enrollReasonId: string | null;
  /** @format uuid */
  roleId: string | null;
  managerErrorAction: ImportUserRolesManagerErrorAction;
  changePassword: boolean;
  listExceptions: string[];
  sendNotificationMail: boolean;
  /** @format uuid */
  recipientId: string | null;
  dataSeparatorChar: string;
}

export interface ImportUserRemoteModel {
  useAutomaticLoadData: boolean;
  ftpHost: string | null;
  /** @format int32 */
  ftpPort: number | null;
  ftpUser: string | null;
  ftpPassword: string | null;
  ftpDirectory: string | null;
  ftpFile: string | null;
  isSecureFtp: boolean | null;
  /**
   * @format time
   * @example ""13:45:42.0000000""
   */
  timeExecution: string | null;
}

export interface IndicatorCardDto {
  /** @format uuid */
  uniqueId: string;
  title: string;
  subtitle1: string | null;
  subtitle2: string | null;
  value: string;
  color: CardColor;
  action: IndicatorCardActionType;
  data: Record<string, any>;
}

export type IndicatorCardDtoListIRequest = object;

export interface IndicatorDataQuery {
  browserTimeZoneId: string;
}

export interface IndicatorDto {
  name: string;
  indicatorType: IndicatorType;
}

export type IndicatorDtoIEquatable = object;

export interface InfixExpressionItem {
  operator: LogicOperator;
  braces: LogicBraces;
  fieldSpecId: string;
  negate: boolean;
  /** @format int32 */
  expressionNumber: number;
}

export interface InputLocaleDefinition {
  locale: string;
  name: string;
  isDefault: boolean;
  required: boolean;
  nameR: ResourceModel[];
}

export type InputLocaleDefinitionIEquatable = object;

export interface InstanceDeployDto {
  /** @format uuid */
  deployId: string;
  username: string;
  trainingName: string;
  applicationType: DeployApplicationType;
}

export interface InstanceEvaluationDto {
  showQuestionPoints: boolean;
  /** @format double */
  timeToComplete: number | null;
  allowGoback: boolean;
  showCorrectAnswer: boolean;
  showCorrection: boolean;
  showFeedback: boolean;
  allowContinueAborted: boolean;
  freezeChronometer: boolean;
  /** @format int32 */
  maxTries: number;
}

export interface InstanceSurveyDto {
  /** @format date-time */
  deadline: Date;
  allowReview: boolean;
  identifyUsers: boolean;
  beforeExpireBehavior: SurveyReviewBehaviorBeforeExpire;
  afterExpireBehavior: SurveyReviewBehaviorAfterExpire;
  expired: boolean;
}

export interface InstructorAppointmentQuery {
  /** @format uuid */
  appointmentId: string;
}

export interface InstructorAppointmentResponse {
  subject: string;
  /** @format date-time */
  startDate: Date;
  /** @format date-time */
  endDate: Date;
  allDay: boolean;
}

export type InstructorAppointmentResponseIEquatable = object;

export type InstructorAppointmentResponseIRequest = object;

export type Int32IRequest = object;

export type Int32NullableIRequest = object;

export interface Int32StringKeyValueItem {
  /** @format int32 */
  key: number;
  value: string | null;
}

export interface InviteProcessCommand {
  /** @format uuid */
  inviteId: string;
  /** @format uuid */
  notificationId: string;
  accepted: boolean;
}

export interface InviteProcessResponse {
  /** @format uuid */
  channelId: string | null;
  success: boolean;
  errorMessage: string | null;
}

export type InviteProcessResponseIRequest = object;

export interface InviteUserCommand {
  /** @format uuid */
  channelId: string;
  /** @format uuid */
  userId: string;
}

export interface IosDefinition {
  iosBundleNameId: string;
  iosAppStoreUrl: string;
}

export interface IsMeetingInstructorQuery {
  includePast: boolean;
}

export interface ItemTrainingDto {
  /** @format uuid */
  trainingId: string | null;
  multipleClasses: boolean;
}

export type ItemTrainingDtoIEquatable = object;

export interface JobProcessDetailQuery {
  /** @format uuid */
  id: string;
}

export interface JobProcessQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  failed: boolean | null;
  searchText: string | null;
}

export interface JobProcessResponse {
  /** @format uuid */
  schedulerTaskId: string;
  /** @format uuid */
  schedulerTaskLogId: string;
  /** @format uuid */
  schedulerId: string;
  jobType: SchedulerJobType;
  status: SchedulerStatus;
  statusName: string;
  name: string;
  /** @format int64 */
  duration: number;
  /** @format date-time */
  executedOn: Date;
  finishedSuccessfully: boolean;
  informationMessage: string | null;
}

export type JobProcessResponseIEquatable = object;

export interface JobProcessResponsePaginatedList {
  items: JobProcessResponse[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type JobProcessResponsePaginatedListIRequest = object;

export interface JoinChannelCommand {
  /** @format uuid */
  channelSourceId: string;
  /** @format uuid */
  channelDestinyId: string;
}

export interface JoinMembersStaticGroupCommand {
  /** @format uuid */
  groupSourceId: string;
  /** @format uuid */
  groupDestinyId: string;
}

export interface JoinQuestionGroupCommand {
  /** @format uuid */
  questionGroupSourceId: string;
  /** @format uuid */
  questionGroupDestinyId: string;
}

export interface JoinStickersCommand {
  /** @format uuid */
  sourceStickerId: string;
  /** @format uuid */
  destinyStickerId: string;
}

export interface JoinTagsCommand {
  /** @format uuid */
  tagSourceId: string;
  /** @format uuid */
  tagDestinyId: string;
}

export interface JoinTopicCommand {
  /** @format uuid */
  topicSourceId: string;
  /** @format uuid */
  topicDestinyId: string;
}

export interface KPTupleDouble {
  /** @format date-time */
  dtref: Date;
  /** @format double */
  value: number;
}

export type KPTupleDoubleIEquatable = object;

export interface KPTupleLong {
  /** @format date-time */
  dtref: Date;
  /** @format int64 */
  value: number;
}

export type KPTupleLongIEquatable = object;

export interface KeyLabelModel {
  key: any;
  label: string;
}

export type KeyLabelModelIEquatable = object;

export interface KnowledgeContextualRAGResponse {
  question: string;
  answer: string;
  sourcesUsed: RAGKnowledgeSource[];
  relatedSearchSuggestions: string[];
  outOfContext: boolean;
  /** @format timespan */
  processingTime: string;
  error: string | null;
  /** @format int32 */
  errorCode: number | null;
  conversationId: string;
  /** @format int32 */
  turnNumber: number;
  /** @format float */
  contextRelevance: number;
  isFirstQuestion: boolean;
  conversationSummary: string | null;
  contextualMetadata: ContextualSearchMetadata;
}

export type KnowledgeContextualRAGResponseIRequest = object;

export interface KnowledgeFeedFilter {
  command:
    | "UserIncludeBlockedUsers"
    | "UserTags"
    | "UserUnits"
    | "UserGroups"
    | "UserWorkplaces"
    | "UserWorkplaceText"
    | "UserCustomField"
    | "UserIncludeInactive"
    | "UserIncludeDeleted"
    | "UserIsManager"
    | "UserManagerDirectSubordinates"
    | "UserManagerAllSubordinates"
    | "UserSpecific"
    | "UserInternal"
    | "UserExternal"
    | "UserTopicOptional"
    | "UserTopicRequired"
    | "UserChannelMembers"
    | "UserTrainingAttending"
    | "UserTrainingApproved"
    | "UserTrainingReproved"
    | "UserInterestTag"
    | "UserBlockReason"
    | "UserAndDirectSubordinates"
    | "UserAndAllSubordinates"
    | "UserHasSealProvenKnowledgeTopic"
    | "UserIsSpecialistInTopic"
    | "UserLastAccessBeforeOf"
    | "UserLastAccessAfterOf"
    | "UserPermission"
    | "UserRoles"
    | "UserSuspendedAccounts"
    | "UserHasNotActiveDevPlan"
    | "UserHasActiveDevPlan"
    | "UserHasDraftDevPlan"
    | "UserHasDelayedDevPlan"
    | "UserHasPendingApprovalDevPlan"
    | "UserOnlyBlocked"
    | "UserOnlyInactive"
    | "UsersOnlyDeleted"
    | "UserIsExternal"
    | "UserTrainingAudience"
    | "UserTrainingMandatoryAudience"
    | "UserOnlyUnblocked"
    | "TrainingTopic"
    | "TrainingSticker"
    | "TrainingPublishPeriod"
    | "TrainingWorkload"
    | "TrainingBestRated"
    | "TrainingWithAvailableClassrooms"
    | "TrainingStartNow"
    | "TrainingInLearnPath"
    | "TrainingCoordinator"
    | "TrainingSpecific"
    | "TrainingTypeCourseWeb"
    | "TrainingTypeLive"
    | "TrainingTypeExternalCourse"
    | "TrainingTypeAssessment"
    | "TrainingTypeActivity"
    | "TrainingTypeLearnPath"
    | "TrainingTypeGame"
    | "TrainingRequiredAudienceContain"
    | "TrainingOptionalAudienceContain"
    | "TrainingContentType"
    | "TrainingCustomField"
    | "TrainingLanguage"
    | "TrainingInstructor"
    | "TrainingNeverEnroll"
    | "TrainingTag"
    | "TrainingCurrentUserMandatory"
    | "TrainingCurrentUserOptional"
    | "TrainingCurrentUserAssigned"
    | "TrainingCurrentUserRegisterTeamMembers"
    | "TrainingCurrentUserTopicInterest"
    | "TrainingNameContain"
    | "TrainingAuthorContain"
    | "TrainingExternalCodeContain"
    | "TrainingWithUsersInProgress"
    | "TrainingWithClasses"
    | "TrainingWithUsersInterest"
    | "TrainingCreatedOn"
    | "TrainingModifiedOn"
    | "TrainingIsBuilding"
    | "TrainingCreatedByYou"
    | "TrainingCreatedByUser"
    | "TrainingWithMeeting"
    | "TrainingNameOrExternalCodeContain"
    | "TrainingWithRenovationWindowEnrolls"
    | "TrainingWithInvalidatedEnrolls"
    | "TrainingWithHideConcludedEnrolls"
    | "TrainingValidateExpiringOrExpired"
    | "TrainingValidateExpired"
    | "TrainingAvailableOnApp"
    | "ClassroomWithActiveUsers"
    | "ClassroomExecutionPeriod"
    | "ClassroomNameContain"
    | "ClassroomExternalCodeContain"
    | "ClassroomUsersInProgress"
    | "ClassroomWithOpenEnrollment"
    | "ClassroomWithAudience"
    | "ClassroomExpired"
    | "ClassroomInstructor"
    | "ClassroomCreatedOn"
    | "ClassroomModifiedOn"
    | "ClassroomCreatedByYou"
    | "ClassroomCreatedByUser"
    | "EnrollPeriodEnrolled"
    | "EnrollPeriodConclusion"
    | "EnrollPeriodFirstAccess"
    | "EnrollPeriodLastAccess"
    | "EnrollPeriodHistoric"
    | "EnrollStartedMoreThanDays"
    | "EnrollInProgress"
    | "EnrollNotStart"
    | "EnrollDelayed"
    | "EnrollFinalized"
    | "EnrollApproved"
    | "EnrollReproved"
    | "EnrollInRenovationWindow"
    | "EnrollInvalidated"
    | "EnrollRejected"
    | "EnrollMandatoryAudience"
    | "EnrollOptionalAudience"
    | "EnrollOutOfAudience"
    | "EnrollDoesCertificationExpire"
    | "EnrollCertificationExpiringIn30Days"
    | "EnrollCertificationExpiringIn60Days"
    | "EnrollBlockedUsersOnly"
    | "EnrollExcludeInactiveUser"
    | "EnrollSpecificClassroom"
    | "EnrollTrainingMandatory"
    | "EnrollCanceledOrRevoked"
    | "EnrollHideInvalidated"
    | "EnrollHideConcluded"
    | "EnrollContainsStatus"
    | "EnrollRegistrationMode"
    | "EnrollUsername"
    | "BannerWithAudience"
    | "BannerNotAudience"
    | "BannerForUser"
    | "KnowledgeQuickFilter"
    | "KnowledgeChannel"
    | "KnowledgeTopic"
    | "KnowledgeAuthor"
    | "KnowledgeSticker"
    | "KnowledgeTopicsYourInterest"
    | "KnowledgeChannelsYouAreSubscribed"
    | "KnowledgeInstitutional"
    | "KnowledgeNonInstitutional"
    | "KnowledgePublishedByYou"
    | "KnowledgeUserFollowingAuthor"
    | "KnowledgeContainVideo"
    | "KnowledgeContainAudio"
    | "KnowledgeContainImage"
    | "KnowledgeContainLink"
    | "KnowledgeContainDocument"
    | "KnowledgeContainMention"
    | "KnowledgeContainShorts"
    | "KnowledgeTitleContains"
    | "KnowledgePeriod"
    | "KnowledgeCreatedOn"
    | "KnowledgeModifiedOn"
    | "KnowledgeExpired"
    | "KnowledgeAvailableInTheFuture"
    | "KnowledgeLiked"
    | "KnowledgeLikedCoworks"
    | "KnowledgeRecommended"
    | "KnowledgeTrending"
    | "KnowledgeMentioningYou"
    | "KnowledgeRestrictedAccess"
    | "KnowledgeContent"
    | "KnowledgeModifiedByManagerOrSupervisor"
    | "KnowledgeBlocked"
    | "KnowledgeViewsCount"
    | "KnowledgeLikesCount"
    | "KnowledgeCommentsCount"
    | "KnowledgeSeenByYou"
    | "KnowledgeNotSeenByYou"
    | "KnowledgeMentioning"
    | "KnowledgeMentioningUser"
    | "KnowledgeMentioningTopic"
    | "KnowledgeMentioningChannel"
    | "KnowledgeMentioningPublication"
    | "KnowledgePost"
    | "KnowledgeQuestion"
    | "KnowledgeList"
    | "KnowledgePoll"
    | "KnowledgeModerationPending"
    | "KnowledgeIsRejected"
    | "KnowledgeAvailableOnly"
    | "KnowledgeNonVisiblePubs"
    | "KnowledgeContainsPresentation"
    | "KnowledgeBinder"
    | "KnowledgePublicationTag"
    | "SurveyTypeAdHoc"
    | "SurveyTypeEfficacy"
    | "SurveyTypeReaction"
    | "SurveyPeriod"
    | "SurveySticker"
    | "SurveyStatusAnswered"
    | "SurveyStatusNotAnswered"
    | "ChannelCreatedBySelf"
    | "ChannelOwner"
    | "ChannelOwnerGroup"
    | "ChannelOwnerUnit"
    | "ChannelPublic"
    | "ChannelPrivate"
    | "EnrollOperationAudienceOption"
    | "EnrollOperationClassroom"
    | "EnrollOperationStatusEnrollment"
    | "EnrollOperationEnrollmentHistory"
    | "EnrollOperationAudienceMandatoryToEnrollOption"
    | "DashboardUserMandatoryAudience"
    | "AssessmentTopic"
    | "AssessmentLanguage"
    | "AssessmentTag"
    | "AssessmentNameContain"
    | "AssessmentAuthorContain"
    | "AssessmentCodeContain"
    | "AssessmentCreatedOn"
    | "AssessmentModifiedOn"
    | "AssessmentIsBuilding"
    | "AssessmentCreatedByYou"
    | "AssessmentCreatedByUser"
    | "AssessmentModifiedByUser"
    | "GroupContainsMember"
    | "GroupTags"
    | "GroupUsage"
    | "GroupUnit"
    | "GroupActiveAndInactive"
    | "GroupInactiveOnly"
    | "GroupSuspendedOnly"
    | "UnitUser"
    | "UnitTag"
    | "UnitCustomField"
    | "TopicSubTopic"
    | "TopicTags"
    | "TopicKnowledge"
    | "TopicSkill"
    | "TopicCompetency"
    | "TopicBundler"
    | "TopicWithPublications"
    | "TopicWithChallenge"
    | "TopicWithTraining"
    | "TopicWithSpecialist"
    | "TopicWithoutPublications"
    | "TopicWithoutChallenge"
    | "TopicWithoutTraining"
    | "TopicWithoutSpecialist"
    | "TopicActiveAndInactive"
    | "TopicInactiveOnly"
    | "TopicUserRequiredLink"
    | "TopicUserOptionalLink"
    | "TopicUserWithEndorsement"
    | "TopicUserWithProvenKnowledge"
    | "TopicUserIsVerifiedKnower"
    | "TopicUserIsSpecialist"
    | "RoleContainPermision"
    | "RoleAssignedUser"
    | "SchedulerRunning"
    | "SchedulerNeverRun"
    | "SchedulerSuccess"
    | "SchedulerFailed"
    | "SchedulerEnabledOnly"
    | "SchedulerDisabledOnly"
    | "SchedulerQueueObjectType"
    | "SchedulerMessagingFromDate"
    | "SchedulerMessagingPushOnly"
    | "SchedulerMessagingSmtpOnly"
    | "SchedulerMessagingStatusDone"
    | "SchedulerMessagingStatusFailed"
    | "SchedulerMessagingStatusPending"
    | "SchedulerMessagingStatusRunning"
    | "SchedulerMessagingToDate"
    | "SchedulerMessagingUser"
    | "MeetingActiveAndInactive"
    | "GeneralCombineUsingOR";
  value: any;
  text?: string | null;
  period?: AdvFilterPeriod | null;
  range?: AdvFilterRange | null;
  customField?: AdvFilterCustomField | null;
  includeDescendants?: boolean | null;
  /** @format uuid */
  unitTypeId?: string | null;
  quickFilter: KnowledgeFeedQuickFilter | null;
}

export type KnowledgeFeedFilterIEquatable = object;

export interface KnowledgeFeedQuickFilter {
  filterType: KnowledgeQuickFilterType;
  /** @format uuid */
  customObjectId: string | null;
}

export type KnowledgeFeedQuickFilterIEquatable = object;

export interface KnowledgeModerationSettingsResponse {
  allowManagerModeration: boolean;
}

export type KnowledgeModerationSettingsResponseIEquatable = object;

export interface KnowledgePanelAnalysisDrillByDetailQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  filters: AdvCoreFilter[];
  analysisType: KnowledgePanelAnalysisType;
  period: DateRange | null;
  searchText: string | null;
  /** @format uuid */
  drillValue: string;
}

export interface KnowledgePanelAnalysisDrillByValueQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  filters: AdvCoreFilter[];
  analysisType: KnowledgePanelAnalysisType;
  period: DateRange | null;
  searchText: string | null;
  /** @format uuid */
  drillValue: string;
}

export interface KnowledgePanelAnalysisExportCommand {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  filters: AdvCoreFilter[];
  analysisType: KnowledgePanelAnalysisType;
  period: DateRange | null;
}

export interface KnowledgePanelAnalysisQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  filters: AdvCoreFilter[];
  analysisType: KnowledgePanelAnalysisType;
  period: DateRange | null;
}

export interface KnowledgePanelGetResumeQuery {
  filters: AdvCoreFilter[];
}

export interface KnowledgePanelReview {
  /** @format int32 */
  totalPublications: number;
  /** @format int32 */
  totalPublicationsLast30: number;
  /** @format int32 */
  totalAnswers: number;
  /** @format int32 */
  totalAnswersLast30: number;
  /** @format int32 */
  totalViewsReceipt: number;
  /** @format int32 */
  totalViewsReceivedLast30: number;
  publicationsLast12: KPTupleLong[];
  publicationsLast30: KPTupleLong[];
  receivedViewsLast30: KPTupleLong[];
}

export type KnowledgePanelReviewIEquatable = object;

export type KnowledgePanelReviewIRequest = object;

export interface KnowledgeRagSearchQuery {
  searchText: string;
  conversationId: string | null;
}

export interface KnowledgeSearchDto {
  /** @format uuid */
  publicationId: string;
  /** @format uuid */
  linkedPublicationId: string | null;
  /** @format uuid */
  listExclusiveId: string | null;
  publicationType: PublicationType;
  classificationType: PublicationClassificationType;
  classificationTypeName: string;
  title: string;
  summary: string | null;
  headline: string | null;
  /** @format date-time */
  lastUpdate: Date;
  thumbnailUrl: string | null;
  /** @format uuid */
  authorId: string;
  authorName: string;
  authorThumbnailUrl: string | null;
  attachs: GlobalSearchAttachDto[];
}

export type KnowledgeSearchDtoIEquatable = object;

export interface KnowledgeSearchDtoPaginatedList {
  items: KnowledgeSearchDto[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export interface KnowledgeSearchFilters {
  searchOption: KnowledgeSearchOption;
  publicationType: PublicationType | null;
  classificationType: PublicationClassificationType | null;
  attachDocumentType: KnowledgeSearchAttachDocumentType | null;
  videoDuration: KnowledgeSearchAttachVideoDuration | null;
  restriction: KnowledgeSearchRestriction | null;
  period: KnowledgeSearchPeriod | null;
  /** @format date-time */
  periodStart: Date | null;
  /** @format date-time */
  periodEnd: Date | null;
}

export type KnowledgeSearchFiltersIEquatable = object;

export interface KnowledgeSearchQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  searchText: string;
  filters: KnowledgeSearchFilters;
  orderBy: GlobalSearchOrderBy | null;
  relevanceEnabled: boolean;
}

export interface KnowledgeSearchResponse {
  knowledgeSearchResult: UtilRequiredKeys<
    KnowledgeSearchDtoPaginatedList,
    "items" | "totalPages" | "totalRows" | "pageNumber" | "pageSize"
  > & {
    items: KnowledgeSearchDto[];
    /** @format int32 */
    totalPages: number;
    /** @format int32 */
    totalRows: number;
    /** @format int32 */
    pageNumber: number;
    /** @format int32 */
    pageSize: number;
  };
  hasVideos: boolean;
  hasDocuments: boolean;
  relevanceEnabled: boolean;
}

export type KnowledgeSearchResponseIRequest = object;

export interface LastUserRemoteLoadDataResponse {
  /** @format date-time */
  lastProcessingDate: Date;
  finishedSuccessfully: boolean;
  lastProcessingResult: string | null;
}

export type LastUserRemoteLoadDataResponseIEquatable = object;

export interface LearnPathAccessProps {
  enableOption: LearnPathComponentEnableOption;
  /** @format date-time */
  enableOnDate: Date | null;
}

export type LearnPathAccessPropsIEquatable = object;

export type LearnPathApprovalRulesPropsRecordIEquatable = object;

export interface LearnPathComponentPropsQuery {
  /** @format uuid */
  trainingId: string;
  /** @format int32 */
  versionNumber: number;
  /** @format uuid */
  componentId: string;
}

export type LearnPathComponentRegistrationPropsRecordIEquatable = object;

export interface LearnPathComponentWeightsQuery {
  /** @format uuid */
  trainingId: string;
  /** @format int32 */
  versionNumber: number;
}

export interface LearnPathComponentWeightsResponse {
  /** @format uuid */
  componentId: string;
  componentType: TrainingComponentType;
  name: string;
  /** @format int32 */
  weight: number | null;
  composeFinalScore: boolean;
}

export type LearnPathComponentWeightsResponseIEquatable = object;

export type LearnPathComponentWeightsResponseListIRequest = object;

export interface LearnPathComponentsQuery {
  /** @format uuid */
  trainingId: string;
  /** @format int32 */
  versionNumber: number;
}

export interface LearnPathEnrollCardDto {
  stateIndicator: CardIcon;
  isCurrent: boolean;
  card: CardDto;
}

export type LearnPathEnrollCardDtoIEquatable = object;

export interface LearnPathEnrollPhaseDto {
  /** @format uuid */
  phaseId: string | null;
  title: string;
  /** @format int32 */
  minCredits: number | null;
  /** @format int32 */
  maxCredits: number | null;
  currentCard: LearnPathEnrollCardDto | null;
  cards: LearnPathEnrollCardDto[];
}

export type LearnPathEnrollPhaseDtoIEquatable = object;

export interface LearnPathEnrollmentPhasesQuery {
  /** @format uuid */
  enrollmentId: string | null;
  /** @format uuid */
  classroomId: string | null;
  browserTimeZoneId: string;
}

export interface LearnPathEnrollmentPhasesResponse {
  current: LearnPathEnrollCardDto | null;
  items: LearnPathEnrollPhaseDto[];
}

export type LearnPathEnrollmentPhasesResponseIEquatable = object;

export type LearnPathEnrollmentPhasesResponseIRequest = object;

export interface LearnPathEnrollmentViewQuery {
  /** @format uuid */
  enrollmentId: string;
}

export interface LearnPathGameMapPhaseDto {
  /** @format uuid */
  componentId: string;
  phaseName: string;
  /** @format int32 */
  displayOrder: number;
  /** @format int32 */
  mapXPos: number;
  /** @format int32 */
  mapYPos: number;
  phaseVideo: FileGetDto | null;
  phaseStartupVideo: FileGetDto | null;
  phaseVideoLoop: boolean;
}

export interface LearnPathGameMapQuery {
  /** @format uuid */
  trainingId: string;
}

export interface LearnPathGameMapResponse {
  /** @format uuid */
  trainingId: string;
  mapType: GameMapType;
  /** @format int32 */
  pinAvatarSize: number;
  staticMapFile: FileGetDto | null;
  phases: LearnPathGameMapPhaseDto[];
}

export type LearnPathGameMapResponseIRequest = object;

export interface LearnPathGamePhasesListQuery {
  /** @format uuid */
  trainingId: string;
}

export interface LearnPathGamePhasesListResponse {
  /** @format uuid */
  componentId: string;
  phaseName: string;
  /** @format int32 */
  displayOrder: number;
  enabledComponents: string | null;
  enableOption: LearnPathComponentEnableOption | null;
  /** @format date-time */
  enableOnDate: Date | null;
  description: string | null;
  condition: LearnPathGameAdditionalCondition;
  /** @format int32 */
  conditionValue: number | null;
  /** @format date-time */
  finalizationDate: Date | null;
}

export type LearnPathGamePhasesListResponseListIRequest = object;

export interface LearnPathGameQuery {
  /** @format uuid */
  trainingId: string;
}

export interface LearnPathGameRankingListQuery {
  /** @format uuid */
  trainingId: string;
}

export interface LearnPathGameResponse {
  /** @format uuid */
  trainingId: string;
  mandatoryAudienceOnly: boolean;
  noTrainingReuse: boolean;
  /** @format date-time */
  dueDate: Date | null;
  showPhaseAdvanceAnimation: boolean;
  manualFile: FileGetDto | null;
}

export type LearnPathGameResponseIRequest = object;

export interface LearnPathPhaseProps {
  /** @format int32 */
  minCredits: number | null;
  /** @format int32 */
  maxCredits: number | null;
  skipPhaseOnCertificationRenewal: boolean;
  access: LearnPathAccessProps;
  /** @format date-time */
  notificationPhaseEnabledDate: Date | null;
}

export type LearnPathPhasePropsIEquatable = object;

export interface LearnPathPhasePropsQuery {
  /** @format uuid */
  trainingId: string;
  /** @format int32 */
  versionNumber: number;
  /** @format uuid */
  componentId: string;
}

export interface LearnPathPhasesViewQuery {
  /** @format uuid */
  trainingId: string;
}

export interface LearnPathPropsDto {
  access: LearnPathAccessProps;
  /** @format int32 */
  credits: number | null;
  isMandatory: boolean;
  computeProgress: boolean | null;
  classroom: AutoCompleteDataModelDto[];
  reuseOption: TrainingLearnPathReuseOption;
  /** @format date-time */
  reuseApprovedSinceDate: Date | null;
  /** @format int32 */
  reuseFinalizedSinceDays: number | null;
}

export type LearnPathPropsDtoIEquatable = object;

export type LearnPathReEnrollPropsRecordIEquatable = object;

export interface LearnPathRulesApprovalDto {
  /** @format int32 */
  minCredits: number | null;
  needsMinCreditsOnAllPhases: boolean | null;
  /** @format int32 */
  minProgress: number | null;
  /** @format int32 */
  minFinalScore: number;
  autoEnrollFinish: boolean;
  autoEnrollFinishNeedAllComponents: boolean;
  studentCanFinishEnroll: boolean;
  hasFinalScoreCalculation: boolean;
}

export type LearnPathRulesApprovalDtoIRequest = object;

export interface LearnPathRulesApprovalItem {
  /** @format int32 */
  minCredits: number | null;
  needsMinCreditsOnAllPhases: boolean | null;
  /** @format int32 */
  minProgress: number | null;
  /** @format int32 */
  minFinalScore: number;
  studentCanFinishEnroll: boolean;
  autoEnrollFinish: boolean;
  autoEnrollFinishNeedAllComponents: boolean;
}

export type LearnPathRulesApprovalItemIEquatable = object;

export interface LearnPathRulesComponentRegistrationDto {
  autoEnrollOption: TrainingLearnPathComponentAutoEnrollOption;
  allowTrainingReuse: boolean;
  ignoreAudience: boolean;
  ignoreAutoEnrollLimits: boolean;
  ignorePreRequisites: boolean;
  ignoreApproval: boolean;
}

export type LearnPathRulesComponentRegistrationDtoIRequest = object;

export interface LearnPathRulesComponentRegistrationItem {
  autoEnrollOption: TrainingLearnPathComponentAutoEnrollOption;
  ignoreAudience: boolean;
  ignorePreRequisites: boolean;
  ignoreAutoEnrollLimits: boolean;
  ignoreApproval: boolean;
  allowTrainingReuse: boolean;
}

export type LearnPathRulesComponentRegistrationItemIEquatable = object;

export interface LearnPathRulesDto {
  /** @format uuid */
  trainingId: string;
  trainingType: TrainingType;
  name: string;
  timezoneId: string;
  multipleClasses: boolean;
  hasActiveEnrollments: boolean;
  hasClosedEnrollments: boolean;
  /** @format date-time */
  createdOn: Date;
  allowRegistrationOverride: boolean;
  allowReservationsOverride: boolean;
  allowPreRequisitesOverride: boolean;
  allowExecutionOverride: boolean;
  allowAssessmentOverride: boolean;
  allowCerticateOverride: boolean;
  allowAgreementOverride: boolean;
  allowInteractionOverride: boolean;
  allowAwardOverride: boolean;
  agreement: TrainingRulesAgreementDto;
  assessment: TrainingRulesAssessmentDto;
  autoEnrollLimits: TrainingRulesAutoEnrollLimitsDto;
  award: TrainingRulesAwardDto;
  certificate: TrainingRulesCertificateDto;
  execution: TrainingRulesExecutionDto;
  interaction: TrainingRulesInteractionDto;
  registration: TrainingRulesRegistrationDto;
  seats: TrainingRulesSeatsDto;
  preRequisites: TrainingRulesPreRequisitesDto;
  progressByCredits: boolean;
  componentRegistration: LearnPathRulesComponentRegistrationDto;
  approvalRules: LearnPathRulesApprovalDto;
  reenrollRules: LearnPathRulesReEnrollDto;
}

export type LearnPathRulesDtoIEquatable = object;

export type LearnPathRulesDtoIRequest = object;

export interface LearnPathRulesQuery {
  /** @format uuid */
  trainingId: string;
}

export interface LearnPathRulesReEnrollDto {
  conditionsChanged: boolean;
  onlyIfBelongAudience: boolean;
  revokePreviousApproval: boolean;
}

export type LearnPathRulesReEnrollDtoIRequest = object;

export interface LearnPathRulesReEnrollItem {
  conditionsChanged: boolean;
  onlyIfBelongAudience: boolean;
  revokePreviousApproval: boolean;
}

export type LearnPathRulesReEnrollItemIEquatable = object;

export interface LearnPathTrainingQuery {
  /** @format uuid */
  trainingId: string;
}

export interface LearnPathViewComponentDto {
  /** @format uuid */
  componentId: string;
  /** @format int32 */
  displayOrder: number;
  title: string;
  /** @format uuid */
  trainingId: string;
  /** @format uuid */
  thumbnailId: string | null;
  thumbnailUrl: string;
  /** @format int32 */
  trainingDurationMinutes: number;
  trainingDurationFormated: string;
  trainingType: TrainingType;
  trainingTypeStr: string;
  contentType: TrainingContentType;
  contentTypeStr: string;
}

export type LearnPathViewComponentDtoIEquatable = object;

export interface LearnPathViewPhaseDto {
  /** @format int32 */
  groupNumber: number;
  /** @format uuid */
  phaseId: string;
  title: string;
  components: LearnPathViewComponentDto[];
}

export type LearnPathViewPhaseDtoIEnumerableIRequest = object;

export type LearnPathViewPhaseDtoIEquatable = object;

export interface LibraryTrainingsQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  searchText: string | null;
  browserTimeZoneId: string;
  option: LibraryTrainingsOption;
  orderBy: LibraryTrainingsOrderBy;
}

export interface LikeClassroomDiscussionCommand {
  /** @format uuid */
  classroomId: string;
  /** @format uuid */
  discussionId: string;
  like: boolean;
}

export type LikeClassroomDiscussionCommandIEquatable = object;

export interface LikeDevPlanDiscussionCommand {
  /** @format uuid */
  devPlanId: string;
  /** @format uuid */
  discussionId: string;
  like: boolean;
}

export type LikeDevPlanDiscussionCommandIEquatable = object;

export interface ListExclusiveDto {
  /** @format uuid */
  listId: string;
  title: string;
}

export interface ListPublicationItemsDto {
  /** @format uuid */
  publicationId: string;
  title: string;
  publicationType: PublicationType;
  /** @format uuid */
  questionId: string | null;
  /** @format int32 */
  displayOrder: number;
}

export type ListPublicationItemsDtoIEquatable = object;

export interface ListSubscriptionResponse {
  /** @format uuid */
  listId: string;
  title: string;
  thumbnailUrl: string | null;
  registered: boolean;
  hideQuickAccess: boolean | null;
  /** @format int32 */
  itemCount: number;
  /** @format int32 */
  followerCount: number;
}

export type ListSubscriptionResponseIEnumerableIRequest = object;

export type ListSubscriptionResponseIEquatable = object;

export interface ListSubscriptionsQuery {
  /** @format int32 */
  takeRecords: number;
  searchText: string | null;
  filterBy: ListSubscriptionFilterBy;
}

export interface LmsAwardTopicSettingsDto {
  topic: TopicAutoCompleteHierarchicalModelDto[];
  includeDescendants: boolean;
  /** @format int32 */
  grantPoints: number;
}

export type LmsAwardTopicSettingsDtoIEquatable = object;

export interface LmsCancelEnrollReasonSuggestionsQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  searchText: string | null;
}

export interface LmsSettingAwardResponse {
  /** @format uuid */
  id: string;
  /** @format int32 */
  maxEnrollPoints: number;
  /** @format int32 */
  maxEnrollApprovalPoints: number;
  /** @format int32 */
  challengePoints: number;
  applyLimits: boolean;
  awardTopics: LmsAwardTopicSettingsDto[];
}

export interface LmsSettingChallengeResponse {
  /** @format uuid */
  id: string;
  /** @format int32 */
  maxQuestions: number;
  showFeedback: boolean;
  showCorrectAnswer: boolean;
  showProvenKnowledgeRecallDays: boolean;
  showDaysBetweenRetentionTests: boolean;
  showStopRepeatRetentionTestsTimes: boolean;
  /** @format int32 */
  provenKnowledgeRecallDays: number | null;
  /** @format int32 */
  daysBetweenRetentionTests: number | null;
  /** @format int32 */
  stopRepeatRetentionTestsTimes: number | null;
  headlineR: ResourceModel[];
  thumbnail: FileGetDto | null;
}

export type LmsSettingChallengeResponseIEquatable = object;

export interface LmsSettingIndexTrainingResponse {
  /** @format uuid */
  id: string;
  /** @format uuid */
  groupingByUnitTypeId: string;
  /** @format int32 */
  gracePeriod: number;
  /** @format int32 */
  historyPeriod: number;
  /** @format date-time */
  lastProcessingDate: Date | null;
  canRequestExecution: boolean;
  /** @format date-time */
  lastExecutionRequestDate: Date | null;
  topics: TopicAutoCompleteHierarchicalModelDto[];
  restrictUsersGroups: AutoCompleteDataModelDto[];
}

export type LmsSettingIndexTrainingResponseIEquatable = object;

export interface LmsSettingReminderResponse {
  /** @format uuid */
  id: string;
  meetingLongNotificationEnabled: boolean;
  /** @format int32 */
  meetingShortNotificationMinutes: number;
  /** @format int32 */
  enrollmentDueDays: number;
  /** @format int32 */
  enrollmentExpireDays: number;
  /** @format int32 */
  inactiveDays: number;
  /** @format int32 */
  mandatoryTrainingNotEnrolledDays: number;
  /** @format int32 */
  answerNewKnowledgeTestsDays: number;
  /** @format int32 */
  activityWillExpireDays: number;
  /** @format int32 */
  continueEnrolledTrainingDays: number;
  /** @format int32 */
  developmentPlanConclusionsDays: number;
}

export type LmsSettingReminderResponseIEquatable = object;

export interface LmsSettingsResponse {
  /** @format uuid */
  id: string;
  /** @format int32 */
  deadlineEvalEfficacyAndReaction: number;
  /** @format int32 */
  unansweredApprovalRequests: number;
  /** @format int32 */
  debugScorm: number;
  /** @format date-time */
  qrCodeTimeBefore: Date | null;
  /** @format date-time */
  qrCodeTimeAfter: Date | null;
  rootName: string;
  allowEnrollUsers: boolean;
  cancelEnrollReasons: CancelEnrollReasonDto[];
}

export type LmsSettingsResponseIEquatable = object;

export interface LoadDataQueueQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  failed: boolean | null;
  searchText: string | null;
  /** @format uuid */
  queueId: string | null;
}

export interface LoginResultDto {
  loginResult: AccountLoginCheckResult;
  loginResultMessage: string | null;
  account: AccountLoginDto | null;
  /** @format date-time */
  endOfWorkDay: Date | null;
  contineAuthStamp: string | null;
  sessionId: string | null;
  /** @format uuid */
  spyUserId: string | null;
  spyUserName: string | null;
  appAuthenticatorActived: boolean;
  bypassTwoFactor: boolean;
}

export type LoginResultDtoIEquatable = object;

export interface LpGameAwardComponenPointsQuery {
  /** @format uuid */
  trainingId: string;
  /** @format uuid */
  componentId: string;
}

export interface LpGameAwardRankingListQuery {
  /** @format uuid */
  trainingId: string;
}

export interface LpGameAwardRankingListResponse {
  /** @format uuid */
  learnPathGameRankingId: string;
  name: string;
  awards: LpGameAwardRankingPositionDto[];
}

export type LpGameAwardRankingListResponseListIRequest = object;

export interface LpGameAwardRankingPositionDto {
  /** @format int32 */
  rankPosition: number;
  /** @format int32 */
  points: number;
}

export interface LpGameRankingAudienceUsersQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  trainingId: string;
  /** @format uuid */
  learnPathGameRankingId: string;
  searchText: string | null;
}

export interface LpGameRankingListResponse {
  /** @format uuid */
  learnPathGameRankingId: string;
  name: string;
  isDefault: boolean;
  enabledComponents: string | null;
  unitTypeName: string;
  unitName: string;
}

export type LpGameRankingListResponseListIRequest = object;

export interface LpGameRankingQuery {
  /** @format uuid */
  trainingId: string;
  /** @format uuid */
  learnPathGameRankingId: string;
}

export interface LpGameRankingResponse {
  /** @format uuid */
  learnPathGameRankingId: string;
  name: string;
  /** @format uuid */
  unitTypeId: string;
  isDefault: boolean;
  unit: UnitAutoCompleteHierarchicalModelDto[];
  showUserNames: boolean;
}

export type LpGameRankingResponseIRequest = object;

export interface LpGameRankingSelectorQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  trainingId: string;
  searchText: string | null;
}

export interface LpGameRankingSelectorResponse {
  /** @format uuid */
  learnPathGameRankingId: string;
  name: string;
}

export interface LpGameRankingSelectorResponsePaginatedList {
  items: LpGameRankingSelectorResponse[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type LpGameRankingSelectorResponsePaginatedListIRequest = object;

export interface LpGameScoreComponentSuggestionsQuery {
  /** @format uuid */
  trainingId: string;
  searchText: string | null;
}

export interface LpGameScoreListQuery {
  /** @format uuid */
  trainingId: string;
}

export interface LpGameScoreListResponse {
  /** @format uuid */
  componentId: string;
  name: string;
  /** @format int32 */
  displayOrder: number;
  option: LearnPathGameScoreOverrideOption;
  /** @format float */
  optionValue: number;
}

export type LpGameScoreListResponseListIRequest = object;

export interface LpTrainingComponentDto {
  /** @format uuid */
  enrollmentId: string | null;
  status: EnrollStatus | null;
  /** @format date-time */
  finalizationDate: Date | null;
  /** @format int32 */
  progressPercent: number | null;
  /** @format date-time */
  dueDate: Date | null;
}

export type LpTrainingComponentDtoIEquatable = object;

export interface MailModelPropertyDefinition {
  propName: string;
  displayName: string;
}

export interface ManageCarouselListQuery {
  module: CarouselModule;
}

export interface ManageCarouselListResponse {
  /** @format uuid */
  carouselId: string;
  /** @format int32 */
  lineNum: number;
  /** @format int32 */
  columnNum: number;
  name: string;
}

export type ManageCarouselListResponseIEquatable = object;

export type ManageCarouselListResponseListIRequest = object;

export interface ManageCarouselQuery {
  /** @format uuid */
  carouselId: string;
}

export interface ManagePromoteSettingsResponse {
  /** @format uuid */
  knowledgeSettingId: string;
  topics: TopicAutoCompleteHierarchicalModelDto[];
  channels: AutoCompleteDataModelDto[];
}

export type ManagePromoteSettingsResponseIEquatable = object;

export interface ManageSaveCarouselCommand {
  /** @format uuid */
  carouselId: string;
  names: ResourceModel[];
  module: CarouselModule;
  contentType: CarouselContentType;
  /** @format int32 */
  lineNum: number | null;
  /** @format int32 */
  columnNum: number | null;
  contentParameters: CarouselContentFilter | null;
  listType: CarouselListType | null;
  mixPubTrainingOption: CarouselPubTrainingOption | null;
  audiences: string[];
  links: CarouselLinkItem[];
  contentList: CarouselListItem[];
}

export interface ManageSaveIndicatorCommand {
  indicatorType: IndicatorType;
}

export interface ManageUserListResponse {
  users: UtilRequiredKeys<
    ManagedUserDtoPaginatedList,
    "items" | "totalPages" | "totalRows" | "pageNumber" | "pageSize"
  > & {
    items: ManagedUserDto[];
    /** @format int32 */
    totalPages: number;
    /** @format int32 */
    totalRows: number;
    /** @format int32 */
    pageNumber: number;
    /** @format int32 */
    pageSize: number;
  };
  licensing: ManageUsersLicensing;
}

export type ManageUserListResponseIRequest = object;

export interface ManageUsersLicensing {
  billingType: TenantBillingType;
  /** @format int32 */
  maxUsers: number;
  /** @format int32 */
  currentUsers: number;
  /** @format int32 */
  remaining: number;
}

export interface ManagedAbsenceTypeListQueryResponse {
  /** @format uuid */
  absenceTypeId: string;
  name: string;
  nameR: ResourceModel[];
}

export type ManagedAbsenceTypeListQueryResponseIEquatable = object;

export interface ManagedAbsenceTypeListQueryResponsePaginatedList {
  items: ManagedAbsenceTypeListQueryResponse[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export interface ManagedAccessAgreementResponse {
  assignRequired: boolean;
  /** @format uuid */
  agreementId: string | null;
  text: string | null;
  attach: FileGetDto | null;
  recordInfo: RecordInfoDto | null;
}

export type ManagedAccessAgreementResponseIEquatable = object;

export interface ManagedAccessTimeRuleListQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  searchText: string | null;
}

export interface ManagedAccessTimeRuleListResponse {
  datasource: UtilRequiredKeys<
    AccessTimeRuleItemPaginatedList,
    "items" | "totalPages" | "totalRows" | "pageNumber" | "pageSize"
  > & {
    items: AccessTimeRuleItem[];
    /** @format int32 */
    totalPages: number;
    /** @format int32 */
    totalRows: number;
    /** @format int32 */
    pageNumber: number;
    /** @format int32 */
    pageSize: number;
  };
  isActive: boolean;
}

export type ManagedAccessTimeRuleListResponseIEquatable = object;

export type ManagedAccessTimeRuleListResponseIRequest = object;

export interface ManagedAccessTimeRuleQuery {
  /** @format uuid */
  accessTimeRuleId: string;
}

export interface ManagedAccessTimeRuleResponse {
  /** @format uuid */
  accessTimeRuleId: string;
  name: string;
  description: string | null;
  constraintType: AccessTimeConstraintType;
  /** @format date-time */
  startedOn: Date;
  /** @format date-time */
  finishedOn: Date | null;
  /**
   * @format time
   * @example ""13:45:42.0000000""
   */
  startTime: string;
  /**
   * @format time
   * @example ""13:45:42.0000000""
   */
  endTime: string;
  weekDays: number[];
  allowAccessToCorporateIPS: boolean;
  denyAccessOnHolidaysCalendarId: AutoCompleteDataModelDto | null;
  denyAccessOnUserWorkplaceHolidaysCalendar: boolean;
  accessDeniedMessages: ResourceModel[];
  units: UnitAutoCompleteHierarchicalModelDto[];
  groups: AutoCompleteDataModelDto[];
  exceptionGroups: AutoCompleteDataModelDto[];
  recordInfo: RecordInfoDto | null;
}

export type ManagedAccessTimeRuleResponseIEquatable = object;

export type ManagedAccessTimeRuleResponseIRequest = object;

export interface ManagedAppAuthSettings {
  enabled: boolean;
  tenantId: string | null;
  primaryDomainName: string | null;
  /** @format uuid */
  applicationId: string | null;
  secret: string | null;
  /** @format uuid */
  objectId: string | null;
}

export type ManagedAppAuthSettingsIEquatable = object;

export interface ManagedAppAuthSettingsResponse {
  appSettings: ManagedAppAuthSettings;
  canChangeEnabled: boolean;
}

export type ManagedAppAuthSettingsResponseIEquatable = object;

export interface ManagedAssDeployListQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  searchText: string | null;
  finished: boolean;
  orderBy: SurveyDeployListOrderByQuery;
}

export interface ManagedAssDeployQuery {
  /** @format uuid */
  assDeployId: string | null;
}

export interface ManagedAssDeployRequest {
  /** @format uuid */
  deployId: string | null;
  assessement: AssessmentSelectorDto;
  groups: GroupInfo[];
  name: string | null;
  timezoneId: string | null;
  /** @format date-time */
  startDate: Date | null;
  /** @format date-time */
  endDate: Date | null;
  sticker: SelectedStickerDto | null;
}

export type ManagedAssDeployRequestIEquatable = object;

export type ManagedAssDeployRequestIRequest = object;

export interface ManagedAssQuestionListQuery {
  /** @format uuid */
  assessmentId: string;
  searchText: string | null;
  showDeleted: boolean;
}

export interface ManagedAssQuestionListResponse {
  /** @format uuid */
  itemId: string;
  /** @format uuid */
  questionId: string;
  /** @format int32 */
  currentVersion: number;
  questionText: string;
  isBlocked: boolean;
  /** @format int32 */
  points: number | null;
  assessmentItemType: AssessmentItemType;
  questionGroupName: string;
  questionType: QuestionType;
  /** @format int32 */
  numberOfQuestion: number | null;
  tags: string;
  isDeleted: boolean;
  recovery: boolean;
}

export type ManagedAssQuestionListResponseIEquatable = object;

export interface ManagedAssQuestionListResponsePaginatedList {
  items: ManagedAssQuestionListResponse[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type ManagedAssQuestionListResponsePaginatedListIRequest = object;

export interface ManagedAssRuleQuery {
  /** @format uuid */
  assessmentId: string;
  /** @format uuid */
  itemId: string;
}

export interface ManagedAssRuleResponse {
  /** @format uuid */
  assessmentId: string;
  /** @format uuid */
  itemId: string;
  assessmentItemType: AssessmentItemType;
  questionGroup: AutoCompleteHierarchicalModelDto[];
  /** @format int32 */
  numberOfQuestion: number;
  tags: TagAutoCompleteDataModelDto[];
}

export type ManagedAssRuleResponseIEquatable = object;

export type ManagedAssRuleResponseIRequest = object;

export interface ManagedAutoRegisterPendingApprovalDto {
  /** @format uuid */
  userId: string;
  name: string;
  email: string | null;
  thumbnailUrl: string | null;
  message: string | null;
}

export type ManagedAutoRegisterPendingApprovalDtoIEquatable = object;

export interface ManagedAutoRegisterPendingApprovalDtoPaginatedList {
  items: ManagedAutoRegisterPendingApprovalDto[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type ManagedAutoRegisterPendingApprovalDtoPaginatedListIRequest = object;

export interface ManagedAutoRegisterPendingApprovalQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  searchText: string | null;
  order: ManagedAutoRegisterOrder;
}

export interface ManagedAwardChannelDto {
  channel: AutoCompleteDataModelDto[];
  /** @format int32 */
  grantPoints: number;
}

export interface ManagedAwardRankingListResponse {
  /** @format uuid */
  rankingId: string;
  name: string;
  participants: AwardParticipantsType;
  unitTypeName: string;
  unitName: string | null;
  isDefault: boolean;
}

export type ManagedAwardRankingListResponseIEquatable = object;

export interface ManagedAwardRankingQuery {
  /** @format uuid */
  rankingId: string | null;
}

export interface ManagedAwardRankingResponse {
  /** @format uuid */
  rankingId: string | null;
  nameR: ResourceModel[];
  /** @format uuid */
  unitTypeId: string | null;
  participants: AwardParticipantsType;
  unit: UnitAutoCompleteHierarchicalModelDto[];
  showUserNames: boolean;
  isDefault: boolean;
}

export type ManagedAwardRankingResponseIEquatable = object;

export type ManagedAwardRankingResponseIRequest = object;

export interface ManagedAwardSettingsQueryResponse {
  /** @format int32 */
  createPostGrantPoints: number;
  /** @format int32 */
  answerQuestionGrantPoints: number;
  createPostChannels: ManagedAwardChannelDto[];
  questionAnswerChannels: ManagedAwardChannelDto[];
}

export interface ManagedBadgeListQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  searchText: string | null;
  onlyActive: boolean;
  groupAction: ManagedBadgeGroupAction;
}

export interface ManagedBadgeListQueryResponse {
  /** @format uuid */
  badgeId: string;
  name: string;
  thumbnailUrl: string;
  isActive: boolean;
  /** @format int32 */
  grantPoints: number;
}

export type ManagedBadgeListQueryResponseIEquatable = object;

export interface ManagedBadgeListQueryResponsePaginatedList {
  items: ManagedBadgeListQueryResponse[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type ManagedBadgeListQueryResponsePaginatedListIRequest = object;

export interface ManagedBadgeQuery {
  /** @format uuid */
  badgeId: string | null;
}

export interface ManagedBadgeResponse {
  /** @format uuid */
  badgeId: string | null;
  nameR: ResourceModel[];
  descriptionBeforeWinR: ResourceModel[] | null;
  descriptionAfterWinR: ResourceModel[] | null;
  /** @format int32 */
  grantPoints: number | null;
  /** @format date-time */
  startDate: Date | null;
  /** @format date-time */
  endDate: Date | null;
  timezoneId: string;
  isActive: boolean;
  thumbnail: FileGetDto | null;
  action: BadgeRuleAction;
  period: BadgeRulePeriod | null;
  /** @format int32 */
  minActions: number | null;
  actionLimit: BadgeRuleActionLimits | null;
  onlyOnce: boolean | null;
  maxUsersPerPeriod: boolean | null;
  /** @format int32 */
  awardMaxTopRanking: number | null;
  channel: AutoCompleteDataModelDto[];
  topic: TopicAutoCompleteHierarchicalModelDto[];
  topicIncludeDescendants: boolean | null;
  stickers: AutoCompleteDataModelDto[];
  trainings: AutoCompleteDataModelDto[];
  audiencesNeedAll: boolean;
  groups: GroupInfo[];
  recordInfo: RecordInfoDto | null;
}

export type ManagedBadgeResponseIEquatable = object;

export type ManagedBadgeResponseIRequest = object;

export interface ManagedBannerQuery {
  /** @format uuid */
  bannerId: string | null;
}

export interface ManagedBannerResponse {
  /** @format uuid */
  bannerId: string;
  name: string | null;
  userContainsAllGroups: boolean;
  /** @format date-time */
  startDate: Date | null;
  /** @format date-time */
  endDate: Date | null;
  timezoneId: string | null;
  contentType: BannerContentType;
  headline: ResourceModel[];
  useOwnSticker: boolean;
  title: ResourceModel[] | null;
  subtitle: ResourceModel[] | null;
  storageFile: FileGetDto | null;
  useContentImage: boolean;
  audiences: GroupInfo[];
  /** @format int32 */
  priority: number;
  useTitleSticker: boolean;
  useSubTitleSticker: boolean;
  panoramicOption: BannerPanoramicOption | null;
  /** @format int32 */
  containerHeight: number;
  recordInfo: RecordInfoDto | null;
  publication: AutoCompleteDataModelDto | null;
  sticker: AutoCompleteDataModelDto[] | null;
  training: AutoCompleteDataModelDto | null;
  assDeploy: AutoCompleteDataModelDto | null;
  topic: TopicAutoCompleteHierarchicalModelDto[] | null;
  topicGoTo: BannerTopicGoToType | null;
  systemFeature: SystemFeature | null;
  linkUrl: string | null;
  openLinkOnNewBrowserTab: boolean | null;
}

export type ManagedBannerResponseIEquatable = object;

export type ManagedBannerResponseIRequest = object;

export interface ManagedBlockReasonListQueryResponse {
  /** @format uuid */
  blockReasonId: string;
  name: string;
  nameR: ResourceModel[];
  isTemporary: boolean;
  isReserved: boolean;
}

export type ManagedBlockReasonListQueryResponseIEquatable = object;

export interface ManagedBlockReasonListQueryResponsePaginatedList {
  items: ManagedBlockReasonListQueryResponse[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export interface ManagedCalendarListResponse {
  /** @format uuid */
  calendarId: string;
  name: string;
  isDefault: boolean;
}

export type ManagedCalendarListResponseIEquatable = object;

export interface ManagedCalendarListResponsePaginatedList {
  items: ManagedCalendarListResponse[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export interface ManagedChangeLoginBlockQuery {
  /** @format uuid */
  userId: string;
}

export interface ManagedChangeLoginBlockQueryResponse {
  status: UserStatus;
  /** @format uuid */
  blockReasonId: string | null;
  /** @format date-time */
  unblockAt: Date | null;
  blocker: UserDto | null;
  /** @format date-time */
  blockedOn: Date | null;
  /** @format date-time */
  accessExpiresOn: Date | null;
}

export type ManagedChangeLoginBlockQueryResponseIEquatable = object;

export type ManagedChangeLoginBlockQueryResponseIRequest = object;

export interface ManagedChannelListQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  searchText: string | null;
  filters: AdvCoreFilter[];
  includeChannelsAdminPermission: boolean;
  orderBy: ManagedChannelListOrderBy;
}

export interface ManagedChannelListQueryResponse {
  /** @format uuid */
  channelId: string;
  name: string;
  thumbnailUrl: string;
  /** @format int32 */
  totalMembers: number;
  /** @format int32 */
  totalPublications: number;
  /** @format int64 */
  totalStorageSize: number;
  isPrivate: boolean;
  canDelete: boolean;
  canJoin: boolean;
  canAccessConfidencialInfo: boolean;
}

export type ManagedChannelListQueryResponseIEquatable = object;

export interface ManagedChannelListQueryResponsePaginatedList {
  items: ManagedChannelListQueryResponse[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type ManagedChannelListQueryResponsePaginatedListIRequest = object;

export interface ManagedChannelMembersListResponse {
  /** @format uuid */
  memberId: string;
  memberType: MemberType;
  name: string;
  thumbnailUrl: string;
  role: ChannelRoles;
  roleName: string;
  hasDirectAssignment: boolean;
}

export type ManagedChannelMembersListResponseIEquatable = object;

export interface ManagedChannelMembersListResponsePaginatedList {
  items: ManagedChannelMembersListResponse[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export interface ManagedChannelQueryResponse {
  /** @format uuid */
  channelId: string;
  name: string;
  thumbnailUrl: string;
  /** @format uuid */
  thumbnailId: string | null;
  description: string | null;
  /** @format uuid */
  ownerId: string;
  preferModerationByManager: boolean;
  approvalMode: ChannelApprovalMode;
  enableVideoModeration: boolean;
  isPrivate: boolean;
  denyExternalUsers: boolean;
  containsConfidentialInfo: boolean;
  autoRegisterMode: ChannelAutoRegisterMode;
  dismissApprovalForUnits: boolean;
  dismissApprovalWithPassword: boolean;
  approvalPassword: string | null;
  suggestApprovalPassword: string | null;
  allowInvite: boolean;
  autoRegisterRole: ChannelRoles;
  allowNonMemberComments: boolean;
  allowSupervisorEdit: boolean;
  enableIaQuestionAnswering: boolean;
  requirePublicationEditJustification: boolean;
  useCustomQuickFilter: boolean;
  moderator: AutoCompleteDataModelDto;
  recordInfo: RecordInfoDto | null;
  isOwnerOrManager: boolean;
  canEditAllowSupervisorEdit: boolean;
  topicsSuggested: TopicAutoCompleteHierarchicalModelDto[];
  unitsDismissed: UnitAutoCompleteHierarchicalModelDto[];
}

export interface ManagedChannelSuggestionsQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  searchText: string | null;
  exceptChannelIds: string[];
}

export interface ManagedClassroomActivityQuery {
  /** @format uuid */
  classroomId: string;
  /** @format uuid */
  componentId: string;
}

export interface ManagedClassroomMeetingQuery {
  /** @format uuid */
  classroomId: string;
  /** @format uuid */
  componentId: string;
}

export interface ManagedClassroomQuery {
  /** @format uuid */
  trainingId: string;
  /** @format uuid */
  classroomId: string;
}

export interface ManagedClassroomResponse {
  /** @format uuid */
  classroomId: string;
  name: string;
  nameReadOnly: boolean;
  trainingName: string;
  trainingContentType: TrainingContentType;
  trainningMultipleClasses: boolean;
  trainingIsExclusive: boolean;
  /** @format uuid */
  thumbnailId: string | null;
  thumbnailUrl: string;
  instructors: AutoCompleteDataModelDto[];
  owners: AutoCompleteDataModelDto[];
  timezoneId: string;
  externalCode: string | null;
  externalCodeReadOnly: boolean;
  isActive: boolean;
  hasClosedEnrollments: boolean;
  recordInfo: ClassroomRecordInfoDto | null;
  customFields: CustomFieldValueDto[];
}

export type ManagedClassroomResponseIEquatable = object;

export type ManagedClassroomResponseIRequest = object;

export interface ManagedClassroomsListQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  trainingId: string;
  searchText: string | null;
  onlyActive: boolean;
  filter: AdvCoreFilter[];
  orderBy: ManagedClassroomOrderByQuery;
}

export interface ManagedClassroomsListResponse {
  /** @format uuid */
  classroomId: string;
  name: string;
  isActive: boolean;
  trainingName: string;
  /** @format int32 */
  enrollmentsCount: number;
  /** @format int32 */
  activeEnrollmentsCount: number;
  /** @format int32 */
  finishedEnrollmentCount: number;
  /** @format int32 */
  approvedPercent: number;
  /** @format date-time */
  enrollAvailableFrom: Date | null;
  /** @format date-time */
  enrollAvailableUntil: Date | null;
  enrollSuspended: boolean;
  /** @format date-time */
  dueDate: Date | null;
  enrollClosed: boolean;
  canTutoring: boolean;
}

export interface ManagedClassroomsListResponsePaginatedList {
  items: ManagedClassroomsListResponse[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type ManagedClassroomsListResponsePaginatedListIRequest = object;

export interface ManagedCustomFieldListQueryResponse {
  fieldId: string;
  fieldType: CustomFieldType;
  usage: CustomFieldUsages;
  usageName: string;
  usageSubTypeName: string | null;
  label: string;
  isActive: boolean;
}

export type ManagedCustomFieldListQueryResponseIEquatable = object;

export interface ManagedCustomFieldListQueryResponsePaginatedList {
  items: ManagedCustomFieldListQueryResponse[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export interface ManagedCustomFieldQueryResponse {
  fieldId: string;
  fieldType: CustomFieldType;
  fieldTypeName: string;
  usage: CustomFieldUsages;
  usageName: string;
  usageSubType: string | null;
  labelR: ResourceModel[];
  placeholderTextR: ResourceModel[];
  validationErrorMessageR: ResourceModel[];
  defaultValue: string | null;
  isActive: boolean;
  isRequired: boolean;
  isUnique: boolean;
  keepHistory: boolean;
  showConcealed: boolean;
  /** @format int32 */
  sequenceOrder: number;
  fillConstraint: CustomFieldFillConstraint;
  showWidth: CustomFieldWidth;
  isVisibleToSelfUser: boolean | null;
  isEditableToSelfUser: boolean | null;
  showOnUserProfile: boolean | null;
  isPersonalInformation: boolean | null;
  userDisplayArea: CustomFieldUserDisplayArea | null;
  canBeUsedOnEmailTemplates: boolean;
  canBeUsedInFilters: boolean;
  textField: TextFieldDto | null;
  numericField: NumericFieldDto | null;
  valueSelectionField: ValueSelectionFieldDto | null;
  objectSelectionField: ObjectSelectionFieldDto | null;
  recordInfo: RecordInfoDto;
}

export type ManagedCustomFieldQueryResponseIEquatable = object;

export interface ManagedEfficacySurveyParticipantsQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  userId: string;
  searchText: string | null;
}

export interface ManagedEfficacySurveyParticipantsResponse {
  /** @format uuid */
  deployId: string;
  /** @format uuid */
  deployParticipantId: string;
  /** @format uuid */
  assessmentId: string;
  /** @format date-time */
  validUntil: Date;
  /** @format date-time */
  answeredOn: Date | null;
  expired: boolean;
  /** @format uuid */
  trainingId: string;
  trainingName: string;
  thumbnailUrl: string;
  contentType: TrainingContentType;
}

export type ManagedEfficacySurveyParticipantsResponseIEquatable = object;

export interface ManagedEfficacySurveyParticipantsResponsePaginatedList {
  items: ManagedEfficacySurveyParticipantsResponse[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type ManagedEfficacySurveyParticipantsResponsePaginatedListIRequest =
  object;

export interface ManagedEnrollmentClassroomListQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  trainingId: string;
  searchText: string | null;
}

export interface ManagedEnrollmentClassroomListResponse {
  /** @format uuid */
  classroomId: string;
  name: string;
  timezoneId: string;
  enrollSuspended: boolean;
  executionDueDateOption: TrainingDueDateOption;
  /** @format date-time */
  executionStartDate: Date | null;
  /** @format date-time */
  executionDueDate: Date | null;
  /** @format int32 */
  executionDueDays: number | null;
  /** @format int32 */
  availableEnrollmentsCount: number;
}

export type ManagedEnrollmentClassroomListResponseIEquatable = object;

export type ManagedEnrollmentClassroomListResponseIRequest = object;

export interface ManagedEnrollmentClassroomListResponsePaginatedList {
  items: ManagedEnrollmentClassroomListResponse[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type ManagedEnrollmentClassroomListResponsePaginatedListIRequest =
  object;

export interface ManagedEnrollmentProcessResponse {
  /** @format int64 */
  totalSuccess: number | null;
  /** @format int64 */
  totalFail: number | null;
  usersFail: ManagedEnrollmentProcessUserDto[];
}

export type ManagedEnrollmentProcessResponseIEquatable = object;

export type ManagedEnrollmentProcessResponseIRequest = object;

export interface ManagedEnrollmentProcessUserDto {
  /** @format uuid */
  userId: string;
  name: string;
  message: string | null;
}

export interface ManagedEnrollmentSelectedUsersQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  trainingId: string;
  operation: ManageEnrollOperation;
}

export interface ManagedEnrollmentTrainingListQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  searchText: string | null;
  /** @format uuid */
  trainingId: string | null;
  /** @format uuid */
  classroomId: string | null;
  addCompletedClassroom: boolean;
  filter: AdvCoreFilter[];
  orderBy: ManagedEnrollmentTrainingsListOrderBy;
}

export interface ManagedEnrollmentTrainingListResponse {
  /** @format uuid */
  trainingId: string;
  trainingType: TrainingType;
  contentType: TrainingContentType;
  contentTypeStr: string;
  name: string;
  thumbnailUrl: string | null;
  /** @format int32 */
  classCount: number;
  timezoneId: string;
  multipleClasses: boolean;
  isCoordinator: boolean;
  /** @format uuid */
  classroomId: string;
  classroomName: string;
  enrollSuspended: boolean;
  executionDueDateOption: TrainingDueDateOption;
  /** @format date-time */
  executionStartDate: Date | null;
  /** @format date-time */
  executionDueDate: Date | null;
  /** @format int32 */
  executionDueDays: number | null;
  /** @format int32 */
  availableEnrollmentsCount: number;
}

export type ManagedEnrollmentTrainingListResponseIEquatable = object;

export interface ManagedEnrollmentTrainingListResponsePaginatedList {
  items: ManagedEnrollmentTrainingListResponse[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type ManagedEnrollmentTrainingListResponsePaginatedListIRequest = object;

export interface ManagedEnrollmentTrainingSelectorQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  searchText: string | null;
  /** @format uuid */
  exceptTrainingId: string | null;
  trainingType: TrainingType | null;
}

export interface ManagedEnrollmentUserListQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  trainingId: string;
  /** @format uuid */
  classroomId: string | null;
  operation: ManageEnrollOperation;
  useImportedUsers: boolean;
  searchText: string | null;
  filter: AdvCoreFilter[];
}

export interface ManagedEvaluationListQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  searchText: string | null;
  viewActiveAndBlock: boolean | null;
  filter: AdvCoreFilter[];
  orderBy: EvaluationListOrderByQuery;
}

export interface ManagedEvaluationListResponse {
  /** @format uuid */
  assessmentId: string;
  name: string;
  externalCode: string;
  /** @format date-time */
  publishedOn: Date | null;
  isBlocked: boolean;
  /** @format double */
  storageSize: number;
  /** @format int32 */
  totalQuestions: number;
  thumbnailUrl: string;
}

export type ManagedEvaluationListResponseIEquatable = object;

export interface ManagedEvaluationListResponsePaginatedList {
  items: ManagedEvaluationListResponse[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type ManagedEvaluationListResponsePaginatedListIRequest = object;

export interface ManagedEvaluationQuery {
  /** @format uuid */
  assessmentId: string | null;
}

export interface ManagedExpressClassroomQuery {
  /** @format uuid */
  trainingId: string;
}

export interface ManagedExpressClassroomResponse {
  name: string;
  nameReadOnly: boolean;
  /** @format date-time */
  dueDate: Date | null;
  allowExecutionOverride: boolean;
}

export type ManagedExpressClassroomResponseIEquatable = object;

export type ManagedExpressClassroomResponseIRequest = object;

export interface ManagedGroupCurrentMembersQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  groupId: string;
  searchText: string | null;
  expanded: boolean;
}

export interface ManagedGroupMembersListQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  groupId: string;
  searchText: string | null;
}

export interface ManagedGroupMembersListResponse {
  /** @format uuid */
  memberId: string;
  name: string;
  memberType: MemberType;
  thumbnailUrl: string;
  operation: MemberOperation | null;
}

export type ManagedGroupMembersListResponseIEquatable = object;

export interface ManagedGroupMembersListResponsePaginatedList {
  items: ManagedGroupMembersListResponse[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type ManagedGroupMembersListResponsePaginatedListIRequest = object;

export interface ManagedGroupQuery {
  /** @format uuid */
  groupId: string | null;
  groupType: GroupType;
}

export interface ManagedGroupQueryFieldSpecDto {
  id: string;
  specField: string;
  typeArg: ManagedGroupQueryTypeArg;
  operator: GroupDynamicSpecFieldOperators;
  negate: boolean;
  values: AutoCompleteDataModelDto[];
  unitValues: UnitAutoCompleteHierarchicalModelDto[] | null;
  topicValues: TopicAutoCompleteHierarchicalModelDto[] | null;
  value: string | null;
  /** @format double */
  minValue: number | null;
  /** @format double */
  maxValue: number | null;
  /** @format date-time */
  startDate: Date | null;
  /** @format date-time */
  endDate: Date | null;
  boolValue: boolean | null;
  customFieldType: CustomFieldType | null;
  customFieldObjectType: CustomFieldObjectType | null;
}

export type ManagedGroupQueryFieldSpecDtoIEquatable = object;

export interface ManagedGroupQueryRuleDto {
  expressions: InfixExpressionItem[];
  items: ManagedGroupQueryFieldSpecDto[];
}

export type ManagedGroupQueryRuleDtoIEquatable = object;

export interface ManagedGroupQueryTypeArg {
  key: any;
  label: string;
}

export type ManagedGroupQueryTypeArgIEquatable = object;

export interface ManagedGroupResponse {
  /** @format uuid */
  groupId: string | null;
  groupType: GroupType;
  active: boolean;
  name: string | null;
  description: string | null;
  thumbnail: FileGetDto | null;
  usages: GroupUsages | null;
  unit: UnitAutoCompleteHierarchicalModelDto[];
  recordInfo: RecordInfoDto | null;
  tags: TagAutoCompleteDataModelDto[];
  rules: ManagedGroupQueryRuleDto;
  pauseProcessing: boolean;
  dynamicGroupsProcessing: string;
  /** @format date-time */
  lastProcessingDate: Date | null;
}

export type ManagedGroupResponseIEquatable = object;

export type ManagedGroupResponseIRequest = object;

export interface ManagedGroupsListQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  groupType: GroupType;
  searchText: string | null;
  filters: AdvCoreFilter[];
  orderBy: AdminGroupListOrderByQuery;
}

export interface ManagedGroupsListResponse {
  /** @format uuid */
  groupId: string;
  groupType: GroupType;
  name: string;
  thumbnailUrl: string;
  /** @format int32 */
  memberCount: number;
  pauseProcessing: boolean | null;
  active: boolean | null;
  /** @format int32 */
  queueProcessingCount: number;
}

export type ManagedGroupsListResponseIEquatable = object;

export interface ManagedGroupsListResponsePaginatedList {
  items: ManagedGroupsListResponse[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type ManagedGroupsListResponsePaginatedListIRequest = object;

export interface ManagedHolidayListResponse {
  /** @format uuid */
  calendarId: string;
  /** @format date */
  day: Date;
  name: string;
  periodOfDay: HolidayPeriodOfDay;
}

export type ManagedHolidayListResponseIEquatable = object;

export interface ManagedHolidayListResponsePaginatedList {
  items: ManagedHolidayListResponse[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export interface ManagedImportResponse {
  locale: string;
  timezoneId: string;
  dataSeparator: ImportRulesDataSeparator;
  /** @format int32 */
  auditDays: number;
}

export type ManagedImportResponseIEquatable = object;

export interface ManagedImportUserRemoteResponse {
  useAutomaticLoadData: boolean;
  ftpHost: string | null;
  /** @format int32 */
  ftpPort: number | null;
  ftpUser: string | null;
  ftpPassword: string | null;
  ftpDirectory: string | null;
  ftpFile: string | null;
  isSecureFtp: boolean | null;
  /**
   * @format time
   * @example ""13:45:42.0000000""
   */
  timeExecution: string | null;
  /** @format date-time */
  lastExecution: Date | null;
}

export type ManagedImportUserRemoteResponseIEquatable = object;

export interface ManagedImportUserResponse {
  /** @format uuid */
  blockReasonTempId: string | null;
  /** @format uuid */
  blockReasonId: string | null;
  trainingAction: ImportUserRolesInactivateTrainingAction;
  enrollReasons: AutoCompleteDataModelDto[];
  roles: AutoCompleteDataModelDto[];
  managerErrorAction: ImportUserRolesManagerErrorAction;
  changePassword: boolean;
  listExceptions: AutoCompleteDataModelDto[];
  sendNotificationMail: boolean;
  recipient: AutoCompleteDataModelDto | null;
}

export type ManagedImportUserResponseIEquatable = object;

export interface ManagedInfoResponse {
  /** @format uuid */
  classroomId: string;
  name: string;
  timezoneId: string;
  /** @format uuid */
  trainingId: string;
  trainingName: string;
  multipleClasses: boolean;
}

export type ManagedInfoResponseIEquatable = object;

export type ManagedInfoResponseIRequest = object;

export interface ManagedInstructorAppointmentsQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  instructorId: string;
  searchText: string | null;
  onlyConflicts: boolean;
  includeCompleted: boolean;
  /** @format date-time */
  meetingDate: Date | null;
  onlySpecificDay: boolean;
  orderBy: ManagedInstructorAppointmentsOrderBy;
}

export interface ManagedInstructorCalendarQuery {
  /** @format uuid */
  instructorId: string;
  /** @format date-time */
  meetingDate: Date;
  includeCompleted: boolean;
  browerTimeZoneId: string;
}

export interface ManagedInstructorClassesQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  instructorId: string;
  searchText: string | null;
  includeCompleted: boolean;
  orderBy: ManagedInstructorClassesOrderBy;
}

export interface ManagedInstructorClassesResponse {
  /** @format uuid */
  classroomId: string;
  name: string;
  multipleClasses: boolean;
  /** @format uuid */
  trainingId: string;
  trainingType: TrainingType;
  trainingName: string;
  trainingContentType: TrainingContentType;
  thumbnailUrl: string | null;
  /** @format date-time */
  startDate: Date;
  /** @format date-time */
  dueDate: Date | null;
  canMonitoringClass: boolean;
  canEditClass: boolean;
  canEditTraining: boolean;
}

export type ManagedInstructorClassesResponseIEquatable = object;

export interface ManagedInstructorClassesResponsePaginatedList {
  items: ManagedInstructorClassesResponse[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type ManagedInstructorClassesResponsePaginatedListIRequest = object;

export interface ManagedInstructorListQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  searchText: string | null;
  filter: AdvCoreFilter[];
  onlyConflicts: boolean;
  includeCompleted: boolean;
  orderBy: ManagedInstructorListOrderBy;
}

export interface ManagedInstructorListResponse {
  /** @format uuid */
  instructorId: string;
  name: string;
  thumbnailUrl: string;
  /** @format int32 */
  classesCount: number;
  /** @format int32 */
  meetingsCount: number;
  /** @format int32 */
  conflictsCount: number;
  /** @format date-time */
  nextMeetingStartDate: Date | null;
  /** @format date-time */
  nextMeetingEndDate: Date | null;
}

export type ManagedInstructorListResponseIEquatable = object;

export interface ManagedInstructorListResponsePaginatedList {
  items: ManagedInstructorListResponse[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type ManagedInstructorListResponsePaginatedListIRequest = object;

export interface ManagedKnowledgeSettingsResponse {
  /** @format uuid */
  knowledgeSettingId: string;
  allowVideoForExternalUsers: boolean;
  /** @format int32 */
  maxAttachLength: number | null;
  attachLimitsBypassGroups: AutoCompleteDataModelDto[];
  autoRegisterShortVideos: boolean;
  institutionalThumbnail: FileGetDto | null;
  institutionalName: string;
  viewsPrivacy: KnowledgeViewsPrivacy;
  preferAIModeration: boolean;
  allowManagerModeration: boolean;
  allowManagerEdit: boolean;
  /** @format int32 */
  aiTopicThreshold: number;
}

export type ManagedKnowledgeSettingsResponseIEquatable = object;

export interface ManagedMailTemplateListQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  searchText: string | null;
  category: NotificationModule;
}

export interface ManagedMailTemplateListResponse {
  notificationTypeId: NotificationType;
  module: NotificationModule;
  name: string;
  moduleName: string;
}

export type ManagedMailTemplateListResponseIEquatable = object;

export interface ManagedMailTemplateListResponsePaginatedList {
  items: ManagedMailTemplateListResponse[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type ManagedMailTemplateListResponsePaginatedListIRequest = object;

export interface ManagedMailTemplateQuery {
  notificationTypeId: NotificationType;
  locale: string;
}

export interface ManagedManagerTypeListQueryResponse {
  /** @format uuid */
  id: string;
  name: string;
  nameR: ResourceModel[];
  externalCode: string;
}

export type ManagedManagerTypeListQueryResponseIEquatable = object;

export interface ManagedManagerTypeListQueryResponsePaginatedList {
  items: ManagedManagerTypeListQueryResponse[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export interface ManagedMeetingDto {
  /** @format uuid */
  meetingId: string;
  meetingType: MeetingType;
  name: string;
  description: string | null;
  thumbnail: FileGetDto | null;
  assignPresenceAfterViewRecording: boolean;
  hasScore: boolean;
  /** @format date-time */
  startDate: Date | null;
  /** @format date-time */
  endDate: Date | null;
  /** @format timespan */
  bookAdditionalTimeBefore: string | null;
  /** @format timespan */
  bookAdditionalTimeAfter: string | null;
  computeProgress: boolean;
  meetingRoom: MeetingRoomAutoCompleteDataModelDto | null;
  location: ManagedMeetingLocationDto | null;
  onlineLocation: ManagedMeetingOnlineLocationDto | null;
  instructors: AutoCompleteDataModelDto[];
  assistants: AutoCompleteDataModelDto[];
  multipleClasses: boolean;
  trainingName: string;
  classroomName: string | null;
  meetingTypesEnabled: MeetingType[];
  started: boolean;
}

export type ManagedMeetingDtoIEquatable = object;

export type ManagedMeetingDtoIRequest = object;

export interface ManagedMeetingLocationDto {
  locationName: string;
  timezoneId: string;
  address: AddressModel | null;
}

export type ManagedMeetingLocationDtoIEquatable = object;

export interface ManagedMeetingOnlineLocationDto {
  timezoneId: string;
  externalUrl: string | null;
  zoomUrl: string | null;
  teamsUrl: string | null;
  /** @format int32 */
  minPermanence: number | null;
}

export type ManagedMeetingOnlineLocationDtoIEquatable = object;

export interface ManagedMemberSelectorQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  searchText: string | null;
  ignoreSelectionHistory: boolean;
  exceptGroupIds: string[];
}

export interface ManagedMemberSelectorResponse {
  /** @format uuid */
  memberId: string;
  name: string;
  thumbnailUrl: string | null;
  memberType: MemberType;
  fromHistory: boolean;
}

export type ManagedMemberSelectorResponseIEquatable = object;

export interface ManagedMemberSelectorResponsePaginatedList {
  items: ManagedMemberSelectorResponse[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type ManagedMemberSelectorResponsePaginatedListIRequest = object;

export interface ManagedNotificationTemplateResponse {
  notificationTypeId: NotificationType;
  locale: string;
  subject: string;
  body: string | null;
  header: string | null;
  footer: string | null;
  preCodeBlock: string;
  attachCalendarIcs: boolean | null;
  allowReply: boolean;
  replyEmail: string | null;
  defaultSubject: string;
  defaultBody: string | null;
  recordInfo: RecordInfoDto | null;
  templateProperties: MailModelPropertyDefinition[] | null;
}

export type ManagedNotificationTemplateResponseIEquatable = object;

export type ManagedNotificationTemplateResponseIRequest = object;

export interface ManagedPerformaSettingsResponse {
  /** @format uuid */
  settingId: string;
  enabled: boolean;
  baseUrl: string;
  webServicesUserId: string;
  webServicesPassword: string;
}

export type ManagedPerformaSettingsResponseIEquatable = object;

export interface ManagedQuestionAlternativeDto {
  /** @format uuid */
  alternativeId: string;
  text: string;
  /** @format int32 */
  displayOrder: number;
  publicationRecommended: AutoCompleteDataModelDto[];
  trainingRecommended: AutoCompleteDataModelDto[];
  evaluation: QuestionAlternativeEvaluationDto | null;
  survey: QuestionAlternativeSurveyDto | null;
}

export type ManagedQuestionAlternativeDtoIEquatable = object;

export interface ManagedQuestionDefaultValuesQuery {
  /** @format uuid */
  questionGroupId: string | null;
}

export interface ManagedQuestionDefaultValuesResponse {
  /** @format int32 */
  points: number;
  allowInKnowledgeTests: boolean;
}

export type ManagedQuestionDefaultValuesResponseIEquatable = object;

export type ManagedQuestionDefaultValuesResponseIRequest = object;

export interface ManagedQuestionEvaluationDto {
  /** @format int32 */
  points: number;
  randomized: boolean;
  allowInKnowledgeTests: boolean;
  allowPartialScore: boolean;
  feedback: string | null;
  otherIncorrectAnswers: string[] | null;
}

export type ManagedQuestionEvaluationDtoIEquatable = object;

export interface ManagedQuestionGroupListItemResponse {
  /** @format uuid */
  questionGroupId: string;
  /** @format uuid */
  parentGroupId: string | null;
  name: string;
  fullPathName: string;
  /** @format int32 */
  defaultPoints: number | null;
  defaultAllowInKnowledgeTests: boolean;
  /** @format int32 */
  totalQuestions: number;
  /** @format int32 */
  totalSubGroup: number;
  canUseKnowledgeTests: boolean;
  hasTopic: boolean;
  forSurvey: boolean;
  canManage: boolean;
}

export type ManagedQuestionGroupListItemResponseIEquatable = object;

export interface ManagedQuestionGroupListItemResponsePaginatedList {
  items: ManagedQuestionGroupListItemResponse[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export interface ManagedQuestionGroupListQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  questionGroupId: string | null;
  /** @format uuid */
  parentGroupId: string | null;
  searchText: string | null;
  forSurvey: boolean;
  onlyUseKnowledgeTest: boolean;
  listType: ManagedQuestionGroupListType;
}

export interface ManagedQuestionGroupListResponse {
  listItems: UtilRequiredKeys<
    ManagedQuestionGroupListItemResponsePaginatedList,
    "items" | "totalPages" | "totalRows" | "pageNumber" | "pageSize"
  > & {
    items: ManagedQuestionGroupListItemResponse[];
    /** @format int32 */
    totalPages: number;
    /** @format int32 */
    totalRows: number;
    /** @format int32 */
    pageNumber: number;
    /** @format int32 */
    pageSize: number;
  };
  rootGroupName: string;
}

export type ManagedQuestionGroupListResponseIEquatable = object;

export type ManagedQuestionGroupListResponseIRequest = object;

export interface ManagedQuestionGroupQuery {
  /** @format uuid */
  questionGroupId: string | null;
  /** @format uuid */
  parentGroupId: string | null;
}

export interface ManagedQuestionGroupResponse {
  /** @format uuid */
  questionGroupId: string | null;
  parentGroup: AutoCompleteHierarchicalModelDto[];
  name: string;
  /** @format int32 */
  defaultPoints: number;
  defaultAllowInKnowledgeTests: boolean;
}

export type ManagedQuestionGroupResponseIEquatable = object;

export type ManagedQuestionGroupResponseIRequest = object;

export interface ManagedQuestionListQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  questionGroupId: string;
  searchText: string | null;
  viewActiveAndBlock: boolean | null;
  orderBy: QuestionListOrderByQuery;
}

export interface ManagedQuestionListResponse {
  /** @format uuid */
  questionId: string;
  /** @format int32 */
  currentVersion: number;
  questionText: string;
  isBlocked: boolean;
  /** @format int32 */
  points: number;
  /** @format date-time */
  publishedOn: Date | null;
  /** @format double */
  storage: number;
  questionType: QuestionType;
  questionClass: QuestionClass;
  /** @format int32 */
  totalVersions: number;
  allowInKnowledgeTests: boolean;
  hasQuestionActive: boolean;
  groupHasTopic: boolean;
}

export type ManagedQuestionListResponseIEquatable = object;

export interface ManagedQuestionListResponsePaginatedList {
  items: ManagedQuestionListResponse[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type ManagedQuestionListResponsePaginatedListIRequest = object;

export interface ManagedQuestionQuery {
  /** @format uuid */
  questionId: string;
  /** @format int32 */
  version: number | null;
}

export interface ManagedQuestionResponse {
  /** @format uuid */
  questionId: string | null;
  /** @format uuid */
  questionGroupId: string | null;
  /** @format uuid */
  exclusiveAssessmentId: string | null;
  questionType: QuestionType;
  questionClass: QuestionClass;
  isBlocked: boolean;
  /** @format int32 */
  applyCount: number;
  questionText: string | null;
  remarks: string | null;
  attach: FileGetDto | null;
  thumbnailUrl: string | null;
  alternatives: ManagedQuestionAlternativeDto[];
  differentFeedback: boolean;
  publicationRecommended: AutoCompleteDataModelDto[];
  trainingRecommended: AutoCompleteDataModelDto[];
  /** @format date-time */
  publishedOn: Date | null;
  tags: TagAutoCompleteDataModelDto[];
  placeholderText: string | null;
  /** @format int32 */
  maxLen: number | null;
  changeVersion: boolean;
  evaluation: ManagedQuestionEvaluationDto | null;
  survey: ManagedQuestionSurveyDto | null;
  availableQuestioBank: boolean | null;
}

export type ManagedQuestionResponseIEquatable = object;

export type ManagedQuestionResponseIRequest = object;

export interface ManagedQuestionSurveyDto {
  pointTyped: boolean | null;
  showSideBySide: boolean;
  /** @format int32 */
  fillInMinValue: number | null;
  /** @format int32 */
  fillInMaxValue: number | null;
  essayAnswerRequired: boolean | null;
}

export type ManagedQuestionSurveyDtoIEquatable = object;

export interface ManagedQuestionVersionListQuery {
  /** @format uuid */
  questionId: string;
}

export interface ManagedQuestionVersionListResponse {
  /** @format uuid */
  questionId: string;
  /** @format int32 */
  version: number;
  questionType: QuestionType;
  questionClass: QuestionClass;
  /** @format uuid */
  questionGroupId: string | null;
  /** @format date-time */
  publishedOn: Date | null;
  createdName: string;
  modifiedName: string;
  /** @format date-time */
  createdOn: Date;
  /** @format date-time */
  modifiedOn: Date;
  /** @format int32 */
  applyCount: number;
  isCurrent: boolean;
}

export type ManagedQuestionVersionListResponseIEquatable = object;

export type ManagedQuestionVersionListResponseListIRequest = object;

export interface ManagedQuickAccessQuery {
  searchText: string | null;
  orderBy: ManagedQuickAccessOrderBy;
  filterBy: ManagedQuickAccessFilterBy;
}

export interface ManagedQuickAccessResponse {
  /** @format uuid */
  subscriptionId: string;
  subscriptionType: KnowledgeSubscriptionType;
  subscriptionName: string;
  name: string;
  thumbnailUrl: string | null;
  hide: boolean;
}

export type ManagedQuickAccessResponseIEnumerableIRequest = object;

export type ManagedQuickAccessResponseIEquatable = object;

export interface ManagedQuickFilterQuery {
  /** @format uuid */
  quickFilterId: string;
}

export interface ManagedQuickFilterResponse {
  /** @format uuid */
  quickFilterId: string;
  filterType: KnowledgeQuickFilterType;
  topic: TopicAutoCompleteHierarchicalModelDto[];
  channel: AutoCompleteDataModelDto[];
  sticker: AutoCompleteDataModelDto[];
  tag: AutoCompleteDataModelDto[];
  /** @format date-time */
  dueDate: Date | null;
}

export type ManagedQuickFilterResponseIEquatable = object;

export type ManagedQuickFilterResponseIRequest = object;

export interface ManagedQuickFilterTypeListQuery {
  scope: KnowledgeQuickFilterScope;
}

export interface ManagedQuickFilterTypeListResponse {
  filterType: KnowledgeQuickFilterType;
  name: string;
}

export type ManagedQuickFilterTypeListResponseIEquatable = object;

export type ManagedQuickFilterTypeListResponseListIRequest = object;

export interface ManagedQuickFiltersListQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  scope: KnowledgeQuickFilterScope;
  /** @format uuid */
  scopeRef: string | null;
  searchText: string | null;
  listExpired: boolean;
}

export interface ManagedQuickFiltersListResponse {
  /** @format uuid */
  quickFilterId: string;
  name: string;
  filterType: KnowledgeQuickFilterType;
  /** @format date-time */
  dueDate: Date | null;
}

export type ManagedQuickFiltersListResponseIEquatable = object;

export interface ManagedQuickFiltersListResponsePaginatedList {
  items: ManagedQuickFiltersListResponse[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type ManagedQuickFiltersListResponsePaginatedListIRequest = object;

export interface ManagedReportGroupResponse {
  /** @format uuid */
  reportGroupId: string;
  nameR: ResourceModel[];
  inUse: boolean;
  name: string;
}

export type ManagedReportGroupResponseIEquatable = object;

export interface ManagedReportListQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  searchText: string;
  viewStatus: ManagedReportListStatusView;
}

export interface ManagedReportListResponse {
  /** @format uuid */
  reportId: string;
  name: string;
  groupName: string;
  isActive: boolean;
}

export type ManagedReportListResponseIEquatable = object;

export interface ManagedReportListResponsePaginatedList {
  items: ManagedReportListResponse[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type ManagedReportListResponsePaginatedListIRequest = object;

export interface ManagedReportQuery {
  /** @format uuid */
  reportId: string;
}

export interface ManagedReportResponse {
  /** @format uuid */
  reportId: string;
  name: string;
  /** @format uuid */
  reportGroupId: string;
  sqlExpression: string;
  isActive: boolean;
  orderByValues: KeyLabelModel[];
  parameters: ReportParamDto[];
  recordInfo: RecordInfoDto;
}

export type ManagedReportResponseIEquatable = object;

export type ManagedReportResponseIRequest = object;

export interface ManagedRoleGroupConflitResolutionQuery {
  /** @format uuid */
  roleId: string;
  /** @format uuid */
  groupId: string;
}

export interface ManagedRoleGroupConflitResolutionResponse {
  currentOption: RoleMergeOption;
  options: Record<string, string>;
}

export type ManagedRoleGroupConflitResolutionResponseIEquatable = object;

export type ManagedRoleGroupConflitResolutionResponseIRequest = object;

export interface ManagedRoleGroupConstraintsQuery {
  /** @format uuid */
  roleId: string;
  /** @format uuid */
  groupId: string;
}

export type ManagedRoleGroupConstraintsQueryIEquatable = object;

export interface ManagedRoleGroupConstraintsQueryResponse {
  permissions: RolePermissionConstraintsDto[];
  hasOwnConstraints: boolean;
}

export type ManagedRoleGroupConstraintsQueryResponseIEquatable = object;

export type ManagedRoleGroupConstraintsQueryResponseIRequest = object;

export interface ManagedRoleGroupQueryResponse {
  /** @format uuid */
  groupId: string;
  name: string;
  thumbnailUrl: string;
  groupType: GroupType;
  statusCode: ManagedRoleGroupStatus;
  statusCodeName: string;
}

export type ManagedRoleGroupQueryResponseIEquatable = object;

export interface ManagedRoleGroupQueryResponsePaginatedList {
  items: ManagedRoleGroupQueryResponse[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type ManagedRoleGroupQueryResponsePaginatedListIRequest = object;

export interface ManagedRoleGroupsQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  roleId: string;
  name: string | null;
}

export interface ManagedRoleListQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  name: string | null;
  filters: AdvCoreFilter[];
}

export interface ManagedRoleQuery {
  /** @format uuid */
  roleId: string;
}

export interface ManagedRoleQueryResponse {
  /** @format uuid */
  roleId: string;
  nameR: ResourceModel[];
  descriptionR: ResourceModel[];
  externalCode: string | null;
  isFreelyAssignable: boolean;
  isReserved: boolean;
  defaultConstraints: PermissionConstraintDto;
  recordInfo: RecordInfoDto | null;
  canEditPermissions: boolean;
  canChangeUserOptions: boolean;
  canAddGroupRole: boolean;
  hasAssignmentDependency: boolean;
  permissions: RolePermissionDto[];
  assignmentDependencyRoles: AutoCompleteDataModelDto[];
}

export type ManagedRoleQueryResponseIEquatable = object;

export type ManagedRoleQueryResponseIRequest = object;

export interface ManagedRoleResponse {
  /** @format uuid */
  roleId: string;
  name: string;
  /** @format int32 */
  usersCount: number;
  /** @format int32 */
  groupsCount: number;
  isReserved: boolean;
  canAssignGroups: boolean;
}

export type ManagedRoleResponseIEquatable = object;

export interface ManagedRoleResponsePaginatedList {
  items: ManagedRoleResponse[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type ManagedRoleResponsePaginatedListIRequest = object;

export interface ManagedRoleUserConflitResolutionQuery {
  /** @format uuid */
  roleId: string;
  /** @format uuid */
  userId: string;
}

export interface ManagedRoleUserConflitResolutionResponse {
  currentOption: RoleMergeOption;
  options: Record<string, string>;
}

export type ManagedRoleUserConflitResolutionResponseIEquatable = object;

export type ManagedRoleUserConflitResolutionResponseIRequest = object;

export interface ManagedRoleUserConstraintsQuery {
  /** @format uuid */
  roleId: string;
  /** @format uuid */
  userId: string;
}

export interface ManagedRoleUserConstraintsQueryResponse {
  permissions: RolePermissionConstraintsDto[];
  hasOwnConstraints: boolean;
}

export type ManagedRoleUserConstraintsQueryResponseIEquatable = object;

export type ManagedRoleUserConstraintsQueryResponseIRequest = object;

export interface ManagedRoleUserGroupsAssignedQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  userId: string;
  searchText: string | null;
}

export interface ManagedRoleUserGroupsAssignedQueryResponse {
  /** @format uuid */
  groupId: string;
  name: string;
  thumbnailUrl: string;
}

export type ManagedRoleUserGroupsAssignedQueryResponseIEquatable = object;

export interface ManagedRoleUserGroupsAssignedQueryResponsePaginatedList {
  items: ManagedRoleUserGroupsAssignedQueryResponse[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type ManagedRoleUserGroupsAssignedQueryResponsePaginatedListIRequest =
  object;

export interface ManagedRoleUserQueryResponse {
  /** @format uuid */
  userId: string;
  name: string;
  thumbnailUrl: string;
  isDirectAssignment: boolean;
  statusCode: ManagedRoleUserStatus;
  statusCodeName: string;
}

export type ManagedRoleUserQueryResponseIEquatable = object;

export type ManagedRoleUserQueryResponseListIRequest = object;

export interface ManagedRoleUserQueryResponsePaginatedList {
  items: ManagedRoleUserQueryResponse[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type ManagedRoleUserQueryResponsePaginatedListIRequest = object;

export interface ManagedRoleUserSuggestionsQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  roleId: string;
  searchText: string | null;
  ignoreSelectionHistory: boolean;
}

export interface ManagedRoleUsersQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  roleId: string;
  name: string | null;
}

export interface ManagedSamlAuthHelpers {
  canChangeEnabled: boolean;
  hasSamlCertificate: boolean;
}

export type ManagedSamlAuthHelpersIEquatable = object;

export interface ManagedSamlAuthSettings {
  enabled: boolean;
  identifier: string;
  loginUrl: string;
  logoutUrl: string;
  firstNameClaimField: string | null;
  lastNameClaimField: string | null;
  emailClaimField: string | null;
  locationClaimField: string | null;
  phoneClaimField: string | null;
  objectIdClaimField: string | null;
  autoRegisterOnUnits: UnitAutoCompleteHierarchicalModelDto[];
  autoRegisterRole: AutoCompleteDataModelDto | null;
  helpers: ManagedSamlAuthHelpers;
}

export type ManagedSamlAuthSettingsIEquatable = object;

export interface ManagedSamlAuthSettingsResponse {
  samlSettings: ManagedSamlAuthSettings;
  helpers: ManagedSamlAuthHelpers;
}

export type ManagedSamlAuthSettingsResponseIEquatable = object;

export interface ManagedShortVideoConfidentialQuery {
  searchText: string | null;
  showExpired: boolean | null;
}

export interface ManagedShortVideoListQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  searchText: string | null;
  showExpired: boolean | null;
  isAdminList: boolean;
  orderBy: ShortVideoListOrderBy;
}

export interface ManagedShortVideoListResponse {
  /** @format uuid */
  shortVideoId: string;
  /** @format uuid */
  publicationId: string;
  /** @format int64 */
  startTime: number;
  /** @format int64 */
  endTime: number;
  title: string;
  /** @format date-time */
  dueDate: Date | null;
}

export type ManagedShortVideoListResponseIEquatable = object;

export interface ManagedShortVideoListResponsePaginatedList {
  items: ManagedShortVideoListResponse[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type ManagedShortVideoListResponsePaginatedListIRequest = object;

export interface ManagedSsoAuthSettingsResponse {
  enabled: boolean;
  sourceUrl: string;
  integrationKey: string;
  helpers: ManagedStandardAuthHelpers;
}

export type ManagedSsoAuthSettingsResponseIEquatable = object;

export interface ManagedStandardAuthHelpers {
  possibleAuthFields: PossibleAuthFieldModel[];
  canChangeEnabled: boolean;
}

export type ManagedStandardAuthHelpersIEquatable = object;

export interface ManagedStandardAuthSettingsResponse {
  enabled: boolean;
  identityFields: string[];
  identifierInstuctions: string;
  /** @format int32 */
  minLen: number;
  requiresOneNumber: boolean;
  requiresOneUpperLetter: boolean;
  requiresOneSymbol: boolean;
  allowNameParts: boolean;
  /** @format int32 */
  maxInvalidPasswordAttempts: number;
  /** @format int32 */
  lockoutTime: number;
  enablePasswordRecovery: boolean;
  requiresCaptcha: boolean;
  twoFactorAppAuthenticatorEnabled: boolean;
  twoFactorEmailEnabled: boolean;
  allowSkipAppAuthenticator: boolean;
  helpers: ManagedStandardAuthHelpers;
}

export type ManagedStandardAuthSettingsResponseIEquatable = object;

export interface ManagedStickerListQueryResponse {
  /** @format uuid */
  stickerId: string;
  name: string;
  nameR: ResourceModel[];
  backgroundColor: string;
  priority: StickerPriority;
  isActive: boolean;
  stickerType: StickerType;
  isSystemSticker: boolean;
}

export type ManagedStickerListQueryResponseIEquatable = object;

export interface ManagedStickerListQueryResponsePaginatedList {
  items: ManagedStickerListQueryResponse[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export interface ManagedStickerPriority {
  key: StickerPriority;
  label: string;
}

export type ManagedStickerPriorityIEquatable = object;

export interface ManagedStickerQuery {
  /** @format uuid */
  stickerId: string | null;
}

export interface ManagedStickerResponse {
  /** @format uuid */
  stickerId: string | null;
  applyTo: StickerAppliesTo;
  nameR: ResourceModel[];
  color: string;
  priority: StickerPriority;
  restrictedUse: boolean;
  requiredDeadline: boolean;
  isSystemSticker: boolean;
  canBeAssignedByUser: boolean;
  settings: ManagedStickerSettings;
  recordInfo: RecordInfoDto | null;
}

export type ManagedStickerResponseIEquatable = object;

export type ManagedStickerResponseIRequest = object;

export interface ManagedStickerSettings {
  priorities: ManagedStickerPriority[];
}

export type ManagedStickerSettingsIEquatable = object;

export interface ManagedSurveyDeployListResponse {
  /** @format uuid */
  deployId: string;
  /** @format uuid */
  assessmentId: string;
  name: string;
  thumbnailUrl: string;
  /** @format date-time */
  startDate: Date;
  /** @format date-time */
  endDate: Date;
  /** @format int32 */
  totalAnswers: number;
  isActive: boolean;
  isStarted: boolean;
  isFinalized: boolean;
}

export type ManagedSurveyDeployListResponseIEquatable = object;

export interface ManagedSurveyDeployListResponsePaginatedList {
  items: ManagedSurveyDeployListResponse[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type ManagedSurveyDeployListResponsePaginatedListIRequest = object;

export interface ManagedSurveyListQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  searchText: string | null;
  viewActiveAndBlock: boolean | null;
  filter: AdvCoreFilter[];
  orderBy: SurveyListOrderByQuery;
}

export interface ManagedSurveyListResponse {
  /** @format uuid */
  assessmentId: string;
  name: string;
  externalCode: string;
  /** @format date-time */
  publishedOn: Date | null;
  isBlocked: boolean;
  /** @format double */
  storageSize: number;
  /** @format int32 */
  totalQuestions: number;
  thumbnailUrl: string;
}

export type ManagedSurveyListResponseIEquatable = object;

export interface ManagedSurveyListResponsePaginatedList {
  items: ManagedSurveyListResponse[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type ManagedSurveyListResponsePaginatedListIRequest = object;

export interface ManagedSurveyQuery {
  /** @format uuid */
  assessmentId: string | null;
}

export interface ManagedSystemSettingsResponse {
  title: string;
  uiTheme: string;
  logo: FileGetDto | null;
  background: FileGetDto | null;
  highlightImage: FileGetDto | null;
  icon: FileGetDto | null;
  timezoneId: string;
  locale: string;
  blockSendMail: boolean;
  enableSendBirthday: boolean;
  emailSenderName: string;
  emailSenderAddress: string;
  /** @format int32 */
  maxAuditLogDays: number;
  /** @format int32 */
  maxSchedulerLogDays: number;
  corporateIP: string[];
  /**
   * @format time
   * @example ""13:45:42.0000000""
   */
  dynamicGroupsProcessingTime: string;
  /** @format int32 */
  bannerInterval: number | null;
  /** @format int32 */
  bannerHeight: number | null;
  bannerAutomaticRotation: boolean;
  bannerViewRandom: boolean;
  canChangeEmailAddress: boolean;
}

export type ManagedSystemSettingsResponseIEquatable = object;

export interface ManagedTagListQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  usage: TagUsage;
  restriction: TagRestriction | null;
  searchText: string | null;
}

export interface ManagedTagListResponse {
  /** @format uuid */
  tagId: string;
  name: string;
  usage: TagUsage;
  inUse: boolean;
  isSystemTag: boolean;
}

export type ManagedTagListResponseIEquatable = object;

export interface ManagedTagListResponsePaginatedList {
  items: ManagedTagListResponse[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type ManagedTagListResponsePaginatedListIRequest = object;

export interface ManagedTagQuery {
  /** @format uuid */
  tagId: string;
}

export interface ManagedTagResponse {
  /** @format uuid */
  tagId: string;
  name: string;
  recordInfo: RecordInfoDto | null;
}

export type ManagedTagResponseIEquatable = object;

export type ManagedTagResponseIRequest = object;

export interface ManagedTagRestrictionListResponse {
  restriction: TagRestriction;
  name: string;
}

export type ManagedTagRestrictionListResponseIEquatable = object;

export interface ManagedTagUsageListResponse {
  usage: TagUsage;
  name: string;
}

export type ManagedTagUsageListResponseIEquatable = object;

export interface ManagedTopicChallengeQuery {
  /** @format uuid */
  topicId: string;
}

export interface ManagedTopicChallengeRequest {
  /** @format uuid */
  topicId: string | null;
  /** @format uuid */
  internalQuestionGroupId: string | null;
  audiencesNeedAll: boolean;
  groups: GroupInfo[];
  fullName: string | null;
  disableChallenge: boolean;
  grantSealProvenKnowledge: boolean;
  isKnowledgeProveDirty: boolean;
  questionGroups: ManagedTopicQuestionGroupDto[];
}

export type ManagedTopicChallengeRequestIEquatable = object;

export type ManagedTopicChallengeRequestIRequest = object;

export interface ManagedTopicGroupsQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  topicId: string;
  searchText: string | null;
}

export interface ManagedTopicGroupsQueryResponse {
  /** @format uuid */
  groupId: string;
  name: string;
  requiredLink: boolean;
}

export type ManagedTopicGroupsQueryResponseIEquatable = object;

export interface ManagedTopicGroupsQueryResponsePaginatedList {
  items: ManagedTopicGroupsQueryResponse[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type ManagedTopicGroupsQueryResponsePaginatedListIRequest = object;

export interface ManagedTopicListQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  topicId: string | null;
  /** @format uuid */
  parentId: string | null;
  searchText: string | null;
  filters: AdvCoreFilter[];
  listType: ManagedTopicListType;
}

export interface ManagedTopicListResponse {
  /** @format uuid */
  topicId: string;
  /** @format uuid */
  parentId: string | null;
  name: string;
  thumbnailUrl: string;
  isActive: boolean;
  /** @format int32 */
  totalDirectTopics: number;
  category: TopicCategory;
  categoryName: string;
  canCreate: boolean;
  canUpdate: boolean;
  canDelete: boolean;
  /** @format int32 */
  hops: number;
}

export type ManagedTopicListResponseIEquatable = object;

export interface ManagedTopicListResponsePaginatedList {
  items: ManagedTopicListResponse[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type ManagedTopicListResponsePaginatedListIRequest = object;

export interface ManagedTopicQuery {
  /** @format uuid */
  topicId: string | null;
  /** @format uuid */
  parentId: string | null;
}

export interface ManagedTopicQuestionGroupDto {
  /** @format uuid */
  questionGroupId: string;
  name: string;
  fullName: string;
  /** @format int32 */
  totalQuestions: number;
}

export type ManagedTopicQuestionGroupDtoIEquatable = object;

export interface ManagedTopicRelationsQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  topicId: string;
  searchText: string | null;
}

export interface ManagedTopicRelationsQueryResponse {
  /** @format uuid */
  topicId: string;
  name: string;
  thumbnailUrl: string;
  origin: TopicRelationOrigin;
  creatorName: string;
}

export type ManagedTopicRelationsQueryResponseIEquatable = object;

export interface ManagedTopicRelationsQueryResponsePaginatedList {
  items: ManagedTopicRelationsQueryResponse[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type ManagedTopicRelationsQueryResponsePaginatedListIRequest = object;

export interface ManagedTopicResponse {
  /** @format uuid */
  topicId: string | null;
  /** @format uuid */
  parentId: string | null;
  category: TopicCategory;
  nameR: ResourceModel[];
  name: string;
  descriptionR: ResourceModel[];
  parent: TopicAutoCompleteHierarchicalModelDto[];
  isActive: boolean;
  allowUserAutoInterest: boolean;
  isAvailableForExternalUsers: boolean;
  akaNames: string[] | null;
  thumbnail: FileGetDto | null;
  recordInfo: RecordInfoDto | null;
  tags: TagAutoCompleteDataModelDto[];
  supportData: TopicSupportDataDto;
  isUsed: boolean;
}

export type ManagedTopicResponseIEquatable = object;

export type ManagedTopicResponseIRequest = object;

export interface ManagedTopicUsersQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  topicId: string;
  searchText: string | null;
  viewRequiredLink: boolean | null;
  viewOptionalLink: boolean | null;
  isSpecialist: boolean | null;
  hasProvenKnowledgeSeal: boolean | null;
  hasEndorsement: boolean | null;
  hasProvenKnowdledge: boolean | null;
  hasAssessedProficiency: boolean | null;
  orderBy: ManagedTopicUsersOrderBy;
}

export interface ManagedTopicUsersQueryResponse {
  /** @format uuid */
  userId: string;
  name: string;
  thumbnailUrl: string;
  isSpecialist: boolean;
  specialistSealGrantedBy: string;
  /** @format date-time */
  specialistSealGrantedOn: Date | null;
  hasProvenKnowledgeSeal: boolean;
  /** @format int32 */
  endorsements: number;
  loggedUserHasEndorsed: boolean;
  canGrantSpecialistSeal: boolean;
  /** @format double */
  provenKnowledgePercent: number;
  requiredLink: boolean;
  dynamicLink: boolean;
}

export type ManagedTopicUsersQueryResponseIEquatable = object;

export interface ManagedTopicUsersQueryResponsePaginatedList {
  items: ManagedTopicUsersQueryResponse[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type ManagedTopicUsersQueryResponsePaginatedListIRequest = object;

export interface ManagedTopicUsersSuggestionQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  topicId: string;
  searchText: string | null;
}

export interface ManagedTrainingAgreementResponse {
  /** @format uuid */
  defaultAgreementId: string | null;
  defaultAgreement: AgreementAutoCompleteDataModelDto | null;
  canCreateExclusiveAgreement: boolean;
}

export type ManagedTrainingAgreementResponseIEquatable = object;

export interface ManagedTrainingsListQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  searchText: string | null;
  onlyActive: boolean;
  filter: AdvCoreFilter[];
  orderBy: ManagedTrainingsListOrderBy;
}

export interface ManagedTrainingsListResponse {
  /** @format uuid */
  trainingId: string;
  trainingType: TrainingType;
  contentType: TrainingContentType;
  contentTypeStr: string;
  name: string;
  /** @format int32 */
  currentContentVersion: number;
  multipleClasses: boolean;
  enrollSuspended: boolean;
  hasPendingDraft: boolean;
  thumbnailUrl: string;
  /** @format date-time */
  publishedOn: Date | null;
  /** @format int64 */
  totalStorageSize: number;
  /** @format int32 */
  activeEnrollmentsCount: number;
  /** @format int32 */
  usersEnrolledCount: number;
  isActive: boolean;
  /** @format uuid */
  classroomId: string | null;
  classroomName: string | null;
  canTrainingManage: boolean;
  canTrainingUpdate: boolean;
  canClassroomManage: boolean;
  canTutoring: boolean;
  /** @format int32 */
  totalUsersInterest: number;
}

export type ManagedTrainingsListResponseIEquatable = object;

export interface ManagedTrainingsListResponsePaginatedList {
  items: ManagedTrainingsListResponse[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type ManagedTrainingsListResponsePaginatedListIRequest = object;

export interface ManagedUnitListQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  searchText: string | null;
  filters: AdvCoreFilter[];
  /** @format uuid */
  unitId: string | null;
  /** @format uuid */
  parentId: string | null;
  /** @format uuid */
  unitTypeId: string | null;
  onlyRoot: boolean;
  onlyTreeUp: boolean;
}

export interface ManagedUnitListResponse {
  /** @format uuid */
  unitId: string;
  /** @format uuid */
  unitTypeId: string;
  /** @format uuid */
  parentId: string;
  /** @format int32 */
  totalDirectUnits: number;
  /** @format int32 */
  totalUnits: number;
  /** @format int32 */
  totalDirectUsers: number;
  /** @format int32 */
  totalUsers: number;
  name: string;
  unitTypeName: string;
  /** @format int32 */
  depthLevel: number;
  canCreate: boolean;
  canUpdate: boolean;
  canDelete: boolean;
}

export type ManagedUnitListResponseIEquatable = object;

export interface ManagedUnitListResponsePaginatedList {
  items: ManagedUnitListResponse[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type ManagedUnitListResponsePaginatedListIRequest = object;

export interface ManagedUnitPermissionResponse {
  canCreateAnyUnit: boolean;
}

export type ManagedUnitPermissionResponseIEquatable = object;

export interface ManagedUnitQuery {
  /** @format uuid */
  unitId: string | null;
  /** @format uuid */
  parentId: string | null;
  /** @format uuid */
  unitTypeId: string | null;
}

export interface ManagedUnitQuerySettings {
  workplaceLabel: string;
  isWorkplaceFreeText: boolean;
}

export type ManagedUnitQuerySettingsIEquatable = object;

export interface ManagedUnitResponse {
  /** @format uuid */
  unitId: string | null;
  /** @format uuid */
  unitTypeId: string | null;
  /** @format uuid */
  parentId: string | null;
  parent: UnitAutoCompleteHierarchicalModelDto[];
  parentUnitTypeName: string;
  nameR: ResourceModel[];
  description: string | null;
  allowAssociates: boolean;
  externalCode: string | null;
  defaultUserLocale: string | null;
  /** @format uuid */
  defaultUserWorkplaceId: string | null;
  defaultUserWorkplace: string | null;
  activeWorkplace: boolean;
  activeUserLocale: boolean;
  workplace: AutoCompleteDataModelDto[];
  customFields: CustomFieldValueDto[] | null;
  tags: TagAutoCompleteDataModelDto[];
  recordInfo: RecordInfoDto | null;
  settings: ManagedUnitQuerySettings;
}

export type ManagedUnitResponseIEquatable = object;

export type ManagedUnitResponseIRequest = object;

export interface ManagedUnitTypeQuery {
  /** @format uuid */
  unitTypeId: string | null;
}

export interface ManagedUnitTypeQuerySettings {
  canChangeIsRequired: boolean;
}

export type ManagedUnitTypeQuerySettingsIEquatable = object;

export interface ManagedUnitTypeResponse {
  /** @format uuid */
  unitTypeId: string | null;
  nameR: ResourceModel[];
  branchNameR: ResourceModel[];
  externalCode: string;
  isRequired: boolean;
  allowMultiSelection: boolean;
  showOnUserProfile: boolean;
  defineJobsAndPositions: boolean;
  thumbnail: FileGetDto | null;
  recordInfo: RecordInfoDto | null;
  settings: ManagedUnitTypeQuerySettings;
}

export type ManagedUnitTypeResponseIEquatable = object;

export type ManagedUnitTypeResponseIRequest = object;

export interface ManagedUnitUserQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  unitId: string;
  searchText: string | null;
  userType: ManagedUnitUserType;
}

export interface ManagedUserCredentialsQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  userId: string;
  searchText: string | null;
  credentialType: UserCredentialType | null;
}

export interface ManagedUserCredentialsResponse {
  /** @format uuid */
  credentialId: string;
  credentialType: UserCredentialType;
  title: string;
  description: string | null;
  /** @format date-time */
  startedOn: Date | null;
  /** @format date-time */
  finishedOn: Date | null;
}

export type ManagedUserCredentialsResponseIEquatable = object;

export interface ManagedUserDto {
  /** @format uuid */
  userId: string;
  name: string;
  thumbnailUrl: string;
  email: string;
  status: UserStatus;
  statusName: string;
  isManager: boolean;
  hasManager: boolean;
  isDeleted: boolean;
  isAbsent: boolean;
  hasSamlAccount: boolean;
  hasStandardAccount: boolean;
  canChangePassword: boolean;
  canBlockOrSetAbsence: boolean;
  canAssignRole: boolean;
  canImpersonate: boolean;
  canEdit: boolean;
  canDelete: boolean;
  isLockedout: boolean;
  twoFactorActivated: boolean;
  userType: UserType;
}

export type ManagedUserDtoIEquatable = object;

export interface ManagedUserDtoPaginatedList {
  items: ManagedUserDto[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export interface ManagedUserGroupSuggestionsQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  userId: string;
  searchText: string | null;
}

export interface ManagedUserGroupsQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  userId: string;
  searchText: string | null;
}

export interface ManagedUserGroupsQueryResponse {
  /** @format uuid */
  groupId: string;
  name: string;
  thumbnailUrl: string;
  directGroup: boolean;
  status: ManagedUserGroupsQueryStatus;
  groupType: GroupType;
}

export type ManagedUserGroupsQueryResponseIEquatable = object;

export interface ManagedUserGroupsQueryResponsePaginatedList {
  items: ManagedUserGroupsQueryResponse[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type ManagedUserGroupsQueryResponsePaginatedListIRequest = object;

export interface ManagedUserIdiomsResponse {
  idiomId: string;
  name: string;
  readingProficiency: UserIdiomProficiencyType;
  writingProficiency: UserIdiomProficiencyType;
  speakingProficiency: UserIdiomProficiencyType;
  hearingProficiency: UserIdiomProficiencyType;
  abroadExperienceTime: UserIdiomAbroadExperienceTime | null;
  isNative: boolean;
  isDefault: boolean;
  hasAbroadExperienceTime: boolean;
}

export type ManagedUserIdiomsResponseIEquatable = object;

export interface ManagedUserListQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  searchText: string | null;
  filters: AdvCoreFilter[];
  isSelectable: boolean | null;
  /** @format int32 */
  forceLimit: number | null;
  orderBy: ManagedUserListOrderByQuery;
}

export interface ManagedUserPermissionsQuery {
  /** @format uuid */
  userId: string;
  searchText: string | null;
}

export interface ManagedUserPermissionsQueryResponse {
  permissionId: string;
  name: string;
  constraints: PermissionConstraintDto;
}

export type ManagedUserPermissionsQueryResponseIEnumerableIRequest = object;

export type ManagedUserPermissionsQueryResponseIEquatable = object;

export interface ManagedUserQuery {
  /** @format uuid */
  userId: string | null;
}

export interface ManagedUserQueryResponse {
  customFieldsBasic: CustomFieldValueDto[] | null;
  customFieldsCorporate: CustomFieldValueDto[] | null;
  customFieldsPersonal: CustomFieldValueDto[] | null;
  customFieldsAdditional: CustomFieldValueDto[] | null;
  customFieldsConcealed: CustomFieldValueDto[] | null;
  /** @format uuid */
  userId: string;
  name: string;
  displayName: string;
  email: string | null;
  preferredLocale: string | null;
  status: UserStatus;
  statusName: string;
  manager: UserDto | null;
  approver: UserDto | null;
  workplace: WorkplaceDto | null;
  workplaceText: string | null;
  thumbnail: FileGetDto | null;
  isExternalUser: boolean;
  recordInfo: RecordInfoDto;
  /** @format date-time */
  lastLoginOn: Date | null;
  /** @format date */
  admissionDate: Date | null;
  /** @format date */
  dismissedDate: Date | null;
  /** @format date-time */
  accessExpiresOn: Date | null;
  /** @format date */
  birthDate: Date | null;
  /** @format uuid */
  blockReasonId: string | null;
  /** @format date-time */
  unblockAt: Date | null;
  blocker: UserDto | null;
  /** @format date-time */
  blockedOn: Date | null;
  allowUserConnections: boolean;
  receiveDailySummaryEmail: boolean;
  unitTypes: UnitTypeItemDto[];
  secondaryManagers: SecondaryManagerItemDto[] | null;
  tags: UserTagDto[];
  phones: UserPhoneDto[];
  socialNetworks: UserSocialNetworkDto[];
  settings: ManagedUserQuerySettings;
  hasSamlAccount: boolean;
  generatePassword: boolean;
  password: string | null;
  readonly: boolean;
  userType: UserType;
}

export type ManagedUserQueryResponseIEquatable = object;

export type ManagedUserQueryResponseIRequest = object;

export interface ManagedUserQuerySettings {
  workplaceLabel: string;
  isWorkplaceFreeText: boolean;
  workplaceRequiredForNewUsers: boolean;
  isEmailRequired: boolean;
  isEmailUnique: boolean;
  unitTypeAccess: Record<string, boolean>;
  /** @format int32 */
  passwordMinLength: number;
  passwordRequiresOneUpperLetter: boolean;
  passwordRequiresOneNumber: boolean;
  passwordRequiresOneSymbol: boolean;
  passwordAllowNameParts: boolean;
  canAssignRoles: boolean;
}

export type ManagedUserQuerySettingsIEquatable = object;

export interface ManagedUserRecordFilesQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  userId: string;
  searchText: string | null;
}

export interface ManagedUserRecordFilesResponse {
  file: FileGetDto;
  /** @format date-time */
  createdOn: Date;
  creator: string;
  /** @format uuid */
  createdBy: string;
}

export type ManagedUserRecordFilesResponseIEquatable = object;

export interface ManagedUserRecordFilesResponsePaginatedList {
  items: ManagedUserRecordFilesResponse[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type ManagedUserRecordFilesResponsePaginatedListIRequest = object;

export interface ManagedUserRolePermissionsQuery {
  /** @format uuid */
  userId: string;
}

export interface ManagedUserRolePermissionsResponse {
  canAssignRoles: boolean;
}

export type ManagedUserRolePermissionsResponseIEquatable = object;

export type ManagedUserRolePermissionsResponseIRequest = object;

export interface ManagedUserRoleSuggestionsQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  userId: string;
  searchText: string | null;
}

export interface ManagedUserRolesQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  userId: string;
  searchText: string | null;
}

export interface ManagedUserRolesQueryResponse {
  /** @format uuid */
  roleId: string;
  name: string;
  statusCode: ManagedRoleUserStatus;
  statusCodeName: string;
  isDirectAssignment: boolean;
  isReserved: boolean;
  systemRoleName: string;
  canChangeUserOptions: boolean;
}

export type ManagedUserRolesQueryResponseIEquatable = object;

export interface ManagedUserRolesQueryResponsePaginatedList {
  items: ManagedUserRolesQueryResponse[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type ManagedUserRolesQueryResponsePaginatedListIRequest = object;

export interface ManagedUserSettingsResponse {
  canUncheckEmailRequired: boolean;
  isEmailRequired: boolean;
  isEmailUnique: boolean;
  alertToFillEmail: boolean;
  workplaceLabel: ResourceModel[];
  isWorkplaceFreeText: boolean;
  workplaceRequiredForNewUsers: boolean;
  alertToFillWorkplace: boolean;
  agreementMustBeAssinged: boolean;
  sendWelcomeEmail: boolean;
  defaultRole: AutoCompleteDataModelDto | null;
  roles: AutoCompleteDataModelDto[];
  enableAutoRegister: boolean;
  autoRegisterOnUnits: UnitAutoCompleteHierarchicalModelDto[];
  autoRegisterUserType: UserType | null;
  autoRegisterRequireApproval: boolean;
  autoRegisterRole: AutoCompleteDataModelDto;
  usersNotifyAutoRegister: AutoCompleteDataModelDto[];
  requiresAccountValidation: boolean;
  registerFormMode: string;
  registerFormExternalUrl: string;
}

export type ManagedUserSettingsResponseIEquatable = object;

export interface ManagedUserTopicsQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  userId: string;
  searchText: string | null;
  orderBy: ManagedUserTopicsOrderBy;
  viewRequiredLink: boolean | null;
  viewOptionalLink: boolean | null;
  isSpecialist: boolean | null;
  hasProvenKnowledgeSeal: boolean | null;
  hasEndorsement: boolean | null;
  hasProvenKnowdledge: boolean | null;
}

export interface ManagedUserTopicsQueryResponse {
  /** @format uuid */
  topicId: string;
  name: string;
  thumbnailUrl: string;
  isSpecialist: boolean;
  specialistSealGrantedBy: string;
  /** @format date-time */
  specialistSealGrantedOn: Date | null;
  hasProvenKnowledgeSeal: boolean;
  /** @format int32 */
  endorsements: number;
  loggedUserHasEndorsed: boolean;
  /** @format double */
  provenKnowledgePercent: number;
  requiredLink: boolean;
  dynamicLink: boolean;
  canGrantSpecialistSeal: boolean;
  canDelete: boolean;
  readonly: boolean;
}

export type ManagedUserTopicsQueryResponseIEquatable = object;

export interface ManagedWorkplaceListQueryResponse {
  /** @format uuid */
  workplaceId: string;
  name: string;
  geoLocalization: string | null;
  /** @format uuid */
  holidayCalendarId: string | null;
  holidayCalendarName: string;
}

export type ManagedWorkplaceListQueryResponseIEquatable = object;

export interface ManagedWorkplaceListQueryResponsePaginatedList {
  items: ManagedWorkplaceListQueryResponse[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export interface ManagerAutoCompleteDataModelDto {
  key: any;
  label: string;
  thumbnailUrl?: string | null;
  canDelete?: boolean | null;
  fixed?: boolean | null;
  selectable?: boolean | null;
  fromHistory?: boolean;
  allSubordinatesGroup: GroupInfo;
  directSubordinatesGroup: GroupInfo;
}

export type ManagerAutoCompleteDataModelDtoIEquatable = object;

export interface ManagerAutoCompleteDataModelDtoPaginatedList {
  items: ManagerAutoCompleteDataModelDto[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type ManagerAutoCompleteDataModelDtoPaginatedListIRequest = object;

export interface ManagerChangePasswordQuery {
  /** @format uuid */
  userId: string;
}

export interface ManagerChangePasswordResponse {
  hasSamlAccount: boolean | null;
  standardAccountEnabled: boolean | null;
  passwordSuggestion: string;
  /** @format int32 */
  passwordMinLength: number;
  passwordRequiresOneUpperLetter: boolean;
  passwordRequiresOneNumber: boolean;
  passwordRequiresOneSymbol: boolean;
  passwordAllowNameParts: boolean;
}

export type ManagerChangePasswordResponseIEquatable = object;

export type ManagerChangePasswordResponseIRequest = object;

export interface ManagerEfficacyDeclineCommand {
  /** @format uuid */
  userId: string;
}

export type ManagerEfficacyDeclineCommandIEquatable = object;

export interface ManagerEfficacyUserListQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  searchText: string | null;
  orderBy: ManagerEfficacyUserOrderBy;
}

export interface ManagerEfficacyUserResponse {
  /** @format uuid */
  userId: string;
  name: string;
  thumbnailUrl: string;
  /** @format int32 */
  totalDeploys: number;
  trainingName: string | null;
  /** @format date-time */
  validUntil: Date | null;
  /** @format uuid */
  deployId: string | null;
  /** @format uuid */
  deployParticipantId: string | null;
  /** @format uuid */
  assessmentId: string | null;
}

export type ManagerEfficacyUserResponseIEquatable = object;

export interface ManagerEfficacyUserResponsePaginatedList {
  items: ManagerEfficacyUserResponse[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type ManagerEfficacyUserResponsePaginatedListIRequest = object;

export interface ManagerSelectorQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  searchText: string | null;
  ignoreSelectionHistory: boolean;
}

export interface ManagerSelectorResponse {
  /** @format uuid */
  userId: string;
  name: string;
  thumbnailUrl: string;
  fromHistory: boolean;
}

export type ManagerSelectorResponseIEquatable = object;

export interface ManagerSelectorResponsePaginatedList {
  items: ManagerSelectorResponse[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type ManagerSelectorResponsePaginatedListIRequest = object;

export interface ManagerTreeNode {
  /** @format uuid */
  id: string;
  name: string;
  thumbnailUrl: string | null;
  children: ManagerTreeNode[];
}

export type ManagerTreeNodeIRequest = object;

export interface ManagerTreeQuery {
  /** @format uuid */
  managerId: string | null;
}

export interface MarkApprovedDevPlanCommand {
  /** @format uuid */
  devPlanId: string;
  approved: boolean;
}

export interface MarkReadCommand {
  /** @format uuid */
  publicationId: string;
}

export interface MarkReadDirectMessageCommand {
  messageIds: string[];
  markRead: boolean;
}

export interface MarkReadonlyDevPlanCommand {
  /** @format uuid */
  devPlanId: string;
  readonly: boolean;
}

export interface MarkRemoveItemAssessmentCommand {
  /** @format uuid */
  assessmentId: string;
  /** @format uuid */
  itemId: string;
}

export interface MasterEnrollmentTrainingData {
  /** @format uuid */
  masterEnrollmentId: string;
  trainingName: string;
  isExclusiveAndFinalized: boolean;
  linkInLearnPath: boolean;
  isReenroll: boolean;
}

export type MasterEnrollmentTrainingDataIEquatable = object;

export interface MasterPublicationDto {
  /** @format uuid */
  publicationId: string;
  isAvailable: boolean;
}

export interface MaterialListCardsQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  classroomId: string;
  /** @format uuid */
  materialListId: string;
}

export interface MaterialListClassroomOptionsQuery {
  /** @format uuid */
  classroomId: string;
}

export interface MaterialListClassroomOptionsResponse {
  /** @format uuid */
  classroomId: string;
  allowInstructorAddMaterial: boolean;
  allowInstructorBlockMaterial: boolean;
  showTrainingMaterialFirst: boolean;
}

export type MaterialListClassroomOptionsResponseIRequest = object;

export interface MaterialListInfoQuery {
  /** @format uuid */
  trainingId: string | null;
  /** @format uuid */
  classroomId: string | null;
  isInstructorMode: boolean;
}

export interface MaterialListInfoResponse {
  /** @format uuid */
  trainingId: string;
  trainingName: string;
  /** @format uuid */
  classroomId: string | null;
  classroomName: string | null;
  multipleClasses: boolean;
  isInstructor: boolean;
  allowInstructorAddMaterial: boolean;
  allowInstructorBlockMaterial: boolean;
  canAdd: boolean;
  canBlock: boolean;
}

export type MaterialListInfoResponseIRequest = object;

export interface MaterialListTrainingOptionsQuery {
  /** @format uuid */
  trainingId: string;
}

export interface MaterialListTrainingOptionsResponse {
  /** @format uuid */
  trainingId: string;
  allowMaterialOverride: boolean;
  allowInstructorAddMaterial: boolean;
  allowInstructorBlockMaterial: boolean;
}

export type MaterialListTrainingOptionsResponseIRequest = object;

export interface MaterialListsCardDto {
  /** @format uuid */
  materialListId: string;
  name: string;
}

export type MaterialListsCardDtoIEnumerableIRequest = object;

export type MaterialListsCardDtoIEquatable = object;

export interface MaterialListsQuery {
  /** @format uuid */
  classroomId: string;
}

export interface MediaServicePublishUrls {
  smoothStreamingUri: string | null;
  hlsUri: string | null;
  mpegDashUri: string | null;
  progressiveDownloadUris: string[];
}

export interface MediaTrackModel {
  kind: string;
  src: string;
  srcLang: string;
  default: boolean | null;
  label: string;
}

export type MediaTrackModelIEquatable = object;

export interface MeetingDefaultQuery {
  /** @format uuid */
  trainingId: string | null;
}

export interface MeetingDefaultResponse {
  locationTimezoneId: string | null;
  meetingTypesEnabled: MeetingType[];
  multipleClasses: boolean;
}

export type MeetingDefaultResponseIEquatable = object;

export type MeetingDefaultResponseIRequest = object;

export interface MeetingEnrollmentItemQuery {
  /** @format uuid */
  componentId: string;
  /** @format uuid */
  enrollmentId: string | null;
  /** @format uuid */
  classroomId: string | null;
}

export interface MeetingInstructorConflitsQuery {
  /** @format uuid */
  meetingId: string | null;
  instructorIds: string[];
  /** @format date-time */
  startDate: Date;
  /** @format date-time */
  endDate: Date;
  /** @format timespan */
  additionalTimeBefore: string | null;
  /** @format timespan */
  additionalTimeAfter: string | null;
}

export interface MeetingInstructorConflitsResponse {
  /** @format uuid */
  instructorId: string;
  name: string;
  /** @format date-time */
  startDate: Date;
  /** @format date-time */
  endDate: Date;
}

export type MeetingInstructorConflitsResponseIEquatable = object;

export type MeetingInstructorConflitsResponseListIRequest = object;

export interface MeetingInstructorOnlineUrlQuery {
  /** @format uuid */
  componentId: string;
  /** @format uuid */
  classroomId: string;
}

export interface MeetingInstructorOnlineUrlResponse {
  url: string | null;
  errorMessage: string | null;
}

export type MeetingInstructorOnlineUrlResponseIRequest = object;

export interface MeetingItemQuery {
  /** @format uuid */
  componentId: string;
  /** @format int32 */
  versionNumber: number | null;
  /** @format uuid */
  classroomId: string | null;
}

export interface MeetingQuery {
  /** @format uuid */
  trainingId: string;
  /** @format uuid */
  meetingId: string;
  /** @format int32 */
  versionNumber: number;
  createClone: boolean;
}

export interface MeetingRoomAutoCompleteDataModelDto {
  key: any;
  label: string;
  thumbnailUrl?: string | null;
  canDelete?: boolean | null;
  fixed?: boolean | null;
  selectable?: boolean | null;
  fromHistory?: boolean;
  timezoneId: string;
  address: AddressModel;
}

export type MeetingRoomAutoCompleteDataModelDtoIEquatable = object;

export interface MeetingRoomAutoCompleteDataModelDtoPaginatedList {
  items: MeetingRoomAutoCompleteDataModelDto[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type MeetingRoomAutoCompleteDataModelDtoPaginatedListIRequest = object;

export interface MeetingRoomListQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  searchText: string;
  filters: AdvCoreFilter[];
}

export interface MeetingRoomResponse {
  /** @format uuid */
  roomId: string | null;
  name: string;
  address1: string;
  address2: string | null;
  city: string;
  state: string;
  zipCode: string;
  timezoneId: string;
  isActive: boolean;
}

export type MeetingRoomResponseIEquatable = object;

export type MeetingRoomResponseIRequest = object;

export interface MeetingRoomResponsePaginatedList {
  items: MeetingRoomResponse[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type MeetingRoomResponsePaginatedListIRequest = object;

export interface MeetingRoomSuggestionsQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  searchText: string | null;
}

export interface MeetingTeamsDto {
  enabled: boolean;
  microsoftTeamsKey: string;
}

export type MeetingTeamsDtoIEquatable = object;

export interface MeetingZoomDto {
  enabled: boolean;
  accountId: string;
  clientId: string;
  clientSecret: string;
  defaultPassword: string;
  sharedInstructorEmail: string | null;
}

export type MeetingZoomDtoIEquatable = object;

export interface MemberAutoCompleteDataModelDto {
  key: any;
  label: string;
  thumbnailUrl?: string | null;
  canDelete?: boolean | null;
  fixed?: boolean | null;
  selectable?: boolean | null;
  fromHistory?: boolean;
  memberType: MemberType;
}

export type MemberAutoCompleteDataModelDtoIEquatable = object;

export interface MemberAutoCompleteDataModelDtoPaginatedList {
  items: MemberAutoCompleteDataModelDto[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type MemberAutoCompleteDataModelDtoPaginatedListIRequest = object;

export interface MemberListDto {
  /** @format uuid */
  memberId: string;
  name: string;
  thumbnailUrl: string;
  memberType: MemberType;
}

export type MemberListDtoIEquatable = object;

export interface MemberListDtoPaginatedList {
  items: MemberListDto[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type MemberListDtoPaginatedListIRequest = object;

export interface MessagingQueueQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  filters: AdvCoreFilter[];
  searchText: string;
}

export interface MessagingQueueResponse {
  /** @format uuid */
  queueId: string;
  /** @format uuid */
  recipientId: string;
  recipientName: string;
  recipientRemarks: string | null;
  subject: string;
  queueObject: string;
  /** @format date-time */
  postedOn: Date;
  /** @format date-time */
  lastProcessingDate: Date | null;
  /** @format int32 */
  lastProcessingStatusCode: number | null;
  lastProcessingResult: string | null;
  /** @format int32 */
  retries: number;
  finishedSuccessfully: boolean | null;
  status: QueueStatus;
  statusName: string;
}

export type MessagingQueueResponseIEquatable = object;

export interface MessagingQueueResponsePaginatedList {
  items: MessagingQueueResponse[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type MessagingQueueResponsePaginatedListIRequest = object;

export interface ModerateAutoRegisterCommand {
  /** @format uuid */
  userId: string;
  approved: boolean;
  message: string | null;
}

export interface ModeratePublicationCommand {
  /** @format uuid */
  actionId: string;
  actionResponse: PublicationActionResponse;
  messageToAuthor: string | null;
  messageToRequester: string | null;
}

export interface ModeratorChannelAutoCompleteDataModelDto {
  key: any;
  label: string;
  thumbnailUrl?: string | null;
  canDelete?: boolean | null;
  fixed?: boolean | null;
  selectable?: boolean | null;
  fromHistory?: boolean;
  role: ChannelRoles;
}

export type ModeratorChannelAutoCompleteDataModelDtoIEquatable = object;

export interface ModeratorChannelAutoCompleteDataModelDtoPaginatedList {
  items: ModeratorChannelAutoCompleteDataModelDto[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type ModeratorChannelAutoCompleteDataModelDtoPaginatedListIRequest =
  object;

export interface ModeratorChannelSuggestionsQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  channelId: string | null;
  searchText: string | null;
}

export interface MoveAllScosToPhaseCommand {
  /** @format uuid */
  trainingId: string;
  /** @format int32 */
  versionNumber: number;
  /** @format uuid */
  phaseComponentId: string;
}

export interface MoveComponentCommand {
  /** @format uuid */
  trainingId: string;
  /** @format int32 */
  versionNumber: number;
  /** @format uuid */
  componentId: string;
  direction: MoveComponentDirection;
}

export interface MoveComponentToPhaseCommand {
  /** @format uuid */
  trainingId: string;
  /** @format int32 */
  versionNumber: number;
  /** @format uuid */
  componentId: string;
  /** @format uuid */
  phaseComponentId: string;
}

export interface MoveModuleLineCommand {
  module: CarouselModule;
  /** @format int32 */
  line: number;
  option: MoveCarouselModuleLineOption;
}

export interface NoticeQuery {
  /** @format uuid */
  publicationId: string;
  /** @format uuid */
  classroomId: string;
}

export interface NotificationAction {
  title: string;
  keys: any[];
}

export interface NotificationDataDto {
  message: string;
  action: NotificationAction | null;
  /** @format uuid */
  firstUserId: string | null;
  firstUserName: string | null;
  /** @format int32 */
  totalUsers: number;
}

export interface NotificationWorkspaceDto {
  notificationTypeId: NotificationType;
  /** @format uuid */
  notificationId: string;
  /** @format date-time */
  day: Date;
  /** @format date-time */
  createdOn: Date;
  isNew: boolean;
  regularNotification: NotificationDataDto | null;
  priorityNotification: PriorityNotificationContent[] | null;
}

export type NotificationWorkspaceDtoListIRequest = object;

export interface NotificationWorkspacecounterResponse {
  newDirectMessages: boolean;
  /** @format int32 */
  regularNotifications: number;
  /** @format int32 */
  priorityNotifications: number;
}

export type NotificationWorkspacecounterResponseIEquatable = object;

export type NotificationWorkspacecounterResponseIRequest = object;

export interface NumericFieldDto {
  /** @format double */
  minValue: number | null;
  /** @format double */
  maxValue: number | null;
  /** @format int32 */
  precision: number;
  inputMask: string | null;
  displayFormat: string | null;
  isCurrency: boolean;
}

export type NumericFieldDtoIEquatable = object;

export interface ObjectSelectionFieldDto {
  objectType: CustomFieldObjectType;
  allowMultiValue: boolean;
  selectionList: AutoCompleteModel[] | null;
}

export type ObjectSelectionFieldDtoIEquatable = object;

export interface OperationSearchUsersQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  operation: UserOperationType;
  action: UserOperationAction | null;
  /** @format uuid */
  objectId: string | null;
  useImportedUsers: boolean;
  searchText: string | null;
  filter: AdvCoreFilter[];
}

export interface OperationSelectedUsersQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  operation: UserOperationType;
  allActiveUsers: boolean;
}

export interface OrganogramManagerDto {
  /** @format uuid */
  userId: string;
  name: string;
  thumbnailUrl: string;
  hasManager: boolean;
  jobPositionName: string | null;
  userType: UserType;
}

export type OrganogramManagerDtoIEquatable = object;

export interface OrganogramSecondayManagerDto {
  /** @format uuid */
  userId: string;
  name: string;
  thumbnailUrl: string;
  hasManager: boolean;
  jobPositionName: string | null;
  userType: UserType;
  managerTypes: UserManagerTypesResponse[];
}

export type OrganogramSecondayManagerDtoIEquatable = object;

export interface OtherReportsQuery {
  /** @format uuid */
  actionId: string;
}

export interface OthersReportsResponse {
  requester: UserShortView;
  reason: PublicationActionType;
  reasonName: string;
  /** @format date-time */
  requestedOn: Date;
  message: string | null;
}

export type OthersReportsResponseIEnumerableIRequest = object;

export type OthersReportsResponseIEquatable = object;

export interface PackageOrganizationInfo {
  /** @format uuid */
  organizationId: string;
  identifier: string;
  title: string;
  isDefault: boolean;
  validSelection: boolean;
  inUseByOtherTraining: boolean;
  isCurrentSelection: boolean;
}

export interface PackageScormDto {
  /** @format uuid */
  fileId: string | null;
  originalFileName: string;
  fileName: string;
  /** @format int64 */
  filesize: number;
  /** @format date-time */
  uploadedDate: Date | null;
  /** @format uuid */
  manifestId: string | null;
  identifier: string;
  organizations: PackageOrganizationInfo[];
}

export type PackageScormDtoIRequest = object;

export interface PaginatedDiscussion {
  items: GetDiscussionDto[];
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  totalThreads: number;
  canComment: boolean;
}

export type PaginatedDiscussionIRequest = object;

export interface PaginatedUserCredentials {
  items: ManagedUserCredentialsResponse[];
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageOffset: number;
  hasPreviousPage: boolean;
  hasNextPage: boolean;
  canUpdateCredentials: boolean;
}

export type PaginatedUserCredentialsIRequest = object;

export interface PaginatedUserTopics {
  items: ManagedUserTopicsQueryResponse[];
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageOffset: number;
  hasPreviousPage: boolean;
  hasNextPage: boolean;
  canAddRequiredTopics: boolean;
  canAddTopics: boolean;
}

export type PaginatedUserTopicsIRequest = object;

export interface ParsedFileResult {
  title: string | null;
  description: string | null;
  author: string | null;
  filename: string;
  type?: string;
  /** @format int64 */
  fileSize?: number;
  /** @format date-time */
  fileCreationDate: Date | null;
  /** @format int32 */
  width: number | null;
  /** @format int32 */
  height: number | null;
  /** @format int64 */
  duration: number | null;
  containsImageOnly: boolean;
  keywords: string[] | null;
  language: string | null;
  metadata: string | null;
}

export type ParsedFileResultIEquatable = object;

export interface PerformaGoal {
  /** @format double */
  percentage: number;
  percentageColor: string;
  /** @format int32 */
  totalIndicators: number;
  /** @format int32 */
  totalDelayed: number;
  /** @format int32 */
  totalNotReachMinProgress: number;
  /** @format date-time */
  lastUpdate: Date;
}

export type PerformaGoalIEquatable = object;

export interface PerformaPerformanceEvaluation {
  /** @format int32 */
  taskCount: number;
  /** @format int32 */
  delayedCount: number;
  waitingThirdParty: boolean;
  leaderEvaluationPending: boolean;
  /** @format date-time */
  lastUpdate: Date;
}

export type PerformaPerformanceEvaluationIEquatable = object;

export interface PerformanceReviewsCommand {
  /** @format uuid */
  userId: string;
}

export interface PerformanceReviewsResponse {
  /** @format uuid */
  userId: string;
  performanceReviews: DashboardPerformanceReviews | null;
}

export type PerformanceReviewsResponseIEquatable = object;

export type PerformanceReviewsResponseIRequest = object;

export interface PermissionCategorySelectorReponse {
  category: PermissionCategory;
  name: string;
}

export type PermissionCategorySelectorReponseIEquatable = object;

export interface PermissionConstraintDto {
  global: boolean;
  directSubordinates: boolean | null;
  allSubordinates: boolean | null;
  selfUser: boolean | null;
  selfUserOwnedObjects: boolean | null;
  units: PermissionConstraintUnitDto[] | null;
  groups: PermissionConstraintGroupDto[] | null;
  selfUserUnitTypes: PermissionConstraintUnitTypeResponse[] | null;
}

export type PermissionConstraintDtoIRequest = object;

export interface PermissionConstraintGroupDto {
  /** @format uuid */
  groupId: string;
  name: string;
}

export interface PermissionConstraintModel {
  global: boolean;
  units: PermissionConstraintUnitModel[] | null;
  groups: string[] | null;
  selfUserUnitTypes: string[] | null;
  directSubordinates: boolean | null;
  allSubordinates: boolean | null;
  selfUser: boolean | null;
  selfUserOwnedObjects: boolean | null;
}

export interface PermissionConstraintUnitDto {
  /** @format uuid */
  unitId: string;
  name: string;
  /** @format uuid */
  unitTypeId: string;
  unitTypeName: string;
  includeDescendants: boolean;
  /** @format uuid */
  linkedGroupId: string;
}

export interface PermissionConstraintUnitModel {
  /** @format uuid */
  unitId: string;
  /** @format uuid */
  unitTypeId: string;
  includeDescendants: boolean;
  /** @format uuid */
  linkedGroupId: string;
}

export type PermissionConstraintUnitModelIEqualityComparer = object;

export type PermissionConstraintUnitModelIEquatable = object;

export interface PermissionConstraintUnitTypeResponse {
  /** @format uuid */
  unitTypeId: string;
  name: string;
}

export interface PermissionSelectorResponse {
  permissionId: string;
  name: string;
  description: string;
  acceptedConstraints: AcceptedConstraints;
}

export type PermissionSelectorResponseIEnumerableIRequest = object;

export type PermissionSelectorResponseIEquatable = object;

export interface PermissionsSelectorQuery {
  name: string | null;
  category: PermissionCategory | null;
}

export interface PermissionsSuggestionsQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  searchText: string | null;
  category: PermissionCategory | null;
}

export interface PhaseMapItem {
  /** @format uuid */
  componentId: string;
  staticMap: PhaseStaticMapModel | null;
  videoMap: PhaseVideoMapModel | null;
}

export interface PhasePropsDto {
  name: string;
  learnPathProps: LearnPathPhaseProps | null;
}

export type PhasePropsDtoIEquatable = object;

export interface PhaseStaticMapModel {
  /** @format int32 */
  mapXPos: number;
  /** @format int32 */
  mapYPos: number;
}

export interface PhaseVideoMapModel {
  /** @format uuid */
  phaseVideoId: string | null;
  /** @format uuid */
  phaseStartupVideoId: string | null;
  phaseVideoLoop: boolean;
}

export interface PingAssInstanceCommand {
  /** @format uuid */
  instanceId: string;
  /** @format double */
  elapsedTime: number | null;
}

export interface PingDraftContentCommand {
  /** @format uuid */
  trainingId: string;
  /** @format int32 */
  versionNumber: number;
}

export interface PollItemModel {
  /** @format uuid */
  id: string;
  text: string;
}

export interface PossibleAuthFieldModel {
  fieldId: string;
  labelR: ResourceModel[];
  isRequired: boolean;
}

export type PossibleAuthFieldModelIEquatable = object;

export interface PostComponentDto {
  /** @format uuid */
  publicationId: string | null;
  classification: PublicationClassificationType;
  classificationName: string;
  /** @format int64 */
  storageSize: number | null;
  /** @format int64 */
  mediaDuration: number | null;
}

export type PostComponentDtoIEquatable = object;

export interface PostEnrollmentItemQuery {
  /** @format uuid */
  componentId: string;
  /** @format uuid */
  enrollmentId: string | null;
}

export interface PostItemQuery {
  /** @format uuid */
  componentId: string | null;
  /** @format uuid */
  publicationId: string | null;
}

export interface PostPropsDto {
  /** @format timespan */
  completeOnMinTime: string | null;
  completeOnFullMediaPlayed: boolean;
  completeOnAttachOpened: boolean;
  disableMediaSeek: boolean;
}

export type PostPropsDtoIEquatable = object;

export interface PostPropsQuery {
  /** @format uuid */
  trainingId: string;
  /** @format int32 */
  versionNumber: number;
  /** @format uuid */
  componentId: string;
}

export interface PostQuery {
  /** @format uuid */
  publicationId: string;
  createClone: boolean;
}

export interface PriorityNotificationContent {
  text: string;
  bold: boolean;
  addNewLine: boolean;
  isAction: boolean;
  actionCommand: string | null;
}

export type PriorityNotificationContentIEquatable = object;

export interface ProcessAwardRuleClassroomCommand {
  /** @format uuid */
  classroomId: string;
}

export interface ProcessAwardRuleTrainingCommand {
  /** @format uuid */
  trainingId: string;
}

export interface ProcessCertificateRuleClassroomCommand {
  /** @format uuid */
  classroomId: string;
}

export interface ProcessCertificateRuleTrainingCommand {
  /** @format uuid */
  trainingId: string;
}

export interface ProcessDynamicGroupCommand {
  /** @format uuid */
  groupId: string;
}

export interface ProcessEnrollOperationCommand {
  /** @format uuid */
  trainingId: string;
  operation: ManageEnrollOperation;
}

export interface ProfileRequestConnectionCommand {
  /** @format uuid */
  userId: string;
  message: string;
}

export interface PublicationAdvancedItem {
  isInstitutional: boolean;
  /** @format date-time */
  viewPeriodStart: Date | null;
  /** @format date-time */
  viewPeriodEnd: Date | null;
  /** @format date-time */
  viewStickerUntil: Date | null;
  /** @format uuid */
  stickerId: string | null;
  tags: PublicationTagItem[];
}

export interface PublicationAttachFileItem {
  /** @format uuid */
  attachId: string;
  /** @format uuid */
  fileId: string | null;
  linkMetadata: ContentMetadata | null;
  /** @format uuid */
  thumbnailId: string | null;
  /** @format uuid */
  cardImageId: string | null;
  caption: string | null;
  /** @format uuid */
  binderPageRefId: string | null;
}

export interface PublicationContentQuery {
  /** @format uuid */
  publicationId: string;
}

export interface PublicationContextDto {
  /** @format uuid */
  publicationId: string;
  publicationType: PublicationType;
  publicationName: string;
  /** @format uuid */
  channelId: string | null;
  channelName: string | null;
}

export type PublicationContextDtoIEquatable = object;

export interface PublicationContextualRAGResponse {
  question: string;
  answer: string;
  sourcesUsed: RAGPublicationSource[];
  relatedSearchSuggestions: string[];
  outOfContext: boolean;
  /** @format timespan */
  processingTime: string;
  error: string | null;
  /** @format int32 */
  errorCode: number | null;
  conversationId: string;
  /** @format int32 */
  turnNumber: number;
  /** @format float */
  contextRelevance: number;
  isFirstQuestion: boolean;
  conversationSummary: string | null;
  contextualMetadata: ContextualSearchMetadata;
}

export type PublicationContextualRAGResponseIRequest = object;

export interface PublicationCreationSettingsResponse {
  allowAttachVideo: boolean;
  /** @format int64 */
  maxAttachSize: number | null;
  channelSuggestions: ChannelAutoCompleteDataModelDto[];
  defaultChannel: ChannelAutoCompleteDataModelDto[];
  topics: TopicAutoCompleteHierarchicalModelDto[];
  allowInstitutionalPublisher: boolean;
  canCreateTags: boolean;
}

export type PublicationCreationSettingsResponseIEquatable = object;

export type PublicationCreationSettingsResponseIRequest = object;

export interface PublicationPanelDto {
  /** @format uuid */
  publicationId: string;
  title: string;
  publicationType: PublicationType;
  /** @format uuid */
  parentPublicationId: string | null;
  channelName: string;
  thumbnailUrl: string;
}

export type PublicationPanelDtoIEquatable = object;

export interface PublicationPresentation {
  orderedItems: string[];
  /** @format int32 */
  rotationInterval: number;
}

export interface PublicationPresentationItem {
  /** @format int32 */
  rotationInterval: number;
  orderedItems: string[];
}

export interface PublicationRagSearchQuery {
  /** @format uuid */
  publicationId: string;
  /** @format uuid */
  attachId: string | null;
  searchText: string;
  conversationId: string | null;
  answerInMarkdown: boolean;
}

export interface PublicationReportAnalysedInfoQuery {
  /** @format uuid */
  actionId: string;
}

export interface PublicationReportAnalysedInfoResponse {
  owner: UserShortView;
  notes: string | null;
  response: PublicationActionResponse;
  /** @format uuid */
  publicationId: string;
  publicationType: PublicationType;
  publicationTitle: string;
  /** @format uuid */
  masterPublicationId: string | null;
  approved: boolean;
}

export type PublicationReportAnalysedInfoResponseIEquatable = object;

export type PublicationReportAnalysedInfoResponseIRequest = object;

export interface PublicationSelectorDto {
  /** @format uuid */
  publicationId: string;
  title: string;
  publicationType: PublicationType;
  selected: boolean;
}

export type PublicationSelectorDtoIEquatable = object;

export interface PublicationSelectorDtoPaginatedList {
  items: PublicationSelectorDto[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type PublicationSelectorDtoPaginatedListIRequest = object;

export interface PublicationSelectorQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  searchText: string | null;
  /** @format uuid */
  listPublicationId: string | null;
  /** @format uuid */
  userId: string | null;
  selectorType: PublicationSelectorType;
  onlyPostPublications: boolean;
  orderBy?: PublicationSelectorOrder | null;
}

export interface PublicationShortVideoSelectorQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  searchText: string | null;
}

export interface PublicationShortVideosQuery {
  /** @format uuid */
  publicationId: string;
  /** @format uuid */
  attachId: string | null;
}

export interface PublicationTagDto {
  /** @format uuid */
  tagId: string;
  tagName: string;
  isSystemTag: boolean;
}

export type PublicationTagDtoIEquatable = object;

export interface PublicationTagItem {
  /** @format uuid */
  tagId: string;
  tagName: string;
}

export interface PublicationToogleChannelPinnedCommand {
  /** @format uuid */
  publicationId: string;
}

export interface PublicationsForApprovalQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  searchText: string | null;
  showThirdParty: boolean;
  order: FeedModerationOrder;
}

export interface PublishDevPlanCommand {
  /** @format uuid */
  devPlanId: string;
}

export interface PublishTrainingCommand {
  /** @format uuid */
  trainingId: string;
}

export interface PublishTrainingContentCommand {
  /** @format uuid */
  trainingId: string;
  /** @format int32 */
  versionNumber: number;
}

export interface QrMeetingInfoResponse {
  /** @format uuid */
  trainingId: string;
  trainingType: TrainingType;
  trainingName: string;
  meetingName: string;
  meetingType: MeetingType;
  locationName: string | null;
  roomName: string | null;
  /** @format date-time */
  endDate: Date | null;
  /** @format date-time */
  startDate: Date | null;
  identifierInstructions: string | null;
}

export interface QrMeetingRegisterAttendanceCommand {
  authFieldValue: string;
  password: string;
  ipAddress: string;
  /** @format uuid */
  componentId: string;
}

export interface QrMeetingRegisterAttendanceResponse {
  success: boolean;
  /** @format uuid */
  enrollmentId: string | null;
  username: string;
  error: string | null;
  eventName: string | null;
}

export type QrMeetingRegisterAttendanceResponseIRequest = object;

export interface QuestionAllowKnowledgeTestCommand {
  /** @format uuid */
  questionId: string;
}

export interface QuestionAlternativeEvaluationDto {
  correctAnswer: string;
  feedback: string | null;
  answerIsNumber: boolean;
}

export type QuestionAlternativeEvaluationDtoIEquatable = object;

export interface QuestionAlternativeSurveyDto {
  /** @format int32 */
  points: number | null;
}

export type QuestionAlternativeSurveyDtoIEquatable = object;

export interface QuestionAttachDto {
  /** @format uuid */
  fileId: string;
  url: string;
  mimetype: string | null;
  fileName: string | null;
  /** @format int64 */
  fileSize: number | null;
  /** @format int64 */
  height: number | null;
  /** @format int64 */
  width: number | null;
  /** @format int64 */
  duration: number | null;
  imageWide: boolean;
  fileEncodedUrls: MediaServicePublishUrls | null;
  thumbnail: QuestionThumbnailDto | null;
  mediaTracks?: MediaTrackModel[] | null;
}

export interface QuestionChallengeListQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  questionGroupId: string;
  searchText: string | null;
}

export interface QuestionChallengeListResponse {
  /** @format uuid */
  questionId: string;
  /** @format int32 */
  currentVersion: number;
  questionText: string;
  questionType: QuestionType;
  questionClass: QuestionClass;
}

export type QuestionChallengeListResponseIEquatable = object;

export interface QuestionChallengeListResponsePaginatedList {
  items: QuestionChallengeListResponse[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type QuestionChallengeListResponsePaginatedListIRequest = object;

export interface QuestionContextDto {
  /** @format uuid */
  questionId: string;
  questionType: QuestionType;
  questionText: string;
  forSurvey: boolean;
}

export type QuestionContextDtoIEquatable = object;

export interface QuestionGroupKnowledgeTestInfoQuery {
  /** @format uuid */
  questionGroupId: string;
}

export interface QuestionGroupKnowledgeTestInfoResponse {
  /** @format int32 */
  totalQuestions: number;
}

export type QuestionGroupKnowledgeTestInfoResponseIEquatable = object;

export type QuestionGroupKnowledgeTestInfoResponseIRequest = object;

export interface QuestionGroupSelectInfoQuery {
  /** @format uuid */
  questionGroupId: string;
  tags: string[] | null;
  /** @format int32 */
  numberOfQuestions: number | null;
}

export interface QuestionGroupSelectInfoResponse {
  /** @format int32 */
  totalQuestions: number;
  /** @format int32 */
  totalPoints: number;
}

export type QuestionGroupSelectInfoResponseIEquatable = object;

export type QuestionGroupSelectInfoResponseIRequest = object;

export interface QuestionGroupSuggestionsHierarchicaQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  parentId: string | null;
  forSurvey: boolean;
  searchText: string | null;
  trySelectionHistory: boolean;
  exceptQuestionGroupIds: string[];
}

export interface QuestionListDto {
  /** @format uuid */
  questionId: string;
  /** @format int32 */
  currentVersion: number;
  questionText: string;
  /** @format int32 */
  totalAnswers: number;
  /** @format int32 */
  percentIncorrect: number;
  questionType: QuestionType;
  questionClass: QuestionClass;
  canEdit: boolean;
}

export type QuestionListDtoIEquatable = object;

export interface QuestionListDtoPaginatedList {
  items: QuestionListDto[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type QuestionListDtoPaginatedListIRequest = object;

export interface QuestionOpenAIAlternativeDto {
  alternativeText: string;
  isCorrect: boolean;
  isInfo: boolean;
}

export interface QuestionOpenAIDto {
  questionText: string;
  alternatives: QuestionOpenAIAlternativeDto[];
  selected: boolean;
  feedback: string | null;
}

export interface QuestionSelectListQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  questionGroupId: string;
  searchText: string | null;
  onlyAllowInKnowledgeTests: boolean | null;
  orderBy: QuestionSelectListOrderByQuery;
}

export interface QuestionSelectListResponse {
  /** @format uuid */
  questionId: string;
  questionText: string;
  /** @format int32 */
  points: number;
  questionType: QuestionType;
}

export type QuestionSelectListResponseIEquatable = object;

export interface QuestionSelectListResponsePaginatedList {
  items: QuestionSelectListResponse[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type QuestionSelectListResponsePaginatedListIRequest = object;

export interface QuestionThumbnailDto {
  url: string;
  /** @format int64 */
  height: number | null;
  /** @format int64 */
  width: number | null;
  mimetype: string | null;
}

export interface QueueEventDetailQuery {
  /** @format uuid */
  id: string;
}

export interface QueueEventResponse {
  /** @format uuid */
  queueId: string;
  queueObject: QueueObjectType;
  queueObjectName: string;
  status: QueueStatus;
  statusName: string;
  /** @format date-time */
  lastProcessingDate: Date | null;
  /** @format int32 */
  lastProcessingStatusCode: number | null;
  lastProcessingResult: string | null;
  /** @format int64 */
  duration: number | null;
  /** @format int32 */
  retries: number;
  /** @format date-time */
  postedOn: Date;
  /** @format double */
  progress: number | null;
  remarks: string;
  owner: UserShortView | null;
  finishedSuccessfully: boolean | null;
  allowDataDownload: boolean;
}

export type QueueEventResponseIEquatable = object;

export interface QueueEventResponsePaginatedList {
  items: QueueEventResponse[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type QueueEventResponsePaginatedListIRequest = object;

export interface QueueEventsQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  filters: AdvCoreFilter[];
  searchText: string;
}

export interface QuickAccessQuery {
  onlyVisible: boolean;
}

export interface QuickAccessResponse {
  /** @format uuid */
  subscriptionId: string;
  subscriptionType: KnowledgeSubscriptionType;
  name: string;
  thumbnailUrl: string | null;
  callout: boolean;
  hideQuickAccess: boolean;
}

export type QuickAccessResponseIEnumerableIRequest = object;

export type QuickAccessResponseIEquatable = object;

export interface QuickFilterCommandEquivDto {
  commandName: string;
  value: string | null;
}

export interface QuickFilterDto {
  /** @format uuid */
  quickFilterId: string;
  name: string;
  filterType: KnowledgeQuickFilterType;
  /** @format uuid */
  customObjectId: string | null;
  command: QuickFilterCommandEquivDto | null;
}

export type QuickFilterDtoIEquatable = object;

export type QuickFilterDtoListIRequest = object;

export interface RAGKnowledgeSource {
  /** @format uuid */
  publicationId: string;
  publicationType: PublicationType;
  title: string;
  author: UserShortView;
  /** @format date-time */
  publishedOn: Date;
  channelName: string;
  isAnonymous: boolean;
  institutional: FeedInstitutionalInfo | null;
}

export type RAGPublicationSource = object;

export interface ReactiveItemAssessmentCommand {
  /** @format uuid */
  assessmentId: string;
  /** @format uuid */
  itemId: string;
}

export interface ReceiveIntegrationDataCommand {
  data: ReceiveIntegrationDataDto[];
}

export interface ReceiveIntegrationDataDto {
  /** @format uuid */
  userId: string;
  goal: PerformaGoal | null;
  assessment: PerformaPerformanceEvaluation | null;
}

export type ReceiveIntegrationDataDtoIEquatable = object;

export interface ReceiveIntegrationDataResponse {
  /** @format uuid */
  userId: string;
  message: string;
}

export type ReceiveIntegrationDataResponseIEquatable = object;

export type ReceiveIntegrationDataResponseListIRequest = object;

export interface RecommendationGroupsSuggestionQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  searchText: string | null;
}

export interface RecordInfoActorDto {
  /** @format uuid */
  userId: string;
  name: string;
  /** @format uuid */
  thumbnailId: string | null;
  thumbnailUrl: string;
  /** @format date-time */
  occurrenceDate: Date;
  isSystemUser: boolean;
  isApiUser: boolean;
}

export type RecordInfoActorDtoIEquatable = object;

export interface RecordInfoDto {
  creator: RecordInfoActorDto;
  revisor: RecordInfoActorDto;
  deleter: RecordInfoActorDto | null;
}

export type RecordInfoDtoIEquatable = object;

export interface RecoverPasswordSettingsQuery {
  securityStamp: string;
}

export interface RecoverPasswordSettingsResponse {
  emailSenderAddress: string;
  emailSenderName: string;
  /** @format int32 */
  passwordMinLength: number;
  passwordRequiresOneUpperLetter: boolean;
  passwordRequiresOneNumber: boolean;
  passwordRequiresOneSymbol: boolean;
  passwordAllowNameParts: boolean;
  username: string;
}

export type RecoverPasswordSettingsResponseIEquatable = object;

export type RecoverPasswordSettingsResponseIRequest = object;

export interface RefuseChannelSubscriptionCommand {
  /** @format uuid */
  channelId: string;
  /** @format uuid */
  userId: string;
  message: string | null;
}

export type RegisterAccessTimeRuleIEquatable = object;

export interface RegisterActivityChecklistDto {
  /** @format uuid */
  itemId: string;
  checked: boolean;
}

export type RegisterActivityChecklistDtoIEquatable = object;

export interface RegisterActivityChecklistItemDto {
  /** @format uuid */
  itemId: string;
  name: string;
  /** @format double */
  score: number;
}

export type RegisterActivityChecklistItemDtoIEquatable = object;

export interface RegisterActivityDto {
  /** @format uuid */
  enrollmentId: string;
  /** @format uuid */
  componentId: string;
  /** @format uuid */
  userId: string;
  name: string;
  activityName: string;
  scorePending: boolean;
  /** @format double */
  scorePercent: number | null;
  /** @format date-time */
  deliveryDate: Date | null;
  /** @format uuid */
  deliveredFileId: string | null;
  hasCheckList: boolean;
  assignScoreByCheckList: boolean;
  digitalDelivery: boolean;
  /** @format date-time */
  dueDate: Date | null;
  /** @format date-time */
  correctedOn: Date | null;
  delayed: boolean;
  expired: boolean;
  checklist: RegisterActivityChecklistDto[];
}

export type RegisterActivityDtoIEquatable = object;

export type RegisterActivityDtoListIRequest = object;

export interface RegisterActivityMatrixComponentDto {
  /** @format uuid */
  componentId: string;
  activityName: string;
  checklist: RegisterActivityChecklistItemDto[];
}

export type RegisterActivityMatrixComponentDtoIEquatable = object;

export interface RegisterActivityMatrixResponse {
  activities: RegisterActivityMatrixComponentDto[];
  users: RegisterActivityMatrixUserDto[];
  data: RegisterActivityDto[];
}

export type RegisterActivityMatrixResponseIEquatable = object;

export type RegisterActivityMatrixResponseIRequest = object;

export interface RegisterActivityMatrixUserDto {
  /** @format uuid */
  userId: string;
  name: string;
}

export type RegisterActivityMatrixUserDtoIEquatable = object;

export interface RegisterActivityScoreCommand {
  enrollments: RegisterActivityScoreSave[];
}

export interface RegisterActivityScoreMatrixQuery {
  /** @format uuid */
  classroomId: string;
  searchText: string | null;
  noFilled: boolean;
}

export interface RegisterActivityScoreQuery {
  /** @format uuid */
  classroomId: string;
  /** @format uuid */
  componentId: string;
  searchText: string | null;
  noFilled: boolean;
  orderBy: SupervisorRegisterActivityScoreOrderBy;
}

export interface RegisterActivityScoreSave {
  /** @format uuid */
  enrollmentId: string;
  /** @format uuid */
  componentId: string;
  /** @format double */
  scorePercent: number | null;
  checklist: SupervisorActivityChecklistItem[] | null;
}

export type RegisterAssDeployRequestIEquatable = object;

export interface RegisterConclusionFormCommand {
  /** @format uuid */
  classroomId: string;
  /** @format uuid */
  masterEnrollmentId: string | null;
  formData: ConclusionFormSaveDto;
}

export interface RegisterMediaTrackCommand {
  /** @format uuid */
  fileId: string;
  /** @format uuid */
  playbackId: string;
  events: RegisterMediaTrackEventRequest[];
}

export type RegisterMediaTrackCommandIEquatable = object;

export interface RegisterMediaTrackEventRequest {
  /** @format int64 */
  emittedAt: number;
  /** @format int32 */
  eventType: number;
  /** @format int64 */
  eventValue: number;
  paused: boolean;
  errorCode: string | null;
  /** @format date */
  dateRef: Date;
}

export type RegisterMediaTrackEventRequestIEquatable = object;

export type RegisterMediaTrackRequestIEquatable = object;

export interface RegisterMeetingAttendedCommand {
  enrollments: RegisterMeetingAttendedSave[];
}

export interface RegisterMeetingAttendedQuery {
  /** @format uuid */
  classroomId: string;
  /** @format uuid */
  componentId: string;
  searchText: string | null;
  noFilled: boolean;
  orderBy: RegisterMeetingAttendedOrderBy;
}

export interface RegisterMeetingAttendedSave {
  /** @format uuid */
  enrollmentId: string;
  /** @format uuid */
  componentId: string;
  attendend: boolean | null;
  /** @format double */
  scorePercent: number | null;
}

export interface RegisterMeetingDto {
  /** @format uuid */
  enrollmentId: string;
  /** @format uuid */
  componentId: string;
  /** @format uuid */
  userId: string;
  name: string;
  meetingName: string;
  registerMode: MeetingAttendanceRegisterMode | null;
  attended: boolean | null;
  scorePending: boolean;
  /** @format double */
  scorePercent: number | null;
  hasScore: boolean;
}

export type RegisterMeetingDtoIEquatable = object;

export type RegisterMeetingDtoListIRequest = object;

export interface RegisterMeetingMatrixComponentDto {
  /** @format uuid */
  componentId: string;
  meetingName: string;
  hasScore: boolean;
}

export type RegisterMeetingMatrixComponentDtoIEquatable = object;

export interface RegisterMeetingMatrixQuery {
  /** @format uuid */
  classroomId: string;
  searchText: string | null;
  noFilled: boolean;
}

export interface RegisterMeetingMatrixResponse {
  meetings: RegisterMeetingMatrixComponentDto[];
  users: RegisterMeetingMatrixUserDto[];
  data: RegisterMeetingDto[];
}

export type RegisterMeetingMatrixResponseIEquatable = object;

export type RegisterMeetingMatrixResponseIRequest = object;

export interface RegisterMeetingMatrixUserDto {
  /** @format uuid */
  userId: string;
  name: string;
}

export type RegisterMeetingMatrixUserDtoIEquatable = object;

export interface RegisterMemberGroupRequest {
  /** @format uuid */
  memberId: string;
  memberType: MemberType;
}

export type RegisterReportDtoIEquatable = object;

export type RegisterStickerRequestIEquatable = object;

export interface RegisterTimeSpentCommand {
  /** @format uuid */
  enrollmentId: string;
  /** @format int32 */
  seconds: number;
}

export type RegisterUnitRequestIEquatable = object;

export type RegisterUnitTypeRequestIEquatable = object;

export interface RegistrationIntoTrainingChecksQuery {
  /** @format uuid */
  trainingId: string;
  /** @format uuid */
  userId: string;
}

export interface RegistrationIntoTrainingChecksResults {
  uniqueClassroomUnavailable: boolean | null;
  trainingAudiencePassed: boolean | null;
  /** @format date-time */
  nextEnrollDate: Date | null;
  /** @format int32 */
  enrollMaxTries: number | null;
  canInterest: boolean;
  hasInterest: boolean;
  masterEnrollmentTrainingChecks: MasterEnrollmentTrainingData | null;
}

export type RegistrationIntoTrainingChecksResultsIEquatable = object;

export type RegistrationIntoTrainingChecksResultsIRequest = object;

export interface ReleaseNoteDto {
  releaseNumber: string;
  /** @format date-time */
  releaseDate: Date;
}

export type ReleaseNoteDtoIEquatable = object;

export interface RemoveAllScosCommand {
  /** @format uuid */
  trainingId: string;
  /** @format int32 */
  versionNumber: number;
}

export interface RemoveDeliveredActivityCommand {
  /** @format uuid */
  enrollmentId: string;
  /** @format uuid */
  componentId: string;
}

export interface RemoveItemFromListsCommand {
  /** @format uuid */
  itemPublicationId: string;
}

export interface RemoveListItemCommand {
  /** @format uuid */
  listPublicationId: string;
  /** @format uuid */
  itemPublicationId: string;
}

export interface RemoveRatingEnrollmentCommand {
  /** @format uuid */
  enrollmentId: string;
}

export interface RemoveRecoveryAssessmentCommand {
  /** @format uuid */
  assessmentId: string;
}

export interface RemoveRelationshipPublicationCommand {
  /** @format uuid */
  publicationId: string;
  /** @format uuid */
  relatedPublicationId: string;
}

export interface RemoveRelationshipTrainingCommand {
  /** @format uuid */
  publicationId: string;
  /** @format uuid */
  relatedTrainingId: string;
}

export interface RemoveTopicChallengeCommand {
  /** @format uuid */
  topicId: string;
}

export type RemoveTopicChallengeCommandIEquatable = object;

export interface RemoveTrainingInterestCommand {
  /** @format uuid */
  trainingId: string;
}

export interface RemoveUserEnrollOperationCommand {
  /** @format uuid */
  trainingId: string;
  operation: ManageEnrollOperation;
  userIds: string[];
}

export interface RemoveUsersOperationCommand {
  operation: UserOperationType;
  userIds: string[];
}

export interface ReorderAssessmentItemsCommand {
  /** @format uuid */
  assessmentId: string;
  orderedItems: string[];
}

export interface ReorderBannerCommand {
  items: string[];
}

export interface ReorderBannerListQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export interface ReorderComponentsCommand {
  /** @format uuid */
  trainingId: string;
  /** @format int32 */
  versionNumber: number;
  componentsInOrder: string[];
  onlyPhases: boolean;
}

export interface ReorderGroupsCommand {
  /** @format uuid */
  devplanId: string;
  groupsInOrder: string[];
}

export interface ReorderIndicatorCommand {
  sequence: IndicatorType[];
}

export interface ReorderItemsCommand {
  /** @format uuid */
  devPlanGroupId: string;
  itemsInOrder: string[];
}

export interface ReorderListItemsCommand {
  /** @format uuid */
  listPublicationId: string;
  orderedItems: string[];
}

export interface ReorderMaterialListCommand {
  materialListIds: string[];
}

export interface ReorderMaterialListItemCommand {
  /** @format uuid */
  materialListId: string;
  materialListItemsIds: string[];
}

export interface RepassQuestionCommand {
  /** @format uuid */
  publicationId: string;
  usersId: string[];
}

export interface ReportDefinitionDto {
  /** @format uuid */
  reportId: string;
  name: string;
  orderBy: string;
  orderByValues: KeyLabelModel[];
  parameters: ReportParamDto[];
}

export type ReportDefinitionDtoIEquatable = object;

export type ReportDefinitionDtoIRequest = object;

export interface ReportExecuteCommand {
  /** @format uuid */
  reportId: string;
  reportParams: ReportParamStore[];
  orderBy: string | null;
}

export interface ReportExecutePreviewCommand {
  /** @format uuid */
  reportId: string;
  reportParams: ReportParamStore[];
  orderBy: string | null;
}

export interface ReportExecutePreviewResponse {
  columns: string[];
  rows: any[];
  query: string;
  errorMessages: string | null;
}

export type ReportExecutePreviewResponseIEquatable = object;

export type ReportExecutePreviewResponseIRequest = object;

export interface ReportGroupSelectorResponse {
  /** @format uuid */
  reportGroupId: string;
  name: string;
}

export type ReportGroupSelectorResponseIEquatable = object;

export interface ReportParamDto {
  paramName: string;
  paramType: ReportParamType;
  paramTypeName: string;
  paramValue: string | null;
  label: string;
  placeholderText: string | null;
  validationErrorMessage: string | null;
  defaultValue: string | null;
  isRequired: boolean;
  /** @format int32 */
  sequenceOrder: number;
  textField: ReportParamText | null;
  numericField: ReportParamNumeric | null;
  valueSelectionField: ReportParamValueSelection | null;
  objectSelectionField: ReportParamObjectSelection | null;
}

export type ReportParamDtoIEquatable = object;

export interface ReportParamNumeric {
  /** @format double */
  minValue: number | null;
  /** @format double */
  maxValue: number | null;
  /** @format int32 */
  precision: number;
  inputMask: string | null;
  isCurrency: boolean;
}

export type ReportParamNumericIEquatable = object;

export interface ReportParamObjectSelection {
  objectType: ReportParamObjectType;
  subType: string | null;
  allowMultiValue: boolean;
}

export type ReportParamObjectSelectionIEquatable = object;

export interface ReportParamObjectSelectorResponse {
  objectTypes: AutoCompleteDataModelDto[];
  tagUsages: AutoCompleteDataModelDto[];
  stickerAppliesTo: AutoCompleteDataModelDto[];
  unitTypes: AutoCompleteDataModelDto[];
  publicationTypes: AutoCompleteDataModelDto[];
  trainingTypes: AutoCompleteDataModelDto[];
}

export type ReportParamObjectSelectorResponseIEquatable = object;

export interface ReportParamStore {
  paramName: string;
  paramValue: string;
}

export type ReportParamStoreIEquatable = object;

export interface ReportParamText {
  /** @format int32 */
  length: number;
  inputMask: string | null;
  validation: string | null;
}

export type ReportParamTextIEquatable = object;

export interface ReportParamTypesSelectorResponse {
  type: ReportParamType;
  name: string;
}

export type ReportParamTypesSelectorResponseIEquatable = object;

export interface ReportParamValueSelection {
  allowMultiValue: boolean;
  selectionList: KeyLabelModel[];
}

export type ReportParamValueSelectionIEquatable = object;

export interface ReportParametersQuery {
  /** @format uuid */
  reportId: string;
  ignorePreviousValues: boolean;
}

export interface ReportScheduleDto {
  /** @format uuid */
  reportScheduleId: string;
  /** @format uuid */
  reportId: string;
  name: string;
  /**
   * @format time
   * @example ""13:45:42.0000000""
   */
  runAt: string;
  /** @format int32 */
  dayOfMonth: number | null;
  daysOfWeek: DayOfWeek[] | null;
  recipients: AutoCompleteDataModelDto[];
  reportParams: ReportParamDto[];
  frequency: ReportScheduleFrequency;
}

export type ReportScheduleDtoIEquatable = object;

export type ReportScheduleDtoIRequest = object;

export interface ReportScheduleQuery {
  /** @format uuid */
  reportScheduleId: string;
}

export interface ReportTypesSelectorResponse {
  type: PublicationActionType;
  name: string;
}

export type ReportTypesSelectorResponseIEquatable = object;

export interface ReportsForApprovalQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  searchText: string | null;
  order: FeedModerationOrder;
}

export interface ReprocessQueueCommand {
  reprocessAll: boolean;
  items: string[];
}

export interface RequestChannelAccessCommand {
  /** @format uuid */
  channelId: string;
  reason: string;
}

export interface RequestChannelSubscriptionCommand {
  /** @format uuid */
  channelId: string;
  message: string | null;
  password: string | null;
  onlyIfFreeRegistration?: boolean | null;
}

export type RequestChannelSubscriptionResultIRequest = object;

export type RequestTrainingIndexExecutionCommand = object;

export interface RequestUnblockPublicationCommand {
  /** @format uuid */
  publicationId: string;
  message: string;
}

export interface ResourceModel {
  locale: string;
  text: string | null;
}

export interface ResourceResume {
  /** @format int32 */
  value: number;
  /** @format double */
  percentage: number;
  threhold: SystemUsageThreshold;
}

export type ResourceResumeIEquatable = object;

export interface RestorePublicationCommand {
  /** @format uuid */
  publicationId: string;
}

export interface RevisionEssayResponse {
  /** @format uuid */
  userId: string | null;
  name: string;
  thumbnailUrl: string | null;
  answer: string;
  identifyUsers: boolean;
}

export type RevisionEssayResponseIEquatable = object;

export interface RevisionEssayResponsePaginatedList {
  items: RevisionEssayResponse[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type RevisionEssayResponsePaginatedListIRequest = object;

export interface RoleGroupConflitResolutionCommand {
  /** @format uuid */
  roleId: string;
  /** @format uuid */
  groupId: string;
  mergeOption: RoleMergeOption;
}

export interface RoleGroupConstraintsCommand {
  /** @format uuid */
  roleId: string;
  /** @format uuid */
  groupId: string;
  customPermissions: UserSecurityRoleConstraintItem[];
}

export interface RoleGroupCreateCommand {
  /** @format uuid */
  roleId: string;
  groups: string[];
}

export interface RoleGroupDeleteCommand {
  /** @format uuid */
  roleId: string;
  /** @format uuid */
  groupId: string;
}

export interface RolePermissionConstraintsDto {
  permissionId: string;
  name: string;
  customConstraints: PermissionConstraintDto;
  defaultConstraints: PermissionConstraintDto;
  acceptedConstraints: AcceptedConstraints;
}

export type RolePermissionConstraintsDtoIEquatable = object;

export interface RolePermissionDto {
  permissionId: string;
  name: string;
  constraints: PermissionConstraintDto;
  acceptedConstraints: AcceptedConstraints;
}

export type RolePermissionDtoIEquatable = object;

export interface RoleSelectorResponse {
  /** @format uuid */
  roleId: string;
  name: string;
  fromHistory: boolean;
}

export type RoleSelectorResponseIEquatable = object;

export interface RoleSelectorResponsePaginatedList {
  items: RoleSelectorResponse[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type RoleSelectorResponsePaginatedListIRequest = object;

export interface RoleUserConflitResolutionCommand {
  /** @format uuid */
  roleId: string;
  /** @format uuid */
  userId: string;
  mergeOption: RoleMergeOption;
}

export interface RoleUserConstraintsCommand {
  /** @format uuid */
  roleId: string;
  /** @format uuid */
  userId: string;
  customPermissions: UserSecurityRoleConstraintItem[];
}

export type RoleUserConstraintsCommandIEquatable = object;

export interface RoleUserCreateCommand {
  /** @format uuid */
  roleId: string;
  users: string[];
}

export type RoleUserCreateCommandIEquatable = object;

export interface RoleUserDeleteCommand {
  /** @format uuid */
  roleId: string;
  users: string[] | null;
}

export interface RoleUserDesactivateCommand {
  /** @format uuid */
  roleId: string;
  /** @format uuid */
  userId: string;
}

export interface RoleUserReactivateCommand {
  /** @format uuid */
  roleId: string;
  /** @format uuid */
  userId: string;
}

export interface RolesSelectorQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  searchText: string | null;
  ignoreSelectionHistory: boolean;
}

export type RulesDtoIEquatable = object;

export interface SamlAuthSettingsModel {
  enabled: boolean;
  identifier: string;
  loginUrl: string;
  logoutUrl: string;
  certificate: string;
  firstNameClaimField: string | null;
  lastNameClaimField: string | null;
  emailClaimField: string | null;
  locationClaimField: string | null;
  phoneClaimField: string | null;
  objectIdClaimField: string | null;
  autoRegisterOnUnits: string[];
  /** @format uuid */
  autoRegisterRole: string;
}

export interface SamlOptions {
  samlLoginUrl: string;
  samlLogoutUrl: string | null;
}

export type SamlOptionsIEquatable = object;

export interface SaveAIQuestionCommand {
  questions: QuestionOpenAIDto[];
  evaluation: SaveQuestionEvaluationDto | null;
  survey: SaveQuestionSurveyDto | null;
  tags: string[];
  /** @format uuid */
  questionGroupId: string | null;
  /** @format uuid */
  exclusiveAssessmentId: string | null;
  availableQuestioBank: boolean | null;
  isBlocked: boolean;
  /** @format uuid */
  publicationRecommendedId: string | null;
}

export interface SaveAccessTimeRuleSettingsCommand {
  settings: AccessTimeRuleModel;
}

export interface SaveAnswerAssInstanceCommand {
  /** @format uuid */
  instanceId: string;
  /** @format uuid */
  questionId: string;
  /** @format int32 */
  version: number;
  /** @format double */
  elapsedTime: number | null;
  confidenceLevel: ConfidenceLevel | null;
  alternatives: AssessmentAlternativeSaveDto[];
}

export interface SaveAppAuthSettingsCommand {
  app: AppAuthSettingsModel;
}

export interface SaveAssessmentPropsCommand {
  /** @format uuid */
  trainingId: string;
  /** @format int32 */
  versionNumber: number;
  /** @format uuid */
  componentId: string;
  course: SaveCoursePropsDto;
  assessment: AssessmentPropsDto;
}

export interface SaveCalloutCommand {
  /** @format uuid */
  calloutId: string;
  calloutType: LmsCalloutType;
}

export interface SaveClassroomInstructorsCommand {
  /** @format uuid */
  classroomId: string;
  instructors: string[];
}

export interface SaveClassroomRulesAgreementCommand {
  /** @format uuid */
  classroomId: string;
  rules: TrainingRulesAgreementItem;
}

export interface SaveClassroomRulesApprovalCommand {
  /** @format uuid */
  classroomId: string;
  rules: TrainingRulesApprovalRulesItem;
}

export interface SaveClassroomRulesAssCommand {
  /** @format uuid */
  classroomId: string;
  rules: TrainingRulesAssessmentItemDto;
}

export interface SaveClassroomRulesAwardCommand {
  /** @format uuid */
  classroomId: string;
  rules: TrainingRulesAwardItem;
}

export interface SaveClassroomRulesCertificateCommand {
  /** @format uuid */
  classroomId: string;
  rules: TrainingRulesCertificateItem;
}

export interface SaveClassroomRulesConclusionFormCommand {
  /** @format uuid */
  classroomId: string;
  rules: TrainingRulesConclusionFormItem;
}

export interface SaveClassroomRulesExecutionCommand {
  /** @format uuid */
  classroomId: string;
  rules: TrainingRulesExecutionItem;
}

export interface SaveClassroomRulesInstructorCommand {
  /** @format uuid */
  classroomId: string;
  rules: TrainingRulesInstructorActionItem;
}

export interface SaveClassroomRulesInteractionCommand {
  /** @format uuid */
  classroomId: string;
  rules: TrainingRulesDiscussionItem;
}

export interface SaveClassroomRulesPreReqCommand {
  /** @format uuid */
  classroomId: string;
  rules: TrainingRulesPreRequisitesItem;
}

export interface SaveClassroomRulesRegistrationCommand {
  /** @format uuid */
  classroomId: string;
  rules: TrainingRulesRegistrationItem;
}

export interface SaveClassroomRulesSeatsCommand {
  /** @format uuid */
  classroomId: string;
  rules: TrainingRulesSeatsItem;
}

export interface SaveComponentPropsDto {
  access: LearnPathAccessProps;
  /** @format int32 */
  credits: number | null;
  isMandatory: boolean;
  computeProgress: boolean | null;
  reuseOption: TrainingLearnPathReuseOption;
  /** @format date-time */
  reuseApprovedSinceDate: Date | null;
  /** @format int32 */
  reuseFinalizedSinceDays: number | null;
  /** @format uuid */
  classroomId: string | null;
}

export type SaveComponentPropsDtoIEquatable = object;

export interface SaveComponentWeightsCommand {
  /** @format uuid */
  trainingId: string;
  /** @format int32 */
  versionNumber: number;
  components: ComponentWeightItem[];
}

export interface SaveCoursePhasePropsDto {
  enableOnComponentsCompleted: string[];
}

export type SaveCoursePhasePropsDtoIEquatable = object;

export interface SaveCoursePropsCommand {
  /** @format uuid */
  trainingId: string;
  /** @format int32 */
  versionNumber: number;
  /** @format uuid */
  componentId: string;
  course: SaveCoursePropsDto;
}

export interface SaveCoursePropsDto {
  enableOption: CourseComponentEnableOption;
  /** @format int32 */
  daysAfterClassAvailability: number | null;
  computeProgress: boolean;
  enableOnComponentsCompleted: string[];
}

export type SaveCoursePropsDtoIEquatable = object;

export interface SaveEnrollOperationCommand {
  /** @format uuid */
  trainingId: string;
  /** @format uuid */
  classroomId: string | null;
  operation: ManageEnrollOperation;
  enrollment: EnrollOperationEnrollmentProps | null;
  cancel: EnrollOperationCancelProps | null;
  extraTime: EnrollOperationExtraTimeProps | null;
  revoke: EnrollOperationRevokeProps | null;
  undoRevoke: EnrollOperationRevokeProps | null;
  reEnroll: EnrollOperationReEnrollProps | null;
  exclude: EnrollOperationExcludeProps | null;
}

export interface SaveEvaluationDto {
  /** @format uuid */
  assessmentId: string;
  exclusiveUsage: ExclusiveUsage | null;
  name: string;
  /** @format uuid */
  thumbnailId: string | null;
  instructions: string | null;
  isBlocked: boolean;
  isDraft: boolean;
  makeAvailable: boolean;
  externalCode: string | null;
  language: string | null;
  author: string | null;
  topics: string[];
  tags: string[];
  owners: string[];
  allowGoback: boolean;
  allowContinueAbortedEvaluation: boolean;
  showQuestionPoints: boolean;
  /** @format timespan */
  timeToComplete: string | null;
  freezeChronometer: boolean;
  /** @format int32 */
  maxTries: number | null;
  showCorrection: boolean;
  showCorrectAnswer: boolean;
  showFeedback: boolean;
  /** @format uuid */
  essayEvaluatorId: string | null;
  description: string | null;
  randomized: boolean;
}

export interface SaveIaSettingsCommand {
  settings: IaModel;
  searchSubjects: string[];
}

export interface SaveImportCommand {
  settings: ImportModel;
}

export interface SaveImportUserCommand {
  settings: ImportUserModel;
}

export interface SaveImportUserRemoteCommand {
  settings: ImportUserRemoteModel;
}

export interface SaveIndexTrainingSettingsCommand {
  /** @format uuid */
  groupingByUnitTypeId: string;
  /** @format int32 */
  gracePeriod: number;
  /** @format int32 */
  historyPeriod: number;
  topics: string[];
  restrictUsersGroups: string[];
}

export interface SaveKnowledgeAwardSettingsCommand {
  /** @format int32 */
  createPostGrantPoints: number;
  /** @format int32 */
  answerQuestionGrantPoints: number;
  createPostChannels: SaveManagedAwardChannelDto[];
  questionAnswerChannels: SaveManagedAwardChannelDto[];
}

export interface SaveKnowledgeSettingsCommand {
  allowVideoForExternalUsers: boolean;
  /** @format int32 */
  maxAttachLength: number | null;
  attachLimitsBypassGroups: string[] | null;
  autoRegisterShortVideos: boolean;
  /** @format uuid */
  institutionalThumbnailId: string | null;
  institutionalName: string;
  viewsPrivacy: KnowledgeViewsPrivacy;
  preferAIModeration: boolean;
  allowManagerModeration: boolean;
  allowManagerEdit: boolean;
  /** @format int32 */
  aiTopicThreshold: number;
}

export interface SaveKnowledgeTestSettingsCommand {
  /** @format int32 */
  maxQuestions: number;
  showFeedback: boolean;
  showCorrectAnswer: boolean;
  showProvenKnowledgeRecallDays: boolean;
  showDaysBetweenRetentionTests: boolean;
  showStopRepeatRetentionTestsTimes: boolean;
  /** @format int32 */
  provenKnowledgeRecallDays: number | null;
  /** @format int32 */
  daysBetweenRetentionTests: number | null;
  /** @format int32 */
  stopRepeatRetentionTestsTimes: number | null;
  headlineR: ResourceModel[];
  /** @format uuid */
  thumbnailId: string | null;
}

export interface SaveLearnPathComponentPropsCommand {
  /** @format uuid */
  trainingId: string;
  /** @format int32 */
  versionNumber: number;
  /** @format uuid */
  componentId: string | null;
  course: SaveCoursePhasePropsDto;
  component: SaveComponentPropsDto;
}

export interface SaveLmsAwardSettingsCommand {
  /** @format int32 */
  maxEnrollPoints: number;
  /** @format int32 */
  maxEnrollApprovalPoints: number;
  /** @format int32 */
  challengePoints: number;
  applyLimits: boolean;
  awardTopics: SaveLmsAwardTopicSettingsDto[];
}

export interface SaveLmsAwardTopicSettingsDto {
  /** @format uuid */
  topicId: string;
  includeDescendants: boolean;
  /** @format int32 */
  grantPoints: number;
}

export type SaveLmsAwardTopicSettingsDtoIEquatable = object;

export interface SaveLpGameConfigCommand {
  /** @format uuid */
  trainingId: string;
  mandatoryAudienceOnly: boolean;
  noTrainingReuse: boolean;
  /** @format date-time */
  dueDate: Date | null;
  showPhaseAdvanceAnimation: boolean;
  /** @format uuid */
  manualFileId: string | null;
}

export interface SaveLpGameMapCommand {
  /** @format uuid */
  trainingId: string;
  mapType: GameMapType;
  /** @format int32 */
  pinAvatarSize: number;
  /** @format uuid */
  staticMapFileId: string | null;
  phases: PhaseMapItem[];
}

export interface SaveLpGamePhaseConfigCommand {
  /** @format uuid */
  trainingId: string;
  /** @format uuid */
  componentId: string;
  description: string | null;
  condition: LearnPathGameAdditionalCondition;
  /** @format int32 */
  conditionValue: number | null;
  /** @format date-time */
  finalizationDate: Date | null;
}

export interface SaveLpRulesApprovalCommand {
  /** @format uuid */
  trainingId: string;
  rules: LearnPathRulesApprovalItem;
}

export interface SaveLpRulesComponentRegistrationCommand {
  /** @format uuid */
  trainingId: string;
  rules: LearnPathRulesComponentRegistrationItem;
}

export interface SaveLpRulesReEnrollCommand {
  /** @format uuid */
  trainingId: string;
  rules: LearnPathRulesReEnrollItem;
}

export interface SaveManagedAwardChannelDto {
  /** @format uuid */
  channelId: string;
  /** @format int32 */
  grantPoints: number;
}

export interface SaveOnlineMeetingSettingsCommand {
  teams: MeetingTeamsDto | null;
  zoom: MeetingZoomDto | null;
}

export interface SavePerformaSettingsCommand {
  /** @format uuid */
  settingId: string;
  enabled: boolean;
  baseUrl: string;
  webServicesUserId: string;
  webServicesPassword: string;
}

export interface SavePhasePropsDto {
  name: string;
  learnPathProps: LearnPathPhaseProps;
}

export type SavePhasePropsDtoIEquatable = object;

export interface SavePostPropsCommand {
  /** @format uuid */
  trainingId: string;
  /** @format int32 */
  versionNumber: number;
  /** @format uuid */
  componentId: string;
  course: SaveCoursePropsDto;
  post: PostPropsDto;
}

export interface SavePublicationResultDto {
  success: boolean;
  approvalStatus: PublicationApprovalStatus | null;
  /** @format uuid */
  newPublicationId: string | null;
}

export type SavePublicationResultDtoIEquatable = object;

export type SavePublicationResultDtoIRequest = object;

export interface SaveQuestionAlternativeDto {
  /** @format uuid */
  alternativeId: string;
  text: string;
  /** @format int32 */
  displayOrder: number;
  publicationRecommended: string[];
  trainingRecommended: string[];
  evaluation: QuestionAlternativeEvaluationDto | null;
  survey: QuestionAlternativeSurveyDto | null;
}

export type SaveQuestionAlternativeDtoIEquatable = object;

export interface SaveQuestionCommand {
  /** @format uuid */
  questionId: string | null;
  questionClass: QuestionClass;
  questionType: QuestionType;
  /** @format uuid */
  questionGroupId: string | null;
  /** @format uuid */
  exclusiveAssessmentId: string | null;
  questionText: string;
  remarks: string | null;
  /** @format uuid */
  attachId: string | null;
  alternatives: SaveQuestionAlternativeDto[];
  knowledgePublicationRecommended: string[] | null;
  trainingRecommended: string[] | null;
  tags: string[];
  isBlocked: boolean;
  isDraft: boolean;
  placeholderText: string | null;
  /** @format int32 */
  maxLen: number | null;
  evaluation: SaveQuestionEvaluationDto | null;
  survey: SaveQuestionSurveyDto | null;
  availableQuestioBank: boolean | null;
}

export interface SaveQuestionEvaluationDto {
  /** @format int32 */
  points: number;
  allowInKnowledgeTests: boolean;
  randomized: boolean;
  allowPartialScore: boolean;
  feedback: string | null;
  otherIncorrectAnswers: string[] | null;
}

export interface SaveQuestionSurveyDto {
  pointTyped: boolean | null;
  showSideBySide: boolean;
  /** @format int32 */
  fillInMinValue: number | null;
  /** @format int32 */
  fillInMaxValue: number | null;
  essayAnswerRequired: boolean | null;
  changeVersion: boolean | null;
}

export interface SaveReminderSettingsCommand {
  meetingLongNotificationEnabled: boolean;
  /** @format int32 */
  meetingShortNotificationMinutes: number;
  /** @format int32 */
  enrollmentDueDays: number;
  /** @format int32 */
  enrollmentExpireDays: number;
  /** @format int32 */
  inactiveDays: number;
  /** @format int32 */
  mandatoryTrainingNotEnrolledDays: number;
  /** @format int32 */
  answerNewKnowledgeTestsDays: number;
  /** @format int32 */
  activityWillExpireDays: number;
  /** @format int32 */
  continueEnrolledTrainingDays: number;
  /** @format int32 */
  developmentPlanConclusionsDays: number;
}

export interface SaveSamlAuthSettingsCommand {
  saml: SamlAuthSettingsModel;
}

export interface SaveScoPropsCommand {
  /** @format uuid */
  trainingId: string;
  /** @format int32 */
  versionNumber: number;
  /** @format uuid */
  componentId: string;
  course: SaveCoursePropsDto;
  sco: ScoPropsDto;
}

export interface SaveSettingsCommand {
  /** @format int32 */
  deadlineEvalEfficacyAndReaction: number;
  /** @format int32 */
  unansweredApprovalRequests: number;
  /** @format int32 */
  debugScorm: number;
  /** @format timespan */
  qrCodeTimeBefore: string | null;
  /** @format timespan */
  qrCodeTimeAfter: string | null;
  rootName: string;
  allowEnrollUsers: boolean;
  /** @format int32 */
  daysToAnswerAssessments: number;
  cancelEnrollReasons: CancelEnrollReasonDto[];
}

export interface SaveSettingsRulesApprovalCommand {
  rules: TrainingRulesApprovalRulesItem;
}

export interface SaveSettingsRulesAssessmentCommand {
  rules: TrainingRulesAssessmentItemDto;
}

export interface SaveSettingsRulesAwardCommand {
  rules: TrainingRulesAwardItem;
}

export interface SaveSettingsRulesCertificateCommand {
  rules: TrainingRulesCertificateItem;
}

export interface SaveSettingsRulesConclusionFormCommand {
  rules: TrainingRulesConclusionFormItem;
}

export interface SaveSettingsRulesExecutionCommand {
  rules: TrainingRulesExecutionItem;
}

export interface SaveSettingsRulesInstructorCommand {
  rules: TrainingRulesInstructorActionItem;
}

export interface SaveSettingsRulesInteractionCommand {
  discussionRules: TrainingRulesDiscussionItem;
  interactionRules: TrainingRulesInteractionItem;
}

export interface SaveSettingsRulesLearnPathApprovalCommand {
  rules: LearnPathRulesApprovalItem;
}

export interface SaveSettingsRulesLearnPathComponentRegistrationCommand {
  rules: LearnPathRulesComponentRegistrationItem;
}

export interface SaveSettingsRulesLearnPathReEnrollCommand {
  rules: LearnPathRulesReEnrollItem;
}

export interface SaveSettingsRulesLimitsCommand {
  rules: TrainingRulesAutoEnrollLimitsItem;
}

export interface SaveSettingsRulesRegistrationCommand {
  rules: TrainingRulesRegistrationItem;
}

export interface SaveSsoAuthSettingsCommand {
  settings: SsoAuthSettingsModel;
}

export interface SaveStandardAuthSettingsCommand {
  settings: StandardAuthSettingsModel;
}

export interface SaveSystemImageCommand {
  /** @format uuid */
  id: string;
  /** @format uuid */
  fileId: string | null;
}

export interface SaveSystemSettingsCommand {
  settings: SystemSettingsModel;
}

export interface SaveTrainingResultDto {
  success: boolean;
  /** @format uuid */
  newTrainingId: string | null;
}

export type SaveTrainingResultDtoIRequest = object;

export interface SaveTrainingRulesAgreementCommand {
  /** @format uuid */
  trainingId: string;
  allowOverride: boolean;
  rules: TrainingRulesAgreementItem;
}

export interface SaveTrainingRulesApprovalCommand {
  /** @format uuid */
  trainingId: string;
  allowOverride: boolean;
  rules: TrainingRulesApprovalRulesItem;
}

export interface SaveTrainingRulesAssCommand {
  /** @format uuid */
  trainingId: string;
  allowOverride: boolean;
  rules: TrainingRulesAssessmentItemDto;
}

export interface SaveTrainingRulesAwardCommand {
  /** @format uuid */
  trainingId: string;
  allowOverride: boolean;
  rules: TrainingRulesAwardItem;
}

export interface SaveTrainingRulesCertificateCommand {
  /** @format uuid */
  trainingId: string;
  allowOverride: boolean;
  rules: TrainingRulesCertificateItem;
}

export interface SaveTrainingRulesConclusionFormCommand {
  /** @format uuid */
  trainingId: string;
  allowOverride: boolean;
  rules: TrainingRulesConclusionFormItem;
}

export interface SaveTrainingRulesExecutionCommand {
  /** @format uuid */
  trainingId: string;
  allowOverride: boolean;
  rules: TrainingRulesExecutionItem;
}

export interface SaveTrainingRulesInstructorCommand {
  /** @format uuid */
  trainingId: string;
  allowOverride: boolean;
  rules: TrainingRulesInstructorActionItem;
}

export interface SaveTrainingRulesInteractionCommand {
  /** @format uuid */
  trainingId: string;
  allowOverride: boolean;
  discussionRules: TrainingRulesDiscussionItem;
  interactionRules: TrainingRulesInteractionItem;
}

export interface SaveTrainingRulesLimitsCommand {
  /** @format uuid */
  trainingId: string;
  rules: TrainingRulesAutoEnrollLimitsItem;
}

export interface SaveTrainingRulesPreReqCommand {
  /** @format uuid */
  trainingId: string;
  allowOverride: boolean;
  rules: TrainingRulesPreRequisitesItem;
}

export interface SaveTrainingRulesRegistrationCommand {
  /** @format uuid */
  trainingId: string;
  allowOverride: boolean;
  rules: TrainingRulesRegistrationItem;
}

export interface SaveTrainingRulesSeatsCommand {
  /** @format uuid */
  trainingId: string;
  allowOverride: boolean;
  rules: TrainingRulesSeatsItem;
}

export interface SaveUserSettingsCommand {
  settings: UserSettingsModel;
}

export interface SchedulerTaskLogQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  schedulerTaskId: string;
  searchText: string | null;
  filters: AdvCoreFilter[];
}

export interface SchedulerTaskLogResponse {
  /** @format uuid */
  schedulerTashLogId: string;
  /** @format date-time */
  executedOn: Date;
  /** @format int64 */
  duration: number;
  finishedSuccessfully: boolean;
  informationMessage: string | null;
  errorMessage: string | null;
  exceptionMessage: string | null;
}

export type SchedulerTaskLogResponseIEquatable = object;

export interface SchedulerTaskLogResponsePaginatedList {
  items: SchedulerTaskLogResponse[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type SchedulerTaskLogResponsePaginatedListIRequest = object;

export interface SchedulerTaskLogResults {
  informationMessage: string | null;
  errorMessage: string | null;
  exceptionMessage: string | null;
}

export type SchedulerTaskLogResultsIEquatable = object;

export type SchedulerTaskLogResultsIRequest = object;

export interface SchedulerTaskQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  filters: AdvCoreFilter[];
  searchText: string | null;
}

export interface SchedulerTaskResponse {
  /** @format uuid */
  schedulerTaskId: string;
  /** @format uuid */
  schedulerId: string;
  jobId: string;
  name: string;
  status: SchedulerStatus;
  statusName: string;
  enabled: boolean;
  /** @format date-time */
  lastRun: Date | null;
  /** @format date-time */
  nextRun: Date | null;
  cronTab: string;
  cronDescription: string;
}

export type SchedulerTaskResponseIEquatable = object;

export interface SchedulerTaskResponsePaginatedList {
  items: SchedulerTaskResponse[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type SchedulerTaskResponsePaginatedListIRequest = object;

export interface ScoComponentDto {
  /** @format uuid */
  scoId: string;
  lessonStatus: string | null;
  isPage: boolean;
  hasChildren: boolean;
  isParent: boolean;
  windowOption: TrainingScormPlayerWindowOption;
  /** @format int32 */
  windowWidth: number | null;
  /** @format int32 */
  windowHeight: number | null;
}

export type ScoComponentDtoIEquatable = object;

export interface ScoPropsDto {
  nameOverride: string | null;
  nameOverrided: boolean;
  scoHasOwnAccessRules: boolean;
  scoComputeProgressEnabled: boolean;
}

export type ScoPropsDtoIEquatable = object;

export interface ScoPropsQuery {
  /** @format uuid */
  trainingId: string;
  /** @format int32 */
  versionNumber: number;
  /** @format uuid */
  componentId: string;
}

export interface ScoreComponentDto {
  /** @format uuid */
  componentId: string;
  componentType: TrainingComponentType;
  name: string;
  /** @format int32 */
  weight: number;
  /** @format int32 */
  score: number | null;
  pendingScore: boolean;
}

export type ScoreComponentDtoIEquatable = object;

export interface ScormDebugTrainingsListQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  searchText: string | null;
}

export interface ScormDebugTrainingsListResponse {
  /** @format uuid */
  trainingId: string;
  name: string;
  thumbnailUrl: string;
  /** @format int32 */
  totalLogs: number;
}

export type ScormDebugTrainingsListResponseIEquatable = object;

export interface ScormDebugTrainingsListResponsePaginatedList {
  items: ScormDebugTrainingsListResponse[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type ScormDebugTrainingsListResponsePaginatedListIRequest = object;

export interface ScormLogQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  trainingId: string;
  searchText: string | null;
}

export interface ScormLogResponse {
  /** @format uuid */
  userId: string;
  name: string;
  displayName: string;
  title: string;
  operation: string;
  lessonStatus: string;
  /** @format date-time */
  createdOn: Date;
  rawXml: string;
}

export type ScormLogResponseIEquatable = object;

export interface ScormLogResponsePaginatedList {
  items: ScormLogResponse[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type ScormLogResponsePaginatedListIRequest = object;

export interface ScormPackageInfoQuery {
  /** @format uuid */
  fileId: string;
  /** @format uuid */
  trainingId: string;
  newVersion: boolean;
}

export interface ScormPlayerAccessTokenQuery {
  playerMode: PlayerMode;
  /** @format uuid */
  scoId: string;
  /** @format uuid */
  enrollmentId: string | null;
}

export interface ScormPlayerProps {
  windowOption: TrainingScormPlayerWindowOption;
  /** @format int32 */
  windowWidth: number | null;
  /** @format int32 */
  windowHeight: number | null;
  enableScoDataLog: boolean;
}

export type ScormPlayerPropsIEquatable = object;

export type ScormPlayerPropsIRequest = object;

export interface ScormPlayerSettingsQuery {
  /** @format uuid */
  trainingId: string;
  /** @format int32 */
  versionNumber: number;
}

export interface ScormTrainingSelectorQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  searchText: string | null;
}

export interface SearchTextDto {
  text: string;
  rule: SearchTextRule;
}

export interface SecondaryManagerItemDto {
  /** @format uuid */
  managerTypeId: string;
  managerTypeName: string;
  manager: UserDto | null;
}

export type SecondaryManagerItemDtoIEquatable = object;

export interface SecurityRolePermissionItem {
  permissionId: string;
  constraints: PermissionConstraintModel;
}

export type SecurityRolePermissionItemIEquatable = object;

export interface SecurityRoleSuggestionsQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  name: string | null;
  exceptRoleIds: string[];
}

export interface SelectQuickFiltersCommand {
  scope: KnowledgeQuickFilterScope;
  /** @format uuid */
  scopeRef: string | null;
  quickFilterIds: string[];
}

export interface SelectedStickerDto {
  /** @format uuid */
  stickerId: string;
  /** @format date-time */
  viewUntil: Date | null;
}

export type SelectedStickerDtoIEquatable = object;

export interface SelectionQuickFilterItemResponse {
  /** @format uuid */
  quickFilterId: string;
  name: string;
  filterType: KnowledgeQuickFilterType;
  customName: string | null;
  isSelected: boolean;
  /** @format int32 */
  selectionDisplayOrder: number | null;
  isChecked: boolean;
}

export type SelectionQuickFilterItemResponseIEquatable = object;

export interface SelectionQuickFilterResponse {
  scopeName: string | null;
  items: SelectionQuickFilterItemResponse[];
}

export type SelectionQuickFilterResponseIEquatable = object;

export type SelectionQuickFilterResponseIRequest = object;

export interface SelectionQuickFiltersQuery {
  scope: KnowledgeQuickFilterScope;
  /** @format uuid */
  scopeRef: string | null;
}

export interface SendDirectMessageCommand {
  recipientIds: string[];
  subject: string;
  body: string;
  /** @format uuid */
  attachId: string | null;
}

export interface SendMessageEnrollmentCommand {
  /** @format uuid */
  trainingId: string;
  /** @format uuid */
  classroomId: string | null;
  subject: string;
  body: string;
  /** @format uuid */
  attachId: string | null;
}

export interface SetDefaultCalendarCommand {
  /** @format uuid */
  calendarId: string;
}

export interface SetTemporaryBlockReasonCommand {
  /** @format uuid */
  blockReasonId: string;
  isTemporary: boolean;
}

export interface SettingsOnlineMeetingResponse {
  /** @format uuid */
  id: string;
  teamsEnabled: boolean;
  microsoftTeamsKey: string | null;
  zoomEnabled: boolean;
  zoomAccountId: string | null;
  zoomClientId: string | null;
  zoomClientSecret: string | null;
  zoomDefaultPassword: string | null;
  zoomSharedInstructorEmail: string | null;
  isAppRegistrationEnabled: boolean;
}

export type SettingsOnlineMeetingResponseIEquatable = object;

export interface SharePublicationCommand {
  /** @format uuid */
  publicationId: string;
  /** @format uuid */
  channelId: string;
  comments: string | null;
}

export interface ShareTrainingCommand {
  /** @format uuid */
  trainingId: string;
  target: ShareTrainingTarget;
  /** @format uuid */
  targetId: string;
  title: string;
  comments: string | null;
}

export interface ShortVideoDto {
  /** @format uuid */
  shortVideoId: string;
  attach: FeedAttachDto;
  settings: ShortVideoSettingsDto | null;
}

export type ShortVideoDtoIEquatable = object;

export type ShortVideoDtoIRequest = object;

export type ShortVideoDtoListIRequest = object;

export interface ShortVideoSettingsDto {
  /** @format int64 */
  startTime: number;
  /** @format int64 */
  endTime: number;
  /** @format date-time */
  dueDate: Date | null;
  priorityView: boolean | null;
}

export type ShortVideoSettingsDtoIEquatable = object;

export interface SpyLoginAuthDto {
  user: UserShortView;
  authUser: UserShortView;
  /** @format date-time */
  validUntil: Date;
  approved: boolean | null;
  expired: boolean;
}

export type SpyLoginAuthDtoIEquatable = object;

export type SpyLoginAuthDtoIRequest = object;

export interface SsoAuthSettingsModel {
  enabled: boolean;
  sourceUrl: string;
  integrationKey: string;
}

export interface StandardAccountAgreeRequest {
  securityStamp: string;
  /** @format uuid */
  agreementId: string;
  deviceInfo: string;
  timezoneId: string;
}

export type StandardAccountAgreeRequestIEquatable = object;

export interface StandardAccountAgreeResponse {
  status: StandardAccountAgreeStatus;
}

export type StandardAccountAgreeResponseIEquatable = object;

export interface StandardAccountConfirmCommand {
  securityStamp: string;
}

export type StandardAccountConfirmCommandIEquatable = object;

export interface StandardAccountConfirmResponse {
  status: StandardAccountConfirmStatus;
}

export type StandardAccountConfirmResponseIEquatable = object;

export type StandardAccountConfirmResponseIRequest = object;

export interface StandardAccountRenewConfirmationCommand {
  authKey: string;
  newEmail: string | null;
}

export type StandardAccountRenewConfirmationCommandIEquatable = object;

export interface StandardAccountRenewConfirmationResponse {
  status: StandardAccountRenewConfirmationStatus;
}

export type StandardAccountRenewConfirmationResponseIEquatable = object;

export type StandardAccountRenewConfirmationResponseIRequest = object;

export interface StandardAccountResendConfirmationCommand {
  authFieldValue: string | null;
  securityStamp: string | null;
}

export type StandardAccountResendConfirmationCommandIEquatable = object;

export interface StandardAccountResendConfirmationResponse {
  status: StandardAccountResendConfirmationStatus;
}

export type StandardAccountResendConfirmationResponseIEquatable = object;

export type StandardAccountResendConfirmationResponseIRequest = object;

export interface StandardAccountResetPasswordCommand {
  securityStamp: string;
  password: string;
}

export type StandardAccountResetPasswordCommandIEquatable = object;

export interface StandardAccountResetPasswordResponse {
  status: StandardAccountResetPasswordStatus;
}

export type StandardAccountResetPasswordResponseIEquatable = object;

export type StandardAccountResetPasswordResponseIRequest = object;

export interface StandardAccountSendResetPasswordCommand {
  authFieldValue: string;
}

export type StandardAccountSendResetPasswordCommandIEquatable = object;

export interface StandardAccountSendResetPasswordResponse {
  status: StandardAccountSendResetPasswordStatus;
}

export type StandardAccountSendResetPasswordResponseIEquatable = object;

export type StandardAccountSendResetPasswordResponseIRequest = object;

export interface StandardAccountUnlockCommand {
  /** @format uuid */
  userId: string;
}

export type StandardAccountUnlockCommandIEquatable = object;

export interface StandardAuthSettingsModel {
  enabled: boolean;
  identityFields: string[];
  identifierInstuctions: string;
  /** @format int32 */
  minLen: number;
  requiresOneNumber: boolean;
  requiresOneUpperLetter: boolean;
  requiresOneSymbol: boolean;
  allowNameParts: boolean;
  /** @format int32 */
  maxInvalidPasswordAttempts: number;
  /** @format int32 */
  lockoutTime: number;
  enablePasswordRecovery: boolean;
  requiresCaptcha: boolean;
  twoFactorMethods: TwoFactorAuthMethods;
  allowSkipAppAuthenticator: boolean;
}

export interface StartEvalInstanceCommand {
  /** @format uuid */
  instanceId: string;
  /** @format uuid */
  enrollmentId: string | null;
  /** @format uuid */
  componentId: string | null;
  /** @format uuid */
  deployId: string | null;
  /** @format uuid */
  deployParticipantId: string | null;
}

export interface StartPlayerEvaluationQuery {
  /** @format uuid */
  assessmentId: string;
  /** @format uuid */
  deployId: string;
  /** @format uuid */
  participantId: string;
}

export interface StartPlayerSurveyQuery {
  /** @format uuid */
  assessmentId: string;
  /** @format uuid */
  deployId: string;
  /** @format uuid */
  participantId: string | null;
  onlyResult: boolean;
}

export interface StartSurvInstanceCommand {
  /** @format uuid */
  instanceId: string;
  /** @format uuid */
  deployId: string | null;
  /** @format uuid */
  deployParticipantId: string | null;
}

export interface StickerAppliesToListQueryResponse {
  appliesTo: StickerAppliesTo;
  name: string;
}

export type StickerAppliesToListQueryResponseIEquatable = object;

export interface StickerDto {
  /** @format uuid */
  stickerId: string;
  name: string;
  requiredDeadline: boolean;
}

export type StickerDtoIEquatable = object;

export interface StickerSelectorAdvFilterQuery {
  applyTo: StickerAppliesTo | null;
}

export interface StickerSelectorAdvFilterResponse {
  /** @format uuid */
  stickerId: string;
  name: string;
}

export type StickerSelectorAdvFilterResponseIEquatable = object;

export type StickerSelectorAdvFilterResponseListIRequest = object;

export interface StickerSuggestionQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  searchText: string | null;
  applyTo: StickerAppliesTo;
  checkRestrictions: boolean;
  exceptStickerIds: string[];
}

export interface StorageMetadataModel {
  title: string | null;
  description: string | null;
  author: string | null;
  filename: string;
  type?: string;
  /** @format int64 */
  fileSize?: number;
  /** @format date-time */
  fileCreationDate: Date | null;
  /** @format int32 */
  width: number | null;
  /** @format int32 */
  height: number | null;
  /** @format int64 */
  duration: number | null;
}

export type StorageMetadataModelIEquatable = object;

export type StringIRequest = object;

export interface StringImportedItemModel {
  item: string | null;
  success: boolean;
  errorMessage: string[];
}

export type StringImportedItemModelListIRequest = object;

export type StringListIRequest = object;

export interface SubordinateDto {
  /** @format uuid */
  userId: string;
  name: string;
  thumbnailUrl: string;
  isManager: boolean;
  jobPositionName: string | null;
  userType: UserType;
}

export type SubordinateDtoIEquatable = object;

export interface SubordinateDtoPaginatedList {
  items: SubordinateDto[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export interface SubordinateSelectorQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  managerId: string;
  searchText: string | null;
}

export interface SubordinateSelectorResponse {
  /** @format uuid */
  userId: string;
  name: string;
  thumbnailUrl: string;
  isDirectSubordinate: boolean;
}

export type SubordinateSelectorResponseIEquatable = object;

export interface SubordinateSelectorResponsePaginatedList {
  items: SubordinateSelectorResponse[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type SubordinateSelectorResponsePaginatedListIRequest = object;

export interface SubordinaterAutoCompleteDataModelDto {
  key: any;
  label: string;
  thumbnailUrl?: string | null;
  canDelete?: boolean | null;
  fixed?: boolean | null;
  selectable?: boolean | null;
  fromHistory?: boolean;
  isManager: boolean;
  jobPositionName: string;
  userType: UserType;
}

export type SubordinaterAutoCompleteDataModelDtoIEquatable = object;

export interface SubordinaterAutoCompleteDataModelDtoPaginatedList {
  items: SubordinaterAutoCompleteDataModelDto[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type SubordinaterAutoCompleteDataModelDtoPaginatedListIRequest = object;

export interface SubordinatesSuggestionQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  managerId: string;
  searchText: string | null;
  directSubordinatesOnly: boolean;
}

export interface SubscribePublicationCommand {
  /** @format uuid */
  publicationId: string;
}

export interface SubscribeTopicCommand {
  /** @format uuid */
  topicId: string;
}

export interface SubscribeUserCommand {
  /** @format uuid */
  userId: string;
}

export interface SubscriptionToggleHideCommand {
  /** @format uuid */
  subscriptionId: string;
}

export interface SubtitleItemDto {
  /** @format int64 */
  startTime: number;
  /** @format int64 */
  endTime: number;
  startTimeFormated: string;
  endTimeFormated: string;
  lines: string;
}

export type SubtitleItemDtoIEquatable = object;

export type SubtitleItemDtoListIRequest = object;

export interface SupervisorActionDto {
  canManageEnroll: boolean;
  isCoordinator: boolean;
  coordinatorCanManageEnroll: boolean;
}

export type SupervisorActionDtoIEquatable = object;

export interface SupervisorActivitiesQuery {
  /** @format uuid */
  classroomId: string;
  /** @format uuid */
  componentId: string | null;
}

export interface SupervisorActivityChecklistItem {
  /** @format uuid */
  itemId: string;
  checked: boolean;
}

export interface SupervisorActivityDto {
  /** @format uuid */
  publicationId: string | null;
  /** @format uuid */
  componentId: string | null;
  name: string;
  /** @format date-time */
  dueDate: Date | null;
  digitalDelivery: boolean;
  /** @format int32 */
  totalScored: number;
  /** @format int32 */
  totalPending: number;
  dueDateExpired: boolean;
  /** @format int32 */
  totalDelivery: number;
  isCanceled: boolean;
  canScore: boolean;
  checklist: RegisterActivityChecklistItemDto[];
}

export type SupervisorActivityDtoIEquatable = object;

export type SupervisorActivityDtoListIRequest = object;

export interface SupervisorCancelActivityCommand {
  /** @format uuid */
  componentId: string;
  /** @format uuid */
  classroomId: string;
}

export interface SupervisorClassroomActivityQuery {
  /** @format uuid */
  classroomId: string;
  /** @format uuid */
  componentId: string;
}

export interface SupervisorClassroomDiscussionDto {
  /** @format uuid */
  trainingId: string;
  trainingName: string;
  trainingType: TrainingType;
  multipleClasses: boolean;
  /** @format uuid */
  classroomId: string;
  classroomName: string;
  /** @format int32 */
  discussionCount: number;
  /** @format int32 */
  mentionCount: number;
}

export type SupervisorClassroomDiscussionDtoIEquatable = object;

export interface SupervisorClassroomDiscussionDtoPaginatedList {
  items: SupervisorClassroomDiscussionDto[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type SupervisorClassroomDiscussionDtoPaginatedListIRequest = object;

export interface SupervisorClassroomDiscussionsQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  trainingId: string | null;
  option: SupervisorClassroomDiscussionOption;
  searchText: string | null;
  filter: AdvCoreFilter[];
  pendingOnly: boolean;
  includeClassroomsFinalized: boolean;
  queryMode: SupervisorTrainingsQueryMode;
}

export interface SupervisorClassroomDto {
  /** @format uuid */
  classroomId: string;
  name: string;
  /** @format int32 */
  activeEnrollments: number;
  /** @format int32 */
  mentionCount: number;
  /** @format int32 */
  executionDueDays: number | null;
  /** @format date-time */
  executionDueDate: Date | null;
  /** @format int32 */
  executionExpireDaysAfterDueDate: number | null;
  pendingScoreOrAttended: boolean;
  pendingAssScore: boolean;
  /** @format date-time */
  registrationAvailableUntil: Date | null;
}

export type SupervisorClassroomDtoIEquatable = object;

export interface SupervisorClassroomDtoPaginatedList {
  items: SupervisorClassroomDto[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type SupervisorClassroomDtoPaginatedListIRequest = object;

export interface SupervisorClassroomMeetingDto {
  /** @format uuid */
  trainingId: string;
  trainingName: string;
  /** @format uuid */
  classroomId: string;
  classroomName: string | null;
  /** @format uuid */
  meetingId: string;
  meetingName: string;
  meetingType: MeetingType;
  meetingTypeName: string;
  /** @format date-time */
  startDate: Date;
  /** @format date-time */
  endDate: Date;
  locationName: string;
  mandatoryAttendance: boolean;
  hasScore: boolean;
  meetingLink: string | null;
  isMainInstructor: boolean;
  isInstructorAssistant: boolean;
}

export type SupervisorClassroomMeetingDtoIEquatable = object;

export interface SupervisorClassroomMeetingDtoPaginatedList {
  items: SupervisorClassroomMeetingDto[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type SupervisorClassroomMeetingDtoPaginatedListIRequest = object;

export interface SupervisorClassroomMeetingQuery {
  /** @format uuid */
  classroomId: string;
  /** @format uuid */
  componentId: string;
}

export interface SupervisorClassroomMeetingResponse {
  canModify: boolean;
  canCancel: boolean;
  canUndoCancel: boolean;
  canPublishRecording: boolean;
  hasAttendanceOrScoreAssigned: boolean;
  isCanceled: boolean;
  canAccessAttendanceList: boolean;
  hasCloseEnrollsments: boolean;
  meeting: ManagedMeetingDto;
  recordingFile: FileGetDto | null;
}

export type SupervisorClassroomMeetingResponseIEquatable = object;

export type SupervisorClassroomMeetingResponseIRequest = object;

export interface SupervisorClassroomMeetingsQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  trainingId: string | null;
  option: SupervisorClassroomMeetingOption;
  searchText: string | null;
  filter: AdvCoreFilter[];
  pendingOnly: boolean;
  includeClassroomsFinalized: boolean;
  queryMode: SupervisorTrainingsQueryMode;
}

export interface SupervisorClassroomNoticeResponse {
  /** @format uuid */
  noticeId: string;
  title: string;
  /** @format date-time */
  createdOn: Date;
  creator: UserShortView;
  /** @format date-time */
  availableFrom: Date | null;
  /** @format date-time */
  availableTo: Date | null;
  notAvailableYet: boolean;
  isExpired: boolean;
}

export type SupervisorClassroomNoticeResponseIEquatable = object;

export interface SupervisorClassroomNoticeResponsePaginatedList {
  items: SupervisorClassroomNoticeResponse[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type SupervisorClassroomNoticeResponsePaginatedListIRequest = object;

export interface SupervisorClassroomNoticesQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  classroomId: string;
  searchText: string | null;
  includeExpired: boolean;
}

export interface SupervisorClassroomsQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  trainingId: string;
  /** @format uuid */
  instructorId: string | null;
  searchText: string | null;
}

export interface SupervisorDiscussionDto {
  /** @format uuid */
  trainingId: string;
  trainingName: string;
  trainingType: TrainingType;
  multipleClasses: boolean;
  /** @format uuid */
  classroomId: string;
  classroomName: string;
}

export type SupervisorDiscussionDtoIEquatable = object;

export interface SupervisorEnrollmentDetailsQuery {
  /** @format uuid */
  enrollmentId: string;
}

export interface SupervisorEnrollmentDetailsResponse {
  summary: EnrollmentSummaryDto;
  components: EnrollmentComponentDto[];
  scoreComponents: ScoreComponentDto[];
}

export type SupervisorEnrollmentDetailsResponseIEquatable = object;

export type SupervisorEnrollmentDetailsResponseIRequest = object;

export interface SupervisorEnrollmentDto {
  /** @format uuid */
  enrollmentId: string;
  /** @format uuid */
  trainingId: string;
  /** @format uuid */
  classroomId: string;
  /** @format uuid */
  userId: string;
  name: string;
  thumbnailUrl: string;
  status: EnrollStatus;
  /** @format double */
  progressPercent: number | null;
  /** @format double */
  scorePercent: number | null;
  /** @format date-time */
  startDate: Date;
  /** @format date-time */
  lastAccess: Date | null;
  /** @format date-time */
  finalizationDate: Date | null;
  /** @format date-time */
  dueDate: Date | null;
  /** @format date-time */
  effectiveExpireDate: Date | null;
  /** @format double */
  preTestScore: number | null;
  /** @format timespan */
  timeSpent: string | null;
  isMandatory: boolean;
  isDelayed: boolean;
  isExpired: boolean;
  /** @format uuid */
  certificateFileId: string | null;
  /** @format date-time */
  certificateValidUntil: Date | null;
  hasCertificate: boolean;
  canExtraTime: boolean;
  canCancel: boolean;
}

export type SupervisorEnrollmentDtoIEquatable = object;

export interface SupervisorEnrollmentDtoPaginatedList {
  items: SupervisorEnrollmentDto[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type SupervisorEnrollmentDtoPaginatedListIRequest = object;

export interface SupervisorEnrollmentsQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  classroomId: string;
  lastEnrollmentOnly: boolean;
  searchText: string | null;
  filter: AdvCoreFilter[];
  orderBy: SupervisorEnrollmentOrderBy;
}

export interface SupervisorHeaderDto {
  /** @format uuid */
  trainingId: string;
  name: string;
  thumbnailUrl: string | null;
  trainingType: TrainingType;
  contentType: TrainingContentType;
  contentTypeStr: string;
  timezoneId: string;
  multipleClasses: boolean;
  /** @format int32 */
  classCount: number;
  /** @format int32 */
  trainingRatingAvg: number;
  /** @format uuid */
  classroomId: string;
  classroomName: string;
  classIsActive: boolean;
  classIsFinalized: boolean;
  executionDueDateOption: TrainingDueDateOption;
  /** @format date-time */
  executionStartDate: Date | null;
  /** @format date-time */
  executionDueDate: Date | null;
  /** @format int32 */
  executionDueDays: number | null;
  /** @format int32 */
  executionDaysLeft: number | null;
  /** @format int32 */
  executionExpireDaysAfterDueDate: number | null;
  ratingOption: TrainingRatingOption;
  canCancelEventAndActivity: boolean;
  canModifyEventAndActivity: boolean;
  /** @format int32 */
  enrollmentsCount: number;
  /** @format int32 */
  closedEnrollmentsCount: number;
  /** @format int32 */
  approvedEnrollmentsCount: number;
  /** @format int32 */
  reprovedEnrollmentsCount: number;
  /** @format int32 */
  discussionCount: number;
  /** @format int32 */
  materialListCount: number;
  /** @format int32 */
  noticeCount: number;
  /** @format int32 */
  classRatingAvg: number;
  /** @format int32 */
  discussionMentionPendingCountInstructor: number;
  /** @format int32 */
  discussionMentionPendingCountOthers: number;
  /** @format int32 */
  eventPendingsCount: number;
  /** @format int32 */
  activityPendingsCount: number;
  /** @format int32 */
  essayPendingsCount: number;
  meetings: SupervisorMeetingDto[];
  activities: SupervisorActivityDto[];
  instructors: UserShortView[];
  managers: SupervisorManagerDto[];
  actions: SupervisorActionDto;
}

export type SupervisorHeaderDtoIEquatable = object;

export type SupervisorHeaderDtoIRequest = object;

export interface SupervisorHeaderQuery {
  /** @format uuid */
  classroomId: string;
  queryMode: SupervisorTrainingsQueryMode;
}

export interface SupervisorInsightsDto {
  /** @format int32 */
  trainingCount: number;
  /** @format int32 */
  classroomCount: number;
  /** @format int32 */
  discussionCount: number;
  /** @format int32 */
  discussionMentionCountInstructor: number;
  /** @format int32 */
  discussionMentionCountOthers: number;
  /** @format int32 */
  activeEnrollments: number;
  /** @format int32 */
  pendingCount: number;
  /** @format int32 */
  eventCount: number;
  /** @format int32 */
  eventDoneCount: number;
  /** @format int32 */
  eventNextCount: number;
  /** @format int32 */
  totalEnrollments: number;
  /** @format int32 */
  totalEnrollmentsFinalized: number;
  /** @format int32 */
  totalEnrollmentsApproved: number;
  /** @format double */
  enrollmentsApprovedPercent: number;
  /** @format uuid */
  nextMeetingId: string | null;
  /** @format date-time */
  nextMeetingStartDate: Date | null;
  uniqueDiscussionClassroom: SupervisorDiscussionDto | null;
  uniqueMentionClassroom: SupervisorDiscussionDto | null;
}

export type SupervisorInsightsDtoIEquatable = object;

export type SupervisorInsightsDtoIRequest = object;

export interface SupervisorInsightsQuery {
  searchText: string | null;
  filter: AdvCoreFilter[];
  pendingOnly: boolean;
  includeClassroomsFinalized: boolean;
  queryMode: SupervisorTrainingsQueryMode;
}

export interface SupervisorInstructorSuggestionsQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  searchText: string | null;
}

export interface SupervisorManagerDto {
  role: string;
  user: UserShortView;
}

export interface SupervisorMeetingDto {
  /** @format uuid */
  meetingId: string | null;
  /** @format uuid */
  componentId: string | null;
  meetingType: MeetingType | null;
  meetingTypeName: string | null;
  name: string;
  isMandatory: boolean | null;
  locationName: string | null;
  /** @format date-time */
  startDate: Date | null;
  /** @format date-time */
  endDate: Date | null;
  timezoneId: string | null;
  /** @format int32 */
  instructorCount: number;
  instructorName: string | null;
  hasPending: boolean;
  meetingLink: string | null;
  cancelled: boolean | null;
  hasScore: boolean;
  /** @format int32 */
  totalAttended: number;
  /** @format int32 */
  totalPending: number;
  canAccessAttendanceList: boolean;
  isToday: boolean;
  started: boolean;
  finished: boolean;
  canAccess: boolean;
}

export type SupervisorMeetingDtoIEquatable = object;

export type SupervisorMeetingDtoListIRequest = object;

export interface SupervisorMeetingsQuery {
  /** @format uuid */
  classroomId: string;
  /** @format uuid */
  componentId: string | null;
}

export interface SupervisorPublishMeetingRecordingCommand {
  /** @format uuid */
  classroomId: string;
  /** @format uuid */
  componentId: string;
  /** @format uuid */
  recordingFileId: string | null;
}

export interface SupervisorStatisticsAssessment {
  /** @format uuid */
  reactionAssessmentId: string | null;
  /** @format uuid */
  userEfficacyAssessmentId: string | null;
  /** @format uuid */
  managerEfficacyAssessmentId: string | null;
  /** @format uuid */
  reactionDeployId: string | null;
  /** @format uuid */
  userEfficacyDeployId: string | null;
  /** @format uuid */
  managerEfficacyDeployId: string | null;
  reactionHasPoints: boolean;
  userEfficacyHasPoints: boolean;
  managerEfficacyHasPoints: boolean;
  reactionIsEvaluation: boolean;
  userEfficacyIsEvaluation: boolean;
  /** @format double */
  avgReactionScore: number | null;
  /** @format double */
  avgUserEfficacy: number | null;
  /** @format double */
  avgManagerEfficacy: number | null;
  /** @format int32 */
  totalUserReaction: number;
  /** @format int32 */
  totalUserEfficacy: number;
  /** @format int32 */
  totalManagerEfficacy: number;
  /** @format int32 */
  totalNotAnswerReaction: number;
  /** @format int32 */
  totalNotUserEfficacy: number;
  /** @format int32 */
  totalNotManagerEfficacy: number;
  /** @format int32 */
  totalDeploys: number;
  /** @format double */
  answeredTax: number;
}

export interface SupervisorStatisticsDrillQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  trainingId: string | null;
  /** @format uuid */
  classroomId: string | null;
  searchText: string | null;
  finalizedOnly: boolean;
  lastEnrollmentOnly: boolean;
  chart: SupervisorStatisticsChart;
  /** @format int32 */
  datasetIndex: number;
}

export interface SupervisorStatisticsDto {
  resume: SupervisorStatisticsResume;
  components: TrainingPanelTutorStatisticsComponent[];
  assessment: SupervisorStatisticsAssessment | null;
}

export type SupervisorStatisticsDtoIRequest = object;

export interface SupervisorStatisticsQuery {
  /** @format uuid */
  classroomId: string;
  finalizedOnly: boolean;
  lastEnrollmentOnly: boolean;
}

export interface SupervisorStatisticsResume {
  /** @format int64 */
  totalEnrolls: number;
  /** @format int64 */
  totalWaiting: number;
  status: number[];
  deadline: number[];
  progress: number[];
  grade: number[];
  /** @format int64 */
  totalStatus: number;
  /** @format int64 */
  totalDeadline: number;
  /** @format int64 */
  totalProgress: number;
  /** @format int64 */
  totalGrade: number;
  statusPercent: number[];
  deadlinePercent: number[];
  progressPercent: number[];
  gradePercent: number[];
  /** @format int64 */
  doing: number;
  /** @format int64 */
  canceled: number;
  /** @format int64 */
  approved: number;
  /** @format int64 */
  reproved: number;
  /** @format int64 */
  exempted: number;
  /** @format int64 */
  finished: number;
  /** @format double */
  conclusionTax: number;
  /** @format double */
  approvalTax: number;
}

export interface SupervisorTrainingDto {
  /** @format uuid */
  trainingId: string;
  name: string;
  /** @format uuid */
  thumbnailId: string | null;
  thumbnailUrl: string;
  /** @format uuid */
  uniqueClassroomId: string | null;
  /** @format int32 */
  classroomCount: number;
  /** @format int32 */
  activeEnrollments: number;
  /** @format int32 */
  mentionCount: number;
  /** @format int32 */
  executionDueDays: number | null;
  /** @format date-time */
  executionDueDate: Date | null;
  /** @format int32 */
  executionExpireDaysAfterDueDate: number | null;
  pendingScoreOrAttended: boolean;
  pendingAssScore: boolean;
  /** @format date-time */
  registrationAvailableUntil: Date | null;
  canManageEnroll: boolean;
}

export type SupervisorTrainingDtoIEquatable = object;

export interface SupervisorTrainingDtoPaginatedList {
  items: SupervisorTrainingDto[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type SupervisorTrainingDtoPaginatedListIRequest = object;

export interface SupervisorTrainingsQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  searchText: string | null;
  filter: AdvCoreFilter[];
  pendingOnly: boolean;
  includeClassroomsFinalized: boolean;
  queryMode: SupervisorTrainingsQueryMode;
  orderBy: SupervisorTrainingsOrderBy;
}

export interface SupervisorUndoCancelActivityCommand {
  /** @format uuid */
  componentId: string;
  /** @format uuid */
  classroomId: string;
}

export interface SupervisorUndoCancelClassroomMeetingCommand {
  /** @format uuid */
  componentId: string;
  /** @format uuid */
  classroomId: string;
}

export interface SupervisorUpdateActivityCommand {
  /** @format uuid */
  componentId: string;
  /** @format uuid */
  classroomId: string;
  /** @format date-time */
  dueDate: Date;
}

export interface SupervisorUpdateClassroomMeetingCommand {
  meetingType: MeetingType;
  /** @format uuid */
  componentId: string;
  /** @format uuid */
  classroomId: string;
  /** @format uuid */
  roomId: string | null;
  locationName: string | null;
  address: AddressModel | null;
  timezoneId: string | null;
  /** @format date-time */
  startDate: Date | null;
  /** @format date-time */
  endDate: Date | null;
  externalUrl: string | null;
  /** @format timespan */
  bookAdditionalTimeBefore: string | null;
  /** @format timespan */
  bookAdditionalTimeAfter: string | null;
  instructors: string[] | null;
  assistants: string[] | null;
}

export interface SurveySuggestionsQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  searchText: string | null;
}

export interface SystemFeatureResponse {
  feature: SystemFeature;
  name: string;
}

export type SystemFeatureResponseIEquatable = object;

export interface SystemSettingsModel {
  title: string;
  uiTheme: string;
  /** @format uuid */
  logoId: string | null;
  /** @format uuid */
  backgroundId: string | null;
  /** @format uuid */
  highlightImageId: string | null;
  /** @format uuid */
  iconId: string | null;
  timezoneId: string;
  locale: string;
  blockSendMail: boolean;
  enableSendBirthday: boolean;
  emailSenderName: string;
  emailSenderAddress: string;
  /** @format int32 */
  maxAuditLogDays: number;
  corporateIP: string[];
  /**
   * @format time
   * @example ""13:45:42.0000000""
   */
  dynamicGroupsProcessingTime: string;
  /** @format int32 */
  bannerInterval: number | null;
  bannerAutomaticRotation: boolean;
  bannerViewRandom: boolean;
  /** @format int32 */
  bannerHeight: number;
  /** @format int32 */
  maxSchedulerLogDays: number;
  canChangeEmailAddress: boolean;
}

export interface SystemUsageDto {
  iaRequestsExceeded: boolean;
  storageExceeded: boolean;
  streamingExceeded: boolean;
  usersExceeded: boolean;
  useExternalVideoBroadcast: boolean;
  callIaStatus: IaRequestCallingStatus;
  callIaStatusName: string;
}

export type SystemUsageDtoIEquatable = object;

export interface TagAssociatedAssessmentsQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  tagId: string;
  searchText: string | null;
}

export interface TagAssociatedGroupsQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  tagId: string;
  searchText: string | null;
}

export interface TagAssociatedTopicsQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  tagId: string;
  searchText: string | null;
}

export interface TagAssociatedTrainingsQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  tagId: string;
  searchText: string | null;
}

export interface TagAssociatedUnitsQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  tagId: string;
  searchText: string | null;
}

export interface TagAssociatedUsersQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  tagId: string;
  listInterest: boolean;
  searchText: string | null;
}

export interface TagAutoCompleteDataModelDto {
  key: any;
  label: string;
  thumbnailUrl?: string | null;
  canDelete?: boolean | null;
  fixed?: boolean | null;
  selectable?: boolean | null;
  fromHistory?: boolean;
  usage: TagUsage;
}

export type TagAutoCompleteDataModelDtoIEquatable = object;

export interface TagSelectorQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  searchText: string | null;
  usage: TagUsage;
  ignoreSelectionHistory: boolean;
}

export interface TagSelectorResponse {
  /** @format uuid */
  tagId: string;
  name: string;
  usage: TagUsage;
  fromHistory: boolean;
}

export type TagSelectorResponseIEquatable = object;

export interface TagSelectorResponsePaginatedList {
  items: TagSelectorResponse[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type TagSelectorResponsePaginatedListIRequest = object;

export interface TagsSuggestionAutoComplete {
  key: any;
  label: string;
  thumbnailUrl?: string | null;
  canDelete?: boolean | null;
  fixed?: boolean | null;
  selectable?: boolean | null;
  fromHistory?: boolean;
  usage: TagUsage;
}

export type TagsSuggestionAutoCompleteIEquatable = object;

export interface TagsSuggestionAutoCompletePaginatedList {
  items: TagsSuggestionAutoComplete[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type TagsSuggestionAutoCompletePaginatedListIRequest = object;

export interface TagsSuggestionsQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  name: string | null;
  usage: TagUsage;
  exceptTagIds: string[];
}

export interface TenantMobileInfo {
  appName: string;
  android: AndroidDefinition | null;
  ios: IosDefinition | null;
}

export interface TenantUIConfig {
  themeName: string;
  title: string;
}

export type TenantUIConfigIEquatable = object;

export interface TextFieldDto {
  /** @format int32 */
  length: number | null;
  inputMask: string | null;
  displayFormat: string | null;
  validation: string | null;
  multiline: boolean;
  preDefinedType: CustomFieldPreDefinedType;
}

export type TextFieldDtoIEquatable = object;

export interface ThreadReorderCommand {
  /** @format uuid */
  masterPublicationId: string;
  orderedItems: string[];
}

export interface ThumbnailPublicationResponse {
  /** @format uuid */
  publicationId: string;
  thumbnailUrl: string;
  thumbnail: FileGetDto | null;
}

export type ThumbnailPublicationResponseIEquatable = object;

export type ThumbnailPublicationResponseIRequest = object;

export interface TimezoneDto {
  timezoneId: string;
  nameR: ResourceModel[];
  shortName: string;
  /** @format int32 */
  offset: number;
}

export type TimezoneDtoIEquatable = object;

export interface ToggleBlockProfileCommand {
  /** @format uuid */
  userId: string;
}

export interface ToggleMutedChannelCommand {
  /** @format uuid */
  channelId: string;
}

export interface ToggleMutedTopicCommand {
  /** @format uuid */
  topicId: string;
}

export interface ToggleMutedUserProfileCommand {
  /** @format uuid */
  userId: string;
}

export interface ToggleSilenceProfileCommand {
  /** @format uuid */
  userId: string;
}

export interface TopicAutoCompleteDataModelDto {
  key: any;
  label: string;
  thumbnailUrl?: string | null;
  canDelete?: boolean | null;
  fixed?: boolean | null;
  selectable?: boolean | null;
  fromHistory?: boolean;
  requiredGroup: GroupInfo;
  optionalGroup: GroupInfo;
  /** @format uuid */
  sysQuestionGroupId: string | null;
}

export type TopicAutoCompleteDataModelDtoIEquatable = object;

export interface TopicAutoCompleteDataModelDtoPaginatedList {
  items: TopicAutoCompleteDataModelDto[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type TopicAutoCompleteDataModelDtoPaginatedListIRequest = object;

export interface TopicAutoCompleteHierarchicalModelDto {
  key: any;
  label: string;
  thumbnailUrl?: string | null;
  canDelete?: boolean | null;
  fixed?: boolean | null;
  selectable?: boolean | null;
  fromHistory?: boolean;
  includeDescendants: boolean;
  hasChild: boolean;
  allowAssociates: boolean;
  tooltip: string | null;
  tree: AutoCompleteHierarchicalTreeModelDto[];
  requiredGroup: GroupInfo;
  optionalGroup: GroupInfo;
}

export type TopicAutoCompleteHierarchicalModelDtoIEquatable = object;

export type TopicAutoCompleteHierarchicalModelDtoListIRequest = object;

export interface TopicAutoCompleteHierarchicalModelDtoPaginatedList {
  items: TopicAutoCompleteHierarchicalModelDto[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type TopicAutoCompleteHierarchicalModelDtoPaginatedListIRequest = object;

export interface TopicCategoryOptionsDto {
  category: TopicCategory;
  name: string;
}

export type TopicCategoryOptionsDtoIEquatable = object;

export interface TopicCategorySelectorQuery {
  searchText: string | null;
}

export interface TopicCategorySelectorResponse {
  value: TopicCategory;
  name: string;
}

export type TopicCategorySelectorResponseIEnumerableIRequest = object;

export type TopicCategorySelectorResponseIEquatable = object;

export interface TopicChallengeListQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  searchText: string | null;
  suspended: boolean;
}

export interface TopicChallengeResponse {
  /** @format uuid */
  topicId: string;
  name: string;
  thumbnailUrl: string;
  disableChallenge: boolean;
  /** @format int32 */
  availableQuestions: number;
  /** @format int32 */
  totalAudience: number;
  /** @format int32 */
  usersAnswered: number;
}

export type TopicChallengeResponseIEquatable = object;

export interface TopicChallengeResponsePaginatedList {
  items: TopicChallengeResponse[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type TopicChallengeResponsePaginatedListIRequest = object;

export interface TopicGroupCreateCommand {
  /** @format uuid */
  topicId: string;
  /** @format uuid */
  groupId: string;
}

export interface TopicGroupDeleteCommand {
  /** @format uuid */
  topicId: string;
  /** @format uuid */
  groupId: string;
}

export interface TopicItemDto {
  /** @format uuid */
  topicId: string;
  name: string;
  thumbnailUrl: string;
}

export type TopicItemDtoIEquatable = object;

export interface TopicItemDtoPaginatedList {
  items: TopicItemDto[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type TopicItemDtoPaginatedListIRequest = object;

export interface TopicPanelDto {
  /** @format uuid */
  topicId: string;
  name: string;
}

export type TopicPanelDtoIEquatable = object;

export type TopicPanelDtoListIRequest = object;

export interface TopicQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  topicId: string;
  includeDescendants: boolean;
  browserTimeZoneId: string;
  searchText: string | null;
  filters: AdvCoreFilter[];
  order: LmsTrainingOrder;
}

export interface TopicRelationCreateCommand {
  /** @format uuid */
  topicId: string;
  /** @format uuid */
  relatedTopicId: string;
  bidirectional: boolean;
}

export interface TopicRelationDeleteCommand {
  /** @format uuid */
  topicId: string;
  /** @format uuid */
  relatedTopicId: string;
  bidirectional: boolean;
}

export interface TopicSearchDto {
  /** @format uuid */
  topicId: string;
  name: string;
  description: string | null;
  thumbnailUrl: string | null;
  /** @format int32 */
  totalPublications: number;
}

export type TopicSearchDtoIEquatable = object;

export interface TopicSearchDtoPaginatedList {
  items: TopicSearchDto[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type TopicSearchDtoPaginatedListIRequest = object;

export interface TopicSearchQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  searchText: string;
  orderBy: TopicSearchOrderBy;
}

export interface TopicSelectorHierarchicalQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  parentId: string | null;
  /** @format uuid */
  topicId: string | null;
  searchText: string | null;
  selectorType: TopicSelectorType;
  mode: TopicSelectorMode;
  trySelectionHistory: boolean;
}

export interface TopicSelectorHierarchicalResponse {
  /** @format uuid */
  parentId: string | null;
  /** @format uuid */
  topicId: string;
  name: string;
  thumbnailUrl: string;
  hasChildren: boolean;
  /** @format uuid */
  requiredGroupId: string | null;
  /** @format uuid */
  optionalGroupId: string | null;
  fromHistory: boolean;
  selectable: boolean;
}

export type TopicSelectorHierarchicalResponseIEquatable = object;

export interface TopicSelectorHierarchicalResponsePaginatedList {
  items: TopicSelectorHierarchicalResponse[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type TopicSelectorHierarchicalResponsePaginatedListIRequest = object;

export interface TopicSubscriptionResponse {
  /** @format uuid */
  topicId: string;
  name: string;
  thumbnailUrl: string | null;
  registered: boolean;
  hideQuickAccess: boolean | null;
  /** @format int32 */
  publicationCount: number;
  /** @format int32 */
  subscriptionCount: number;
}

export type TopicSubscriptionResponseIEnumerableIRequest = object;

export type TopicSubscriptionResponseIEquatable = object;

export interface TopicSubscriptionsQuery {
  /** @format int32 */
  takeRecords: number;
  searchText: string | null;
  filterBy: TopicSubscriptionFilterBy;
}

export interface TopicSuggestionsHierarchicalQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  parentId: string | null;
  searchText: string | null;
  trySelectionHistory: boolean;
  isInterestAssigment: boolean;
  applyKnowledgeTests: boolean;
  exceptTopicIds: string[];
}

export interface TopicSuggestionsQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  searchText: string | null;
  ignoreSelectionHistory: boolean;
  isInterestAssigment: boolean;
  applyKnowledgeTests: boolean;
  categories: TopicCategory[] | null;
}

export interface TopicSupportDataDto {
  categoryOptions: TopicCategoryOptionsDto[];
}

export type TopicSupportDataDtoIEquatable = object;

export interface TopicUserAssociatedGroupsQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  topicId: string;
  /** @format uuid */
  userId: string;
  searchText: string | null;
}

export interface TopicUserChangeLinkCommand {
  /** @format uuid */
  topicId: string;
  /** @format uuid */
  userId: string;
  isRequiredLink: boolean;
}

export interface TopicUserCreateCommand {
  /** @format uuid */
  topicId: string;
  /** @format uuid */
  userId: string;
  requiredLink: boolean;
}

export interface TopicUserDeleteCommand {
  /** @format uuid */
  topicId: string;
  /** @format uuid */
  userId: string;
}

export interface TopicUserEndorsersQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  topicId: string;
  /** @format uuid */
  userId: string;
  searchText: string | null;
}

export interface TopicUsersListQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  topicId: string;
  searchText: string | null;
}

export interface TrackContentResult {
  completed: boolean;
  completeChanged: boolean;
  publicationViewed: boolean;
  mediaCompleted: boolean;
  attachOpened: boolean;
}

export type TrackContentResultIEquatable = object;

export interface TrackMediaCommand {
  /** @format uuid */
  publicationId: string;
  /** @format uuid */
  attachId: string;
  /** @format double */
  playTime: number;
}

export interface TrackMediaResponse {
  success: boolean;
  mediaCompleted: boolean;
}

export type TrackMediaResponseIEquatable = object;

export type TrackMediaResponseIRequest = object;

export interface TrackingContentCommand {
  /** @format uuid */
  enrollmentId: string;
  /** @format uuid */
  componentId: string;
  /** @format uuid */
  attachId: string;
  /** @format double */
  playTime: number;
  viewedOrFullPlayed: boolean;
}

export interface TrackingContentResponse {
  success: boolean;
  /** @format double */
  progressPercent: number | null;
  trackResult: TrackContentResult | null;
}

export type TrackingContentResponseIRequest = object;

export interface TrackingMeetingRecordingViewCommand {
  /** @format uuid */
  enrollmentId: string;
  /** @format uuid */
  componentId: string;
  /** @format double */
  playTime: number;
  fullPlayed: boolean;
}

export interface TrainingAccessTimeResult {
  canAccess: boolean;
  hasRestriction: boolean;
  /** @format date-time */
  endOfWorkDay: Date | null;
  /** @format date-time */
  nextStartWorkDay: Date | null;
  message: string | null;
}

export type TrainingAccessTimeResultIEquatable = object;

export interface TrainingActivityEnrollmentData {
  /** @format date-time */
  deliveryDate: Date | null;
  scorePending: boolean | null;
  /** @format double */
  scorePercent: number | null;
  /** @format date-time */
  correctedOn: Date | null;
  /** @format uuid */
  deliveredFileId: string | null;
  timezoneId: string;
}

export type TrainingActivityEnrollmentDataIEquatable = object;

export interface TrainingActivityItemDto {
  /** @format uuid */
  publicationId: string;
  title: string;
  content: string | null;
  author: UserShortView;
  classificationType: PublicationClassificationType;
  classificationTypeName: string;
  copyFromKnowledge: boolean;
  /** @format date-time */
  publishedOn: Date | null;
  /** @format date-time */
  editedOn: Date | null;
  /** @format date-time */
  contentModifiedDate: Date | null;
  /** @format date-time */
  createdOn: Date;
  contentLoadStatus: FeedContentLoadStatus;
  presentation: PublicationPresentation | null;
  attachs: FeedAttachDto[] | null;
  mentions: FeedMentionDto[] | null;
  interaction: TrainingPublicationInteractionDto | null;
  allowIaExplains: boolean;
  /** @format uuid */
  firstImageAttachId: string | null;
  digitalDelivery: boolean;
  /** @format int32 */
  maxFileSize: number | null;
  /** @format date-time */
  dueDate: Date | null;
  isCanceled: boolean;
  /** @format int32 */
  daysLeft: number | null;
  showDaysLeft: boolean;
  expired: boolean;
  canDownloadFile: boolean;
  canUploadFile: boolean;
  canReplaceFile: boolean;
  canDeleteFile: boolean;
  enrollmentData: TrainingActivityEnrollmentData | null;
}

export type TrainingActivityItemDtoIEquatable = object;

export type TrainingActivityItemDtoIRequest = object;

export interface TrainingAgreeCommandRequest {
  /** @format uuid */
  agreementId: string;
  /** @format uuid */
  enrollmentId: string;
  deviceInfo: string;
  timezoneId: string;
}

export type TrainingAgreementPropsRecordIEquatable = object;

export type TrainingApprovalRulesPropsRecordIEquatable = object;

export interface TrainingAssessmentItemDto {
  /** @format uuid */
  assessmentId: string;
  name: string;
  allowReview: boolean;
  scorePending: boolean;
  /** @format double */
  scorePercent: number;
  maxTriesDiscardedByUser: boolean;
  /** @format int32 */
  minFinalScore: number;
  /** @format int32 */
  weight: number;
  onlyComponentFinalScore: boolean;
  thumbnailUrl: string | null;
  /** @format int32 */
  tries: number;
  /** @format int32 */
  maxTries: number;
  /** @format date-time */
  completedOn: Date | null;
  componentCompleted: boolean;
  enrollStatus: EnrollStatus;
  /** @format uuid */
  lastInstanceId: string | null;
  allowContinueAbortedEvaluation: boolean;
  /** @format int32 */
  remaingTries: number;
  canAnswer: boolean;
  canDiscard: boolean;
}

export type TrainingAssessmentItemDtoIEquatable = object;

export type TrainingAssessmentItemDtoIRequest = object;

export interface TrainingAssessmentItemQuery {
  /** @format uuid */
  enrollmentId: string;
  /** @format uuid */
  componentId: string;
}

export interface TrainingAssessmentUsedQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  searchText: string | null;
  /** @format uuid */
  assessmentId: string;
}

export interface TrainingAudienceFeatures {
  isMandatory: boolean;
  canUserManagerDismiss: boolean;
  canManagerEnrollSubordinates: boolean;
}

export type TrainingAudienceFeaturesIEquatable = object;

export interface TrainingAudiencePreviewUsersQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  trainingId: string;
  searchText: string | null;
  needAll: boolean;
  groupIds: string[];
}

export interface TrainingAudienceQuery {
  /** @format uuid */
  trainingId: string;
}

export interface TrainingAudienceUserSuggestionsQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  trainingId: string;
  searchText: string | null;
  includeYourself: boolean;
}

export interface TrainingAudienceUsersQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  trainingId: string;
  searchText: string | null;
  onlyMandatory: boolean;
  /** @format uuid */
  classroomId: string | null;
}

export interface TrainingAutoCompleteDataModelDto {
  key: any;
  label: string;
  thumbnailUrl?: string | null;
  canDelete?: boolean | null;
  fixed?: boolean | null;
  selectable?: boolean | null;
  fromHistory?: boolean;
  approvedUsersGroup: GroupInfo;
  enrolledUsersGroup: GroupInfo;
  attendingUsersGroup: GroupInfo;
}

export type TrainingAutoCompleteDataModelDtoIEquatable = object;

export interface TrainingAutoCompleteDataModelDtoPaginatedList {
  items: TrainingAutoCompleteDataModelDto[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type TrainingAutoCompleteDataModelDtoPaginatedListIRequest = object;

export type TrainingAutoEnrollLimitsPropsRecordIEquatable = object;

export interface TrainingAwardPointsProps {
  enrollPointsEnabled: boolean;
  /** @format int32 */
  enrollPoints: number | null;
  approvalPointsEnabled: boolean;
  /** @format int32 */
  approvalPoints: number | null;
}

export type TrainingAwardPointsPropsIEquatable = object;

export type TrainingAwardRulePropsRecordIEquatable = object;

export interface TrainingBasicInfoQuery {
  /** @format uuid */
  trainingId: string;
}

export interface TrainingBasicInfoResponse {
  /** @format uuid */
  trainingId: string;
  name: string;
}

export type TrainingBasicInfoResponseIEquatable = object;

export type TrainingBasicInfoResponseIRequest = object;

export type TrainingCertificatePropsRecordIEquatable = object;

export interface TrainingCheckVersionFreezedQuery {
  /** @format uuid */
  trainingId: string;
  /** @format int32 */
  versionNumber: number;
}

export interface TrainingComponentDto {
  /** @format uuid */
  componentId: string;
  componentType: TrainingComponentType;
  title: string;
  /** @format int32 */
  displayOrder: number;
  composeFinalScore: boolean;
  usedInPreviousVersions: boolean;
  /** @format int32 */
  credits: number | null;
  /** @format uuid */
  publicationId: string | null;
  pubClassification: PublicationClassificationType | null;
  pubClassificationName: string | null;
  /** @format int64 */
  pubStorageSize: number | null;
  /** @format int64 */
  pubMediaDuration: number | null;
  allowGenerateAIQuestion: boolean | null;
  /** @format date-time */
  activityDueDate: Date | null;
  activityIsCancelled: boolean | null;
  /** @format uuid */
  assessmentId: string | null;
  assessmentIsExclusive: boolean;
  /** @format uuid */
  scoId: string | null;
  scoIsPage: boolean;
  scoIsParent: boolean;
  scoHasChildren: boolean;
  scormPlayerWindowOption: TrainingScormPlayerWindowOption | null;
  /** @format int32 */
  scormPlayerWindowWidth: number | null;
  /** @format int32 */
  scormPlayerWindowHeight: number | null;
  /** @format uuid */
  meetingId: string | null;
  meetingType: MeetingType | null;
  meetingMandatoryAttendance: boolean | null;
  meetingLocationName: string | null;
  /** @format date-time */
  meetingStartDate: Date | null;
  /** @format date-time */
  meetingEndDate: Date | null;
  meetingTimezoneId: string | null;
  meetingIsCancelled: boolean | null;
  learnPathIsMandatory: boolean | null;
  /** @format uuid */
  learnPathItemTrainingId: string | null;
  learnPathItemIsDraft: boolean | null;
  learnPathItemIsActive: boolean | null;
  learnPathItemTrainingType: TrainingType | null;
  learnPathItemIsExclusive: boolean | null;
  learnPathItemMultipleClasses: boolean | null;
  learnPathItemContentType: TrainingContentType | null;
  learnPathItemContentTypeStr: string | null;
  /** @format uuid */
  learnPathItemUniqueComponentId: string | null;
  learnPathItemUniqueHasClosedEnrollments: boolean;
  learnPathItemUniqueUsedInPreviousVersions: boolean;
}

export type TrainingComponentDtoListIRequest = object;

export interface TrainingComponentSearchDto {
  /** @format uuid */
  componentId: string;
  accessEnabled: boolean;
  /** @format uuid */
  publicationId: string;
  publicationType: PublicationType;
  title: string;
  summary: string;
  headline: string | null;
  attachs: GlobalSearchAttachDto[];
}

export type TrainingComponentSearchDtoIEquatable = object;

export interface TrainingComponentSearchDtoPaginatedList {
  items: TrainingComponentSearchDto[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type TrainingComponentSearchDtoPaginatedListIRequest = object;

export type TrainingConclusionFormPropsRecordIEquatable = object;

export interface TrainingContentSearchQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  enrollmentId: string | null;
  /** @format uuid */
  classroomId: string | null;
  searchText: string;
}

export interface TrainingContentTypeResponse {
  value: TrainingContentType;
  name: string;
}

export type TrainingContentTypeResponseIEquatable = object;

export interface TrainingContextDto {
  /** @format uuid */
  trainingId: string;
  trainingName: string;
}

export type TrainingContextDtoIEquatable = object;

export interface TrainingCopyMaterialListCommand {
  /** @format uuid */
  trainingIdFrom: string;
  /** @format uuid */
  trainingIdTo: string;
}

export interface TrainingDashboardSuggestionsQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  searchText: string | null;
  /** @format uuid */
  userId: string | null;
}

export type TrainingDiscussionPropsRecordIEquatable = object;

export interface TrainingEnrollSubordinateSelectorQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  trainingId: string;
  /** @format uuid */
  managerId: string;
  searchText: string | null;
}

export interface TrainingEvaluationComponentQuery {
  /** @format uuid */
  trainingId: string;
  /** @format uuid */
  assessmentId: string | null;
  createClone: boolean | null;
}

export type TrainingExecutionPropsRecordIEquatable = object;

export interface TrainingHeaderInfoDto {
  /** @format uuid */
  trainingId: string;
  name: string;
  contentType: TrainingContentType;
  contentTypeName: string;
  classroomName: string | null;
  thumbnailUrl: string;
  promotionVideo: FileGetDto | null;
}

export interface TrainingIndexEvolutionDto {
  /** @format date-time */
  lastProcessingDate: Date | null;
  aggregateData: TrainingIndexEvolutionItemDto[];
  nonAggregateData: TrainingIndexEvolutionItemDto[];
}

export type TrainingIndexEvolutionDtoIEquatable = object;

export interface TrainingIndexEvolutionItemDto {
  /** @format int32 */
  yearMonth: number;
  monthName: string;
  /** @format double */
  trainingIndex: number | null;
  /** @format date-time */
  lastProcessingDate: Date;
  /** @format int32 */
  totalUsers: number;
}

export type TrainingIndexEvolutionItemDtoIEquatable = object;

export interface TrainingIndexGeneralKeyTopicsListQuery {
  /** @format int32 */
  yearMonth: number;
}

export interface TrainingIndexGeneralUnitsHierarchicalQuery {
  /** @format int32 */
  yearMonth: number;
  searchText: string | null;
  /** @format uuid */
  parentId: string | null;
  orderBy: TrainingIndexOrderBy;
}

export interface TrainingIndexGeneralUnitsListQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format int32 */
  yearMonth: number;
  searchText: string;
  orderBy: TrainingIndexOrderBy;
  onlyDeleted: boolean;
}

export interface TrainingIndexGeneralUsersListQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format int32 */
  yearMonth: number;
  orderBy: TrainingIndexOrderBy;
  searchText: string | null;
}

export interface TrainingIndexSettingsResponse {
  unitTypeName: string;
  /** @format uuid */
  uniqueAccessUnitId: string | null;
  updateInProgress: boolean;
  permissions: TrainingIndexOptions[];
}

export type TrainingIndexSettingsResponseIEquatable = object;

export interface TrainingIndexTeamEvolutionQuery {
  /** @format uuid */
  managerId: string;
  /** @format uuid */
  topicId: string | null;
}

export interface TrainingIndexTeamEvolutionResponse {
  /** @format date-time */
  lastProcessingDate: Date | null;
  aggregateData: TrainingIndexEvolutionItemDto[];
  nonAggregateData: TrainingIndexEvolutionItemDto[];
  /** @format uuid */
  userId: string;
  name: string;
  thumbnailUrl: string;
  jobPosition: string | null;
  topicName: string | null;
  canViewDescendants: boolean;
}

export type TrainingIndexTeamEvolutionResponseIEquatable = object;

export type TrainingIndexTeamEvolutionResponseIRequest = object;

export interface TrainingIndexTeamKeyTopicsListQuery {
  /** @format uuid */
  managerId: string;
  /** @format int32 */
  yearMonth: number;
  allSubordinates: boolean;
}

export interface TrainingIndexTeamUsersListQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  managerId: string;
  /** @format int32 */
  yearMonth: number;
  searchText: string | null;
  allSubordinates: boolean;
  isAggregated: boolean;
  /** @format uuid */
  topicId: string | null;
}

export interface TrainingIndexTopicDto {
  /** @format uuid */
  topicId: string;
  name: string;
  /** @format double */
  trainingIndex: number;
}

export type TrainingIndexTopicDtoIEquatable = object;

export type TrainingIndexTopicDtoListIRequest = object;

export interface TrainingIndexTopicEvolutionQuery {
  /** @format uuid */
  topicId: string;
}

export interface TrainingIndexTopicEvolutionResponse {
  /** @format date-time */
  lastProcessingDate: Date | null;
  aggregateData: TrainingIndexEvolutionItemDto[];
  nonAggregateData: TrainingIndexEvolutionItemDto[];
  /** @format uuid */
  topicId: string;
  name: string;
  thumbnailUrl: string;
}

export type TrainingIndexTopicEvolutionResponseIEquatable = object;

export type TrainingIndexTopicEvolutionResponseIRequest = object;

export interface TrainingIndexTopicUnitsHierarchicalQuery {
  /** @format uuid */
  topicId: string;
  /** @format int32 */
  yearMonth: number;
  searchText: string | null;
  /** @format uuid */
  parentId: string | null;
  orderBy: TrainingIndexOrderBy;
}

export interface TrainingIndexTopicUnitsListQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  topicId: string;
  /** @format int32 */
  yearMonth: number;
  searchText: string;
  orderBy: TrainingIndexOrderBy;
}

export interface TrainingIndexTopicUsersListQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  topicId: string;
  /** @format int32 */
  yearMonth: number;
  orderBy: TrainingIndexOrderBy;
  searchText: string | null;
}

export interface TrainingIndexTrainingDto {
  /** @format uuid */
  trainingId: string;
  trainingType: TrainingType;
  name: string;
  thumbnailUrl: string;
  trainingContentType: TrainingContentType;
  trainingContentTypeName: string;
  classification: TrainingIndexTrainingClassification;
  /** @format date-time */
  finalizationDate: Date | null;
  /** @format uuid */
  enrollmentId: string | null;
  status: EnrollStatus | null;
  statusName: string | null;
  canSelfSubscribe: boolean;
  canSubscribe: boolean;
  canReview: boolean;
  canDoExempt: boolean;
}

export type TrainingIndexTrainingDtoIEquatable = object;

export interface TrainingIndexTrainingDtoPaginatedList {
  items: TrainingIndexTrainingDto[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type TrainingIndexTrainingDtoPaginatedListIRequest = object;

export interface TrainingIndexTrainingSummaryDto {
  classification: TrainingIndexTrainingClassification;
  /** @format int32 */
  trainingsCount: number;
}

export type TrainingIndexTrainingSummaryDtoIEquatable = object;

export type TrainingIndexTrainingSummaryDtoListIRequest = object;

export interface TrainingIndexUnitDto {
  /** @format uuid */
  unitId: string;
  name: string;
  /** @format double */
  trainingIndex: number | null;
  isDeleted: boolean;
}

export type TrainingIndexUnitDtoIEquatable = object;

export interface TrainingIndexUnitDtoPaginatedList {
  items: TrainingIndexUnitDto[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type TrainingIndexUnitDtoPaginatedListIRequest = object;

export interface TrainingIndexUnitEvolutionQuery {
  /** @format uuid */
  unitId: string;
  /** @format uuid */
  topicId: string | null;
}

export interface TrainingIndexUnitEvolutionResponse {
  /** @format date-time */
  lastProcessingDate: Date | null;
  aggregateData: TrainingIndexEvolutionItemDto[];
  nonAggregateData: TrainingIndexEvolutionItemDto[];
  /** @format uuid */
  unitId: string;
  name: string;
  unitTypeName: string;
  canViewDescendants: boolean;
  topicName: string | null;
}

export type TrainingIndexUnitEvolutionResponseIEquatable = object;

export type TrainingIndexUnitEvolutionResponseIRequest = object;

export interface TrainingIndexUnitHierarchicalDto {
  /** @format uuid */
  unitId: string;
  /** @format uuid */
  parentId: string | null;
  name: string;
  hasChildren: boolean;
  isDeleted: boolean;
  /** @format double */
  trainingIndex: number | null;
}

export type TrainingIndexUnitHierarchicalDtoIEquatable = object;

export interface TrainingIndexUnitKeyTopicsListQuery {
  /** @format uuid */
  unitId: string;
  /** @format int32 */
  yearMonth: number;
  isAggregated: boolean;
}

export interface TrainingIndexUnitTreeItemDto {
  /** @format uuid */
  unitId: string;
  name: string;
}

export type TrainingIndexUnitTreeItemDtoIEquatable = object;

export interface TrainingIndexUnitUsersListQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  unitId: string;
  /** @format int32 */
  yearMonth: number;
  orderBy: TrainingIndexOrderBy;
  searchText: string | null;
  includeDescendants: boolean;
  /** @format uuid */
  topicId: string | null;
}

export interface TrainingIndexUnitsHierarchicalResponse {
  items: TrainingIndexUnitHierarchicalDto[];
  treeUp: TrainingIndexUnitTreeItemDto[];
}

export type TrainingIndexUnitsHierarchicalResponseIEquatable = object;

export type TrainingIndexUnitsHierarchicalResponseIRequest = object;

export interface TrainingIndexUserDto {
  /** @format uuid */
  userId: string;
  name: string;
  displayName: string;
  thumbnailUrl: string;
  jobPosition: string | null;
  inGracePeriod: boolean;
  hasTeam: boolean;
  /** @format double */
  trainingIndex: number;
}

export type TrainingIndexUserDtoIEquatable = object;

export interface TrainingIndexUserDtoPaginatedList {
  items: TrainingIndexUserDto[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type TrainingIndexUserDtoPaginatedListIRequest = object;

export interface TrainingIndexUserEvolutionQuery {
  /** @format uuid */
  userId: string;
  /** @format uuid */
  topicId: string | null;
}

export interface TrainingIndexUserEvolutionResponse {
  /** @format date-time */
  lastProcessingDate: Date | null;
  aggregateData: TrainingIndexEvolutionItemDto[];
  nonAggregateData: TrainingIndexEvolutionItemDto[];
  /** @format uuid */
  userId: string;
  name: string;
  thumbnailUrl: string;
  jobPosition: string | null;
  topicName: string | null;
}

export type TrainingIndexUserEvolutionResponseIEquatable = object;

export type TrainingIndexUserEvolutionResponseIRequest = object;

export interface TrainingIndexUserKeyTopicsListQuery {
  /** @format uuid */
  userId: string;
  /** @format int32 */
  yearMonth: number;
}

export interface TrainingIndexUserTrainingsListQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  userId: string;
  /** @format uuid */
  topicId: string | null;
  classification: TrainingIndexTrainingClassification | null;
}

export interface TrainingIndexUserTrainingsSummaryQuery {
  /** @format uuid */
  userId: string;
  /** @format uuid */
  topicId: string | null;
}

export type TrainingInstructorActionPropsRecordIEquatable = object;

export interface TrainingInstructorSuggestionsQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  searchText: string | null;
  /** @format uuid */
  trainingId: string | null;
}

export type TrainingInteractionPropsRecordIEquatable = object;

export interface TrainingItemBase {
  /** @format uuid */
  trainingId: string;
  name: string;
}

export interface TrainingItemDto {
  /** @format uuid */
  trainingId: string;
  name: string;
  thumbnailUrl: string;
}

export type TrainingItemDtoIEquatable = object;

export interface TrainingItemDtoPaginatedList {
  items: TrainingItemDto[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type TrainingItemDtoPaginatedListIRequest = object;

export interface TrainingMaterialListItem {
  allowInstructorAddMaterial: boolean;
  allowInstructorBlockMaterial: boolean;
}

export type TrainingMaterialListItemIEquatable = object;

export interface TrainingMaterialListItemListQuery {
  /** @format uuid */
  materialListId: string;
  /** @format uuid */
  classroomId: string | null;
}

export interface TrainingMaterialListItemReorderQuery {
  /** @format uuid */
  materialListId: string;
}

export interface TrainingMaterialListItemReorderResponse {
  /** @format uuid */
  materialListItemId: string;
  title: string;
}

export type TrainingMaterialListItemReorderResponseListIRequest = object;

export interface TrainingMaterialListItemResponse {
  /** @format uuid */
  materialListId: string;
  /** @format uuid */
  materialListItemId: string;
  /** @format uuid */
  publicationId: string;
  publicationType: PublicationType;
  title: string;
  classificationType: PublicationClassificationType;
  classificationName: string;
  /** @format int64 */
  duration: number | null;
  exclusive: boolean;
  thumbnailUrl: string | null;
  blocked: boolean;
  canEdit: boolean;
  canRemove: boolean;
  canBlock: boolean;
}

export type TrainingMaterialListItemResponseListIRequest = object;

export interface TrainingMaterialListListQuery {
  /** @format uuid */
  trainingId: string;
  /** @format uuid */
  classroomId: string | null;
}

export type TrainingMaterialListPropsRecordIEquatable = object;

export interface TrainingMaterialListResponse {
  /** @format uuid */
  materialListId: string;
  /** @format uuid */
  trainingId: string;
  /** @format uuid */
  classroomId: string | null;
  name: string;
  blocked: boolean;
  canEdit: boolean;
  canBlock: boolean;
}

export type TrainingMaterialListResponseIEquatable = object;

export type TrainingMaterialListResponseListIRequest = object;

export interface TrainingMaterialListSelectorQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  searchText: string | null;
  /** @format uuid */
  trainingIdIgnore: string;
}

export interface TrainingMeetingEnrollmentData {
  registerMode: MeetingAttendanceRegisterMode | null;
  /** @format uuid */
  attendanceRegisteredBy: string | null;
  /** @format date-time */
  attendanceRegisteredOn: Date | null;
  attended: boolean | null;
  scorePending: boolean;
  /** @format double */
  scorePercent: number | null;
  /** @format date-time */
  cancelledOn: Date | null;
  cancelReason: string | null;
  /** @format int64 */
  recordingLastPosition: number | null;
  recordingFullPlayed: boolean;
  canSeekRecording: boolean;
  /** @format int32 */
  minFinalScore: number;
  classroomName: string | null;
}

export type TrainingMeetingEnrollmentDataIEquatable = object;

export interface TrainingMeetingItemDto {
  /** @format uuid */
  componentId: string;
  /** @format uuid */
  meetingId: string;
  meetingType: MeetingType;
  meetingTypeName: string;
  name: string;
  description: string | null;
  thumbnailUrl: string | null;
  mandatoryAttendance: boolean;
  assignPresenceAfterViewRecording: boolean;
  locationName: string | null;
  address: AddressModel | null;
  /** @format date-time */
  startDate: Date | null;
  /** @format date-time */
  endDate: Date | null;
  meetingOnlineLink: string | null;
  meetingOnlineLinkExpired: boolean | null;
  isInProgress: boolean;
  finished: boolean;
  isCancelled: boolean;
  timezoneId: string;
  isInstructor: boolean;
  recordingFile: FileGetDto | null;
  enrollmentData: TrainingMeetingEnrollmentData | null;
}

export type TrainingMeetingItemDtoIEquatable = object;

export type TrainingMeetingItemDtoIRequest = object;

export interface TrainingNoticeItemDto {
  /** @format uuid */
  publicationId: string;
  title: string;
  content: string | null;
  author: UserShortView;
  classificationType: PublicationClassificationType;
  classificationTypeName: string;
  copyFromKnowledge: boolean;
  /** @format date-time */
  publishedOn: Date | null;
  /** @format date-time */
  editedOn: Date | null;
  /** @format date-time */
  contentModifiedDate: Date | null;
  /** @format date-time */
  createdOn: Date;
  contentLoadStatus: FeedContentLoadStatus;
  presentation: PublicationPresentation | null;
  attachs: FeedAttachDto[] | null;
  mentions: FeedMentionDto[] | null;
  interaction: TrainingPublicationInteractionDto | null;
  allowIaExplains: boolean;
  /** @format uuid */
  firstImageAttachId: string | null;
  trainingName: string | null;
  isNew: boolean;
  /** @format int32 */
  totalRows: number;
}

export type TrainingNoticeItemDtoIEquatable = object;

export interface TrainingNoticeItemDtoPaginatedList {
  items: TrainingNoticeItemDto[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type TrainingNoticeItemDtoPaginatedListIRequest = object;

export interface TrainingPanelAnalysisQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  cacheId: string;
  /** @format uuid */
  trainingId: string | null;
  /** @format uuid */
  classroomId: string | null;
  /** @format uuid */
  topicId: string | null;
  dataset: TrainingPanelAnalyseDimension;
  drillOption: TrainingPanelDrillOption;
  orderDirection: TrainingPanelOrderDirection;
  enrollFilter: TrainingPanelEnrollFilter | null;
}

export interface TrainingPanelAssAnalysis {
  /** @format double */
  successRate: number;
}

export type TrainingPanelAssAnalysisIEquatable = object;

export interface TrainingPanelAssAnalysisPeopleListQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  cacheId: string;
  orderBy: AssAnalysisDetailsOrderBy;
}

export interface TrainingPanelAssAnalysisQuestionListQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  cacheId: string;
  orderBy: AssAnalysisDetailsOrderBy;
}

export interface TrainingPanelAssAnalysisResumeQuery {
  /** @format uuid */
  cacheId: string;
}

export interface TrainingPanelAssDeployDto {
  /** @format uuid */
  deployId: string;
  /** @format uuid */
  assessmentId: string;
  /** @format double */
  value: number | null;
  valueText: string | null;
  assessmentType: AssessmentType;
  assessmentName: string;
  trainingName: string;
}

export interface TrainingPanelAssDeployDtoPaginatedList {
  items: TrainingPanelAssDeployDto[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type TrainingPanelAssDeployDtoPaginatedListIRequest = object;

export interface TrainingPanelAssDeployUserDto {
  /** @format uuid */
  deployId: string;
  /** @format uuid */
  assessmentId: string;
  /** @format double */
  value: number | null;
  valueText: string | null;
  /** @format uuid */
  deployParticipantId: string;
  /** @format uuid */
  userId: string;
  name: string;
  thumbnailUrl: string;
  trainingName: string | null;
}

export interface TrainingPanelAssDeployUserDtoPaginatedList {
  items: TrainingPanelAssDeployUserDto[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type TrainingPanelAssDeployUserDtoPaginatedListIRequest = object;

export interface TrainingPanelAssessment {
  /** @format double */
  answeredPercent: number | null;
  /** @format double */
  reactionGradePercentAvg: number | null;
  /** @format double */
  userEfficacyGradePercentAvg: number | null;
  /** @format double */
  managerEfficacyGradePercentAvg: number | null;
  insights: TrainingPanelAssessmentInsights;
}

export type TrainingPanelAssessmentIEquatable = object;

export interface TrainingPanelAssessmentInsight {
  /** @format uuid */
  deployId: string;
  /** @format uuid */
  assessmentId: string;
  assessmentType: AssessmentType;
  assessmentName: string;
  /** @format int32 */
  totalUniqueAss: number;
  /** @format int32 */
  totalDistributed: number;
  /** @format int32 */
  totalAnswered: number;
  /** @format int32 */
  totalDeploys: number;
  /** @format int32 */
  totalNotAnswered: number;
  /** @format double */
  answeredPercent: number;
}

export type TrainingPanelAssessmentInsightIEquatable = object;

export interface TrainingPanelAssessmentInsights {
  reaction: TrainingPanelAssessmentInsight;
  userEfficacy: TrainingPanelAssessmentInsight;
  managerEfficacy: TrainingPanelAssessmentInsight;
}

export type TrainingPanelAssessmentInsightsIEquatable = object;

export interface TrainingPanelAudience {
  /** @format double */
  joinRate: number | null;
  /** @format double */
  completionRate: number | null;
  /** @format double */
  approvalRate: number | null;
}

export type TrainingPanelAudienceIEquatable = object;

export interface TrainingPanelCacheDto {
  /** @format uuid */
  cacheId: string;
  /** @format date-time */
  processingDate: Date;
  review: TrainingPanelReview;
  hasUserRestrictions: boolean;
  classroomsSelector: ClassroomSelectorDto[] | null;
  cacheRequestFilter: TraningPanelFilterRequest | null;
}

export type TrainingPanelCacheDtoIEquatable = object;

export type TrainingPanelCacheDtoIRequest = object;

export interface TrainingPanelCacheTutorDto {
  cache: TrainingPanelCacheDto;
  classroomsSelector: ClassroomSelectorDto[];
}

export type TrainingPanelCacheTutorDtoIEquatable = object;

export type TrainingPanelCacheTutorDtoIRequest = object;

export interface TrainingPanelCancelEnrollReasonDto {
  /** @format uuid */
  cancelEnrollReasonId: string | null;
  name: string | null;
  /** @format double */
  value: number;
  valueText: string;
}

export interface TrainingPanelCancelEnrollReasonDtoPaginatedList {
  items: TrainingPanelCancelEnrollReasonDto[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type TrainingPanelCancelEnrollReasonDtoPaginatedListIRequest = object;

export interface TrainingPanelCertification {
  absolute: TrainingPanelCertificationFields;
  percent: TrainingPanelCertificationFields;
  insights: TrainingPanelCertificationInsights;
}

export interface TrainingPanelCertificationFields {
  /** @format double */
  expiredShort: number;
  /** @format double */
  expiredLong: number;
  /** @format double */
  expiring: number;
  /** @format double */
  valid: number;
  /** @format double */
  total: number;
}

export type TrainingPanelCertificationFieldsIEquatable = object;

export type TrainingPanelCertificationIEquatable = object;

export interface TrainingPanelCertificationInsights {
  absolute: TrainingPanelCertificationInsightsRecertificate;
  percent: TrainingPanelCertificationInsightsRecertificate;
  /** @format int32 */
  issued: number;
  /** @format int32 */
  valid: number;
  /** @format int32 */
  expired: number;
}

export type TrainingPanelCertificationInsightsIEquatable = object;

export interface TrainingPanelCertificationInsightsRecertificate {
  /** @format double */
  recertificationInProgress: number;
}

export type TrainingPanelCertificationInsightsRecertificateIEquatable = object;

export interface TrainingPanelClassroomDto {
  /** @format double */
  value: number | null;
  valueFormat: string;
  valueText: string;
  /** @format uuid */
  classroomId: string;
  name: string;
  /** @format date-time */
  finalizedDate: Date | null;
  /** @format int32 */
  activeEnrollments: number;
}

export interface TrainingPanelClassroomDtoPaginatedList {
  items: TrainingPanelClassroomDto[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export interface TrainingPanelDrillDto {
  trainings: UtilRequiredKeys<
    TrainingPanelTrainingDtoPaginatedList,
    "items" | "totalPages" | "totalRows" | "pageNumber" | "pageSize"
  > & {
    items: TrainingPanelTrainingDto[];
    /** @format int32 */
    totalPages: number;
    /** @format int32 */
    totalRows: number;
    /** @format int32 */
    pageNumber: number;
    /** @format int32 */
    pageSize: number;
  };
  classrooms: UtilRequiredKeys<
    TrainingPanelClassroomDtoPaginatedList,
    "items" | "totalPages" | "totalRows" | "pageNumber" | "pageSize"
  > & {
    items: TrainingPanelClassroomDto[];
    /** @format int32 */
    totalPages: number;
    /** @format int32 */
    totalRows: number;
    /** @format int32 */
    pageNumber: number;
    /** @format int32 */
    pageSize: number;
  };
  enrolls: UtilRequiredKeys<
    TrainingPanelEnrollDtoPaginatedList,
    "items" | "totalPages" | "totalRows" | "pageNumber" | "pageSize"
  > & {
    items: TrainingPanelEnrollDto[];
    /** @format int32 */
    totalPages: number;
    /** @format int32 */
    totalRows: number;
    /** @format int32 */
    pageNumber: number;
    /** @format int32 */
    pageSize: number;
  };
  topics: UtilRequiredKeys<
    TrainingPanelTopicDtoPaginatedList,
    "items" | "totalPages" | "totalRows" | "pageNumber" | "pageSize"
  > & {
    items: TrainingPanelTopicDto[];
    /** @format int32 */
    totalPages: number;
    /** @format int32 */
    totalRows: number;
    /** @format int32 */
    pageNumber: number;
    /** @format int32 */
    pageSize: number;
  };
  users: UtilRequiredKeys<
    UserItemDtoPaginatedList,
    "items" | "totalPages" | "totalRows" | "pageNumber" | "pageSize"
  > & {
    items: UserItemDto[];
    /** @format int32 */
    totalPages: number;
    /** @format int32 */
    totalRows: number;
    /** @format int32 */
    pageNumber: number;
    /** @format int32 */
    pageSize: number;
  };
}

export type TrainingPanelDrillDtoIRequest = object;

export interface TrainingPanelEnrollDto {
  /** @format uuid */
  enrollmentId: string;
  /** @format uuid */
  userId: string;
  name: string;
  displayName: string;
  thumbnailUrl: string;
  status: EnrollStatus;
  statusName: string;
  /** @format date-time */
  enrolledOn: Date;
  /** @format date-time */
  firstAccess: Date | null;
  /** @format date-time */
  lastAccess: Date | null;
  /** @format date-time */
  dueDate: Date | null;
  /** @format date-time */
  executionStartDate: Date | null;
  /** @format date-time */
  finalizationDate: Date | null;
  /** @format date-time */
  effectiveExpireDate: Date | null;
  /** @format date-time */
  cancelledOn: Date | null;
  cancelledBy: string | null;
  cancelReason: string | null;
  trainingHasScore: boolean;
  /** @format double */
  progressPercent: number | null;
  /** @format double */
  scorePercent: number | null;
  /** @format double */
  preTestScore: number | null;
  /** @format timespan */
  timeSpent: string | null;
  /** @format int32 */
  timeSpentMinutes: number | null;
  isDelayed: boolean;
  mandatory: boolean;
  hasCertificate: boolean;
  userInAudience: boolean;
  /** @format uuid */
  certificateFileId: string;
  liked: boolean | null;
  /** @format int32 */
  ratingStars: number | null;
  canCancel: boolean;
  canExtraTime: boolean;
}

export interface TrainingPanelEnrollDtoPaginatedList {
  items: TrainingPanelEnrollDto[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export interface TrainingPanelEnrollFilter {
  searchText: string | null;
  advFilters: AdvCoreFilter[];
  orderBy: SupervisorEnrollmentOrderBy;
}

export interface TrainingPanelEnrollStatus {
  absolute: TrainingPanelEnrollStatusFields;
  percent: TrainingPanelEnrollStatusFields;
  insights: TrainingPanelEnrollStatusInsights;
}

export interface TrainingPanelEnrollStatusFields {
  /** @format double */
  notStart: number;
  /** @format double */
  inProgress: number;
  /** @format double */
  delayed: number;
  /** @format double */
  canceled: number;
  /** @format double */
  reproved: number;
  /** @format double */
  approved: number;
  /** @format double */
  lapsed: number;
  /** @format double */
  total: number;
}

export type TrainingPanelEnrollStatusFieldsIEquatable = object;

export type TrainingPanelEnrollStatusIEquatable = object;

export interface TrainingPanelEnrollStatusInsights {
  /** @format double */
  totalTimeViewMinutes: number;
  /** @format double */
  concludedTimeViewMinutesAvg: number;
}

export type TrainingPanelEnrollStatusInsightsIEquatable = object;

export interface TrainingPanelFinalization {
  /** @format double */
  approvalRate: number | null;
  /** @format double */
  concludedOnTimeRate: number | null;
  /** @format double */
  approvalGradeAverage: number | null;
}

export type TrainingPanelFinalizationIEquatable = object;

export interface TrainingPanelIndicatorDrillDto {
  trainings: UtilRequiredKeys<
    TrainingItemDtoPaginatedList,
    "items" | "totalPages" | "totalRows" | "pageNumber" | "pageSize"
  > & {
    items: TrainingItemDto[];
    /** @format int32 */
    totalPages: number;
    /** @format int32 */
    totalRows: number;
    /** @format int32 */
    pageNumber: number;
    /** @format int32 */
    pageSize: number;
  };
  users: UtilRequiredKeys<
    UserItemDtoPaginatedList,
    "items" | "totalPages" | "totalRows" | "pageNumber" | "pageSize"
  > & {
    items: UserItemDto[];
    /** @format int32 */
    totalPages: number;
    /** @format int32 */
    totalRows: number;
    /** @format int32 */
    pageNumber: number;
    /** @format int32 */
    pageSize: number;
  };
}

export type TrainingPanelIndicatorDrillDtoIRequest = object;

export interface TrainingPanelIndicatorDrillQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  cacheId: string;
  searchText: string | null;
  dataset: TrainingPanelIndicatorDimension;
}

export interface TrainingPanelMandatoryAudience {
  absolute: TrainingPanelMandatoryAudienceFields;
  percent: TrainingPanelMandatoryAudienceFields;
  insight: TrainingPanelMandatoryAudienceInsight;
}

export interface TrainingPanelMandatoryAudienceFields {
  /** @format double */
  hasNotEnroll: number;
  /** @format double */
  inProgress: number;
  /** @format double */
  notConcluded: number;
  /** @format double */
  concluded: number;
  /** @format double */
  exempt: number;
  /** @format double */
  lapsed: number;
  /** @format double */
  autoEnroll: number;
  /** @format double */
  totalMandatory: number;
}

export type TrainingPanelMandatoryAudienceFieldsIEquatable = object;

export type TrainingPanelMandatoryAudienceIEquatable = object;

export interface TrainingPanelMandatoryAudienceInsight {
  /** @format double */
  absolute: number;
  /** @format double */
  percent: number;
}

export type TrainingPanelMandatoryAudienceInsightIEquatable = object;

export interface TrainingPanelOpinion {
  /** @format double */
  gradeAvg: number | null;
  insights: TrainingPanelOpinionInsights;
}

export interface TrainingPanelOpinionDto {
  /** @format uuid */
  trainingId: string;
  name: string;
  thumbnailUrl: string;
  /** @format double */
  value: number;
  valueText: string;
}

export interface TrainingPanelOpinionDtoPaginatedList {
  items: TrainingPanelOpinionDto[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type TrainingPanelOpinionDtoPaginatedListIRequest = object;

export type TrainingPanelOpinionIEquatable = object;

export interface TrainingPanelOpinionInsightFields {
  /** @format int32 */
  userWrite: number;
}

export type TrainingPanelOpinionInsightFieldsIEquatable = object;

export interface TrainingPanelOpinionInsightTraining {
  trainingName: string;
  /** @format double */
  starRateAvg: number;
}

export type TrainingPanelOpinionInsightTrainingIEquatable = object;

export interface TrainingPanelOpinionInsights {
  absolute: TrainingPanelOpinionInsightFields;
  percent: TrainingPanelOpinionInsightFields;
  /** @format int32 */
  totalTrainings: number;
  /** @format int32 */
  totalTrainingsFiltered: number;
  /** @format int32 */
  totalUsers: number;
  /** @format uuid */
  uniqueTrainingId: string | null;
  better: TrainingPanelOpinionInsightTraining | null;
  worst: TrainingPanelOpinionInsightTraining | null;
}

export type TrainingPanelOpinionInsightsIEquatable = object;

export interface TrainingPanelResume {
  /** @format int32 */
  trainings: number;
  /** @format int32 */
  classrooms: number;
  /** @format int32 */
  users: number;
  /** @format int32 */
  enrolls: number;
  /** @format int32 */
  enrolledUsers: number;
  /** @format int32 */
  enrolledTrainings: number;
  uniqueTraining: TrainingItemBase | null;
  filterByUser: boolean;
  filterByTraining: boolean;
  filterByClassroom: boolean;
  filteringOneTraining: boolean;
  filteringOneUser: boolean;
  insights: TrainingPanelResumeInsights;
}

export type TrainingPanelResumeIEquatable = object;

export interface TrainingPanelResumeInsights {
  absolute: TrainingPanelResumeInsightsFields;
  percent: TrainingPanelResumeInsightsFields;
  /** @format int32 */
  totalTrainingsAcceptingEnroll: number;
  classroomInfo: TrainingPanelResumeInsightsClassroomInfo | null;
}

export interface TrainingPanelResumeInsightsClassroomInfo {
  /** @format date-time */
  minStartDate: Date | null;
  /** @format date-time */
  maxStartDate: Date | null;
}

export type TrainingPanelResumeInsightsClassroomInfoIEquatable = object;

export interface TrainingPanelResumeInsightsFields {
  /** @format double */
  mandatoryTraining: number;
  /** @format double */
  ownUserEnroll: number;
  /** @format int32 */
  total: number;
}

export type TrainingPanelResumeInsightsFieldsIEquatable = object;

export type TrainingPanelResumeInsightsIEquatable = object;

export interface TrainingPanelReview {
  resume: TrainingPanelResume;
  audience: TrainingPanelAudience;
  mandatoryAudience: TrainingPanelMandatoryAudience;
  finalization: TrainingPanelFinalization;
  status: TrainingPanelEnrollStatus;
  certification: TrainingPanelCertification;
  assessment: TrainingPanelAssessment;
  opinion: TrainingPanelOpinion;
  tutorStatistics: TrainingPanelTutorStatistics | null;
  assAnalysis: TrainingPanelAssAnalysis;
}

export type TrainingPanelReviewIEquatable = object;

export interface TrainingPanelSeeAlsoQuery {
  /** @format uuid */
  trainingId: string;
}

export interface TrainingPanelSeeAlsoResponse {
  /** @format uuid */
  trainingId: string;
  name: string;
  contentType: string;
}

export type TrainingPanelSeeAlsoResponseListIRequest = object;

export interface TrainingPanelSpecialistsQuery {
  /** @format uuid */
  trainingId: string;
}

export interface TrainingPanelTopicDto {
  /** @format double */
  value: number | null;
  valueFormat: string;
  valueText: string;
  /** @format uuid */
  topicId: string;
  name: string;
  thumbnailUrl: string;
  /** @format int32 */
  totalTrainings: number;
  /** @format int32 */
  totalClassrooms: number;
}

export interface TrainingPanelTopicDtoPaginatedList {
  items: TrainingPanelTopicDto[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export interface TrainingPanelTopicQuery {
  /** @format uuid */
  trainingId: string;
}

export interface TrainingPanelTopicResponse {
  /** @format uuid */
  topicId: string;
  name: string;
  /** @format int64 */
  publicationCount: number | null;
}

export type TrainingPanelTopicResponseIEquatable = object;

export type TrainingPanelTopicResponseListIRequest = object;

export interface TrainingPanelTrainingDto {
  /** @format double */
  value: number | null;
  valueFormat: string;
  valueText: string;
  /** @format uuid */
  trainingId: string;
  name: string;
  thumbnailUrl: string;
  trainingType: TrainingType;
  trainingTypeName: string;
  contentType: TrainingContentType;
  contentTypeName: string;
  /** @format int32 */
  totalClassrooms: number;
}

export interface TrainingPanelTrainingDtoPaginatedList {
  items: TrainingPanelTrainingDto[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export interface TrainingPanelTutorStatistics {
  finalizedOnly: TrainingPanelTutorStatisticsData;
  all: TrainingPanelTutorStatisticsData;
}

export interface TrainingPanelTutorStatisticsComponent {
  /** @format uuid */
  componentId: string;
  title: string;
  hasGrade: boolean;
  conclusion: number[];
  grade: number[];
  /** @format int64 */
  totalConclusion: number;
  /** @format int64 */
  totalGrade: number;
  conclusionPercent: number[];
  gradePercent: number[];
}

export type TrainingPanelTutorStatisticsComponentIEquatable = object;

export interface TrainingPanelTutorStatisticsData {
  /** @format int32 */
  totalEnrolls: number;
  progress: number[];
  grade: number[];
  /** @format int64 */
  totalProgress: number;
  /** @format int64 */
  totalGrade: number;
  progressPercent: number[];
  gradePercent: number[];
  components: TrainingPanelTutorStatisticsComponent[];
}

export type TrainingPanelTutorStatisticsDataIEquatable = object;

export type TrainingPanelTutorStatisticsIEquatable = object;

export interface TrainingPostEnrollmentData {
  /** @format int64 */
  publicationTimeViewed: number | null;
  disableMediaSeek: boolean;
  /** @format double */
  completeOnMinTime: number | null;
  completeOnFullMediaPlayed: boolean;
  completeOnAttachOpened: boolean;
}

export type TrainingPostEnrollmentDataIEquatable = object;

export interface TrainingPostItemDto {
  /** @format uuid */
  publicationId: string;
  title: string;
  content: string | null;
  author: UserShortView;
  classificationType: PublicationClassificationType;
  classificationTypeName: string;
  copyFromKnowledge: boolean;
  /** @format date-time */
  publishedOn: Date | null;
  /** @format date-time */
  editedOn: Date | null;
  /** @format date-time */
  contentModifiedDate: Date | null;
  /** @format date-time */
  createdOn: Date;
  contentLoadStatus: FeedContentLoadStatus;
  presentation: PublicationPresentation | null;
  attachs: FeedAttachDto[] | null;
  mentions: FeedMentionDto[] | null;
  interaction: TrainingPublicationInteractionDto | null;
  allowIaExplains: boolean;
  /** @format uuid */
  firstImageAttachId: string | null;
  enrollmentData: TrainingPostEnrollmentData | null;
}

export type TrainingPostItemDtoIEquatable = object;

export type TrainingPostItemDtoIRequest = object;

export interface TrainingPreReqOptionSelectorResponse {
  option: TrainingPreRequisiteOption;
  name: string;
}

export type TrainingPreReqOptionSelectorResponseIEquatable = object;

export interface TrainingPreRequisiteDto {
  /** @format uuid */
  requisiteTrainingId: string;
  requisiteTrainingName: string;
  allowEquivalents: boolean;
  requisiteTrainingStatus: TrainingPreRequisiteOption;
  requisiteTrainingStatusName: string;
}

export interface TrainingPreRequisiteItem {
  /** @format uuid */
  requisiteTrainingId: string;
  allowEquivalents: boolean;
  requisiteTrainingStatus: TrainingPreRequisiteOption;
}

export interface TrainingPreviewQuery {
  /** @format uuid */
  trainingId: string;
  /** @format uuid */
  classroomId: string | null;
}

export interface TrainingPublicationInteractionDto {
  hasLiked: boolean;
  /** @format int32 */
  likeCount: number;
  allowLike: boolean;
  /** @format int32 */
  viewCount: number;
}

export type TrainingPublicationInteractionDtoIEquatable = object;

export interface TrainingPublicationItemDto {
  /** @format uuid */
  publicationId: string;
  title: string;
  content: string | null;
  author: UserShortView;
  classificationType: PublicationClassificationType;
  classificationTypeName: string;
  copyFromKnowledge: boolean;
  /** @format date-time */
  publishedOn: Date | null;
  /** @format date-time */
  editedOn: Date | null;
  /** @format date-time */
  contentModifiedDate: Date | null;
  /** @format date-time */
  createdOn: Date;
  contentLoadStatus: FeedContentLoadStatus;
  presentation: PublicationPresentation | null;
  attachs: FeedAttachDto[] | null;
  mentions: FeedMentionDto[] | null;
  interaction: TrainingPublicationInteractionDto | null;
  allowIaExplains: boolean;
  /** @format uuid */
  firstImageAttachId: string | null;
}

export type TrainingPublicationItemDtoIEquatable = object;

export interface TrainingRatingItemResponse {
  /** @format uuid */
  enrollmentId: string;
  /** @format uuid */
  userId: string;
  name: string;
  thumbnailUrl: string | null;
  /** @format int32 */
  ratingStars: number;
  ratingComment: string | null;
  /** @format date-time */
  publishedOn: Date;
  canDelete: boolean;
}

export type TrainingRatingItemResponseIEquatable = object;

export interface TrainingRatingItemResponsePaginatedList {
  items: TrainingRatingItemResponse[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export interface TrainingRatingsResponse {
  /** @format double */
  ratingAvg: number;
  data: UtilRequiredKeys<
    TrainingRatingItemResponsePaginatedList,
    "items" | "totalPages" | "totalRows" | "pageNumber" | "pageSize"
  > & {
    items: TrainingRatingItemResponse[];
    /** @format int32 */
    totalPages: number;
    /** @format int32 */
    totalRows: number;
    /** @format int32 */
    pageNumber: number;
    /** @format int32 */
    pageSize: number;
  };
}

export type TrainingRatingsResponseIEquatable = object;

export type TrainingRegistrationPropsRecordIEquatable = object;

export interface TrainingRelationshipSelectorQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  searchText: string | null;
  /** @format uuid */
  exceptTrainingId: string | null;
  trainingType: TrainingType | null;
  orderBy?: TrainingRelationshipSelectorOrderBy | null;
}

export interface TrainingRulesAgreementDto {
  allowOverride: boolean;
  enableTrainingAgreement: boolean;
  canCreateExclusiveAgreement: boolean;
  trainingAgreement: AgreementDto | null;
  isExclusive: boolean;
}

export type TrainingRulesAgreementDtoIRequest = object;

export interface TrainingRulesAgreementItem {
  enableTrainingAgreement: boolean;
  /** @format uuid */
  trainingAgreementId: string | null;
  trainingAgreementText: string | null;
}

export type TrainingRulesAgreementItemIEquatable = object;

export interface TrainingRulesApprovalRulesDto {
  /** @format int32 */
  minProgress: number;
  /** @format int32 */
  minFinalScore: number;
  studentCanFinishEnroll: boolean;
  autoEnrollFinish: boolean;
  autoEnrollFinishIgnoreEvalTries: boolean;
  hasFinalScoreCalculation: boolean;
  dueAnyDate: boolean;
}

export type TrainingRulesApprovalRulesDtoIRequest = object;

export interface TrainingRulesApprovalRulesItem {
  /** @format int32 */
  minProgress: number;
  /** @format int32 */
  minFinalScore: number;
  studentCanFinishEnroll: boolean;
  autoEnrollFinish: boolean;
  autoEnrollFinishIgnoreEvalTries: boolean | null;
}

export type TrainingRulesApprovalRulesItemIEquatable = object;

export interface TrainingRulesAssessmentDto {
  applyReaction: boolean;
  reactionAssessment: AssessmentSelectorDto | null;
  /** @format int32 */
  reactionAssessmentDaysAfterFinalization: number | null;
  applyUserEfficacy: boolean;
  userEfficacyAssessment: AssessmentSelectorDto | null;
  userEfficacyAssessmentType: AssessmentType;
  /** @format int32 */
  userEfficacyAssessmentDaysAfterFinalization: number | null;
  applyManagerEfficacy: boolean;
  managerEfficacyAssessment: AssessmentSelectorDto | null;
  /** @format int32 */
  managerEfficacyAssessmentDaysAfterFinalization: number | null;
}

export type TrainingRulesAssessmentDtoIRequest = object;

export interface TrainingRulesAssessmentItemDto {
  /** @format uuid */
  reactionAssessmentId: string | null;
  /** @format int32 */
  reactionAssessmentDaysAfterFinalization: number;
  /** @format uuid */
  userEfficacyAssessmentId: string | null;
  /** @format int32 */
  userEfficacyAssessmentDaysAfterFinalization: number;
  /** @format uuid */
  managerEfficacyAssessmentId: string | null;
  /** @format int32 */
  managerEfficacyAssessmentDaysAfterFinalization: number;
}

export interface TrainingRulesAutoEnrollLimitsDto {
  /** @format int32 */
  maxTries: number | null;
  /** @format int32 */
  retryIntervalDays: number | null;
  denyIfCertificateValid: boolean;
}

export type TrainingRulesAutoEnrollLimitsDtoIRequest = object;

export interface TrainingRulesAutoEnrollLimitsItem {
  /** @format int32 */
  maxTries: number | null;
  /** @format int32 */
  retryIntervalDays: number | null;
  denyIfCertificateValid: boolean;
}

export type TrainingRulesAutoEnrollLimitsItemIEquatable = object;

export interface TrainingRulesAwardDto {
  mandatoryAudience: TrainingAwardPointsProps;
  optionalAudience: TrainingAwardPointsProps | null;
  sameAwardsAllAudiences: boolean;
}

export type TrainingRulesAwardDtoIRequest = object;

export interface TrainingRulesAwardItem {
  mandatoryAudience: TrainingAwardPointsProps;
  optionalAudience: TrainingAwardPointsProps | null;
  sameAwardsAllAudiences: boolean;
}

export type TrainingRulesAwardItemIEquatable = object;

export interface TrainingRulesCertificateDto {
  enableTrainingValidity: boolean;
  /** @format int32 */
  trainingValidityMonthDay: number | null;
  /** @format int32 */
  trainingValidityDays: number | null;
  computeValidityDaysFromLastCertification: boolean;
  /** @format int32 */
  renovationWindowDays: number | null;
  generateCertificate: boolean;
  certificateFile: FileGetDto | null;
}

export type TrainingRulesCertificateDtoIRequest = object;

export interface TrainingRulesCertificateItem {
  enableTrainingValidity: boolean;
  /** @format int32 */
  trainingValidityMonthDay: number | null;
  /** @format int32 */
  trainingValidityDays: number | null;
  computeValidityDaysFromLastCertification: boolean;
  /** @format int32 */
  renovationWindowDays: number | null;
  generateCertificate: boolean;
  /** @format uuid */
  certificateFileId: string | null;
}

export type TrainingRulesCertificateItemIEquatable = object;

export interface TrainingRulesConclusionFormDto {
  institutionOrProvider: TrainingThreeStateInfo;
  institutionOrProviderOptions: string[] | null;
  certificate: TrainingThreeStateInfo;
  coursePeriod: TrainingThreeStateInfo;
  courseDuration: TrainingThreeStateInfo;
  attendancePercent: TrainingThreeStateInfo;
  finalScore: TrainingThreeStateInfo;
  finalScoreIsPercent: boolean | null;
  /** @format double */
  finalScoreMin: number | null;
  /** @format double */
  finalScoreMax: number | null;
  pricePaid: TrainingThreeStateInfo;
  approvalOption: TrainingExternalCourseApprovalOption;
  approver: AutoCompleteDataModelDto | null;
}

export type TrainingRulesConclusionFormDtoIRequest = object;

export interface TrainingRulesConclusionFormItem {
  institutionOrProvider: TrainingThreeStateInfo;
  coursePeriod: TrainingThreeStateInfo;
  courseDuration: TrainingThreeStateInfo;
  attendancePercent: TrainingThreeStateInfo;
  finalScore: TrainingThreeStateInfo;
  pricePaid: TrainingThreeStateInfo;
  certificate: TrainingThreeStateInfo;
  approvalOption: TrainingExternalCourseApprovalOption;
  institutionOrProviderOptions: string[] | null;
  finalScoreIsPercent: boolean | null;
  /** @format double */
  finalScoreMin: number | null;
  /** @format double */
  finalScoreMax: number | null;
  /** @format uuid */
  approverId: string | null;
}

export type TrainingRulesConclusionFormItemIEquatable = object;

export interface TrainingRulesDiscussionItem {
  enableDiscussion: boolean;
  allowPrivateMessageOnly: boolean | null;
  continueInteractionAfterFinalization: boolean | null;
  /** @format int32 */
  continueInteractionAfterFinalizationDays: number | null;
  ratingOption: TrainingRatingOption;
}

export type TrainingRulesDiscussionItemIEquatable = object;

export interface TrainingRulesExecutionDto {
  /** @format date-time */
  startDate: Date | null;
  dueDateOption: TrainingDueDateOption;
  /** @format date-time */
  dueDate: Date | null;
  /** @format int32 */
  dueDays: number | null;
  /** @format int32 */
  expireDaysAfterDueDate: number | null;
  allowTrainingReview: boolean;
  /** @format int32 */
  reviewDaysLimit: number | null;
  afterApprovalRegisterOnTrainingId: AutoCompleteDataModelDto | null;
  accessOnlyOnCorporateNetwork: boolean;
}

export type TrainingRulesExecutionDtoIRequest = object;

export interface TrainingRulesExecutionItem {
  /** @format date-time */
  startDate: Date | null;
  dueDateOption: TrainingDueDateOption;
  /** @format date-time */
  dueDate: Date | null;
  /** @format int32 */
  dueDays: number | null;
  /** @format int32 */
  expireDaysAfterDueDate: number | null;
  allowTrainingReview: boolean;
  /** @format int32 */
  reviewDaysLimit: number | null;
  /** @format uuid */
  afterApprovalRegisterOnTrainingId: string | null;
  accessOnlyOnCorporateNetwork: boolean;
}

export type TrainingRulesExecutionItemIEquatable = object;

export interface TrainingRulesInstructorActionDto {
  canModifyEventAndActivity: boolean;
  canCancelEventAndActivity: boolean;
  canExtendDueDate: boolean;
  canCancelEnrollment: boolean;
}

export type TrainingRulesInstructorActionDtoIRequest = object;

export interface TrainingRulesInstructorActionItem {
  canModifyEventAndActivity: boolean;
  canCancelEventAndActivity: boolean;
  canExtendDueDate: boolean;
  canCancelEnrollment: boolean;
}

export type TrainingRulesInstructorActionItemIEquatable = object;

export interface TrainingRulesInteractionDto {
  enableLike: boolean;
  shareOption: TrainingShareOption;
  enableViewEnrolledUsers: boolean;
  enableShareInChannelAndLists: boolean;
  enableDiscussion: boolean;
  allowPrivateMessageOnly: boolean | null;
  continueInteractionAfterFinalization: boolean | null;
  /** @format int32 */
  continueInteractionAfterFinalizationDays: number | null;
  ratingOption: TrainingRatingOption;
}

export type TrainingRulesInteractionDtoIRequest = object;

export interface TrainingRulesInteractionItem {
  enableLike: boolean;
  shareOption: TrainingShareOption;
  enableViewEnrolledUsers: boolean;
  enableShareInChannelAndLists: boolean;
}

export type TrainingRulesInteractionItemIEquatable = object;

export interface TrainingRulesPreRequisitesDto {
  preRequisites: TrainingPreRequisiteDto[];
  /** @format int32 */
  total: number;
}

export type TrainingRulesPreRequisitesDtoIRequest = object;

export interface TrainingRulesPreRequisitesItem {
  preRequisites: TrainingPreRequisiteItem[];
}

export interface TrainingRulesRegistrationDto {
  /** @format date-time */
  enrollAvailableFrom: Date | null;
  /** @format date-time */
  enrollAvailableUntil: Date | null;
  enrollAvailableExpired: boolean;
  enrollSuspended: boolean;
  oneClickEnroll: boolean;
  preApprovalByUserManagerOrApprover: boolean;
  /** @format uuid */
  trainingApproverId: string | null;
  requiredApprovalWhenEnrolledByManager: boolean;
  cancellationOption: TrainingCancellationOption;
  /** @format date-time */
  cancellationUntilDate: Date | null;
  /** @format int32 */
  cancellationUntilDaysAfterEnroll: number | null;
  allowCancellationIfEnrolledByManager: boolean;
  trainingApprover: AutoCompleteDataModelDto | null;
  /** @format date-time */
  maxCancellationDate: Date | null;
}

export type TrainingRulesRegistrationDtoIRequest = object;

export interface TrainingRulesRegistrationItem {
  /** @format date-time */
  enrollAvailableFrom: Date | null;
  /** @format date-time */
  enrollAvailableUntil: Date | null;
  enrollSuspended: boolean;
  oneClickEnroll: boolean;
  preApprovalByUserManagerOrApprover: boolean;
  /** @format uuid */
  trainingApproverId: string | null;
  requiredApprovalWhenEnrolledByManager: boolean;
  cancellationOption: TrainingCancellationOption;
  /** @format date-time */
  cancellationUntilDate: Date | null;
  /** @format int32 */
  cancellationUntilDaysAfterEnroll: number | null;
  allowCancellationIfEnrolledByManager: boolean;
}

export type TrainingRulesRegistrationItemIEquatable = object;

export interface TrainingRulesSeatsDto {
  isTemplate: boolean;
  /** @format int32 */
  seats: number | null;
  /** @format int32 */
  minAllocatedSeats: number;
  seatsReserved: TrainingSeatsDto[];
  /** @format int32 */
  totalSeatsReserved: number;
  /** @format int32 */
  allocateWithoutReservation: number | null;
}

export type TrainingRulesSeatsDtoIRequest = object;

export interface TrainingRulesSeatsItem {
  seatsReserved: TrainingSeatsItem[];
  /** @format int32 */
  seats: number | null;
}

export type TrainingSearchActionDtoIEquatable = object;

export interface TrainingSearchDto {
  actions: CardAction[];
  data: Record<string, any>;
  /** @format uuid */
  trainingId: string;
  trainingType: TrainingType;
  contentType: TrainingContentType;
  trainingTypeName: string;
  contentTypeName: string;
  thumbnailUrl: string;
  name: string;
  summary: string | null;
  /** @format int32 */
  trainingDurationMinutes: number;
}

export type TrainingSearchDtoIEquatable = object;

export interface TrainingSearchDtoPaginatedList {
  items: TrainingSearchDto[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export interface TrainingSearchFilters {
  trainingContentType: TrainingContentType | null;
  duration: TrainingSearchDuration | null;
  publication: TrainingSearchPublication | null;
  /** @format date-time */
  publicationStart: Date | null;
  /** @format date-time */
  publicationEnd: Date | null;
  start: TrainingSearchStart | null;
  /** @format date-time */
  trainingStart: Date | null;
  /** @format date-time */
  trainingEnd: Date | null;
  restriction: TrainingSearchRestriction | null;
}

export type TrainingSearchFiltersIEquatable = object;

export interface TrainingSearchQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  searchText: string;
  filters: TrainingSearchFilters;
  orderBy: GlobalSearchOrderBy;
  relevanceEnabled: boolean;
}

export interface TrainingSearchResponse {
  traningSearchResult: UtilRequiredKeys<
    TrainingSearchDtoPaginatedList,
    "items" | "totalPages" | "totalRows" | "pageNumber" | "pageSize"
  > & {
    items: TrainingSearchDto[];
    /** @format int32 */
    totalPages: number;
    /** @format int32 */
    totalRows: number;
    /** @format int32 */
    pageNumber: number;
    /** @format int32 */
    pageSize: number;
  };
  relevanceEnabled: boolean;
}

export type TrainingSearchResponseIEquatable = object;

export type TrainingSearchResponseIRequest = object;

export interface TrainingSeatsDto {
  /** @format uuid */
  groupId: string;
  groupType: GroupType;
  groupName: string;
  /** @format int32 */
  seatsReserved: number;
  /** @format int32 */
  seatsUsed: number | null;
  /** @format int32 */
  seatsLeft: number | null;
  /** @format int32 */
  allocationPriority: number;
}

export interface TrainingSeatsItem {
  /** @format uuid */
  groupId: string;
  /** @format int32 */
  seatsReserved: number;
  /** @format int32 */
  allocationPriority: number;
}

export interface TrainingSelectorDto {
  /** @format uuid */
  trainingId: string;
  name: string;
  thumbnailUrl: string | null;
  contentType: TrainingContentType;
  selected: boolean;
}

export type TrainingSelectorDtoIEquatable = object;

export interface TrainingSelectorDtoPaginatedList {
  items: TrainingSelectorDto[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type TrainingSelectorDtoPaginatedListIRequest = object;

export interface TrainingSelectorQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  searchText: string | null;
  /** @format uuid */
  exceptTrainingId: string | null;
  trainingType: TrainingType | null;
  onlyManage: boolean;
}

export interface TrainingSpecialistResponse {
  /** @format uuid */
  userId: string;
  name: string;
  thumbnailUrl: string | null;
  unitName: string | null;
}

export type TrainingSpecialistResponseIEquatable = object;

export type TrainingSpecialistResponseListIRequest = object;

export interface TrainingSuggestionsQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  searchText: string | null;
  trainingType: TrainingType | null;
  /** @format uuid */
  exceptTrainingId: string | null;
  onlyActive: boolean;
  onlyWithUserAttending: boolean;
  isManageView: boolean;
  isCoordinator: boolean;
}

export interface TrainingUserInteractionCommand {
  /** @format uuid */
  trainingId: string;
  option: TrainingUserInteractionOption;
}

export interface TrainingUserInterestResponse {
  /** @format uuid */
  userId: string;
  name: string;
  /** @format uuid */
  thumbnailId: string | null;
  thumbnailUrl: string;
  /** @format date-time */
  createdOn: Date;
}

export type TrainingUserInterestResponseIEquatable = object;

export interface TrainingUserInterestResponsePaginatedList {
  items: TrainingUserInterestResponse[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type TrainingUserInterestResponsePaginatedListIRequest = object;

export interface TrainingUsersInterestQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  trainingId: string;
  searchText: string | null;
}

export interface TrainingVersionComponentSuggestionsQuery {
  /** @format uuid */
  trainingId: string;
  /** @format int32 */
  versionNumber: number;
  searchText: string | null;
  /** @format uuid */
  excludeComponentId: string | null;
}

export interface TrainingVersionDto {
  isCurrent: boolean;
  /** @format int32 */
  versionNumber: number;
  /** @format date-time */
  publishedOn: Date | null;
  /** @format date-time */
  publishedUntil: Date | null;
  canEditDraft: boolean;
  scormManifestIdentifier: string | null;
  scormOrganizationIdentifier: string | null;
  scormUsedInPreviousVersion: boolean;
  forceCreateNewScormPackage: boolean;
  /** @format int32 */
  totalFinishedEnrolls: number;
  /** @format int32 */
  totalActiveEnrolls: number | null;
  isDraft: boolean;
  isFreezed: boolean;
  inUse: boolean;
  readOnly: boolean;
  allowCreateNewComponentVersion: boolean;
  containsScorm: boolean;
  lastDrafter: AppUserView | null;
  recordInfo: RecordInfoDto;
  reenrollFromPreviousVersion: boolean;
}

export type TrainingVersionDtoIEquatable = object;

export type TrainingVersionDtoIRequest = object;

export type TrainingVersionDtoListIRequest = object;

export interface TrainingVersionsQuery {
  /** @format uuid */
  trainingId: string;
}

export interface TrainingViewDto {
  /** @format uuid */
  trainingId: string;
  trainingType: TrainingType;
  trainingTypeName: string;
  contentType: TrainingContentType;
  contentTypeName: string;
  name: string;
  description: string | null;
  objectives: string | null;
  author: string | null;
  language: string | null;
  thumbnailUrl: string | null;
  promotionVideoThumbnailUrl: string | null;
  promotionVideo: FileGetDto | null;
  hasAudienceDefined: boolean;
  /** @format int32 */
  likeCount: number;
  liked: boolean;
  bookmarked: boolean;
  /** @format int32 */
  availableClassroomCount: number;
  multipleClasses: boolean;
  /** @format int32 */
  trainingDurationMinutes: number;
  trainingDurationFormated: string;
  /** @format date-time */
  registrationEnrollAvailableFrom: Date | null;
  /** @format date-time */
  registrationEnrollAvailableUntil: Date | null;
  registrationOneClickEnroll: boolean;
  registrationCancellationOption: TrainingCancellationOption;
  /** @format date-time */
  registrationCancellationUntilDate: Date | null;
  /** @format int32 */
  registrationCancellationUntilDaysAfterEnroll: number | null;
  registrationPreApprovalByUserManagerOrApprover: boolean | null;
  /** @format date-time */
  executionStartDate: Date | null;
  executionDueDateOption: TrainingDueDateOption;
  /** @format date-time */
  executionDueDate: Date | null;
  /** @format int32 */
  executionDueDays: number | null;
  /** @format uuid */
  nextTrainingId: string | null;
  nextTrainingName: string | null;
  generateCertificate: boolean;
  /** @format uuid */
  certificateFileId: string | null;
  certificateEnableTrainingValidity: boolean | null;
  /** @format int32 */
  certificateTrainingValidityMonthDay: number | null;
  /** @format int32 */
  certificateTrainingValidityDays: number | null;
  certificateComputeValidityDaysFromLastCertification: boolean | null;
  /** @format int32 */
  certificateRenovationWindowDays: number | null;
  ratingOption: TrainingRatingOption;
  shareOption: TrainingShareOption;
  enableLike: boolean;
  enableViewEnrolledUsers: boolean;
  enableShareInChannelAndLists: boolean;
  fullManaged: boolean;
  isMandatory: boolean;
  /** @format int32 */
  awardEnrollPoints: number | null;
  /** @format int32 */
  awardApprovalPoints: number | null;
  /** @format double */
  ratingAvg: number;
  /** @format int32 */
  ratingStars: number;
  /** @format int32 */
  ratingCount: number;
  /** @format int32 */
  activeEnrollmentsCount: number;
  /** @format int32 */
  usersEnrolledCount: number;
  approvers: UserShortView[] | null;
  instructors: UserShortView[] | null;
  /** @format date-time */
  publishedOn: Date | null;
  /** @format date-time */
  modifiedOn: Date | null;
  hasSubordinatesEnabled: boolean;
}

export type TrainingViewDtoIRequest = object;

export interface TrainingViewQuery {
  /** @format uuid */
  trainingId: string;
  incrementTrainingViewCounter: boolean | null;
}

export interface TraningPanelAssDeploySelectionQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  cacheId: string;
  searchText: string | null;
  dataset: TraininPanelAssDataset;
}

export interface TraningPanelAssDeployUserSelectionQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  cacheId: string;
  /** @format uuid */
  deployId: string;
  /** @format uuid */
  assessmentId: string;
  searchText: string | null;
  dataset: TraininPanelAssDataset;
}

export interface TraningPanelAssDeployUsersQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  cacheId: string;
  searchText: string | null;
  dataset: TraininPanelAssDataset;
  answered: boolean;
}

export interface TraningPanelAudienceNotEnrolledUsersQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  cacheId: string;
  searchText: string | null;
  mandatory: boolean;
  /** @format uuid */
  trainingId?: string | null;
}

export interface TraningPanelCanceledEnrollsByReasonQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  cacheId: string;
  searchText: string | null;
}

export interface TraningPanelFilterRequest {
  filters: AdvCoreFilter[];
  searchText: string | null;
}

export interface TraningPanelGetOrCreateCacheCommand {
  filters: AdvCoreFilter[];
  searchText: string | null;
  panelType: TrainingPanelType;
  forceUpdate: boolean;
}

export interface TraningPanelGetOrCreateCacheTutorCommand {
  /** @format uuid */
  trainingId: string;
  /** @format uuid */
  classroomId: string | null;
  viewMode: SupervisorTrainingsQueryMode;
  filters: AdvCoreFilter[];
  searchText: string | null;
}

export interface TraningPanelOpinionSelectionQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  cacheId: string;
  searchText: string | null;
}

export interface TraningPanelSupervisorStatisticsUsersQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  cacheId: string;
  searchText: string | null;
  finalizedOnly: boolean;
  chart: SupervisorStatisticsChart;
  /** @format int32 */
  datasetIndex: number;
  /** @format uuid */
  componentId: string | null;
}

export interface TransferTrainingRulesToOpenedClassroomsCommand {
  /** @format uuid */
  trainingId: string;
  target: ClassroomTargetRule;
}

export type TwoFactorEmailValidationResultIRequest = object;

export interface TwoFactorOptions {
  emailAuthenticatorEnabled: boolean;
  appAuthenticatorEnabled: boolean;
  allowSkipAppAuthenticator: boolean;
}

export type TwoFactorOptionsIEquatable = object;

export interface UnarchiveDevPlanCommand {
  /** @format uuid */
  devPlanId: string;
}

export interface UnblockPublicationCommand {
  /** @format uuid */
  publicationId: string;
}

export interface UnitAutoCompleteDataModelDto {
  key: any;
  label: string;
  thumbnailUrl?: string | null;
  canDelete?: boolean | null;
  fixed?: boolean | null;
  selectable?: boolean | null;
  fromHistory?: boolean;
  /** @format uuid */
  unitTypeId: string;
  unitTypeName: string;
  usersGroup: GroupInfo;
  allUsersGroup: GroupInfo;
  includeDescendants: boolean;
}

export type UnitAutoCompleteDataModelDtoIEquatable = object;

export interface UnitAutoCompleteDataModelDtoPaginatedList {
  items: UnitAutoCompleteDataModelDto[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type UnitAutoCompleteDataModelDtoPaginatedListIRequest = object;

export interface UnitAutoCompleteHierarchicalModelDto {
  key: any;
  label: string;
  thumbnailUrl?: string | null;
  canDelete?: boolean | null;
  fixed?: boolean | null;
  selectable?: boolean | null;
  fromHistory?: boolean;
  includeDescendants: boolean;
  hasChild: boolean;
  allowAssociates: boolean;
  tooltip: string | null;
  tree: AutoCompleteHierarchicalTreeModelDto[];
  /** @format uuid */
  unitTypeId: string;
  unitTypeName: string;
  usersGroup: GroupInfo;
  allUsersGroup: GroupInfo;
}

export type UnitAutoCompleteHierarchicalModelDtoIEquatable = object;

export interface UnitAutoCompleteHierarchicalModelDtoPaginatedList {
  items: UnitAutoCompleteHierarchicalModelDto[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type UnitAutoCompleteHierarchicalModelDtoPaginatedListIRequest = object;

export interface UnitContainsDescQuery {
  /** @format uuid */
  parentId: string;
  /** @format uuid */
  unitId: string;
}

export interface UnitItemDto {
  /** @format uuid */
  unitId: string;
  name: string;
  /** @format uuid */
  unitTypeId: string;
  unitTypeName: string;
}

export type UnitItemDtoIEquatable = object;

export interface UnitItemDtoPaginatedList {
  items: UnitItemDto[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type UnitItemDtoPaginatedListIRequest = object;

export interface UnitSelectionTreeResponse {
  /** @format uuid */
  unitId: string;
  /** @format uuid */
  parentId: string | null;
  name: string;
  /** @format uuid */
  unitTypeId: string;
  unitTypeName: string;
  enabled: boolean;
  allowAssociates: boolean;
  hasChildren: boolean;
  matchText: boolean;
  expanded: boolean;
  /** @format uuid */
  usersGroupId: string | null;
  usersGroupType: GroupType | null;
  usersGroupName: string | null;
  /** @format uuid */
  allUsersGroupId: string | null;
  allUsersGroupType: GroupType | null;
  allUsersGroupName: string | null;
}

export type UnitSelectionTreeResponseIEnumerableIRequest = object;

export type UnitSelectionTreeResponseIEquatable = object;

export interface UnitSuggestionsHierarchicalQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  unitTypeId: string | null;
  /** @format uuid */
  parentId: string | null;
  searchText: string | null;
  trySelectionHistory: boolean;
  allowIncludeDescendants: boolean;
  ignoreAllowAssociates: boolean;
  showRoot: boolean;
}

export interface UnitSuggestionsQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  unitTypeId: string | null;
  searchText: string | null;
}

export interface UnitTypeItemDto {
  /** @format uuid */
  unitTypeId: string;
  unitTypeName: string;
  isRequired: boolean;
  allowMultiSelect: boolean;
  units: UnitAutoCompleteHierarchicalModelDto[];
}

export type UnitTypeItemDtoIEquatable = object;

export interface UnitTypeResponse {
  /** @format uuid */
  unitTypeId: string;
  name: string;
  isRequired: boolean;
  allowMultiSelection: boolean;
  hasUnits: boolean;
}

export type UnitTypeResponseIEquatable = object;

export interface UnitTypeSuggestionsQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  searchText: string;
}

export interface UnitsSelectionTreeQuery {
  /** @format uuid */
  nodeId: string | null;
  /** @format uuid */
  parentId: string | null;
  /** @format uuid */
  unitTypeId: string | null;
  searchText: string | null;
}

export interface UnsubscribeChannelCommand {
  /** @format uuid */
  channelId: string;
}

export interface UnsubscribePublicationCommand {
  /** @format uuid */
  publicationId: string;
}

export interface UnsubscribeTopicCommand {
  /** @format uuid */
  topicId: string;
}

export interface UnsubscribeUserCommand {
  /** @format uuid */
  userId: string;
}

export interface UpdateAbsenceTypeCommand {
  /** @format uuid */
  absenceTypeId: string;
  nameR: ResourceModel[];
}

export type UpdateAbsenceTypeCommandIEquatable = object;

export interface UpdateAccessAgreementCommand {
  assignRequired: boolean;
  text: string;
  /** @format uuid */
  fileId: string | null;
  /** @format uuid */
  agreementId: string;
}

export interface UpdateAccessTimeRuleCommand {
  name: string;
  description: string | null;
  constraintType: AccessTimeConstraintType;
  /** @format date-time */
  startedOn: Date;
  /** @format date-time */
  finishedOn: Date | null;
  weekDays: number[];
  allowAccessToCorporateIPS: boolean;
  /** @format uuid */
  denyAccessOnHolidaysCalendarId: string | null;
  denyAccessOnUserWorkplaceHolidaysCalendar: boolean;
  accessDeniedMessages: ResourceModel[];
  units: string[];
  groups: string[];
  exceptionGroups: string[];
  /**
   * @format time
   * @example ""13:45:42.0000000""
   */
  startTime: string;
  /**
   * @format time
   * @example ""13:45:42.0000000""
   */
  endTime: string;
  /** @format uuid */
  accessTimeRuleId: string;
}

export type UpdateAccessTimeRuleCommandIEquatable = object;

export interface UpdateAudienceCommand {
  needAll: boolean;
  features: TrainingAudienceFeatures | null;
  groups: AudienceGroupDto[];
  /** @format uuid */
  audienceId: string;
  type: AudienceTargetType;
}

export interface UpdateBlockReasonCommand {
  /** @format uuid */
  blockReasonId: string;
  nameR: ResourceModel[];
}

export interface UpdateClassroomActivityCommand {
  /** @format uuid */
  componentId: string;
  /** @format uuid */
  classroomId: string;
  /** @format date-time */
  dueDate: Date;
}

export interface UpdateClassroomDiscussionCommand {
  /** @format uuid */
  discussionId: string;
  message: string;
  discussionType: DiscussionType;
  /** @format uuid */
  classroomId: string;
}

export type UpdateClassroomDiscussionCommandIEquatable = object;

export interface UpdateClassroomMeetingCommand {
  description: string | null;
  assignPresenceAfterViewRecording: boolean;
  hasScore: boolean;
  /** @format int32 */
  minPermanence: number | null;
  meetingType: MeetingType;
  /** @format uuid */
  roomId: string | null;
  locationName: string | null;
  address: AddressModel | null;
  timezoneId: string | null;
  /** @format date-time */
  startDate: Date | null;
  /** @format date-time */
  endDate: Date | null;
  externalUrl: string | null;
  instructors: string[] | null;
  assistants: string[] | null;
  /** @format timespan */
  bookAdditionalTimeBefore: string | null;
  /** @format timespan */
  bookAdditionalTimeAfter: string | null;
  /** @format uuid */
  componentId: string;
  /** @format uuid */
  classroomId: string;
}

export interface UpdateCommentCommand {
  /** @format uuid */
  discussionId: string;
  message: string;
  discussionType: DiscussionType;
}

export type UpdateCommentCommandIEquatable = object;

export interface UpdateConclusionFormCommand {
  /** @format uuid */
  enrollmentId: string;
  formData: ConclusionFormSaveDto;
}

export interface UpdateCustomFieldCommand {
  fieldId: string;
  fieldType: CustomFieldType;
  usage: CustomFieldUsages;
  usageSubType: string | null;
  labelR: ResourceModel[];
  placeholderTextR: ResourceModel[];
  validationErrorMessageR: ResourceModel[];
  defaultValue: string | null;
  isActive: boolean;
  isRequired: boolean;
  isUnique: boolean;
  isClaim: boolean;
  keepHistory: boolean;
  showConcealed: boolean;
  /** @format int32 */
  sequenceOrder: number;
  fillConstraint: CustomFieldFillConstraint;
  showWidth: CustomFieldWidth;
  isVisibleToSelfUser: boolean | null;
  isEditableToSelfUser: boolean | null;
  showOnUserProfile: boolean | null;
  isPersonalInformation: boolean | null;
  userDisplayArea: CustomFieldUserDisplayArea | null;
  canBeUsedOnEmailTemplates: boolean;
  canBeUsedInFilters: boolean;
  textField: TextFieldDto | null;
  numericField: NumericFieldDto | null;
  valueSelectionField: ValueSelectionFieldDto | null;
  objectSelectionField: ObjectSelectionFieldDto | null;
}

export interface UpdateDevPlanActivityCommand {
  /** @format uuid */
  devPlanId: string;
  /** @format uuid */
  devPlanGroupId: string;
  /** @format uuid */
  devPlanItemId: string;
  /** @format date-time */
  completionDeadline: Date | null;
  /** @format double */
  progressPercent: number | null;
  ignoreLastApprovedEnrollment: boolean | null;
}

export interface UpdateDevPlanDiscussionCommand {
  /** @format uuid */
  discussionId: string;
  message: string;
  discussionType: DiscussionType;
  /** @format uuid */
  devPlanId: string;
}

export type UpdateDevPlanDiscussionCommandIEquatable = object;

export type UpdateDiscussionDtoIEquatable = object;

export interface UpdateDynamicGroupCommand {
  usages: GroupUsages | null;
  name: string;
  description: string | null;
  /** @format uuid */
  thumbnailId: string | null;
  /** @format uuid */
  unitId: string;
  active: boolean;
  /** @format int32 */
  priority: number;
  spec: GroupDynamicSpec;
  pauseProcessing: boolean;
  tags: string[];
  /** @format uuid */
  groupId: string;
}

export interface UpdateEvaluationCommand {
  /** @format uuid */
  assessmentId: string;
  exclusiveUsage: ExclusiveUsage | null;
  name: string;
  /** @format uuid */
  thumbnailId: string | null;
  instructions: string | null;
  isBlocked: boolean;
  isDraft: boolean;
  makeAvailable: boolean;
  externalCode: string | null;
  language: string | null;
  author: string | null;
  topics: string[];
  tags: string[];
  owners: string[];
  allowGoback: boolean;
  allowContinueAbortedEvaluation: boolean;
  showQuestionPoints: boolean;
  /** @format timespan */
  timeToComplete: string | null;
  freezeChronometer: boolean;
  /** @format int32 */
  maxTries: number | null;
  showCorrection: boolean;
  showCorrectAnswer: boolean;
  showFeedback: boolean;
  /** @format uuid */
  essayEvaluatorId: string | null;
  description: string | null;
  randomized: boolean;
}

export interface UpdateExternalCodeCommand {
  /** @format uuid */
  managerTypeId: string;
  externalCode: string;
}

export interface UpdateHolidayCommand {
  /** @format uuid */
  calendarId: string;
  /** @format date */
  day: Date;
  /** @format date */
  currentDay: Date;
  name: string;
  periodOfDay: HolidayPeriodOfDay;
}

export interface UpdateListClassifyPublicationCommand {
  /** @format uuid */
  publicationId: string;
  topics: string[];
  /** @format uuid */
  channelId: string | null;
  advancedOptions: PublicationAdvancedItem;
}

export interface UpdateLpGameAwardRankingCommand {
  /** @format uuid */
  trainingId: string;
  /** @format uuid */
  learnPathGameRankingId: string;
  hasAward: boolean;
}

export interface UpdateMailTemplateCommand {
  notificationTypeId: NotificationType;
  locale: string;
  subject: string | null;
  body: string | null;
  header: string | null;
  footer: string | null;
  attachCalendarIcs: boolean | null;
  replyEmail: string | null;
  restore: boolean;
}

export interface UpdateMaterialListClassroomOptionsCommand {
  /** @format uuid */
  classroomId: string;
  rules: TrainingMaterialListItem;
  showTrainingMaterialFirst: boolean;
}

export interface UpdateMaterialListCommand {
  /** @format uuid */
  materialListId: string;
  name: string;
}

export interface UpdateMaterialListTrainingOptionsCommand {
  /** @format uuid */
  trainingId: string;
  allowMaterialOverride: boolean;
  rules: TrainingMaterialListItem;
}

export interface UpdateMeetingRoomCommand {
  name: string;
  address1: string;
  address2: string | null;
  city: string;
  state: string;
  zipCode: string;
  timezoneId: string;
  isActive: boolean;
  /** @format uuid */
  roomId: string;
}

export interface UpdateOtherActivityProgressCommand {
  /** @format uuid */
  devPlanItemId: string;
  /** @format int32 */
  progressPercent: number;
}

export interface UpdatePollClassifyPublicationCommand {
  /** @format uuid */
  publicationId: string;
  topics: string[];
  /** @format uuid */
  channelId: string;
  advancedOptions: PublicationAdvancedItem;
}

export interface UpdatePostClassifyPublicationCommand {
  /** @format uuid */
  publicationId: string;
  topics: string[];
  /** @format uuid */
  channelId: string;
  advancedOptions: PublicationAdvancedItem;
}

export interface UpdateProfileCommand {
  /** @format uuid */
  userId: string;
  name: string;
  displayName: string;
  email: string | null;
  preferredLocale: string | null;
  /** @format uuid */
  thumbnailId: string | null;
  /** @format uuid */
  workplaceId: string | null;
  workplaceText: string | null;
  /** @format date-time */
  accessExpiresOn: Date | null;
  /** @format date */
  admissionDate: Date | null;
  /** @format date */
  dismissedDate: Date | null;
  /** @format date */
  birthDate: Date | null;
  allowUserConnections: boolean;
  receiveDailySummaryEmail: boolean;
  discloseBirthDate: boolean;
  userType: UserType;
  customFields: FieldValueItem[] | null;
  phones: UserPhoneItem[] | null;
  socialNetworks: UserSocialNetworkItem[] | null;
}

export interface UpdateProfileResponse {
  name: string;
  email: string | null;
  locale: string;
  thumbnailUrl: string;
}

export type UpdateProfileResponseIEquatable = object;

export type UpdateProfileResponseIRequest = object;

export interface UpdateQuestionClassifyPublicationCommand {
  /** @format uuid */
  publicationId: string;
  topics: string[];
  /** @format uuid */
  channelId: string;
  advancedOptions: PublicationAdvancedItem;
}

export interface UpdateQuestionGroupCommand {
  name: string;
  /** @format uuid */
  parentGroupId: string | null;
  forSurvey: boolean;
  /** @format int32 */
  defaultPoints: number;
  defaultAllowInKnowledgeTests: boolean;
  /** @format uuid */
  questionGroupId: string;
}

export interface UpdateQuestionPointsCommand {
  /** @format uuid */
  questionGroupId: string;
  /** @format int32 */
  points: number;
}

export interface UpdateQuickFilterCommand {
  /** @format uuid */
  quickFilterId: string;
  /** @format date-time */
  dueDate: Date | null;
  nameR: ResourceModel[] | null;
}

export interface UpdateReportScheduleParamsCommand {
  /** @format uuid */
  reportScheduleId: string | null;
  reportParams: ReportParamStore[];
  orderBy: string;
}

export interface UpdateRoleCommand {
  nameR: ResourceModel[];
  descriptionR: ResourceModel[];
  isFreelyAssignable: boolean;
  externalCode: string | null;
  assignmentDependencyRoleIds: string[];
  defaultConstraints: PermissionConstraintModel;
  permissions: SecurityRolePermissionItem[];
  /** @format uuid */
  roleId: string;
}

export interface UpdateRuleAssCommand {
  /** @format uuid */
  assessmentId: string;
  /** @format uuid */
  itemId: string;
  assessmentItemType: AssessmentItemType;
  /** @format int32 */
  numberOfQuestion: number | null;
  tags: string[] | null;
}

export interface UpdateStaticGroupCommand {
  usages: GroupUsages | null;
  name: string;
  description: string | null;
  /** @format uuid */
  thumbnailId: string | null;
  /** @format uuid */
  unitId: string;
  active: boolean;
  tags: string[];
  /** @format uuid */
  groupId: string;
}

export interface UpdateStickerCommand {
  applyTo: StickerAppliesTo;
  nameR: ResourceModel[];
  color: string;
  priority: StickerPriority;
  restrictedUse: boolean;
  requiredDeadline: boolean;
  /** @format uuid */
  stickerId: string;
}

export type UpdateStickerCommandIEquatable = object;

export interface UpdateSurveyCommand {
  /** @format uuid */
  assessmentId: string;
  exclusiveUsage: ExclusiveUsage | null;
  name: string;
  /** @format uuid */
  thumbnailId: string | null;
  instructions: string | null;
  isBlocked: boolean;
  isDraft: boolean;
  makeAvailable: boolean;
  externalCode: string | null;
  language: string | null;
  author: string | null;
  topics: string[];
  tags: string[];
  owners: string[];
  resultWithPoints: boolean;
  allowReview: boolean;
  beforeExpireBehavior: SurveyReviewBehaviorBeforeExpire;
  afterExpireBehavior: SurveyReviewBehaviorAfterExpire;
  /** @format int32 */
  daysToReviewResults: number | null;
  /** @format int32 */
  daysToReviewAnswers: number | null;
  identifyUsers: boolean;
  identifyAnswers: boolean;
  identifyForManagersOnly: boolean;
  groups: string[];
}

export interface UpdateTagCommand {
  /** @format uuid */
  tagId: string;
  name: string;
}

export interface UpdateThumbnailPublicationCommand {
  /** @format uuid */
  publicationId: string;
  /** @format uuid */
  thumbnailId: string | null;
}

export interface UpdateTopicChallengeCommand {
  /** @format uuid */
  topicId: string;
  audiencesNeedAll: boolean;
  audience: string[];
  questionsGroups: string[];
  disableChallenge: boolean;
  grantSealProvenKnowledge: boolean;
}

export type UpdateTopicChallengeCommandIEquatable = object;

export interface UpdateTopicCommand {
  category: TopicCategory;
  /** @format uuid */
  parentId: string | null;
  nameR: ResourceModel[];
  descriptionR: ResourceModel[];
  akaNames: string[] | null;
  /** @format uuid */
  thumbnailId: string | null;
  isActive: boolean;
  allowUserAutoInterest: boolean;
  isAvailableForExternalUsers: boolean;
  tags: string[] | null;
  /** @format uuid */
  topicId: string;
}

export interface UpdateTrainingAgreementSettingsCommand {
  canCreateExclusiveAgreement: boolean;
}

export interface UpdateUnitCommand {
  /** @format uuid */
  unitTypeId: string | null;
  /** @format uuid */
  parentId: string;
  nameR: ResourceModel[];
  description: string | null;
  /** @format uuid */
  defaultUserWorkplaceId: string | null;
  defaultUserWorkplace: string | null;
  defaultUserLocale: string | null;
  externalCode: string | null;
  allowAssociates: boolean;
  tags: string[];
  customFields: FieldValueItem[] | null;
  /** @format uuid */
  unitId: string;
}

export type UpdateUnitCommandIEquatable = object;

export interface UpdateUnitTypeCommand {
  nameR: ResourceModel[];
  branchNameR: ResourceModel[];
  externalCode: string;
  isRequired: boolean;
  allowMultiSelection: boolean;
  showOnUserProfile: boolean;
  defineJobsAndPositions: boolean;
  /** @format uuid */
  thumbnailId: string | null;
  /** @format uuid */
  unitTypeId: string;
}

export type UpdateUnitTypeCommandIEquatable = object;

export interface UpdateUserCommand {
  name: string;
  displayName: string;
  email: string | null;
  preferredLocale: string | null;
  /** @format uuid */
  thumbnailId: string | null;
  /** @format uuid */
  workplaceId: string | null;
  workplaceText: string | null;
  /** @format uuid */
  blockReasonId: string | null;
  /** @format date-time */
  unblockAt: Date | null;
  /** @format uuid */
  managerId: string | null;
  /** @format uuid */
  approverId: string | null;
  /** @format date-time */
  accessExpiresOn: Date | null;
  /** @format date */
  admissionDate: Date | null;
  /** @format date */
  dismissedDate: Date | null;
  /** @format date */
  birthDate: Date | null;
  allowUserConnections: boolean;
  receiveDailySummaryEmail: boolean;
  userType: UserType;
  units: string[];
  customFields: FieldValueItem[] | null;
  secondaryManagers: UserSecondaryManagerItem[] | null;
  phones: UserPhoneItem[] | null;
  socialNetworks: UserSocialNetworkItem[] | null;
  tags: string[] | null;
  /** @format uuid */
  userId: string;
  reactiving: boolean;
}

export interface UpdateVideoPosterCommand {
  /** @format uuid */
  publicationId: string;
  /** @format uuid */
  attachId: string;
  posterBase64: string;
  /** @format int32 */
  width: number;
  /** @format int32 */
  height: number;
}

export interface UpdateWorkplaceCommand {
  /** @format uuid */
  workplaceId: string;
  name: string;
  geoLocalization: string | null;
  /** @format uuid */
  holidayCalendarId: string | null;
}

export interface UpdateZoomInstructorLinkCommand {
  /** @format uuid */
  classroomId: string;
  /** @format uuid */
  componentId: string;
}

export interface UserAbsenceAddCommand {
  /** @format uuid */
  userId: string;
  /** @format uuid */
  absenceTypeId: string;
  /** @format date-time */
  validFrom: Date;
  /** @format date-time */
  validUntil: Date | null;
  /** @format uuid */
  delegateUserId: string | null;
}

export type UserAbsenceAddCommandIEquatable = object;

export interface UserAbsenceDesactivateCommand {
  /** @format uuid */
  userId: string;
  /** @format uuid */
  userAbsenceId: string;
}

export type UserAbsenceDesactivateCommandIEquatable = object;

export interface UserAbsenceQuery {
  /** @format uuid */
  userId: string;
}

export type UserAbsenceRequestIEquatable = object;

export interface UserAbsenceResponse {
  /** @format uuid */
  userAbsenceId: string | null;
  /** @format uuid */
  absenceTypeId: string | null;
  /** @format date-time */
  validFrom: Date;
  /** @format date-time */
  validUntil: Date | null;
  delegateUser: AutoCompleteDataModelDto[];
}

export type UserAbsenceResponseIEquatable = object;

export type UserAbsenceResponseIRequest = object;

export interface UserAbsenceUpdateCommand {
  /** @format uuid */
  userId: string;
  /** @format uuid */
  userAbsenceId: string;
  /** @format date-time */
  validUntil: Date | null;
}

export type UserAbsenceUpdateCommandIEquatable = object;

export interface UserAddPersonalInterestCommand {
  /** @format uuid */
  userId: string;
  tagName: string;
}

export interface UserAnswersAlternativeQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  instanceId: string | null;
  /** @format uuid */
  deployId: string | null;
  /** @format uuid */
  questionId: string;
  /** @format int32 */
  version: number;
  /** @format uuid */
  alternativeId: string;
  onlyTrueAnswer: boolean;
  searchText: string | null;
}

export interface UserAnswersQuestionQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  deployId: string | null;
  /** @format uuid */
  instanceId: string | null;
  /** @format uuid */
  questionId: string;
  /** @format int32 */
  version: number;
  searchText: string | null;
}

export interface UserAnswersQuestionResponse {
  /** @format uuid */
  userId: string;
  name: string;
  /** @format uuid */
  thumbnailId: string | null;
  thumbnailUrl: string;
  /** @format int32 */
  totalAnswer: number;
}

export type UserAnswersQuestionResponseIEquatable = object;

export interface UserAnswersQuestionResponsePaginatedList {
  items: UserAnswersQuestionResponse[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type UserAnswersQuestionResponsePaginatedListIRequest = object;

export interface UserChangeEmailCommand {
  email: string;
}

export interface UserChangeOwnPasswordCommand {
  oldPassword: string;
  newPassword: string;
}

export interface UserCredentialAddOrUpdateCommand {
  /** @format uuid */
  credentialId: string | null;
  /** @format uuid */
  userId: string;
  credentialType: UserCredentialType;
  title: string;
  description: string | null;
  /** @format date-time */
  startedOn: Date | null;
  /** @format date-time */
  finishedOn: Date | null;
}

export interface UserCredentialDeleteCommand {
  /** @format uuid */
  credentialId: string;
  /** @format uuid */
  userId: string;
}

export interface UserCredentialTypeSelectorResponse {
  type: UserCredentialType;
  name: string;
}

export type UserCredentialTypeSelectorResponseIEquatable = object;

export type UserCustomFieldAreasIEquatable = object;

export interface UserDashboardSuggestionsQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  searchText: string | null;
  /** @format uuid */
  classroomId: string | null;
}

export interface UserDirectMessageSuggestionsQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  searchText: string | null;
}

export interface UserDiscussionSuggestionsQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  classroomId: string;
  searchText: string | null;
  selectionHistoryType: UserSelectionEntityType | null;
  discussionType: DiscussionType;
  ignoreSelectionHistory: boolean;
}

export interface UserDto {
  /** @format uuid */
  userId: string;
  name: string;
  thumbnailUrl: string;
}

export type UserDtoIEquatable = object;

export interface UserEditProfilePermissions {
  allowUpdatePersonal: boolean;
  allowUpdateName: boolean;
  allowUpdatePhoto: boolean;
  allowUpdateLocal: boolean;
  allowUpdateKnowledge: boolean;
  allowUpdateCredentials: boolean;
  allowViewRecordFiles: boolean;
  allowAddRecordFiles: boolean;
  allowDeleteRecordFiles: boolean;
}

export type UserEditProfilePermissionsIEquatable = object;

export interface UserEditProfileQuery {
  /** @format uuid */
  userId: string;
}

export interface UserEditProfileResponse {
  customFieldsBasic: CustomFieldValueDto[] | null;
  customFieldsCorporate: CustomFieldValueDto[] | null;
  customFieldsPersonal: CustomFieldValueDto[] | null;
  customFieldsAdditional: CustomFieldValueDto[] | null;
  customFieldsConcealed: CustomFieldValueDto[] | null;
  /** @format uuid */
  userId: string;
  name: string;
  displayName: string;
  email: string | null;
  preferredLocale: string | null;
  status: UserStatus;
  statusName: string;
  workplace: WorkplaceDto | null;
  workplaceText: string | null;
  thumbnail: FileGetDto | null;
  isExternalUser: boolean;
  recordInfo: RecordInfoDto;
  /** @format date-time */
  lastLoginOn: Date | null;
  /** @format date */
  admissionDate: Date | null;
  /** @format date */
  dismissedDate: Date | null;
  /** @format date-time */
  accessExpiresOn: Date | null;
  /** @format date */
  birthDate: Date | null;
  /** @format uuid */
  blockReasonId: string | null;
  allowUserConnections: boolean;
  receiveDailySummaryEmail: boolean;
  discloseBirthDate: boolean;
  phones: UserPhoneDto[];
  socialNetworks: UserSocialNetworkDto[];
  hasSamlAccount: boolean;
  settings: UserEditProfileSettings;
  permissions: UserEditProfilePermissions;
}

export type UserEditProfileResponseIEquatable = object;

export type UserEditProfileResponseIRequest = object;

export interface UserEditProfileSettings {
  workplaceLabel: string;
  isWorkplaceFreeText: boolean;
  workplaceRequiredForNewUsers: boolean;
  isEmailRequired: boolean;
  isEmailUnique: boolean;
}

export type UserEditProfileSettingsIEquatable = object;

export interface UserEmailResponse {
  /** @format uuid */
  userId: string;
  name: string;
  email: string | null;
}

export type UserEmailResponseIEquatable = object;

export interface UserEnrollStatisticsDto {
  /** @format uuid */
  userId: string;
  name: string;
  thumbnailUrl: string;
  /** @format double */
  scorePercent: number | null;
  /** @format int32 */
  times: number;
}

export type UserEnrollStatisticsDtoIEquatable = object;

export interface UserEnrollStatisticsDtoPaginatedList {
  items: UserEnrollStatisticsDto[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type UserEnrollStatisticsDtoPaginatedListIRequest = object;

export type UserEntityIRequest = object;

export interface UserIdiomAbroadExperienceTimeSelectorResponse {
  type: UserIdiomAbroadExperienceTime;
  name: string;
}

export type UserIdiomAbroadExperienceTimeSelectorResponseIEquatable = object;

export interface UserIdiomProficiencyItem {
  idiomId: string;
  readingProficiency: UserIdiomProficiencyType;
  writingProficiency: UserIdiomProficiencyType;
  speakingProficiency: UserIdiomProficiencyType;
  hearingProficiency: UserIdiomProficiencyType;
  abroadExperienceTime: UserIdiomAbroadExperienceTime | null;
  isNative: boolean;
}

export type UserIdiomProficiencyItemIEquatable = object;

export interface UserIdiomProficiencyTypesSelectorResponse {
  type: UserIdiomProficiencyType;
  name: string;
}

export type UserIdiomProficiencyTypesSelectorResponseIEquatable = object;

export interface UserIdiomsAddCommand {
  /** @format uuid */
  userId: string;
  idioms: UserIdiomProficiencyItem[];
}

export interface UserInfoDto {
  /** @format uuid */
  userId: string;
  name: string;
  email: string;
  culture: string;
  thumbnailUrl: string;
  timezoneId: string;
  status: UserStatus;
  statusName: string;
}

export type UserInfoDtoIEquatable = object;

export interface UserInfoDtoPaginatedList {
  items: UserInfoDto[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type UserInfoDtoPaginatedListIRequest = object;

export interface UserItemDto {
  /** @format uuid */
  userId: string;
  name: string;
  thumbnailUrl: string;
  detail?: string | null;
}

export type UserItemDtoIEquatable = object;

export interface UserItemDtoPaginatedList {
  items: UserItemDto[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type UserItemDtoPaginatedListIRequest = object;

export interface UserMainManagerSubordinatesResponse {
  subordinates: UtilRequiredKeys<
    SubordinateDtoPaginatedList,
    "items" | "totalPages" | "totalRows" | "pageNumber" | "pageSize"
  > & {
    items: SubordinateDto[];
    /** @format int32 */
    totalPages: number;
    /** @format int32 */
    totalRows: number;
    /** @format int32 */
    pageNumber: number;
    /** @format int32 */
    pageSize: number;
  };
  managerTypes: UserManagerTypesResponse[];
}

export type UserMainManagerSubordinatesResponseIEquatable = object;

export type UserMainManagerSubordinatesResponseIRequest = object;

export interface UserManagerSubordinatesQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  managerId: string;
  /** @format uuid */
  managerType: string | null;
  searchText: string | null;
}

export interface UserManagerSuggestionsQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  searchText: string | null;
}

export interface UserManagerTypesResponse {
  /** @format uuid */
  secondaryManagerTypeId: string;
  name: string;
}

export type UserManagerTypesResponseIEquatable = object;

export interface UserNotificationConfigDto {
  tabs: UserNotificationConfigTabDto[];
}

export interface UserNotificationConfigGroupDto {
  groupId: NotificationGroup;
  name: string;
  description: string | null;
  sendPushNotification: boolean | null;
  mailOption: NotificationSendMailOption | null;
  showOnWorkspace: boolean | null;
}

export interface UserNotificationConfigTabDto {
  tabId: NotificationTab;
  name: string;
  groups: UserNotificationConfigGroupDto[];
}

export interface UserOperationAdditionalInfoProps {
  customField: FieldValueItem;
}

export type UserOperationAdditionalInfoPropsIEquatable = object;

export interface UserOperationBlockProps {
  status: UserStatus;
  /** @format uuid */
  blockReasonId: string | null;
  /** @format date-time */
  unblockAt: Date | null;
  /** @format date-time */
  accessExpiresOn: Date | null;
}

export type UserOperationBlockPropsIEquatable = object;

export interface UserOperationBroadcastMessageProps {
  type: BroadcastMessageType;
  subject: string | null;
  body: string | null;
  allActiveUsers: boolean;
}

export type UserOperationBroadcastMessagePropsIEquatable = object;

export interface UserOperationGeneralInfoProps {
  extenalUser: boolean | null;
  preferredLocale: string | null;
  /** @format uuid */
  workplaceId: string | null;
  workplaceText: string | null;
  /** @format date */
  admissionDate: Date | null;
  /** @format date */
  dismissedDate: Date | null;
}

export type UserOperationGeneralInfoPropsIEquatable = object;

export interface UserOperationGroupProps {
  action: UserOperationAction;
  /** @format uuid */
  groupId: string;
}

export type UserOperationGroupPropsIEquatable = object;

export interface UserOperationManagementProps {
  /** @format uuid */
  managerId: string | null;
  secondaryManager: UserSecondaryManagerItem | null;
}

export type UserOperationManagementPropsIEquatable = object;

export interface UserOperationResults {
  /** @format int64 */
  totalSuccess: number | null;
  /** @format int64 */
  totalFail: number | null;
  usersFail: UserOperationResultsItem[];
}

export type UserOperationResultsIEquatable = object;

export type UserOperationResultsIRequest = object;

export interface UserOperationResultsItem {
  /** @format uuid */
  userId: string;
  name: string;
  message: string | null;
}

export interface UserOperationRoleProps {
  action: UserOperationAction;
  /** @format uuid */
  roleId: string;
}

export type UserOperationRolePropsIEquatable = object;

export interface UserOperationSettingsQuery {
  operation: UserOperationType | null;
}

export interface UserOperationSettingsResponse {
  locale: string;
  workplaceLabel: string;
  isWorkplaceFreeText: boolean;
  customFields: CustomFieldValueDto[];
  secondaryManagers: SecondaryManagerItemDto[];
  unitTypes: UnitTypeResponse[];
  blockReasons: BlockReasonSelectorResponse[];
}

export type UserOperationSettingsResponseIEquatable = object;

export type UserOperationSettingsResponseIRequest = object;

export interface UserOperationTagProps {
  action: UserOperationAction;
  /** @format uuid */
  tagId: string;
}

export type UserOperationTagPropsIEquatable = object;

export interface UserOperationTopicProps {
  action: UserOperationAction;
  /** @format uuid */
  topicId: string;
  isRequired: boolean;
}

export type UserOperationTopicPropsIEquatable = object;

export interface UserOperationUnitProps {
  action: UserOperationAction;
  /** @format uuid */
  unitId: string;
}

export type UserOperationUnitPropsIEquatable = object;

export interface UserOrganogramManagersQuery {
  /** @format uuid */
  userId: string;
}

export interface UserOrganogramManagersResponse {
  primaryManagers: OrganogramManagerDto[];
  secondaryManagerTypes: OrganogramSecondayManagerDto | null;
}

export type UserOrganogramManagersResponseIEquatable = object;

export type UserOrganogramManagersResponseIRequest = object;

export interface UserPanelDto {
  /** @format uuid */
  userId: string;
  name: string;
  thumbnailUrl: string;
  isManager: boolean;
  /** @format int32 */
  totalRows: number;
}

export type UserPanelDtoIEquatable = object;

export interface UserPanelDtoPaginatedList {
  items: UserPanelDto[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type UserPanelDtoPaginatedListIRequest = object;

export interface UserPanelPersonalInterestDto {
  /** @format uuid */
  tagId: string;
  name: string;
  /** @format int32 */
  totalRows: number;
}

export type UserPanelPersonalInterestDtoIEquatable = object;

export interface UserPanelPersonalInterestDtoPaginatedList {
  items: UserPanelPersonalInterestDto[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type UserPanelPersonalInterestDtoPaginatedListIRequest = object;

export interface UserPanelProfessionaInterestDto {
  /** @format uuid */
  topicId: string;
  name: string;
  thumbnailUrl: string;
  isSpecialist: boolean;
  hasProvenKnowledgeSeal: boolean;
  isEndorsed: boolean;
  /** @format int32 */
  endorsementCount: number;
  /** @format int32 */
  totalRows: number;
}

export type UserPanelProfessionaInterestDtoIEquatable = object;

export interface UserPanelProfessionaInterestDtoPaginatedList {
  items: UserPanelProfessionaInterestDto[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type UserPanelProfessionaInterestDtoPaginatedListIRequest = object;

export interface UserPanelSpecialistInterestDto {
  /** @format uuid */
  userId: string;
  name: string;
  thumbnailUrl: string;
  isSpecialist: boolean;
  hasProvenKnowledgeSeal: boolean;
  specialistSealGrantedBy: string;
  /** @format date-time */
  specialistSealGrantedOn: Date | null;
  isEndorsed: boolean;
  /** @format int32 */
  endorsementCount: number;
  /** @format int32 */
  totalRows: number;
}

export type UserPanelSpecialistInterestDtoIEquatable = object;

export interface UserPanelSpecialistInterestDtoPaginatedList {
  items: UserPanelSpecialistInterestDto[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type UserPanelSpecialistInterestDtoPaginatedListIRequest = object;

export interface UserPanelStatisticDto {
  /** @format int32 */
  totalPublications: number;
  /** @format int32 */
  totalAnswers: number;
  /** @format int32 */
  totalViews: number;
  /** @format int32 */
  totalLikes: number;
  /** @format int32 */
  followers: number;
  /** @format int32 */
  following: number;
  /** @format int32 */
  historyPoints: number;
  /** @format int32 */
  monthPoints: number;
  /** @format int32 */
  totalBadges: number;
}

export type UserPanelStatisticDtoIEquatable = object;

export type UserPanelStatisticDtoIRequest = object;

export interface UserPermissionConstraintQuery {
  permissionId: string;
}

export interface UserPersonalInterestsQuery {
  /** @format uuid */
  userId: string;
}

export interface UserPersonalInterestsResponse {
  /** @format uuid */
  tagId: string;
  tagName: string;
}

export type UserPersonalInterestsResponseIEquatable = object;

export type UserPersonalInterestsResponseIRequest = object;

export type UserPersonalInterestsResponseListIRequest = object;

export interface UserPhoneDto {
  phoneNumber: string;
  phoneType: UserPhoneType;
  usedForSMS: boolean | null;
  showOnProfile: boolean;
}

export type UserPhoneDtoIEquatable = object;

export interface UserPhoneItem {
  phoneNumber: string;
  phoneType: UserPhoneType;
  usedForSMS: boolean | null;
  showOnProfile: boolean;
}

export interface UserPhoneTypeSelectorResponse {
  type: UserPhoneType;
  name: string;
}

export type UserPhoneTypeSelectorResponseIEquatable = object;

export interface UserProfileDto {
  /** @format uuid */
  userId: string;
  name: string;
  displayName: string;
  thumbnailUrl: string;
  workplaceText: string | null;
  email: string | null;
  /** @format date */
  birthDate: Date | null;
  isCurrentUser: boolean;
  isFollowing: boolean;
  status: UserStatus;
  statusName: string;
  /** @format date-time */
  blockedOn: Date | null;
  /** @format date-time */
  silencedOn: Date | null;
  isManager: boolean;
  muted: boolean;
  /** @format uuid */
  managerId: string | null;
  managerName: string | null;
  phones: UserProfilePhoneDto[] | null;
  units: UserProfileUnitDto[];
  customFields: CustomFieldValueBasicDto[] | null;
  socialNetworks: UserSocialNetworkDto[];
  /** @format date */
  admissionDate: Date | null;
  /** @format date */
  dismissedDate: Date | null;
  backgroundImage: FileGetDto | null;
  /** @format int32 */
  publicationCount: number;
  hasMentions: boolean;
  allowTeam: boolean;
  allowViewAnalysis: boolean;
  allowEditManage: boolean;
  allowEditProfile: boolean;
  allowRequestConnection: boolean;
  userType: UserType;
  /** @format date-time */
  createdOn: Date;
  /** @format date-time */
  deletedOn: Date | null;
}

export type UserProfileDtoIEquatable = object;

export interface UserProfilePhoneDto {
  phoneNumber: string;
  phoneNumberFormatted: string;
  phoneType: UserPhoneType;
  phoneTypeName: string;
  usedForSMS: boolean;
}

export interface UserProfileUnitDto {
  /** @format uuid */
  unitId: string;
  name: string;
}

export interface UserRecordFileAddCommand {
  /** @format uuid */
  userId: string;
  /** @format uuid */
  fileId: string;
}

export interface UserRecordFileDeleteCommand {
  /** @format uuid */
  userId: string;
  /** @format uuid */
  fileId: string;
}

export interface UserRemoveBackgroundImageCommand {
  /** @format uuid */
  userId: string;
}

export interface UserRemovePersonalInterestCommand {
  /** @format uuid */
  userId: string;
  /** @format uuid */
  tagId: string;
}

export interface UserRequestSpyAuthorizationQuery {
  /** @format uuid */
  authorizationId: string;
}

export interface UserRequestSupportAuthCommand {
  /** @format uuid */
  userId: string;
}

export interface UserResetTwoFactorAppCommand {
  /** @format uuid */
  userId: string;
}

export interface UserRoleAddCommand {
  /** @format uuid */
  userId: string;
  /** @format uuid */
  roleId: string;
}

export interface UserRoleDeleteCommand {
  /** @format uuid */
  userId: string;
  /** @format uuid */
  roleId: string;
}

export interface UserRoleDesactivateCommand {
  /** @format uuid */
  userId: string;
  /** @format uuid */
  roleId: string;
}

export type UserRoleEntityIRequest = object;

export interface UserRoleReactivateCommand {
  /** @format uuid */
  roleId: string;
  /** @format uuid */
  userId: string;
}

export interface UserSearchDto {
  /** @format uuid */
  userId: string;
  name: string;
  displayName: string | null;
  email: string | null;
  thumbnailUrl: string | null;
  isSpecialist: boolean;
  jobPositionName: string | null;
  /** @format int32 */
  totalPublications: number;
}

export type UserSearchDtoIEquatable = object;

export interface UserSearchDtoPaginatedList {
  items: UserSearchDto[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type UserSearchDtoPaginatedListIRequest = object;

export interface UserSearchQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  searchText: string;
  orderBy: UserSearchOrderBy;
}

export interface UserSecondaryManagerItem {
  /** @format uuid */
  managerId: string | null;
  /** @format uuid */
  managerTypeId: string;
}

export interface UserSecurityRoleConstraintItem {
  permissionId: string;
  constraints: PermissionConstraintModel;
}

export type UserSecurityRoleConstraintItemIEquatable = object;

export interface UserSelectionEntry {
  entityType: UserSelectionEntityType;
  /** @format uuid */
  entityId: string;
  otherInfo: string;
  entityName: string;
}

export type UserSelectionEntryIEquatable = object;

export interface UserSelectionHistoryClickCommand {
  /** @format uuid */
  userId: string;
  entries: UserSelectionEntry[];
}

export interface UserSelectionHistoryCommand {
  /** @format uuid */
  userId: string;
  entries: UserSelectionEntry[];
}

export interface UserSelectorQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  searchText: string | null;
  groupTypes: GroupType[] | null;
  ignoreSelectionHistory: boolean;
}

export interface UserSelectorResponse {
  /** @format uuid */
  userId: string;
  name: string;
  thumbnailUrl: string;
  fromHistory: boolean;
}

export type UserSelectorResponseIEquatable = object;

export interface UserSelectorResponsePaginatedList {
  items: UserSelectorResponse[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type UserSelectorResponsePaginatedListIRequest = object;

export interface UserSettingsDto {
  loginUserPlaceHolder: string;
  isEmailRequired: boolean;
  isEmailUnique: boolean;
  alertToFillEmail: boolean;
  workplaceLabel: string;
  isWorkplaceFreeText: boolean;
  workplaceRequiredForNewUsers: boolean;
  alertToFillWorkplace: boolean;
  /** @format uuid */
  approverOfLastResort: string;
  allowInterestTags: boolean;
  userConnectionAllowedDefaultValue: boolean;
  sendWelcomeEmail: boolean;
  requiresAgreementOnFirstAuthentication: boolean;
}

export type UserSettingsDtoIEquatable = object;

export interface UserSettingsModel {
  isEmailRequired: boolean;
  isEmailUnique: boolean;
  alertToFillEmail: boolean;
  workplaceLabel: ResourceModel[];
  isWorkplaceFreeText: boolean;
  workplaceRequiredForNewUsers: boolean;
  alertToFillWorkplace: boolean;
  agreementMustBeAssigned: boolean;
  sendWelcomeEmail: boolean;
  welcomeText: string;
  /** @format uuid */
  defaultRoleId: string | null;
  enableAutoRegister: boolean;
  autoRegisterOnUnits: string[] | null;
  registerFormMode: string;
  registerFormExternalUrl: string | null;
  /** @format uuid */
  autoRegisterRole: string | null;
  requiresAccountValidation: boolean;
  autoRegisterUserType: UserType | null;
  autoRegisterRequireApproval: boolean;
  usersNotifyAutoRegister: string[];
}

export interface UserShortView {
  /** @format uuid */
  userId: string;
  name: string;
  fullName: string;
  thumbnailUrl: string;
  userType: UserType;
  metadata: any;
}

export interface UserSocialNetworkDto {
  socialNetworkType: UserSocialNetworkType;
  socialNetworkTypeName: string;
  socialNetworkId: string;
}

export type UserSocialNetworkDtoIEquatable = object;

export interface UserSocialNetworkItem {
  socialNetworkType: UserSocialNetworkType;
  socialNetworkId: string;
}

export interface UserSpyLoginAuthQuery {
  /** @format uuid */
  authorizationId: string;
}

export interface UserSuggestionsQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  searchText: string | null;
  type: UserSuggestionsType;
  selectionHistoryType: UserSelectionEntityType | null;
  includeYourself: boolean;
  usingPermissions?: string[] | null;
  hasPermissions?: string[] | null;
}

export interface UserTagDto {
  /** @format uuid */
  tagId: string;
  tagName: string;
  isSystemTag: boolean;
}

export type UserTagDtoIEquatable = object;

export interface UserTagInterestSuggestionsQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  searchText: string | null;
}

export interface UserTopicAddEndorsementCommand {
  /** @format uuid */
  topicId: string;
  /** @format uuid */
  userId: string;
}

export interface UserTopicDeleteEndorsementCommand {
  /** @format uuid */
  topicId: string;
  /** @format uuid */
  userId: string;
}

export interface UserTopicGrantSpecialistByManagerCommand {
  /** @format uuid */
  topicId: string;
  /** @format uuid */
  userId: string;
}

export interface UserTopicRevokeSpecialistByManagerCommand {
  /** @format uuid */
  topicId: string;
  /** @format uuid */
  userId: string;
}

export interface UserUpdateBackgroundImageCommand {
  /** @format uuid */
  userId: string;
  /** @format uuid */
  backgroundImageId: string;
}

export interface UsersActiveEnrollmentsQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  trainingId: string;
  searchText: string | null;
}

export interface UsersFinishedEnrollmentsQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  trainingId: string;
  /** @format int32 */
  versionNumber: number;
  searchText: string | null;
}

export interface ValueSelectionFieldDto {
  allowMultiValue: boolean;
  selectionList: ValueSelectionFieldValue[] | null;
}

export type ValueSelectionFieldDtoIEquatable = object;

export interface ValueSelectionFieldValue {
  key: string;
  label: string;
  canDelete: boolean;
  inUse: boolean;
}

export type ValueSelectionFieldValueIEquatable = object;

export interface VideoMatchSubtitlesQuery {
  /** @format uuid */
  publicationId: string;
  /** @format uuid */
  attachId: string;
  searchText: string;
}

export interface WhoAnsweredPollPublicationQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  publicationId: string;
  searchText: string | null;
}

export interface WhoLikesPublicationQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  publicationId: string;
  searchText: string | null;
}

export interface WhoViewPublicationQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  publicationId: string;
  searchText: string | null;
}

export interface WordItemDto {
  word: string;
  indexes: number[];
}

export type WordItemDtoIEquatable = object;

export type WordItemDtoListIRequest = object;

export interface WorkflowActionCommand {
  /** @format uuid */
  workflowId: string;
  /** @format int32 */
  step: number;
  action: WorkflowPreApprovalOption;
  messageToRequester: string | null;
}

export interface WorkflowActionResult {
  success: boolean;
  status: EnrollmentWorkflowStatus;
}

export type WorkflowActionResultIEquatable = object;

export type WorkflowActionResultIRequest = object;

export interface WorkflowConclusionDto {
  /** @format uuid */
  workflowId: string;
  /** @format int32 */
  workflowStep: number;
  /** @format uuid */
  trainingId: string;
  trainingName: string;
  trainingType: TrainingType;
  multipleClasses: boolean;
  /** @format uuid */
  classroomId: string;
  classroomName: string;
  /** @format uuid */
  enrollmentId: string;
  /** @format uuid */
  userId: string;
  userName: string;
  /** @format uuid */
  thumbnailId: string | null;
  userThumbnailUrl: string | null;
  formData: WorkflowConclusionItem;
  processedStatus: string | null;
}

export type WorkflowConclusionDtoIEquatable = object;

export interface WorkflowConclusionDtoPaginatedList {
  items: WorkflowConclusionDto[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type WorkflowConclusionDtoPaginatedListIRequest = object;

export interface WorkflowConclusionItem {
  /** @format date-time */
  lastSubmit: Date;
  institutionOrProvider: string | null;
  /** @format double */
  finalScore: number | null;
  finalScoreIsPercent: boolean | null;
  /** @format double */
  attendancePercent: number | null;
  /** @format double */
  pricePaid: number | null;
  remarks: string | null;
  /** @format date-time */
  startDate: Date | null;
  /** @format date-time */
  endDate: Date | null;
  /** @format int32 */
  duration: number | null;
  /** @format uuid */
  certificateId: string | null;
}

export type WorkflowConclusionItemIEquatable = object;

export interface WorkflowEnrollRequestDto {
  /** @format uuid */
  workflowId: string;
  /** @format int32 */
  workflowStep: number;
  /** @format uuid */
  trainingId: string;
  trainingName: string;
  trainingType: TrainingType;
  trainingTypeName: string;
  trainingContentType: TrainingContentType;
  trainingContentTypeName: string;
  multipleClasses: boolean;
  classroomName: string | null;
  /** @format date-time */
  executionStartDate: Date | null;
  /** @format date-time */
  executionDueDate: Date | null;
  /** @format int32 */
  executionDueDays: number | null;
  isMandatory: boolean;
  /** @format date-time */
  eventPeriodStart: Date | null;
  /** @format date-time */
  eventPeriodEnd: Date | null;
  eventTimezoneId: string | null;
  eventLocationName: string | null;
  eventType: MeetingType | null;
  eventTypeName: string | null;
  /** @format uuid */
  enrollmentId: string;
  /** @format uuid */
  userId: string;
  userName: string;
  /** @format uuid */
  thumbnailId: string | null;
  userThumbnailUrl: string | null;
  messageToApprover: string | null;
  processedStatus: string | null;
}

export type WorkflowEnrollRequestDtoIEquatable = object;

export interface WorkflowEnrollRequestDtoPaginatedList {
  items: WorkflowEnrollRequestDto[];
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  totalRows: number;
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
}

export type WorkflowEnrollRequestDtoPaginatedListIRequest = object;

export interface WorkflowPreApprovalQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  searchText: string | null;
  orderBy: WorkflowApprovalsOrderBy;
}

export interface WorkflowcConclusionFormQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  searchText: string | null;
  orderBy: WorkflowApprovalsOrderBy;
}

export interface WorkplaceDto {
  /** @format uuid */
  workplaceId: string;
  name: string;
}

export type WorkplaceDtoIEquatable = object;

export interface WorkplaceSuggestionsQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  searchText: string | null;
}

export interface WorkspaceMessageUsersQuery {
  /** @format int32 */
  pageNumber: number;
  /** @format int32 */
  pageSize: number;
  /** @format uuid */
  notificationId: string;
  searchText: string | null;
}

export interface WorkspaceMessagesQuery {
  /** @format int32 */
  startIndex: number;
  /** @format int32 */
  endIndex: number;
  /** @format uuid */
  userId: string;
}

export interface WorkspaceNewMessagesCounterQuery {
  /** @format uuid */
  userId: string;
}

export type CreateAbsenceTypePayload = CreateAbsenceTypeCommand;

export type UpdateAbsenceTypePayload = UpdateAbsenceTypeCommand;

export type DeleteAbsenceTypePayload = DeleteAbsenceTypeCommand;

export type ManagedAccessTimeRulesPayload = ManagedAccessTimeRuleListQuery;

export type GetAccessTimeRulePayload = ManagedAccessTimeRuleQuery;

export type CreateAccessTimeRulePayload = CreateAccessTimeRuleCommand;

export type UpdateAccessTimeRulePayload = UpdateAccessTimeRuleCommand;

export type GetAffectedUsersPayload = AccessTimeAffectedUsersQuery;

export type CreateStandardAccountPayload = CreateStandardAccountCommand;

export type StandardAccountConfirmPayload = StandardAccountConfirmCommand;

export type StandardAccountRenewConfirmationPayload =
  StandardAccountRenewConfirmationCommand;

export type StandardAccountResendConfirmationPayload =
  StandardAccountResendConfirmationCommand;

export type RecoverPasswordSettingsPayload = RecoverPasswordSettingsQuery;

export type StandardAccountResetPasswordPayload =
  StandardAccountResetPasswordCommand;

export type StandardAccountSendResetPasswordPayload =
  StandardAccountSendResetPasswordCommand;

export type StandardAccountUnlockPayload = StandardAccountUnlockCommand;

export type StandardAccountSetAgreementPayload = StandardAccountAgreeRequest;

export type CreateTokenAccessPayload = CreateTokenAccessCommand;

export type EmailAuthenticatorSendCodePayload =
  EmailAuthenticatorSendCodeCommand;

export type EmailAuthenticatorValidateCodePayload =
  EmailAuthenticatorValidateCodeCommand;

export type AppAuthenticatorResetPayload = AppAuthenticatorResetCommand;

export type AppAuthenticatorSetupConfirmPayload =
  AppAuthenticatorSetupConfirmCommand;

export type AppAuthenticatorValidateCodePayload =
  AppAuthenticatorValidateCodeCommand;

export type AppAuthenticatorPrepareSetupPayload =
  AppAuthenticatorPrepareSetupCommand;

export type CheckTrainingAgreementUsagePayload =
  CheckTrainingAgreementUsageQuery;

export type CreateAccessAgreementPayload = CreateAccessAgreementCommand;

export type UpdateAccessAgreementPayload = UpdateAccessAgreementCommand;

export type CreateOrUpdateTrainingAssessmentPayload =
  CreateOrUpdateTrainingAgreementCommand;

export type DeleteTrainingAssessmentPayload = DeleteTrainingAgreementCommand;

export type UpdateTrainingAgreementSettingsPayload =
  UpdateTrainingAgreementSettingsCommand;

export type WriteAppLogPayload = AppLogParams;

export type SurveysAdHocPayload = AssDeploySelectorQuery;

export type GetAssDeployAudiencePayload = AssDeployAudienceQuery;

export type DeclineAdHocSurveyPayload = AdHocSurveyDeclineCommand;

export type ManagedEvaluationsPayload = ManagedEvaluationListQuery;

export type ManagedEvaluationPayload = ManagedEvaluationQuery;

export type ManagedAssQuestionsPayload = ManagedAssQuestionListQuery;

export type ManagedSurveysPayload = ManagedSurveyListQuery;

export type ManagedSurveyPayload = ManagedSurveyQuery;

export type GetEvaluationInfoPayload = EvaluationInfoQuery;

export type GetManagedAssRulePayload = ManagedAssRuleQuery;

export type GetCorrectionEssayEvaluationsPayload = EssayCorrectionListQuery;

export type GetEssayCorrectionUsersPayload = EssayCorrectionUserListQuery;

export type GetEssayCorrectionQuestionsPayload =
  EssayCorrectionQuestionListQuery;

export type ManagedAssDeployPayload = ManagedAssDeployListQuery;

export type CreateOrUpdateAssDeployPayload = CreateOrUpdateAssDeployCommand;

export type GetManagedAssDeployPayload = ManagedAssDeployQuery;

export type GroupsAudienceUsersPayload = GroupsAudienceUsersQuery;

export type GetTrainingAssessmentUsedPayload = TrainingAssessmentUsedQuery;

export type UpdateEvaluationPayload = UpdateEvaluationCommand;

export type UpdateSurveyPayload = UpdateSurveyCommand;

export type AddQuestionPayload = AssAddQuestionCommand;

export type AddRuleRaffleAssPayload = AddRuleRaffleAssCommand;

export type AddRuleAllAssPayload = AddRuleAllAssCommand;

export type UpdateRuleAssPayload = UpdateRuleAssCommand;

export type MarkRemoveItemAssessmentPayload = MarkRemoveItemAssessmentCommand;

export type RemoveRecoveryAssessmentPayload = RemoveRecoveryAssessmentCommand;

export type ClearItemsAssessmentPayload = ClearItemsAssessmentCommand;

export type ReactiveItemAssessmentPayload = ReactiveItemAssessmentCommand;

export type ReorderItemsPayload = ReorderAssessmentItemsCommand;

export type DuplicateItemPayload = AssessmentDuplicateItemCommand;

export type DeleteAssessmentPayload = DeleteAssessmentCommand;

export type DeleteAssDeployPayload = DeleteAssDeployCommand;

export type EssayRegisterCorrectionPayload = EssayRegisterCorrectionCommand;

export type CloneSurveyPayload = CloneSurveyCommand;

export type CloneEvaluationPayload = CloneEvaluationCommand;

export type GetStartPlayerSurveyPayload = StartPlayerSurveyQuery;

export type GetStartPlayerEvaluationPayload = StartPlayerEvaluationQuery;

export type GetDeploySummaryPayload = GetDeploySummaryQuery;

export type GetQuestionAssInstancePayload = GetQuestionAssInstanceQuery;

export type GetDeployQuestionPayload = GetDeployQuestionQuery;

export type GetEvalInstancePayload = GetEvalInstanceQuery;

export type GetSurveyInstancePayload = GetSurveyInstanceQuery;

export type GetRevisionEssaySurveyPayload = GetRevisionEssaySurveyListQuery;

export type GetUserAnswersQuestionPayload = UserAnswersQuestionQuery;

export type GetUserAnswersAlternativePayload = UserAnswersAlternativeQuery;

export type GetEvalResultInstancePayload = GetEvalResultInstanceQuery;

export type ChallengeUserTopicsPayload = ChallengeUserTopicListQuery;

export type GetChallengeInstancePayload = GetChallengeInstanceQuery;

export type GetChallengeResultPayload = GetChallengeResultQuery;

export type CreateEvalInstancePayload = CreateEvalInstanceCommand;

export type StartEvalInstancePayload = StartEvalInstanceCommand;

export type CreateChallengeInstancePayload = CreateChallengeInstanceCommand;

export type CreateSurveyInstancePayload = CreateSurvInstanceCommand;

export type SaveAnswerAssInstancePayload = SaveAnswerAssInstanceCommand;

export type PingAssInstancePayload = PingAssInstanceCommand;

export type DeletePreviewAssInstancePayload = DeletePreviewAssInstanceCommand;

export type StartSurveyInstancePayload = StartSurvInstanceCommand;

export type FinishAssInstancePayload = FinishAssInstanceCommand;

export type AssessmentsPayload = AssessmentSelectorQuery;

export type GetAssessmentQuestionUsedPayload = AssessmentQuestionUsedQuery;

export type EvaluationSuggestionsPayload = EvaluationSuggestionsQuery;

export type SurveySuggestionsPayload = SurveySuggestionsQuery;

export type AssDeployGetSuggestionsPayload = AssDeploySuggestionsQuery;

export type GetLogsPayload = AuditLogQuery;

export type GetAuditLogDetailPayload = AuditLogDetailQuery;

export type GetEntityTypesPayload = AuditLogEntityTypesQuery;

export type GetAwardResumePayload = AwardResumeQuery;

export type ManagedGetRankingPayload = ManagedAwardRankingQuery;

export type CreateOrUpdateAwardRankingPayload =
  CreateOrUpdateAwardRankingCommand;

export type DeleteAwardRankingPayload = DeleteAwardRankingCommand;

export type TranslateTextPayload = AzureTranslationTextQuery;

export type ManagedBadgesPayload = ManagedBadgeListQuery;

export type ManagedGetBadgePayload = ManagedBadgeQuery;

export type GetBadgeSystemListPayload = BadgeSystemListQuery;

export type GetBadgeInfoPayload = BadgeInfoQuery;

export type CreateOrUpdateBadgePayload = CreateOrUpdateBadgeCommand;

export type DeleteBadgePayload = DeleteBadgeCommand;

export type ListBannerPayload = BannerListQuery;

export type CreateOrUpdateBannerPayload = CreateOrUpdateBannerCommand;

export type GetBannerPayload = ManagedBannerQuery;

export type GetBannersPayload = BannerQuery;

export type ReorderBannerPayload = ReorderBannerCommand;

export type GetOrderBannerPayload = ReorderBannerListQuery;

export type PublicationsPayload = PublicationSelectorQuery;

export type SetDefaultCalendarPayload = SetDefaultCalendarCommand;

export type AddHolidayPayload = CreateHolidayCommand;

export type UpdateHolidayPayload = UpdateHolidayCommand;

export type RemoveHolidayPayload = DeleteHolidayCommand;

export type ValidateRecaptchaPayload = string;

export type GetConfigPayload = CarouselConfigQuery;

export type GetCarouselLinkInfoPayload = CarouselLinkInfoQuery;

export type GetCarouselDataPayload = CarouselDataQuery;

export type GetManageCarouselListPayload = ManageCarouselListQuery;

export type GetSystemListPayload = CarouselSystemListQuery;

export type GetManageCarouselPayload = ManageCarouselQuery;

export type CheckNewSensitiveDataPayload = CarouselCheckNewSensitiveDataQuery;

export type SaveCarouselPayload = ManageSaveCarouselCommand;

export type ExecuteOperationPayload = ExecuteOperationCommand;

export type MoveLinePayload = MoveModuleLineCommand;

export type CheckAlivePayload = CheckAliveCommand;

export type GetScormPlayerTokenPayload = ScormPlayerAccessTokenQuery;

export type ManagedChannelPayload = ManagedChannelListQuery;

export type CreateChannelPayload = CreateOrUpdateChannelCommand;

export type UpdateChannelPayload = CreateOrUpdateChannelCommand;

export type DeleteChannelPayload = DeleteChannelCommand;

export type JoinChannelPayload = JoinChannelCommand;

export type InviteUserPayload = InviteUserCommand;

export type InviteProcessPayload = InviteProcessCommand;

export type AddMembersPayload = AddMembersChannelCommand;

export type DeleteMemberPayload = DeleteMemberChannelCommand;

export type ChangeMemberRolePayload = ChangeMemberRoleCommand;

export type RequestAccessPayload = RequestChannelAccessCommand;

export type GetClassroomPayload = ManagedClassroomQuery;

export type GetExpressClassroomInfoPayload = ManagedExpressClassroomQuery;

export type GetClassroomComponentsPayload = ClassroomComponentsQuery;

export type GetClassroomMeetingPayload = ManagedClassroomMeetingQuery;

export type GetClassroomActivityPayload = ManagedClassroomActivityQuery;

export type GetClassroomAudiencePayload = ClassroomAudienceQuery;

export type GetClassroomAudienceUsersPayload = ClassroomAudienceUsersQuery;

export type GetCourseClassroomRulesPayload = ClassroomCourseRulesQuery;

export type GetECourseClassroomRulesPayload = ClassroomECourseRulesQuery;

export type GetLearnPathClassroomRulesPayload = ClassroomLearnPathRulesQuery;

export type GetClassroomInfoPayload = ClassroomInfoQuery;

export type CreateOrUpdateClassroomPayload = CreateOrUpdateClassroomCommand;

export type CreateExpressClassroomPayload = CreateExpressClassroomCommand;

export type DeleteClassroomPayload = DeleteClassroomCommand;

export type UpdateMeetingPayload = UpdateClassroomMeetingCommand;

export type UpdateActivityPayload = UpdateClassroomActivityCommand;

export type CancelMeetingPayload = CancelClassroomMeetingCommand;

export type GetMeetingAttendanceDataPayload = ClassroomMeetingAttendanceQuery;

export type ProcessAwardRuleClassroomPayload = ProcessAwardRuleClassroomCommand;

export type ProcessCertificateRuleClassroomPayload =
  ProcessCertificateRuleClassroomCommand;

export type SaveInstructorsPayload = SaveClassroomInstructorsCommand;

export type SaveClassroomRulesRegistrationPayload =
  SaveClassroomRulesRegistrationCommand;

export type SaveClassroomRulesAssessmentPayload = SaveClassroomRulesAssCommand;

export type SaveClassroomRulesExecutionPayload =
  SaveClassroomRulesExecutionCommand;

export type SaveClassroomRulesInstructorActionPayload =
  SaveClassroomRulesInstructorCommand;

export type SaveClassroomRulesApprovalPayload =
  SaveClassroomRulesApprovalCommand;

export type SaveClassroomPreReqsPayload = SaveClassroomRulesPreReqCommand;

export type SaveClassroomRulesAwardPayload = SaveClassroomRulesAwardCommand;

export type SaveClassroomRulesSeatsPayload = SaveClassroomRulesSeatsCommand;

export type SaveClassroomRulesCertificatePayload =
  SaveClassroomRulesCertificateCommand;

export type SaveClassroomRulesInteractionPayload =
  SaveClassroomRulesInteractionCommand;

export type SaveRulesAgreementPayload = SaveClassroomRulesAgreementCommand;

export type SaveRulesConclusionFormPayload =
  SaveClassroomRulesConclusionFormCommand;

export type CreateCustomFieldPayload = CreateCustomFieldCommand;

export type UpdateCustomFieldPayload = UpdateCustomFieldCommand;

export type DashAnalysisResultsResumePayload = AssAnalysisResultsResumeQuery;

export type DashAnalysisResultsQuestionsListPayload =
  AssAnalysisResultsQuestionsListQuery;

export type DashAnalysisResultsPeopleListPayload =
  AssAnalysisResultsPeopleListQuery;

export type DashAnalysisGroupQuestionResumePayload =
  AssAnalysisGroupQuestionResumeQuery;

export type DashAnalysisGroupQuestionListPayload =
  AssAnalysisGroupQuestionListQuery;

export type DashAnalysisGroupPeopleListPayload =
  AssAnalysisGroupPeopleListQuery;

export type ExportDashAnalysisResultsQuestionsListPayload =
  ExportAssAnalysisQuestionListCommand;

export type ExportDashAnalysisResultsPeopleListPayload =
  ExportAssAnalysisPeopleListCommand;

export type ExportDashAnalysisGroupQuestionListPayload =
  ExportAssAnalysisGroupQuestionListCommand;

export type ExportDashAnalysisGroupPeopleListPayload =
  ExportAssAnalysisGroupPeopleListCommand;

export type DashAwardResumePayload = DashAwardResumeQuery;

export type DashAwardPointsPayload = DashAwardPointsQuery;

export type DashAwardBadgesPayload = DashAwardBadgesQuery;

export type DashAwardUsersRankingPayload = DashAwardUsersRankingListQuery;

export type ExportDashAwardUsersRankingPayload =
  DashAwardExportUsersRankingCommand;

export type DashAwardReasonsPayload = DashAwardReasonsListQuery;

export type ExportDashAwardReasonsPayload = DashAwardExportReasonsCommand;

export type DashAwardUsersBadgesPayload = DashAwardUsersBadgesListQuery;

export type ExportDashAwardUsersBadgesPayload =
  DashAwardExportUsersBadgesCommand;

export type DashAwardBadgesListPayload = DashAwardBadgesListQuery;

export type ExportDashAwardBadgesListPayload = DashAwardExportBadgesCommand;

export type DashAwardPointsStatementPayload = DashAwardPointsStatementListQuery;

export type GetInvoicePayload = BillingInvoiceQuery;

export type GetBillingQuotaPayload = BillingQuotaQuery;

export type GetInvoiceExtractPayload = BillingInvoiceExtractQuery;

export type GetUsersPayload = BillingUsersQuery;

export type GetIaRequestsPayload = BillingIaQuery;

export type GetStreamingFilesPayload = BillingStreamingQuery;

export type GetStreamingDetailsPayload = BillingStreamingDetailsQuery;

export type ExportUsersPayload = BillingUsersExportCommand;

export type ExportStreamingPayload = BillingStreamingExportCommand;

export type ExportIaPayload = BillingIaExportCommand;

export type ChallengeIndicatorsPayload = DashChallengeIndicatorsQuery;

export type ChallengeInsightsPayload = DashChallengeInsightsQuery;

export type ChallengeUsersTopicsSealsPayload =
  DashChallengeUsersTopicsSealsQuery;

export type ChallengeQuestionIncorrectPayload =
  DashChallengeQuestionIncorrectQuery;

export type ChallengeParticipationPayload = DashChallengeParticipationQuery;

export type ChallengeUserEligibleParticipatesPayload =
  DashChallengeUserEligibleParticipateQuery;

export type ChallengeUserAnsweredPayload = DashChallengeUserAnsweredQuery;

export type ChallengeUsersAnalysisPayload = DashChallengeUsersAnalysisQuery;

export type ExportChallengeUsersAnalysisPayload =
  DashChallengeExportUsersAnalysisCommand;

export type ChallengeTopicsAnalysisPayload = DashChallengeTopicsAnalysisQuery;

export type ExportChallengeTopicsAnalysisPayload =
  DashChallengeExportTopicsAnalysisCommand;

export type GetResumeBody = KnowledgePanelGetResumeQuery;

export type GetAnalysisPayload = KnowledgePanelAnalysisQuery;

export type AnalysisDrillByValuePayload =
  KnowledgePanelAnalysisDrillByValueQuery;

export type AnalysisDrillByDetailPayload =
  KnowledgePanelAnalysisDrillByDetailQuery;

export type ExportAnalysisPayload = KnowledgePanelAnalysisExportCommand;

export type GetAvailableReportsPayload = AvailableReportsQuery;

export type GetReportParametersPayload = ReportParametersQuery;

export type ExecuteReportPayload = ReportExecuteCommand;

export type UsersPayload = UserDashboardSuggestionsQuery;

export type TrainingsPayload = TrainingDashboardSuggestionsQuery;

export type GetUserEvolutionPayload = TrainingIndexUserEvolutionQuery;

export type GetTeamEvolutionPayload = TrainingIndexTeamEvolutionQuery;

export type GetTopicEvolutionPayload = TrainingIndexTopicEvolutionQuery;

export type GetUnitEvolutionPayload = TrainingIndexUnitEvolutionQuery;

export type GetGeneralUsersPayload = TrainingIndexGeneralUsersListQuery;

export type GetTopicUsersPayload = TrainingIndexTopicUsersListQuery;

export type GetUnitUsersPayload = TrainingIndexUnitUsersListQuery;

export type GetTeamUsersPayload = TrainingIndexTeamUsersListQuery;

export type GetGeneralKeyTopicsPayload = TrainingIndexGeneralKeyTopicsListQuery;

export type GetUserKeyTopicsPayload = TrainingIndexUserKeyTopicsListQuery;

export type GetUnitKeyTopicsPayload = TrainingIndexUnitKeyTopicsListQuery;

export type GetTeamKeyTopicsPayload = TrainingIndexTeamKeyTopicsListQuery;

export type GetGeneralUnitsPayload = TrainingIndexGeneralUnitsListQuery;

export type GetGeneralUnitsHierarchicalPayload =
  TrainingIndexGeneralUnitsHierarchicalQuery;

export type GetTopicUnitsPayload = TrainingIndexTopicUnitsListQuery;

export type GetTopicUnitsHierarchicalPayload =
  TrainingIndexTopicUnitsHierarchicalQuery;

export type GetUserTrainingsPayload = TrainingIndexUserTrainingsListQuery;

export type GetUserTrainingsSummaryPayload =
  TrainingIndexUserTrainingsSummaryQuery;

export type ExportGeneralUsersPayload = ExportITGeneralUsersListCommand;

export type ExportGeneralTopicsPayload = ExportITGeneralTopicsListCommand;

export type ExportGeneralUnitsPayload = ExportITGeneralUnitsListCommand;

export type ExportUserEvolutionPayload = ExportITUserEvolutionCommand;

export type ExportUserTopicsPayload = ExportITUserTopicsListCommand;

export type ExportUserTrainingsPayload = ExportITUserTrainingsCommand;

export type ExportUnitEvolutionPayload = ExportITUnitEvolutionCommand;

export type ExportUnitUsersPayload = ExportITUnitUsersListCommand;

export type ExportUnitTopicsPayload = ExportITUnitTopicsListCommand;

export type ExportTopicEvolutionPayload = ExportITTopicEvolutionCommand;

export type ExportTopicUsersPayload = ExportITTopicUsersListCommand;

export type ExportTopicUnitsPayload = ExportITTopicUnitsListCommand;

export type ExportTeamEvolutionPayload = ExportITTeamEvolutionCommand;

export type ExportTeamUsersPayload = ExportITTeamUsersListCommand;

export type ExportTeamTopicsPayload = ExportITTeamTopicsListCommand;

export type GetOrCreateCachePayload = TraningPanelGetOrCreateCacheCommand;

export type GetOrCreateCacheTutorPayload =
  TraningPanelGetOrCreateCacheTutorCommand;

export type TrainingAnalysisPayload = TrainingPanelAnalysisQuery;

export type TrainingIndicatorDrillPayload = TrainingPanelIndicatorDrillQuery;

export type ExportTrainingAnalysisPayload = ExportTrainingPanelAnalysisCommand;

export type AudienceNotEnrolledUsersPayload =
  TraningPanelAudienceNotEnrolledUsersQuery;

export type AssDeploySelectionPayload = TraningPanelAssDeploySelectionQuery;

export type AssDeployUserSelectionPayload =
  TraningPanelAssDeployUserSelectionQuery;

export type AssDeployUsersPayload = TraningPanelAssDeployUsersQuery;

export type TutorStatisticsUsersPayload =
  TraningPanelSupervisorStatisticsUsersQuery;

export type OpinionTrainingSelectionPayload = TraningPanelOpinionSelectionQuery;

export type CanceledEnrollsByReasonPayload =
  TraningPanelCanceledEnrollsByReasonQuery;

export type AssAnalysisResumePayload = TrainingPanelAssAnalysisResumeQuery;

export type AssAnalysisQuestionListPayload =
  TrainingPanelAssAnalysisQuestionListQuery;

export type AssAnalysisPeopleListPayload =
  TrainingPanelAssAnalysisPeopleListQuery;

export type ExportDashAnalysisQuestionsListPayload =
  ExportTrainingPanelAssAnalysisQuestionListCommand;

export type ExportDashAnalysisPeopleListPayload =
  ExportTrainingPanelAssAnalysisPeopleListCommand;

export type GetPermissionsPayload = EvolutionPermissionQuery;

export type GetTrainingsResumePayload = EvolutionTrainingResumeQuery;

export type GetTrainingsListPayload = EvolutionTrainingsListQuery;

export type ExportTrainingsListPayload = EvolutionTrainingsListQuery;

export type GetTrainingCertificatesListPayload =
  EvolutionTrainingCertificatesListQuery;

export type GetKnowledgeResumePayload = EvolutionKnowledgeResumeQuery;

export type GetEvolutionKnowledgeListPayload = EvolutionKnowledgeListQuery;

export type ExportEvolutionKnowledgeListPayload = EvolutionKnowledgeListQuery;

export type EvolutionKnowledgeDrillPayload = EvolutionKnowledgeDrillQuery;

export type GetEvolutionChallengeResumePayload = EvolutionChallengeResumeQuery;

export type GetEvolutionChallengeTopicsPayload =
  EvolutionChallengeTopicsListQuery;

export type ExportEvolutionChallengeTopicsPayload =
  ExportEvolutionChallengeTopicsCommand;

export type GetAwardResumeBody = EvolutionAwardResumeQuery;

export type GetAwardRankingListPayload = EvolutionAwardRankingListQuery;

export type GetAwardBadgesPayload = EvolutionAwardBadgesListQuery;

export type DevPlansListPayload = DevPlansListQuery;

export type GetUserPermissionsPayload = DevPlanUserPermissionsQuery;

export type GetUsersListPayload = DevPlanUsersListQuery;

export type GetDevPlanPayload = DevPlanQuery;

export type GetDevPlanViewPayload = DevPlanViewQuery;

export type GetDevPlanItemsPayload = DevPlanItemsQuery;

export type GetDevPlanGroupPayload = DevPlanGroupQuery;

export type DevPlanGroupsPayload = DevPlanGroupsListQuery;

export type DevPlanItemsPayload = DevPlanItemsListQuery;

export type TrainingSelectorPayload = DevPlanTrainingSelectorQuery;

export type GetDevPlanActivityPayload = DevPlanOtherActivityQuery;

export type GetDevPlanActivityContentPayload = DevPlanActivityContentQuery;

export type CheckTrainingApprovedPayload = DevPlanTrainingApprovedQuery;

export type CreateOrUpdateDevPlanPayload = CreateOrUpdateDevPlanCommand;

export type CreateOrUpdateDevPlanGroupPayload =
  CreateOrUpdateDevPlanGroupCommand;

export type PublishPayload = PublishDevPlanCommand;

export type CreateTrainingActivityPayload = CreateTrainingActivityCommand;

export type CreatePublicationActivityPayload = CreatePublicationActivityCommand;

export type CreateOtherActivityPayload = CreateOtherActivityCommand;

export type UpdateDevPlanActivityPayload = UpdateDevPlanActivityCommand;

export type MarkApprovedDevPlanPayload = MarkApprovedDevPlanCommand;

export type MarkReadonlyDevPlanPayload = MarkReadonlyDevPlanCommand;

export type ReorderGroupsPayload = ReorderGroupsCommand;

export type ReorderItemsBody = ReorderItemsCommand;

export type DeletePlanPayload = DeleteDevPlanCommand;

export type ArchivePlanPayload = ArchiveDevPlanCommand;

export type UnarchivePlanPayload = UnarchiveDevPlanCommand;

export type DeleteGroupPayload = DeleteDevPlanGroupCommand;

export type DeleteItemGroupPayload = DeleteDevPlanItemCommand;

export type UpdateOtherActivityProgressPayload =
  UpdateOtherActivityProgressCommand;

export type SendDirectMessagePayload = SendDirectMessageCommand;

export type DeleteDirectMessagePayload = DeleteDirectMessageCommand;

export type MarkReadDirectMessagePayload = MarkReadDirectMessageCommand;

export type GetDirectMessagesPayload = DirectMessageListQuery;

export type GetDirectMessagePayload = DirectMessageQuery;

export type GetCourseEnrollmentPayload = CourseEnrollmentViewQuery;

export type GetLearnPathEnrollmentPayload = LearnPathEnrollmentViewQuery;

export type GetECourseEnrollmentPayload = ECourseEnrollmentViewQuery;

export type GetLearnPathEnrollmentPhasesPayload =
  LearnPathEnrollmentPhasesQuery;

export type GetMeetingItemPayload = MeetingEnrollmentItemQuery;

export type GetPostItemPayload = PostEnrollmentItemQuery;

export type GetActivityItemPayload = ActivityEnrollmentItemQuery;

export type GetMaterialListsPayload = MaterialListsQuery;

export type GetMaterialListCardsPayload = MaterialListCardsQuery;

export type GetTrainingPanelSeeAlsoPayload = TrainingPanelSeeAlsoQuery;

export type GetTrainingPanelSpecialistsPayload = TrainingPanelSpecialistsQuery;

export type GetTrainingPanelTopicsPayload = TrainingPanelTopicQuery;

export type GetEnrolledUsersPayload = EnrolledUsersQuery;

export type GetProgressDetailPayload = EnrollmentProgressDetailQuery;

export type GetScoreDetailPayload = EnrollmentScoreDetailQuery;

export type GetTrainingAgreementPayload = EnrollmentTrainingAgreementQuery;

export type GetEnrollmentViewPreChecksPayload = EnrollmentViewPreChecksRequest;

export type GetEnrollmentWorkflowStatusQueryPayload =
  EnrollmentWorkflowStatusQuery;

export type GetEnrollmentCalendarPayload = EnrollmentCalendarQuery;

export type SearchTrainingsPayload = TrainingContentSearchQuery;

export type GetCourseConclusionFormPayload = CourseConclusionFormQuery;

export type GetEnrollmentFinalResultPayload = EnrollmentFinalResultQuery;

export type GetEnrollmentCalloutsPayload = EnrollmentCalloutsQuery;

export type GetEnrollmentNoticesPayload = EnrollmentNoticesQuery;

export type TrackingContentPayload = TrackingContentCommand;

export type MeetingRecordingTrackingPayload =
  TrackingMeetingRecordingViewCommand;

export type CloseEnrollmentManualPayload = CloseEnrollmentCommand;

export type CancelEnrollmentPayload = CancelEnrollmentCommand;

export type AddRatingPayload = AddRatingEnrollmentCommand;

export type RemoveRatingPayload = RemoveRatingEnrollmentCommand;

export type AddComponentAccessPayload = AddComponentAccessCommand;

export type DiscardMaxTriesAssEnrollmentPayload =
  DiscardMaxTriesAssEnrollmentCommand;

export type RegisterTimeSpentPayload = RegisterTimeSpentCommand;

export type DeliveryActivityPayload = DeliveryActivityCommand;

export type RemoveDeliveredActivityPayload = RemoveDeliveredActivityCommand;

export type RegisterConclusionFormPayload = RegisterConclusionFormCommand;

export type UpdateConclusionFormPayload = UpdateConclusionFormCommand;

export type CheckReuseECourseUnmanagedPayload =
  CheckReuseECourseUnmanagedCommand;

export type SendMessageEnrollmentPayload = SendMessageEnrollmentCommand;

export type GetEnrollmentTrainingsPayload = ManagedEnrollmentTrainingListQuery;

export type GetManagedEnrollmentUsersPayload = ManagedEnrollmentUserListQuery;

export type GetManagedEnrollmentSelectedUsersPayload =
  ManagedEnrollmentSelectedUsersQuery;

export type GetManagedEnrollmentClassroomsPayload =
  ManagedEnrollmentClassroomListQuery;

export type AddUserEnrollPayload = AddUserEnrollOperationCommand;

export type AddAllUserEnrollPayload = AddAllUserEnrollOperationCommand;

export type RemoveUserEnrollPayload = RemoveUserEnrollOperationCommand;

export type ClearUsersEnrollPayload = ClearUsersEnrollOperationCommand;

export type SaveEnrollPayload = SaveEnrollOperationCommand;

export type ProcessEnrollPayload = ProcessEnrollOperationCommand;

export type ImportUserListEnrollPayload = ImportUserListEnrollOperationCommand;

export type ImportUserFileEnrollPayload = ImportUserFileEnrollOperationCommand;

export type ClearImportedUsersEnrollPayload =
  ClearImportedUsersEnrollOperationCommand;

export type ImportEnrollPayload = ImportEnrollCommand;

export type SaveSystemSettingsPayload = SaveSystemSettingsCommand;

export type SaveSystemImagePayload = SaveSystemImageCommand;

export type SaveUserSettingsPayload = SaveUserSettingsCommand;

export type SaveStandardSettingsPayload = SaveStandardAuthSettingsCommand;

export type SaveSamlAuthSettingsPayload = SaveSamlAuthSettingsCommand;

export type SavePerformaSettingsPayload = SavePerformaSettingsCommand;

export type SaveAppAuthSettingsPayload = SaveAppAuthSettingsCommand;

export type SaveSsoSettingsPayload = SaveSsoAuthSettingsCommand;

export type SaveAccessTimeSettingsPayload = SaveAccessTimeRuleSettingsCommand;

export type SaveIaSettingsPayload = SaveIaSettingsCommand;

export type SaveImportSettingsPayload = SaveImportCommand;

export type SaveImportUserSettingsPayload = SaveImportUserCommand;

export type SaveImportUserRemoteSettingsPayload = SaveImportUserRemoteCommand;

export type TestUserRemoteFtpConnectionTestPayload = FtpConnectionTestCommand;

export type SaveOnlineMeetingSettingsPayload = SaveOnlineMeetingSettingsCommand;

export type CreateAllTrainingModelsPayload = CreateAllTrainingModelsCommand;

export type GlobalSearchPreviewPayload = GlobalSearchPreviewQuery;

export type GlobalSearchPayload = GlobalSearchQuery;

export type KnowledgeSearchPayload = KnowledgeSearchQuery;

export type TrainingSearchPayload = TrainingSearchQuery;

export type UserSearchPayload = UserSearchQuery;

export type TopicSearchPayload = TopicSearchQuery;

export type ChannelSearchPayload = ChannelSearchQuery;

export type RagSearchPayload = KnowledgeRagSearchQuery;

export type GetGroupMembersPayload = GroupMembersQuery;

export type GetGroupsPayload = GroupQuery;

export type ManagedGroupsPayload = ManagedGroupsListQuery;

export type GetGroupPayload = ManagedGroupQuery;

export type GroupIsUsedPayload = GroupIsUsedQuery;

export type CreateStaticGroupPayload = CreateStaticGroupCommand;

/**
 * Id do Group
 */
export type UpdateStaticGroupPayload = UpdateStaticGroupCommand;

/**
 * Informações para registro principal do Grupo Dinâmico.
 */
export type CreateDynamicGroupPayload = CreateDynamicGroupCommand;

/**
 * Informações para registro principal do Grupo Dinâmico.
 */
export type UpdateDynamicGroupPayload = UpdateDynamicGroupCommand;

export type DeleteGroupBody = DeleteGroupCommand;

export type ProcessDynamicGroupPayload = ProcessDynamicGroupCommand;

export type ManagedGroupMembersListPayload = ManagedGroupMembersListQuery;

export type ManagedGroupGetCurrentMembersPayload =
  ManagedGroupCurrentMembersQuery;

export type AddMemberStaticGroupPayload = AddMemberStaticGroupCommand;

export type DeleteMemberStaticGroupPayload = DeleteMemberStaticGroupCommand;

export type JoinMembersStaticGroupPayload = JoinMembersStaticGroupCommand;

export type ImportUserMemberToStaticGroupPayload =
  ImportUserMemberToStaticGroupCommand;

export type DeleteAllMemberStaticGroupPayload =
  DeleteAllMemberStaticGroupCommand;

export type GroupMembersExportPayload = GroupMembersExportQuery;

export type GetIndicatorDataPayload = IndicatorDataQuery;

export type SaveBody = ManageSaveIndicatorCommand;

export type DeletePayload = DeleteIndicatorCommand;

export type ReorderPayload = ReorderIndicatorCommand;

export type ListPayload = ManagedInstructorListQuery;

export type GetClassesPayload = ManagedInstructorClassesQuery;

export type GetAppointmentsPayload = ManagedInstructorAppointmentsQuery;

export type GetCalendarPayload = ManagedInstructorCalendarQuery;

export type GetAppointmentPayload = InstructorAppointmentQuery;

export type CreateOrUpdateAppointmentPayload = CreateOrUpdateAppointmentCommand;

export type DeleteAppointmentPayload = DeleteAppointmentCommand;

export type MeetingInstructorOnlineUrlPayload = MeetingInstructorOnlineUrlQuery;

export type PublicationCommentsPayload = CommentListQuery;

export type CreatePublicationCommentPayload = CreateCommentCommand;

export type UpdatePublicationCommentPayload = UpdateCommentCommand;

export type DeletePublicationCommentPayload = DeleteCommentCommand;

export type LikePublicationCommentPayload = CommentLikeCommand;

export type GetFeedStartupPayload = FeedStartupQuery;

export type GetFeedShortsPayload = FeedShortVideoQuery;

export type GetFeedMyContributionsPayload = FeedMyContributionsQuery;

export type GetFeedMyAnswersPayload = FeedMyAnswersQuery;

export type GetFeedMyDraftsPayload = FeedMyDraftsQuery;

export type GetFeedListPayload = FeedListQuery;

export type GetFeedQuestionPayload = FeedQuestionQuery;

export type GetFeedItemPayload = FeedItemQuery;

export type GetFeedListByTypePayload = FeedListByTypeQuery;

export type GetFeedThreadItemsPayload = FeedThreadItemsQuery;

export type GetFeedMyListsPayload = FeedMyListsQuery;

export type GetFeedHistoryPayload = FeedHistoryQuery;

export type GetFeedQuestionRecentPayload = FeedQuestionRecentQuery;

export type GetFeedQuestionToYouPayload = FeedQuestionToYouQuery;

export type GetFeedQuestionFollowingPayload = FeedQuestionFollowingQuery;

export type GetFeedChannelHeaderPayload = FeedChannelHeaderQuery;

export type GetFeedChannelPanelUsersMostPublicationPayload =
  FeedChannelPanelUsersMostPublicationQuery;

export type GetFeedChannelPanelTopicsMentionPayload =
  FeedChannelPanelTopicsMentionQuery;

export type GetQuickFilterFeedChannelPayload = FeedChannelQuickFilterQuery;

export type GetFeedChannelPayload = FeedChannelQuery;

export type GetFeedPublicationAdminPayload = FeedPublicationAdminQuery;

export type GetFeedPublicationAdminRestrictionsPayload =
  FeedPublicationAdminRestrictionsQuery;

export type GetFeedTopicPanelChannelMostMentionPayload =
  FeedTopicPanelChannelMostMentionQuery;

export type GetFeedTopicPanelRelationPayload = FeedTopicPanelRelationQuery;

export type GetFeedTopicPanelSpecialistInterestPayload =
  FeedTopicPanelSpecialistInterestQuery;

export type GetFeedUserProfilePayload = FeedUserProfileQuery;

export type GetQuickFilterFeedUserPayload = FeedUserQuickFilterQuery;

export type GetFeedUserPanelProfessionalInterestPayload =
  FeedUserPanelProfessionalInterestQuery;

export type GetFeedUserPanelPersonalInterestPayload =
  FeedUserPanelPersonalInterestQuery;

export type GetFeedPanelUserFollowingPayload = FeedPanelUserFollowingQuery;

export type GetFeedPanelUserFollowersPayload = FeedPanelUserFollowersQuery;

export type GetFeedPanelUserStatisticPayload = FeedPanelUserStatisticQuery;

export type GetFeedPanelUsersSameInterestTagPayload =
  FeedPanelUsersSameInterestTagQuery;

export type GetFeedPanelUserCredentialsPayload = FeedPanelUserCredentialsQuery;

export type GetFeedTopicHeaderPayload = FeedTopicHeaderQuery;

export type GetFeedTopicPayload = FeedTopicQuery;

export type GetQuickFilterFeedTopicPayload = FeedTopicQuickFilterQuery;

export type MarkPublicationReadPayload = MarkReadCommand;

export type AddOrRemoveLikePayload = AddOrRemoveLikeCommand;

export type PublicationToogleChannelPinnedPayload =
  PublicationToogleChannelPinnedCommand;

export type PublicationsForApprovalPayload = PublicationsForApprovalQuery;

export type ReportsForApprovalPayload = ReportsForApprovalQuery;

export type ChannelSubscriptionsForApprovalPayload =
  ChannelSubscriptionsForApprovalQuery;

export type GetOtherReportsPayload = OtherReportsQuery;

export type ModeratePublicationPayload = ModeratePublicationCommand;

export type GetCreationSettingsPayload = GetCreationSettingsQuery;

export type GetAdvancedOptionsSettingsPayload = GetAdvancedOptionsSettingsQuery;

export type GetPostPublicationPayload = GetPostPublicationQuery;

export type GetPostThreadPublicationPayload = GetPostThreadPublicationQuery;

export type GetPostListExclusivePublicationPayload =
  GetPostListExclusivePublicationQuery;

export type GetBinderPublicationPayload = GetBinderPublicationQuery;

export type GetPollPublicationPayload = GetPollPublicationQuery;

export type GetPollThreadPublicationPayload = GetPollThreadPublicationQuery;

export type GetPollResultsPayload = GetPollResultsQuery;

export type GetQuestionPublicationPayload = GetQuestionPublicationQuery;

export type GetAnswerPublicationPayload = GetAnswerPublicationQuery;

export type GetListPublicationPayload = GetListPublicationQuery;

export type GetPublicationThreadSequencePayload =
  GetPublicationThreadSequenceQuery;

export type GetListPublicationItemsDisplayOrderPayload =
  GetListPublicationItemsDisplayOrderQuery;

export type GetListPublicationInPlaybackPayload =
  GetListPublicationInPlaybackQuery;

export type GetListPermissionsPayload = GetListPermissionsQuery;

export type GetRelationshipsPayload = GetRelationshipPublicationQuery;

export type GetThumbnailPublicationPayload = GetThumbnailPublicationQuery;

export type GetUnblockRequestPayload = GetUnblockRequestPublicationQuery;

export type GetWhoLikesPayload = WhoLikesPublicationQuery;

export type GetWhoAnsweredPollPayload = WhoAnsweredPollPublicationQuery;

export type GetWhoViewPayload = WhoViewPublicationQuery;

export type GetUserListsPayload = GetUserListsQuery;

export type GetRelatedPublicationsPayload = GetRelatedPublicationsQuery;

export type GetPeopleInterestedPayload = GetPeopleInterestedQuery;

export type GetPublicationFollowersPayload = GetPublicationFollowersQuery;

export type GetTopicPeopleInterestedPayload = GetTopicPeopleInterestedQuery;

export type GetContentPayload = PublicationContentQuery;

export type GetCommentContentPayload = GetPublicationCommentContentQuery;

export type GetPublicationShortVideosPayload = PublicationShortVideosQuery;

export type GetAttachTranscriptionPayload = GetAttachTranscriptionQuery;

export type ReportAnalysedInfoPayload = PublicationReportAnalysedInfoQuery;

export type UpdateMediaPosterPayload = UpdateVideoPosterCommand;

export type PublicationRagSearchPayload = PublicationRagSearchQuery;

export type GetPostClassifyPublicationPayload = GetPostClassifyPublicationQuery;

export type GetPollClassifyPublicationPayload = GetPollClassifyPublicationQuery;

export type GetListClassifyPublicationPayload = GetListClassifyPublicationQuery;

export type GetQuestionClassifyPublicationPayload =
  GetQuestionClassifyPublicationQuery;

export type CreateOrUpdatePostPublicationPayload = CreateOrUpdatePostCommand;

export type CreateOrUpdatePostThreadPublicationPayload =
  CreateOrUpdatePostThreadCommand;

export type CreateOrUpdatePostListExclusivePublicationPayload =
  CreateOrUpdatePostListExclusiveCommand;

export type CreateOrUpdateBinderPublicationPayload =
  CreateOrUpdateBinderCommand;

export type CreateOrUpdatePollPublicationPayload = CreateOrUpdatePollCommand;

export type CreateOrUpdatePollThreadPublicationPayload =
  CreateOrUpdatePollThreadCommand;

export type AddPollAnswerCommandPayload = AddPollAnswerCommand;

export type CreateOrUpdateQuestionPublicationPayload =
  CreateOrUpdateQuestionCommand;

export type CreateOrUpdateAnswerPublicationPayload =
  CreateOrUpdateAnswerCommand;

export type CreateOrUpdateListPublicationPayload = CreateOrUpdateListCommand;

export type AddListItemPayload = AddListItemCommand;

export type RemoveListItemPayload = RemoveListItemCommand;

export type ClearListItemsPayload = ClearListItemsCommand;

export type ReorderListItemsPayload = ReorderListItemsCommand;

export type ThreadReorderPayload = ThreadReorderCommand;

export type DeletePublicationPayload = DeletePublicationCommand;

export type AddAbuseReportPayload = AddAbuseReportPublicationCommand;

export type AddRelationshipPublicationPayload =
  AddRelationshipPublicationCommand;

export type RemoveRelationshipPublicationPayload =
  RemoveRelationshipPublicationCommand;

export type AddRelationshipTrainingPayload = AddRelationshipTrainingCommand;

export type RemoveRelationshipTrainingPayload =
  RemoveRelationshipTrainingCommand;

export type BlockPublicationPayload = BlockPublicationCommand;

export type UnblockPublicationPayload = UnblockPublicationCommand;

export type UpdateThumbnailPublicationPayload =
  UpdateThumbnailPublicationCommand;

export type RequestUnblockPayload = RequestUnblockPublicationCommand;

export type AddRecommendationPayload = AddRecommendationPublicationCommand;

export type SharePayload = SharePublicationCommand;

export type HidePublicationPayload = HidePublicationCommand;

export type CreatePrivateListPayload = CreatePrivateListCommand;

export type AddToListFavoritesPayload = AddToListFavoritesCommand;

export type AddToListSeeLaterPayload = AddToListSeeLaterCommand;

export type RemoveItemFromListsPayload = RemoveItemFromListsCommand;

export type TrackMediaPayload = TrackMediaCommand;

export type CreateBatchPublicationPayload = CreateBatchPublicationCommand;

export type UpdatePostClassifyPublicationPayload =
  UpdatePostClassifyPublicationCommand;

export type UpdatePollClassifyPublicationPayload =
  UpdatePollClassifyPublicationCommand;

export type UpdateListClassifyPublicationPayload =
  UpdateListClassifyPublicationCommand;

export type UpdateQuestionClassifyPublicationPayload =
  UpdateQuestionClassifyPublicationCommand;

export type RepassQuestionPayload = RepassQuestionCommand;

export type RestorePublicationPayload = RestorePublicationCommand;

export type CreateQuickFilterPayload = CreateQuickFilterCommand;

export type UpdateQuickFilterPayload = UpdateQuickFilterCommand;

export type DeleteQuickFilterPayload = DeleteQuickFilterCommand;

export type SelectQuickFiltersPayload = SelectQuickFiltersCommand;

export type GetSelectionQuickFilterPayload = SelectionQuickFiltersQuery;

export type GetQuickFilterTypesPayload = ManagedQuickFilterTypeListQuery;

export type ManagedQuickFilterPayload = ManagedQuickFiltersListQuery;

export type GetQuickFilterPayload = ManagedQuickFilterQuery;

export type ChannelsPayload = ChannelSelectorQuery;

export type PublicationsBody = PublicationSelectorQuery;

export type SaveKnowledgeSettingsPayload = SaveKnowledgeSettingsCommand;

export type AddTopicToPromoteSettingsPayload = AddTopicToPromoteSettingsCommand;

export type DeleteTopicToPromoteSettingsPayload =
  DeleteTopicToPromoteSettingsCommand;

export type AddChannelToPromoteSettingsPayload =
  AddChannelToPromoteSettingsCommand;

export type DeleteChannelToPromoteSettingsPayload =
  DeleteChannelToPromoteSettingsCommand;

export type SaveKnowledgeAwardSettingsPayload =
  SaveKnowledgeAwardSettingsCommand;

export type ManagedListPayload = ManagedShortVideoListQuery;

export type ManagingContainsConfidentialPublicationPayload =
  ManagedShortVideoConfidentialQuery;

export type GetShortVideoPayload = GetShortVideoQuery;

export type PublicationSelectorPayload = PublicationShortVideoSelectorQuery;

export type SaveShortVideoPayload = CreateOrUpdateShortVideoCommand;

export type DeleteShortVideoPayload = DeleteShortVideoCommand;

export type GetQuickAccessListPayload = QuickAccessQuery;

export type ManagedQuickAccessListPayload = ManagedQuickAccessQuery;

export type ChannelSubscriptionsPayload = ChannelSubscriptionsQuery;

export type TopicSubscriptionsPayload = TopicSubscriptionsQuery;

export type AuthorSubscriptionsPayload = AuthorSubscriptionsQuery;

export type ListSubscriptionsPayload = ListSubscriptionsQuery;

export type RequestChannelSubscriptionPayload =
  RequestChannelSubscriptionCommand;

export type RefuseChannelSubscriptionPayload = RefuseChannelSubscriptionCommand;

export type AcceptChannelSubscriptionPayload = AcceptChannelSubscriptionCommand;

export type ChannelSubscriptionsSettingsPayload =
  ChannelSubscriptionsSettingsQuery;

export type UnsubscribeChannelPayload = UnsubscribeChannelCommand;

export type SubscribeTopicPayload = SubscribeTopicCommand;

export type UnsubscribeTopicPayload = UnsubscribeTopicCommand;

export type SubscribePublicationPayload = SubscribePublicationCommand;

export type UnsubscribePublicationPayload = UnsubscribePublicationCommand;

export type SubscribeUserPayload = SubscribeUserCommand;

export type UnsubscribeUserPayload = UnsubscribeUserCommand;

export type ToggleHidePayload = SubscriptionToggleHideCommand;

export type ToggleMutedChannelPayload = ToggleMutedChannelCommand;

export type ToggleMutedTopicPayload = ToggleMutedTopicCommand;

export type ToggleMutedUserProfilePayload = ToggleMutedUserProfileCommand;

export type ToggleSilenceProfilePayload = ToggleSilenceProfileCommand;

export type ToggleBlockProfilePayload = ToggleBlockProfileCommand;

export type ProfileRequestConnectionPayload = ProfileRequestConnectionCommand;

export type ChannelsBody = ChannelSuggestionsQuery;

export type ManagedChannelsPayload = ManagedChannelSuggestionsQuery;

export type ChannelsAddMembersPayload = ChannelAddMembersSuggestionsQuery;

export type ModeratorsChannelPayload = ModeratorChannelSuggestionsQuery;

export type FeedChannelPayload = FeedChannelSuggestionsQuery;

export type ChannelUsersMembersSuggestionPayload =
  ChannelUsersMembersSuggestionQuery;

export type ChannelMemberUsersPayload = ChannelMemberUsersSuggestionQuery;

export type ChannelMemberGroupsPayload = ChannelMemberGroupsSuggestionQuery;

export type PublicationRecommendationGroupsPayload =
  RecommendationGroupsSuggestionQuery;

export type PublicationAuthorsPayload = AuthorSuggestionsQuery;

export type GetDiscussionClassroomPayload = ClassroomDiscussionListQuery;

export type GetDiscussionDevPlanPayload = DevPlanDiscussionListQuery;

export type CreateDiscussionClassroomPayload = CreateClassroomDiscussionCommand;

export type UpdateDiscussionClassroomPayload = UpdateClassroomDiscussionCommand;

export type DeleteDiscussionClassroomPayload = DeleteClassroomDiscussionCommand;

export type LikeDiscussionClassroomPayload = LikeClassroomDiscussionCommand;

export type CreateDiscussionDevPlanPayload = CreateDevPlanDiscussionCommand;

export type UpdateDiscussionDevPlanPayload = UpdateDevPlanDiscussionCommand;

export type DeleteDiscussionDevPlanPayload = DeleteDevPlanDiscussionCommand;

export type LikeDiscussionDevPlanPayload = LikeDevPlanDiscussionCommand;

export type DevPlanUserDiscussionSuggestionsPayload =
  DevPlanUserDiscussionSuggestionsQuery;

export type DevPlanUserDiscussionSelectorPayload =
  DevPlanUserDiscussionSuggestionsQuery;

export type WorkflowPreApprovalPayload = WorkflowPreApprovalQuery;

export type WorkflowConclusionFormPayload = WorkflowcConclusionFormQuery;

export type GetSupervisorTrainingsPayload = SupervisorTrainingsQuery;

export type GetSupervisorClassroomsPayload = SupervisorClassroomsQuery;

export type GetSupervisorClassroomNoticesPayload =
  SupervisorClassroomNoticesQuery;

export type GetSupervisorClassroomDiscussionsPayload =
  SupervisorClassroomDiscussionsQuery;

export type GetSupervisorClassroomMeetingsPayload =
  SupervisorClassroomMeetingsQuery;

export type GetSupervisorInsightsPayload = SupervisorInsightsQuery;

export type GetSupervisorEnrollmentPayload = SupervisorEnrollmentsQuery;

export type GetSupervisorHeaderPayload = SupervisorHeaderQuery;

export type GetSupervisorMeetingsPayload = SupervisorMeetingsQuery;

export type GetSupervisorActivitiesPayload = SupervisorActivitiesQuery;

export type GetSupervisorClassroomSchedulePayload = ClassroomScheduleQuery;

export type GetSupervisorStatisticsPayload = SupervisorStatisticsQuery;

export type GetSupervisorStatisticsDrillPayload =
  SupervisorStatisticsDrillQuery;

export type GetRegisterMeetingAttendedPayload = RegisterMeetingAttendedQuery;

export type GetRegisterActivityScorePayload = RegisterActivityScoreQuery;

export type GetRegisterMeetingsMatrixPayload = RegisterMeetingMatrixQuery;

export type GetRegisterActivitiesMatrixPayload =
  RegisterActivityScoreMatrixQuery;

export type GetSupervisorEnrollmentDetailsPayload =
  SupervisorEnrollmentDetailsQuery;

export type GetSupervisorClassroomMeetingPayload =
  SupervisorClassroomMeetingQuery;

export type WorkflowActionPayload = WorkflowActionCommand;

export type AddEnrollmentExtraTimePayload = AddEnrollmentExtraTimeCommand;

export type CancelEnrollmentBody = CancelBatchEnrollmentCommand;

export type DeleteClassroomNoticePayload = DeleteClassroomNoticeCommand;

export type RegisterMeetingAttendedPayload = RegisterMeetingAttendedCommand;

export type RegisterActivityScorePayload = RegisterActivityScoreCommand;

export type InstructorUpdateMeeetingPayload =
  SupervisorUpdateClassroomMeetingCommand;

export type InstructorUndoCancelMeetingPayload =
  SupervisorUndoCancelClassroomMeetingCommand;

export type InstructorPublishMeetingRecordingPayload =
  SupervisorPublishMeetingRecordingCommand;

export type DirectMessageToClassroomPayload = DirectMessageToClassroomCommand;

export type GetPostPayload = PostQuery;

export type GetActivityPayload = ActivityQuery;

export type GetNoticePayload = NoticeQuery;

export type GetTrainingPostItemPayload = PostItemQuery;

export type GetActivityItemBody = ActivityItemQuery;

export type GetTrainingContentPostItemPayload = ContentPostItemQuery;

export type GetSupervisorClassroomActivityPayload =
  SupervisorClassroomActivityQuery;

export type CreateOrUpdatePostExclusiveTrainingPayload =
  CreateOrUpdatePostExclusiveTrainingCommand;

export type CreateOrUpdateActivityExclusiveTrainingPayload =
  CreateOrUpdateActivityExclusiveTrainingCommand;

export type CreatePostExclusiveTrainingFromPublicationPayload =
  CreatePostExclusiveTrainingFromPublicationCommand;

export type CreateOrUpdatePostComponentPayload =
  CreateOrUpdatePostComponentCommand;

export type CreateOrUpdateActivityComponentPayload =
  CreateOrUpdateActivityComponentCommand;

export type CreatePostComponentFromPublicationPayload =
  CreatePostComponentFromPublicationCommand;

export type CreateOrUpdateMaterialListPostPayload =
  CreateOrUpdateMaterialListPostCommand;

export type CreateOrUpdateNoticePayload = CreateOrUpdateNoticeCommand;

export type SupervisorUpdateActivityPayload = SupervisorUpdateActivityCommand;

export type SupervisorCancelActivityPayload = SupervisorCancelActivityCommand;

export type SupervisorUndoCancelActivityPayload =
  SupervisorUndoCancelActivityCommand;

export type QrMeetingRegisterAttendancePayload =
  QrMeetingRegisterAttendanceCommand;

export type RegistrationIntoTrainingChecksPayload =
  RegistrationIntoTrainingChecksQuery;

export type CreateEnrollPayload = CreateEnrollCommand;

export type EnrollSubordinatesPayload = EnrollSubordinatesCommand;

export type AddTrainingInterestPayload = AddTrainingInterestCommand;

export type RemoveTrainingInterestPayload = RemoveTrainingInterestCommand;

export type TrainingUsersInterestPayload = TrainingUsersInterestQuery;

export type CreateExemptEnrollPayload = CreateExemptEnrollCommand;

export type DeleteExemptEnrollPayload = DeleteExemptEnrollCommand;

export type UserDiscussionSelectorPayload = UserDiscussionSuggestionsQuery;

export type TrainingPayload = TrainingSelectorQuery;

export type TrainingRelationshipPayload = TrainingRelationshipSelectorQuery;

export type TrainingMaterialListPayload = TrainingMaterialListSelectorQuery;

export type TrainingEnrollmentPayload = ManagedEnrollmentTrainingSelectorQuery;

export type LpGameRankingsPayload = LpGameRankingSelectorQuery;

export type TrainingEnrollSubordinatesPayload =
  TrainingEnrollSubordinateSelectorQuery;

export type GetListEventRoomPayload = MeetingRoomListQuery;

export type GetMeetingRoomPayload = GetMeetingRoomQuery;

export type SaveSettingsPayload = SaveSettingsCommand;

export type SaveReminderPayload = SaveReminderSettingsCommand;

export type SaveKnowledgeTestPayload = SaveKnowledgeTestSettingsCommand;

export type SaveIndexTrainingSettingsPayload = SaveIndexTrainingSettingsCommand;

export type RequestTrainingIndexExecutionPayload =
  RequestTrainingIndexExecutionCommand;

export type CreateMeetingRoomPayload = CreateMeetingRoomCommand;

export type UpdateMeetingRoomPayload = UpdateMeetingRoomCommand;

export type DeleteMeetingRoomPayload = DeleteMeeetingRoomCommand;

export type SaveAwardSettingsPayload = SaveLmsAwardSettingsCommand;

export type SaveRulesInteractionSettingsPayload =
  SaveSettingsRulesInteractionCommand;

export type SaveRulesInstructorActionSettingsPayload =
  SaveSettingsRulesInstructorCommand;

export type SaveRulesLimitsSettingsPayload = SaveSettingsRulesLimitsCommand;

export type SaveRulesAwardSettingsPayload = SaveSettingsRulesAwardCommand;

export type SaveRulesRegistrationSettingsPayload =
  SaveSettingsRulesRegistrationCommand;

export type SaveRulesExecutionSettingsPayload =
  SaveSettingsRulesExecutionCommand;

export type SaveRulesAssessmentSettingsPayload =
  SaveSettingsRulesAssessmentCommand;

export type SaveRulesConclusionFormSettingsPayload =
  SaveSettingsRulesConclusionFormCommand;

export type SaveRulesLpReEnrollSettingsPayload =
  SaveSettingsRulesLearnPathReEnrollCommand;

export type SaveRulesLpComponentRegistrationSettingsPayload =
  SaveSettingsRulesLearnPathComponentRegistrationCommand;

export type SaveRulesLpApprovalSettingsPayload =
  SaveSettingsRulesLearnPathApprovalCommand;

export type SaveRulesApprovalSettingsPayload = SaveSettingsRulesApprovalCommand;

export type SaveRulesCertificateSettingsPayload =
  SaveSettingsRulesCertificateCommand;

export type GetCarouselTrainingAttendingPayload =
  CarouselTrainingAttendingQuery;

export type GetCarouselTrainingMandatoryPayload =
  CarouselTrainingMandatoryQuery;

export type GetCatalogPayload = CatalogQuery;

export type GetTopicTrainingsPayload = TopicQuery;

export type GetAvailableTrainingsPayload = AvailableTrainingsQuery;

export type GetAttendingTrainingsPayload = AttendingTrainingsQuery;

export type GetFinishedTrainingsPayload = FinishedTrainingsQuery;

export type GetLibraryPayload = LibraryTrainingsQuery;

export type GetHistoryPayload = HistoryQuery;

export type GetHistoryItemPayload = HistoryItemQuery;

export type GetCalendarBody = CalendarQuery;

export type GetCalendarAppointmentsPayload = CalendarAppointmentsQuery;

export type IsMeetingInstructorPayload = IsMeetingInstructorQuery;

export type UserInteractionPayload = TrainingUserInteractionCommand;

export type AddRecommendationBody = AddTrainingRecommendationCommand;

export type ShareTrainingPayload = ShareTrainingCommand;

export type SaveCalloutPayload = SaveCalloutCommand;

export type TrainingsBody = TrainingSuggestionsQuery;

export type ClassroomsPayload = ClassroomSuggestionsQuery;

export type TrainingInstructorsPayload = TrainingInstructorSuggestionsQuery;

export type ClassroomInstructorsPayload = ClassroomInstructorSuggestionsQuery;

export type SupervisorInstructorsPayload = SupervisorInstructorSuggestionsQuery;

export type TrainingVersionComponentsPayload =
  TrainingVersionComponentSuggestionsQuery;

export type MeetingRoomsPayload = MeetingRoomSuggestionsQuery;

export type QuestionGroupHierarchicalPayload =
  QuestionGroupSuggestionsHierarchicaQuery;

export type UserDiscussionSuggestionsPayload = UserDiscussionSuggestionsQuery;

export type LpGameScoreComponentsPayload = LpGameScoreComponentSuggestionsQuery;

export type AudienceUserSuggestionsPayload =
  TrainingAudienceUserSuggestionsQuery;

export type CancelEnrollReasonSuggestionsPayload =
  LmsCancelEnrollReasonSuggestionsQuery;

export type DiscoverUserTrainingInfoPayload = DiscoverUserTrainingInfoQuery;

export type GetTrainingViewPayload = TrainingViewQuery;

export type GetTrainingPreviewPayload = TrainingPreviewQuery;

export type GetClassroomsViewPayload = ClassroomViewQuery;

export type GetLearnPathPhasesViewPayload = LearnPathPhasesViewQuery;

export type GetTrainingAssessmentItemPayload = TrainingAssessmentItemQuery;

export type TrainingSetAgreementPayload = TrainingAgreeCommandRequest;

export type CreteBlockReasonPayload = CreateBlockReasonCommand;

export type UpdateBlockReasonPayload = UpdateBlockReasonCommand;

export type SetTemporaryOrPermanentBlockReasonPayload =
  SetTemporaryBlockReasonCommand;

export type ManagedMailTemplatesPayload = ManagedMailTemplateListQuery;

export type GetMailTemplatePayload = ManagedMailTemplateQuery;

export type SaveMailTemplatePayload = UpdateMailTemplateCommand;

export type DeclinePayload = ManagerEfficacyDeclineCommand;

export type ManagerEfficacyUsersPayload = ManagerEfficacyUserListQuery;

export type ManagerEfficayParticipantsPayload =
  ManagedEfficacySurveyParticipantsQuery;

export type RegisterPayload = RegisterMediaTrackCommand;

export type GetWorkspaceNewMessagesCounterPayload =
  WorkspaceNewMessagesCounterQuery;

export type GetWorkspaceMessagesPayload = WorkspaceMessagesQuery;

export type GetWorkspaceMessageUsersPayload = WorkspaceMessageUsersQuery;

export type HideWorkspaceNotificationPayload = HideWorkspaceNotificationCommand;

export type ClearWorkspaceNotificationsPayload =
  ClearWorkspaceNotificationsCommand;

export type ChooseLandingpagePayload = ChooseLandingpageCommand;

export type GetGoalDashboardPowerMindsPayload = GoalDashboardCommand;

export type GetAssessmentPowerMindsPayload = PerformanceReviewsCommand;

export type ReceiveIntegrationDataPayload = ReceiveIntegrationDataCommand;

export type GetMatchSubtitlesPayload = VideoMatchSubtitlesQuery;

export type ManagedQuestionGroupsPayload = ManagedQuestionGroupListQuery;

export type ManagedGetQuestionGroupPayload = ManagedQuestionGroupQuery;

export type ManagedQuestionsPayload = ManagedQuestionListQuery;

export type ManagedGetQuestionPayload = ManagedQuestionQuery;

export type ManagedQuestionDefaultValuesPayload =
  ManagedQuestionDefaultValuesQuery;

export type GetQuestionSelectPayload = QuestionSelectListQuery;

export type QuestionGroupSelectInfoPayload = QuestionGroupSelectInfoQuery;

export type QuestionGroupKnowledgeTestInfoPayload =
  QuestionGroupKnowledgeTestInfoQuery;

export type GetQuestionVersionsPayload = ManagedQuestionVersionListQuery;

export type GetOpenAiQuestionsPayload = GetOpenAIQuestionsRequest;

export type GetOpenAiQuestionsFromPubPayload = GetOpenAIQuestionsFromPubQuery;

export type QuestionsChallengePayload = QuestionChallengeListQuery;

export type CreateQuestionGroupPayload = CreateQuestionGroupCommand;

export type UpdateQuestionGroupPayload = UpdateQuestionGroupCommand;

export type DeleteQuestionGroupPayload = DeleteQuestionGroupCommand;

export type JoinQuestionGroupPayload = JoinQuestionGroupCommand;

export type SaveQuestionPayload = SaveQuestionCommand;

export type SaveAiQuestionPayload = SaveAIQuestionCommand;

export type DeleteQuestionPayload = DeleteQuestionCommand;

export type BlockOrUnblockQuestionPayload = BlockOrUnblockQuestionCommand;

export type AllowKnowledgeTestPayload = QuestionAllowKnowledgeTestCommand;

export type UpdateQuestionPointsPayload = UpdateQuestionPointsCommand;

export type ChangeAllowKnowledgeTestAllQuestionGroupPayload =
  AllowKnowledgeTestAllQuestionGroupCommand;

export type BlockOrUnblockAllQuestionGroupPayload =
  BlockOrUnblockAllQuestionGroupCommand;

export type ImportQuestionFilePayload = ImportQuestionFileCommand;

export type CopyQuestionsToNewGroupPayload = CopyQuestionsToNewGroupCommand;

export type GetManagedReportListPayload = ManagedReportListQuery;

export type GetManagedReportPayload = ManagedReportQuery;

export type CreateOrUpdateReportPayload = CreateOrUpdateReportCommand;

export type DeleteReportPayload = DeleteReportCommand;

export type ExecutePreviewPayload = ReportExecutePreviewCommand;

export type GetSchedulePayload = ReportScheduleQuery;

export type CreateOrUpdateSchedulePayload = CreateOrUpdateReportScheduleCommand;

export type UpdateScheduleReportParamsPayload =
  UpdateReportScheduleParamsCommand;

export type DeleteSchedulePayload = DeleteReportScheduleCommand;

export type AddOrUpdateReportGroupPayload = AddOrUpdateReportGroupCommand;

export type DeleteReportGroupPayload = DeleteReportGroupCommand;

export type SchedulerJobsStatusPayload = SchedulerTaskQuery;

export type SchedulerTaskLogPayload = SchedulerTaskLogQuery;

export type JobProcessesPayload = JobProcessQuery;

export type JobProcessDetailPayload = JobProcessDetailQuery;

export type QueueEventsPayload = QueueEventsQuery;

export type QueueEventDetailPayload = QueueEventDetailQuery;

export type LoadDataQueuePayload = LoadDataQueueQuery;

export type MessagingQueuePayload = MessagingQueueQuery;

export type ReprocessQueuePayload = ReprocessQueueCommand;

export type GetTrainingsPayload = ScormDebugTrainingsListQuery;

export type TrainingSelectorBody = ScormTrainingSelectorQuery;

export type GetLogPayload = ScormLogQuery;

export type ChangeDebugPayload = ChangeScormDebugCommand;

export type CreateOrUpdatePayload = CreateOrUpdateManagerTypeCommand;

export type UpdateExternalCodePayload = UpdateExternalCodeCommand;

export type ManagedRolesPayload = ManagedRoleListQuery;

export type GetRolePayload = ManagedRoleQuery;

/**
 * Informações para registro principal do Papel.
 */
export type CreateRolePayload = CreateRoleCommand;

export type UpdateRolePayload = UpdateRoleCommand;

export type DeleteRolePayload = DeleteRoleCommand;

export type CloneRolePayload = CloneRoleCommand;

export type GetUsersBody = ManagedRoleUsersQuery;

export type GetUserSuggestionsPayload = ManagedRoleUserSuggestionsQuery;

export type AddUserPayload = RoleUserCreateCommand;

export type DeleteUserPayload = RoleUserDeleteCommand;

export type ReactivateUserPayload = RoleUserReactivateCommand;

export type DesactivateUserPayload = RoleUserDesactivateCommand;

export type GetUserConstraintsPayload = ManagedRoleUserConstraintsQuery;

export type GetUserGroupsAssignedPayload = ManagedRoleUserGroupsAssignedQuery;

export type SaveUserConstraintsPayload = RoleUserConstraintsCommand;

export type GetUserConflitResolutionPayload =
  ManagedRoleUserConflitResolutionQuery;

export type SaveUserConflitResolutionPayload = RoleUserConflitResolutionCommand;

export type GetGroupsBody = ManagedRoleGroupsQuery;

export type AddGroupsPayload = RoleGroupCreateCommand;

export type DeleteGroupInput = RoleGroupDeleteCommand;

export type GetGroupConstraintsPayload = ManagedRoleGroupConstraintsQuery;

export type SaveGroupConstraintsPayload = RoleGroupConstraintsCommand;

export type GetGroupConflitResolutionPayload =
  ManagedRoleGroupConflitResolutionQuery;

export type SaveGroupConflitResolutionPayload =
  RoleGroupConflitResolutionCommand;

export type GroupsPayload = GroupSelectorQuery;

export type UsersBody = UserSelectorQuery;

export type ManagersPayload = ManagerSelectorQuery;

export type SubordinatesPayload = SubordinateSelectorQuery;

export type PermissionsPayload = PermissionsSelectorQuery;

export type UnitsTreePayload = UnitsSelectionTreeQuery;

export type ManagedMemberPayload = ManagedMemberSelectorQuery;

export type TagsPayload = TagSelectorQuery;

export type GroupUsagesPayload = GroupUsagesSelectorQuery;

export type RolesPayload = RolesSelectorQuery;

export type CustomFieldsByUsagePayload = CustomFieldSelectorQuery;

export type TopicsHierarchicalPayload = TopicSelectorHierarchicalQuery;

export type TopicCategoryPayload = TopicCategorySelectorQuery;

export type AbsenceTypesPayload = AbsenceTypeSelectorQuery;

export type StickerAdvFilterPayload = StickerSelectorAdvFilterQuery;

export type ManagedGetStickerPayload = ManagedStickerQuery;

export type CreateStickerPayload = CreateStickerCommand;

export type UpdateStickerPayload = UpdateStickerCommand;

export type JoinStickersPayload = JoinStickersCommand;

export type TagsBody = TagsSuggestionsQuery;

export type AgreementsPayload = AgreementSuggestionsQuery;

export type ManagedMemberBody = ManagedMemberSelectorQuery;

export type ChannelMemberPayload = ChannelMemberSuggestionQuery;

export type GroupUnitSuggestionsPayload = GroupUnitSuggestionsQuery;

export type GroupRuleLoginStatusPayload = GroupRuleLoginStatusSuggestionsQuery;

export type WorkplacesPayload = WorkplaceSuggestionsQuery;

export type SecurityRolesPayload = SecurityRoleSuggestionsQuery;

export type GroupsBody = GroupSuggestionsPayload;

export type UsersInput = UserSuggestionsQuery;

export type ManagersBody = UserManagerSuggestionsQuery;

export type DirectManagersPayload = DirectManagerSuggestionQuery;

export type SubordinatesBody = SubordinatesSuggestionQuery;

export type UnitsPayload = UnitSuggestionsQuery;

export type UnitHierarchicalPayload = UnitSuggestionsHierarchicalQuery;

export type PermissionsBody = PermissionsSuggestionsQuery;

export type CalendarsPayload = CalendarSuggestionQuery;

export type StickersPayload = StickerSuggestionQuery;

export type TopicsPayload = TopicSuggestionsQuery;

export type TopicHierarchicalPayload = TopicSuggestionsHierarchicalQuery;

export type UserTagInterestsPayload = UserTagInterestSuggestionsQuery;

export type UnitTypesBody = UnitTypeSuggestionsQuery;

export type UsersDirectMessagePayload = UserDirectMessageSuggestionsQuery;

export type ManagedTagPayload = ManagedTagQuery;

export type ManagedTagsPayload = ManagedTagListQuery;

export type GetTagAssociatedUnitsPayload = TagAssociatedUnitsQuery;

export type GetTagAssociatedGroupsPayload = TagAssociatedGroupsQuery;

export type GetTagAssociatedUsersPayload = TagAssociatedUsersQuery;

export type GetTagAssociatedTopicsPayload = TagAssociatedTopicsQuery;

export type GetTagAssociatedTrainingsPayload = TagAssociatedTrainingsQuery;

export type GetTagAssociatedAssessmentsPayload = TagAssociatedAssessmentsQuery;

export type CreateTagPayload = CreateTagCommand;

export type UpdateTagPayload = UpdateTagCommand;

export type DeleteTagPayload = DeleteTagCommand;

export type JoinTagsPayload = JoinTagsCommand;

export type ChangeRestrictionTagPayload = ChangeTagRestrictionCommand;

export type GetUsersInput = TopicUsersListQuery;

export type TopicsChallengePayload = TopicChallengeListQuery;

export type ManageTopicChallengePayload = ManagedTopicChallengeQuery;

export type AddTopicChallengePayload = AddTopicChallengeCommand;

export type UpdateTopicChallengePayload = UpdateTopicChallengeCommand;

export type RemoveTopicChallengePayload = RemoveTopicChallengeCommand;

export type ChangeChallengeStatusPayload = ChangeChallengeStatusCommand;

export type CreateTopicPayload = CreateTopicCommand;

export type UpdateTopicPayload = UpdateTopicCommand;

export type DeleteTopicPayload = DeleteTopicCommand;

export type AddUserToTopicPayload = TopicUserCreateCommand;

export type RemoveUserFromTopicPayload = TopicUserDeleteCommand;

export type ChangeUserLinkPayload = TopicUserChangeLinkCommand;

export type AddDynamicGroupToTopicPayload = TopicGroupCreateCommand;

export type RemoveDynamicGroupFromTopicPayload = TopicGroupDeleteCommand;

export type AddTopicRelationPayload = TopicRelationCreateCommand;

export type RemoveTopicRelationPayload = TopicRelationDeleteCommand;

export type JoinTopicPayload = JoinTopicCommand;

export type ManagedTopicsPayload = ManagedTopicListQuery;

export type ManagedGetTopicPayload = ManagedTopicQuery;

export type GetUsersBody1 = ManagedTopicUsersQuery;

export type GetUsersLinkSuggestionPayload = ManagedTopicUsersSuggestionQuery;

export type GetGroupsInput = ManagedTopicGroupsQuery;

export type GetRelationsPayload = ManagedTopicRelationsQuery;

export type GetEndorserUsersPayload = TopicUserEndorsersQuery;

export type GetAssociatedGroupsPayload = TopicUserAssociatedGroupsQuery;

export type ManagedTrainingsListPayload = ManagedTrainingsListQuery;

export type GetCourseTrainingPayload = CourseTrainingQuery;

export type GetExternalCourseTrainingPayload = ExternalCourseTrainingQuery;

export type GetLearnPathTrainingPayload = LearnPathTrainingQuery;

export type GetCourseComponentsPayload = CourseComponentsQuery;

export type GetLearnPathComponentsPayload = LearnPathComponentsQuery;

export type GetEvaluationComponentPayload = TrainingEvaluationComponentQuery;

export type GetMeetingComponentPayload = MeetingQuery;

export type GetCourseComponentWeightsPayload = CourseComponentWeightsQuery;

export type GetLearnPathComponentWeightsPayload =
  LearnPathComponentWeightsQuery;

export type GetTrainingVersionsPayload = TrainingVersionsQuery;

export type CheckVersionFreezedPayload = TrainingCheckVersionFreezedQuery;

export type GetTrainingAudiencePayload = TrainingAudienceQuery;

export type GetTrainingAudiencePreviewUsersPayload =
  TrainingAudiencePreviewUsersQuery;

export type GetTrainingAudienceUsersPayload = TrainingAudienceUsersQuery;

export type GetCourseRulesPayload = CourseRulesQuery;

export type GetLearnPathRulesPayload = LearnPathRulesQuery;

export type GetExternalCourseRulesPayload = ExternalCourseRulesQuery;

export type GetScormPackageInfoPayload = ScormPackageInfoQuery;

export type GetScormPlayerSettingsPayload = ScormPlayerSettingsQuery;

export type GetManagedMeetingDefaultPayload = MeetingDefaultQuery;

export type TrainingMaterialListsPayload = TrainingMaterialListListQuery;

export type TrainingMaterialListItemsPayload =
  TrainingMaterialListItemListQuery;

export type GetTrainingMaterialListItemReorderPayload =
  TrainingMaterialListItemReorderQuery;

export type MaterialListTrainingOptionsPayload =
  MaterialListTrainingOptionsQuery;

export type MaterialListClassroomOptionsPayload =
  MaterialListClassroomOptionsQuery;

export type GetMaterialListInfoPayload = MaterialListInfoQuery;

export type GetPostPropsPayload = PostPropsQuery;

export type GetScoPropsPayload = ScoPropsQuery;

export type GetAssessmentPropsPayload = AssessmentPropsQuery;

export type GetCoursePropsPayload = CoursePropsQuery;

export type GetLearnPathPhasePropsPayload = LearnPathPhasePropsQuery;

export type GetLearnPathComponentPropsPayload = LearnPathComponentPropsQuery;

export type GetUsersFinishedEnrollmentsPayload = UsersFinishedEnrollmentsQuery;

export type GetUsersActiveEnrollmentsPayload = UsersActiveEnrollmentsQuery;

export type GetMeetingItemBody = MeetingItemQuery;

export type GetTrainingBasicInfoPayload = TrainingBasicInfoQuery;

export type GetLearnPathGamePayload = LearnPathGameQuery;

export type LearnPathGamePhasesPayload = LearnPathGamePhasesListQuery;

export type LearnPathGameRankingsPayload = LearnPathGameRankingListQuery;

export type GetLpGameRankingPayload = LpGameRankingQuery;

export type GetLpGameRankingAudienceUsersPayload =
  LpGameRankingAudienceUsersQuery;

export type LearnPathGameScoresPayload = LpGameScoreListQuery;

export type LearnPathGameAwardRankingsPayload = LpGameAwardRankingListQuery;

export type LearnPathGameMapPayload = LearnPathGameMapQuery;

export type LearnPathGameAwardComponenPointsPayload =
  LpGameAwardComponenPointsQuery;

export type ImportTrainingPayload = ImportTrainingCommand;

export type CreateOrUpdateCourseTrainingPayload =
  CreateOrUpdateCourseTrainingCommand;

export type CreateOrUpdateExternalCourseTrainingPayload =
  CreateOrUpdateExternalCourseTrainingCommand;

export type CreateOrUpdateLearnPathTrainingPayload =
  CreateOrUpdateLearnPathTrainingCommand;

export type DeleteTrainingPayload = DeleteTrainingCommand;

export type PublishTrainingPayload = PublishTrainingCommand;

export type DeleteComponentPayload = DeleteComponentCommand;

export type CreateExclusiveScormCoursePayload =
  CreateExclusiveScormCourseCommand;

export type CreateOrUpdateEvaluationComponentPayload =
  CreateOrUpdateEvaluationComponentCommand;

export type CreateOrUpdateEvaluationExclusiveTrainingPayload =
  CreateOrUpdateEvaluationExclusiveTrainingCommand;

export type CreateEvaluationAiQuestionPayload =
  CreateEvaluationAIQuestionCommand;

export type CreateOrUpdateModuleComponentPayload =
  CreateOrUpdateModuleComponentCommand;

export type CreateOrUpdatePhaseComponentPayload =
  CreateOrUpdatePhaseComponentCommand;

export type CreateOrUpdatePhaseLearnPathPayload =
  CreateOrUpdatePhaseLearnPathCommand;

export type SaveLearnPathComponentPropsPayload =
  SaveLearnPathComponentPropsCommand;

export type CreateLearnPathTrainingComponentPayload =
  CreateLearnPathTrainingComponentCommand;

export type AddAssessmentComponentPayload = AddAssessmentComponentCommand;

export type AddAssessmentExclusiveTrainingPayload =
  AddAssessmentExclusiveTrainingCommand;

export type CreateOrUpdateMeetingComponentPayload =
  CreateOrUpdateMeetingComponentCommand;

export type CreateOrUpdateMeetingExclusiveTrainingPayload =
  CreateOrUpdateMeetingExclusiveTrainingCommand;

export type UpdateZoomInstructorLinkCommandPayload =
  UpdateZoomInstructorLinkCommand;

export type SaveTrainingComponentsWeightsPayload = SaveComponentWeightsCommand;

export type CreateOrUpdateScoModulesPayload = CreateOrUpdateScoModulesCommand;

export type MoveAllScosToPhasePayload = MoveAllScosToPhaseCommand;

export type RemoveAllScosComponentsPayload = RemoveAllScosCommand;

export type CreateOrUpdateScormPlayerSettingsPayload =
  CreateOrUpdateScormPlayerSettingsCommand;

export type MoveComponentPayload = MoveComponentCommand;

export type MoveComponentToPhasePayload = MoveComponentToPhaseCommand;

export type ReorderComponentsPayload = ReorderComponentsCommand;

export type PingDraftContentPayload = PingDraftContentCommand;

export type CreateNewTrainingVersionPayload = CreateNewTrainingVersionCommand;

export type DiscardTrainingContentPayload = DiscardTrainingContentCommand;

export type PublishTrainingContentPayload = PublishTrainingContentCommand;

export type CreateTrainingMaterialListPayload =
  CreateTrainingMaterialListCommand;

export type CreateClassroomMaterialListPayload =
  CreateClassroomMaterialListCommand;

export type DeleteTrainingMaterialListPayload =
  DeleteTrainingMaterialListCommand;

export type DeleteClassroomMaterialListPayload =
  DeleteClassroomMaterialListCommand;

export type UpdateMaterialListPayload = UpdateMaterialListCommand;

export type UpdateMaterialListTrainingOptionsPayload =
  UpdateMaterialListTrainingOptionsCommand;

export type UpdateMaterialListClassroomOptionsPayload =
  UpdateMaterialListClassroomOptionsCommand;

export type AddMaterialListItemPayload = AddMaterialListItemCommand;

export type ReorderMaterialListItemPayload = ReorderMaterialListItemCommand;

export type DeleteTrainingMaterialListItemPayload =
  DeleteTrainingMaterialListItemCommand;

export type DeleteClassroomMaterialListItemPayload =
  DeleteClassroomMaterialListItemCommand;

export type ReorderMaterialListPayload = ReorderMaterialListCommand;

export type CopyMaterialListPayload = TrainingCopyMaterialListCommand;

export type BlockOrUnblockMaterialListPayload =
  BlockOrUnblockMaterialListCommand;

export type BlockOrUnblockMaterialListItemPayload =
  BlockOrUnblockMaterialListItemCommand;

export type SaveTrainingRulesRegistrationPayload =
  SaveTrainingRulesRegistrationCommand;

export type SaveTrainingRulesAssessmentPayload = SaveTrainingRulesAssCommand;

export type SaveTrainingRulesExecutionPayload =
  SaveTrainingRulesExecutionCommand;

export type SaveTrainingRulesInstructorActionPayload =
  SaveTrainingRulesInstructorCommand;

export type SaveTrainingRulesApprovalPayload = SaveTrainingRulesApprovalCommand;

export type SaveTrainingPreReqsPayload = SaveTrainingRulesPreReqCommand;

export type SaveTrainingRulesAwardPayload = SaveTrainingRulesAwardCommand;

export type SaveTrainingRulesSeatsPayload = SaveTrainingRulesSeatsCommand;

export type SaveTrainingRulesLimitsPayload = SaveTrainingRulesLimitsCommand;

export type SaveTrainingRulesCertificatePayload =
  SaveTrainingRulesCertificateCommand;

export type SaveTrainingRulesInteractionPayload =
  SaveTrainingRulesInteractionCommand;

export type SaveTrainingRulesAgreementPayload =
  SaveTrainingRulesAgreementCommand;

export type SaveLearnPathRulesApprovalPayload = SaveLpRulesApprovalCommand;

export type SaveTrainingRulesConclusionFormPayload =
  SaveTrainingRulesConclusionFormCommand;

export type SaveLearnPathRulesComponentRegistrationPayload =
  SaveLpRulesComponentRegistrationCommand;

export type SaveLearnPathRulesReEnrollmentPayload = SaveLpRulesReEnrollCommand;

export type GetMeetingInstructorConflitsPayload =
  MeetingInstructorConflitsQuery;

export type UpdateAudiencePayload = UpdateAudienceCommand;

export type SavePostPropsPayload = SavePostPropsCommand;

export type SaveScoPropsPayload = SaveScoPropsCommand;

export type SaveAssessmentPropsPayload = SaveAssessmentPropsCommand;

export type SaveCoursePropsPayload = SaveCoursePropsCommand;

export type GetClassroomsPayload = ManagedClassroomsListQuery;

export type TransferTrainingRulesToOpenedClassroomsPayload =
  TransferTrainingRulesToOpenedClassroomsCommand;

export type ProcessAwardRuleTrainingPayload = ProcessAwardRuleTrainingCommand;

export type ProcessCertificateRuleTrainingPayload =
  ProcessCertificateRuleTrainingCommand;

export type SaveLearnPathGameConfigPayload = SaveLpGameConfigCommand;

export type SaveLearnPathGamePhaseConfigPayload = SaveLpGamePhaseConfigCommand;

export type CreateOrUpdateLearnPathGameRankingPayload =
  CreateOrUpdateLpGameRankingCommand;

export type DeleteLearnPathGameRankingPayload = DeleteLpGameRankingCommand;

export type CreateOrUpdateLpGameScorePayload = CreateOrUpdateLpGameScoreCommand;

export type DeleteLpGameScorePayload = DeleteLpGameScoreCommand;

export type UpdateLpGameAwardRankingPayload = UpdateLpGameAwardRankingCommand;

export type CreateOrUpdateLpGameAwardRankingPayload =
  CreateOrUpdateLpGameAwardRankingCommand;

export type DeleteLpGameAwardRankingPayload = DeleteLpGameAwardRankingCommand;

export type SaveLpGameMapPayload = SaveLpGameMapCommand;

export type ManagedUnitsPayload = ManagedUnitListQuery;

export type ManagedGetUnitPayload = ManagedUnitQuery;

export type ManagedGetUsersUnitPayload = ManagedUnitUserQuery;

export type ManagedUnitContainsDescPayload = UnitContainsDescQuery;

export type ImportUnitPayload = ImportUnitCommand;

export type CreateUnitPayload = CreateUnitCommand;

/**
 * Id do Group
 */
export type UpdateUnitPayload = UpdateUnitCommand;

export type DeleteUnitPayload = DeleteUnitCommand;

export type ManagedGetUnitTypePayload = ManagedUnitTypeQuery;

export type CreateUnitTypePayload = CreateUnitTypeCommand;

/**
 * Id do Group
 */
export type UpdateUnitTypePayload = UpdateUnitTypeCommand;

export type DeleteUnitTypePayload = DeleteUnitTypeCommand;

export type SaveSelectionHistoryPayload = UserSelectionHistoryCommand;

export type SaveSelectionHistoryClickPayload = UserSelectionHistoryClickCommand;

export type UserOrganogramManagersPayload = UserOrganogramManagersQuery;

export type ManagerSubordinatesPayload = UserManagerSubordinatesQuery;

export type ChangePasswordPayload = UserChangeOwnPasswordCommand;

export type GetEditProfilePayload = UserEditProfileQuery;

export type UpdateProfilePayload = UpdateProfileCommand;

export type ResetTwoFactorAppPayload = UserResetTwoFactorAppCommand;

export type GetPersonalInterestsPayload = UserPersonalInterestsQuery;

export type AddPersonalInterestPayload = UserAddPersonalInterestCommand;

export type RemovePersonalInterestPayload = UserRemovePersonalInterestCommand;

export type UpdateNotificationConfigPayload = ChangeNotificationConfigCommand;

export type GetAbsencePayload = UserAbsenceQuery;

export type UpdateBackgroundImagePayload = UserUpdateBackgroundImageCommand;

export type RemoveBackgroundImagePayload = UserRemoveBackgroundImageCommand;

export type ChangeEmailPayload = UserChangeEmailCommand;

export type GetSpyLoginAuthPayload = UserSpyLoginAuthQuery;

export type RequestSpyAuthorizationPayload = UserRequestSpyAuthorizationQuery;

export type RequestSupportAuthorizationPayload = UserRequestSupportAuthCommand;

export type UserPermissionConstraintQueryPayload =
  UserPermissionConstraintQuery;

export type GetChangeLoginBlockPayload = ManagedChangeLoginBlockQuery;

export type ManagerChangePasswordSettingsPayload = ManagerChangePasswordQuery;

export type ManagedUsersPayload = ManagedUserListQuery;

export type GetUserPayload = ManagedUserQuery;

export type ManagerTreePayload = ManagerTreeQuery;

export type CreateUserPayload = CreateUserCommand;

export type UpdateUserPayload = UpdateUserCommand;

/**
 * Id do usuário.
 */
export type DeleteUserBody = DeleteUserCommand;

export type ImportUserAdhocPayload = ImportUserAdhocCommand;

export type ChangeUserStatusPayload = ChangeUserStatusCommand;

export type ChangePasswordBody = ChangePasswordCommand;

export type GetRolesPayload = ManagedUserRolesQuery;

export type GetRolePermissionsPayload = ManagedUserRolePermissionsQuery;

export type GetRoleSuggestionsPayload = ManagedUserRoleSuggestionsQuery;

export type AddRolePayload = UserRoleAddCommand;

export type DeleteRoleBody = UserRoleDeleteCommand;

export type ReactivateRolePayload = UserRoleReactivateCommand;

export type DesactivateRolePayload = UserRoleDesactivateCommand;

export type GetPermissionsListPayload = ManagedUserPermissionsQuery;

export type GetGroupsPayload1 = ManagedUserGroupsQuery;

export type GetGroupSuggestionsPayload = ManagedUserGroupSuggestionsQuery;

export type GetTopicsPayload = ManagedUserTopicsQuery;

export type GrantSpecialistSealPayload =
  UserTopicGrantSpecialistByManagerCommand;

export type RevokeSpecialistSealPayload =
  UserTopicRevokeSpecialistByManagerCommand;

export type AddTopicEndormentPayload = UserTopicAddEndorsementCommand;

export type DeleteTopicEndormentPayload = UserTopicDeleteEndorsementCommand;

export type AddAbsencePayload = UserAbsenceAddCommand;

export type UpdateAbsencePayload = UserAbsenceUpdateCommand;

export type DesactivateAbsencePayload = UserAbsenceDesactivateCommand;

export type AddOrUpdateCredentialPayload = UserCredentialAddOrUpdateCommand;

export type DeleteCredentialPayload = UserCredentialDeleteCommand;

export type GetCredentialsPayload = ManagedUserCredentialsQuery;

export type GetRecordFilesPayload = ManagedUserRecordFilesQuery;

export type AddRecordFilePayload = UserRecordFileAddCommand;

export type DeleteRecordFilePayload = UserRecordFileDeleteCommand;

export type AddOrUpdateIdiomsPayload = UserIdiomsAddCommand;

export type AutoRegisterPendingApprovalsPayload =
  ManagedAutoRegisterPendingApprovalQuery;

export type ModerateAutoRegisterPayload = ModerateAutoRegisterCommand;

export type GetSettingsBody = UserOperationSettingsQuery;

export type GetSelectableUsersPayload = OperationSearchUsersQuery;

export type GetSelectedUsersPayload = OperationSelectedUsersQuery;

export type AddUserBody = AddUserOperationCommand;

export type AddAllUsersPayload = AddAllUsersOperationCommand;

export type RemoveUserPayload = RemoveUsersOperationCommand;

export type ClearUsersPayload = ClearUsersOperationCommand;

export type ExecuteUserOperationPayload = ExecuteUserOperationCommand;

export type ImportUserListPayload = ImportUserListUserOperationCommand;

export type ImportUserFilePayload = ImportUserFileUserOperationCommand;

export type ClearImportedUsersPayload = ClearImportedUsersOperationCommand;

export type ImageSearchPayload = GoogleSearchImagesQuery;

export type CreateWorkplacePayload = CreateWorkplaceCommand;

export type UpdateWorkplacePayload = UpdateWorkplaceCommand;

import axios, {
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse,
  HeadersDefaults,
  ResponseType,
} from "axios";

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams
  extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<
  FullRequestParams,
  "body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown>
  extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({
    securityWorker,
    secure,
    format,
    ...axiosConfig
  }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({
      ...axiosConfig,
      baseURL: axiosConfig.baseURL || "",
    });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(
    params1: AxiosRequestConfig,
    params2?: AxiosRequestConfig,
  ): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method &&
          this.instance.defaults.headers[
            method.toLowerCase() as keyof HeadersDefaults
          ]) ||
          {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] =
        property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(
          key,
          isFileType ? formItem : this.stringifyFormItem(formItem),
        );
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (
      type === ContentType.FormData &&
      body &&
      body !== null &&
      typeof body === "object"
    ) {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (
      type === ContentType.Text &&
      body &&
      body !== null &&
      typeof body !== "string"
    ) {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type && type !== ContentType.FormData
          ? { "Content-Type": type }
          : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title PowerMinds 1.0
 * @version 1.0
 * @license MicroPower (https://www.micropowerglobal.com/licenses)
 * @contact MicroPower Software <micropower@micropowerglobal.com>
 *
 * MicroPower PowerMinds
 */
export class Api<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * Executa o Logout no usuário.
   *
   * @tags Account
   * @name Logout
   * @request POST:/AccountLogout
   * @secure
   * @response `200` `any` OK
   */
  logout = (params: RequestParams = {}) =>
    this.request<any, any>({
      path: `/AccountLogout`,
      method: "POST",
      secure: true,
      ...params,
    });

  /**
   * Obtém os dados do QrCode para Registro de Presença.
   *
   * @tags LmsQrMeeting
   * @name QrMeetingInfo
   * @request GET:/QrMettingInfo
   * @secure
   * @response `200` `QrMeetingInfoResponse` OK (May return null)
   * @response `204` `any` No Content
   */
  qrMeetingInfo = (
    query?: {
      /** @format uuid */
      ComponentId?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<QrMeetingInfoResponse, any>({
      path: `/QrMettingInfo`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * Registra Presença em Evento via QrCode.
   *
   * @tags LmsQrMeeting
   * @name QrMeetingRegisterAttendance
   * @request POST:/QrMeetingRegisterAttendance
   * @secure
   * @response `200` `QrMeetingRegisterAttendanceResponse` OK
   */
  qrMeetingRegisterAttendance = (
    data: QrMeetingRegisterAttendancePayload,
    params: RequestParams = {},
  ) =>
    this.request<QrMeetingRegisterAttendanceResponse, any>({
      path: `/QrMeetingRegisterAttendance`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * Faz o download do certificado default do sistema.
   *
   * @tags LmsSettings
   * @name DownloadDefaultCertificate
   * @request GET:/Lms/DownloadDefaultCertificate
   * @secure
   * @response `200` `any` OK
   */
  downloadDefaultCertificate = (params: RequestParams = {}) =>
    this.request<any, any>({
      path: `/Lms/DownloadDefaultCertificate`,
      method: "GET",
      secure: true,
      ...params,
    });

  /**
   * Registra a quantidade de dados trafegados de um arquivo de mídia.
   *
   * @tags MediaTrack
   * @name Register
   * @request POST:/RegisterMediaTrack
   * @secure
   * @response `200` `boolean` OK
   */
  register = (data: RegisterPayload, params: RequestParams = {}) =>
    this.request<boolean, any>({
      path: `/RegisterMediaTrack`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * No description
   *
   * @tags Public
   * @name Icon16
   * @request GET:/icon16.png
   * @secure
   * @response `200` `any` OK
   */
  icon16 = (params: RequestParams = {}) =>
    this.request<any, any>({
      path: `/icon16.png`,
      method: "GET",
      secure: true,
      ...params,
    });

  /**
   * No description
   *
   * @tags Public
   * @name Icon24
   * @request GET:/icon24.png
   * @secure
   * @response `200` `any` OK
   */
  icon24 = (params: RequestParams = {}) =>
    this.request<any, any>({
      path: `/icon24.png`,
      method: "GET",
      secure: true,
      ...params,
    });

  /**
   * No description
   *
   * @tags Public
   * @name Icon32
   * @request GET:/icon32.png
   * @secure
   * @response `200` `any` OK
   */
  icon32 = (params: RequestParams = {}) =>
    this.request<any, any>({
      path: `/icon32.png`,
      method: "GET",
      secure: true,
      ...params,
    });

  /**
   * No description
   *
   * @tags Public
   * @name Icon64
   * @request GET:/icon64.png
   * @secure
   * @response `200` `any` OK
   */
  icon64 = (params: RequestParams = {}) =>
    this.request<any, any>({
      path: `/icon64.png`,
      method: "GET",
      secure: true,
      ...params,
    });

  /**
   * No description
   *
   * @tags Public
   * @name Icon128
   * @request GET:/icon128.png
   * @secure
   * @response `200` `any` OK
   */
  icon128 = (params: RequestParams = {}) =>
    this.request<any, any>({
      path: `/icon128.png`,
      method: "GET",
      secure: true,
      ...params,
    });

  /**
   * No description
   *
   * @tags Public
   * @name Icon180
   * @request GET:/icon180.png
   * @secure
   * @response `200` `any` OK
   */
  icon180 = (params: RequestParams = {}) =>
    this.request<any, any>({
      path: `/icon180.png`,
      method: "GET",
      secure: true,
      ...params,
    });

  /**
   * No description
   *
   * @tags Public
   * @name Icon192
   * @request GET:/icon192.png
   * @secure
   * @response `200` `any` OK
   */
  icon192 = (params: RequestParams = {}) =>
    this.request<any, any>({
      path: `/icon192.png`,
      method: "GET",
      secure: true,
      ...params,
    });

  /**
   * No description
   *
   * @tags Public
   * @name Icon512
   * @request GET:/icon512.png
   * @secure
   * @response `200` `any` OK
   */
  icon512 = (params: RequestParams = {}) =>
    this.request<any, any>({
      path: `/icon512.png`,
      method: "GET",
      secure: true,
      ...params,
    });

  /**
   * Obtém o Logo do Site.
   *
   * @tags Session
   * @name Logo
   * @request GET:/Logo
   * @secure
   * @response `200` `any` OK
   */
  logo = (params: RequestParams = {}) =>
    this.request<any, any>({
      path: `/Logo`,
      method: "GET",
      secure: true,
      ...params,
    });

  /**
   * Obtém a imagem de Background do Site.
   *
   * @tags Session
   * @name Background
   * @request GET:/Background
   * @secure
   * @response `200` `any` OK
   */
  background = (params: RequestParams = {}) =>
    this.request<any, any>({
      path: `/Background`,
      method: "GET",
      secure: true,
      ...params,
    });

  /**
   * Obtém a imagem de Ícone do Site.
   *
   * @tags Session
   * @name Icon
   * @request GET:/Icon
   * @secure
   * @response `200` `any` OK
   */
  icon = (params: RequestParams = {}) =>
    this.request<any, any>({
      path: `/Icon`,
      method: "GET",
      secure: true,
      ...params,
    });

  /**
   * Obtém a Imagem de Destaque do Site.
   *
   * @tags Session
   * @name HighlightImage
   * @request GET:/HighlightImage
   * @secure
   * @response `200` `any` OK
   */
  highlightImage = (params: RequestParams = {}) =>
    this.request<any, any>({
      path: `/HighlightImage`,
      method: "GET",
      secure: true,
      ...params,
    });

  /**
   * Obtém o Logo Padrão do Site.
   *
   * @tags Session
   * @name DefaultLogo
   * @request GET:/DefaultLogo
   * @secure
   * @response `200` `any` OK
   */
  defaultLogo = (params: RequestParams = {}) =>
    this.request<any, any>({
      path: `/DefaultLogo`,
      method: "GET",
      secure: true,
      ...params,
    });

  /**
   * Obtém a Imagem Padrão do Ícone do Site.
   *
   * @tags Session
   * @name DefaultIcon
   * @request GET:/DefaultIcon
   * @secure
   * @response `200` `any` OK
   */
  defaultIcon = (params: RequestParams = {}) =>
    this.request<any, any>({
      path: `/DefaultIcon`,
      method: "GET",
      secure: true,
      ...params,
    });

  /**
   * Obtém a Imagem Padrão de Background do Site.
   *
   * @tags Session
   * @name DefaultBackground
   * @request GET:/DefaultBackground
   * @secure
   * @response `200` `any` OK
   */
  defaultBackground = (params: RequestParams = {}) =>
    this.request<any, any>({
      path: `/DefaultBackground`,
      method: "GET",
      secure: true,
      ...params,
    });

  /**
   * Obtém a Imagem Padrão de Destaque do Site.
   *
   * @tags Session
   * @name DefaultHighlightImage
   * @request GET:/DefaultHighlightImage
   * @secure
   * @response `200` `any` OK
   */
  defaultHighlightImage = (params: RequestParams = {}) =>
    this.request<any, any>({
      path: `/DefaultHighlightImage`,
      method: "GET",
      secure: true,
      ...params,
    });

  /**
   * Obtém as configurações do sistema.
   *
   * @tags Session
   * @name GetAppSettings
   * @request GET:/GetAppSettings
   * @secure
   * @response `200` `AppSettingsResponse` OK
   */
  getAppSettings = (params: RequestParams = {}) =>
    this.request<AppSettingsResponse, any>({
      path: `/GetAppSettings`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * Utilizado apenas para verifica se o token de acesso ainda é válido.
   *
   * @tags Session
   * @name CheckAccess
   * @request POST:/CheckAccess
   * @secure
   * @response `200` `any` OK
   */
  checkAccess = (params: RequestParams = {}) =>
    this.request<any, any>({
      path: `/CheckAccess`,
      method: "POST",
      secure: true,
      ...params,
    });

  /**
   * Obtém o Video de Limite de Utilização Atingido.
   *
   * @tags Storage
   * @name GetVideoLimitReached
   * @request GET:/GetVideoPlanExceeded.mp4
   * @secure
   * @response `200` `any` OK
   */
  getVideoLimitReached = (params: RequestParams = {}) =>
    this.request<any, any>({
      path: `/GetVideoPlanExceeded.mp4`,
      method: "GET",
      secure: true,
      ...params,
    });

  /**
   * Obtém um asset (arquivo) armazenado.
   *
   * @tags Storage
   * @name GetAsset
   * @request GET:/GetAsset/{id}
   * @secure
   * @response `200` `any` OK
   */
  getAsset = (id: string, params: RequestParams = {}) =>
    this.request<any, any>({
      path: `/GetAsset/${id}`,
      method: "GET",
      secure: true,
      ...params,
    });

  /**
   * Método exclusivo para envio de arquivo ao Microsoft Azure Media Indexer.
   *
   * @tags Storage
   * @name MediaIndexerUpload
   * @request GET:/MediaIndexerUpload/{id}
   * @secure
   * @response `200` `any` OK
   */
  mediaIndexerUpload = (id: string, params: RequestParams = {}) =>
    this.request<any, any>({
      path: `/MediaIndexerUpload/${id}`,
      method: "GET",
      secure: true,
      ...params,
    });

  /**
   * Obtém as trilhas de legenda de uma arquivo do tipo vídeo.
   *
   * @tags Storage
   * @name GetMediaTrack
   * @request GET:/GetMediaTrack/{id}
   * @secure
   * @response `200` `any` OK
   */
  getMediaTrack = (id: string, params: RequestParams = {}) =>
    this.request<any, any>({
      path: `/GetMediaTrack/${id}`,
      method: "GET",
      secure: true,
      ...params,
    });

  /**
   * Obtém um asset (arquivo) armazenado.
   *
   * @tags Storage
   * @name GetSystemImage
   * @request GET:/GetSystemImage/{id}
   * @secure
   * @response `200` `any` OK
   */
  getSystemImage = (id: string, params: RequestParams = {}) =>
    this.request<any, any>({
      path: `/GetSystemImage/${id}`,
      method: "GET",
      secure: true,
      ...params,
    });

  /**
   * Faz o download de um arquivo.
   *
   * @tags Storage
   * @name Download
   * @request GET:/Download/{id}
   * @secure
   * @response `200` `any` OK
   */
  download = (id: string, params: RequestParams = {}) =>
    this.request<any, any>({
      path: `/Download/${id}`,
      method: "GET",
      secure: true,
      ...params,
    });

  /**
   * Obtém a imagem padrão para Publicações Institucionais.
   *
   * @tags System
   * @name GetDefaultInstitutionalThumbnail
   * @request GET:/GetDefaultInstitutionalThumbnail
   * @secure
   * @response `200` `any` OK
   */
  getDefaultInstitutionalThumbnail = (params: RequestParams = {}) =>
    this.request<any, any>({
      path: `/GetDefaultInstitutionalThumbnail`,
      method: "GET",
      secure: true,
      ...params,
    });

  /**
   * No description
   *
   * @tags User
   * @name GetPermissions
   * @request POST:/GetUserPermissions
   * @secure
   * @response `200` `(string)[]` OK
   */
  getPermissions = (params: RequestParams = {}) =>
    this.request<string[], any>({
      path: `/GetUserPermissions`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });

  absenceType = {
    /**
     * Cria um tipo de ausência
     *
     * @tags AbsenceType
     * @name CreateAbsenceType
     * @request POST:/api/v1/AbsenceType/CreateAbsenceType
     * @secure
     * @response `200` `string | null` OK (May return null)
     * @response `204` `any` No Content
     */
    createAbsenceType: (
      data: CreateAbsenceTypePayload,
      params: RequestParams = {},
    ) =>
      this.request<string | null, any>({
        path: `/api/v1/AbsenceType/CreateAbsenceType`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Altera um tipo de ausência
     *
     * @tags AbsenceType
     * @name UpdateAbsenceType
     * @request POST:/api/v1/AbsenceType/UpdateAbsenceType
     * @secure
     * @response `200` `boolean` OK
     */
    updateAbsenceType: (
      data: UpdateAbsenceTypePayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/AbsenceType/UpdateAbsenceType`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Exclui um tipo de ausência
     *
     * @tags AbsenceType
     * @name DeleteAbsenceType
     * @request POST:/api/v1/AbsenceType/DeleteAbsenceType
     * @secure
     * @response `200` `boolean` OK
     */
    deleteAbsenceType: (
      data: DeleteAbsenceTypePayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/AbsenceType/DeleteAbsenceType`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém uma lista de motivo de ausência
     *
     * @tags AbsenceType
     * @name ManagedAbsenceType
     * @request GET:/api/v1/AbsenceType/ManagedAbsenceType
     * @secure
     * @response `200` `ManagedAbsenceTypeListQueryResponsePaginatedList` OK
     */
    managedAbsenceType: (
      query?: {
        /** @format int32 */
        PageNumber?: number;
        /** @format int32 */
        PageSize?: number;
        /** @format int32 */
        Offset?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<ManagedAbsenceTypeListQueryResponsePaginatedList, any>({
        path: `/api/v1/AbsenceType/ManagedAbsenceType`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  accessTimeRule = {
    /**
     * Obtém a lista de Horário de Acesso.
     *
     * @tags AccessTimeRule
     * @name ManagedAccessTimeRules
     * @request POST:/api/v1/AccessTimeRule/ManagedAccessTimeRules
     * @secure
     * @response `200` `ManagedAccessTimeRuleListResponse` OK
     */
    managedAccessTimeRules: (
      data: ManagedAccessTimeRulesPayload,
      params: RequestParams = {},
    ) =>
      this.request<ManagedAccessTimeRuleListResponse, any>({
        path: `/api/v1/AccessTimeRule/ManagedAccessTimeRules`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém o registro de um Horário de Acesso.
     *
     * @tags AccessTimeRule
     * @name GetAccessTimeRule
     * @request POST:/api/v1/AccessTimeRule/GetAccessTimeRule
     * @secure
     * @response `200` `ManagedAccessTimeRuleResponse` OK (May return null)
     * @response `204` `any` No Content
     */
    getAccessTimeRule: (
      data: GetAccessTimeRulePayload,
      params: RequestParams = {},
    ) =>
      this.request<ManagedAccessTimeRuleResponse, any>({
        path: `/api/v1/AccessTimeRule/GetAccessTimeRule`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Cria um horário de acesso.
     *
     * @tags AccessTimeRule
     * @name CreateAccessTimeRule
     * @request POST:/api/v1/AccessTimeRule/CreateAccessTimeRule
     * @secure
     * @response `200` `string` OK
     */
    createAccessTimeRule: (
      data: CreateAccessTimeRulePayload,
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/api/v1/AccessTimeRule/CreateAccessTimeRule`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Atualiza um horário de acesso.
     *
     * @tags AccessTimeRule
     * @name UpdateAccessTimeRule
     * @request POST:/api/v1/AccessTimeRule/UpdateAccessTimeRule
     * @secure
     * @response `200` `boolean` OK
     */
    updateAccessTimeRule: (
      data: UpdateAccessTimeRulePayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/AccessTimeRule/UpdateAccessTimeRule`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Exclui um horário de acesso.
     *
     * @tags AccessTimeRule
     * @name DeleteAccessTimeRule
     * @request DELETE:/api/v1/AccessTimeRule/DeleteAccessTimeRule
     * @secure
     * @response `200` `boolean` OK
     */
    deleteAccessTimeRule: (
      query?: {
        /** @format uuid */
        AccessTimeRuleId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/AccessTimeRule/DeleteAccessTimeRule`,
        method: "DELETE",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Obtém a lista de usuários afetados pelo horário de acesso.
     *
     * @tags AccessTimeRule
     * @name GetAffectedUsers
     * @request POST:/api/v1/AccessTimeRule/GetAffectedUsers
     * @secure
     * @response `200` `UserItemDtoPaginatedList` OK
     */
    getAffectedUsers: (
      data: GetAffectedUsersPayload,
      params: RequestParams = {},
    ) =>
      this.request<UserItemDtoPaginatedList, any>({
        path: `/api/v1/AccessTimeRule/GetAffectedUsers`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  account = {
    /**
     * Obtém as configurações do formulário de auto-registro de usuário.
     *
     * @tags Account
     * @name AutoRegisterSettings
     * @request GET:/api/v1/Account/AutoRegisterSettings
     * @secure
     * @response `200` `AutoRegisterSettingsResponse` OK
     */
    autoRegisterSettings: (params: RequestParams = {}) =>
      this.request<AutoRegisterSettingsResponse, any>({
        path: `/api/v1/Account/AutoRegisterSettings`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Cria uma conta de acesso padrão (usuário e senha).
     *
     * @tags Account
     * @name CreateStandardAccount
     * @request POST:/api/v1/Account/CreateStandardAccount
     * @secure
     * @response `200` `CreateStandardAccountResponse` OK
     */
    createStandardAccount: (
      data: CreateStandardAccountPayload,
      params: RequestParams = {},
    ) =>
      this.request<CreateStandardAccountResponse, any>({
        path: `/api/v1/Account/CreateStandardAccount`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Executa a confirmação da conta padrão (usuário e senha).
     *
     * @tags Account
     * @name StandardAccountConfirm
     * @request POST:/api/v1/Account/StandardAccountConfirm
     * @secure
     * @response `200` `StandardAccountConfirmResponse` OK
     */
    standardAccountConfirm: (
      data: StandardAccountConfirmPayload,
      params: RequestParams = {},
    ) =>
      this.request<StandardAccountConfirmResponse, any>({
        path: `/api/v1/Account/StandardAccountConfirm`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Executa uma nova confirmação da conta de acesso padrão (usuário e senha).
     *
     * @tags Account
     * @name StandardAccountRenewConfirmation
     * @request POST:/api/v1/Account/StandardAccountRenewConfirmation
     * @secure
     * @response `200` `StandardAccountRenewConfirmationResponse` OK
     */
    standardAccountRenewConfirmation: (
      data: StandardAccountRenewConfirmationPayload,
      params: RequestParams = {},
    ) =>
      this.request<StandardAccountRenewConfirmationResponse, any>({
        path: `/api/v1/Account/StandardAccountRenewConfirmation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Reenvia o email de confirmação da conta de acesso padrão (usuário e senha).
     *
     * @tags Account
     * @name StandardAccountResendConfirmation
     * @request POST:/api/v1/Account/StandardAccountResendConfirmation
     * @secure
     * @response `200` `StandardAccountResendConfirmationResponse` OK
     */
    standardAccountResendConfirmation: (
      data: StandardAccountResendConfirmationPayload,
      params: RequestParams = {},
    ) =>
      this.request<StandardAccountResendConfirmationResponse, any>({
        path: `/api/v1/Account/StandardAccountResendConfirmation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém as configurações do formulário de Recuperação de Senha.
     *
     * @tags Account
     * @name RecoverPasswordSettings
     * @request POST:/api/v1/Account/RecoverPasswordSettings
     * @secure
     * @response `200` `RecoverPasswordSettingsResponse` OK (May return null)
     * @response `204` `any` No Content
     */
    recoverPasswordSettings: (
      data: RecoverPasswordSettingsPayload,
      params: RequestParams = {},
    ) =>
      this.request<RecoverPasswordSettingsResponse, any>({
        path: `/api/v1/Account/RecoverPasswordSettings`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Altera a senha de acesso do usuário.
     *
     * @tags Account
     * @name StandardAccountResetPassword
     * @request POST:/api/v1/Account/StandardAccountResetPassword
     * @secure
     * @response `200` `StandardAccountResetPasswordResponse` OK (May return null)
     * @response `204` `any` No Content
     */
    standardAccountResetPassword: (
      data: StandardAccountResetPasswordPayload,
      params: RequestParams = {},
    ) =>
      this.request<StandardAccountResetPasswordResponse, any>({
        path: `/api/v1/Account/StandardAccountResetPassword`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Envia o email para recuperação de senha para um usuário.
     *
     * @tags Account
     * @name StandardAccountSendResetPassword
     * @request POST:/api/v1/Account/StandardAccountSendResetPassword
     * @secure
     * @response `200` `StandardAccountSendResetPasswordResponse` OK
     */
    standardAccountSendResetPassword: (
      data: StandardAccountSendResetPasswordPayload,
      params: RequestParams = {},
    ) =>
      this.request<StandardAccountSendResetPasswordResponse, any>({
        path: `/api/v1/Account/StandardAccountSendResetPassword`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Desbloqueia a Conta do usuário.
     *
     * @tags Account
     * @name StandardAccountUnlock
     * @request POST:/api/v1/Account/StandardAccountUnlock
     * @secure
     * @response `200` `boolean` OK
     */
    standardAccountUnlock: (
      data: StandardAccountUnlockPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/Account/StandardAccountUnlock`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém o Acordo de Uso de Sistema atualmente em uso.
     *
     * @tags Account
     * @name GetCurrentAccessAgreement
     * @request GET:/api/v1/Account/GetCurrentAccessAgreement
     * @secure
     * @response `200` `GetCurrentAgreementQueryResponse` OK (May return null)
     * @response `204` `any` No Content
     */
    getCurrentAccessAgreement: (params: RequestParams = {}) =>
      this.request<GetCurrentAgreementQueryResponse, any>({
        path: `/api/v1/Account/GetCurrentAccessAgreement`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Registra o aceite do acordo de uso do sistema pelo usuário.
     *
     * @tags Account
     * @name StandardAccountSetAgreement
     * @request POST:/api/v1/Account/StandardAccountSetAgreement
     * @secure
     * @response `200` `StandardAccountAgreeResponse` OK
     */
    standardAccountSetAgreement: (
      data: StandardAccountSetAgreementPayload,
      params: RequestParams = {},
    ) =>
      this.request<StandardAccountAgreeResponse, any>({
        path: `/api/v1/Account/StandardAccountSetAgreement`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Cria um acesso para Login por Token.
     *
     * @tags Account
     * @name CreateTokenAccess
     * @request POST:/api/v1/Account/CreateTokenAccess
     * @secure
     * @response `200` `CreateTokenAccessResponse` OK
     */
    createTokenAccess: (
      data: CreateTokenAccessPayload,
      params: RequestParams = {},
    ) =>
      this.request<CreateTokenAccessResponse, any>({
        path: `/api/v1/Account/CreateTokenAccess`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Envia o PINCODE do Autenticador por EMAIL.
     *
     * @tags Account
     * @name EmailAuthenticatorSendCode
     * @request POST:/api/v1/Account/EmailAuthenticatorSendCode
     * @secure
     * @response `200` `boolean` OK
     */
    emailAuthenticatorSendCode: (
      data: EmailAuthenticatorSendCodePayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/Account/EmailAuthenticatorSendCode`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Confirma o PinCode do Autenticador por EMAIL.
     *
     * @tags Account
     * @name EmailAuthenticatorValidateCode
     * @request POST:/api/v1/Account/EmailAuthenticatorValidateCode
     * @secure
     * @response `200` `TwoFactorEmailValidationResult` OK
     */
    emailAuthenticatorValidateCode: (
      data: EmailAuthenticatorValidateCodePayload,
      params: RequestParams = {},
    ) =>
      this.request<TwoFactorEmailValidationResult, any>({
        path: `/api/v1/Account/EmailAuthenticatorValidateCode`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Confirma a configuração do Autenticador por APP.
     *
     * @tags Account
     * @name AppAuthenticatorReset
     * @request POST:/api/v1/Account/AppAuthenticatorReset
     * @secure
     * @response `200` `boolean` OK
     */
    appAuthenticatorReset: (
      data: AppAuthenticatorResetPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/Account/AppAuthenticatorReset`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Cria um acesso para Login por Token.
     *
     * @tags Account
     * @name AppAuthenticatorSetupConfirm
     * @request POST:/api/v1/Account/AppAuthenticatorSetupConfirm
     * @secure
     * @response `200` `boolean` OK
     */
    appAuthenticatorSetupConfirm: (
      data: AppAuthenticatorSetupConfirmPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/Account/AppAuthenticatorSetupConfirm`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Confirma o PinCode do Autenticador por APP.
     *
     * @tags Account
     * @name AppAuthenticatorValidateCode
     * @request POST:/api/v1/Account/AppAuthenticatorValidateCode
     * @secure
     * @response `200` `boolean` OK
     */
    appAuthenticatorValidateCode: (
      data: AppAuthenticatorValidateCodePayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/Account/AppAuthenticatorValidateCode`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém o Deeplink para configuração do Autenticador por APP.
     *
     * @tags Account
     * @name AppAuthenticatorPrepareSetup
     * @request POST:/api/v1/Account/AppAuthenticatorPrepareSetup
     * @secure
     * @response `200` `AppAuthenticatorPrepareSetupResponse` OK
     */
    appAuthenticatorPrepareSetup: (
      data: AppAuthenticatorPrepareSetupPayload,
      params: RequestParams = {},
    ) =>
      this.request<AppAuthenticatorPrepareSetupResponse, any>({
        path: `/api/v1/Account/AppAuthenticatorPrepareSetup`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtem a Configuração do Autenticador por APP para o usuário logado.
     *
     * @tags Account
     * @name GetCurrentAppAuthenticatorInfo
     * @request GET:/api/v1/Account/GetCurrentAppAuthenticatorInfo
     * @secure
     * @response `200` `GetCurrentAppAuthenticatorInfoResponse` OK
     */
    getCurrentAppAuthenticatorInfo: (
      query?: {
        query?: GetCurrentAppAuthenticatorInfoQuery;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetCurrentAppAuthenticatorInfoResponse, any>({
        path: `/api/v1/Account/GetCurrentAppAuthenticatorInfo`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  agreement = {
    /**
     * Obtém o Termo de Uso para Acesso ao Sistema.
     *
     * @tags Agreement
     * @name ManagedAccessAgreement
     * @request POST:/api/v1/Agreement/ManagedAccessAgreement
     * @secure
     * @response `200` `ManagedAccessAgreementResponse` OK
     */
    managedAccessAgreement: (params: RequestParams = {}) =>
      this.request<ManagedAccessAgreementResponse, any>({
        path: `/api/v1/Agreement/ManagedAccessAgreement`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Obtém o Termo de Uso para Realização de Treinamentos.
     *
     * @tags Agreement
     * @name ManagedTrainingAgreement
     * @request POST:/api/v1/Agreement/ManagedTrainingAgreement
     * @secure
     * @response `200` `ManagedTrainingAgreementResponse` OK
     */
    managedTrainingAgreement: (params: RequestParams = {}) =>
      this.request<ManagedTrainingAgreementResponse, any>({
        path: `/api/v1/Agreement/ManagedTrainingAgreement`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Verifica em quais treinamentos o termo de uso está sendo utilizado.
     *
     * @tags Agreement
     * @name CheckTrainingAgreementUsage
     * @request POST:/api/v1/Agreement/CheckTrainingAgreementUsage
     * @secure
     * @response `200` `(string)[]` OK
     */
    checkTrainingAgreementUsage: (
      data: CheckTrainingAgreementUsagePayload,
      params: RequestParams = {},
    ) =>
      this.request<string[], any>({
        path: `/api/v1/Agreement/CheckTrainingAgreementUsage`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Cria o Termo de Uso para Acesso ao Sistema.
     *
     * @tags Agreement
     * @name CreateAccessAgreement
     * @request POST:/api/v1/Agreement/CreateAccessAgreement
     * @secure
     * @response `200` `string` OK
     */
    createAccessAgreement: (
      data: CreateAccessAgreementPayload,
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/api/v1/Agreement/CreateAccessAgreement`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Altera o Termo de Uso para Acesso ao Sistema.
     *
     * @tags Agreement
     * @name UpdateAccessAgreement
     * @request POST:/api/v1/Agreement/UpdateAccessAgreement
     * @secure
     * @response `200` `boolean` OK
     */
    updateAccessAgreement: (
      data: UpdateAccessAgreementPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/Agreement/UpdateAccessAgreement`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Cria ou atualiza o Termo de Uso para Realização de Treinamentos.
     *
     * @tags Agreement
     * @name CreateOrUpdateTrainingAssessment
     * @request POST:/api/v1/Agreement/CreateOrUpdateTrainingAssessment
     * @secure
     * @response `200` `AgreementAutoCompleteDataModelDto` OK
     */
    createOrUpdateTrainingAssessment: (
      data: CreateOrUpdateTrainingAssessmentPayload,
      params: RequestParams = {},
    ) =>
      this.request<AgreementAutoCompleteDataModelDto, any>({
        path: `/api/v1/Agreement/CreateOrUpdateTrainingAssessment`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Exclui termo de uso para Realização de Treinamentos (se não estiver em uso).
     *
     * @tags Agreement
     * @name DeleteTrainingAssessment
     * @request POST:/api/v1/Agreement/DeleteTrainingAssessment
     * @secure
     * @response `200` `boolean` OK
     */
    deleteTrainingAssessment: (
      data: DeleteTrainingAssessmentPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/Agreement/DeleteTrainingAssessment`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Atualiza configurações de Termos de Uso para Realização de Treinamentos.
     *
     * @tags Agreement
     * @name UpdateTrainingAgreementSettings
     * @request POST:/api/v1/Agreement/UpdateTrainingAgreementSettings
     * @secure
     * @response `200` `boolean` OK
     */
    updateTrainingAgreementSettings: (
      data: UpdateTrainingAgreementSettingsPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/Agreement/UpdateTrainingAgreementSettings`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  writeLog = {
    /**
     * Registra o Log de Erro da Aplicação Client.
     *
     * @tags App
     * @name WriteAppLog
     * @request POST:/api/App/WriteLog
     * @secure
     * @response `200` `string` OK
     */
    writeAppLog: (data: WriteAppLogPayload, params: RequestParams = {}) =>
      this.request<string, any>({
        path: `/api/App/WriteLog`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  assDeploy = {
    /**
     * Obtém uma lista de Avaliaçãos Ad-Hoc disponíveis para seleção.
     *
     * @tags AssDeploy
     * @name SurveysAdHoc
     * @request POST:/api/v1/AssDeploy/SurveysAdHoc
     * @secure
     * @response `200` `AssDeploySelectorResponsePaginatedList` OK
     */
    surveysAdHoc: (data: SurveysAdHocPayload, params: RequestParams = {}) =>
      this.request<AssDeploySelectorResponsePaginatedList, any>({
        path: `/api/v1/AssDeploy/SurveysAdHoc`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém o público-alvo de uma aplicação de pesquisa.
     *
     * @tags AssDeploy
     * @name GetAssDeployAudience
     * @request POST:/api/v1/AssDeploy/GetAssDeployAudience
     * @secure
     * @response `200` `AssDeployAudienceRequest` OK
     */
    getAssDeployAudience: (
      data: GetAssDeployAudiencePayload,
      params: RequestParams = {},
    ) =>
      this.request<AssDeployAudienceRequest, any>({
        path: `/api/v1/AssDeploy/GetAssDeployAudience`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Cancela a participação do usuário na pesquisa Ad-Hoc.
     *
     * @tags AssDeploy
     * @name DeclineAdHocSurvey
     * @request POST:/api/v1/AssDeploy/DeclineAdHocSurvey
     * @secure
     * @response `200` `boolean` OK
     */
    declineAdHocSurvey: (
      data: DeclineAdHocSurveyPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/AssDeploy/DeclineAdHocSurvey`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  assManagement = {
    /**
     * Obtém a lista de Banco de Avaliações.
     *
     * @tags AssManagement
     * @name ManagedEvaluations
     * @request POST:/api/v1/AssManagement/ManagedEvaluations
     * @secure
     * @response `200` `ManagedEvaluationListResponsePaginatedList` OK
     */
    managedEvaluations: (
      data: ManagedEvaluationsPayload,
      params: RequestParams = {},
    ) =>
      this.request<ManagedEvaluationListResponsePaginatedList, any>({
        path: `/api/v1/AssManagement/ManagedEvaluations`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém os dados para criação e edição de uma Avaliação.
     *
     * @tags AssManagement
     * @name ManagedEvaluation
     * @request POST:/api/v1/AssManagement/ManagedEvaluation
     * @secure
     * @response `200` `GetEvaluationDto` OK (May return null)
     * @response `204` `any` No Content
     */
    managedEvaluation: (
      data: ManagedEvaluationPayload,
      params: RequestParams = {},
    ) =>
      this.request<GetEvaluationDto, any>({
        path: `/api/v1/AssManagement/ManagedEvaluation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém a lista de Questões e Regras de uma avaliação ou pesquisa.
     *
     * @tags AssManagement
     * @name ManagedAssQuestions
     * @request POST:/api/v1/AssManagement/ManagedAssQuestions
     * @secure
     * @response `200` `ManagedAssQuestionListResponsePaginatedList` OK
     */
    managedAssQuestions: (
      data: ManagedAssQuestionsPayload,
      params: RequestParams = {},
    ) =>
      this.request<ManagedAssQuestionListResponsePaginatedList, any>({
        path: `/api/v1/AssManagement/ManagedAssQuestions`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém a lista do banco de pesquisa.
     *
     * @tags AssManagement
     * @name ManagedSurveys
     * @request POST:/api/v1/AssManagement/ManagedSurveys
     * @secure
     * @response `200` `ManagedSurveyListResponsePaginatedList` OK
     */
    managedSurveys: (data: ManagedSurveysPayload, params: RequestParams = {}) =>
      this.request<ManagedSurveyListResponsePaginatedList, any>({
        path: `/api/v1/AssManagement/ManagedSurveys`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtem os dados para criação / edição uma pesquisa.
     *
     * @tags AssManagement
     * @name ManagedSurvey
     * @request POST:/api/v1/AssManagement/ManagedSurvey
     * @secure
     * @response `200` `GetSurveyDto` OK (May return null)
     * @response `204` `any` No Content
     */
    managedSurvey: (data: ManagedSurveyPayload, params: RequestParams = {}) =>
      this.request<GetSurveyDto, any>({
        path: `/api/v1/AssManagement/ManagedSurvey`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Retorna dados básicos de uma avaliação.
     *
     * @tags AssManagement
     * @name GetEvaluationInfo
     * @request POST:/api/v1/AssManagement/GetEvaluationInfo
     * @secure
     * @response `200` `EvaluationInfoResponse` OK (May return null)
     * @response `204` `any` No Content
     */
    getEvaluationInfo: (
      data: GetEvaluationInfoPayload,
      params: RequestParams = {},
    ) =>
      this.request<EvaluationInfoResponse, any>({
        path: `/api/v1/AssManagement/GetEvaluationInfo`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém dados para edição de uma regra de uma avaliação.
     *
     * @tags AssManagement
     * @name GetManagedAssRule
     * @request POST:/api/v1/AssManagement/GetManagedAssRule
     * @secure
     * @response `200` `ManagedAssRuleResponse` OK
     */
    getManagedAssRule: (
      data: GetManagedAssRulePayload,
      params: RequestParams = {},
    ) =>
      this.request<ManagedAssRuleResponse, any>({
        path: `/api/v1/AssManagement/GetManagedAssRule`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Lista avaliações com questões dissertativas com questões a corrigir.
     *
     * @tags AssManagement
     * @name GetCorrectionEssayEvaluations
     * @request POST:/api/v1/AssManagement/GetCorrectionEssayEvaluations
     * @secure
     * @response `200` `EssayCorrectionDtoPaginatedList` OK
     */
    getCorrectionEssayEvaluations: (
      data: GetCorrectionEssayEvaluationsPayload,
      params: RequestParams = {},
    ) =>
      this.request<EssayCorrectionDtoPaginatedList, any>({
        path: `/api/v1/AssManagement/GetCorrectionEssayEvaluations`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Lista de usuários da avaliação que possui perguntas dissertativas.
     *
     * @tags AssManagement
     * @name GetEssayCorrectionUsers
     * @request POST:/api/v1/AssManagement/GetEssayCorrectionUsers
     * @secure
     * @response `200` `(EssayCorrectionUsersResponse)[]` OK
     */
    getEssayCorrectionUsers: (
      data: GetEssayCorrectionUsersPayload,
      params: RequestParams = {},
    ) =>
      this.request<EssayCorrectionUsersResponse[], any>({
        path: `/api/v1/AssManagement/GetEssayCorrectionUsers`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Lista as questões das instâncias da avaliação para o usuário.
     *
     * @tags AssManagement
     * @name GetEssayCorrectionQuestions
     * @request POST:/api/v1/AssManagement/GetEssayCorrectionQuestions
     * @secure
     * @response `200` `EssayCorrectionQuestionResponse` OK
     */
    getEssayCorrectionQuestions: (
      data: GetEssayCorrectionQuestionsPayload,
      params: RequestParams = {},
    ) =>
      this.request<EssayCorrectionQuestionResponse, any>({
        path: `/api/v1/AssManagement/GetEssayCorrectionQuestions`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém a lista da aplicação de pesquisa.
     *
     * @tags AssManagement
     * @name ManagedAssDeploy
     * @request POST:/api/v1/AssManagement/ManagedAssDeploy
     * @secure
     * @response `200` `ManagedSurveyDeployListResponsePaginatedList` OK
     */
    managedAssDeploy: (
      data: ManagedAssDeployPayload,
      params: RequestParams = {},
    ) =>
      this.request<ManagedSurveyDeployListResponsePaginatedList, any>({
        path: `/api/v1/AssManagement/ManagedAssDeploy`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AssManagement
     * @name CreateOrUpdateAssDeploy
     * @request POST:/api/v1/AssManagement/CreateOrUpdateAssDeploy
     * @secure
     * @response `200` `string` OK
     */
    createOrUpdateAssDeploy: (
      data: CreateOrUpdateAssDeployPayload,
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/api/v1/AssManagement/CreateOrUpdateAssDeploy`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AssManagement
     * @name GetManagedAssDeploy
     * @request POST:/api/v1/AssManagement/GetManagedAssDeploy
     * @secure
     * @response `200` `ManagedAssDeployRequest` OK (May return null)
     * @response `204` `any` No Content
     */
    getManagedAssDeploy: (
      data: GetManagedAssDeployPayload,
      params: RequestParams = {},
    ) =>
      this.request<ManagedAssDeployRequest, any>({
        path: `/api/v1/AssManagement/GetManagedAssDeploy`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém lista de usuários que compõem o público-alvo da lista de grupos informada.
     *
     * @tags AssManagement
     * @name GroupsAudienceUsers
     * @request POST:/api/v1/AssManagement/GroupsAudienceUsers
     * @secure
     * @response `200` `UserItemDtoPaginatedList` OK
     */
    groupsAudienceUsers: (
      data: GroupsAudienceUsersPayload,
      params: RequestParams = {},
    ) =>
      this.request<UserItemDtoPaginatedList, any>({
        path: `/api/v1/AssManagement/GroupsAudienceUsers`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém uma lista de treinamentos onde o assessment está sendo utilizado.
     *
     * @tags AssManagement
     * @name GetTrainingAssessmentUsed
     * @request POST:/api/v1/AssManagement/GetTrainingAssessmentUsed
     * @secure
     * @response `200` `TrainingSelectorDtoPaginatedList` OK
     */
    getTrainingAssessmentUsed: (
      data: GetTrainingAssessmentUsedPayload,
      params: RequestParams = {},
    ) =>
      this.request<TrainingSelectorDtoPaginatedList, any>({
        path: `/api/v1/AssManagement/GetTrainingAssessmentUsed`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Atualiza uma avaliação.
     *
     * @tags AssManagement
     * @name UpdateEvaluation
     * @request POST:/api/v1/AssManagement/UpdateEvaluation
     * @secure
     * @response `200` `boolean` OK
     */
    updateEvaluation: (
      data: UpdateEvaluationPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/AssManagement/UpdateEvaluation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Salva uma pesquisa.
     *
     * @tags AssManagement
     * @name UpdateSurvey
     * @request POST:/api/v1/AssManagement/UpdateSurvey
     * @secure
     * @response `200` `boolean` OK
     */
    updateSurvey: (data: UpdateSurveyPayload, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/api/v1/AssManagement/UpdateSurvey`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Adiciona questões a uma avaliação.
     *
     * @tags AssManagement
     * @name AddQuestion
     * @request POST:/api/v1/AssManagement/AddQuestion
     * @secure
     * @response `200` `boolean` OK
     */
    addQuestion: (data: AddQuestionPayload, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/api/v1/AssManagement/AddQuestion`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Adiciona uma regra de sorteio de questões na avaliação.
     *
     * @tags AssManagement
     * @name AddRuleRaffleAss
     * @request POST:/api/v1/AssManagement/AddRuleRaffleAss
     * @secure
     * @response `200` `boolean` OK
     */
    addRuleRaffleAss: (
      data: AddRuleRaffleAssPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/AssManagement/AddRuleRaffleAss`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Adiciona uma regra de seleção de todas as questões de um grupo de questões.
     *
     * @tags AssManagement
     * @name AddRuleAllAss
     * @request POST:/api/v1/AssManagement/AddRuleAllAss
     * @secure
     * @response `200` `boolean` OK
     */
    addRuleAllAss: (data: AddRuleAllAssPayload, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/api/v1/AssManagement/AddRuleAllAss`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Atualizar uma regra de seleção de questões de um grupo.
     *
     * @tags AssManagement
     * @name UpdateRuleAss
     * @request POST:/api/v1/AssManagement/UpdateRuleAss
     * @secure
     * @response `200` `boolean` OK
     */
    updateRuleAss: (data: UpdateRuleAssPayload, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/api/v1/AssManagement/UpdateRuleAss`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Marca um item de uma avaliação para remoção.
     *
     * @tags AssManagement
     * @name MarkRemoveItemAssessment
     * @request POST:/api/v1/AssManagement/MarkRemoveItemAssessment
     * @secure
     * @response `200` `boolean` OK
     */
    markRemoveItemAssessment: (
      data: MarkRemoveItemAssessmentPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/AssManagement/MarkRemoveItemAssessment`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Remove itens editados e recuperados.
     *
     * @tags AssManagement
     * @name RemoveRecoveryAssessment
     * @request POST:/api/v1/AssManagement/RemoveRecoveryAssessment
     * @secure
     * @response `200` `boolean` OK
     */
    removeRecoveryAssessment: (
      data: RemoveRecoveryAssessmentPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/AssManagement/RemoveRecoveryAssessment`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Marca para remover todos os itens da avaliação/pesquisa.
     *
     * @tags AssManagement
     * @name ClearItemsAssessment
     * @request POST:/api/v1/AssManagement/ClearItemsAssessment
     * @secure
     * @response `200` `boolean` OK
     */
    clearItemsAssessment: (
      data: ClearItemsAssessmentPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/AssManagement/ClearItemsAssessment`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Marca um item de uma avaliação para remoção.
     *
     * @tags AssManagement
     * @name ReactiveItemAssessment
     * @request POST:/api/v1/AssManagement/ReactiveItemAssessment
     * @secure
     * @response `200` `boolean` OK
     */
    reactiveItemAssessment: (
      data: ReactiveItemAssessmentPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/AssManagement/ReactiveItemAssessment`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Reordena a sequência das questões do assessment.
     *
     * @tags AssManagement
     * @name ReorderItems
     * @request POST:/api/v1/AssManagement/ReorderItems
     * @secure
     * @response `200` `boolean` OK
     */
    reorderItems: (data: ReorderItemsPayload, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/api/v1/AssManagement/ReorderItems`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Duplica um item da questão do assessment e deixa exclusiva.
     *
     * @tags AssManagement
     * @name DuplicateItem
     * @request POST:/api/v1/AssManagement/DuplicateItem
     * @secure
     * @response `200` `boolean` OK
     */
    duplicateItem: (data: DuplicateItemPayload, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/api/v1/AssManagement/DuplicateItem`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Exclui uma avaliação.
     *
     * @tags AssManagement
     * @name DeleteAssessment
     * @request POST:/api/v1/AssManagement/DeleteAssessment
     * @secure
     * @response `200` `boolean` OK
     */
    deleteAssessment: (
      data: DeleteAssessmentPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/AssManagement/DeleteAssessment`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Exclui uma Pesquisa.
     *
     * @tags AssManagement
     * @name DeleteAssDeploy
     * @request POST:/api/v1/AssManagement/DeleteAssDeploy
     * @secure
     * @response `200` `boolean` OK
     */
    deleteAssDeploy: (
      data: DeleteAssDeployPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/AssManagement/DeleteAssDeploy`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Registra nota e feedback da questão dissertativa.
     *
     * @tags AssManagement
     * @name EssayRegisterCorrection
     * @request POST:/api/v1/AssManagement/EssayRegisterCorrection
     * @secure
     * @response `200` `boolean` OK
     */
    essayRegisterCorrection: (
      data: EssayRegisterCorrectionPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/AssManagement/EssayRegisterCorrection`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Duplica uma pesquisa.
     *
     * @tags AssManagement
     * @name CloneSurvey
     * @request POST:/api/v1/AssManagement/CloneSurvey
     * @secure
     * @response `200` `boolean` OK
     */
    cloneSurvey: (data: CloneSurveyPayload, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/api/v1/AssManagement/CloneSurvey`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Duplica uma avaliação.
     *
     * @tags AssManagement
     * @name CloneEvaluation
     * @request POST:/api/v1/AssManagement/CloneEvaluation
     * @secure
     * @response `200` `boolean` OK
     */
    cloneEvaluation: (
      data: CloneEvaluationPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/AssManagement/CloneEvaluation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  assPlayer = {
    /**
     * Obtém os dados do início da pesquisa para verificar a operação que o player deve executar.
     *
     * @tags AssPlayer
     * @name GetStartPlayerSurvey
     * @request POST:/api/v1/AssPlayer/GetStartPlayerSurvey
     * @secure
     * @response `200` `AssessmentStartPlayerDto` OK
     */
    getStartPlayerSurvey: (
      data: GetStartPlayerSurveyPayload,
      params: RequestParams = {},
    ) =>
      this.request<AssessmentStartPlayerDto, any>({
        path: `/api/v1/AssPlayer/GetStartPlayerSurvey`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém os dados do início da avaliação para verificar a operação que o player deve executar.
     *
     * @tags AssPlayer
     * @name GetStartPlayerEvaluation
     * @request POST:/api/v1/AssPlayer/GetStartPlayerEvaluation
     * @secure
     * @response `200` `AssessmentStartPlayerDto` OK
     */
    getStartPlayerEvaluation: (
      data: GetStartPlayerEvaluationPayload,
      params: RequestParams = {},
    ) =>
      this.request<AssessmentStartPlayerDto, any>({
        path: `/api/v1/AssPlayer/GetStartPlayerEvaluation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtem o início de do player de pesquisa no mode revisão com os dados de sumário.
     *
     * @tags AssPlayer
     * @name GetDeploySummary
     * @request POST:/api/v1/AssPlayer/GetDeploySummary
     * @secure
     * @response `200` `AssessmentInstanceDto` OK
     */
    getDeploySummary: (
      data: GetDeploySummaryPayload,
      params: RequestParams = {},
    ) =>
      this.request<AssessmentInstanceDto, any>({
        path: `/api/v1/AssPlayer/GetDeploySummary`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtem as informações de uma questão de uma instância.
     *
     * @tags AssPlayer
     * @name GetQuestionAssInstance
     * @request POST:/api/v1/AssPlayer/GetQuestionAssInstance
     * @secure
     * @response `200` `AssessmentQuestionDto` OK
     */
    getQuestionAssInstance: (
      data: GetQuestionAssInstancePayload,
      params: RequestParams = {},
    ) =>
      this.request<AssessmentQuestionDto, any>({
        path: `/api/v1/AssPlayer/GetQuestionAssInstance`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtem as informações de uma questão para revisão do deploy.
     *
     * @tags AssPlayer
     * @name GetDeployQuestion
     * @request POST:/api/v1/AssPlayer/GetDeployQuestion
     * @secure
     * @response `200` `AssessmentQuestionDto` OK
     */
    getDeployQuestion: (
      data: GetDeployQuestionPayload,
      params: RequestParams = {},
    ) =>
      this.request<AssessmentQuestionDto, any>({
        path: `/api/v1/AssPlayer/GetDeployQuestion`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtem o início de uma instância de avaliação.
     *
     * @tags AssPlayer
     * @name GetEvalInstance
     * @request POST:/api/v1/AssPlayer/GetEvalInstance
     * @secure
     * @response `200` `AssessmentInstanceDto` OK
     */
    getEvalInstance: (
      data: GetEvalInstancePayload,
      params: RequestParams = {},
    ) =>
      this.request<AssessmentInstanceDto, any>({
        path: `/api/v1/AssPlayer/GetEvalInstance`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtem o início de uma instância de pesquisa.
     *
     * @tags AssPlayer
     * @name GetSurveyInstance
     * @request POST:/api/v1/AssPlayer/GetSurveyInstance
     * @secure
     * @response `200` `AssessmentInstanceDto` OK
     */
    getSurveyInstance: (
      data: GetSurveyInstancePayload,
      params: RequestParams = {},
    ) =>
      this.request<AssessmentInstanceDto, any>({
        path: `/api/v1/AssPlayer/GetSurveyInstance`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Lista a resposta de todos os usuários da questão para revisão da pesquisa.
     *
     * @tags AssPlayer
     * @name GetRevisionEssaySurvey
     * @request POST:/api/v1/AssPlayer/GetRevisionEssaySurvey
     * @secure
     * @response `200` `RevisionEssayResponsePaginatedList` OK
     */
    getRevisionEssaySurvey: (
      data: GetRevisionEssaySurveyPayload,
      params: RequestParams = {},
    ) =>
      this.request<RevisionEssayResponsePaginatedList, any>({
        path: `/api/v1/AssPlayer/GetRevisionEssaySurvey`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém a lista de usuários que responderam a questão.
     *
     * @tags AssPlayer
     * @name GetUserAnswersQuestion
     * @request POST:/api/v1/AssPlayer/GetUserAnswersQuestion
     * @secure
     * @response `200` `UserAnswersQuestionResponsePaginatedList` OK
     */
    getUserAnswersQuestion: (
      data: GetUserAnswersQuestionPayload,
      params: RequestParams = {},
    ) =>
      this.request<UserAnswersQuestionResponsePaginatedList, any>({
        path: `/api/v1/AssPlayer/GetUserAnswersQuestion`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém a lista de usuários que responderam a alternativa da questão.
     *
     * @tags AssPlayer
     * @name GetUserAnswersAlternative
     * @request POST:/api/v1/AssPlayer/GetUserAnswersAlternative
     * @secure
     * @response `200` `AnswersAlternativeDtoPaginatedList` OK
     */
    getUserAnswersAlternative: (
      data: GetUserAnswersAlternativePayload,
      params: RequestParams = {},
    ) =>
      this.request<AnswersAlternativeDtoPaginatedList, any>({
        path: `/api/v1/AssPlayer/GetUserAnswersAlternative`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém o resultado final de uma instância finalizada.
     *
     * @tags AssPlayer
     * @name GetEvalResultInstance
     * @request POST:/api/v1/AssPlayer/GetEvalResultInstance
     * @secure
     * @response `200` `AssessmentInstanceResultDto` OK
     */
    getEvalResultInstance: (
      data: GetEvalResultInstancePayload,
      params: RequestParams = {},
    ) =>
      this.request<AssessmentInstanceResultDto, any>({
        path: `/api/v1/AssPlayer/GetEvalResultInstance`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém a lista de tópicos para responder nos testes de conhecimento.
     *
     * @tags AssPlayer
     * @name ChallengeUserTopics
     * @request POST:/api/v1/AssPlayer/ChallengeUserTopics
     * @secure
     * @response `200` `ChallengeUserTopicResponse` OK
     */
    challengeUserTopics: (
      data: ChallengeUserTopicsPayload,
      params: RequestParams = {},
    ) =>
      this.request<ChallengeUserTopicResponse, any>({
        path: `/api/v1/AssPlayer/ChallengeUserTopics`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Verifica se tem alguma instância que não foi concluída.
     *
     * @tags AssPlayer
     * @name ChallengeAnswerPending
     * @request POST:/api/v1/AssPlayer/ChallengeAnswerPending
     * @secure
     * @response `200` `ChallengePendingTopicResponse` OK
     */
    challengeAnswerPending: (params: RequestParams = {}) =>
      this.request<ChallengePendingTopicResponse, any>({
        path: `/api/v1/AssPlayer/ChallengeAnswerPending`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Obtém o início de uma instância de desafio de conhecimento.
     *
     * @tags AssPlayer
     * @name GetChallengeInstance
     * @request POST:/api/v1/AssPlayer/GetChallengeInstance
     * @secure
     * @response `200` `AssessmentInstanceDto` OK
     */
    getChallengeInstance: (
      data: GetChallengeInstancePayload,
      params: RequestParams = {},
    ) =>
      this.request<AssessmentInstanceDto, any>({
        path: `/api/v1/AssPlayer/GetChallengeInstance`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém os dados final do resultdo da execução do teste de desafio.
     *
     * @tags AssPlayer
     * @name GetChallengeResult
     * @request POST:/api/v1/AssPlayer/GetChallengeResult
     * @secure
     * @response `200` `AssessmentChallengeRevisionDto` OK
     */
    getChallengeResult: (
      data: GetChallengeResultPayload,
      params: RequestParams = {},
    ) =>
      this.request<AssessmentChallengeRevisionDto, any>({
        path: `/api/v1/AssPlayer/GetChallengeResult`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém Registro de configuração para desafios de conhecimento.
     *
     * @tags AssPlayer
     * @name GetChallengeSettings
     * @request POST:/api/v1/AssPlayer/GetChallengeSettings
     * @secure
     * @response `200` `ChallengeLmsSettingsResponse` OK
     */
    getChallengeSettings: (params: RequestParams = {}) =>
      this.request<ChallengeLmsSettingsResponse, any>({
        path: `/api/v1/AssPlayer/GetChallengeSettings`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Cria ou inicia uma instâncida de uma avaliação.
     *
     * @tags AssPlayer
     * @name CreateEvalInstance
     * @request POST:/api/v1/AssPlayer/CreateEvalInstance
     * @secure
     * @response `200` `AssessmentInstanceDto` OK
     */
    createEvalInstance: (
      data: CreateEvalInstancePayload,
      params: RequestParams = {},
    ) =>
      this.request<AssessmentInstanceDto, any>({
        path: `/api/v1/AssPlayer/CreateEvalInstance`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Registra o início da instância de uma avaliação.
     *
     * @tags AssPlayer
     * @name StartEvalInstance
     * @request POST:/api/v1/AssPlayer/StartEvalInstance
     * @secure
     * @response `200` `AssessmentSaveResultDto` OK
     */
    startEvalInstance: (
      data: StartEvalInstancePayload,
      params: RequestParams = {},
    ) =>
      this.request<AssessmentSaveResultDto, any>({
        path: `/api/v1/AssPlayer/StartEvalInstance`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Cria uma instância de um desafio para um tópico.
     *
     * @tags AssPlayer
     * @name CreateChallengeInstance
     * @request POST:/api/v1/AssPlayer/CreateChallengeInstance
     * @secure
     * @response `200` `AssessmentInstanceDto` OK
     */
    createChallengeInstance: (
      data: CreateChallengeInstancePayload,
      params: RequestParams = {},
    ) =>
      this.request<AssessmentInstanceDto, any>({
        path: `/api/v1/AssPlayer/CreateChallengeInstance`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Cria ou inicia uma instâncida de uma pesquisa.
     *
     * @tags AssPlayer
     * @name CreateSurveyInstance
     * @request POST:/api/v1/AssPlayer/CreateSurveyInstance
     * @secure
     * @response `200` `AssessmentInstanceDto` OK
     */
    createSurveyInstance: (
      data: CreateSurveyInstancePayload,
      params: RequestParams = {},
    ) =>
      this.request<AssessmentInstanceDto, any>({
        path: `/api/v1/AssPlayer/CreateSurveyInstance`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Salva a resposta de questão de uma instância.
     *
     * @tags AssPlayer
     * @name SaveAnswerAssInstance
     * @request POST:/api/v1/AssPlayer/SaveAnswerAssInstance
     * @secure
     * @response `200` `AssessmentSaveResultDto` OK
     */
    saveAnswerAssInstance: (
      data: SaveAnswerAssInstancePayload,
      params: RequestParams = {},
    ) =>
      this.request<AssessmentSaveResultDto, any>({
        path: `/api/v1/AssPlayer/SaveAnswerAssInstance`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Registra o tempo de resposta e o ping.
     *
     * @tags AssPlayer
     * @name PingAssInstance
     * @request POST:/api/v1/AssPlayer/PingAssInstance
     * @secure
     * @response `200` `boolean` OK
     */
    pingAssInstance: (
      data: PingAssInstancePayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/AssPlayer/PingAssInstance`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Exclui a instância em modo preview.
     *
     * @tags AssPlayer
     * @name DeletePreviewAssInstance
     * @request POST:/api/v1/AssPlayer/DeletePreviewAssInstance
     * @secure
     * @response `200` `boolean` OK
     */
    deletePreviewAssInstance: (
      data: DeletePreviewAssInstancePayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/AssPlayer/DeletePreviewAssInstance`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Registra o início da instância de uma pesquisa.
     *
     * @tags AssPlayer
     * @name StartSurveyInstance
     * @request POST:/api/v1/AssPlayer/StartSurveyInstance
     * @secure
     * @response `200` `AssessmentSaveResultDto` OK
     */
    startSurveyInstance: (
      data: StartSurveyInstancePayload,
      params: RequestParams = {},
    ) =>
      this.request<AssessmentSaveResultDto, any>({
        path: `/api/v1/AssPlayer/StartSurveyInstance`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Exclui a instância em modo preview.
     *
     * @tags AssPlayer
     * @name FinishAssInstance
     * @request POST:/api/v1/AssPlayer/FinishAssInstance
     * @secure
     * @response `200` `AssessmentSaveResultDto` OK
     */
    finishAssInstance: (
      data: FinishAssInstancePayload,
      params: RequestParams = {},
    ) =>
      this.request<AssessmentSaveResultDto, any>({
        path: `/api/v1/AssPlayer/FinishAssInstance`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  assSelectors = {
    /**
     * Obtém uma lista de avaliação para seleção.
     *
     * @tags AssSelectors
     * @name Assessments
     * @request POST:/api/v1/AssSelectors/Assessments
     * @secure
     * @response `200` `AssessmentSelectorDtoPaginatedList` OK
     */
    assessments: (data: AssessmentsPayload, params: RequestParams = {}) =>
      this.request<AssessmentSelectorDtoPaginatedList, any>({
        path: `/api/v1/AssSelectors/Assessments`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém uma lista de assessment onde a questão é utilizada.
     *
     * @tags AssSelectors
     * @name GetAssessmentQuestionUsed
     * @request POST:/api/v1/AssSelectors/GetAssessmentQuestionUsed
     * @secure
     * @response `200` `AssessmentSelectorDtoPaginatedList` OK
     */
    getAssessmentQuestionUsed: (
      data: GetAssessmentQuestionUsedPayload,
      params: RequestParams = {},
    ) =>
      this.request<AssessmentSelectorDtoPaginatedList, any>({
        path: `/api/v1/AssSelectors/GetAssessmentQuestionUsed`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  assSuggestions = {
    /**
     * Obtém sugestões de avaliações.
     *
     * @tags AssSuggestions
     * @name EvaluationSuggestions
     * @request POST:/api/v1/AssSuggestions/EvaluationSuggestions
     * @secure
     * @response `200` `AutoCompleteDataModelDtoPaginatedList` OK
     */
    evaluationSuggestions: (
      data: EvaluationSuggestionsPayload,
      params: RequestParams = {},
    ) =>
      this.request<AutoCompleteDataModelDtoPaginatedList, any>({
        path: `/api/v1/AssSuggestions/EvaluationSuggestions`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém sugestões de pesquisa.
     *
     * @tags AssSuggestions
     * @name SurveySuggestions
     * @request POST:/api/v1/AssSuggestions/SurveySuggestions
     * @secure
     * @response `200` `AutoCompleteDataModelDtoPaginatedList` OK
     */
    surveySuggestions: (
      data: SurveySuggestionsPayload,
      params: RequestParams = {},
    ) =>
      this.request<AutoCompleteDataModelDtoPaginatedList, any>({
        path: `/api/v1/AssSuggestions/SurveySuggestions`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém sugestões de pesquisas aplicadas.
     *
     * @tags AssSuggestions
     * @name AssDeployGetSuggestions
     * @request POST:/api/v1/AssSuggestions/AssDeployGetSuggestions
     * @secure
     * @response `200` `AutoCompleteDataModelDtoPaginatedList` OK
     */
    assDeployGetSuggestions: (
      data: AssDeployGetSuggestionsPayload,
      params: RequestParams = {},
    ) =>
      this.request<AutoCompleteDataModelDtoPaginatedList, any>({
        path: `/api/v1/AssSuggestions/AssDeployGetSuggestions`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  asyncUpload = {
    /**
     * Passe parâmetros opcionais utilizando FORM DATA: createThumbnail: number [no=0, yes=1]
     *
     * @tags AsyncUpload
     * @name ChunkUpload
     * @summary ==1== Guarda o arquivo divido em partes, na área de Upload.
     * @request POST:/api/v1/AsyncUpload/ChunkUpload
     * @secure
     * @response `200` `AsyncUploadResult` OK
     */
    chunkUpload: (params: RequestParams = {}) =>
      this.request<AsyncUploadResult, any>({
        path: `/api/v1/AsyncUpload/ChunkUpload`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Passe parâmetros opcionais utilizando FORM DATA: createThumbnail: number [no=0, yes=1]
     *
     * @tags AsyncUpload
     * @name Save
     * @summary ==1== Guarda o arquivo na área de Upload.
     * @request POST:/api/v1/AsyncUpload/Save
     * @secure
     * @response `200` `AsyncUploadResult` OK
     */
    save: (params: RequestParams = {}) =>
      this.request<AsyncUploadResult, any>({
        path: `/api/v1/AsyncUpload/Save`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Remove o arquivo da área de Upload
     *
     * @tags AsyncUpload
     * @name Remove
     * @request POST:/api/v1/AsyncUpload/Remove
     * @secure
     * @response `200` `boolean` OK
     */
    remove: (params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/api/v1/AsyncUpload/Remove`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  auditLog = {
    /**
     * Obtém o AuditLog.
     *
     * @tags AuditLog
     * @name GetLogs
     * @request POST:/api/v1/AuditLog/GetLogs
     * @secure
     * @response `200` `AuditLogDtoPaginatedList` OK
     */
    getLogs: (data: GetLogsPayload, params: RequestParams = {}) =>
      this.request<AuditLogDtoPaginatedList, any>({
        path: `/api/v1/AuditLog/GetLogs`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém o Conteúdo Detalhado de um Log de Auditoria.
     *
     * @tags AuditLog
     * @name GetAuditLogDetail
     * @request POST:/api/v1/AuditLog/GetAuditLogDetail
     * @secure
     * @response `200` `string` OK (May return null)
     * @response `204` `any` No Content
     */
    getAuditLogDetail: (
      data: GetAuditLogDetailPayload,
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/api/v1/AuditLog/GetAuditLogDetail`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém a Lista de Eventos do Log de Auditoria.
     *
     * @tags AuditLog
     * @name GetEvents
     * @request POST:/api/v1/AuditLog/GetEvents
     * @secure
     * @response `200` `(AuditLogEventResponse)[]` OK
     */
    getEvents: (params: RequestParams = {}) =>
      this.request<AuditLogEventResponse[], any>({
        path: `/api/v1/AuditLog/GetEvents`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Obtém a Lista de Entidades do Log de Auditoria.
     *
     * @tags AuditLog
     * @name GetEntityTypes
     * @request POST:/api/v1/AuditLog/GetEntityTypes
     * @secure
     * @response `200` `(AuditLogEntityTypeResponse)[]` OK
     */
    getEntityTypes: (data: GetEntityTypesPayload, params: RequestParams = {}) =>
      this.request<AuditLogEntityTypeResponse[], any>({
        path: `/api/v1/AuditLog/GetEntityTypes`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  award = {
    /**
     * Obtém uma lista de Medalhas.
     *
     * @tags Award
     * @name GetAwardResume
     * @request POST:/api/v1/Award/GetAwardResume
     * @secure
     * @response `200` `AwardResumeResponse` OK
     */
    getAwardResume: (data: GetAwardResumePayload, params: RequestParams = {}) =>
      this.request<AwardResumeResponse, any>({
        path: `/api/v1/Award/GetAwardResume`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  awardRanking = {
    /**
     * Obtém a lista de rankings.
     *
     * @tags AwardRanking
     * @name ManagedRankings
     * @request POST:/api/v1/AwardRanking/ManagedRankings
     * @secure
     * @response `200` `(ManagedAwardRankingListResponse)[]` OK
     */
    managedRankings: (params: RequestParams = {}) =>
      this.request<ManagedAwardRankingListResponse[], any>({
        path: `/api/v1/AwardRanking/ManagedRankings`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Obtem os dados para criação / edição de uma Premiação Global.
     *
     * @tags AwardRanking
     * @name ManagedGetRanking
     * @request POST:/api/v1/AwardRanking/ManagedGetRanking
     * @secure
     * @response `200` `ManagedAwardRankingResponse` OK
     */
    managedGetRanking: (
      data: ManagedGetRankingPayload,
      params: RequestParams = {},
    ) =>
      this.request<ManagedAwardRankingResponse, any>({
        path: `/api/v1/AwardRanking/ManagedGetRanking`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Cria ou atualiza um ranking de premiação global.
     *
     * @tags AwardRanking
     * @name CreateOrUpdateAwardRanking
     * @request POST:/api/v1/AwardRanking/CreateOrUpdateAwardRanking
     * @secure
     * @response `200` `string | null` OK (May return null)
     * @response `204` `any` No Content
     */
    createOrUpdateAwardRanking: (
      data: CreateOrUpdateAwardRankingPayload,
      params: RequestParams = {},
    ) =>
      this.request<string | null, any>({
        path: `/api/v1/AwardRanking/CreateOrUpdateAwardRanking`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Excluir um ranking de premiação global.
     *
     * @tags AwardRanking
     * @name DeleteAwardRanking
     * @request POST:/api/v1/AwardRanking/DeleteAwardRanking
     * @secure
     * @response `200` `boolean` OK
     */
    deleteAwardRanking: (
      data: DeleteAwardRankingPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/AwardRanking/DeleteAwardRanking`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  azure = {
    /**
     * Executa tradução de um texto em vários idiomas utilizando a API do Microsoft Azure.
     *
     * @tags Azure
     * @name TranslateText
     * @request POST:/api/v1/Azure/TranslateText
     * @secure
     * @response `200` `AzureTranslationTextResponse` OK
     */
    translateText: (data: TranslateTextPayload, params: RequestParams = {}) =>
      this.request<AzureTranslationTextResponse, any>({
        path: `/api/v1/Azure/TranslateText`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  badge = {
    /**
     * Obtém uma lista de Medalhas.
     *
     * @tags Badge
     * @name ManagedBadges
     * @request POST:/api/v1/Badge/ManagedBadges
     * @secure
     * @response `200` `ManagedBadgeListQueryResponsePaginatedList` OK
     */
    managedBadges: (data: ManagedBadgesPayload, params: RequestParams = {}) =>
      this.request<ManagedBadgeListQueryResponsePaginatedList, any>({
        path: `/api/v1/Badge/ManagedBadges`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtem os dados para criação / edição de uma medalha.
     *
     * @tags Badge
     * @name ManagedGetBadge
     * @request POST:/api/v1/Badge/ManagedGetBadge
     * @secure
     * @response `200` `ManagedBadgeResponse` OK
     */
    managedGetBadge: (
      data: ManagedGetBadgePayload,
      params: RequestParams = {},
    ) =>
      this.request<ManagedBadgeResponse, any>({
        path: `/api/v1/Badge/ManagedGetBadge`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém a Lista de Tipos Pré-definidos para medalhas.
     *
     * @tags Badge
     * @name GetBadgeSystemList
     * @request POST:/api/v1/Badge/GetBadgeSystemList
     * @secure
     * @response `200` `BadgeSystemListResponse` OK
     */
    getBadgeSystemList: (
      data: GetBadgeSystemListPayload,
      params: RequestParams = {},
    ) =>
      this.request<BadgeSystemListResponse, any>({
        path: `/api/v1/Badge/GetBadgeSystemList`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém informações sobre medalha.
     *
     * @tags Badge
     * @name GetBadgeInfo
     * @request POST:/api/v1/Badge/GetBadgeInfo
     * @secure
     * @response `200` `BadgeInfoResponse` OK
     */
    getBadgeInfo: (data: GetBadgeInfoPayload, params: RequestParams = {}) =>
      this.request<BadgeInfoResponse, any>({
        path: `/api/v1/Badge/GetBadgeInfo`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Cria ou atualiza uma madalha.
     *
     * @tags Badge
     * @name CreateOrUpdateBadge
     * @request POST:/api/v1/Badge/CreateOrUpdateBadge
     * @secure
     * @response `200` `string | null` OK (May return null)
     * @response `204` `any` No Content
     */
    createOrUpdateBadge: (
      data: CreateOrUpdateBadgePayload,
      params: RequestParams = {},
    ) =>
      this.request<string | null, any>({
        path: `/api/v1/Badge/CreateOrUpdateBadge`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Exclui uma medalha.
     *
     * @tags Badge
     * @name DeleteBadge
     * @request POST:/api/v1/Badge/DeleteBadge
     * @secure
     * @response `200` `DeleteBadgeResponse` OK
     */
    deleteBadge: (data: DeleteBadgePayload, params: RequestParams = {}) =>
      this.request<DeleteBadgeResponse, any>({
        path: `/api/v1/Badge/DeleteBadge`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  banner = {
    /**
     * Lista um banner
     *
     * @tags Banner
     * @name ListBanner
     * @request POST:/api/v1/Banner/ListBanner
     * @secure
     * @response `200` `BannerListResponsePaginatedList` OK
     */
    listBanner: (data: ListBannerPayload, params: RequestParams = {}) =>
      this.request<BannerListResponsePaginatedList, any>({
        path: `/api/v1/Banner/ListBanner`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Cria um banner
     *
     * @tags Banner
     * @name CreateOrUpdateBanner
     * @request POST:/api/v1/Banner/CreateOrUpdateBanner
     * @secure
     * @response `200` `string` OK
     */
    createOrUpdateBanner: (
      data: CreateOrUpdateBannerPayload,
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/api/v1/Banner/CreateOrUpdateBanner`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Exclui um banner
     *
     * @tags Banner
     * @name DeleteBanner
     * @request DELETE:/api/v1/Banner/DeleteBanner
     * @secure
     * @response `200` `boolean` OK
     */
    deleteBanner: (
      query?: {
        /** @format uuid */
        BannerId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/Banner/DeleteBanner`,
        method: "DELETE",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Adiciona um click ao banner.
     *
     * @tags Banner
     * @name AddHit
     * @request PUT:/api/v1/Banner/AddHit
     * @secure
     * @response `200` `boolean` OK
     */
    addHit: (
      query?: {
        /** @format uuid */
        BannerId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/Banner/AddHit`,
        method: "PUT",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Obtem um Banner para edição.
     *
     * @tags Banner
     * @name GetBanner
     * @request POST:/api/v1/Banner/GetBanner
     * @secure
     * @response `200` `ManagedBannerResponse` OK
     */
    getBanner: (data: GetBannerPayload, params: RequestParams = {}) =>
      this.request<ManagedBannerResponse, any>({
        path: `/api/v1/Banner/GetBanner`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtem uma lista de banner oara exibição.
     *
     * @tags Banner
     * @name GetBanners
     * @request POST:/api/v1/Banner/GetBanners
     * @secure
     * @response `200` `BannerResponsePaginatedList` OK
     */
    getBanners: (data: GetBannersPayload, params: RequestParams = {}) =>
      this.request<BannerResponsePaginatedList, any>({
        path: `/api/v1/Banner/GetBanners`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Reordena a priorização do Banner
     *
     * @tags Banner
     * @name ReorderBanner
     * @request POST:/api/v1/Banner/ReorderBanner
     * @secure
     * @response `200` `boolean` OK
     */
    reorderBanner: (data: ReorderBannerPayload, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/api/v1/Banner/ReorderBanner`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtem uma lista de banner para reodernar a priorização
     *
     * @tags Banner
     * @name GetOrderBanner
     * @request POST:/api/v1/Banner/GetOrderBanner
     * @secure
     * @response `200` `BannerListResponsePaginatedList` OK
     */
    getOrderBanner: (data: GetOrderBannerPayload, params: RequestParams = {}) =>
      this.request<BannerListResponsePaginatedList, any>({
        path: `/api/v1/Banner/GetOrderBanner`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Publicações.
     *
     * @tags Banner
     * @name Publications
     * @request POST:/api/v1/Banner/Publications
     * @secure
     * @response `200` `PublicationSelectorDtoPaginatedList` OK
     */
    publications: (data: PublicationsPayload, params: RequestParams = {}) =>
      this.request<PublicationSelectorDtoPaginatedList, any>({
        path: `/api/v1/Banner/Publications`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  calendar = {
    /**
     * Cria um calendário
     *
     * @tags Calendar
     * @name CreateCalendar
     * @request POST:/api/v1/Calendar/CreateCalendar
     * @secure
     * @response `200` `string` OK
     */
    createCalendar: (
      query?: {
        /** @format uuid */
        CalendarId?: string;
        Name?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/api/v1/Calendar/CreateCalendar`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Altera um calendário
     *
     * @tags Calendar
     * @name UpdateCalendar
     * @request PUT:/api/v1/Calendar/UpdateCalendar
     * @secure
     * @response `200` `string` OK
     */
    updateCalendar: (
      query?: {
        /** @format uuid */
        CalendarId?: string;
        Name?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/api/v1/Calendar/UpdateCalendar`,
        method: "PUT",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Exclui um calendário
     *
     * @tags Calendar
     * @name DeleteCalendar
     * @request DELETE:/api/v1/Calendar/DeleteCalendar
     * @secure
     * @response `200` `boolean` OK
     */
    deleteCalendar: (
      query?: {
        /** @format uuid */
        CalendarId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/Calendar/DeleteCalendar`,
        method: "DELETE",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Obtém uma lista de calendários
     *
     * @tags Calendar
     * @name ManagedHolidaysCalendars
     * @request GET:/api/v1/Calendar/ManagedHolidaysCalendars
     * @secure
     * @response `200` `ManagedCalendarListResponsePaginatedList` OK
     */
    managedHolidaysCalendars: (
      query?: {
        SearchText?: string;
        /** @format int32 */
        PageNumber?: number;
        /** @format int32 */
        PageSize?: number;
        /** @format int32 */
        Offset?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<ManagedCalendarListResponsePaginatedList, any>({
        path: `/api/v1/Calendar/ManagedHolidaysCalendars`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Define calendário padrão
     *
     * @tags Calendar
     * @name SetDefaultCalendar
     * @request PUT:/api/v1/Calendar/SetDefaultCalendar
     * @secure
     * @response `200` `boolean` OK
     */
    setDefaultCalendar: (
      data: SetDefaultCalendarPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/Calendar/SetDefaultCalendar`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém uma lista de feriados de um calendário.
     *
     * @tags Calendar
     * @name GetHolidays
     * @request GET:/api/v1/Calendar/GetHolidays
     * @secure
     * @response `200` `ManagedHolidayListResponsePaginatedList` OK
     */
    getHolidays: (
      query?: {
        /** @format uuid */
        CalendarId?: string;
        SearchText?: string;
        ViewCurrentYear?: boolean;
        /** @format int32 */
        PageNumber?: number;
        /** @format int32 */
        PageSize?: number;
        /** @format int32 */
        Offset?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<ManagedHolidayListResponsePaginatedList, any>({
        path: `/api/v1/Calendar/GetHolidays`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Adiciona um feriado.
     *
     * @tags Calendar
     * @name AddHoliday
     * @request POST:/api/v1/Calendar/AddHoliday
     * @secure
     * @response `200` `boolean` OK
     */
    addHoliday: (data: AddHolidayPayload, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/api/v1/Calendar/AddHoliday`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Altera um feriado.
     *
     * @tags Calendar
     * @name UpdateHoliday
     * @request PUT:/api/v1/Calendar/UpdateHoliday
     * @secure
     * @response `200` `boolean` OK
     */
    updateHoliday: (data: UpdateHolidayPayload, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/api/v1/Calendar/UpdateHoliday`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Remove um feriado.
     *
     * @tags Calendar
     * @name RemoveHoliday
     * @request DELETE:/api/v1/Calendar/RemoveHoliday
     * @secure
     * @response `200` `boolean` OK
     */
    removeHoliday: (data: RemoveHolidayPayload, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/api/v1/Calendar/RemoveHoliday`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Replica feriados do ano atual para o próximo ano.
     *
     * @tags Calendar
     * @name ReplyHolidaysToNextYear
     * @request POST:/api/v1/Calendar/ReplyHolidaysToNextYear
     * @secure
     * @response `200` `number` OK
     */
    replyHolidaysToNextYear: (
      query?: {
        /** @format uuid */
        CalendarId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<number, any>({
        path: `/api/v1/Calendar/ReplyHolidaysToNextYear`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  captcha = {
    /**
     * No description
     *
     * @tags Captcha
     * @name ValidateRecaptcha
     * @request POST:/api/v1/Captcha/ValidateRecaptcha
     * @secure
     * @response `200` `number` OK
     */
    validateRecaptcha: (
      data: ValidateRecaptchaPayload,
      params: RequestParams = {},
    ) =>
      this.request<number, any>({
        path: `/api/v1/Captcha/ValidateRecaptcha`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  carousel = {
    /**
     * Obtém a Configuração da Lista de Carrosséis.
     *
     * @tags Carousel
     * @name GetConfig
     * @request POST:/api/v1/Carousel/GetConfig
     * @secure
     * @response `200` `CarouselConfigDto` OK
     */
    getConfig: (data: GetConfigPayload, params: RequestParams = {}) =>
      this.request<CarouselConfigDto, any>({
        path: `/api/v1/Carousel/GetConfig`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém a definição de um link do carrossel.
     *
     * @tags Carousel
     * @name GetCarouselLinkInfo
     * @request POST:/api/v1/Carousel/GetCarouselLinkInfo
     * @secure
     * @response `200` `CarouselLinkInfoDto` OK
     */
    getCarouselLinkInfo: (
      data: GetCarouselLinkInfoPayload,
      params: RequestParams = {},
    ) =>
      this.request<CarouselLinkInfoDto, any>({
        path: `/api/v1/Carousel/GetCarouselLinkInfo`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém os Dados do Carrossel.
     *
     * @tags Carousel
     * @name GetCarouselData
     * @request POST:/api/v1/Carousel/GetCarouselData
     * @secure
     * @response `200` `CarouselDataResponse` OK
     */
    getCarouselData: (
      data: GetCarouselDataPayload,
      params: RequestParams = {},
    ) =>
      this.request<CarouselDataResponse, any>({
        path: `/api/v1/Carousel/GetCarouselData`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém a Lista de Carrosséis de um módulo.
     *
     * @tags Carousel
     * @name GetManageCarouselList
     * @request POST:/api/v1/Carousel/GetManageCarouselList
     * @secure
     * @response `200` `(ManageCarouselListResponse)[]` OK
     */
    getManageCarouselList: (
      data: GetManageCarouselListPayload,
      params: RequestParams = {},
    ) =>
      this.request<ManageCarouselListResponse[], any>({
        path: `/api/v1/Carousel/GetManageCarouselList`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém a Lista de Tipos Pré-definidos de Carrosséis.
     *
     * @tags Carousel
     * @name GetSystemList
     * @request POST:/api/v1/Carousel/GetSystemList
     * @secure
     * @response `200` `(CarouselSystemListResponse)[]` OK
     */
    getSystemList: (data: GetSystemListPayload, params: RequestParams = {}) =>
      this.request<CarouselSystemListResponse[], any>({
        path: `/api/v1/Carousel/GetSystemList`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém a definição de um carrossel.
     *
     * @tags Carousel
     * @name GetManageCarousel
     * @request POST:/api/v1/Carousel/GetManageCarousel
     * @secure
     * @response `200` `CarouselGetDto` OK
     */
    getManageCarousel: (
      data: GetManageCarouselPayload,
      params: RequestParams = {},
    ) =>
      this.request<CarouselGetDto, any>({
        path: `/api/v1/Carousel/GetManageCarousel`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Verifica se há algum nova dado sensível que foi atualizado.
     *
     * @tags Carousel
     * @name CheckNewSensitiveData
     * @request POST:/api/v1/Carousel/CheckNewSensitiveData
     * @secure
     * @response `200` `boolean` OK
     */
    checkNewSensitiveData: (
      data: CheckNewSensitiveDataPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/Carousel/CheckNewSensitiveData`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Atualiza o Carrossel.
     *
     * @tags Carousel
     * @name SaveCarousel
     * @request POST:/api/v1/Carousel/SaveCarousel
     * @secure
     * @response `200` `string | null` OK (May return null)
     * @response `204` `any` No Content
     */
    saveCarousel: (data: SaveCarouselPayload, params: RequestParams = {}) =>
      this.request<string | null, any>({
        path: `/api/v1/Carousel/SaveCarousel`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Atualiza uma operação de movimentação ou exclusão.
     *
     * @tags Carousel
     * @name ExecuteOperation
     * @request POST:/api/v1/Carousel/ExecuteOperation
     * @secure
     * @response `200` `CarouselOperationResult` OK
     */
    executeOperation: (
      data: ExecuteOperationPayload,
      params: RequestParams = {},
    ) =>
      this.request<CarouselOperationResult, any>({
        path: `/api/v1/Carousel/ExecuteOperation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Move uma Linha do Carrossel.
     *
     * @tags Carousel
     * @name MoveLine
     * @request POST:/api/v1/Carousel/MoveLine
     * @secure
     * @response `200` `CarouselOperationResult` OK
     */
    moveLine: (data: MoveLinePayload, params: RequestParams = {}) =>
      this.request<CarouselOperationResult, any>({
        path: `/api/v1/Carousel/MoveLine`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  cds = {
    /**
     * Valida se canal de comunicação com o Cds está ativo
     *
     * @tags Cds
     * @name CheckAlive
     * @request POST:/api/v1/Cds/CheckAlive
     * @secure
     * @response `200` `string` OK
     */
    checkAlive: (data: CheckAlivePayload, params: RequestParams = {}) =>
      this.request<string, any>({
        path: `/api/v1/Cds/CheckAlive`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtem um token de acesso ao Scorm Player.
     *
     * @tags Cds
     * @name GetScormPlayerToken
     * @request POST:/api/v1/Cds/GetScormPlayerToken
     * @secure
     * @response `200` `string` OK (May return null)
     * @response `204` `any` No Content
     */
    getScormPlayerToken: (
      data: GetScormPlayerTokenPayload,
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/api/v1/Cds/GetScormPlayerToken`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtem os dados necessarios para o lançamento do curso
     *
     * @tags Cds
     * @name GetLaunchSco
     * @request POST:/api/v1/Cds/GetLaunchSco
     * @secure
     * @response `200` `any` OK
     */
    getLaunchSco: (params: RequestParams = {}) =>
      this.request<any, any>({
        path: `/api/v1/Cds/GetLaunchSco`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Cds
     * @name GetScoData
     * @request POST:/api/v1/Cds/GetScoData
     * @secure
     * @response `200` `any` OK
     */
    getScoData: (params: RequestParams = {}) =>
      this.request<any, any>({
        path: `/api/v1/Cds/GetScoData`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Cds
     * @name SetScoData
     * @request POST:/api/v1/Cds/SetScoData
     * @secure
     * @response `200` `any` OK
     */
    setScoData: (params: RequestParams = {}) =>
      this.request<any, any>({
        path: `/api/v1/Cds/SetScoData`,
        method: "POST",
        secure: true,
        ...params,
      }),
  };
  channelManagement = {
    /**
     * Obtém a lista de Canais.
     *
     * @tags ChannelManagement
     * @name ManagedChannel
     * @request POST:/api/v1/ChannelManagement/ManagedChannel
     * @secure
     * @response `200` `ManagedChannelListQueryResponsePaginatedList` OK
     */
    managedChannel: (data: ManagedChannelPayload, params: RequestParams = {}) =>
      this.request<ManagedChannelListQueryResponsePaginatedList, any>({
        path: `/api/v1/ChannelManagement/ManagedChannel`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém as informações principais do Canal para edição.
     *
     * @tags ChannelManagement
     * @name GetChannel
     * @request GET:/api/v1/ChannelManagement/GetChannel
     * @secure
     * @response `200` `ManagedChannelQueryResponse` OK
     */
    getChannel: (
      query?: {
        /** @format uuid */
        ChannelId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ManagedChannelQueryResponse, any>({
        path: `/api/v1/ChannelManagement/GetChannel`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Quantidade de publicaçãoes que canal possui.
     *
     * @tags ChannelManagement
     * @name ChannelPublications
     * @request GET:/api/v1/ChannelManagement/ChannelPublications
     * @secure
     * @response `200` `number` OK
     */
    channelPublications: (
      query?: {
        /** @format uuid */
        ChannelId?: string;
        Option?: ChannelPublicationsCountOption;
      },
      params: RequestParams = {},
    ) =>
      this.request<number, any>({
        path: `/api/v1/ChannelManagement/ChannelPublications`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Obtém as informações principais do Canal para criação.
     *
     * @tags ChannelManagement
     * @name GetChannelDefault
     * @request GET:/api/v1/ChannelManagement/GetChannelDefault
     * @secure
     * @response `200` `ManagedChannelQueryResponse` OK
     */
    getChannelDefault: (params: RequestParams = {}) =>
      this.request<ManagedChannelQueryResponse, any>({
        path: `/api/v1/ChannelManagement/GetChannelDefault`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Obtém uma lista de membros do canal.
     *
     * @tags ChannelManagement
     * @name GetMembers
     * @request GET:/api/v1/ChannelManagement/GetMembers
     * @secure
     * @response `200` `ManagedChannelMembersListResponsePaginatedList` OK
     */
    getMembers: (
      query?: {
        /** @format uuid */
        ChannelId?: string;
        SearchText?: string;
        ExpandedMode?: boolean;
        OrderBy?: ManagedChannelMembersListOrderBy;
        /** @format int32 */
        PageNumber?: number;
        /** @format int32 */
        PageSize?: number;
        /** @format int32 */
        Offset?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<ManagedChannelMembersListResponsePaginatedList, any>({
        path: `/api/v1/ChannelManagement/GetMembers`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Obtém uma lista de membros do canal.
     *
     * @tags ChannelManagement
     * @name GetChannelPermissions
     * @request GET:/api/v1/ChannelManagement/GetChannelPermissions
     * @secure
     * @response `200` `ChannelPermissionsResponse` OK
     */
    getChannelPermissions: (
      query?: {
        /** @format uuid */
        ChannelId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ChannelPermissionsResponse, any>({
        path: `/api/v1/ChannelManagement/GetChannelPermissions`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Cria um canal.
     *
     * @tags ChannelManagement
     * @name CreateChannel
     * @request POST:/api/v1/ChannelManagement/CreateChannel
     * @secure
     * @response `200` `string | null` OK
     */
    createChannel: (data: CreateChannelPayload, params: RequestParams = {}) =>
      this.request<string | null, any>({
        path: `/api/v1/ChannelManagement/CreateChannel`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Atualiza um canal.
     *
     * @tags ChannelManagement
     * @name UpdateChannel
     * @request POST:/api/v1/ChannelManagement/UpdateChannel
     * @secure
     * @response `200` `string | null` OK
     */
    updateChannel: (data: UpdateChannelPayload, params: RequestParams = {}) =>
      this.request<string | null, any>({
        path: `/api/v1/ChannelManagement/UpdateChannel`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Exclui um canal.
     *
     * @tags ChannelManagement
     * @name DeleteChannel
     * @request POST:/api/v1/ChannelManagement/DeleteChannel
     * @secure
     * @response `200` `boolean` OK
     */
    deleteChannel: (data: DeleteChannelPayload, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/api/v1/ChannelManagement/DeleteChannel`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Junta um canal a outro
     *
     * @tags ChannelManagement
     * @name JoinChannel
     * @request POST:/api/v1/ChannelManagement/JoinChannel
     * @secure
     * @response `200` `boolean` OK
     */
    joinChannel: (data: JoinChannelPayload, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/api/v1/ChannelManagement/JoinChannel`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Convida um Usuário para participar do canal.
     *
     * @tags ChannelManagement
     * @name InviteUser
     * @request POST:/api/v1/ChannelManagement/InviteUser
     * @secure
     * @response `200` `boolean` OK
     */
    inviteUser: (data: InviteUserPayload, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/api/v1/ChannelManagement/InviteUser`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Formaliza o convite do Usuário para participar do canal.
     *
     * @tags ChannelManagement
     * @name InviteProcess
     * @request POST:/api/v1/ChannelManagement/InviteProcess
     * @secure
     * @response `200` `InviteProcessResponse` OK
     */
    inviteProcess: (data: InviteProcessPayload, params: RequestParams = {}) =>
      this.request<InviteProcessResponse, any>({
        path: `/api/v1/ChannelManagement/InviteProcess`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Adiciona membros a um canal.
     *
     * @tags ChannelManagement
     * @name AddMembers
     * @request POST:/api/v1/ChannelManagement/AddMembers
     * @secure
     * @response `200` `number` OK
     */
    addMembers: (data: AddMembersPayload, params: RequestParams = {}) =>
      this.request<number, any>({
        path: `/api/v1/ChannelManagement/AddMembers`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Remove membro do canal.
     *
     * @tags ChannelManagement
     * @name DeleteMember
     * @request POST:/api/v1/ChannelManagement/DeleteMember
     * @secure
     * @response `200` `boolean` OK
     */
    deleteMember: (data: DeleteMemberPayload, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/api/v1/ChannelManagement/DeleteMember`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Altera o papel de um membro do canal.
     *
     * @tags ChannelManagement
     * @name ChangeMemberRole
     * @request POST:/api/v1/ChannelManagement/ChangeMemberRole
     * @secure
     * @response `200` `boolean` OK
     */
    changeMemberRole: (
      data: ChangeMemberRolePayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/ChannelManagement/ChangeMemberRole`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Solicita acesso administrativo a um Canal Confidencial.
     *
     * @tags ChannelManagement
     * @name RequestAccess
     * @request POST:/api/v1/ChannelManagement/RequestAccess
     * @secure
     * @response `200` `boolean` OK
     */
    requestAccess: (data: RequestAccessPayload, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/api/v1/ChannelManagement/RequestAccess`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  classroomManagement = {
    /**
     * Obtém uma turma para edição das informações básicas.
     *
     * @tags ClassroomManagement
     * @name GetClassroom
     * @request POST:/api/v1/ClassroomManagement/GetClassroom
     * @secure
     * @response `200` `ManagedClassroomResponse` OK
     */
    getClassroom: (data: GetClassroomPayload, params: RequestParams = {}) =>
      this.request<ManagedClassroomResponse, any>({
        path: `/api/v1/ClassroomManagement/GetClassroom`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém dados para criação de uma turma expressa.
     *
     * @tags ClassroomManagement
     * @name GetExpressClassroomInfo
     * @request POST:/api/v1/ClassroomManagement/GetExpressClassroomInfo
     * @secure
     * @response `200` `ManagedExpressClassroomResponse` OK
     */
    getExpressClassroomInfo: (
      data: GetExpressClassroomInfoPayload,
      params: RequestParams = {},
    ) =>
      this.request<ManagedExpressClassroomResponse, any>({
        path: `/api/v1/ClassroomManagement/GetExpressClassroomInfo`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém os componentes do treinamento na turma.
     *
     * @tags ClassroomManagement
     * @name GetClassroomComponents
     * @request POST:/api/v1/ClassroomManagement/GetClassroomComponents
     * @secure
     * @response `200` `(TrainingComponentDto)[]` OK
     */
    getClassroomComponents: (
      data: GetClassroomComponentsPayload,
      params: RequestParams = {},
    ) =>
      this.request<TrainingComponentDto[], any>({
        path: `/api/v1/ClassroomManagement/GetClassroomComponents`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém dados para edição de um Evento na TURMA.
     *
     * @tags ClassroomManagement
     * @name GetClassroomMeeting
     * @request POST:/api/v1/ClassroomManagement/GetClassroomMeeting
     * @secure
     * @response `200` `ManagedMeetingDto` OK (May return null)
     * @response `204` `any` No Content
     */
    getClassroomMeeting: (
      data: GetClassroomMeetingPayload,
      params: RequestParams = {},
    ) =>
      this.request<ManagedMeetingDto, any>({
        path: `/api/v1/ClassroomManagement/GetClassroomMeeting`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém dados para edição de uma Atividade na TURMA.
     *
     * @tags ClassroomManagement
     * @name GetClassroomActivity
     * @request POST:/api/v1/ClassroomManagement/GetClassroomActivity
     * @secure
     * @response `200` `GetTrainingActivityPublicationDto` OK
     */
    getClassroomActivity: (
      data: GetClassroomActivityPayload,
      params: RequestParams = {},
    ) =>
      this.request<GetTrainingActivityPublicationDto, any>({
        path: `/api/v1/ClassroomManagement/GetClassroomActivity`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém público-alvo da TURMA.
     *
     * @tags ClassroomManagement
     * @name GetClassroomAudience
     * @request POST:/api/v1/ClassroomManagement/GetClassroomAudience
     * @secure
     * @response `200` `AudienceDto` OK
     */
    getClassroomAudience: (
      data: GetClassroomAudiencePayload,
      params: RequestParams = {},
    ) =>
      this.request<AudienceDto, any>({
        path: `/api/v1/ClassroomManagement/GetClassroomAudience`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém lista de usuários que compõe o público-alvo da TURMA.
     *
     * @tags ClassroomManagement
     * @name GetClassroomAudienceUsers
     * @request POST:/api/v1/ClassroomManagement/GetClassroomAudienceUsers
     * @secure
     * @response `200` `UserItemDtoPaginatedList` OK
     */
    getClassroomAudienceUsers: (
      data: GetClassroomAudienceUsersPayload,
      params: RequestParams = {},
    ) =>
      this.request<UserItemDtoPaginatedList, any>({
        path: `/api/v1/ClassroomManagement/GetClassroomAudienceUsers`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém as regras da turma de treinamento do tipo Curso.
     *
     * @tags ClassroomManagement
     * @name GetCourseClassroomRules
     * @request POST:/api/v1/ClassroomManagement/GetCourseClassroomRules
     * @secure
     * @response `200` `CourseRulesDto` OK
     */
    getCourseClassroomRules: (
      data: GetCourseClassroomRulesPayload,
      params: RequestParams = {},
    ) =>
      this.request<CourseRulesDto, any>({
        path: `/api/v1/ClassroomManagement/GetCourseClassroomRules`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém as regras da turma de treinamento do tipo Curso Externo.
     *
     * @tags ClassroomManagement
     * @name GetECourseClassroomRules
     * @request POST:/api/v1/ClassroomManagement/GetECourseClassroomRules
     * @secure
     * @response `200` `ExternalCourseRulesDto` OK
     */
    getECourseClassroomRules: (
      data: GetECourseClassroomRulesPayload,
      params: RequestParams = {},
    ) =>
      this.request<ExternalCourseRulesDto, any>({
        path: `/api/v1/ClassroomManagement/GetECourseClassroomRules`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém as regras da turma de treinamento do tipo Tbrilha.
     *
     * @tags ClassroomManagement
     * @name GetLearnPathClassroomRules
     * @request POST:/api/v1/ClassroomManagement/GetLearnPathClassroomRules
     * @secure
     * @response `200` `LearnPathRulesDto` OK
     */
    getLearnPathClassroomRules: (
      data: GetLearnPathClassroomRulesPayload,
      params: RequestParams = {},
    ) =>
      this.request<LearnPathRulesDto, any>({
        path: `/api/v1/ClassroomManagement/GetLearnPathClassroomRules`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtem informações básicas da turma.
     *
     * @tags ClassroomManagement
     * @name GetClassroomInfo
     * @request POST:/api/v1/ClassroomManagement/GetClassroomInfo
     * @secure
     * @response `200` `ManagedInfoResponse` OK
     */
    getClassroomInfo: (
      data: GetClassroomInfoPayload,
      params: RequestParams = {},
    ) =>
      this.request<ManagedInfoResponse, any>({
        path: `/api/v1/ClassroomManagement/GetClassroomInfo`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Cria uma turma.
     *
     * @tags ClassroomManagement
     * @name CreateOrUpdateClassroom
     * @request POST:/api/v1/ClassroomManagement/CreateOrUpdateClassroom
     * @secure
     * @response `200` `string | null` OK (May return null)
     * @response `204` `any` No Content
     */
    createOrUpdateClassroom: (
      data: CreateOrUpdateClassroomPayload,
      params: RequestParams = {},
    ) =>
      this.request<string | null, any>({
        path: `/api/v1/ClassroomManagement/CreateOrUpdateClassroom`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Cria uma turma rápida.
     *
     * @tags ClassroomManagement
     * @name CreateExpressClassroom
     * @request POST:/api/v1/ClassroomManagement/CreateExpressClassroom
     * @secure
     * @response `200` `ManagedEnrollmentClassroomListResponse` OK (May return null)
     * @response `204` `any` No Content
     */
    createExpressClassroom: (
      data: CreateExpressClassroomPayload,
      params: RequestParams = {},
    ) =>
      this.request<ManagedEnrollmentClassroomListResponse, any>({
        path: `/api/v1/ClassroomManagement/CreateExpressClassroom`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Remove uma turma.
     *
     * @tags ClassroomManagement
     * @name DeleteClassroom
     * @request POST:/api/v1/ClassroomManagement/DeleteClassroom
     * @secure
     * @response `200` `boolean` OK
     */
    deleteClassroom: (
      data: DeleteClassroomPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/ClassroomManagement/DeleteClassroom`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Atualiza informações de um evento na TURMA.
     *
     * @tags ClassroomManagement
     * @name UpdateMeeting
     * @request POST:/api/v1/ClassroomManagement/UpdateMeeting
     * @secure
     * @response `200` `boolean` OK
     */
    updateMeeting: (data: UpdateMeetingPayload, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/api/v1/ClassroomManagement/UpdateMeeting`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Atualiza informações de uma ativiade na TURMA.
     *
     * @tags ClassroomManagement
     * @name UpdateActivity
     * @request POST:/api/v1/ClassroomManagement/UpdateActivity
     * @secure
     * @response `200` `boolean` OK
     */
    updateActivity: (data: UpdateActivityPayload, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/api/v1/ClassroomManagement/UpdateActivity`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Cancela um evento na TURMA.
     *
     * @tags ClassroomManagement
     * @name CancelMeeting
     * @request POST:/api/v1/ClassroomManagement/CancelMeeting
     * @secure
     * @response `200` `boolean` OK
     */
    cancelMeeting: (data: CancelMeetingPayload, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/api/v1/ClassroomManagement/CancelMeeting`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém dados para lista ou qr code de presença de um evento da turma.
     *
     * @tags ClassroomManagement
     * @name GetMeetingAttendanceData
     * @request POST:/api/v1/ClassroomManagement/GetMeetingAttendanceData
     * @secure
     * @response `200` `ClassroomMeetingAttendanceResponse` OK
     */
    getMeetingAttendanceData: (
      data: GetMeetingAttendanceDataPayload,
      params: RequestParams = {},
    ) =>
      this.request<ClassroomMeetingAttendanceResponse, any>({
        path: `/api/v1/ClassroomManagement/GetMeetingAttendanceData`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Marca a turma para reprocessar nova pontuação.
     *
     * @tags ClassroomManagement
     * @name ProcessAwardRuleClassroom
     * @request POST:/api/v1/ClassroomManagement/ProcessAwardRuleClassroom
     * @secure
     * @response `200` `boolean` OK
     */
    processAwardRuleClassroom: (
      data: ProcessAwardRuleClassroomPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/ClassroomManagement/ProcessAwardRuleClassroom`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Marca a turma para reprocessar novo certificado e prazos.
     *
     * @tags ClassroomManagement
     * @name ProcessCertificateRuleClassroom
     * @request POST:/api/v1/ClassroomManagement/ProcessCertificateRuleClassroom
     * @secure
     * @response `200` `boolean` OK
     */
    processCertificateRuleClassroom: (
      data: ProcessCertificateRuleClassroomPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/ClassroomManagement/ProcessCertificateRuleClassroom`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Salva os Instrutores da Turma.
     *
     * @tags ClassroomManagement
     * @name SaveInstructors
     * @request POST:/api/v1/ClassroomManagement/SaveInstructors
     * @secure
     * @response `200` `boolean` OK
     */
    saveInstructors: (
      data: SaveInstructorsPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/ClassroomManagement/SaveInstructors`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Salva as regras de Inscrição da Turma.
     *
     * @tags ClassroomManagement
     * @name SaveClassroomRulesRegistration
     * @request POST:/api/v1/ClassroomManagement/SaveClassroomRulesRegistration
     * @secure
     * @response `200` `TrainingRulesRegistrationDto` OK (May return null)
     * @response `204` `any` No Content
     */
    saveClassroomRulesRegistration: (
      data: SaveClassroomRulesRegistrationPayload,
      params: RequestParams = {},
    ) =>
      this.request<TrainingRulesRegistrationDto, any>({
        path: `/api/v1/ClassroomManagement/SaveClassroomRulesRegistration`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Salva regras de Avaliações de reação e eficácia da Turma.
     *
     * @tags ClassroomManagement
     * @name SaveClassroomRulesAssessment
     * @request POST:/api/v1/ClassroomManagement/SaveClassroomRulesAssessment
     * @secure
     * @response `200` `TrainingRulesAssessmentDto` OK (May return null)
     * @response `204` `any` No Content
     */
    saveClassroomRulesAssessment: (
      data: SaveClassroomRulesAssessmentPayload,
      params: RequestParams = {},
    ) =>
      this.request<TrainingRulesAssessmentDto, any>({
        path: `/api/v1/ClassroomManagement/SaveClassroomRulesAssessment`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Salva as regras de Execução da Turma.
     *
     * @tags ClassroomManagement
     * @name SaveClassroomRulesExecution
     * @request POST:/api/v1/ClassroomManagement/SaveClassroomRulesExecution
     * @secure
     * @response `200` `TrainingRulesExecutionDto` OK (May return null)
     * @response `204` `any` No Content
     */
    saveClassroomRulesExecution: (
      data: SaveClassroomRulesExecutionPayload,
      params: RequestParams = {},
    ) =>
      this.request<TrainingRulesExecutionDto, any>({
        path: `/api/v1/ClassroomManagement/SaveClassroomRulesExecution`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Salva as regras de Ações do Instrutor da Turma.
     *
     * @tags ClassroomManagement
     * @name SaveClassroomRulesInstructorAction
     * @request POST:/api/v1/ClassroomManagement/SaveClassroomRulesInstructorAction
     * @secure
     * @response `200` `TrainingRulesInstructorActionDto` OK (May return null)
     * @response `204` `any` No Content
     */
    saveClassroomRulesInstructorAction: (
      data: SaveClassroomRulesInstructorActionPayload,
      params: RequestParams = {},
    ) =>
      this.request<TrainingRulesInstructorActionDto, any>({
        path: `/api/v1/ClassroomManagement/SaveClassroomRulesInstructorAction`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Salva as regras de Aprovação e Finalização do curso.
     *
     * @tags ClassroomManagement
     * @name SaveClassroomRulesApproval
     * @request POST:/api/v1/ClassroomManagement/SaveClassroomRulesApproval
     * @secure
     * @response `200` `TrainingRulesApprovalRulesDto` OK (May return null)
     * @response `204` `any` No Content
     */
    saveClassroomRulesApproval: (
      data: SaveClassroomRulesApprovalPayload,
      params: RequestParams = {},
    ) =>
      this.request<TrainingRulesApprovalRulesDto, any>({
        path: `/api/v1/ClassroomManagement/SaveClassroomRulesApproval`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Salva as regras de Pré-Requisitos da Turma.
     *
     * @tags ClassroomManagement
     * @name SaveClassroomPreReqs
     * @request POST:/api/v1/ClassroomManagement/SaveClassroomPreReqs
     * @secure
     * @response `200` `TrainingRulesPreRequisitesDto` OK (May return null)
     * @response `204` `any` No Content
     */
    saveClassroomPreReqs: (
      data: SaveClassroomPreReqsPayload,
      params: RequestParams = {},
    ) =>
      this.request<TrainingRulesPreRequisitesDto, any>({
        path: `/api/v1/ClassroomManagement/SaveClassroomPreReqs`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Salva as regras de Premiações da Turma.
     *
     * @tags ClassroomManagement
     * @name SaveClassroomRulesAward
     * @request POST:/api/v1/ClassroomManagement/SaveClassroomRulesAward
     * @secure
     * @response `200` `TrainingRulesAwardDto` OK (May return null)
     * @response `204` `any` No Content
     */
    saveClassroomRulesAward: (
      data: SaveClassroomRulesAwardPayload,
      params: RequestParams = {},
    ) =>
      this.request<TrainingRulesAwardDto, any>({
        path: `/api/v1/ClassroomManagement/SaveClassroomRulesAward`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Salva as regras de Vagas e Reservas da Turma.
     *
     * @tags ClassroomManagement
     * @name SaveClassroomRulesSeats
     * @request POST:/api/v1/ClassroomManagement/SaveClassroomRulesSeats
     * @secure
     * @response `200` `TrainingRulesSeatsDto` OK (May return null)
     * @response `204` `any` No Content
     */
    saveClassroomRulesSeats: (
      data: SaveClassroomRulesSeatsPayload,
      params: RequestParams = {},
    ) =>
      this.request<TrainingRulesSeatsDto, any>({
        path: `/api/v1/ClassroomManagement/SaveClassroomRulesSeats`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Salva as regras de Certificado e Validade da Turma.
     *
     * @tags ClassroomManagement
     * @name SaveClassroomRulesCertificate
     * @request POST:/api/v1/ClassroomManagement/SaveClassroomRulesCertificate
     * @secure
     * @response `200` `TrainingRulesCertificateDto` OK (May return null)
     * @response `204` `any` No Content
     */
    saveClassroomRulesCertificate: (
      data: SaveClassroomRulesCertificatePayload,
      params: RequestParams = {},
    ) =>
      this.request<TrainingRulesCertificateDto, any>({
        path: `/api/v1/ClassroomManagement/SaveClassroomRulesCertificate`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Salva as regras de Interações da Turma.
     *
     * @tags ClassroomManagement
     * @name SaveClassroomRulesInteraction
     * @request POST:/api/v1/ClassroomManagement/SaveClassroomRulesInteraction
     * @secure
     * @response `200` `TrainingRulesInteractionDto` OK (May return null)
     * @response `204` `any` No Content
     */
    saveClassroomRulesInteraction: (
      data: SaveClassroomRulesInteractionPayload,
      params: RequestParams = {},
    ) =>
      this.request<TrainingRulesInteractionDto, any>({
        path: `/api/v1/ClassroomManagement/SaveClassroomRulesInteraction`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Salva as regras de Termo de Aceitação da turma.
     *
     * @tags ClassroomManagement
     * @name SaveRulesAgreement
     * @request POST:/api/v1/ClassroomManagement/SaveRulesAgreement
     * @secure
     * @response `200` `TrainingRulesAgreementDto` OK (May return null)
     * @response `204` `any` No Content
     */
    saveRulesAgreement: (
      data: SaveRulesAgreementPayload,
      params: RequestParams = {},
    ) =>
      this.request<TrainingRulesAgreementDto, any>({
        path: `/api/v1/ClassroomManagement/SaveRulesAgreement`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Salva as regras de Preenchimento do Formulário de Conclusão.
     *
     * @tags ClassroomManagement
     * @name SaveRulesConclusionForm
     * @request POST:/api/v1/ClassroomManagement/SaveRulesConclusionForm
     * @secure
     * @response `200` `TrainingRulesConclusionFormDto` OK (May return null)
     * @response `204` `any` No Content
     */
    saveRulesConclusionForm: (
      data: SaveRulesConclusionFormPayload,
      params: RequestParams = {},
    ) =>
      this.request<TrainingRulesConclusionFormDto, any>({
        path: `/api/v1/ClassroomManagement/SaveRulesConclusionForm`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  customFieldManagement = {
    /**
     * Obtém a lista de campos customizados
     *
     * @tags CustomFieldManagement
     * @name GetManagedCustomFieldList
     * @request GET:/api/v1/CustomFieldManagement/GetManagedCustomFieldList
     * @secure
     * @response `200` `ManagedCustomFieldListQueryResponsePaginatedList` OK
     */
    getManagedCustomFieldList: (
      query?: {
        SearchText?: string;
        ViewStatus?: ManagedCustomFieldListStatusView;
        Usage?: CustomFieldUsages;
        SubUsage?: string;
        /** @format int32 */
        PageNumber?: number;
        /** @format int32 */
        PageSize?: number;
        /** @format int32 */
        Offset?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<ManagedCustomFieldListQueryResponsePaginatedList, any>({
        path: `/api/v1/CustomFieldManagement/GetManagedCustomFieldList`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Obtém as informações principais do campo customizado para edição.
     *
     * @tags CustomFieldManagement
     * @name GetManagedCustomField
     * @request GET:/api/v1/CustomFieldManagement/GetManagedCustomField
     * @secure
     * @response `200` `ManagedCustomFieldQueryResponse` OK (May return null)
     * @response `204` `any` No Content
     */
    getManagedCustomField: (
      query?: {
        FieldId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ManagedCustomFieldQueryResponse, any>({
        path: `/api/v1/CustomFieldManagement/GetManagedCustomField`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Cria um campo custom.
     *
     * @tags CustomFieldManagement
     * @name CreateCustomField
     * @request POST:/api/v1/CustomFieldManagement/CreateCustomField
     * @secure
     * @response `200` `string` OK
     */
    createCustomField: (
      data: CreateCustomFieldPayload,
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/api/v1/CustomFieldManagement/CreateCustomField`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Altera um campo customizado.
     *
     * @tags CustomFieldManagement
     * @name UpdateCustomField
     * @request PUT:/api/v1/CustomFieldManagement/UpdateCustomField
     * @secure
     * @response `200` `string` OK
     */
    updateCustomField: (
      data: UpdateCustomFieldPayload,
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/api/v1/CustomFieldManagement/UpdateCustomField`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Exclui um campo customizado.
     *
     * @tags CustomFieldManagement
     * @name DeleteCustomField
     * @request DELETE:/api/v1/CustomFieldManagement/DeleteCustomField
     * @secure
     * @response `200` `boolean` OK
     */
    deleteCustomField: (
      query?: {
        FieldId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/CustomFieldManagement/DeleteCustomField`,
        method: "DELETE",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  dashboardAssessment = {
    /**
     * Obtém o Resumo da Análise de Resultados da Avaliação.
     *
     * @tags DashboardAssessment
     * @name DashAnalysisResultsResume
     * @request POST:/api/v1/DashboardAssessment/DashAnalysisResultsResume
     * @secure
     * @response `200` `AssAnalysisResultsResumeResponse` OK
     */
    dashAnalysisResultsResume: (
      data: DashAnalysisResultsResumePayload,
      params: RequestParams = {},
    ) =>
      this.request<AssAnalysisResultsResumeResponse, any>({
        path: `/api/v1/DashboardAssessment/DashAnalysisResultsResume`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém a Lista de Questões dos Resultados da Avaliação.
     *
     * @tags DashboardAssessment
     * @name DashAnalysisResultsQuestionsList
     * @request POST:/api/v1/DashboardAssessment/DashAnalysisResultsQuestionsList
     * @secure
     * @response `200` `AssAnalysisQuestionsResponsePaginatedList` OK
     */
    dashAnalysisResultsQuestionsList: (
      data: DashAnalysisResultsQuestionsListPayload,
      params: RequestParams = {},
    ) =>
      this.request<AssAnalysisQuestionsResponsePaginatedList, any>({
        path: `/api/v1/DashboardAssessment/DashAnalysisResultsQuestionsList`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém a Lista de Pessoas dos Resultados da Avaliação.
     *
     * @tags DashboardAssessment
     * @name DashAnalysisResultsPeopleList
     * @request POST:/api/v1/DashboardAssessment/DashAnalysisResultsPeopleList
     * @secure
     * @response `200` `AssAnalysisPeopleResponsePaginatedList` OK
     */
    dashAnalysisResultsPeopleList: (
      data: DashAnalysisResultsPeopleListPayload,
      params: RequestParams = {},
    ) =>
      this.request<AssAnalysisPeopleResponsePaginatedList, any>({
        path: `/api/v1/DashboardAssessment/DashAnalysisResultsPeopleList`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém o Resumo da Análise de Resultados do Grupo de Questões.
     *
     * @tags DashboardAssessment
     * @name DashAnalysisGroupQuestionResume
     * @request POST:/api/v1/DashboardAssessment/DashAnalysisGroupQuestionResume
     * @secure
     * @response `200` `AssAnalysisGroupQuestionResumeResponse` OK
     */
    dashAnalysisGroupQuestionResume: (
      data: DashAnalysisGroupQuestionResumePayload,
      params: RequestParams = {},
    ) =>
      this.request<AssAnalysisGroupQuestionResumeResponse, any>({
        path: `/api/v1/DashboardAssessment/DashAnalysisGroupQuestionResume`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém a Lista de Questões do Grupo de Questões.
     *
     * @tags DashboardAssessment
     * @name DashAnalysisGroupQuestionList
     * @request POST:/api/v1/DashboardAssessment/DashAnalysisGroupQuestionList
     * @secure
     * @response `200` `AssAnalysisQuestionsResponsePaginatedList` OK
     */
    dashAnalysisGroupQuestionList: (
      data: DashAnalysisGroupQuestionListPayload,
      params: RequestParams = {},
    ) =>
      this.request<AssAnalysisQuestionsResponsePaginatedList, any>({
        path: `/api/v1/DashboardAssessment/DashAnalysisGroupQuestionList`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém a Lista de Pessoas do Grupo de Questões.
     *
     * @tags DashboardAssessment
     * @name DashAnalysisGroupPeopleList
     * @request POST:/api/v1/DashboardAssessment/DashAnalysisGroupPeopleList
     * @secure
     * @response `200` `AssAnalysisPeopleResponsePaginatedList` OK
     */
    dashAnalysisGroupPeopleList: (
      data: DashAnalysisGroupPeopleListPayload,
      params: RequestParams = {},
    ) =>
      this.request<AssAnalysisPeopleResponsePaginatedList, any>({
        path: `/api/v1/DashboardAssessment/DashAnalysisGroupPeopleList`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Exporta Lista de Questões dos Resultados da Avaliação.
     *
     * @tags DashboardAssessment
     * @name ExportDashAnalysisResultsQuestionsList
     * @request POST:/api/v1/DashboardAssessment/ExportDashAnalysisResultsQuestionsList
     * @secure
     * @response `200` `any` OK
     */
    exportDashAnalysisResultsQuestionsList: (
      data: ExportDashAnalysisResultsQuestionsListPayload,
      params: RequestParams = {},
    ) =>
      this.request<any, any>({
        path: `/api/v1/DashboardAssessment/ExportDashAnalysisResultsQuestionsList`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * Exporta Lista de Pessoas dos Resultados da Avaliação.
     *
     * @tags DashboardAssessment
     * @name ExportDashAnalysisResultsPeopleList
     * @request POST:/api/v1/DashboardAssessment/ExportDashAnalysisResultsPeopleList
     * @secure
     * @response `200` `any` OK
     */
    exportDashAnalysisResultsPeopleList: (
      data: ExportDashAnalysisResultsPeopleListPayload,
      params: RequestParams = {},
    ) =>
      this.request<any, any>({
        path: `/api/v1/DashboardAssessment/ExportDashAnalysisResultsPeopleList`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * Exporta Lista de Questões do Grupo de Questões.
     *
     * @tags DashboardAssessment
     * @name ExportDashAnalysisGroupQuestionList
     * @request POST:/api/v1/DashboardAssessment/ExportDashAnalysisGroupQuestionList
     * @secure
     * @response `200` `any` OK
     */
    exportDashAnalysisGroupQuestionList: (
      data: ExportDashAnalysisGroupQuestionListPayload,
      params: RequestParams = {},
    ) =>
      this.request<any, any>({
        path: `/api/v1/DashboardAssessment/ExportDashAnalysisGroupQuestionList`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * Exporta Lista de Pessoas do Grupo de Questões.
     *
     * @tags DashboardAssessment
     * @name ExportDashAnalysisGroupPeopleList
     * @request POST:/api/v1/DashboardAssessment/ExportDashAnalysisGroupPeopleList
     * @secure
     * @response `200` `any` OK
     */
    exportDashAnalysisGroupPeopleList: (
      data: ExportDashAnalysisGroupPeopleListPayload,
      params: RequestParams = {},
    ) =>
      this.request<any, any>({
        path: `/api/v1/DashboardAssessment/ExportDashAnalysisGroupPeopleList`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
  dashboardAward = {
    /**
     * Obtém dados resumidos de total para o painel de premiações.
     *
     * @tags DashboardAward
     * @name DashAwardResume
     * @request POST:/api/v1/DashboardAward/DashAwardResume
     * @secure
     * @response `200` `DashAwardResumeResponse` OK
     */
    dashAwardResume: (
      data: DashAwardResumePayload,
      params: RequestParams = {},
    ) =>
      this.request<DashAwardResumeResponse, any>({
        path: `/api/v1/DashboardAward/DashAwardResume`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém a quantidade total de pontuação dos últimos 12 meses.
     *
     * @tags DashboardAward
     * @name DashAwardPoints
     * @request POST:/api/v1/DashboardAward/DashAwardPoints
     * @secure
     * @response `200` `DashAwardChartDto` OK
     */
    dashAwardPoints: (
      data: DashAwardPointsPayload,
      params: RequestParams = {},
    ) =>
      this.request<DashAwardChartDto, any>({
        path: `/api/v1/DashboardAward/DashAwardPoints`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém a quantidade de medalhas dos últimos 12 meses.
     *
     * @tags DashboardAward
     * @name DashAwardBadges
     * @request POST:/api/v1/DashboardAward/DashAwardBadges
     * @secure
     * @response `200` `DashAwardChartDto` OK
     */
    dashAwardBadges: (
      data: DashAwardBadgesPayload,
      params: RequestParams = {},
    ) =>
      this.request<DashAwardChartDto, any>({
        path: `/api/v1/DashboardAward/DashAwardBadges`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém lista de usuários em ordem de pontuação de premiação.
     *
     * @tags DashboardAward
     * @name DashAwardUsersRanking
     * @request POST:/api/v1/DashboardAward/DashAwardUsersRanking
     * @secure
     * @response `200` `DashListItemDtoPaginatedList` OK
     */
    dashAwardUsersRanking: (
      data: DashAwardUsersRankingPayload,
      params: RequestParams = {},
    ) =>
      this.request<DashListItemDtoPaginatedList, any>({
        path: `/api/v1/DashboardAward/DashAwardUsersRanking`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags DashboardAward
     * @name ExportDashAwardUsersRanking
     * @request POST:/api/v1/DashboardAward/ExportDashAwardUsersRanking
     * @secure
     * @response `200` `any` OK
     */
    exportDashAwardUsersRanking: (
      data: ExportDashAwardUsersRankingPayload,
      params: RequestParams = {},
    ) =>
      this.request<any, any>({
        path: `/api/v1/DashboardAward/ExportDashAwardUsersRanking`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * Obtém lista de motivos para premiação com total de pontos.
     *
     * @tags DashboardAward
     * @name DashAwardReasons
     * @request POST:/api/v1/DashboardAward/DashAwardReasons
     * @secure
     * @response `200` `DashAwardReasonsResponsePaginatedList` OK
     */
    dashAwardReasons: (
      data: DashAwardReasonsPayload,
      params: RequestParams = {},
    ) =>
      this.request<DashAwardReasonsResponsePaginatedList, any>({
        path: `/api/v1/DashboardAward/DashAwardReasons`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags DashboardAward
     * @name ExportDashAwardReasons
     * @request POST:/api/v1/DashboardAward/ExportDashAwardReasons
     * @secure
     * @response `200` `any` OK
     */
    exportDashAwardReasons: (
      data: ExportDashAwardReasonsPayload,
      params: RequestParams = {},
    ) =>
      this.request<any, any>({
        path: `/api/v1/DashboardAward/ExportDashAwardReasons`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * Obtém lista de usuários de maiores ganhadores de madalhas.
     *
     * @tags DashboardAward
     * @name DashAwardUsersBadges
     * @request POST:/api/v1/DashboardAward/DashAwardUsersBadges
     * @secure
     * @response `200` `DashListItemDtoPaginatedList` OK
     */
    dashAwardUsersBadges: (
      data: DashAwardUsersBadgesPayload,
      params: RequestParams = {},
    ) =>
      this.request<DashListItemDtoPaginatedList, any>({
        path: `/api/v1/DashboardAward/DashAwardUsersBadges`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags DashboardAward
     * @name ExportDashAwardUsersBadges
     * @request POST:/api/v1/DashboardAward/ExportDashAwardUsersBadges
     * @secure
     * @response `200` `any` OK
     */
    exportDashAwardUsersBadges: (
      data: ExportDashAwardUsersBadgesPayload,
      params: RequestParams = {},
    ) =>
      this.request<any, any>({
        path: `/api/v1/DashboardAward/ExportDashAwardUsersBadges`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * Obtém lista de maiores medalhas concedidas.
     *
     * @tags DashboardAward
     * @name DashAwardBadgesList
     * @request POST:/api/v1/DashboardAward/DashAwardBadgesList
     * @secure
     * @response `200` `DashListItemDtoPaginatedList` OK
     */
    dashAwardBadgesList: (
      data: DashAwardBadgesListPayload,
      params: RequestParams = {},
    ) =>
      this.request<DashListItemDtoPaginatedList, any>({
        path: `/api/v1/DashboardAward/DashAwardBadgesList`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags DashboardAward
     * @name ExportDashAwardBadgesList
     * @request POST:/api/v1/DashboardAward/ExportDashAwardBadgesList
     * @secure
     * @response `200` `any` OK
     */
    exportDashAwardBadgesList: (
      data: ExportDashAwardBadgesListPayload,
      params: RequestParams = {},
    ) =>
      this.request<any, any>({
        path: `/api/v1/DashboardAward/ExportDashAwardBadgesList`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * Obtém o extrato de pontos de premiação.
     *
     * @tags DashboardAward
     * @name DashAwardPointsStatement
     * @request POST:/api/v1/DashboardAward/DashAwardPointsStatement
     * @secure
     * @response `200` `DashAwardPointsStatementResponsePaginatedList` OK
     */
    dashAwardPointsStatement: (
      data: DashAwardPointsStatementPayload,
      params: RequestParams = {},
    ) =>
      this.request<DashAwardPointsStatementResponsePaginatedList, any>({
        path: `/api/v1/DashboardAward/DashAwardPointsStatement`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  dashboardBilling = {
    /**
     * Dashboard de Colaboração: Resumo.
     *
     * @tags DashboardBilling
     * @name GetResume
     * @request POST:/api/v1/DashboardBilling/GetResume
     * @secure
     * @response `200` `BillingResumeResponse` OK
     */
    getResume: (params: RequestParams = {}) =>
      this.request<BillingResumeResponse, any>({
        path: `/api/v1/DashboardBilling/GetResume`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Dashboard de Cobrança: Faturas.
     *
     * @tags DashboardBilling
     * @name GetInvoice
     * @request POST:/api/v1/DashboardBilling/GetInvoice
     * @secure
     * @response `200` `BillingHistoryDto` OK
     */
    getInvoice: (data: GetInvoicePayload, params: RequestParams = {}) =>
      this.request<BillingHistoryDto, any>({
        path: `/api/v1/DashboardBilling/GetInvoice`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Dashboard de Cobrança: Detalhes do Pacote de Franquia.
     *
     * @tags DashboardBilling
     * @name GetBillingQuota
     * @request POST:/api/v1/DashboardBilling/GetBillingQuota
     * @secure
     * @response `200` `BillingQuotaDto` OK (May return null)
     * @response `204` `any` No Content
     */
    getBillingQuota: (
      data: GetBillingQuotaPayload,
      params: RequestParams = {},
    ) =>
      this.request<BillingQuotaDto, any>({
        path: `/api/v1/DashboardBilling/GetBillingQuota`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Dashboard de Cobrança: Lista de Faturas.
     *
     * @tags DashboardBilling
     * @name GetInvoiceExtract
     * @request POST:/api/v1/DashboardBilling/GetInvoiceExtract
     * @secure
     * @response `200` `BillingExtractHistoryDtoPaginatedList` OK
     */
    getInvoiceExtract: (
      data: GetInvoiceExtractPayload,
      params: RequestParams = {},
    ) =>
      this.request<BillingExtractHistoryDtoPaginatedList, any>({
        path: `/api/v1/DashboardBilling/GetInvoiceExtract`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Dashboard de Cobrança: Lista de Usuários com pelo menos um acesso no mês/ano de referência.
     *
     * @tags DashboardBilling
     * @name GetUsers
     * @request POST:/api/v1/DashboardBilling/GetUsers
     * @secure
     * @response `200` `BillingPanelUserDtoPaginatedList` OK
     */
    getUsers: (data: GetUsersPayload, params: RequestParams = {}) =>
      this.request<BillingPanelUserDtoPaginatedList, any>({
        path: `/api/v1/DashboardBilling/GetUsers`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Dashboard de Cobrança: Lista de Usuários que utilizaram Requisições de IA no mês/ano de referência.
     *
     * @tags DashboardBilling
     * @name GetIaRequests
     * @request POST:/api/v1/DashboardBilling/GetIaRequests
     * @secure
     * @response `200` `BillingPanelIaUserDtoPaginatedList` OK
     */
    getIaRequests: (data: GetIaRequestsPayload, params: RequestParams = {}) =>
      this.request<BillingPanelIaUserDtoPaginatedList, any>({
        path: `/api/v1/DashboardBilling/GetIaRequests`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Dashboard de Cobrança: Lista de Arquivos acessados no mês/ano de referência.
     *
     * @tags DashboardBilling
     * @name GetStreamingFiles
     * @request POST:/api/v1/DashboardBilling/GetStreamingFiles
     * @secure
     * @response `200` `BillingPanelStreamingFileDtoPaginatedList` OK
     */
    getStreamingFiles: (
      data: GetStreamingFilesPayload,
      params: RequestParams = {},
    ) =>
      this.request<BillingPanelStreamingFileDtoPaginatedList, any>({
        path: `/api/v1/DashboardBilling/GetStreamingFiles`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Dashboard de Cobrança: Detalhes do vídeo acessado.
     *
     * @tags DashboardBilling
     * @name GetStreamingDetails
     * @request POST:/api/v1/DashboardBilling/GetStreamingDetails
     * @secure
     * @response `200` `BillingStreamingDetailsDto` OK
     */
    getStreamingDetails: (
      data: GetStreamingDetailsPayload,
      params: RequestParams = {},
    ) =>
      this.request<BillingStreamingDetailsDto, any>({
        path: `/api/v1/DashboardBilling/GetStreamingDetails`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Dashboard de Cobrança: Distribuição do Uso do Storage.
     *
     * @tags DashboardBilling
     * @name StorageDistribution
     * @request POST:/api/v1/DashboardBilling/StorageDistribution
     * @secure
     * @response `200` `BillingPanelStorageDto` OK
     */
    storageDistribution: (params: RequestParams = {}) =>
      this.request<BillingPanelStorageDto, any>({
        path: `/api/v1/DashboardBilling/StorageDistribution`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Dashboard de Cobrança: Exportação de Usuários.
     *
     * @tags DashboardBilling
     * @name ExportUsers
     * @request POST:/api/v1/DashboardBilling/ExportUsers
     * @secure
     * @response `200` `any` OK
     */
    exportUsers: (data: ExportUsersPayload, params: RequestParams = {}) =>
      this.request<any, any>({
        path: `/api/v1/DashboardBilling/ExportUsers`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * Dashboard de Cobrança: Exportação de dos Arquivos de Vídeo mais acessados.
     *
     * @tags DashboardBilling
     * @name ExportStreaming
     * @request POST:/api/v1/DashboardBilling/ExportStreaming
     * @secure
     * @response `200` `any` OK
     */
    exportStreaming: (
      data: ExportStreamingPayload,
      params: RequestParams = {},
    ) =>
      this.request<any, any>({
        path: `/api/v1/DashboardBilling/ExportStreaming`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * Dashboard de Cobrança: Exportação dos Usuários com mais requisições de IA.
     *
     * @tags DashboardBilling
     * @name ExportIa
     * @request POST:/api/v1/DashboardBilling/ExportIa
     * @secure
     * @response `200` `any` OK
     */
    exportIa: (data: ExportIaPayload, params: RequestParams = {}) =>
      this.request<any, any>({
        path: `/api/v1/DashboardBilling/ExportIa`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * Dashboard de Cobrança: Exportação das Faturas.
     *
     * @tags DashboardBilling
     * @name ExportInvoices
     * @request POST:/api/v1/DashboardBilling/ExportInvoices
     * @secure
     * @response `200` `any` OK
     */
    exportInvoices: (params: RequestParams = {}) =>
      this.request<any, any>({
        path: `/api/v1/DashboardBilling/ExportInvoices`,
        method: "POST",
        secure: true,
        ...params,
      }),
  };
  dashboardChallenge = {
    /**
     * Obtém indicadores do dashboard de desafios de conhecimento.
     *
     * @tags DashboardChallenge
     * @name ChallengeIndicators
     * @request POST:/api/v1/DashboardChallenge/ChallengeIndicators
     * @secure
     * @response `200` `DashChallengeIndicatorsResponse` OK
     */
    challengeIndicators: (
      data: ChallengeIndicatorsPayload,
      params: RequestParams = {},
    ) =>
      this.request<DashChallengeIndicatorsResponse, any>({
        path: `/api/v1/DashboardChallenge/ChallengeIndicators`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém insights do dashboard de desafios de conhecimento.
     *
     * @tags DashboardChallenge
     * @name ChallengeInsights
     * @request POST:/api/v1/DashboardChallenge/ChallengeInsights
     * @secure
     * @response `200` `DashChallengeInsightsResponse` OK
     */
    challengeInsights: (
      data: ChallengeInsightsPayload,
      params: RequestParams = {},
    ) =>
      this.request<DashChallengeInsightsResponse, any>({
        path: `/api/v1/DashboardChallenge/ChallengeInsights`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém lista de usuários com selo de conhecimento comprovado.
     *
     * @tags DashboardChallenge
     * @name ChallengeUsersTopicsSeals
     * @request POST:/api/v1/DashboardChallenge/ChallengeUsersTopicsSeals
     * @secure
     * @response `200` `DashChallengeUserTopicDtoPaginatedList` OK
     */
    challengeUsersTopicsSeals: (
      data: ChallengeUsersTopicsSealsPayload,
      params: RequestParams = {},
    ) =>
      this.request<DashChallengeUserTopicDtoPaginatedList, any>({
        path: `/api/v1/DashboardChallenge/ChallengeUsersTopicsSeals`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém lista de Questões onde existem mais de 10 respostas registradas e onde mais de 50% das respostas dadas foram incorretas.
     *
     * @tags DashboardChallenge
     * @name ChallengeQuestionIncorrect
     * @request POST:/api/v1/DashboardChallenge/ChallengeQuestionIncorrect
     * @secure
     * @response `200` `QuestionListDtoPaginatedList` OK
     */
    challengeQuestionIncorrect: (
      data: ChallengeQuestionIncorrectPayload,
      params: RequestParams = {},
    ) =>
      this.request<QuestionListDtoPaginatedList, any>({
        path: `/api/v1/DashboardChallenge/ChallengeQuestionIncorrect`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém dados de participação do dashboard de desafios de conhecimento.
     *
     * @tags DashboardChallenge
     * @name ChallengeParticipation
     * @request POST:/api/v1/DashboardChallenge/ChallengeParticipation
     * @secure
     * @response `200` `DashChallengeParticipationResponse` OK
     */
    challengeParticipation: (
      data: ChallengeParticipationPayload,
      params: RequestParams = {},
    ) =>
      this.request<DashChallengeParticipationResponse, any>({
        path: `/api/v1/DashboardChallenge/ChallengeParticipation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém a lista de usuários elégiveis a participar dos desafios de conhecimento.
     *
     * @tags DashboardChallenge
     * @name ChallengeUserEligibleParticipates
     * @request POST:/api/v1/DashboardChallenge/ChallengeUserEligibleParticipates
     * @secure
     * @response `200` `UserItemDtoPaginatedList` OK
     */
    challengeUserEligibleParticipates: (
      data: ChallengeUserEligibleParticipatesPayload,
      params: RequestParams = {},
    ) =>
      this.request<UserItemDtoPaginatedList, any>({
        path: `/api/v1/DashboardChallenge/ChallengeUserEligibleParticipates`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém a lista de usuários que responderam desafios no período.
     *
     * @tags DashboardChallenge
     * @name ChallengeUserAnswered
     * @request POST:/api/v1/DashboardChallenge/ChallengeUserAnswered
     * @secure
     * @response `200` `UserItemDtoPaginatedList` OK
     */
    challengeUserAnswered: (
      data: ChallengeUserAnsweredPayload,
      params: RequestParams = {},
    ) =>
      this.request<UserItemDtoPaginatedList, any>({
        path: `/api/v1/DashboardChallenge/ChallengeUserAnswered`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém lista de usuários para análise de desafio de conhecimento.
     *
     * @tags DashboardChallenge
     * @name ChallengeUsersAnalysis
     * @request POST:/api/v1/DashboardChallenge/ChallengeUsersAnalysis
     * @secure
     * @response `200` `DashListItemDtoPaginatedList` OK
     */
    challengeUsersAnalysis: (
      data: ChallengeUsersAnalysisPayload,
      params: RequestParams = {},
    ) =>
      this.request<DashListItemDtoPaginatedList, any>({
        path: `/api/v1/DashboardChallenge/ChallengeUsersAnalysis`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Painel de Desafio - Exporta excel de análises de usuários
     *
     * @tags DashboardChallenge
     * @name ExportChallengeUsersAnalysis
     * @request POST:/api/v1/DashboardChallenge/ExportChallengeUsersAnalysis
     * @secure
     * @response `200` `any` OK
     */
    exportChallengeUsersAnalysis: (
      data: ExportChallengeUsersAnalysisPayload,
      params: RequestParams = {},
    ) =>
      this.request<any, any>({
        path: `/api/v1/DashboardChallenge/ExportChallengeUsersAnalysis`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * Obtém lista de tópicos para análise de desafio de conhecimento.
     *
     * @tags DashboardChallenge
     * @name ChallengeTopicsAnalysis
     * @request POST:/api/v1/DashboardChallenge/ChallengeTopicsAnalysis
     * @secure
     * @response `200` `DashListItemDtoPaginatedList` OK
     */
    challengeTopicsAnalysis: (
      data: ChallengeTopicsAnalysisPayload,
      params: RequestParams = {},
    ) =>
      this.request<DashListItemDtoPaginatedList, any>({
        path: `/api/v1/DashboardChallenge/ChallengeTopicsAnalysis`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags DashboardChallenge
     * @name ExportChallengeTopicsAnalysis
     * @request POST:/api/v1/DashboardChallenge/ExportChallengeTopicsAnalysis
     * @secure
     * @response `200` `any` OK
     */
    exportChallengeTopicsAnalysis: (
      data: ExportChallengeTopicsAnalysisPayload,
      params: RequestParams = {},
    ) =>
      this.request<any, any>({
        path: `/api/v1/DashboardChallenge/ExportChallengeTopicsAnalysis`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
  dashboardKnowledge = {
    /**
     * Dashboard de Colaboração: Resumo.
     *
     * @tags DashboardKnowledge
     * @name GetResume
     * @request POST:/api/v1/DashboardKnowledge/GetResume
     * @secure
     * @response `200` `KnowledgePanelReview` OK
     */
    getResume: (data: GetResumeBody, params: RequestParams = {}) =>
      this.request<KnowledgePanelReview, any>({
        path: `/api/v1/DashboardKnowledge/GetResume`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Dashboard de Colaboração: Análises.
     *
     * @tags DashboardKnowledge
     * @name GetAnalysis
     * @request POST:/api/v1/DashboardKnowledge/GetAnalysis
     * @secure
     * @response `200` `DashListItemDtoPaginatedList` OK
     */
    getAnalysis: (data: GetAnalysisPayload, params: RequestParams = {}) =>
      this.request<DashListItemDtoPaginatedList, any>({
        path: `/api/v1/DashboardKnowledge/GetAnalysis`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Dashboard de Colaboração: Análises - Drill por Valor.
     *
     * @tags DashboardKnowledge
     * @name AnalysisDrillByValue
     * @request POST:/api/v1/DashboardKnowledge/AnalysisDrillByValue
     * @secure
     * @response `200` `DashListItemDtoPaginatedList` OK
     */
    analysisDrillByValue: (
      data: AnalysisDrillByValuePayload,
      params: RequestParams = {},
    ) =>
      this.request<DashListItemDtoPaginatedList, any>({
        path: `/api/v1/DashboardKnowledge/AnalysisDrillByValue`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Dashboard de Colaboração: Análises - Drill por Contador.
     *
     * @tags DashboardKnowledge
     * @name AnalysisDrillByDetail
     * @request POST:/api/v1/DashboardKnowledge/AnalysisDrillByDetail
     * @secure
     * @response `200` `DashListItemDtoPaginatedList` OK
     */
    analysisDrillByDetail: (
      data: AnalysisDrillByDetailPayload,
      params: RequestParams = {},
    ) =>
      this.request<DashListItemDtoPaginatedList, any>({
        path: `/api/v1/DashboardKnowledge/AnalysisDrillByDetail`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Dashboard de Colaboração: Exportação das Análises.
     *
     * @tags DashboardKnowledge
     * @name ExportAnalysis
     * @request POST:/api/v1/DashboardKnowledge/ExportAnalysis
     * @secure
     * @response `200` `any` OK
     */
    exportAnalysis: (data: ExportAnalysisPayload, params: RequestParams = {}) =>
      this.request<any, any>({
        path: `/api/v1/DashboardKnowledge/ExportAnalysis`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
  dashboardReport = {
    /**
     * Obtém uma lista de Relatórios.
     *
     * @tags DashboardReport
     * @name GetAvailableReports
     * @request POST:/api/v1/DashboardReport/GetAvailableReports
     * @secure
     * @response `200` `AvailableReportResponse` OK
     */
    getAvailableReports: (
      data: GetAvailableReportsPayload,
      params: RequestParams = {},
    ) =>
      this.request<AvailableReportResponse, any>({
        path: `/api/v1/DashboardReport/GetAvailableReports`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém os parâmetros do Relatório.
     *
     * @tags DashboardReport
     * @name GetReportParameters
     * @request POST:/api/v1/DashboardReport/GetReportParameters
     * @secure
     * @response `200` `ReportDefinitionDto` OK
     */
    getReportParameters: (
      data: GetReportParametersPayload,
      params: RequestParams = {},
    ) =>
      this.request<ReportDefinitionDto, any>({
        path: `/api/v1/DashboardReport/GetReportParameters`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Executa um Relatório.
     *
     * @tags DashboardReport
     * @name ExecuteReport
     * @request POST:/api/v1/DashboardReport/ExecuteReport
     * @secure
     * @response `200` `any` OK
     */
    executeReport: (data: ExecuteReportPayload, params: RequestParams = {}) =>
      this.request<any, any>({
        path: `/api/v1/DashboardReport/ExecuteReport`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
  dashboardSuggestions = {
    /**
     * Usuários
     *
     * @tags DashboardSuggestions
     * @name Users
     * @request POST:/api/v1/DashboardSuggestions/Users
     * @secure
     * @response `200` `AutoCompleteDataModelDtoPaginatedList` OK
     */
    users: (data: UsersPayload, params: RequestParams = {}) =>
      this.request<AutoCompleteDataModelDtoPaginatedList, any>({
        path: `/api/v1/DashboardSuggestions/Users`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Treinamentos
     *
     * @tags DashboardSuggestions
     * @name Trainings
     * @request POST:/api/v1/DashboardSuggestions/Trainings
     * @secure
     * @response `200` `TrainingAutoCompleteDataModelDtoPaginatedList` OK
     */
    trainings: (data: TrainingsPayload, params: RequestParams = {}) =>
      this.request<TrainingAutoCompleteDataModelDtoPaginatedList, any>({
        path: `/api/v1/DashboardSuggestions/Trainings`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  dashboardTrainingIndex = {
    /**
     * No description
     *
     * @tags DashboardTrainingIndex
     * @name GetSettings
     * @request POST:/api/v1/DashboardTrainingIndex/GetSettings
     * @secure
     * @response `200` `TrainingIndexSettingsResponse` OK
     */
    getSettings: (params: RequestParams = {}) =>
      this.request<TrainingIndexSettingsResponse, any>({
        path: `/api/v1/DashboardTrainingIndex/GetSettings`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Obtém histórico do índice de treinamento geral.
     *
     * @tags DashboardTrainingIndex
     * @name GetGeneralEvolution
     * @request POST:/api/v1/DashboardTrainingIndex/GetGeneralEvolution
     * @secure
     * @response `200` `TrainingIndexEvolutionDto` OK
     */
    getGeneralEvolution: (params: RequestParams = {}) =>
      this.request<TrainingIndexEvolutionDto, any>({
        path: `/api/v1/DashboardTrainingIndex/GetGeneralEvolution`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Obtém histórico do índice de treinamento do usuário.
     *
     * @tags DashboardTrainingIndex
     * @name GetUserEvolution
     * @request POST:/api/v1/DashboardTrainingIndex/GetUserEvolution
     * @secure
     * @response `200` `TrainingIndexUserEvolutionResponse` OK
     */
    getUserEvolution: (
      data: GetUserEvolutionPayload,
      params: RequestParams = {},
    ) =>
      this.request<TrainingIndexUserEvolutionResponse, any>({
        path: `/api/v1/DashboardTrainingIndex/GetUserEvolution`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém histórico do índice de treinamento da equipe do usuário
     *
     * @tags DashboardTrainingIndex
     * @name GetTeamEvolution
     * @request POST:/api/v1/DashboardTrainingIndex/GetTeamEvolution
     * @secure
     * @response `200` `TrainingIndexTeamEvolutionResponse` OK
     */
    getTeamEvolution: (
      data: GetTeamEvolutionPayload,
      params: RequestParams = {},
    ) =>
      this.request<TrainingIndexTeamEvolutionResponse, any>({
        path: `/api/v1/DashboardTrainingIndex/GetTeamEvolution`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém histórico do índice de treimaneto do tópico.
     *
     * @tags DashboardTrainingIndex
     * @name GetTopicEvolution
     * @request POST:/api/v1/DashboardTrainingIndex/GetTopicEvolution
     * @secure
     * @response `200` `TrainingIndexTopicEvolutionResponse` OK
     */
    getTopicEvolution: (
      data: GetTopicEvolutionPayload,
      params: RequestParams = {},
    ) =>
      this.request<TrainingIndexTopicEvolutionResponse, any>({
        path: `/api/v1/DashboardTrainingIndex/GetTopicEvolution`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém histórico do índice de treimaneto da unidade administrativa.
     *
     * @tags DashboardTrainingIndex
     * @name GetUnitEvolution
     * @request POST:/api/v1/DashboardTrainingIndex/GetUnitEvolution
     * @secure
     * @response `200` `TrainingIndexUnitEvolutionResponse` OK
     */
    getUnitEvolution: (
      data: GetUnitEvolutionPayload,
      params: RequestParams = {},
    ) =>
      this.request<TrainingIndexUnitEvolutionResponse, any>({
        path: `/api/v1/DashboardTrainingIndex/GetUnitEvolution`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém lista de usuários que compõem o índice geral.
     *
     * @tags DashboardTrainingIndex
     * @name GetGeneralUsers
     * @request POST:/api/v1/DashboardTrainingIndex/GetGeneralUsers
     * @secure
     * @response `200` `TrainingIndexUserDtoPaginatedList` OK
     */
    getGeneralUsers: (
      data: GetGeneralUsersPayload,
      params: RequestParams = {},
    ) =>
      this.request<TrainingIndexUserDtoPaginatedList, any>({
        path: `/api/v1/DashboardTrainingIndex/GetGeneralUsers`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém lista de usuários que compõem o índice do tópico.
     *
     * @tags DashboardTrainingIndex
     * @name GetTopicUsers
     * @request POST:/api/v1/DashboardTrainingIndex/GetTopicUsers
     * @secure
     * @response `200` `TrainingIndexUserDtoPaginatedList` OK
     */
    getTopicUsers: (data: GetTopicUsersPayload, params: RequestParams = {}) =>
      this.request<TrainingIndexUserDtoPaginatedList, any>({
        path: `/api/v1/DashboardTrainingIndex/GetTopicUsers`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém lista de usuários que compõem o índice da unidade administrativa.
     *
     * @tags DashboardTrainingIndex
     * @name GetUnitUsers
     * @request POST:/api/v1/DashboardTrainingIndex/GetUnitUsers
     * @secure
     * @response `200` `TrainingIndexUserDtoPaginatedList` OK
     */
    getUnitUsers: (data: GetUnitUsersPayload, params: RequestParams = {}) =>
      this.request<TrainingIndexUserDtoPaginatedList, any>({
        path: `/api/v1/DashboardTrainingIndex/GetUnitUsers`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém lista de usuários que compõem o índice da equipe.
     *
     * @tags DashboardTrainingIndex
     * @name GetTeamUsers
     * @request POST:/api/v1/DashboardTrainingIndex/GetTeamUsers
     * @secure
     * @response `200` `TrainingIndexUserDtoPaginatedList` OK
     */
    getTeamUsers: (data: GetTeamUsersPayload, params: RequestParams = {}) =>
      this.request<TrainingIndexUserDtoPaginatedList, any>({
        path: `/api/v1/DashboardTrainingIndex/GetTeamUsers`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém lista de tópicos chave que compõem o índice geral.
     *
     * @tags DashboardTrainingIndex
     * @name GetGeneralKeyTopics
     * @request POST:/api/v1/DashboardTrainingIndex/GetGeneralKeyTopics
     * @secure
     * @response `200` `(TrainingIndexTopicDto)[]` OK
     */
    getGeneralKeyTopics: (
      data: GetGeneralKeyTopicsPayload,
      params: RequestParams = {},
    ) =>
      this.request<TrainingIndexTopicDto[], any>({
        path: `/api/v1/DashboardTrainingIndex/GetGeneralKeyTopics`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém lista de tópicos chave que compõem o índice do usuário.
     *
     * @tags DashboardTrainingIndex
     * @name GetUserKeyTopics
     * @request POST:/api/v1/DashboardTrainingIndex/GetUserKeyTopics
     * @secure
     * @response `200` `(TrainingIndexTopicDto)[]` OK
     */
    getUserKeyTopics: (
      data: GetUserKeyTopicsPayload,
      params: RequestParams = {},
    ) =>
      this.request<TrainingIndexTopicDto[], any>({
        path: `/api/v1/DashboardTrainingIndex/GetUserKeyTopics`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém lista de tópicos chave que compõem o índice da unidade administrativa.
     *
     * @tags DashboardTrainingIndex
     * @name GetUnitKeyTopics
     * @request POST:/api/v1/DashboardTrainingIndex/GetUnitKeyTopics
     * @secure
     * @response `200` `(TrainingIndexTopicDto)[]` OK
     */
    getUnitKeyTopics: (
      data: GetUnitKeyTopicsPayload,
      params: RequestParams = {},
    ) =>
      this.request<TrainingIndexTopicDto[], any>({
        path: `/api/v1/DashboardTrainingIndex/GetUnitKeyTopics`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém lista de tópicos chave que compõem o índice da equipe.
     *
     * @tags DashboardTrainingIndex
     * @name GetTeamKeyTopics
     * @request POST:/api/v1/DashboardTrainingIndex/GetTeamKeyTopics
     * @secure
     * @response `200` `(TrainingIndexTopicDto)[]` OK
     */
    getTeamKeyTopics: (
      data: GetTeamKeyTopicsPayload,
      params: RequestParams = {},
    ) =>
      this.request<TrainingIndexTopicDto[], any>({
        path: `/api/v1/DashboardTrainingIndex/GetTeamKeyTopics`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém lista de unidades administrativas que compõem o índice geral.
     *
     * @tags DashboardTrainingIndex
     * @name GetGeneralUnits
     * @request POST:/api/v1/DashboardTrainingIndex/GetGeneralUnits
     * @secure
     * @response `200` `TrainingIndexUnitDtoPaginatedList` OK
     */
    getGeneralUnits: (
      data: GetGeneralUnitsPayload,
      params: RequestParams = {},
    ) =>
      this.request<TrainingIndexUnitDtoPaginatedList, any>({
        path: `/api/v1/DashboardTrainingIndex/GetGeneralUnits`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém lista de unidades administrativas que compõem o índice geral.
     *
     * @tags DashboardTrainingIndex
     * @name GetGeneralUnitsHierarchical
     * @request POST:/api/v1/DashboardTrainingIndex/GetGeneralUnitsHierarchical
     * @secure
     * @response `200` `TrainingIndexUnitsHierarchicalResponse` OK
     */
    getGeneralUnitsHierarchical: (
      data: GetGeneralUnitsHierarchicalPayload,
      params: RequestParams = {},
    ) =>
      this.request<TrainingIndexUnitsHierarchicalResponse, any>({
        path: `/api/v1/DashboardTrainingIndex/GetGeneralUnitsHierarchical`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém lista hierárquica de unidades administrativas que compõem o índice do tópico.
     *
     * @tags DashboardTrainingIndex
     * @name GetTopicUnits
     * @request POST:/api/v1/DashboardTrainingIndex/GetTopicUnits
     * @secure
     * @response `200` `TrainingIndexUnitDtoPaginatedList` OK
     */
    getTopicUnits: (data: GetTopicUnitsPayload, params: RequestParams = {}) =>
      this.request<TrainingIndexUnitDtoPaginatedList, any>({
        path: `/api/v1/DashboardTrainingIndex/GetTopicUnits`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém lista hierárquica de unidades administrativas que compõem o índice do tópico.
     *
     * @tags DashboardTrainingIndex
     * @name GetTopicUnitsHierarchical
     * @request POST:/api/v1/DashboardTrainingIndex/GetTopicUnitsHierarchical
     * @secure
     * @response `200` `TrainingIndexUnitsHierarchicalResponse` OK
     */
    getTopicUnitsHierarchical: (
      data: GetTopicUnitsHierarchicalPayload,
      params: RequestParams = {},
    ) =>
      this.request<TrainingIndexUnitsHierarchicalResponse, any>({
        path: `/api/v1/DashboardTrainingIndex/GetTopicUnitsHierarchical`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém lista de treinamentos obrigatórios do usuário.
     *
     * @tags DashboardTrainingIndex
     * @name GetUserTrainings
     * @request POST:/api/v1/DashboardTrainingIndex/GetUserTrainings
     * @secure
     * @response `200` `TrainingIndexTrainingDtoPaginatedList` OK
     */
    getUserTrainings: (
      data: GetUserTrainingsPayload,
      params: RequestParams = {},
    ) =>
      this.request<TrainingIndexTrainingDtoPaginatedList, any>({
        path: `/api/v1/DashboardTrainingIndex/GetUserTrainings`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém resumo de treinamentos obrigatórios do usuário.
     *
     * @tags DashboardTrainingIndex
     * @name GetUserTrainingsSummary
     * @request POST:/api/v1/DashboardTrainingIndex/GetUserTrainingsSummary
     * @secure
     * @response `200` `(TrainingIndexTrainingSummaryDto)[]` OK
     */
    getUserTrainingsSummary: (
      data: GetUserTrainingsSummaryPayload,
      params: RequestParams = {},
    ) =>
      this.request<TrainingIndexTrainingSummaryDto[], any>({
        path: `/api/v1/DashboardTrainingIndex/GetUserTrainingsSummary`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags DashboardTrainingIndex
     * @name ExportGeneralEvolution
     * @request POST:/api/v1/DashboardTrainingIndex/ExportGeneralEvolution
     * @secure
     * @response `200` `any` OK
     */
    exportGeneralEvolution: (params: RequestParams = {}) =>
      this.request<any, any>({
        path: `/api/v1/DashboardTrainingIndex/ExportGeneralEvolution`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags DashboardTrainingIndex
     * @name ExportGeneralUsers
     * @request POST:/api/v1/DashboardTrainingIndex/ExportGeneralUsers
     * @secure
     * @response `200` `any` OK
     */
    exportGeneralUsers: (
      data: ExportGeneralUsersPayload,
      params: RequestParams = {},
    ) =>
      this.request<any, any>({
        path: `/api/v1/DashboardTrainingIndex/ExportGeneralUsers`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags DashboardTrainingIndex
     * @name ExportGeneralTopics
     * @request POST:/api/v1/DashboardTrainingIndex/ExportGeneralTopics
     * @secure
     * @response `200` `any` OK
     */
    exportGeneralTopics: (
      data: ExportGeneralTopicsPayload,
      params: RequestParams = {},
    ) =>
      this.request<any, any>({
        path: `/api/v1/DashboardTrainingIndex/ExportGeneralTopics`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags DashboardTrainingIndex
     * @name ExportGeneralUnits
     * @request POST:/api/v1/DashboardTrainingIndex/ExportGeneralUnits
     * @secure
     * @response `200` `any` OK
     */
    exportGeneralUnits: (
      data: ExportGeneralUnitsPayload,
      params: RequestParams = {},
    ) =>
      this.request<any, any>({
        path: `/api/v1/DashboardTrainingIndex/ExportGeneralUnits`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags DashboardTrainingIndex
     * @name ExportUserEvolution
     * @request POST:/api/v1/DashboardTrainingIndex/ExportUserEvolution
     * @secure
     * @response `200` `any` OK
     */
    exportUserEvolution: (
      data: ExportUserEvolutionPayload,
      params: RequestParams = {},
    ) =>
      this.request<any, any>({
        path: `/api/v1/DashboardTrainingIndex/ExportUserEvolution`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags DashboardTrainingIndex
     * @name ExportUserTopics
     * @request POST:/api/v1/DashboardTrainingIndex/ExportUserTopics
     * @secure
     * @response `200` `any` OK
     */
    exportUserTopics: (
      data: ExportUserTopicsPayload,
      params: RequestParams = {},
    ) =>
      this.request<any, any>({
        path: `/api/v1/DashboardTrainingIndex/ExportUserTopics`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags DashboardTrainingIndex
     * @name ExportUserTrainings
     * @request POST:/api/v1/DashboardTrainingIndex/ExportUserTrainings
     * @secure
     * @response `200` `any` OK
     */
    exportUserTrainings: (
      data: ExportUserTrainingsPayload,
      params: RequestParams = {},
    ) =>
      this.request<any, any>({
        path: `/api/v1/DashboardTrainingIndex/ExportUserTrainings`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags DashboardTrainingIndex
     * @name ExportUnitEvolution
     * @request POST:/api/v1/DashboardTrainingIndex/ExportUnitEvolution
     * @secure
     * @response `200` `any` OK
     */
    exportUnitEvolution: (
      data: ExportUnitEvolutionPayload,
      params: RequestParams = {},
    ) =>
      this.request<any, any>({
        path: `/api/v1/DashboardTrainingIndex/ExportUnitEvolution`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags DashboardTrainingIndex
     * @name ExportUnitUsers
     * @request POST:/api/v1/DashboardTrainingIndex/ExportUnitUsers
     * @secure
     * @response `200` `any` OK
     */
    exportUnitUsers: (
      data: ExportUnitUsersPayload,
      params: RequestParams = {},
    ) =>
      this.request<any, any>({
        path: `/api/v1/DashboardTrainingIndex/ExportUnitUsers`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags DashboardTrainingIndex
     * @name ExportUnitTopics
     * @request POST:/api/v1/DashboardTrainingIndex/ExportUnitTopics
     * @secure
     * @response `200` `any` OK
     */
    exportUnitTopics: (
      data: ExportUnitTopicsPayload,
      params: RequestParams = {},
    ) =>
      this.request<any, any>({
        path: `/api/v1/DashboardTrainingIndex/ExportUnitTopics`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags DashboardTrainingIndex
     * @name ExportTopicEvolution
     * @request POST:/api/v1/DashboardTrainingIndex/ExportTopicEvolution
     * @secure
     * @response `200` `any` OK
     */
    exportTopicEvolution: (
      data: ExportTopicEvolutionPayload,
      params: RequestParams = {},
    ) =>
      this.request<any, any>({
        path: `/api/v1/DashboardTrainingIndex/ExportTopicEvolution`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags DashboardTrainingIndex
     * @name ExportTopicUsers
     * @request POST:/api/v1/DashboardTrainingIndex/ExportTopicUsers
     * @secure
     * @response `200` `any` OK
     */
    exportTopicUsers: (
      data: ExportTopicUsersPayload,
      params: RequestParams = {},
    ) =>
      this.request<any, any>({
        path: `/api/v1/DashboardTrainingIndex/ExportTopicUsers`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags DashboardTrainingIndex
     * @name ExportTopicUnits
     * @request POST:/api/v1/DashboardTrainingIndex/ExportTopicUnits
     * @secure
     * @response `200` `any` OK
     */
    exportTopicUnits: (
      data: ExportTopicUnitsPayload,
      params: RequestParams = {},
    ) =>
      this.request<any, any>({
        path: `/api/v1/DashboardTrainingIndex/ExportTopicUnits`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags DashboardTrainingIndex
     * @name ExportTeamEvolution
     * @request POST:/api/v1/DashboardTrainingIndex/ExportTeamEvolution
     * @secure
     * @response `200` `any` OK
     */
    exportTeamEvolution: (
      data: ExportTeamEvolutionPayload,
      params: RequestParams = {},
    ) =>
      this.request<any, any>({
        path: `/api/v1/DashboardTrainingIndex/ExportTeamEvolution`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags DashboardTrainingIndex
     * @name ExportTeamUsers
     * @request POST:/api/v1/DashboardTrainingIndex/ExportTeamUsers
     * @secure
     * @response `200` `any` OK
     */
    exportTeamUsers: (
      data: ExportTeamUsersPayload,
      params: RequestParams = {},
    ) =>
      this.request<any, any>({
        path: `/api/v1/DashboardTrainingIndex/ExportTeamUsers`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags DashboardTrainingIndex
     * @name ExportTeamTopics
     * @request POST:/api/v1/DashboardTrainingIndex/ExportTeamTopics
     * @secure
     * @response `200` `any` OK
     */
    exportTeamTopics: (
      data: ExportTeamTopicsPayload,
      params: RequestParams = {},
    ) =>
      this.request<any, any>({
        path: `/api/v1/DashboardTrainingIndex/ExportTeamTopics`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
  dashboardTrainingPanel = {
    /**
     * Cria o Cache de Dados para o Dashboard de Painel de Treinamentos.
     *
     * @tags DashboardTrainingPanel
     * @name GetOrCreateCache
     * @request POST:/api/v1/DashboardTrainingPanel/GetOrCreateCache
     * @secure
     * @response `200` `TrainingPanelCacheDto` OK
     */
    getOrCreateCache: (
      data: GetOrCreateCachePayload,
      params: RequestParams = {},
    ) =>
      this.request<TrainingPanelCacheDto, any>({
        path: `/api/v1/DashboardTrainingPanel/GetOrCreateCache`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Cria o Cache de Dados para o Dashboard de Painel de Treinamentos na visão Instructor/Coordenador.
     *
     * @tags DashboardTrainingPanel
     * @name GetOrCreateCacheTutor
     * @request POST:/api/v1/DashboardTrainingPanel/GetOrCreateCacheTutor
     * @secure
     * @response `200` `TrainingPanelCacheTutorDto` OK
     */
    getOrCreateCacheTutor: (
      data: GetOrCreateCacheTutorPayload,
      params: RequestParams = {},
    ) =>
      this.request<TrainingPanelCacheTutorDto, any>({
        path: `/api/v1/DashboardTrainingPanel/GetOrCreateCacheTutor`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Painel de Treinamentos - Análises
     *
     * @tags DashboardTrainingPanel
     * @name TrainingAnalysis
     * @request POST:/api/v1/DashboardTrainingPanel/TrainingAnalysis
     * @secure
     * @response `200` `TrainingPanelDrillDto` OK
     */
    trainingAnalysis: (
      data: TrainingAnalysisPayload,
      params: RequestParams = {},
    ) =>
      this.request<TrainingPanelDrillDto, any>({
        path: `/api/v1/DashboardTrainingPanel/TrainingAnalysis`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Painel de Treinamentos - Indicadores (drill)
     *
     * @tags DashboardTrainingPanel
     * @name TrainingIndicatorDrill
     * @request POST:/api/v1/DashboardTrainingPanel/TrainingIndicatorDrill
     * @secure
     * @response `200` `TrainingPanelIndicatorDrillDto` OK
     */
    trainingIndicatorDrill: (
      data: TrainingIndicatorDrillPayload,
      params: RequestParams = {},
    ) =>
      this.request<TrainingPanelIndicatorDrillDto, any>({
        path: `/api/v1/DashboardTrainingPanel/TrainingIndicatorDrill`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Painel de Treinamentos - Exportação das Análises
     *
     * @tags DashboardTrainingPanel
     * @name ExportTrainingAnalysis
     * @request POST:/api/v1/DashboardTrainingPanel/ExportTrainingAnalysis
     * @secure
     * @response `200` `any` OK
     */
    exportTrainingAnalysis: (
      data: ExportTrainingAnalysisPayload,
      params: RequestParams = {},
    ) =>
      this.request<any, any>({
        path: `/api/v1/DashboardTrainingPanel/ExportTrainingAnalysis`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * Lista de usuários que não se inscrevram em treinamentos do público-alvo.
     *
     * @tags DashboardTrainingPanel
     * @name AudienceNotEnrolledUsers
     * @request POST:/api/v1/DashboardTrainingPanel/AudienceNotEnrolledUsers
     * @secure
     * @response `200` `UserItemDtoPaginatedList` OK
     */
    audienceNotEnrolledUsers: (
      data: AudienceNotEnrolledUsersPayload,
      params: RequestParams = {},
    ) =>
      this.request<UserItemDtoPaginatedList, any>({
        path: `/api/v1/DashboardTrainingPanel/AudienceNotEnrolledUsers`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Painel de Treinamentos - Seleção de Avaliação/Pesquisa.
     *
     * @tags DashboardTrainingPanel
     * @name AssDeploySelection
     * @request POST:/api/v1/DashboardTrainingPanel/AssDeploySelection
     * @secure
     * @response `200` `TrainingPanelAssDeployDtoPaginatedList` OK
     */
    assDeploySelection: (
      data: AssDeploySelectionPayload,
      params: RequestParams = {},
    ) =>
      this.request<TrainingPanelAssDeployDtoPaginatedList, any>({
        path: `/api/v1/DashboardTrainingPanel/AssDeploySelection`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Painel de Treinamentos - Seleção de Usuários que realizaram uma Avaliação.
     *
     * @tags DashboardTrainingPanel
     * @name AssDeployUserSelection
     * @request POST:/api/v1/DashboardTrainingPanel/AssDeployUserSelection
     * @secure
     * @response `200` `TrainingPanelAssDeployUserDtoPaginatedList` OK
     */
    assDeployUserSelection: (
      data: AssDeployUserSelectionPayload,
      params: RequestParams = {},
    ) =>
      this.request<TrainingPanelAssDeployUserDtoPaginatedList, any>({
        path: `/api/v1/DashboardTrainingPanel/AssDeployUserSelection`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Painel de Treinamentos - Usuários Participantes de uma Avaliação/Pesquisa.
     *
     * @tags DashboardTrainingPanel
     * @name AssDeployUsers
     * @request POST:/api/v1/DashboardTrainingPanel/AssDeployUsers
     * @secure
     * @response `200` `TrainingPanelAssDeployUserDtoPaginatedList` OK
     */
    assDeployUsers: (data: AssDeployUsersPayload, params: RequestParams = {}) =>
      this.request<TrainingPanelAssDeployUserDtoPaginatedList, any>({
        path: `/api/v1/DashboardTrainingPanel/AssDeployUsers`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Painel de Treinamentos - Usuários da Turma.
     *
     * @tags DashboardTrainingPanel
     * @name TutorStatisticsUsers
     * @request POST:/api/v1/DashboardTrainingPanel/TutorStatisticsUsers
     * @secure
     * @response `200` `UserEnrollStatisticsDtoPaginatedList` OK
     */
    tutorStatisticsUsers: (
      data: TutorStatisticsUsersPayload,
      params: RequestParams = {},
    ) =>
      this.request<UserEnrollStatisticsDtoPaginatedList, any>({
        path: `/api/v1/DashboardTrainingPanel/TutorStatisticsUsers`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Painel de Treinamentos - Seleção de Treinamentos com Opiniões de Usuários.
     *
     * @tags DashboardTrainingPanel
     * @name OpinionTrainingSelection
     * @request POST:/api/v1/DashboardTrainingPanel/OpinionTrainingSelection
     * @secure
     * @response `200` `TrainingPanelOpinionDtoPaginatedList` OK
     */
    opinionTrainingSelection: (
      data: OpinionTrainingSelectionPayload,
      params: RequestParams = {},
    ) =>
      this.request<TrainingPanelOpinionDtoPaginatedList, any>({
        path: `/api/v1/DashboardTrainingPanel/OpinionTrainingSelection`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Painel de Treinamentos - Motivos de Cancelamento de Inscrições.
     *
     * @tags DashboardTrainingPanel
     * @name CanceledEnrollsByReason
     * @request POST:/api/v1/DashboardTrainingPanel/CanceledEnrollsByReason
     * @secure
     * @response `200` `TrainingPanelCancelEnrollReasonDtoPaginatedList` OK
     */
    canceledEnrollsByReason: (
      data: CanceledEnrollsByReasonPayload,
      params: RequestParams = {},
    ) =>
      this.request<TrainingPanelCancelEnrollReasonDtoPaginatedList, any>({
        path: `/api/v1/DashboardTrainingPanel/CanceledEnrollsByReason`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Painel de Treinamentos - Resumo das Questões Respondidas nos Treinamentos
     *
     * @tags DashboardTrainingPanel
     * @name AssAnalysisResume
     * @request POST:/api/v1/DashboardTrainingPanel/AssAnalysisResume
     * @secure
     * @response `200` `AssAnalysisGroupQuestionResumeResponse` OK
     */
    assAnalysisResume: (
      data: AssAnalysisResumePayload,
      params: RequestParams = {},
    ) =>
      this.request<AssAnalysisGroupQuestionResumeResponse, any>({
        path: `/api/v1/DashboardTrainingPanel/AssAnalysisResume`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Painel de Treinamentos - Lista de Questões respondidas nos Treinamentos
     *
     * @tags DashboardTrainingPanel
     * @name AssAnalysisQuestionList
     * @request POST:/api/v1/DashboardTrainingPanel/AssAnalysisQuestionList
     * @secure
     * @response `200` `AssAnalysisQuestionsResponsePaginatedList` OK
     */
    assAnalysisQuestionList: (
      data: AssAnalysisQuestionListPayload,
      params: RequestParams = {},
    ) =>
      this.request<AssAnalysisQuestionsResponsePaginatedList, any>({
        path: `/api/v1/DashboardTrainingPanel/AssAnalysisQuestionList`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Painel de Treinamentos - Lista de Pessoas que responderam questões Treinamentos
     *
     * @tags DashboardTrainingPanel
     * @name AssAnalysisPeopleList
     * @request POST:/api/v1/DashboardTrainingPanel/AssAnalysisPeopleList
     * @secure
     * @response `200` `AssAnalysisPeopleResponsePaginatedList` OK
     */
    assAnalysisPeopleList: (
      data: AssAnalysisPeopleListPayload,
      params: RequestParams = {},
    ) =>
      this.request<AssAnalysisPeopleResponsePaginatedList, any>({
        path: `/api/v1/DashboardTrainingPanel/AssAnalysisPeopleList`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Painel de Treinamentos - Exporta Lista de Questões respondidas nos Treinamentos.
     *
     * @tags DashboardTrainingPanel
     * @name ExportDashAnalysisQuestionsList
     * @request POST:/api/v1/DashboardTrainingPanel/ExportDashAnalysisQuestionsList
     * @secure
     * @response `200` `any` OK
     */
    exportDashAnalysisQuestionsList: (
      data: ExportDashAnalysisQuestionsListPayload,
      params: RequestParams = {},
    ) =>
      this.request<any, any>({
        path: `/api/v1/DashboardTrainingPanel/ExportDashAnalysisQuestionsList`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * Painel de Treinamentos - Exporta Lista de Pessoas que responderam questões nos Treinamentos
     *
     * @tags DashboardTrainingPanel
     * @name ExportDashAnalysisPeopleList
     * @request POST:/api/v1/DashboardTrainingPanel/ExportDashAnalysisPeopleList
     * @secure
     * @response `200` `any` OK
     */
    exportDashAnalysisPeopleList: (
      data: ExportDashAnalysisPeopleListPayload,
      params: RequestParams = {},
    ) =>
      this.request<any, any>({
        path: `/api/v1/DashboardTrainingPanel/ExportDashAnalysisPeopleList`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
  dashboardUserEvolution = {
    /**
     * Minha Evolução - Permissões
     *
     * @tags DashboardUserEvolution
     * @name GetPermissions
     * @request POST:/api/v1/DashboardUserEvolution/GetPermissions
     * @secure
     * @response `200` `EvolutionPermissionResponse` OK
     */
    getPermissions: (data: GetPermissionsPayload, params: RequestParams = {}) =>
      this.request<EvolutionPermissionResponse, any>({
        path: `/api/v1/DashboardUserEvolution/GetPermissions`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Minha Evolução - Treinamentos - Resumo.
     *
     * @tags DashboardUserEvolution
     * @name GetTrainingsResume
     * @request POST:/api/v1/DashboardUserEvolution/GetTrainingsResume
     * @secure
     * @response `200` `EvolutionTrainingResumeResponse` OK
     */
    getTrainingsResume: (
      data: GetTrainingsResumePayload,
      params: RequestParams = {},
    ) =>
      this.request<EvolutionTrainingResumeResponse, any>({
        path: `/api/v1/DashboardUserEvolution/GetTrainingsResume`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Minha Evolução - Treinamentos - Lista de treinamentos aprovados.
     *
     * @tags DashboardUserEvolution
     * @name GetTrainingsList
     * @request POST:/api/v1/DashboardUserEvolution/GetTrainingsList
     * @secure
     * @response `200` `EvolutionTrainingResponse` OK
     */
    getTrainingsList: (
      data: GetTrainingsListPayload,
      params: RequestParams = {},
    ) =>
      this.request<EvolutionTrainingResponse, any>({
        path: `/api/v1/DashboardUserEvolution/GetTrainingsList`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Minha Evolução - Treinamentos - Exportação da Lista de treinamentos aprovados.
     *
     * @tags DashboardUserEvolution
     * @name ExportTrainingsList
     * @request POST:/api/v1/DashboardUserEvolution/ExportTrainingsList
     * @secure
     * @response `200` `any` OK
     */
    exportTrainingsList: (
      data: ExportTrainingsListPayload,
      params: RequestParams = {},
    ) =>
      this.request<any, any>({
        path: `/api/v1/DashboardUserEvolution/ExportTrainingsList`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * Minha Evolução - Treinamentos - Lista de treinamentos aprovados com certificado ou prazo de validade.
     *
     * @tags DashboardUserEvolution
     * @name GetTrainingCertificatesList
     * @request POST:/api/v1/DashboardUserEvolution/GetTrainingCertificatesList
     * @secure
     * @response `200` `EvolutionTrainingCertificatesResponse` OK
     */
    getTrainingCertificatesList: (
      data: GetTrainingCertificatesListPayload,
      params: RequestParams = {},
    ) =>
      this.request<EvolutionTrainingCertificatesResponse, any>({
        path: `/api/v1/DashboardUserEvolution/GetTrainingCertificatesList`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Minha Evolução - Obtém Estatisticas de Publicações.
     *
     * @tags DashboardUserEvolution
     * @name GetKnowledgeResume
     * @request POST:/api/v1/DashboardUserEvolution/GetKnowledgeResume
     * @secure
     * @response `200` `EvolutionKnowledgeResumeResponse` OK
     */
    getKnowledgeResume: (
      data: GetKnowledgeResumePayload,
      params: RequestParams = {},
    ) =>
      this.request<EvolutionKnowledgeResumeResponse, any>({
        path: `/api/v1/DashboardUserEvolution/GetKnowledgeResume`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Minha Evolução - Obtém lista de Publicações do usuário.
     *
     * @tags DashboardUserEvolution
     * @name GetEvolutionKnowledgeList
     * @request POST:/api/v1/DashboardUserEvolution/GetEvolutionKnowledgeList
     * @secure
     * @response `200` `DashListItemDtoPaginatedList` OK
     */
    getEvolutionKnowledgeList: (
      data: GetEvolutionKnowledgeListPayload,
      params: RequestParams = {},
    ) =>
      this.request<DashListItemDtoPaginatedList, any>({
        path: `/api/v1/DashboardUserEvolution/GetEvolutionKnowledgeList`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Minha Evolução - Exportação da Lista de Publicações do usuário.
     *
     * @tags DashboardUserEvolution
     * @name ExportEvolutionKnowledgeList
     * @request POST:/api/v1/DashboardUserEvolution/ExportEvolutionKnowledgeList
     * @secure
     * @response `200` `any` OK
     */
    exportEvolutionKnowledgeList: (
      data: ExportEvolutionKnowledgeListPayload,
      params: RequestParams = {},
    ) =>
      this.request<any, any>({
        path: `/api/v1/DashboardUserEvolution/ExportEvolutionKnowledgeList`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * Minha Evolução - Obtém os Detalhes da Lista de Publicações do usuário.
     *
     * @tags DashboardUserEvolution
     * @name EvolutionKnowledgeDrill
     * @request POST:/api/v1/DashboardUserEvolution/EvolutionKnowledgeDrill
     * @secure
     * @response `200` `DashListItemDtoPaginatedList` OK
     */
    evolutionKnowledgeDrill: (
      data: EvolutionKnowledgeDrillPayload,
      params: RequestParams = {},
    ) =>
      this.request<DashListItemDtoPaginatedList, any>({
        path: `/api/v1/DashboardUserEvolution/EvolutionKnowledgeDrill`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém indicadores de desafios de conhecimento.
     *
     * @tags DashboardUserEvolution
     * @name GetEvolutionChallengeResume
     * @request POST:/api/v1/DashboardUserEvolution/GetEvolutionChallengeResume
     * @secure
     * @response `200` `EvolutionChallengeResumeResponse` OK
     */
    getEvolutionChallengeResume: (
      data: GetEvolutionChallengeResumePayload,
      params: RequestParams = {},
    ) =>
      this.request<EvolutionChallengeResumeResponse, any>({
        path: `/api/v1/DashboardUserEvolution/GetEvolutionChallengeResume`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém lista de tópicos de um usuário.
     *
     * @tags DashboardUserEvolution
     * @name GetEvolutionChallengeTopics
     * @request POST:/api/v1/DashboardUserEvolution/GetEvolutionChallengeTopics
     * @secure
     * @response `200` `EvolutionChallengeTopicsResponsePaginatedList` OK
     */
    getEvolutionChallengeTopics: (
      data: GetEvolutionChallengeTopicsPayload,
      params: RequestParams = {},
    ) =>
      this.request<EvolutionChallengeTopicsResponsePaginatedList, any>({
        path: `/api/v1/DashboardUserEvolution/GetEvolutionChallengeTopics`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Exporta dados de análise de tópicos para desafio de conhecimento.
     *
     * @tags DashboardUserEvolution
     * @name ExportEvolutionChallengeTopics
     * @request POST:/api/v1/DashboardUserEvolution/ExportEvolutionChallengeTopics
     * @secure
     * @response `200` `any` OK
     */
    exportEvolutionChallengeTopics: (
      data: ExportEvolutionChallengeTopicsPayload,
      params: RequestParams = {},
    ) =>
      this.request<any, any>({
        path: `/api/v1/DashboardUserEvolution/ExportEvolutionChallengeTopics`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * Minha Evolução - Obtém estatistícas de Premiações.
     *
     * @tags DashboardUserEvolution
     * @name GetAwardResume
     * @request POST:/api/v1/DashboardUserEvolution/GetAwardResume
     * @secure
     * @response `200` `EvolutionAwardResumeResponse` OK
     */
    getAwardResume: (data: GetAwardResumeBody, params: RequestParams = {}) =>
      this.request<EvolutionAwardResumeResponse, any>({
        path: `/api/v1/DashboardUserEvolution/GetAwardResume`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Minha Evolução - Premiações - Obtém lista de usuários do ranking.
     *
     * @tags DashboardUserEvolution
     * @name GetAwardRankingList
     * @request POST:/api/v1/DashboardUserEvolution/GetAwardRankingList
     * @secure
     * @response `200` `EvolutionAwardRankingResponse` OK
     */
    getAwardRankingList: (
      data: GetAwardRankingListPayload,
      params: RequestParams = {},
    ) =>
      this.request<EvolutionAwardRankingResponse, any>({
        path: `/api/v1/DashboardUserEvolution/GetAwardRankingList`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Minha Evolução - Premiações - Obtém medalhas do usuário (disponíveis e conquistadas).
     *
     * @tags DashboardUserEvolution
     * @name GetAwardBadges
     * @request POST:/api/v1/DashboardUserEvolution/GetAwardBadges
     * @secure
     * @response `200` `(EvolutionAwardBadgeDto)[]` OK
     */
    getAwardBadges: (data: GetAwardBadgesPayload, params: RequestParams = {}) =>
      this.request<EvolutionAwardBadgeDto[], any>({
        path: `/api/v1/DashboardUserEvolution/GetAwardBadges`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  devPlan = {
    /**
     * Obtém permissões do usuário para listar planos de desenvolvimento.
     *
     * @tags DevPlan
     * @name GetPermissions
     * @request POST:/api/v1/DevPlan/GetPermissions
     * @secure
     * @response `200` `DevPlanPermissionResponse` OK (May return null)
     * @response `204` `any` No Content
     */
    getPermissions: (params: RequestParams = {}) =>
      this.request<DevPlanPermissionResponse, any>({
        path: `/api/v1/DevPlan/GetPermissions`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Obtém a lista de planos de desenvolvimento do usuário.
     *
     * @tags DevPlan
     * @name DevPlansList
     * @request POST:/api/v1/DevPlan/DevPlansList
     * @secure
     * @response `200` `DevPlanUserListResponsePaginatedList` OK
     */
    devPlansList: (data: DevPlansListPayload, params: RequestParams = {}) =>
      this.request<DevPlanUserListResponsePaginatedList, any>({
        path: `/api/v1/DevPlan/DevPlansList`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags DevPlan
     * @name GetUserPermissions
     * @request POST:/api/v1/DevPlan/GetUserPermissions
     * @secure
     * @response `200` `DevPlanUserPermissionResponse` OK
     */
    getUserPermissions: (
      data: GetUserPermissionsPayload,
      params: RequestParams = {},
    ) =>
      this.request<DevPlanUserPermissionResponse, any>({
        path: `/api/v1/DevPlan/GetUserPermissions`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém a lista de usuários.
     *
     * @tags DevPlan
     * @name GetUsersList
     * @request POST:/api/v1/DevPlan/GetUsersList
     * @secure
     * @response `200` `DevPlanUserDtoPaginatedList` OK
     */
    getUsersList: (data: GetUsersListPayload, params: RequestParams = {}) =>
      this.request<DevPlanUserDtoPaginatedList, any>({
        path: `/api/v1/DevPlan/GetUsersList`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém plano de desenvolvimento.
     *
     * @tags DevPlan
     * @name GetDevPlan
     * @request POST:/api/v1/DevPlan/GetDevPlan
     * @secure
     * @response `200` `DevPlanDto` OK (May return null)
     * @response `204` `any` No Content
     */
    getDevPlan: (data: GetDevPlanPayload, params: RequestParams = {}) =>
      this.request<DevPlanDto, any>({
        path: `/api/v1/DevPlan/GetDevPlan`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém plano de desenvolvimento em modo de visualização.
     *
     * @tags DevPlan
     * @name GetDevPlanView
     * @request POST:/api/v1/DevPlan/GetDevPlanView
     * @secure
     * @response `200` `DevPlanViewDto` OK (May return null)
     * @response `204` `any` No Content
     */
    getDevPlanView: (data: GetDevPlanViewPayload, params: RequestParams = {}) =>
      this.request<DevPlanViewDto, any>({
        path: `/api/v1/DevPlan/GetDevPlanView`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém os items de um plano de desenvolvimento.
     *
     * @tags DevPlan
     * @name GetDevPlanItems
     * @request POST:/api/v1/DevPlan/GetDevPlanItems
     * @secure
     * @response `200` `DevPlanItemsResponse` OK
     */
    getDevPlanItems: (
      data: GetDevPlanItemsPayload,
      params: RequestParams = {},
    ) =>
      this.request<DevPlanItemsResponse, any>({
        path: `/api/v1/DevPlan/GetDevPlanItems`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém grupo de atividades.
     *
     * @tags DevPlan
     * @name GetDevPlanGroup
     * @request POST:/api/v1/DevPlan/GetDevPlanGroup
     * @secure
     * @response `200` `DevPlanGroupDto` OK (May return null)
     * @response `204` `any` No Content
     */
    getDevPlanGroup: (
      data: GetDevPlanGroupPayload,
      params: RequestParams = {},
    ) =>
      this.request<DevPlanGroupDto, any>({
        path: `/api/v1/DevPlan/GetDevPlanGroup`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém lista de grupos de atividades.
     *
     * @tags DevPlan
     * @name DevPlanGroups
     * @request POST:/api/v1/DevPlan/DevPlanGroups
     * @secure
     * @response `200` `(DevPlanGroupDto)[]` OK
     */
    devPlanGroups: (data: DevPlanGroupsPayload, params: RequestParams = {}) =>
      this.request<DevPlanGroupDto[], any>({
        path: `/api/v1/DevPlan/DevPlanGroups`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém lista de items do grupo.
     *
     * @tags DevPlan
     * @name DevPlanItems
     * @request POST:/api/v1/DevPlan/DevPlanItems
     * @secure
     * @response `200` `(DevPlanItemDto)[]` OK
     */
    devPlanItems: (data: DevPlanItemsPayload, params: RequestParams = {}) =>
      this.request<DevPlanItemDto[], any>({
        path: `/api/v1/DevPlan/DevPlanItems`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém uma lista de treinamentos onde usuários faz parte do treinamento e pode se auto-inscrever.
     *
     * @tags DevPlan
     * @name TrainingSelector
     * @request POST:/api/v1/DevPlan/TrainingSelector
     * @secure
     * @response `200` `TrainingSelectorDtoPaginatedList` OK (May return null)
     * @response `204` `any` No Content
     */
    trainingSelector: (
      data: TrainingSelectorPayload,
      params: RequestParams = {},
    ) =>
      this.request<TrainingSelectorDtoPaginatedList, any>({
        path: `/api/v1/DevPlan/TrainingSelector`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém uma Publicação do Tipo 'Atividade do Plano de Desenvolvimento'.
     *
     * @tags DevPlan
     * @name GetDevPlanActivity
     * @request POST:/api/v1/DevPlan/GetDevPlanActivity
     * @secure
     * @response `200` `GetDevPlanActivityPublicationDto` OK
     */
    getDevPlanActivity: (
      data: GetDevPlanActivityPayload,
      params: RequestParams = {},
    ) =>
      this.request<GetDevPlanActivityPublicationDto, any>({
        path: `/api/v1/DevPlan/GetDevPlanActivity`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém uma Publicação do Tipo 'Atividade do Plano de Desenvolvimento'.
     *
     * @tags DevPlan
     * @name GetDevPlanActivityContent
     * @request POST:/api/v1/DevPlan/GetDevPlanActivityContent
     * @secure
     * @response `200` `DevPlanActivityContentDto` OK (May return null)
     * @response `204` `any` No Content
     */
    getDevPlanActivityContent: (
      data: GetDevPlanActivityContentPayload,
      params: RequestParams = {},
    ) =>
      this.request<DevPlanActivityContentDto, any>({
        path: `/api/v1/DevPlan/GetDevPlanActivityContent`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Verifica se usuário possui matrícula aprovada no treinamento.
     *
     * @tags DevPlan
     * @name CheckTrainingApproved
     * @request POST:/api/v1/DevPlan/CheckTrainingApproved
     * @secure
     * @response `200` `boolean` OK
     */
    checkTrainingApproved: (
      data: CheckTrainingApprovedPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/DevPlan/CheckTrainingApproved`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Cria ou altera Plano de Desenvolvimento.
     *
     * @tags DevPlan
     * @name CreateOrUpdateDevPlan
     * @request POST:/api/v1/DevPlan/CreateOrUpdateDevPlan
     * @secure
     * @response `200` `string | null` OK (May return null)
     * @response `204` `any` No Content
     */
    createOrUpdateDevPlan: (
      data: CreateOrUpdateDevPlanPayload,
      params: RequestParams = {},
    ) =>
      this.request<string | null, any>({
        path: `/api/v1/DevPlan/CreateOrUpdateDevPlan`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Cria ou altera Grupo de Atividades.
     *
     * @tags DevPlan
     * @name CreateOrUpdateDevPlanGroup
     * @request POST:/api/v1/DevPlan/CreateOrUpdateDevPlanGroup
     * @secure
     * @response `200` `boolean` OK
     */
    createOrUpdateDevPlanGroup: (
      data: CreateOrUpdateDevPlanGroupPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/DevPlan/CreateOrUpdateDevPlanGroup`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Publica plano de desenvolvimento.
     *
     * @tags DevPlan
     * @name Publish
     * @request POST:/api/v1/DevPlan/Publish
     * @secure
     * @response `200` `boolean` OK
     */
    publish: (data: PublishPayload, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/api/v1/DevPlan/Publish`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Cria atividade do tipo "Realizar Treinamento".
     *
     * @tags DevPlan
     * @name CreateTrainingActivity
     * @request POST:/api/v1/DevPlan/CreateTrainingActivity
     * @secure
     * @response `200` `boolean` OK
     */
    createTrainingActivity: (
      data: CreateTrainingActivityPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/DevPlan/CreateTrainingActivity`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Cria atividade do tipo "Publicação".
     *
     * @tags DevPlan
     * @name CreatePublicationActivity
     * @request POST:/api/v1/DevPlan/CreatePublicationActivity
     * @secure
     * @response `200` `boolean` OK
     */
    createPublicationActivity: (
      data: CreatePublicationActivityPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/DevPlan/CreatePublicationActivity`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Cria ou Atualiza publicação do tipo 'Atividade do Plano de Desenvolvimento'.
     *
     * @tags DevPlan
     * @name CreateOtherActivity
     * @request POST:/api/v1/DevPlan/CreateOtherActivity
     * @secure
     * @response `200` `SavePublicationResultDto` OK
     */
    createOtherActivity: (
      data: CreateOtherActivityPayload,
      params: RequestParams = {},
    ) =>
      this.request<SavePublicationResultDto, any>({
        path: `/api/v1/DevPlan/CreateOtherActivity`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Altera Atividade de um plano de desenvolvimento (prazo e progress).
     *
     * @tags DevPlan
     * @name UpdateDevPlanActivity
     * @request POST:/api/v1/DevPlan/UpdateDevPlanActivity
     * @secure
     * @response `200` `boolean` OK
     */
    updateDevPlanActivity: (
      data: UpdateDevPlanActivityPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/DevPlan/UpdateDevPlanActivity`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Marca como aprovado ou não um Plano de Desenvolvimento.
     *
     * @tags DevPlan
     * @name MarkApprovedDevPlan
     * @request POST:/api/v1/DevPlan/MarkApprovedDevPlan
     * @secure
     * @response `200` `boolean` OK
     */
    markApprovedDevPlan: (
      data: MarkApprovedDevPlanPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/DevPlan/MarkApprovedDevPlan`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Marca como somente leitura ou não um Plano de Desenvolvimento aprovado.
     *
     * @tags DevPlan
     * @name MarkReadonlyDevPlan
     * @request POST:/api/v1/DevPlan/MarkReadonlyDevPlan
     * @secure
     * @response `200` `boolean` OK
     */
    markReadonlyDevPlan: (
      data: MarkReadonlyDevPlanPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/DevPlan/MarkReadonlyDevPlan`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Reordena grupos.
     *
     * @tags DevPlan
     * @name ReorderGroups
     * @request POST:/api/v1/DevPlan/ReorderGroups
     * @secure
     * @response `200` `boolean` OK
     */
    reorderGroups: (data: ReorderGroupsPayload, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/api/v1/DevPlan/ReorderGroups`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Reordena items do grupo.
     *
     * @tags DevPlan
     * @name ReorderItems
     * @request POST:/api/v1/DevPlan/ReorderItems
     * @secure
     * @response `200` `boolean` OK
     */
    reorderItems: (data: ReorderItemsBody, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/api/v1/DevPlan/ReorderItems`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Exclui plano.
     *
     * @tags DevPlan
     * @name DeletePlan
     * @request POST:/api/v1/DevPlan/DeletePlan
     * @secure
     * @response `200` `boolean` OK
     */
    deletePlan: (data: DeletePlanPayload, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/api/v1/DevPlan/DeletePlan`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Arquiva plano.
     *
     * @tags DevPlan
     * @name ArchivePlan
     * @request POST:/api/v1/DevPlan/ArchivePlan
     * @secure
     * @response `200` `boolean` OK
     */
    archivePlan: (data: ArchivePlanPayload, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/api/v1/DevPlan/ArchivePlan`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Desarquiva plano.
     *
     * @tags DevPlan
     * @name UnarchivePlan
     * @request POST:/api/v1/DevPlan/UnarchivePlan
     * @secure
     * @response `200` `boolean` OK
     */
    unarchivePlan: (data: UnarchivePlanPayload, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/api/v1/DevPlan/UnarchivePlan`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Exclui grupo.
     *
     * @tags DevPlan
     * @name DeleteGroup
     * @request POST:/api/v1/DevPlan/DeleteGroup
     * @secure
     * @response `200` `boolean` OK
     */
    deleteGroup: (data: DeleteGroupPayload, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/api/v1/DevPlan/DeleteGroup`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Exclui item do grupo.
     *
     * @tags DevPlan
     * @name DeleteItemGroup
     * @request POST:/api/v1/DevPlan/DeleteItemGroup
     * @secure
     * @response `200` `boolean` OK
     */
    deleteItemGroup: (
      data: DeleteItemGroupPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/DevPlan/DeleteItemGroup`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Atualiza progresso de "Outra atividade".
     *
     * @tags DevPlan
     * @name UpdateOtherActivityProgress
     * @request POST:/api/v1/DevPlan/UpdateOtherActivityProgress
     * @secure
     * @response `200` `boolean` OK
     */
    updateOtherActivityProgress: (
      data: UpdateOtherActivityProgressPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/DevPlan/UpdateOtherActivityProgress`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  directMessage = {
    /**
     * Envia mensagem direta para usuários.
     *
     * @tags DirectMessage
     * @name SendDirectMessage
     * @request POST:/api/v1/DirectMessage/SendDirectMessage
     * @secure
     * @response `200` `boolean` OK
     */
    sendDirectMessage: (
      data: SendDirectMessagePayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/DirectMessage/SendDirectMessage`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Exclui mensagem direta.
     *
     * @tags DirectMessage
     * @name DeleteDirectMessage
     * @request POST:/api/v1/DirectMessage/DeleteDirectMessage
     * @secure
     * @response `200` `boolean` OK
     */
    deleteDirectMessage: (
      data: DeleteDirectMessagePayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/DirectMessage/DeleteDirectMessage`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Marcar as mensagens como lidas e não lidas.
     *
     * @tags DirectMessage
     * @name MarkReadDirectMessage
     * @request POST:/api/v1/DirectMessage/MarkReadDirectMessage
     * @secure
     * @response `200` `boolean` OK
     */
    markReadDirectMessage: (
      data: MarkReadDirectMessagePayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/DirectMessage/MarkReadDirectMessage`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém a lista de mensagens direta de um usuário.
     *
     * @tags DirectMessage
     * @name GetDirectMessages
     * @request POST:/api/v1/DirectMessage/GetDirectMessages
     * @secure
     * @response `200` `DirectMessageDtoPaginatedList` OK
     */
    getDirectMessages: (
      data: GetDirectMessagesPayload,
      params: RequestParams = {},
    ) =>
      this.request<DirectMessageDtoPaginatedList, any>({
        path: `/api/v1/DirectMessage/GetDirectMessages`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém mensagem direta.
     *
     * @tags DirectMessage
     * @name GetDirectMessage
     * @request POST:/api/v1/DirectMessage/GetDirectMessage
     * @secure
     * @response `200` `DirectMessageResponse` OK
     */
    getDirectMessage: (
      data: GetDirectMessagePayload,
      params: RequestParams = {},
    ) =>
      this.request<DirectMessageResponse, any>({
        path: `/api/v1/DirectMessage/GetDirectMessage`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  enrollment = {
    /**
     * Obtém matrícula de treinamento do tipo Curso.
     *
     * @tags Enrollment
     * @name GetCourseEnrollment
     * @request POST:/api/v1/Enrollment/GetCourseEnrollment
     * @secure
     * @response `200` `EnrollmentViewDto` OK
     */
    getCourseEnrollment: (
      data: GetCourseEnrollmentPayload,
      params: RequestParams = {},
    ) =>
      this.request<EnrollmentViewDto, any>({
        path: `/api/v1/Enrollment/GetCourseEnrollment`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém matrícula de treinamento do tipo Trilha.
     *
     * @tags Enrollment
     * @name GetLearnPathEnrollment
     * @request POST:/api/v1/Enrollment/GetLearnPathEnrollment
     * @secure
     * @response `200` `EnrollmentViewDto` OK
     */
    getLearnPathEnrollment: (
      data: GetLearnPathEnrollmentPayload,
      params: RequestParams = {},
    ) =>
      this.request<EnrollmentViewDto, any>({
        path: `/api/v1/Enrollment/GetLearnPathEnrollment`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém matrícula de treinamento do tipo Curso Externo.
     *
     * @tags Enrollment
     * @name GetECourseEnrollment
     * @request POST:/api/v1/Enrollment/GetECourseEnrollment
     * @secure
     * @response `200` `EnrollmentViewDto` OK
     */
    getECourseEnrollment: (
      data: GetECourseEnrollmentPayload,
      params: RequestParams = {},
    ) =>
      this.request<EnrollmentViewDto, any>({
        path: `/api/v1/Enrollment/GetECourseEnrollment`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém fases da trilha.
     *
     * @tags Enrollment
     * @name GetLearnPathEnrollmentPhases
     * @request POST:/api/v1/Enrollment/GetLearnPathEnrollmentPhases
     * @secure
     * @response `200` `LearnPathEnrollmentPhasesResponse` OK
     */
    getLearnPathEnrollmentPhases: (
      data: GetLearnPathEnrollmentPhasesPayload,
      params: RequestParams = {},
    ) =>
      this.request<LearnPathEnrollmentPhasesResponse, any>({
        path: `/api/v1/Enrollment/GetLearnPathEnrollmentPhases`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtem os dados para evento presencial ou online para a matricula.
     *
     * @tags Enrollment
     * @name GetMeetingItem
     * @request POST:/api/v1/Enrollment/GetMeetingItem
     * @secure
     * @response `200` `TrainingMeetingItemDto` OK (May return null)
     * @response `204` `any` No Content
     */
    getMeetingItem: (data: GetMeetingItemPayload, params: RequestParams = {}) =>
      this.request<TrainingMeetingItemDto, any>({
        path: `/api/v1/Enrollment/GetMeetingItem`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém publicação de treinamento para matrícula.
     *
     * @tags Enrollment
     * @name GetPostItem
     * @request POST:/api/v1/Enrollment/GetPostItem
     * @secure
     * @response `200` `TrainingPostItemDto` OK (May return null)
     * @response `204` `any` No Content
     */
    getPostItem: (data: GetPostItemPayload, params: RequestParams = {}) =>
      this.request<TrainingPostItemDto, any>({
        path: `/api/v1/Enrollment/GetPostItem`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém publicação de treinamento para matrícula.
     *
     * @tags Enrollment
     * @name GetActivityItem
     * @request POST:/api/v1/Enrollment/GetActivityItem
     * @secure
     * @response `200` `TrainingActivityItemDto` OK (May return null)
     * @response `204` `any` No Content
     */
    getActivityItem: (
      data: GetActivityItemPayload,
      params: RequestParams = {},
    ) =>
      this.request<TrainingActivityItemDto, any>({
        path: `/api/v1/Enrollment/GetActivityItem`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém as Listas de Materiais de uma Turma em ordem de exibição.
     *
     * @tags Enrollment
     * @name GetMaterialLists
     * @request POST:/api/v1/Enrollment/GetMaterialLists
     * @secure
     * @response `200` `(MaterialListsCardDto)[]` OK
     */
    getMaterialLists: (
      data: GetMaterialListsPayload,
      params: RequestParams = {},
    ) =>
      this.request<MaterialListsCardDto[], any>({
        path: `/api/v1/Enrollment/GetMaterialLists`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém as publicações de uma Lista de Material no formato CARD.
     *
     * @tags Enrollment
     * @name GetMaterialListCards
     * @request POST:/api/v1/Enrollment/GetMaterialListCards
     * @secure
     * @response `200` `CardDtoPaginatedList` OK
     */
    getMaterialListCards: (
      data: GetMaterialListCardsPayload,
      params: RequestParams = {},
    ) =>
      this.request<CardDtoPaginatedList, any>({
        path: `/api/v1/Enrollment/GetMaterialListCards`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém lista de treinamentos relacionados para o painel de Veja também.
     *
     * @tags Enrollment
     * @name GetTrainingPanelSeeAlso
     * @request POST:/api/v1/Enrollment/GetTrainingPanelSeeAlso
     * @secure
     * @response `200` `(TrainingPanelSeeAlsoResponse)[]` OK
     */
    getTrainingPanelSeeAlso: (
      data: GetTrainingPanelSeeAlsoPayload,
      params: RequestParams = {},
    ) =>
      this.request<TrainingPanelSeeAlsoResponse[], any>({
        path: `/api/v1/Enrollment/GetTrainingPanelSeeAlso`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém a lista de usuários especialistas do treinamento.
     *
     * @tags Enrollment
     * @name GetTrainingPanelSpecialists
     * @request POST:/api/v1/Enrollment/GetTrainingPanelSpecialists
     * @secure
     * @response `200` `(TrainingSpecialistResponse)[]` OK
     */
    getTrainingPanelSpecialists: (
      data: GetTrainingPanelSpecialistsPayload,
      params: RequestParams = {},
    ) =>
      this.request<TrainingSpecialistResponse[], any>({
        path: `/api/v1/Enrollment/GetTrainingPanelSpecialists`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém a lista de tópicos de um treinamento.
     *
     * @tags Enrollment
     * @name GetTrainingPanelTopics
     * @request POST:/api/v1/Enrollment/GetTrainingPanelTopics
     * @secure
     * @response `200` `(TrainingPanelTopicResponse)[]` OK
     */
    getTrainingPanelTopics: (
      data: GetTrainingPanelTopicsPayload,
      params: RequestParams = {},
    ) =>
      this.request<TrainingPanelTopicResponse[], any>({
        path: `/api/v1/Enrollment/GetTrainingPanelTopics`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém as publicações de uma Lista de Material no formato CARD.
     *
     * @tags Enrollment
     * @name GetEnrolledUsers
     * @request POST:/api/v1/Enrollment/GetEnrolledUsers
     * @secure
     * @response `200` `UserItemDtoPaginatedList` OK
     */
    getEnrolledUsers: (
      data: GetEnrolledUsersPayload,
      params: RequestParams = {},
    ) =>
      this.request<UserItemDtoPaginatedList, any>({
        path: `/api/v1/Enrollment/GetEnrolledUsers`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém detalhamento do progresso.
     *
     * @tags Enrollment
     * @name GetProgressDetail
     * @request POST:/api/v1/Enrollment/GetProgressDetail
     * @secure
     * @response `200` `EnrollmentProgressDetailResponse` OK
     */
    getProgressDetail: (
      data: GetProgressDetailPayload,
      params: RequestParams = {},
    ) =>
      this.request<EnrollmentProgressDetailResponse, any>({
        path: `/api/v1/Enrollment/GetProgressDetail`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém detalhamento da nota.
     *
     * @tags Enrollment
     * @name GetScoreDetail
     * @request POST:/api/v1/Enrollment/GetScoreDetail
     * @secure
     * @response `200` `EnrollmentScoreDetailResponse` OK
     */
    getScoreDetail: (data: GetScoreDetailPayload, params: RequestParams = {}) =>
      this.request<EnrollmentScoreDetailResponse, any>({
        path: `/api/v1/Enrollment/GetScoreDetail`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém termo de aceitação do treinamento, caso exista e ainda não foi aceito.
     *
     * @tags Enrollment
     * @name GetTrainingAgreement
     * @request POST:/api/v1/Enrollment/GetTrainingAgreement
     * @secure
     * @response `200` `EnrollmentTrainingAgreementResponse` OK (May return null)
     * @response `204` `any` No Content
     */
    getTrainingAgreement: (
      data: GetTrainingAgreementPayload,
      params: RequestParams = {},
    ) =>
      this.request<EnrollmentTrainingAgreementResponse, any>({
        path: `/api/v1/Enrollment/GetTrainingAgreement`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Verifica acesso a matrícula.
     *
     * @tags Enrollment
     * @name GetEnrollmentViewPreChecks
     * @request POST:/api/v1/Enrollment/GetEnrollmentViewPreChecks
     * @secure
     * @response `200` `EnrollmentViewPreChecksResponse` OK
     */
    getEnrollmentViewPreChecks: (
      data: GetEnrollmentViewPreChecksPayload,
      params: RequestParams = {},
    ) =>
      this.request<EnrollmentViewPreChecksResponse, any>({
        path: `/api/v1/Enrollment/GetEnrollmentViewPreChecks`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém a Lista de Aprovadores de uma inscrição, com o status do Workflow.
     *
     * @tags Enrollment
     * @name GetEnrollmentWorkflowStatusQuery
     * @request POST:/api/v1/Enrollment/GetEnrollmentWorkflowStatusQuery
     * @secure
     * @response `200` `(EnrollmentWorkflowStatusResponse)[]` OK
     */
    getEnrollmentWorkflowStatusQuery: (
      data: GetEnrollmentWorkflowStatusQueryPayload,
      params: RequestParams = {},
    ) =>
      this.request<EnrollmentWorkflowStatusResponse[], any>({
        path: `/api/v1/Enrollment/GetEnrollmentWorkflowStatusQuery`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém calendário de eventos da matrícula.
     *
     * @tags Enrollment
     * @name GetEnrollmentCalendar
     * @request POST:/api/v1/Enrollment/GetEnrollmentCalendar
     * @secure
     * @response `200` `(EnrollmentCalendarResponse)[]` OK
     */
    getEnrollmentCalendar: (
      data: GetEnrollmentCalendarPayload,
      params: RequestParams = {},
    ) =>
      this.request<EnrollmentCalendarResponse[], any>({
        path: `/api/v1/Enrollment/GetEnrollmentCalendar`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém os registros da busca no conteúdo do curso.
     *
     * @tags Enrollment
     * @name SearchTrainings
     * @request POST:/api/v1/Enrollment/SearchTrainings
     * @secure
     * @response `200` `TrainingComponentSearchDtoPaginatedList` OK
     */
    searchTrainings: (
      data: SearchTrainingsPayload,
      params: RequestParams = {},
    ) =>
      this.request<TrainingComponentSearchDtoPaginatedList, any>({
        path: `/api/v1/Enrollment/SearchTrainings`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém os dados e a configuração do Formulário de Conclusão do Curso Externo.
     *
     * @tags Enrollment
     * @name GetCourseConclusionForm
     * @request POST:/api/v1/Enrollment/GetCourseConclusionForm
     * @secure
     * @response `200` `ConclusionFormDto` OK
     */
    getCourseConclusionForm: (
      data: GetCourseConclusionFormPayload,
      params: RequestParams = {},
    ) =>
      this.request<ConclusionFormDto, any>({
        path: `/api/v1/Enrollment/GetCourseConclusionForm`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém resultado final da finalização da matrícula.
     *
     * @tags Enrollment
     * @name GetEnrollmentFinalResult
     * @request POST:/api/v1/Enrollment/GetEnrollmentFinalResult
     * @secure
     * @response `200` `EnrollmentFinalResultsResponse` OK (May return null)
     * @response `204` `any` No Content
     */
    getEnrollmentFinalResult: (
      data: GetEnrollmentFinalResultPayload,
      params: RequestParams = {},
    ) =>
      this.request<EnrollmentFinalResultsResponse, any>({
        path: `/api/v1/Enrollment/GetEnrollmentFinalResult`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém Callout's da visualização da matrícula.
     *
     * @tags Enrollment
     * @name GetEnrollmentCallouts
     * @request POST:/api/v1/Enrollment/GetEnrollmentCallouts
     * @secure
     * @response `200` `(CalloutDto)[]` OK
     */
    getEnrollmentCallouts: (
      data: GetEnrollmentCalloutsPayload,
      params: RequestParams = {},
    ) =>
      this.request<CalloutDto[], any>({
        path: `/api/v1/Enrollment/GetEnrollmentCallouts`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém avisos da turma do usuário matriculado.
     *
     * @tags Enrollment
     * @name GetEnrollmentNotices
     * @request POST:/api/v1/Enrollment/GetEnrollmentNotices
     * @secure
     * @response `200` `TrainingNoticeItemDtoPaginatedList` OK
     */
    getEnrollmentNotices: (
      data: GetEnrollmentNoticesPayload,
      params: RequestParams = {},
    ) =>
      this.request<TrainingNoticeItemDtoPaginatedList, any>({
        path: `/api/v1/Enrollment/GetEnrollmentNotices`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Armazena o TRACKING do conteúdo
     *
     * @tags Enrollment
     * @name TrackingContent
     * @request POST:/api/v1/Enrollment/TrackingContent
     * @secure
     * @response `200` `TrackingContentResponse` OK
     */
    trackingContent: (
      data: TrackingContentPayload,
      params: RequestParams = {},
    ) =>
      this.request<TrackingContentResponse, any>({
        path: `/api/v1/Enrollment/TrackingContent`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Registra o TRACKING da reprodução da gravação do evento.
     *
     * @tags Enrollment
     * @name MeetingRecordingTracking
     * @request POST:/api/v1/Enrollment/MeetingRecordingTracking
     * @secure
     * @response `200` `TrackingContentResponse` OK
     */
    meetingRecordingTracking: (
      data: MeetingRecordingTrackingPayload,
      params: RequestParams = {},
    ) =>
      this.request<TrackingContentResponse, any>({
        path: `/api/v1/Enrollment/MeetingRecordingTracking`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Fecha matrícula manualmente.
     *
     * @tags Enrollment
     * @name CloseEnrollmentManual
     * @request POST:/api/v1/Enrollment/CloseEnrollmentManual
     * @secure
     * @response `200` `CloseEnrollmentDto` OK
     */
    closeEnrollmentManual: (
      data: CloseEnrollmentManualPayload,
      params: RequestParams = {},
    ) =>
      this.request<CloseEnrollmentDto, any>({
        path: `/api/v1/Enrollment/CloseEnrollmentManual`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Cancela matrícula.
     *
     * @tags Enrollment
     * @name CancelEnrollment
     * @request POST:/api/v1/Enrollment/CancelEnrollment
     * @secure
     * @response `200` `boolean` OK
     */
    cancelEnrollment: (
      data: CancelEnrollmentPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/Enrollment/CancelEnrollment`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém registro da opinião do usuário sobre o treinamento em uma matrícula.
     *
     * @tags Enrollment
     * @name GetEnrollmentRating
     * @request GET:/api/v1/Enrollment/GetEnrollmentRating
     * @secure
     * @response `200` `EnrollmentRatingResponse` OK
     */
    getEnrollmentRating: (
      query?: {
        /** @format uuid */
        EnrollmentId?: string;
        IsMobile?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<EnrollmentRatingResponse, any>({
        path: `/api/v1/Enrollment/GetEnrollmentRating`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Adiciona opinião do usuário sobre o treinamento.
     *
     * @tags Enrollment
     * @name AddRating
     * @request POST:/api/v1/Enrollment/AddRating
     * @secure
     * @response `200` `boolean` OK
     */
    addRating: (data: AddRatingPayload, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/api/v1/Enrollment/AddRating`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Remove opinião do usuário sobre o treinamento.
     *
     * @tags Enrollment
     * @name RemoveRating
     * @request POST:/api/v1/Enrollment/RemoveRating
     * @secure
     * @response `200` `boolean` OK
     */
    removeRating: (data: RemoveRatingPayload, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/api/v1/Enrollment/RemoveRating`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Registra acesso ao componente.
     *
     * @tags Enrollment
     * @name AddComponentAccess
     * @request POST:/api/v1/Enrollment/AddComponentAccess
     * @secure
     * @response `200` `boolean` OK
     */
    addComponentAccess: (
      data: AddComponentAccessPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/Enrollment/AddComponentAccess`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Discarta tentativas restantes de fazer a avaliação e aceita a última nota.
     *
     * @tags Enrollment
     * @name DiscardMaxTriesAssEnrollment
     * @request POST:/api/v1/Enrollment/DiscardMaxTriesAssEnrollment
     * @secure
     * @response `200` `boolean` OK
     */
    discardMaxTriesAssEnrollment: (
      data: DiscardMaxTriesAssEnrollmentPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/Enrollment/DiscardMaxTriesAssEnrollment`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Registra o Tempo de Visualização da Página de Inscrição.
     *
     * @tags Enrollment
     * @name RegisterTimeSpent
     * @request POST:/api/v1/Enrollment/RegisterTimeSpent
     * @secure
     * @response `200` `boolean` OK
     */
    registerTimeSpent: (
      data: RegisterTimeSpentPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/Enrollment/RegisterTimeSpent`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Registra a Entrega de uma Atividade.
     *
     * @tags Enrollment
     * @name DeliveryActivity
     * @request POST:/api/v1/Enrollment/DeliveryActivity
     * @secure
     * @response `200` `boolean` OK
     */
    deliveryActivity: (
      data: DeliveryActivityPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/Enrollment/DeliveryActivity`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Remove uma Atividade entregue.
     *
     * @tags Enrollment
     * @name RemoveDeliveredActivity
     * @request POST:/api/v1/Enrollment/RemoveDeliveredActivity
     * @secure
     * @response `200` `boolean` OK
     */
    removeDeliveredActivity: (
      data: RemoveDeliveredActivityPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/Enrollment/RemoveDeliveredActivity`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Registra o Formulário de Conclusão de Curso Externo.
     *
     * @tags Enrollment
     * @name RegisterConclusionForm
     * @request POST:/api/v1/Enrollment/RegisterConclusionForm
     * @secure
     * @response `200` `CreateEnrollResults` OK
     */
    registerConclusionForm: (
      data: RegisterConclusionFormPayload,
      params: RequestParams = {},
    ) =>
      this.request<CreateEnrollResults, any>({
        path: `/api/v1/Enrollment/RegisterConclusionForm`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Atualiza o Formulário de Conclusão de Curso Externo.
     *
     * @tags Enrollment
     * @name UpdateConclusionForm
     * @request POST:/api/v1/Enrollment/UpdateConclusionForm
     * @secure
     * @response `200` `CreateEnrollResults` OK
     */
    updateConclusionForm: (
      data: UpdateConclusionFormPayload,
      params: RequestParams = {},
    ) =>
      this.request<CreateEnrollResults, any>({
        path: `/api/v1/Enrollment/UpdateConclusionForm`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Verifica se existe matrícula em curso não gerenciado que possa ser reutilizado na trilha.
     *
     * @tags Enrollment
     * @name CheckReuseECourseUnmanaged
     * @request POST:/api/v1/Enrollment/CheckReuseECourseUnmanaged
     * @secure
     * @response `200` `CreateEnrollResults` OK (May return null)
     * @response `204` `any` No Content
     */
    checkReuseECourseUnmanaged: (
      data: CheckReuseECourseUnmanagedPayload,
      params: RequestParams = {},
    ) =>
      this.request<CreateEnrollResults, any>({
        path: `/api/v1/Enrollment/CheckReuseECourseUnmanaged`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Envia mensagem direta para usuários inscritos no Treinamento / Turma com status (NotStarted/InPogress).
     *
     * @tags Enrollment
     * @name SendMessageEnrollment
     * @request POST:/api/v1/Enrollment/SendMessageEnrollment
     * @secure
     * @response `200` `boolean` OK
     */
    sendMessageEnrollment: (
      data: SendMessageEnrollmentPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/Enrollment/SendMessageEnrollment`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Download de uma atividade entregue.
     *
     * @tags Enrollment
     * @name DownloadActivity
     * @request GET:/api/v1/Enrollment/DownloadActivity
     * @secure
     * @response `200` `any` OK
     */
    downloadActivity: (
      query?: {
        /** @format uuid */
        enrollmentId?: string;
        /** @format uuid */
        componentId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<any, any>({
        path: `/api/v1/Enrollment/DownloadActivity`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),
  };
  enrollmentOperation = {
    /**
     * Obtém a lista de treinamento para gerenciamento de inscrições.
     *
     * @tags EnrollmentOperation
     * @name GetEnrollmentTrainings
     * @request POST:/api/v1/EnrollmentOperation/GetEnrollmentTrainings
     * @secure
     * @response `200` `ManagedEnrollmentTrainingListResponsePaginatedList` OK
     */
    getEnrollmentTrainings: (
      data: GetEnrollmentTrainingsPayload,
      params: RequestParams = {},
    ) =>
      this.request<ManagedEnrollmentTrainingListResponsePaginatedList, any>({
        path: `/api/v1/EnrollmentOperation/GetEnrollmentTrainings`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém uma Lista de Usuários disponíveis para seleção.
     *
     * @tags EnrollmentOperation
     * @name GetManagedEnrollmentUsers
     * @request POST:/api/v1/EnrollmentOperation/GetManagedEnrollmentUsers
     * @secure
     * @response `200` `UserInfoDtoPaginatedList` OK
     */
    getManagedEnrollmentUsers: (
      data: GetManagedEnrollmentUsersPayload,
      params: RequestParams = {},
    ) =>
      this.request<UserInfoDtoPaginatedList, any>({
        path: `/api/v1/EnrollmentOperation/GetManagedEnrollmentUsers`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém uma Lista de Usuários selecionados para gerenciamento de inscrições.
     *
     * @tags EnrollmentOperation
     * @name GetManagedEnrollmentSelectedUsers
     * @request POST:/api/v1/EnrollmentOperation/GetManagedEnrollmentSelectedUsers
     * @secure
     * @response `200` `UserInfoDtoPaginatedList` OK
     */
    getManagedEnrollmentSelectedUsers: (
      data: GetManagedEnrollmentSelectedUsersPayload,
      params: RequestParams = {},
    ) =>
      this.request<UserInfoDtoPaginatedList, any>({
        path: `/api/v1/EnrollmentOperation/GetManagedEnrollmentSelectedUsers`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém as turmas de um treinamento para seleção em inscrição.
     *
     * @tags EnrollmentOperation
     * @name GetManagedEnrollmentClassrooms
     * @request POST:/api/v1/EnrollmentOperation/GetManagedEnrollmentClassrooms
     * @secure
     * @response `200` `ManagedEnrollmentClassroomListResponsePaginatedList` OK
     */
    getManagedEnrollmentClassrooms: (
      data: GetManagedEnrollmentClassroomsPayload,
      params: RequestParams = {},
    ) =>
      this.request<ManagedEnrollmentClassroomListResponsePaginatedList, any>({
        path: `/api/v1/EnrollmentOperation/GetManagedEnrollmentClassrooms`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags EnrollmentOperation
     * @name ExportSpreadSheetImportEnrollment
     * @request GET:/api/v1/EnrollmentOperation/ExportSpreadSheetImportEnrollment
     * @secure
     * @response `200` `any` OK
     */
    exportSpreadSheetImportEnrollment: (params: RequestParams = {}) =>
      this.request<any, any>({
        path: `/api/v1/EnrollmentOperation/ExportSpreadSheetImportEnrollment`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * Adiciona um usuário para operação de inscrição.
     *
     * @tags EnrollmentOperation
     * @name AddUserEnroll
     * @request POST:/api/v1/EnrollmentOperation/AddUserEnroll
     * @secure
     * @response `200` `boolean` OK
     */
    addUserEnroll: (data: AddUserEnrollPayload, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/api/v1/EnrollmentOperation/AddUserEnroll`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Adiciona todos os usuários do filtro.
     *
     * @tags EnrollmentOperation
     * @name AddAllUserEnroll
     * @request POST:/api/v1/EnrollmentOperation/AddAllUserEnroll
     * @secure
     * @response `200` `boolean` OK
     */
    addAllUserEnroll: (
      data: AddAllUserEnrollPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/EnrollmentOperation/AddAllUserEnroll`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Remove usuários para operação de inscrição.
     *
     * @tags EnrollmentOperation
     * @name RemoveUserEnroll
     * @request POST:/api/v1/EnrollmentOperation/RemoveUserEnroll
     * @secure
     * @response `200` `boolean` OK
     */
    removeUserEnroll: (
      data: RemoveUserEnrollPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/EnrollmentOperation/RemoveUserEnroll`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Remove todos os usuários selecioandos para operação de inscrição.
     *
     * @tags EnrollmentOperation
     * @name ClearUsersEnroll
     * @request POST:/api/v1/EnrollmentOperation/ClearUsersEnroll
     * @secure
     * @response `200` `boolean` OK
     */
    clearUsersEnroll: (
      data: ClearUsersEnrollPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/EnrollmentOperation/ClearUsersEnroll`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Salva propriedades da operação de inscrição.
     *
     * @tags EnrollmentOperation
     * @name SaveEnroll
     * @request POST:/api/v1/EnrollmentOperation/SaveEnroll
     * @secure
     * @response `200` `boolean` OK
     */
    saveEnroll: (data: SaveEnrollPayload, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/api/v1/EnrollmentOperation/SaveEnroll`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Processa operação de gerenciamento de inscrição.
     *
     * @tags EnrollmentOperation
     * @name ProcessEnroll
     * @request POST:/api/v1/EnrollmentOperation/ProcessEnroll
     * @secure
     * @response `200` `ManagedEnrollmentProcessResponse` OK (May return null)
     * @response `204` `any` No Content
     */
    processEnroll: (data: ProcessEnrollPayload, params: RequestParams = {}) =>
      this.request<ManagedEnrollmentProcessResponse, any>({
        path: `/api/v1/EnrollmentOperation/ProcessEnroll`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Importa lista de usuário para seleção de usuários nas inscrições.
     *
     * @tags EnrollmentOperation
     * @name ImportUserListEnroll
     * @request POST:/api/v1/EnrollmentOperation/ImportUserListEnroll
     * @secure
     * @response `200` `(StringImportedItemModel)[]` OK
     */
    importUserListEnroll: (
      data: ImportUserListEnrollPayload,
      params: RequestParams = {},
    ) =>
      this.request<StringImportedItemModel[], any>({
        path: `/api/v1/EnrollmentOperation/ImportUserListEnroll`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Importa arquivo Excel ou Txt de usuário para seleção de usuários nas inscrições.
     *
     * @tags EnrollmentOperation
     * @name ImportUserFileEnroll
     * @request POST:/api/v1/EnrollmentOperation/ImportUserFileEnroll
     * @secure
     * @response `200` `(StringImportedItemModel)[]` OK
     */
    importUserFileEnroll: (
      data: ImportUserFileEnrollPayload,
      params: RequestParams = {},
    ) =>
      this.request<StringImportedItemModel[], any>({
        path: `/api/v1/EnrollmentOperation/ImportUserFileEnroll`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Remove todos os usuários importados para seleção na operação de inscrição.
     *
     * @tags EnrollmentOperation
     * @name ClearImportedUsersEnroll
     * @request POST:/api/v1/EnrollmentOperation/ClearImportedUsersEnroll
     * @secure
     * @response `200` `boolean` OK
     */
    clearImportedUsersEnroll: (
      data: ClearImportedUsersEnrollPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/EnrollmentOperation/ClearImportedUsersEnroll`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Coloca um Arquivo de Importação de Histórico de Inscrições na Fila de Execução.
     *
     * @tags EnrollmentOperation
     * @name ImportEnroll
     * @request POST:/api/v1/EnrollmentOperation/ImportEnroll
     * @secure
     * @response `200` `boolean` OK
     */
    importEnroll: (data: ImportEnrollPayload, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/api/v1/EnrollmentOperation/ImportEnroll`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  foundationSettings = {
    /**
     * Obtém a lista de Callout's.
     *
     * @tags FoundationSettings
     * @name GetFoundationCallouts
     * @request GET:/api/v1/FoundationSettings/GetFoundationCallouts
     * @secure
     * @response `200` `(CalloutDto)[]` OK
     */
    getFoundationCallouts: (params: RequestParams = {}) =>
      this.request<CalloutDto[], any>({
        path: `/api/v1/FoundationSettings/GetFoundationCallouts`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Obtém as configurações de autenticação padrão do sistema.
     *
     * @tags FoundationSettings
     * @name GetStandardAuthSettings
     * @request GET:/api/v1/FoundationSettings/GetStandardAuthSettings
     * @secure
     * @response `200` `StandardAuthSettingsModel` OK
     */
    getStandardAuthSettings: (params: RequestParams = {}) =>
      this.request<StandardAuthSettingsModel, any>({
        path: `/api/v1/FoundationSettings/GetStandardAuthSettings`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Obtém as configurações de autenticação via SAML.
     *
     * @tags FoundationSettings
     * @name GetSamlAuthSettings
     * @request GET:/api/v1/FoundationSettings/GetSamlAuthSettings
     * @secure
     * @response `200` `SamlAuthSettingsModel` OK
     */
    getSamlAuthSettings: (params: RequestParams = {}) =>
      this.request<SamlAuthSettingsModel, any>({
        path: `/api/v1/FoundationSettings/GetSamlAuthSettings`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Obtém as configurações de autenticação SSO.
     *
     * @tags FoundationSettings
     * @name GetSsoSettings
     * @request GET:/api/v1/FoundationSettings/GetSsoSettings
     * @secure
     * @response `200` `SsoAuthSettingsModel` OK
     */
    getSsoSettings: (params: RequestParams = {}) =>
      this.request<SsoAuthSettingsModel, any>({
        path: `/api/v1/FoundationSettings/GetSsoSettings`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Obtém as configurações do Azure.
     *
     * @tags FoundationSettings
     * @name GetAppAuthSettings
     * @request GET:/api/v1/FoundationSettings/GetAppAuthSettings
     * @secure
     * @response `200` `AppAuthSettingsModel` OK
     */
    getAppAuthSettings: (params: RequestParams = {}) =>
      this.request<AppAuthSettingsModel, any>({
        path: `/api/v1/FoundationSettings/GetAppAuthSettings`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Obtém as configurações de usuário.
     *
     * @tags FoundationSettings
     * @name GetUserSettings
     * @request GET:/api/v1/FoundationSettings/GetUserSettings
     * @secure
     * @response `200` `UserSettingsDto` OK
     */
    getUserSettings: (params: RequestParams = {}) =>
      this.request<UserSettingsDto, any>({
        path: `/api/v1/FoundationSettings/GetUserSettings`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Obtém Registro de configuração da Personalização do Sistema.
     *
     * @tags FoundationSettings
     * @name GetManagedSystemSettings
     * @request GET:/api/v1/FoundationSettings/GetManagedSystemSettings
     * @secure
     * @response `200` `ManagedSystemSettingsResponse` OK
     */
    getManagedSystemSettings: (params: RequestParams = {}) =>
      this.request<ManagedSystemSettingsResponse, any>({
        path: `/api/v1/FoundationSettings/GetManagedSystemSettings`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Obtém configuração de ajuda do sistema
     *
     * @tags FoundationSettings
     * @name AuthFieldsSettings
     * @request GET:/api/v1/FoundationSettings/AuthFieldsSettings
     * @secure
     * @response `200` `AuthFieldsSettingsResponse` OK
     */
    authFieldsSettings: (params: RequestParams = {}) =>
      this.request<AuthFieldsSettingsResponse, any>({
        path: `/api/v1/FoundationSettings/AuthFieldsSettings`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Salva o registro de configuração da Personalização do Sistema.
     *
     * @tags FoundationSettings
     * @name SaveSystemSettings
     * @request POST:/api/v1/FoundationSettings/SaveSystemSettings
     * @secure
     * @response `200` `boolean` OK
     */
    saveSystemSettings: (
      data: SaveSystemSettingsPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/FoundationSettings/SaveSystemSettings`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém o registro de configurações de usuário.
     *
     * @tags FoundationSettings
     * @name GetManagedUserSettings
     * @request GET:/api/v1/FoundationSettings/GetManagedUserSettings
     * @secure
     * @response `200` `ManagedUserSettingsResponse` OK
     */
    getManagedUserSettings: (params: RequestParams = {}) =>
      this.request<ManagedUserSettingsResponse, any>({
        path: `/api/v1/FoundationSettings/GetManagedUserSettings`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Obtém a lista de Imagens Padrão do sistema.
     *
     * @tags FoundationSettings
     * @name GetSystemImages
     * @request GET:/api/v1/FoundationSettings/GetSystemImages
     * @secure
     * @response `200` `(DefaultImagesResponse)[]` OK
     */
    getSystemImages: (params: RequestParams = {}) =>
      this.request<DefaultImagesResponse[], any>({
        path: `/api/v1/FoundationSettings/GetSystemImages`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Obtém a Lista de Funcionalidades do Sistema.
     *
     * @tags FoundationSettings
     * @name GetSystemFeatures
     * @request GET:/api/v1/FoundationSettings/GetSystemFeatures
     * @secure
     * @response `200` `(SystemFeatureResponse)[]` OK
     */
    getSystemFeatures: (params: RequestParams = {}) =>
      this.request<SystemFeatureResponse[], any>({
        path: `/api/v1/FoundationSettings/GetSystemFeatures`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Salva uma imagem padrão do sistema.
     *
     * @tags FoundationSettings
     * @name SaveSystemImage
     * @request POST:/api/v1/FoundationSettings/SaveSystemImage
     * @secure
     * @response `200` `DefaultImagesResponse` OK
     */
    saveSystemImage: (
      data: SaveSystemImagePayload,
      params: RequestParams = {},
    ) =>
      this.request<DefaultImagesResponse, any>({
        path: `/api/v1/FoundationSettings/SaveSystemImage`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Salva o registro de configuração de usuário.
     *
     * @tags FoundationSettings
     * @name SaveUserSettings
     * @request POST:/api/v1/FoundationSettings/SaveUserSettings
     * @secure
     * @response `200` `boolean` OK
     */
    saveUserSettings: (
      data: SaveUserSettingsPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/FoundationSettings/SaveUserSettings`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém o registro de configuração da Autenticação Padrão do Sistema.
     *
     * @tags FoundationSettings
     * @name GetManagedStandardAuthSettings
     * @request GET:/api/v1/FoundationSettings/GetManagedStandardAuthSettings
     * @secure
     * @response `200` `ManagedStandardAuthSettingsResponse` OK
     */
    getManagedStandardAuthSettings: (params: RequestParams = {}) =>
      this.request<ManagedStandardAuthSettingsResponse, any>({
        path: `/api/v1/FoundationSettings/GetManagedStandardAuthSettings`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Salva o registro de configuração da Autenticação Padrão do Sistema.
     *
     * @tags FoundationSettings
     * @name SaveStandardSettings
     * @request POST:/api/v1/FoundationSettings/SaveStandardSettings
     * @secure
     * @response `200` `boolean` OK
     */
    saveStandardSettings: (
      data: SaveStandardSettingsPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/FoundationSettings/SaveStandardSettings`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém o registro de configuração de Autenticação SAML.
     *
     * @tags FoundationSettings
     * @name GetManagedSamlAuthSettings
     * @request GET:/api/v1/FoundationSettings/GetManagedSamlAuthSettings
     * @secure
     * @response `200` `ManagedSamlAuthSettingsResponse` OK
     */
    getManagedSamlAuthSettings: (params: RequestParams = {}) =>
      this.request<ManagedSamlAuthSettingsResponse, any>({
        path: `/api/v1/FoundationSettings/GetManagedSamlAuthSettings`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Salva o registor de configuração de Autenticação SAML.
     *
     * @tags FoundationSettings
     * @name SaveSamlAuthSettings
     * @request POST:/api/v1/FoundationSettings/SaveSamlAuthSettings
     * @secure
     * @response `200` `boolean` OK
     */
    saveSamlAuthSettings: (
      data: SaveSamlAuthSettingsPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/FoundationSettings/SaveSamlAuthSettings`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém o registro de configuração do Performa.
     *
     * @tags FoundationSettings
     * @name GetManagedPerformaSettings
     * @request GET:/api/v1/FoundationSettings/GetManagedPerformaSettings
     * @secure
     * @response `200` `ManagedPerformaSettingsResponse` OK
     */
    getManagedPerformaSettings: (params: RequestParams = {}) =>
      this.request<ManagedPerformaSettingsResponse, any>({
        path: `/api/v1/FoundationSettings/GetManagedPerformaSettings`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Salva o registor de configuração do Performa.
     *
     * @tags FoundationSettings
     * @name SavePerformaSettings
     * @request POST:/api/v1/FoundationSettings/SavePerformaSettings
     * @secure
     * @response `200` `boolean` OK
     */
    savePerformaSettings: (
      data: SavePerformaSettingsPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/FoundationSettings/SavePerformaSettings`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém o registro de configuração de APP REGISTRATION.
     *
     * @tags FoundationSettings
     * @name GetManagedAppAuthSettings
     * @request GET:/api/v1/FoundationSettings/GetManagedAppAuthSettings
     * @secure
     * @response `200` `ManagedAppAuthSettingsResponse` OK
     */
    getManagedAppAuthSettings: (params: RequestParams = {}) =>
      this.request<ManagedAppAuthSettingsResponse, any>({
        path: `/api/v1/FoundationSettings/GetManagedAppAuthSettings`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Salva o registro de configuração de APP REGISTRATION.
     *
     * @tags FoundationSettings
     * @name SaveAppAuthSettings
     * @request POST:/api/v1/FoundationSettings/SaveAppAuthSettings
     * @secure
     * @response `200` `boolean` OK
     */
    saveAppAuthSettings: (
      data: SaveAppAuthSettingsPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/FoundationSettings/SaveAppAuthSettings`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém o registro de configuração de Autenticação SSO.
     *
     * @tags FoundationSettings
     * @name GetManagedSsoAuthSettings
     * @request GET:/api/v1/FoundationSettings/GetManagedSsoAuthSettings
     * @secure
     * @response `200` `ManagedSsoAuthSettingsResponse` OK
     */
    getManagedSsoAuthSettings: (params: RequestParams = {}) =>
      this.request<ManagedSsoAuthSettingsResponse, any>({
        path: `/api/v1/FoundationSettings/GetManagedSsoAuthSettings`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Salva o registro de configuração de Autenticação SSO.
     *
     * @tags FoundationSettings
     * @name SaveSsoSettings
     * @request POST:/api/v1/FoundationSettings/SaveSsoSettings
     * @secure
     * @response `200` `boolean` OK
     */
    saveSsoSettings: (
      data: SaveSsoSettingsPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/FoundationSettings/SaveSsoSettings`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Salva as configurações de Horário de Acesso.
     *
     * @tags FoundationSettings
     * @name SaveAccessTimeSettings
     * @request POST:/api/v1/FoundationSettings/SaveAccessTimeSettings
     * @secure
     * @response `200` `boolean` OK
     */
    saveAccessTimeSettings: (
      data: SaveAccessTimeSettingsPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/FoundationSettings/SaveAccessTimeSettings`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém as configurações de IA.
     *
     * @tags FoundationSettings
     * @name GetIaSettings
     * @request GET:/api/v1/FoundationSettings/GetIaSettings
     * @secure
     * @response `200` `IaSettingsResponse` OK
     */
    getIaSettings: (params: RequestParams = {}) =>
      this.request<IaSettingsResponse, any>({
        path: `/api/v1/FoundationSettings/GetIaSettings`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Salva as configurações de IA.
     *
     * @tags FoundationSettings
     * @name SaveIaSettings
     * @request POST:/api/v1/FoundationSettings/SaveIaSettings
     * @secure
     * @response `200` `boolean` OK
     */
    saveIaSettings: (data: SaveIaSettingsPayload, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/api/v1/FoundationSettings/SaveIaSettings`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém o registro de configuração da Carga de dados manual.
     *
     * @tags FoundationSettings
     * @name GetManagedImportSettings
     * @request GET:/api/v1/FoundationSettings/GetManagedImportSettings
     * @secure
     * @response `200` `ManagedImportResponse` OK
     */
    getManagedImportSettings: (params: RequestParams = {}) =>
      this.request<ManagedImportResponse, any>({
        path: `/api/v1/FoundationSettings/GetManagedImportSettings`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Obtém o registro de configuração da Carga de dados manual de usuários.
     *
     * @tags FoundationSettings
     * @name GetManagedImportUserSettings
     * @request GET:/api/v1/FoundationSettings/GetManagedImportUserSettings
     * @secure
     * @response `200` `ManagedImportUserResponse` OK
     */
    getManagedImportUserSettings: (params: RequestParams = {}) =>
      this.request<ManagedImportUserResponse, any>({
        path: `/api/v1/FoundationSettings/GetManagedImportUserSettings`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Salva o registro de configuração da Carga de dados manual.
     *
     * @tags FoundationSettings
     * @name SaveImportSettings
     * @request POST:/api/v1/FoundationSettings/SaveImportSettings
     * @secure
     * @response `200` `boolean` OK
     */
    saveImportSettings: (
      data: SaveImportSettingsPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/FoundationSettings/SaveImportSettings`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Salva o registro de configuração da Carga de dados manual de usuários.
     *
     * @tags FoundationSettings
     * @name SaveImportUserSettings
     * @request POST:/api/v1/FoundationSettings/SaveImportUserSettings
     * @secure
     * @response `200` `boolean` OK
     */
    saveImportUserSettings: (
      data: SaveImportUserSettingsPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/FoundationSettings/SaveImportUserSettings`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém o registro de configuração da Carga de dados automatica.
     *
     * @tags FoundationSettings
     * @name GetManagedImportUserRemoteSettings
     * @request GET:/api/v1/FoundationSettings/GetManagedImportUserRemoteSettings
     * @secure
     * @response `200` `ManagedImportUserRemoteResponse` OK
     */
    getManagedImportUserRemoteSettings: (params: RequestParams = {}) =>
      this.request<ManagedImportUserRemoteResponse, any>({
        path: `/api/v1/FoundationSettings/GetManagedImportUserRemoteSettings`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Salva o registro de configuração da Carga de dados automatica de usuários.
     *
     * @tags FoundationSettings
     * @name SaveImportUserRemoteSettings
     * @request POST:/api/v1/FoundationSettings/SaveImportUserRemoteSettings
     * @secure
     * @response `200` `boolean` OK
     */
    saveImportUserRemoteSettings: (
      data: SaveImportUserRemoteSettingsPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/FoundationSettings/SaveImportUserRemoteSettings`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém o resultado da última importação remota de usuários.
     *
     * @tags FoundationSettings
     * @name GetLastUserRemoveLoadDataResults
     * @request POST:/api/v1/FoundationSettings/GetLastUserRemoveLoadDataResults
     * @secure
     * @response `200` `LastUserRemoteLoadDataResponse` OK (May return null)
     * @response `204` `any` No Content
     */
    getLastUserRemoveLoadDataResults: (params: RequestParams = {}) =>
      this.request<LastUserRemoteLoadDataResponse, any>({
        path: `/api/v1/FoundationSettings/GetLastUserRemoveLoadDataResults`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Executa a Importação Remota de Usuários imediatamente.
     *
     * @tags FoundationSettings
     * @name RunRemoteUserLoadData
     * @request POST:/api/v1/FoundationSettings/RunRemoteUserLoadData
     * @secure
     * @response `200` `any` OK
     */
    runRemoteUserLoadData: (params: RequestParams = {}) =>
      this.request<any, any>({
        path: `/api/v1/FoundationSettings/RunRemoteUserLoadData`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * Testa conexão com FTP
     *
     * @tags FoundationSettings
     * @name TestUserRemoteFtpConnectionTest
     * @request POST:/api/v1/FoundationSettings/TestUserRemoteFtpConnectionTest
     * @secure
     * @response `200` `boolean` OK
     */
    testUserRemoteFtpConnectionTest: (
      data: TestUserRemoteFtpConnectionTestPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/FoundationSettings/TestUserRemoteFtpConnectionTest`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém Registro de configuração da Integração Online do Teams e Zoom.
     *
     * @tags FoundationSettings
     * @name GetOnlineMeetingSettings
     * @request GET:/api/v1/FoundationSettings/GetOnlineMeetingSettings
     * @secure
     * @response `200` `SettingsOnlineMeetingResponse` OK
     */
    getOnlineMeetingSettings: (params: RequestParams = {}) =>
      this.request<SettingsOnlineMeetingResponse, any>({
        path: `/api/v1/FoundationSettings/GetOnlineMeetingSettings`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Salva o registro de configuração do Teams e do Zoom.
     *
     * @tags FoundationSettings
     * @name SaveOnlineMeetingSettings
     * @request POST:/api/v1/FoundationSettings/SaveOnlineMeetingSettings
     * @secure
     * @response `200` `boolean` OK
     */
    saveOnlineMeetingSettings: (
      data: SaveOnlineMeetingSettingsPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/FoundationSettings/SaveOnlineMeetingSettings`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Solicita o Treinamento dos Modelo de Machine Learning para Knowledge e LMS.
     *
     * @tags FoundationSettings
     * @name CreateAllTrainingModels
     * @request POST:/api/v1/FoundationSettings/CreateAllTrainingModels
     * @secure
     * @response `200` `boolean` OK
     */
    createAllTrainingModels: (
      data: CreateAllTrainingModelsPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/FoundationSettings/CreateAllTrainingModels`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  globalSearch = {
    /**
     * Obtém um resumo da busca global, com 5 items de cada categoria.
     *
     * @tags GlobalSearch
     * @name GlobalSearchPreview
     * @request POST:/api/v1/GlobalSearch/GlobalSearchPreview
     * @secure
     * @response `200` `GlobalSearchPreviewDto` OK
     */
    globalSearchPreview: (
      data: GlobalSearchPreviewPayload,
      params: RequestParams = {},
    ) =>
      this.request<GlobalSearchPreviewDto, any>({
        path: `/api/v1/GlobalSearch/GlobalSearchPreview`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém os registros da busca global.
     *
     * @tags GlobalSearch
     * @name GlobalSearch
     * @request POST:/api/v1/GlobalSearch/GlobalSearch
     * @secure
     * @response `200` `GlobalSearchDto` OK
     */
    globalSearch: (data: GlobalSearchPayload, params: RequestParams = {}) =>
      this.request<GlobalSearchDto, any>({
        path: `/api/v1/GlobalSearch/GlobalSearch`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém os registros da busca no módulo de Conhecimento.
     *
     * @tags GlobalSearch
     * @name KnowledgeSearch
     * @request POST:/api/v1/GlobalSearch/KnowledgeSearch
     * @secure
     * @response `200` `KnowledgeSearchResponse` OK
     */
    knowledgeSearch: (
      data: KnowledgeSearchPayload,
      params: RequestParams = {},
    ) =>
      this.request<KnowledgeSearchResponse, any>({
        path: `/api/v1/GlobalSearch/KnowledgeSearch`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém os registros da busca no módulo de Treinamento.
     *
     * @tags GlobalSearch
     * @name TrainingSearch
     * @request POST:/api/v1/GlobalSearch/TrainingSearch
     * @secure
     * @response `200` `TrainingSearchResponse` OK
     */
    trainingSearch: (data: TrainingSearchPayload, params: RequestParams = {}) =>
      this.request<TrainingSearchResponse, any>({
        path: `/api/v1/GlobalSearch/TrainingSearch`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém os registros da busca em Usuários.
     *
     * @tags GlobalSearch
     * @name UserSearch
     * @request POST:/api/v1/GlobalSearch/UserSearch
     * @secure
     * @response `200` `UserSearchDtoPaginatedList` OK
     */
    userSearch: (data: UserSearchPayload, params: RequestParams = {}) =>
      this.request<UserSearchDtoPaginatedList, any>({
        path: `/api/v1/GlobalSearch/UserSearch`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém os registros da busca em Tópicos.
     *
     * @tags GlobalSearch
     * @name TopicSearch
     * @request POST:/api/v1/GlobalSearch/TopicSearch
     * @secure
     * @response `200` `TopicSearchDtoPaginatedList` OK
     */
    topicSearch: (data: TopicSearchPayload, params: RequestParams = {}) =>
      this.request<TopicSearchDtoPaginatedList, any>({
        path: `/api/v1/GlobalSearch/TopicSearch`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém os registros da busca em Canais.
     *
     * @tags GlobalSearch
     * @name ChannelSearch
     * @request POST:/api/v1/GlobalSearch/ChannelSearch
     * @secure
     * @response `200` `ChannelSearchDtoPaginatedList` OK
     */
    channelSearch: (data: ChannelSearchPayload, params: RequestParams = {}) =>
      this.request<ChannelSearchDtoPaginatedList, any>({
        path: `/api/v1/GlobalSearch/ChannelSearch`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Executa uma pesquisa utilizando RAG (Retrieval-Augmented Generation) para obter respostas baseadas em documentos.
     *
     * @tags GlobalSearch
     * @name RagSearch
     * @request POST:/api/v1/GlobalSearch/RagSearch
     * @secure
     * @response `200` `KnowledgeContextualRAGResponse` OK
     */
    ragSearch: (data: RagSearchPayload, params: RequestParams = {}) =>
      this.request<KnowledgeContextualRAGResponse, any>({
        path: `/api/v1/GlobalSearch/RagSearch`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  group = {
    /**
     * Membros do grupo.
     *
     * @tags Group
     * @name GetGroupMembers
     * @request POST:/api/v1/Group/GetGroupMembers
     * @secure
     * @response `200` `GroupMembersQueryResponsePaginatedList` OK
     */
    getGroupMembers: (
      data: GetGroupMembersPayload,
      params: RequestParams = {},
    ) =>
      this.request<GroupMembersQueryResponsePaginatedList, any>({
        path: `/api/v1/Group/GetGroupMembers`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtem a lista de grupos conforme filtro.
     *
     * @tags Group
     * @name GetGroups
     * @request POST:/api/v1/Group/GetGroups
     * @secure
     * @response `200` `(GroupResponse)[]` OK
     */
    getGroups: (data: GetGroupsPayload, params: RequestParams = {}) =>
      this.request<GroupResponse[], any>({
        path: `/api/v1/Group/GetGroups`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém lista de grupos internos.
     *
     * @tags Group
     * @name GetInternalGroups
     * @request POST:/api/v1/Group/GetInternalGroups
     * @secure
     * @response `200` `(GroupInfo)[]` OK
     */
    getInternalGroups: (params: RequestParams = {}) =>
      this.request<GroupInfo[], any>({
        path: `/api/v1/Group/GetInternalGroups`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  groupManagement = {
    /**
     * Obtém a lista de Groups.
     *
     * @tags GroupManagement
     * @name ManagedGroups
     * @request POST:/api/v1/GroupManagement/ManagedGroups
     * @secure
     * @response `200` `ManagedGroupsListResponsePaginatedList` OK
     */
    managedGroups: (data: ManagedGroupsPayload, params: RequestParams = {}) =>
      this.request<ManagedGroupsListResponsePaginatedList, any>({
        path: `/api/v1/GroupManagement/ManagedGroups`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém as informações principais do grupo para edição.
     *
     * @tags GroupManagement
     * @name GetGroup
     * @request POST:/api/v1/GroupManagement/GetGroup
     * @secure
     * @response `200` `ManagedGroupResponse` OK (May return null)
     * @response `204` `any` No Content
     */
    getGroup: (data: GetGroupPayload, params: RequestParams = {}) =>
      this.request<ManagedGroupResponse, any>({
        path: `/api/v1/GroupManagement/GetGroup`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Retorna se um grupo está sendo utilizado (relacionamento de tabelas).
     *
     * @tags GroupManagement
     * @name GroupIsUsed
     * @request POST:/api/v1/GroupManagement/GroupIsUsed
     * @secure
     * @response `200` `boolean` OK
     */
    groupIsUsed: (data: GroupIsUsedPayload, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/api/v1/GroupManagement/GroupIsUsed`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Cria um grupo estático
     *
     * @tags GroupManagement
     * @name CreateStaticGroup
     * @request POST:/api/v1/GroupManagement/CreateStaticGroup
     * @secure
     * @response `200` `string | null` OK (May return null)
     * @response `204` `any` No Content
     */
    createStaticGroup: (
      data: CreateStaticGroupPayload,
      params: RequestParams = {},
    ) =>
      this.request<string | null, any>({
        path: `/api/v1/GroupManagement/CreateStaticGroup`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Atualiza um grupo estático
     *
     * @tags GroupManagement
     * @name UpdateStaticGroup
     * @request POST:/api/v1/GroupManagement/UpdateStaticGroup
     * @secure
     * @response `200` `boolean` OK
     */
    updateStaticGroup: (
      data: UpdateStaticGroupPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/GroupManagement/UpdateStaticGroup`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Cria um grupo dinâmico
     *
     * @tags GroupManagement
     * @name CreateDynamicGroup
     * @request POST:/api/v1/GroupManagement/CreateDynamicGroup
     * @secure
     * @response `200` `string | null` OK (May return null)
     * @response `204` `any` No Content
     */
    createDynamicGroup: (
      data: CreateDynamicGroupPayload,
      params: RequestParams = {},
    ) =>
      this.request<string | null, any>({
        path: `/api/v1/GroupManagement/CreateDynamicGroup`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Atualiza um grupo dinâmico
     *
     * @tags GroupManagement
     * @name UpdateDynamicGroup
     * @request POST:/api/v1/GroupManagement/UpdateDynamicGroup
     * @secure
     * @response `200` `boolean` OK
     */
    updateDynamicGroup: (
      data: UpdateDynamicGroupPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/GroupManagement/UpdateDynamicGroup`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Exclui um grupo
     *
     * @tags GroupManagement
     * @name DeleteGroup
     * @request POST:/api/v1/GroupManagement/DeleteGroup
     * @secure
     * @response `200` `boolean` OK
     */
    deleteGroup: (data: DeleteGroupBody, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/api/v1/GroupManagement/DeleteGroup`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Processa as regras do grupo dinâmico imediatamente.
     *
     * @tags GroupManagement
     * @name ProcessDynamicGroup
     * @request POST:/api/v1/GroupManagement/ProcessDynamicGroup
     * @secure
     * @response `200` `boolean` OK
     */
    processDynamicGroup: (
      data: ProcessDynamicGroupPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/GroupManagement/ProcessDynamicGroup`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém as lista de membros de um grupo.
     *
     * @tags GroupManagement
     * @name ManagedGroupMembersList
     * @request POST:/api/v1/GroupManagement/ManagedGroupMembersList
     * @secure
     * @response `200` `ManagedGroupMembersListResponsePaginatedList` OK
     */
    managedGroupMembersList: (
      data: ManagedGroupMembersListPayload,
      params: RequestParams = {},
    ) =>
      this.request<ManagedGroupMembersListResponsePaginatedList, any>({
        path: `/api/v1/GroupManagement/ManagedGroupMembersList`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém os membros atuais do Grupo. Não incluirá os membros que estão na Fila de Processamento.
     *
     * @tags GroupManagement
     * @name ManagedGroupGetCurrentMembers
     * @request POST:/api/v1/GroupManagement/ManagedGroupGetCurrentMembers
     * @secure
     * @response `200` `MemberListDtoPaginatedList` OK
     */
    managedGroupGetCurrentMembers: (
      data: ManagedGroupGetCurrentMembersPayload,
      params: RequestParams = {},
    ) =>
      this.request<MemberListDtoPaginatedList, any>({
        path: `/api/v1/GroupManagement/ManagedGroupGetCurrentMembers`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Adiciona um membro no grupo
     *
     * @tags GroupManagement
     * @name AddMemberStaticGroup
     * @request POST:/api/v1/GroupManagement/AddMemberStaticGroup
     * @secure
     * @response `200` `number` OK
     */
    addMemberStaticGroup: (
      data: AddMemberStaticGroupPayload,
      params: RequestParams = {},
    ) =>
      this.request<number, any>({
        path: `/api/v1/GroupManagement/AddMemberStaticGroup`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Exclui um membro do grupo
     *
     * @tags GroupManagement
     * @name DeleteMemberStaticGroup
     * @request POST:/api/v1/GroupManagement/DeleteMemberStaticGroup
     * @secure
     * @response `200` `boolean` OK
     */
    deleteMemberStaticGroup: (
      data: DeleteMemberStaticGroupPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/GroupManagement/DeleteMemberStaticGroup`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Junta membros de um group em outro
     *
     * @tags GroupManagement
     * @name JoinMembersStaticGroup
     * @request POST:/api/v1/GroupManagement/JoinMembersStaticGroup
     * @secure
     * @response `200` `boolean` OK
     */
    joinMembersStaticGroup: (
      data: JoinMembersStaticGroupPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/GroupManagement/JoinMembersStaticGroup`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Adiciona um membro no grupo pela chave de autenticação
     *
     * @tags GroupManagement
     * @name ImportUserMemberToStaticGroup
     * @request POST:/api/v1/GroupManagement/ImportUserMemberToStaticGroup
     * @secure
     * @response `200` `(StringImportedItemModel)[]` OK
     */
    importUserMemberToStaticGroup: (
      data: ImportUserMemberToStaticGroupPayload,
      params: RequestParams = {},
    ) =>
      this.request<StringImportedItemModel[], any>({
        path: `/api/v1/GroupManagement/ImportUserMemberToStaticGroup`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Remove todos os membros de um grupo
     *
     * @tags GroupManagement
     * @name DeleteAllMemberStaticGroup
     * @request POST:/api/v1/GroupManagement/DeleteAllMemberStaticGroup
     * @secure
     * @response `200` `boolean` OK
     */
    deleteAllMemberStaticGroup: (
      data: DeleteAllMemberStaticGroupPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/GroupManagement/DeleteAllMemberStaticGroup`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtem a lista de todos os usuários que são membros do grupo com os campos de autenticação.
     *
     * @tags GroupManagement
     * @name GroupMembersExport
     * @request POST:/api/v1/GroupManagement/GroupMembersExport
     * @secure
     * @response `200` `GroupMembersExportResponsePaginatedList` OK
     */
    groupMembersExport: (
      data: GroupMembersExportPayload,
      params: RequestParams = {},
    ) =>
      this.request<GroupMembersExportResponsePaginatedList, any>({
        path: `/api/v1/GroupManagement/GroupMembersExport`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  indicator = {
    /**
     * Obtém a Lista de todos os Indicadores existentes.
     *
     * @tags Indicator
     * @name GetAllndicators
     * @request GET:/api/v1/Indicator/GetAllndicators
     * @secure
     * @response `200` `(IndicatorDto)[]` OK
     */
    getAllndicators: (params: RequestParams = {}) =>
      this.request<IndicatorDto[], any>({
        path: `/api/v1/Indicator/GetAllndicators`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Obtém a Lista de Indicadores.
     *
     * @tags Indicator
     * @name GetManageIndicatorList
     * @request POST:/api/v1/Indicator/GetManageIndicatorList
     * @secure
     * @response `200` `(IndicatorDto)[]` OK
     */
    getManageIndicatorList: (params: RequestParams = {}) =>
      this.request<IndicatorDto[], any>({
        path: `/api/v1/Indicator/GetManageIndicatorList`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Obtém os Indicadores do Usuário.
     *
     * @tags Indicator
     * @name GetIndicatorData
     * @request POST:/api/v1/Indicator/GetIndicatorData
     * @secure
     * @response `200` `(IndicatorCardDto)[]` OK
     */
    getIndicatorData: (
      data: GetIndicatorDataPayload,
      params: RequestParams = {},
    ) =>
      this.request<IndicatorCardDto[], any>({
        path: `/api/v1/Indicator/GetIndicatorData`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Salva o indicador.
     *
     * @tags Indicator
     * @name Save
     * @request POST:/api/v1/Indicator/Save
     * @secure
     * @response `200` `boolean` OK
     */
    save: (data: SaveBody, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/api/v1/Indicator/Save`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Salva o indicador.
     *
     * @tags Indicator
     * @name Delete
     * @request POST:/api/v1/Indicator/Delete
     * @secure
     * @response `200` `boolean` OK
     */
    delete: (data: DeletePayload, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/api/v1/Indicator/Delete`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Reordena indicadores.
     *
     * @tags Indicator
     * @name Reorder
     * @request POST:/api/v1/Indicator/Reorder
     * @secure
     * @response `200` `boolean` OK
     */
    reorder: (data: ReorderPayload, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/api/v1/Indicator/Reorder`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  instructorManagement = {
    /**
     * Obtém lista de instrutores alocados.
     *
     * @tags InstructorManagement
     * @name List
     * @request POST:/api/v1/InstructorManagement/List
     * @secure
     * @response `200` `ManagedInstructorListResponsePaginatedList` OK
     */
    list: (data: ListPayload, params: RequestParams = {}) =>
      this.request<ManagedInstructorListResponsePaginatedList, any>({
        path: `/api/v1/InstructorManagement/List`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém lista de turmas do instrutor.
     *
     * @tags InstructorManagement
     * @name GetClasses
     * @request POST:/api/v1/InstructorManagement/GetClasses
     * @secure
     * @response `200` `ManagedInstructorClassesResponsePaginatedList` OK
     */
    getClasses: (data: GetClassesPayload, params: RequestParams = {}) =>
      this.request<ManagedInstructorClassesResponsePaginatedList, any>({
        path: `/api/v1/InstructorManagement/GetClasses`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém lista de apontamentos do instrutor.
     *
     * @tags InstructorManagement
     * @name GetAppointments
     * @request POST:/api/v1/InstructorManagement/GetAppointments
     * @secure
     * @response `200` `AppointmentDtoPaginatedList` OK
     */
    getAppointments: (
      data: GetAppointmentsPayload,
      params: RequestParams = {},
    ) =>
      this.request<AppointmentDtoPaginatedList, any>({
        path: `/api/v1/InstructorManagement/GetAppointments`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém agenda do instrutor para um determinado mês.
     *
     * @tags InstructorManagement
     * @name GetCalendar
     * @request POST:/api/v1/InstructorManagement/GetCalendar
     * @secure
     * @response `200` `(AppointmentDayDto)[]` OK
     */
    getCalendar: (data: GetCalendarPayload, params: RequestParams = {}) =>
      this.request<AppointmentDayDto[], any>({
        path: `/api/v1/InstructorManagement/GetCalendar`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém bloqueio de agenda.
     *
     * @tags InstructorManagement
     * @name GetAppointment
     * @request POST:/api/v1/InstructorManagement/GetAppointment
     * @secure
     * @response `200` `InstructorAppointmentResponse` OK
     */
    getAppointment: (data: GetAppointmentPayload, params: RequestParams = {}) =>
      this.request<InstructorAppointmentResponse, any>({
        path: `/api/v1/InstructorManagement/GetAppointment`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Criar ou atualiza bloqueio de agenda do instrutor.
     *
     * @tags InstructorManagement
     * @name CreateOrUpdateAppointment
     * @request POST:/api/v1/InstructorManagement/CreateOrUpdateAppointment
     * @secure
     * @response `200` `CreateOrUpdateAppointmentResult` OK
     */
    createOrUpdateAppointment: (
      data: CreateOrUpdateAppointmentPayload,
      params: RequestParams = {},
    ) =>
      this.request<CreateOrUpdateAppointmentResult, any>({
        path: `/api/v1/InstructorManagement/CreateOrUpdateAppointment`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Remove bloqueio de agenda do instrutor.
     *
     * @tags InstructorManagement
     * @name DeleteAppointment
     * @request POST:/api/v1/InstructorManagement/DeleteAppointment
     * @secure
     * @response `200` `boolean` OK
     */
    deleteAppointment: (
      data: DeleteAppointmentPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/InstructorManagement/DeleteAppointment`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém o link de acesso ao evento ONLINE de um instrutor.
     *
     * @tags InstructorManagement
     * @name MeetingInstructorOnlineUrl
     * @request POST:/api/v1/InstructorManagement/MeetingInstructorOnlineUrl
     * @secure
     * @response `200` `MeetingInstructorOnlineUrlResponse` OK
     */
    meetingInstructorOnlineUrl: (
      data: MeetingInstructorOnlineUrlPayload,
      params: RequestParams = {},
    ) =>
      this.request<MeetingInstructorOnlineUrlResponse, any>({
        path: `/api/v1/InstructorManagement/MeetingInstructorOnlineUrl`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  knowledgeDiscussion = {
    /**
     * Obtém a lista de comentário de uma publicação ou um comentário.
     *
     * @tags KnowledgeDiscussion
     * @name PublicationComments
     * @request POST:/api/v1/KnowledgeDiscussion/PublicationComments
     * @secure
     * @response `200` `PaginatedDiscussion` OK
     */
    publicationComments: (
      data: PublicationCommentsPayload,
      params: RequestParams = {},
    ) =>
      this.request<PaginatedDiscussion, any>({
        path: `/api/v1/KnowledgeDiscussion/PublicationComments`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Cria um comentário para uma publicação.
     *
     * @tags KnowledgeDiscussion
     * @name CreatePublicationComment
     * @request POST:/api/v1/KnowledgeDiscussion/CreatePublicationComment
     * @secure
     * @response `200` `PaginatedDiscussion` OK (May return null)
     * @response `204` `any` No Content
     */
    createPublicationComment: (
      data: CreatePublicationCommentPayload,
      params: RequestParams = {},
    ) =>
      this.request<PaginatedDiscussion, any>({
        path: `/api/v1/KnowledgeDiscussion/CreatePublicationComment`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Altera um comentário para uma publicação.
     *
     * @tags KnowledgeDiscussion
     * @name UpdatePublicationComment
     * @request POST:/api/v1/KnowledgeDiscussion/UpdatePublicationComment
     * @secure
     * @response `200` `boolean` OK
     */
    updatePublicationComment: (
      data: UpdatePublicationCommentPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/KnowledgeDiscussion/UpdatePublicationComment`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Excluir uma comentário de uma publicação.
     *
     * @tags KnowledgeDiscussion
     * @name DeletePublicationComment
     * @request POST:/api/v1/KnowledgeDiscussion/DeletePublicationComment
     * @secure
     * @response `200` `DeleteDiscussionDto` OK
     */
    deletePublicationComment: (
      data: DeletePublicationCommentPayload,
      params: RequestParams = {},
    ) =>
      this.request<DeleteDiscussionDto, any>({
        path: `/api/v1/KnowledgeDiscussion/DeletePublicationComment`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Faz o like ou o dislike em um comentário de uma publicação.
     *
     * @tags KnowledgeDiscussion
     * @name LikePublicationComment
     * @request POST:/api/v1/KnowledgeDiscussion/LikePublicationComment
     * @secure
     * @response `200` `GetDiscussionDto` OK (May return null)
     * @response `204` `any` No Content
     */
    likePublicationComment: (
      data: LikePublicationCommentPayload,
      params: RequestParams = {},
    ) =>
      this.request<GetDiscussionDto, any>({
        path: `/api/v1/KnowledgeDiscussion/LikePublicationComment`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  knowledgeFeed = {
    /**
     * Obtém os itens do Feed de Startup.
     *
     * @tags KnowledgeFeed
     * @name GetFeedStartup
     * @request POST:/api/v1/KnowledgeFeed/GetFeedStartup
     * @secure
     * @response `200` `FeedDataDto` OK
     */
    getFeedStartup: (data: GetFeedStartupPayload, params: RequestParams = {}) =>
      this.request<FeedDataDto, any>({
        path: `/api/v1/KnowledgeFeed/GetFeedStartup`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém uma lista de filtros rápidos para pesquisa do feed
     *
     * @tags KnowledgeFeed
     * @name GetQuickFilterFeedStartup
     * @request GET:/api/v1/KnowledgeFeed/GetQuickFilterFeedStartup
     * @secure
     * @response `200` `(QuickFilterDto)[]` OK
     */
    getQuickFilterFeedStartup: (params: RequestParams = {}) =>
      this.request<QuickFilterDto[], any>({
        path: `/api/v1/KnowledgeFeed/GetQuickFilterFeedStartup`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Obtém a lista de publicações em alta
     *
     * @tags KnowledgeFeed
     * @name GetFeedPanelPublicationTrending
     * @request GET:/api/v1/KnowledgeFeed/GetFeedPanelPublicationTrending
     * @secure
     * @response `200` `(PublicationPanelDto)[]` OK
     */
    getFeedPanelPublicationTrending: (params: RequestParams = {}) =>
      this.request<PublicationPanelDto[], any>({
        path: `/api/v1/KnowledgeFeed/GetFeedPanelPublicationTrending`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Obtém a lista das últimas publicações para o usuário
     *
     * @tags KnowledgeFeed
     * @name GetFeedPanelLatestPublications
     * @request GET:/api/v1/KnowledgeFeed/GetFeedPanelLatestPublications
     * @secure
     * @response `200` `(PublicationPanelDto)[]` OK
     */
    getFeedPanelLatestPublications: (params: RequestParams = {}) =>
      this.request<PublicationPanelDto[], any>({
        path: `/api/v1/KnowledgeFeed/GetFeedPanelLatestPublications`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Obtém a lista de canais em destaque.
     *
     * @tags KnowledgeFeed
     * @name GetFeedPanelChannelsHighlight
     * @request GET:/api/v1/KnowledgeFeed/GetFeedPanelChannelsHighlight
     * @secure
     * @response `200` `(ChannelPanelDto)[]` OK
     */
    getFeedPanelChannelsHighlight: (params: RequestParams = {}) =>
      this.request<ChannelPanelDto[], any>({
        path: `/api/v1/KnowledgeFeed/GetFeedPanelChannelsHighlight`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Obtém a lista de Tópicos em destaque.
     *
     * @tags KnowledgeFeed
     * @name GetFeedPanelTopicsHighlight
     * @request GET:/api/v1/KnowledgeFeed/GetFeedPanelTopicsHighlight
     * @secure
     * @response `200` `(TopicPanelDto)[]` OK
     */
    getFeedPanelTopicsHighlight: (params: RequestParams = {}) =>
      this.request<TopicPanelDto[], any>({
        path: `/api/v1/KnowledgeFeed/GetFeedPanelTopicsHighlight`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Obtém os itens do Feed de Startup.
     *
     * @tags KnowledgeFeed
     * @name GetFeedShorts
     * @request POST:/api/v1/KnowledgeFeed/GetFeedShorts
     * @secure
     * @response `200` `FeedDataDto` OK
     */
    getFeedShorts: (data: GetFeedShortsPayload, params: RequestParams = {}) =>
      this.request<FeedDataDto, any>({
        path: `/api/v1/KnowledgeFeed/GetFeedShorts`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém os itens do Feed de "Minhas Contribuições".
     *
     * @tags KnowledgeFeed
     * @name GetFeedMyContributions
     * @request POST:/api/v1/KnowledgeFeed/GetFeedMyContributions
     * @secure
     * @response `200` `FeedDataDto` OK
     */
    getFeedMyContributions: (
      data: GetFeedMyContributionsPayload,
      params: RequestParams = {},
    ) =>
      this.request<FeedDataDto, any>({
        path: `/api/v1/KnowledgeFeed/GetFeedMyContributions`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém os itens do Feed de "Minhas Respostas".
     *
     * @tags KnowledgeFeed
     * @name GetFeedMyAnswers
     * @request POST:/api/v1/KnowledgeFeed/GetFeedMyAnswers
     * @secure
     * @response `200` `FeedDataDto` OK
     */
    getFeedMyAnswers: (
      data: GetFeedMyAnswersPayload,
      params: RequestParams = {},
    ) =>
      this.request<FeedDataDto, any>({
        path: `/api/v1/KnowledgeFeed/GetFeedMyAnswers`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém os itens do Feed de "Meus Rascunhos".
     *
     * @tags KnowledgeFeed
     * @name GetFeedMyDrafts
     * @request POST:/api/v1/KnowledgeFeed/GetFeedMyDrafts
     * @secure
     * @response `200` `FeedDataDto` OK
     */
    getFeedMyDrafts: (
      data: GetFeedMyDraftsPayload,
      params: RequestParams = {},
    ) =>
      this.request<FeedDataDto, any>({
        path: `/api/v1/KnowledgeFeed/GetFeedMyDrafts`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém os itens do Feed de uma Lista.
     *
     * @tags KnowledgeFeed
     * @name GetFeedList
     * @request POST:/api/v1/KnowledgeFeed/GetFeedList
     * @secure
     * @response `200` `FeedDataDto` OK
     */
    getFeedList: (data: GetFeedListPayload, params: RequestParams = {}) =>
      this.request<FeedDataDto, any>({
        path: `/api/v1/KnowledgeFeed/GetFeedList`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém as respostas de uma pergunta.
     *
     * @tags KnowledgeFeed
     * @name GetFeedQuestion
     * @request POST:/api/v1/KnowledgeFeed/GetFeedQuestion
     * @secure
     * @response `200` `FeedDataDto` OK
     */
    getFeedQuestion: (
      data: GetFeedQuestionPayload,
      params: RequestParams = {},
    ) =>
      this.request<FeedDataDto, any>({
        path: `/api/v1/KnowledgeFeed/GetFeedQuestion`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém um item do Feed.
     *
     * @tags KnowledgeFeed
     * @name GetFeedItem
     * @request POST:/api/v1/KnowledgeFeed/GetFeedItem
     * @secure
     * @response `200` `FeedItemDto` OK (May return null)
     * @response `204` `any` No Content
     */
    getFeedItem: (data: GetFeedItemPayload, params: RequestParams = {}) =>
      this.request<FeedItemDto, any>({
        path: `/api/v1/KnowledgeFeed/GetFeedItem`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém um item do Feed do tipo Lista.
     *
     * @tags KnowledgeFeed
     * @name GetFeedListByType
     * @request POST:/api/v1/KnowledgeFeed/GetFeedListByType
     * @secure
     * @response `200` `FeedItemDto` OK (May return null)
     * @response `204` `any` No Content
     */
    getFeedListByType: (
      data: GetFeedListByTypePayload,
      params: RequestParams = {},
    ) =>
      this.request<FeedItemDto, any>({
        path: `/api/v1/KnowledgeFeed/GetFeedListByType`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém os itens da Thread de uma publicação.
     *
     * @tags KnowledgeFeed
     * @name GetFeedThreadItems
     * @request POST:/api/v1/KnowledgeFeed/GetFeedThreadItems
     * @secure
     * @response `200` `(FeedItemDto)[]` OK
     */
    getFeedThreadItems: (
      data: GetFeedThreadItemsPayload,
      params: RequestParams = {},
    ) =>
      this.request<FeedItemDto[], any>({
        path: `/api/v1/KnowledgeFeed/GetFeedThreadItems`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém os itens do Feed de "Minhas Listas".
     *
     * @tags KnowledgeFeed
     * @name GetFeedMyLists
     * @request POST:/api/v1/KnowledgeFeed/GetFeedMyLists
     * @secure
     * @response `200` `FeedDataDto` OK
     */
    getFeedMyLists: (data: GetFeedMyListsPayload, params: RequestParams = {}) =>
      this.request<FeedDataDto, any>({
        path: `/api/v1/KnowledgeFeed/GetFeedMyLists`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém os itens do Feed "Histórico".
     *
     * @tags KnowledgeFeed
     * @name GetFeedHistory
     * @request POST:/api/v1/KnowledgeFeed/GetFeedHistory
     * @secure
     * @response `200` `FeedDataDto` OK
     */
    getFeedHistory: (data: GetFeedHistoryPayload, params: RequestParams = {}) =>
      this.request<FeedDataDto, any>({
        path: `/api/v1/KnowledgeFeed/GetFeedHistory`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém os itens do Feed de Perguntas "Mais Recentes".
     *
     * @tags KnowledgeFeed
     * @name GetFeedQuestionRecent
     * @request POST:/api/v1/KnowledgeFeed/GetFeedQuestionRecent
     * @secure
     * @response `200` `FeedDataDto` OK
     */
    getFeedQuestionRecent: (
      data: GetFeedQuestionRecentPayload,
      params: RequestParams = {},
    ) =>
      this.request<FeedDataDto, any>({
        path: `/api/v1/KnowledgeFeed/GetFeedQuestionRecent`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém os itens do Feed de Perguntas "Para Você".
     *
     * @tags KnowledgeFeed
     * @name GetFeedQuestionToYou
     * @request POST:/api/v1/KnowledgeFeed/GetFeedQuestionToYou
     * @secure
     * @response `200` `FeedDataDto` OK
     */
    getFeedQuestionToYou: (
      data: GetFeedQuestionToYouPayload,
      params: RequestParams = {},
    ) =>
      this.request<FeedDataDto, any>({
        path: `/api/v1/KnowledgeFeed/GetFeedQuestionToYou`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém os itens do Feed de Perguntas "Acompanhando".
     *
     * @tags KnowledgeFeed
     * @name GetFeedQuestionFollowing
     * @request POST:/api/v1/KnowledgeFeed/GetFeedQuestionFollowing
     * @secure
     * @response `200` `FeedDataDto` OK
     */
    getFeedQuestionFollowing: (
      data: GetFeedQuestionFollowingPayload,
      params: RequestParams = {},
    ) =>
      this.request<FeedDataDto, any>({
        path: `/api/v1/KnowledgeFeed/GetFeedQuestionFollowing`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém dados para o cabeçalho do feed de canal.
     *
     * @tags KnowledgeFeed
     * @name GetFeedChannelHeader
     * @request POST:/api/v1/KnowledgeFeed/GetFeedChannelHeader
     * @secure
     * @response `200` `FeedChannelHeaderResponse` OK (May return null)
     * @response `204` `any` No Content
     */
    getFeedChannelHeader: (
      data: GetFeedChannelHeaderPayload,
      params: RequestParams = {},
    ) =>
      this.request<FeedChannelHeaderResponse, any>({
        path: `/api/v1/KnowledgeFeed/GetFeedChannelHeader`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém a lista de usuários que mais publicaram no canal.
     *
     * @tags KnowledgeFeed
     * @name GetFeedChannelPanelUsersMostPublication
     * @request POST:/api/v1/KnowledgeFeed/GetFeedChannelPanelUsersMostPublication
     * @secure
     * @response `200` `UserPanelDtoPaginatedList` OK
     */
    getFeedChannelPanelUsersMostPublication: (
      data: GetFeedChannelPanelUsersMostPublicationPayload,
      params: RequestParams = {},
    ) =>
      this.request<UserPanelDtoPaginatedList, any>({
        path: `/api/v1/KnowledgeFeed/GetFeedChannelPanelUsersMostPublication`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém a lista de tópicos mais mencionados no canal.
     *
     * @tags KnowledgeFeed
     * @name GetFeedChannelPanelTopicsMention
     * @request POST:/api/v1/KnowledgeFeed/GetFeedChannelPanelTopicsMention
     * @secure
     * @response `200` `(TopicPanelDto)[]` OK
     */
    getFeedChannelPanelTopicsMention: (
      data: GetFeedChannelPanelTopicsMentionPayload,
      params: RequestParams = {},
    ) =>
      this.request<TopicPanelDto[], any>({
        path: `/api/v1/KnowledgeFeed/GetFeedChannelPanelTopicsMention`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém uma lista de filtros rápidos para pesquisa do feed de canais
     *
     * @tags KnowledgeFeed
     * @name GetQuickFilterFeedChannel
     * @request POST:/api/v1/KnowledgeFeed/GetQuickFilterFeedChannel
     * @secure
     * @response `200` `(QuickFilterDto)[]` OK
     */
    getQuickFilterFeedChannel: (
      data: GetQuickFilterFeedChannelPayload,
      params: RequestParams = {},
    ) =>
      this.request<QuickFilterDto[], any>({
        path: `/api/v1/KnowledgeFeed/GetQuickFilterFeedChannel`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém os itens do Feed de Channel.
     *
     * @tags KnowledgeFeed
     * @name GetFeedChannel
     * @request POST:/api/v1/KnowledgeFeed/GetFeedChannel
     * @secure
     * @response `200` `FeedDataDto` OK
     */
    getFeedChannel: (data: GetFeedChannelPayload, params: RequestParams = {}) =>
      this.request<FeedDataDto, any>({
        path: `/api/v1/KnowledgeFeed/GetFeedChannel`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém os itens do Feed de Gerenciamento de Publicações.
     *
     * @tags KnowledgeFeed
     * @name GetFeedPublicationAdmin
     * @request POST:/api/v1/KnowledgeFeed/GetFeedPublicationAdmin
     * @secure
     * @response `200` `FeedItemDtoPaginatedList` OK
     */
    getFeedPublicationAdmin: (
      data: GetFeedPublicationAdminPayload,
      params: RequestParams = {},
    ) =>
      this.request<FeedItemDtoPaginatedList, any>({
        path: `/api/v1/KnowledgeFeed/GetFeedPublicationAdmin`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Retorna se há publicações com restrições no Feed de Gerenciamento de Publicações.
     *
     * @tags KnowledgeFeed
     * @name GetFeedPublicationAdminRestrictions
     * @request POST:/api/v1/KnowledgeFeed/GetFeedPublicationAdminRestrictions
     * @secure
     * @response `200` `boolean` OK
     */
    getFeedPublicationAdminRestrictions: (
      data: GetFeedPublicationAdminRestrictionsPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/KnowledgeFeed/GetFeedPublicationAdminRestrictions`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém a lista de canais mais discutidos do tópico.
     *
     * @tags KnowledgeFeed
     * @name GetFeedTopicPanelChannelMostMention
     * @request POST:/api/v1/KnowledgeFeed/GetFeedTopicPanelChannelMostMention
     * @secure
     * @response `200` `(ChannelPanelDto)[]` OK
     */
    getFeedTopicPanelChannelMostMention: (
      data: GetFeedTopicPanelChannelMostMentionPayload,
      params: RequestParams = {},
    ) =>
      this.request<ChannelPanelDto[], any>({
        path: `/api/v1/KnowledgeFeed/GetFeedTopicPanelChannelMostMention`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém a lista de tópicos relacionados.
     *
     * @tags KnowledgeFeed
     * @name GetFeedTopicPanelRelation
     * @request POST:/api/v1/KnowledgeFeed/GetFeedTopicPanelRelation
     * @secure
     * @response `200` `(TopicPanelDto)[]` OK
     */
    getFeedTopicPanelRelation: (
      data: GetFeedTopicPanelRelationPayload,
      params: RequestParams = {},
    ) =>
      this.request<TopicPanelDto[], any>({
        path: `/api/v1/KnowledgeFeed/GetFeedTopicPanelRelation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém a lista de usuários especialistas e interessados no tópico.
     *
     * @tags KnowledgeFeed
     * @name GetFeedTopicPanelSpecialistInterest
     * @request POST:/api/v1/KnowledgeFeed/GetFeedTopicPanelSpecialistInterest
     * @secure
     * @response `200` `UserPanelSpecialistInterestDtoPaginatedList` OK
     */
    getFeedTopicPanelSpecialistInterest: (
      data: GetFeedTopicPanelSpecialistInterestPayload,
      params: RequestParams = {},
    ) =>
      this.request<UserPanelSpecialistInterestDtoPaginatedList, any>({
        path: `/api/v1/KnowledgeFeed/GetFeedTopicPanelSpecialistInterest`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém o perfil do usuário.
     *
     * @tags KnowledgeFeed
     * @name GetFeedUserProfileHeader
     * @request GET:/api/v1/KnowledgeFeed/GetFeedUserProfileHeader
     * @secure
     * @response `200` `UserProfileDto` OK (May return null)
     * @response `204` `any` No Content
     */
    getFeedUserProfileHeader: (
      query?: {
        /** @format uuid */
        UserId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<UserProfileDto, any>({
        path: `/api/v1/KnowledgeFeed/GetFeedUserProfileHeader`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Obtém os itens do Feed do perfil do usuário.
     *
     * @tags KnowledgeFeed
     * @name GetFeedUserProfile
     * @request POST:/api/v1/KnowledgeFeed/GetFeedUserProfile
     * @secure
     * @response `200` `FeedDataDto` OK
     */
    getFeedUserProfile: (
      data: GetFeedUserProfilePayload,
      params: RequestParams = {},
    ) =>
      this.request<FeedDataDto, any>({
        path: `/api/v1/KnowledgeFeed/GetFeedUserProfile`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém uma lista de filtros rápidos para pesquisa do feed de perfil de usuário.
     *
     * @tags KnowledgeFeed
     * @name GetQuickFilterFeedUser
     * @request POST:/api/v1/KnowledgeFeed/GetQuickFilterFeedUser
     * @secure
     * @response `200` `(QuickFilterDto)[]` OK
     */
    getQuickFilterFeedUser: (
      data: GetQuickFilterFeedUserPayload,
      params: RequestParams = {},
    ) =>
      this.request<QuickFilterDto[], any>({
        path: `/api/v1/KnowledgeFeed/GetQuickFilterFeedUser`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém a lista de interesses profissionais do usuário para painel do feed.
     *
     * @tags KnowledgeFeed
     * @name GetFeedUserPanelProfessionalInterest
     * @request POST:/api/v1/KnowledgeFeed/GetFeedUserPanelProfessionalInterest
     * @secure
     * @response `200` `UserPanelProfessionaInterestDtoPaginatedList` OK
     */
    getFeedUserPanelProfessionalInterest: (
      data: GetFeedUserPanelProfessionalInterestPayload,
      params: RequestParams = {},
    ) =>
      this.request<UserPanelProfessionaInterestDtoPaginatedList, any>({
        path: `/api/v1/KnowledgeFeed/GetFeedUserPanelProfessionalInterest`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém a lista de interesses pessoais do usuário para painel do feed.
     *
     * @tags KnowledgeFeed
     * @name GetFeedUserPanelPersonalInterest
     * @request POST:/api/v1/KnowledgeFeed/GetFeedUserPanelPersonalInterest
     * @secure
     * @response `200` `UserPanelPersonalInterestDtoPaginatedList` OK
     */
    getFeedUserPanelPersonalInterest: (
      data: GetFeedUserPanelPersonalInterestPayload,
      params: RequestParams = {},
    ) =>
      this.request<UserPanelPersonalInterestDtoPaginatedList, any>({
        path: `/api/v1/KnowledgeFeed/GetFeedUserPanelPersonalInterest`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém a lista de Usuários que o usuário está seguindo.
     *
     * @tags KnowledgeFeed
     * @name GetFeedPanelUserFollowing
     * @request POST:/api/v1/KnowledgeFeed/GetFeedPanelUserFollowing
     * @secure
     * @response `200` `UserItemDtoPaginatedList` OK
     */
    getFeedPanelUserFollowing: (
      data: GetFeedPanelUserFollowingPayload,
      params: RequestParams = {},
    ) =>
      this.request<UserItemDtoPaginatedList, any>({
        path: `/api/v1/KnowledgeFeed/GetFeedPanelUserFollowing`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém a lista de Usuários que está seguindo o usuário.
     *
     * @tags KnowledgeFeed
     * @name GetFeedPanelUserFollowers
     * @request POST:/api/v1/KnowledgeFeed/GetFeedPanelUserFollowers
     * @secure
     * @response `200` `UserItemDtoPaginatedList` OK
     */
    getFeedPanelUserFollowers: (
      data: GetFeedPanelUserFollowersPayload,
      params: RequestParams = {},
    ) =>
      this.request<UserItemDtoPaginatedList, any>({
        path: `/api/v1/KnowledgeFeed/GetFeedPanelUserFollowers`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtem dados do painel de estatística do perfil do usuário.
     *
     * @tags KnowledgeFeed
     * @name GetFeedPanelUserStatistic
     * @request POST:/api/v1/KnowledgeFeed/GetFeedPanelUserStatistic
     * @secure
     * @response `200` `UserPanelStatisticDto` OK (May return null)
     * @response `204` `any` No Content
     */
    getFeedPanelUserStatistic: (
      data: GetFeedPanelUserStatisticPayload,
      params: RequestParams = {},
    ) =>
      this.request<UserPanelStatisticDto, any>({
        path: `/api/v1/KnowledgeFeed/GetFeedPanelUserStatistic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém a lista de Usuários que está seguindo o usuário.
     *
     * @tags KnowledgeFeed
     * @name GetFeedPanelUsersSameInterestTag
     * @request POST:/api/v1/KnowledgeFeed/GetFeedPanelUsersSameInterestTag
     * @secure
     * @response `200` `UserItemDtoPaginatedList` OK
     */
    getFeedPanelUsersSameInterestTag: (
      data: GetFeedPanelUsersSameInterestTagPayload,
      params: RequestParams = {},
    ) =>
      this.request<UserItemDtoPaginatedList, any>({
        path: `/api/v1/KnowledgeFeed/GetFeedPanelUsersSameInterestTag`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém lista de credenciais do usuário.
     *
     * @tags KnowledgeFeed
     * @name GetFeedPanelUserCredentials
     * @request POST:/api/v1/KnowledgeFeed/GetFeedPanelUserCredentials
     * @secure
     * @response `200` `(FeedPanelUserCredentialsResponse)[]` OK
     */
    getFeedPanelUserCredentials: (
      data: GetFeedPanelUserCredentialsPayload,
      params: RequestParams = {},
    ) =>
      this.request<FeedPanelUserCredentialsResponse[], any>({
        path: `/api/v1/KnowledgeFeed/GetFeedPanelUserCredentials`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém dados para o cabeçalho do feed de tópico
     *
     * @tags KnowledgeFeed
     * @name GetFeedTopicHeader
     * @request POST:/api/v1/KnowledgeFeed/GetFeedTopicHeader
     * @secure
     * @response `200` `FeedTopicHeaderResponse` OK (May return null)
     * @response `204` `any` No Content
     */
    getFeedTopicHeader: (
      data: GetFeedTopicHeaderPayload,
      params: RequestParams = {},
    ) =>
      this.request<FeedTopicHeaderResponse, any>({
        path: `/api/v1/KnowledgeFeed/GetFeedTopicHeader`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém os itens do Feed de Tópico.
     *
     * @tags KnowledgeFeed
     * @name GetFeedTopic
     * @request POST:/api/v1/KnowledgeFeed/GetFeedTopic
     * @secure
     * @response `200` `FeedDataDto` OK
     */
    getFeedTopic: (data: GetFeedTopicPayload, params: RequestParams = {}) =>
      this.request<FeedDataDto, any>({
        path: `/api/v1/KnowledgeFeed/GetFeedTopic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém uma lista de filtros rápidos para pesquisa do feed de tópicos
     *
     * @tags KnowledgeFeed
     * @name GetQuickFilterFeedTopic
     * @request POST:/api/v1/KnowledgeFeed/GetQuickFilterFeedTopic
     * @secure
     * @response `200` `(QuickFilterDto)[]` OK
     */
    getQuickFilterFeedTopic: (
      data: GetQuickFilterFeedTopicPayload,
      params: RequestParams = {},
    ) =>
      this.request<QuickFilterDto[], any>({
        path: `/api/v1/KnowledgeFeed/GetQuickFilterFeedTopic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Marca Publicação como Lida.
     *
     * @tags KnowledgeFeed
     * @name MarkPublicationRead
     * @request POST:/api/v1/KnowledgeFeed/MarkPublicationRead
     * @secure
     * @response `200` `boolean` OK
     */
    markPublicationRead: (
      data: MarkPublicationReadPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/KnowledgeFeed/MarkPublicationRead`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Adiciona ou Retira um 'Gostei' da publicação.
     *
     * @tags KnowledgeFeed
     * @name AddOrRemoveLike
     * @request POST:/api/v1/KnowledgeFeed/AddOrRemoveLike
     * @secure
     * @response `200` `number` OK
     */
    addOrRemoveLike: (
      data: AddOrRemoveLikePayload,
      params: RequestParams = {},
    ) =>
      this.request<number, any>({
        path: `/api/v1/KnowledgeFeed/AddOrRemoveLike`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Marca ou desmarca a publicação para aparecer no topo do feed do canal
     *
     * @tags KnowledgeFeed
     * @name PublicationToogleChannelPinned
     * @request POST:/api/v1/KnowledgeFeed/PublicationToogleChannelPinned
     * @secure
     * @response `200` `Date | null` OK (May return null)
     * @response `204` `any` No Content
     */
    publicationToogleChannelPinned: (
      data: PublicationToogleChannelPinnedPayload,
      params: RequestParams = {},
    ) =>
      this.request<Date | null, any>({
        path: `/api/v1/KnowledgeFeed/PublicationToogleChannelPinned`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  knowledgeManagement = {
    /**
     * Obtém os itens do Feed de Moderação de Publicações.
     *
     * @tags KnowledgeManagement
     * @name KnowledgeModerationSettings
     * @request GET:/api/v1/KnowledgeManagement/KnowledgeModerationSettings
     * @secure
     * @response `200` `KnowledgeModerationSettingsResponse` OK
     */
    knowledgeModerationSettings: (params: RequestParams = {}) =>
      this.request<KnowledgeModerationSettingsResponse, any>({
        path: `/api/v1/KnowledgeManagement/KnowledgeModerationSettings`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Obtém os itens do Feed de Moderação de Publicações.
     *
     * @tags KnowledgeManagement
     * @name PublicationsForApproval
     * @request POST:/api/v1/KnowledgeManagement/PublicationsForApproval
     * @secure
     * @response `200` `FeedItemDtoPaginatedList` OK
     */
    publicationsForApproval: (
      data: PublicationsForApprovalPayload,
      params: RequestParams = {},
    ) =>
      this.request<FeedItemDtoPaginatedList, any>({
        path: `/api/v1/KnowledgeManagement/PublicationsForApproval`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém os itens do Feed de Moderação de Denúncias.
     *
     * @tags KnowledgeManagement
     * @name ReportsForApproval
     * @request POST:/api/v1/KnowledgeManagement/ReportsForApproval
     * @secure
     * @response `200` `FeedItemDtoPaginatedList` OK
     */
    reportsForApproval: (
      data: ReportsForApprovalPayload,
      params: RequestParams = {},
    ) =>
      this.request<FeedItemDtoPaginatedList, any>({
        path: `/api/v1/KnowledgeManagement/ReportsForApproval`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém os itens do Feed de Moderação de Inscrições em Canal.
     *
     * @tags KnowledgeManagement
     * @name ChannelSubscriptionsForApproval
     * @request POST:/api/v1/KnowledgeManagement/ChannelSubscriptionsForApproval
     * @secure
     * @response `200` `ChannelSubscriptionRequestDtoPaginatedList` OK
     */
    channelSubscriptionsForApproval: (
      data: ChannelSubscriptionsForApprovalPayload,
      params: RequestParams = {},
    ) =>
      this.request<ChannelSubscriptionRequestDtoPaginatedList, any>({
        path: `/api/v1/KnowledgeManagement/ChannelSubscriptionsForApproval`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém outras denúncias associadas a uma Acão de Moderação.
     *
     * @tags KnowledgeManagement
     * @name GetOtherReports
     * @request POST:/api/v1/KnowledgeManagement/GetOtherReports
     * @secure
     * @response `200` `(OthersReportsResponse)[]` OK
     */
    getOtherReports: (
      data: GetOtherReportsPayload,
      params: RequestParams = {},
    ) =>
      this.request<OthersReportsResponse[], any>({
        path: `/api/v1/KnowledgeManagement/GetOtherReports`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Salva o registro de configuração da Personalização do Módulo de Conhecimento.
     *
     * @tags KnowledgeManagement
     * @name ModeratePublication
     * @request POST:/api/v1/KnowledgeManagement/ModeratePublication
     * @secure
     * @response `200` `boolean` OK
     */
    moderatePublication: (
      data: ModeratePublicationPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/KnowledgeManagement/ModeratePublication`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  knowledgePublication = {
    /**
     * Obtém as configurações para criação de uma publicação.
     *
     * @tags KnowledgePublication
     * @name GetCreationSettings
     * @request POST:/api/v1/KnowledgePublication/GetCreationSettings
     * @secure
     * @response `200` `PublicationCreationSettingsResponse` OK
     */
    getCreationSettings: (
      data: GetCreationSettingsPayload,
      params: RequestParams = {},
    ) =>
      this.request<PublicationCreationSettingsResponse, any>({
        path: `/api/v1/KnowledgePublication/GetCreationSettings`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém a configuração para preenchimento das Opções Avançadas de uma Publicação.
     *
     * @tags KnowledgePublication
     * @name GetAdvancedOptionsSettings
     * @request POST:/api/v1/KnowledgePublication/GetAdvancedOptionsSettings
     * @secure
     * @response `200` `AdvancedOptionsCreationSettingsResponse` OK
     */
    getAdvancedOptionsSettings: (
      data: GetAdvancedOptionsSettingsPayload,
      params: RequestParams = {},
    ) =>
      this.request<AdvancedOptionsCreationSettingsResponse, any>({
        path: `/api/v1/KnowledgePublication/GetAdvancedOptionsSettings`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém a lista de Sugestões de Tópico de um Canal.
     *
     * @tags KnowledgePublication
     * @name GetChannelTopicsSuggestionsQuery
     * @request GET:/api/v1/KnowledgePublication/GetChannelTopicsSuggestionsQuery
     * @secure
     * @response `200` `(AutoCompleteHierarchicalModelDto)[]` OK
     */
    getChannelTopicsSuggestionsQuery: (
      query?: {
        /** @format uuid */
        ChannelId?: string;
        PublicationTitle?: string;
        PublicationContent?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AutoCompleteHierarchicalModelDto[], any>({
        path: `/api/v1/KnowledgePublication/GetChannelTopicsSuggestionsQuery`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Obtém uma Publicação do Tipo 'Postagem'.
     *
     * @tags KnowledgePublication
     * @name GetPostPublication
     * @request POST:/api/v1/KnowledgePublication/GetPostPublication
     * @secure
     * @response `200` `GetPostPublicationDto` OK
     */
    getPostPublication: (
      data: GetPostPublicationPayload,
      params: RequestParams = {},
    ) =>
      this.request<GetPostPublicationDto, any>({
        path: `/api/v1/KnowledgePublication/GetPostPublication`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém uma Publicação do Tipo 'Postagem' em modo 'Thread'.
     *
     * @tags KnowledgePublication
     * @name GetPostThreadPublication
     * @request POST:/api/v1/KnowledgePublication/GetPostThreadPublication
     * @secure
     * @response `200` `GetPostThreadPublicationDto` OK
     */
    getPostThreadPublication: (
      data: GetPostThreadPublicationPayload,
      params: RequestParams = {},
    ) =>
      this.request<GetPostThreadPublicationDto, any>({
        path: `/api/v1/KnowledgePublication/GetPostThreadPublication`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém uma Publicação do Tipo 'Postagem' exclusiva de uma lista
     *
     * @tags KnowledgePublication
     * @name GetPostListExclusivePublication
     * @request POST:/api/v1/KnowledgePublication/GetPostListExclusivePublication
     * @secure
     * @response `200` `GetPostListExclusivePublicationDto` OK
     */
    getPostListExclusivePublication: (
      data: GetPostListExclusivePublicationPayload,
      params: RequestParams = {},
    ) =>
      this.request<GetPostListExclusivePublicationDto, any>({
        path: `/api/v1/KnowledgePublication/GetPostListExclusivePublication`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém uma Publicação do Tipo 'Fichário'.
     *
     * @tags KnowledgePublication
     * @name GetBinderPublication
     * @request POST:/api/v1/KnowledgePublication/GetBinderPublication
     * @secure
     * @response `200` `GetBinderPublicationDto` OK
     */
    getBinderPublication: (
      data: GetBinderPublicationPayload,
      params: RequestParams = {},
    ) =>
      this.request<GetBinderPublicationDto, any>({
        path: `/api/v1/KnowledgePublication/GetBinderPublication`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém uma Publicação do Tipo 'Enquete'.
     *
     * @tags KnowledgePublication
     * @name GetPollPublication
     * @request POST:/api/v1/KnowledgePublication/GetPollPublication
     * @secure
     * @response `200` `GetPollPublicationDto` OK
     */
    getPollPublication: (
      data: GetPollPublicationPayload,
      params: RequestParams = {},
    ) =>
      this.request<GetPollPublicationDto, any>({
        path: `/api/v1/KnowledgePublication/GetPollPublication`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém uma Publicação do Tipo 'Enquete' em modo 'Thread'.
     *
     * @tags KnowledgePublication
     * @name GetPollThreadPublication
     * @request POST:/api/v1/KnowledgePublication/GetPollThreadPublication
     * @secure
     * @response `200` `GetPollThreadPublicationDto` OK
     */
    getPollThreadPublication: (
      data: GetPollThreadPublicationPayload,
      params: RequestParams = {},
    ) =>
      this.request<GetPollThreadPublicationDto, any>({
        path: `/api/v1/KnowledgePublication/GetPollThreadPublication`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém os resultados de uma 'Enquete'.
     *
     * @tags KnowledgePublication
     * @name GetPollResults
     * @request POST:/api/v1/KnowledgePublication/GetPollResults
     * @secure
     * @response `200` `FeedPollResults` OK
     */
    getPollResults: (data: GetPollResultsPayload, params: RequestParams = {}) =>
      this.request<FeedPollResults, any>({
        path: `/api/v1/KnowledgePublication/GetPollResults`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém uma Publicação do Tipo 'Pergunta'.
     *
     * @tags KnowledgePublication
     * @name GetQuestionPublication
     * @request POST:/api/v1/KnowledgePublication/GetQuestionPublication
     * @secure
     * @response `200` `GetQuestionPublicationDto` OK
     */
    getQuestionPublication: (
      data: GetQuestionPublicationPayload,
      params: RequestParams = {},
    ) =>
      this.request<GetQuestionPublicationDto, any>({
        path: `/api/v1/KnowledgePublication/GetQuestionPublication`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém uma Publicação do Tipo 'Resposta'.
     *
     * @tags KnowledgePublication
     * @name GetAnswerPublication
     * @request POST:/api/v1/KnowledgePublication/GetAnswerPublication
     * @secure
     * @response `200` `GetAnswerPublicationDto` OK
     */
    getAnswerPublication: (
      data: GetAnswerPublicationPayload,
      params: RequestParams = {},
    ) =>
      this.request<GetAnswerPublicationDto, any>({
        path: `/api/v1/KnowledgePublication/GetAnswerPublication`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém uma Publicação do Tipo 'Lista'.
     *
     * @tags KnowledgePublication
     * @name GetListPublication
     * @request POST:/api/v1/KnowledgePublication/GetListPublication
     * @secure
     * @response `200` `GetListPublicationDto` OK
     */
    getListPublication: (
      data: GetListPublicationPayload,
      params: RequestParams = {},
    ) =>
      this.request<GetListPublicationDto, any>({
        path: `/api/v1/KnowledgePublication/GetListPublication`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém a Sequencia de Publicações de uma Thread.
     *
     * @tags KnowledgePublication
     * @name GetPublicationThreadSequence
     * @request POST:/api/v1/KnowledgePublication/GetPublicationThreadSequence
     * @secure
     * @response `200` `(GetPublicationThreadSequenceResponse)[]` OK
     */
    getPublicationThreadSequence: (
      data: GetPublicationThreadSequencePayload,
      params: RequestParams = {},
    ) =>
      this.request<GetPublicationThreadSequenceResponse[], any>({
        path: `/api/v1/KnowledgePublication/GetPublicationThreadSequence`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém os items de um lista para ordenação.
     *
     * @tags KnowledgePublication
     * @name GetListPublicationItemsDisplayOrder
     * @request POST:/api/v1/KnowledgePublication/GetListPublicationItemsDisplayOrder
     * @secure
     * @response `200` `(GetListPublicationItemsDisplayOrderResponse)[]` OK
     */
    getListPublicationItemsDisplayOrder: (
      data: GetListPublicationItemsDisplayOrderPayload,
      params: RequestParams = {},
    ) =>
      this.request<GetListPublicationItemsDisplayOrderResponse[], any>({
        path: `/api/v1/KnowledgePublication/GetListPublicationItemsDisplayOrder`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém a lista da publicação para visualização em modo de reprodução.
     *
     * @tags KnowledgePublication
     * @name GetListPublicationInPlayback
     * @request POST:/api/v1/KnowledgePublication/GetListPublicationInPlayback
     * @secure
     * @response `200` `GetListPublicationInPlaybackResponse` OK
     */
    getListPublicationInPlayback: (
      data: GetListPublicationInPlaybackPayload,
      params: RequestParams = {},
    ) =>
      this.request<GetListPublicationInPlaybackResponse, any>({
        path: `/api/v1/KnowledgePublication/GetListPublicationInPlayback`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtem as permissões utilizadas na visualização de listas
     *
     * @tags KnowledgePublication
     * @name GetListPermissions
     * @request POST:/api/v1/KnowledgePublication/GetListPermissions
     * @secure
     * @response `200` `GetListPermissionsResponse` OK
     */
    getListPermissions: (
      data: GetListPermissionsPayload,
      params: RequestParams = {},
    ) =>
      this.request<GetListPermissionsResponse, any>({
        path: `/api/v1/KnowledgePublication/GetListPermissions`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém uma lista de rótulos disponíveis.
     *
     * @tags KnowledgePublication
     * @name AvailableStickers
     * @request GET:/api/v1/KnowledgePublication/AvailableStickers
     * @secure
     * @response `200` `(AvailableStickersQueryResponse)[]` OK
     */
    availableStickers: (params: RequestParams = {}) =>
      this.request<AvailableStickersQueryResponse[], any>({
        path: `/api/v1/KnowledgePublication/AvailableStickers`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Obtém os relacionamentos da publicação.
     *
     * @tags KnowledgePublication
     * @name GetRelationships
     * @request POST:/api/v1/KnowledgePublication/GetRelationships
     * @secure
     * @response `200` `(GetRelationshipPublicationResponse)[]` OK
     */
    getRelationships: (
      data: GetRelationshipsPayload,
      params: RequestParams = {},
    ) =>
      this.request<GetRelationshipPublicationResponse[], any>({
        path: `/api/v1/KnowledgePublication/GetRelationships`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém o thumbnail da publicação.
     *
     * @tags KnowledgePublication
     * @name GetThumbnailPublication
     * @request POST:/api/v1/KnowledgePublication/GetThumbnailPublication
     * @secure
     * @response `200` `ThumbnailPublicationResponse` OK
     */
    getThumbnailPublication: (
      data: GetThumbnailPublicationPayload,
      params: RequestParams = {},
    ) =>
      this.request<ThumbnailPublicationResponse, any>({
        path: `/api/v1/KnowledgePublication/GetThumbnailPublication`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém solicitação de desbloqueio.
     *
     * @tags KnowledgePublication
     * @name GetUnblockRequest
     * @request POST:/api/v1/KnowledgePublication/GetUnblockRequest
     * @secure
     * @response `200` `GetUnblockRequestPublicationResponse` OK (May return null)
     * @response `204` `any` No Content
     */
    getUnblockRequest: (
      data: GetUnblockRequestPayload,
      params: RequestParams = {},
    ) =>
      this.request<GetUnblockRequestPublicationResponse, any>({
        path: `/api/v1/KnowledgePublication/GetUnblockRequest`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém uma lista de usuários que curtiram a publicação.
     *
     * @tags KnowledgePublication
     * @name GetWhoLikes
     * @request POST:/api/v1/KnowledgePublication/GetWhoLikes
     * @secure
     * @response `200` `UserItemDtoPaginatedList` OK
     */
    getWhoLikes: (data: GetWhoLikesPayload, params: RequestParams = {}) =>
      this.request<UserItemDtoPaginatedList, any>({
        path: `/api/v1/KnowledgePublication/GetWhoLikes`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém lista de usuários que responderam enquete.
     *
     * @tags KnowledgePublication
     * @name GetWhoAnsweredPoll
     * @request POST:/api/v1/KnowledgePublication/GetWhoAnsweredPoll
     * @secure
     * @response `200` `UserItemDtoPaginatedList` OK
     */
    getWhoAnsweredPoll: (
      data: GetWhoAnsweredPollPayload,
      params: RequestParams = {},
    ) =>
      this.request<UserItemDtoPaginatedList, any>({
        path: `/api/v1/KnowledgePublication/GetWhoAnsweredPoll`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém uma lista de usuários que visualizaram a publicação.
     *
     * @tags KnowledgePublication
     * @name GetWhoView
     * @request POST:/api/v1/KnowledgePublication/GetWhoView
     * @secure
     * @response `200` `UserItemDtoPaginatedList` OK
     */
    getWhoView: (data: GetWhoViewPayload, params: RequestParams = {}) =>
      this.request<UserItemDtoPaginatedList, any>({
        path: `/api/v1/KnowledgePublication/GetWhoView`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém listas que pertencem ao usuário e listas onde usuário é um colaborador.
     *
     * @tags KnowledgePublication
     * @name GetUserLists
     * @request POST:/api/v1/KnowledgePublication/GetUserLists
     * @secure
     * @response `200` `GetUserListsResponsePaginatedList` OK
     */
    getUserLists: (data: GetUserListsPayload, params: RequestParams = {}) =>
      this.request<GetUserListsResponsePaginatedList, any>({
        path: `/api/v1/KnowledgePublication/GetUserLists`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém lista de publicações relacionadas.
     *
     * @tags KnowledgePublication
     * @name GetRelatedPublications
     * @request POST:/api/v1/KnowledgePublication/GetRelatedPublications
     * @secure
     * @response `200` `(GetRelatedPublicationsResponse)[]` OK
     */
    getRelatedPublications: (
      data: GetRelatedPublicationsPayload,
      params: RequestParams = {},
    ) =>
      this.request<GetRelatedPublicationsResponse[], any>({
        path: `/api/v1/KnowledgePublication/GetRelatedPublications`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém uma lista de "pessoas interessadas" na publicação.
     *
     * @tags KnowledgePublication
     * @name GetPeopleInterested
     * @request POST:/api/v1/KnowledgePublication/GetPeopleInterested
     * @secure
     * @response `200` `(GetPeopleInterestedResponse)[]` OK
     */
    getPeopleInterested: (
      data: GetPeopleInterestedPayload,
      params: RequestParams = {},
    ) =>
      this.request<GetPeopleInterestedResponse[], any>({
        path: `/api/v1/KnowledgePublication/GetPeopleInterested`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém lista de usuários seguidores da publicação.
     *
     * @tags KnowledgePublication
     * @name GetPublicationFollowers
     * @request POST:/api/v1/KnowledgePublication/GetPublicationFollowers
     * @secure
     * @response `200` `UserItemDtoPaginatedList` OK
     */
    getPublicationFollowers: (
      data: GetPublicationFollowersPayload,
      params: RequestParams = {},
    ) =>
      this.request<UserItemDtoPaginatedList, any>({
        path: `/api/v1/KnowledgePublication/GetPublicationFollowers`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém uma lista de tópicos que contém "pessoas interessadas" na publicação.
     *
     * @tags KnowledgePublication
     * @name GetTopicPeopleInterested
     * @request POST:/api/v1/KnowledgePublication/GetTopicPeopleInterested
     * @secure
     * @response `200` `(GetTopicPeopleInterestedResponse)[]` OK
     */
    getTopicPeopleInterested: (
      data: GetTopicPeopleInterestedPayload,
      params: RequestParams = {},
    ) =>
      this.request<GetTopicPeopleInterestedResponse[], any>({
        path: `/api/v1/KnowledgePublication/GetTopicPeopleInterested`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém o conteúdo da publicação.
     *
     * @tags KnowledgePublication
     * @name GetContent
     * @request POST:/api/v1/KnowledgePublication/GetContent
     * @secure
     * @response `200` `string` OK (May return null)
     * @response `204` `any` No Content
     */
    getContent: (data: GetContentPayload, params: RequestParams = {}) =>
      this.request<string, any>({
        path: `/api/v1/KnowledgePublication/GetContent`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Carrega o conteúdo de um comentário da publicação.
     *
     * @tags KnowledgePublication
     * @name GetCommentContent
     * @request POST:/api/v1/KnowledgePublication/GetCommentContent
     * @secure
     * @response `200` `string` OK (May return null)
     * @response `204` `any` No Content
     */
    getCommentContent: (
      data: GetCommentContentPayload,
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/api/v1/KnowledgePublication/GetCommentContent`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém os vídeos de uma Publicação que são elegíveis a criação de SHORTS.
     *
     * @tags KnowledgePublication
     * @name GetPublicationShortVideos
     * @request POST:/api/v1/KnowledgePublication/GetPublicationShortVideos
     * @secure
     * @response `200` `(ShortVideoDto)[]` OK
     */
    getPublicationShortVideos: (
      data: GetPublicationShortVideosPayload,
      params: RequestParams = {},
    ) =>
      this.request<ShortVideoDto[], any>({
        path: `/api/v1/KnowledgePublication/GetPublicationShortVideos`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém a transcrição (legenda) de um Anexo da Publicação.
     *
     * @tags KnowledgePublication
     * @name GetAttachTranscription
     * @request POST:/api/v1/KnowledgePublication/GetAttachTranscription
     * @secure
     * @response `200` `(SubtitleItemDto)[]` OK
     */
    getAttachTranscription: (
      data: GetAttachTranscriptionPayload,
      params: RequestParams = {},
    ) =>
      this.request<SubtitleItemDto[], any>({
        path: `/api/v1/KnowledgePublication/GetAttachTranscription`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém a definição do arquivo associado ao Anexo da Publicação.
     *
     * @tags KnowledgePublication
     * @name GetAttachFile
     * @request POST:/api/v1/KnowledgePublication/GetAttachFile
     * @secure
     * @response `200` `FileGetDto` OK
     */
    getAttachFile: (
      query?: {
        /** @format uuid */
        attachId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<FileGetDto, any>({
        path: `/api/v1/KnowledgePublication/GetAttachFile`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Obtém resposta de denúncia reportada.
     *
     * @tags KnowledgePublication
     * @name ReportAnalysedInfo
     * @request POST:/api/v1/KnowledgePublication/ReportAnalysedInfo
     * @secure
     * @response `200` `PublicationReportAnalysedInfoResponse` OK
     */
    reportAnalysedInfo: (
      data: ReportAnalysedInfoPayload,
      params: RequestParams = {},
    ) =>
      this.request<PublicationReportAnalysedInfoResponse, any>({
        path: `/api/v1/KnowledgePublication/ReportAnalysedInfo`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Atualiza o Poster do Vídeo em API.VIDEO.
     *
     * @tags KnowledgePublication
     * @name UpdateMediaPoster
     * @request POST:/api/v1/KnowledgePublication/UpdateMediaPoster
     * @secure
     * @response `200` `boolean` OK
     */
    updateMediaPoster: (
      data: UpdateMediaPosterPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/KnowledgePublication/UpdateMediaPoster`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags KnowledgePublication
     * @name ExportAttachTranscription
     * @request GET:/api/v1/KnowledgePublication/ExportAttachTranscription
     * @secure
     * @response `200` `any` OK
     */
    exportAttachTranscription: (
      query?: {
        /** @format uuid */
        attachId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<any, any>({
        path: `/api/v1/KnowledgePublication/ExportAttachTranscription`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags KnowledgePublication
     * @name DownloadOriginalMedia
     * @request GET:/api/v1/KnowledgePublication/DownloadOriginalMedia
     * @secure
     * @response `200` `any` OK
     */
    downloadOriginalMedia: (
      query?: {
        /** @format uuid */
        attachId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<any, any>({
        path: `/api/v1/KnowledgePublication/DownloadOriginalMedia`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * Executa uma pesquisa utilizando RAG (Retrieval-Augmented Generation) para obter respostas baseadas em transcrições de audio/video.
     *
     * @tags KnowledgePublication
     * @name PublicationRagSearch
     * @request POST:/api/v1/KnowledgePublication/PublicationRagSearch
     * @secure
     * @response `200` `PublicationContextualRAGResponse` OK
     */
    publicationRagSearch: (
      data: PublicationRagSearchPayload,
      params: RequestParams = {},
    ) =>
      this.request<PublicationContextualRAGResponse, any>({
        path: `/api/v1/KnowledgePublication/PublicationRagSearch`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém as informações de classificação de uma postagem.
     *
     * @tags KnowledgePublication
     * @name GetPostClassifyPublication
     * @request POST:/api/v1/KnowledgePublication/GetPostClassifyPublication
     * @secure
     * @response `200` `GetPostClassifyPublicationDto` OK
     */
    getPostClassifyPublication: (
      data: GetPostClassifyPublicationPayload,
      params: RequestParams = {},
    ) =>
      this.request<GetPostClassifyPublicationDto, any>({
        path: `/api/v1/KnowledgePublication/GetPostClassifyPublication`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém as informações de classificação de uma enquete.
     *
     * @tags KnowledgePublication
     * @name GetPollClassifyPublication
     * @request POST:/api/v1/KnowledgePublication/GetPollClassifyPublication
     * @secure
     * @response `200` `GetPollClassifyPublicationDto` OK
     */
    getPollClassifyPublication: (
      data: GetPollClassifyPublicationPayload,
      params: RequestParams = {},
    ) =>
      this.request<GetPollClassifyPublicationDto, any>({
        path: `/api/v1/KnowledgePublication/GetPollClassifyPublication`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém as informações de classificação de uma lista.
     *
     * @tags KnowledgePublication
     * @name GetListClassifyPublication
     * @request POST:/api/v1/KnowledgePublication/GetListClassifyPublication
     * @secure
     * @response `200` `GetListClassifyPublicationDto` OK
     */
    getListClassifyPublication: (
      data: GetListClassifyPublicationPayload,
      params: RequestParams = {},
    ) =>
      this.request<GetListClassifyPublicationDto, any>({
        path: `/api/v1/KnowledgePublication/GetListClassifyPublication`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém as informações de classificação de uma pergunta.
     *
     * @tags KnowledgePublication
     * @name GetQuestionClassifyPublication
     * @request POST:/api/v1/KnowledgePublication/GetQuestionClassifyPublication
     * @secure
     * @response `200` `GetQuestionClassifyPublicationDto` OK
     */
    getQuestionClassifyPublication: (
      data: GetQuestionClassifyPublicationPayload,
      params: RequestParams = {},
    ) =>
      this.request<GetQuestionClassifyPublicationDto, any>({
        path: `/api/v1/KnowledgePublication/GetQuestionClassifyPublication`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Cria ou Atualiza uma Publicação do Tipo 'Postagem'.
     *
     * @tags KnowledgePublication
     * @name CreateOrUpdatePostPublication
     * @request POST:/api/v1/KnowledgePublication/CreateOrUpdatePostPublication
     * @secure
     * @response `200` `SavePublicationResultDto` OK
     */
    createOrUpdatePostPublication: (
      data: CreateOrUpdatePostPublicationPayload,
      params: RequestParams = {},
    ) =>
      this.request<SavePublicationResultDto, any>({
        path: `/api/v1/KnowledgePublication/CreateOrUpdatePostPublication`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Cria ou Atualiza uma Publicação do Tipo 'Postagem' em modo 'Thread'.
     *
     * @tags KnowledgePublication
     * @name CreateOrUpdatePostThreadPublication
     * @request POST:/api/v1/KnowledgePublication/CreateOrUpdatePostThreadPublication
     * @secure
     * @response `200` `SavePublicationResultDto` OK
     */
    createOrUpdatePostThreadPublication: (
      data: CreateOrUpdatePostThreadPublicationPayload,
      params: RequestParams = {},
    ) =>
      this.request<SavePublicationResultDto, any>({
        path: `/api/v1/KnowledgePublication/CreateOrUpdatePostThreadPublication`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Cria ou Atualiza uma Publicação do Tipo 'Postagem' para uma lista.
     *
     * @tags KnowledgePublication
     * @name CreateOrUpdatePostListExclusivePublication
     * @request POST:/api/v1/KnowledgePublication/CreateOrUpdatePostListExclusivePublication
     * @secure
     * @response `200` `SavePublicationResultDto` OK
     */
    createOrUpdatePostListExclusivePublication: (
      data: CreateOrUpdatePostListExclusivePublicationPayload,
      params: RequestParams = {},
    ) =>
      this.request<SavePublicationResultDto, any>({
        path: `/api/v1/KnowledgePublication/CreateOrUpdatePostListExclusivePublication`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Cria ou Atualiza uma Publicação do Tipo 'Fichário'.
     *
     * @tags KnowledgePublication
     * @name CreateOrUpdateBinderPublication
     * @request POST:/api/v1/KnowledgePublication/CreateOrUpdateBinderPublication
     * @secure
     * @response `200` `SavePublicationResultDto` OK
     */
    createOrUpdateBinderPublication: (
      data: CreateOrUpdateBinderPublicationPayload,
      params: RequestParams = {},
    ) =>
      this.request<SavePublicationResultDto, any>({
        path: `/api/v1/KnowledgePublication/CreateOrUpdateBinderPublication`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Cria ou Atualiza uma Publicação do Tipo 'Enquete'.
     *
     * @tags KnowledgePublication
     * @name CreateOrUpdatePollPublication
     * @request POST:/api/v1/KnowledgePublication/CreateOrUpdatePollPublication
     * @secure
     * @response `200` `SavePublicationResultDto` OK
     */
    createOrUpdatePollPublication: (
      data: CreateOrUpdatePollPublicationPayload,
      params: RequestParams = {},
    ) =>
      this.request<SavePublicationResultDto, any>({
        path: `/api/v1/KnowledgePublication/CreateOrUpdatePollPublication`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Cria ou Atualiza uma Publicação do Tipo 'Enquete' em modo 'Thread'.
     *
     * @tags KnowledgePublication
     * @name CreateOrUpdatePollThreadPublication
     * @request POST:/api/v1/KnowledgePublication/CreateOrUpdatePollThreadPublication
     * @secure
     * @response `200` `SavePublicationResultDto` OK
     */
    createOrUpdatePollThreadPublication: (
      data: CreateOrUpdatePollThreadPublicationPayload,
      params: RequestParams = {},
    ) =>
      this.request<SavePublicationResultDto, any>({
        path: `/api/v1/KnowledgePublication/CreateOrUpdatePollThreadPublication`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Adiciona uma Resposta à Enquete.
     *
     * @tags KnowledgePublication
     * @name AddPollAnswerCommand
     * @request POST:/api/v1/KnowledgePublication/AddPollAnswerCommand
     * @secure
     * @response `200` `FeedPollResults` OK (May return null)
     * @response `204` `any` No Content
     */
    addPollAnswerCommand: (
      data: AddPollAnswerCommandPayload,
      params: RequestParams = {},
    ) =>
      this.request<FeedPollResults, any>({
        path: `/api/v1/KnowledgePublication/AddPollAnswerCommand`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Cria ou Atualiza uma Publicação do Tipo 'Pergunta'.
     *
     * @tags KnowledgePublication
     * @name CreateOrUpdateQuestionPublication
     * @request POST:/api/v1/KnowledgePublication/CreateOrUpdateQuestionPublication
     * @secure
     * @response `200` `SavePublicationResultDto` OK
     */
    createOrUpdateQuestionPublication: (
      data: CreateOrUpdateQuestionPublicationPayload,
      params: RequestParams = {},
    ) =>
      this.request<SavePublicationResultDto, any>({
        path: `/api/v1/KnowledgePublication/CreateOrUpdateQuestionPublication`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Cria ou Atualiza uma Publicação do Tipo 'Resposta'.
     *
     * @tags KnowledgePublication
     * @name CreateOrUpdateAnswerPublication
     * @request POST:/api/v1/KnowledgePublication/CreateOrUpdateAnswerPublication
     * @secure
     * @response `200` `SavePublicationResultDto` OK
     */
    createOrUpdateAnswerPublication: (
      data: CreateOrUpdateAnswerPublicationPayload,
      params: RequestParams = {},
    ) =>
      this.request<SavePublicationResultDto, any>({
        path: `/api/v1/KnowledgePublication/CreateOrUpdateAnswerPublication`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Cria ou Atualiza uma Publicação do Tipo 'Lista'.
     *
     * @tags KnowledgePublication
     * @name CreateOrUpdateListPublication
     * @request POST:/api/v1/KnowledgePublication/CreateOrUpdateListPublication
     * @secure
     * @response `200` `SavePublicationResultDto` OK
     */
    createOrUpdateListPublication: (
      data: CreateOrUpdateListPublicationPayload,
      params: RequestParams = {},
    ) =>
      this.request<SavePublicationResultDto, any>({
        path: `/api/v1/KnowledgePublication/CreateOrUpdateListPublication`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Adiciona uma Publicação a uma Lista.
     *
     * @tags KnowledgePublication
     * @name AddListItem
     * @request POST:/api/v1/KnowledgePublication/AddListItem
     * @secure
     * @response `200` `FeedItemDto` OK (May return null)
     * @response `204` `any` No Content
     */
    addListItem: (data: AddListItemPayload, params: RequestParams = {}) =>
      this.request<FeedItemDto, any>({
        path: `/api/v1/KnowledgePublication/AddListItem`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Remove uma Publicação de uma Lista.
     *
     * @tags KnowledgePublication
     * @name RemoveListItem
     * @request POST:/api/v1/KnowledgePublication/RemoveListItem
     * @secure
     * @response `200` `FavoriteActionResult` OK
     */
    removeListItem: (data: RemoveListItemPayload, params: RequestParams = {}) =>
      this.request<FavoriteActionResult, any>({
        path: `/api/v1/KnowledgePublication/RemoveListItem`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Remove todos os itens de uma lista
     *
     * @tags KnowledgePublication
     * @name ClearListItems
     * @request POST:/api/v1/KnowledgePublication/ClearListItems
     * @secure
     * @response `200` `boolean` OK
     */
    clearListItems: (data: ClearListItemsPayload, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/api/v1/KnowledgePublication/ClearListItems`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Remove uma Publicação de uma Lista.
     *
     * @tags KnowledgePublication
     * @name ReorderListItems
     * @request POST:/api/v1/KnowledgePublication/ReorderListItems
     * @secure
     * @response `200` `boolean` OK
     */
    reorderListItems: (
      data: ReorderListItemsPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/KnowledgePublication/ReorderListItems`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Altera a sequencia de exibição das publicações em Thread.
     *
     * @tags KnowledgePublication
     * @name ThreadReorder
     * @request POST:/api/v1/KnowledgePublication/ThreadReorder
     * @secure
     * @response `200` `boolean` OK
     */
    threadReorder: (data: ThreadReorderPayload, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/api/v1/KnowledgePublication/ThreadReorder`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Remove uma publicação.
     *
     * @tags KnowledgePublication
     * @name DeletePublication
     * @request POST:/api/v1/KnowledgePublication/DeletePublication
     * @secure
     * @response `200` `boolean` OK
     */
    deletePublication: (
      data: DeletePublicationPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/KnowledgePublication/DeletePublication`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Adiciona relato de abuso ou erro.
     *
     * @tags KnowledgePublication
     * @name AddAbuseReport
     * @request POST:/api/v1/KnowledgePublication/AddAbuseReport
     * @secure
     * @response `200` `boolean` OK
     */
    addAbuseReport: (data: AddAbuseReportPayload, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/api/v1/KnowledgePublication/AddAbuseReport`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * AdicioRelaciona uma publicação à publicação.
     *
     * @tags KnowledgePublication
     * @name AddRelationshipPublication
     * @request POST:/api/v1/KnowledgePublication/AddRelationshipPublication
     * @secure
     * @response `200` `boolean` OK
     */
    addRelationshipPublication: (
      data: AddRelationshipPublicationPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/KnowledgePublication/AddRelationshipPublication`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Remove uma publicação relacionada.
     *
     * @tags KnowledgePublication
     * @name RemoveRelationshipPublication
     * @request POST:/api/v1/KnowledgePublication/RemoveRelationshipPublication
     * @secure
     * @response `200` `boolean` OK
     */
    removeRelationshipPublication: (
      data: RemoveRelationshipPublicationPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/KnowledgePublication/RemoveRelationshipPublication`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Relaciona um treinamento à Publicação.
     *
     * @tags KnowledgePublication
     * @name AddRelationshipTraining
     * @request POST:/api/v1/KnowledgePublication/AddRelationshipTraining
     * @secure
     * @response `200` `boolean` OK
     */
    addRelationshipTraining: (
      data: AddRelationshipTrainingPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/KnowledgePublication/AddRelationshipTraining`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Remove um treinamento relacionado.
     *
     * @tags KnowledgePublication
     * @name RemoveRelationshipTraining
     * @request POST:/api/v1/KnowledgePublication/RemoveRelationshipTraining
     * @secure
     * @response `200` `boolean` OK
     */
    removeRelationshipTraining: (
      data: RemoveRelationshipTrainingPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/KnowledgePublication/RemoveRelationshipTraining`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Bloqueia uma publicação.
     *
     * @tags KnowledgePublication
     * @name BlockPublication
     * @request POST:/api/v1/KnowledgePublication/BlockPublication
     * @secure
     * @response `200` `boolean` OK
     */
    blockPublication: (
      data: BlockPublicationPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/KnowledgePublication/BlockPublication`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Desbloqueia uma publicação.
     *
     * @tags KnowledgePublication
     * @name UnblockPublication
     * @request POST:/api/v1/KnowledgePublication/UnblockPublication
     * @secure
     * @response `200` `boolean` OK
     */
    unblockPublication: (
      data: UnblockPublicationPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/KnowledgePublication/UnblockPublication`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Atualiza a thumbnail customizado da publicação
     *
     * @tags KnowledgePublication
     * @name UpdateThumbnailPublication
     * @request POST:/api/v1/KnowledgePublication/UpdateThumbnailPublication
     * @secure
     * @response `200` `boolean` OK
     */
    updateThumbnailPublication: (
      data: UpdateThumbnailPublicationPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/KnowledgePublication/UpdateThumbnailPublication`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Registra solicitação de desbloqueio de uma publicação.
     *
     * @tags KnowledgePublication
     * @name RequestUnblock
     * @request POST:/api/v1/KnowledgePublication/RequestUnblock
     * @secure
     * @response `200` `boolean` OK
     */
    requestUnblock: (data: RequestUnblockPayload, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/api/v1/KnowledgePublication/RequestUnblock`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Cria recomendação de publicação a usuários ou grupos.
     *
     * @tags KnowledgePublication
     * @name AddRecommendation
     * @request POST:/api/v1/KnowledgePublication/AddRecommendation
     * @secure
     * @response `200` `boolean` OK
     */
    addRecommendation: (
      data: AddRecommendationPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/KnowledgePublication/AddRecommendation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Compartilha uma publicaçao.
     *
     * @tags KnowledgePublication
     * @name Share
     * @request POST:/api/v1/KnowledgePublication/Share
     * @secure
     * @response `200` `boolean` OK
     */
    share: (data: SharePayload, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/api/v1/KnowledgePublication/Share`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Marca publicação como "escondida".
     *
     * @tags KnowledgePublication
     * @name HidePublication
     * @request POST:/api/v1/KnowledgePublication/HidePublication
     * @secure
     * @response `200` `boolean` OK
     */
    hidePublication: (
      data: HidePublicationPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/KnowledgePublication/HidePublication`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Cria uma lista privada.
     *
     * @tags KnowledgePublication
     * @name CreatePrivateList
     * @request POST:/api/v1/KnowledgePublication/CreatePrivateList
     * @secure
     * @response `200` `SavePublicationResultDto` OK
     */
    createPrivateList: (
      data: CreatePrivateListPayload,
      params: RequestParams = {},
    ) =>
      this.request<SavePublicationResultDto, any>({
        path: `/api/v1/KnowledgePublication/CreatePrivateList`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Adiciona publicação a lista do usuário 'Favoritos'.
     *
     * @tags KnowledgePublication
     * @name AddToListFavorites
     * @request POST:/api/v1/KnowledgePublication/AddToListFavorites
     * @secure
     * @response `200` `FavoriteActionResult` OK
     */
    addToListFavorites: (
      data: AddToListFavoritesPayload,
      params: RequestParams = {},
    ) =>
      this.request<FavoriteActionResult, any>({
        path: `/api/v1/KnowledgePublication/AddToListFavorites`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Adiciona publicação a lista do usuário 'Ver Mais Tarde'.
     *
     * @tags KnowledgePublication
     * @name AddToListSeeLater
     * @request POST:/api/v1/KnowledgePublication/AddToListSeeLater
     * @secure
     * @response `200` `FavoriteActionResult` OK
     */
    addToListSeeLater: (
      data: AddToListSeeLaterPayload,
      params: RequestParams = {},
    ) =>
      this.request<FavoriteActionResult, any>({
        path: `/api/v1/KnowledgePublication/AddToListSeeLater`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Remove uma Publicação de todas as Listas do Usuários.
     *
     * @tags KnowledgePublication
     * @name RemoveItemFromLists
     * @request POST:/api/v1/KnowledgePublication/RemoveItemFromLists
     * @secure
     * @response `200` `boolean` OK
     */
    removeItemFromLists: (
      data: RemoveItemFromListsPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/KnowledgePublication/RemoveItemFromLists`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Registra o TRACKING de um Vídeo da Publicação.
     *
     * @tags KnowledgePublication
     * @name TrackMedia
     * @request POST:/api/v1/KnowledgePublication/TrackMedia
     * @secure
     * @response `200` `TrackMediaResponse` OK
     */
    trackMedia: (data: TrackMediaPayload, params: RequestParams = {}) =>
      this.request<TrackMediaResponse, any>({
        path: `/api/v1/KnowledgePublication/TrackMedia`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Cria lote de publicação para processamento.
     *
     * @tags KnowledgePublication
     * @name CreateBatchPublication
     * @request POST:/api/v1/KnowledgePublication/CreateBatchPublication
     * @secure
     * @response `200` `string` OK
     */
    createBatchPublication: (
      data: CreateBatchPublicationPayload,
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/api/v1/KnowledgePublication/CreateBatchPublication`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Atualiza a classificação de uma postagem.
     *
     * @tags KnowledgePublication
     * @name UpdatePostClassifyPublication
     * @request POST:/api/v1/KnowledgePublication/UpdatePostClassifyPublication
     * @secure
     * @response `200` `boolean` OK
     */
    updatePostClassifyPublication: (
      data: UpdatePostClassifyPublicationPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/KnowledgePublication/UpdatePostClassifyPublication`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Atualiza a classificação de uma enquete.
     *
     * @tags KnowledgePublication
     * @name UpdatePollClassifyPublication
     * @request POST:/api/v1/KnowledgePublication/UpdatePollClassifyPublication
     * @secure
     * @response `200` `boolean` OK
     */
    updatePollClassifyPublication: (
      data: UpdatePollClassifyPublicationPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/KnowledgePublication/UpdatePollClassifyPublication`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Atualiza a classificação de uma lista.
     *
     * @tags KnowledgePublication
     * @name UpdateListClassifyPublication
     * @request POST:/api/v1/KnowledgePublication/UpdateListClassifyPublication
     * @secure
     * @response `200` `boolean` OK
     */
    updateListClassifyPublication: (
      data: UpdateListClassifyPublicationPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/KnowledgePublication/UpdateListClassifyPublication`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Atualiza a classificação de uma pergunta.
     *
     * @tags KnowledgePublication
     * @name UpdateQuestionClassifyPublication
     * @request POST:/api/v1/KnowledgePublication/UpdateQuestionClassifyPublication
     * @secure
     * @response `200` `boolean` OK
     */
    updateQuestionClassifyPublication: (
      data: UpdateQuestionClassifyPublicationPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/KnowledgePublication/UpdateQuestionClassifyPublication`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Repassa um pergunta para um usuáro.
     *
     * @tags KnowledgePublication
     * @name RepassQuestion
     * @request POST:/api/v1/KnowledgePublication/RepassQuestion
     * @secure
     * @response `200` `boolean` OK
     */
    repassQuestion: (data: RepassQuestionPayload, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/api/v1/KnowledgePublication/RepassQuestion`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Limpa itens da lixeira.
     *
     * @tags KnowledgePublication
     * @name ClearTrash
     * @request POST:/api/v1/KnowledgePublication/ClearTrash
     * @secure
     * @response `200` `boolean` OK
     */
    clearTrash: (params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/api/v1/KnowledgePublication/ClearTrash`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Restaura publicação da lixeira.
     *
     * @tags KnowledgePublication
     * @name RestorePublication
     * @request POST:/api/v1/KnowledgePublication/RestorePublication
     * @secure
     * @response `200` `boolean` OK
     */
    restorePublication: (
      data: RestorePublicationPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/KnowledgePublication/RestorePublication`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  knowledgeQuickFilter = {
    /**
     * Cria um filtro rápido customizado
     *
     * @tags KnowledgeQuickFilter
     * @name CreateQuickFilter
     * @request POST:/api/v1/KnowledgeQuickFilter/CreateQuickFilter
     * @secure
     * @response `200` `string` OK
     */
    createQuickFilter: (
      data: CreateQuickFilterPayload,
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/api/v1/KnowledgeQuickFilter/CreateQuickFilter`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Alterar um filtro rápido customizado
     *
     * @tags KnowledgeQuickFilter
     * @name UpdateQuickFilter
     * @request POST:/api/v1/KnowledgeQuickFilter/UpdateQuickFilter
     * @secure
     * @response `200` `boolean` OK
     */
    updateQuickFilter: (
      data: UpdateQuickFilterPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/KnowledgeQuickFilter/UpdateQuickFilter`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Exclui um filtro rápido customizado
     *
     * @tags KnowledgeQuickFilter
     * @name DeleteQuickFilter
     * @request POST:/api/v1/KnowledgeQuickFilter/DeleteQuickFilter
     * @secure
     * @response `200` `boolean` OK
     */
    deleteQuickFilter: (
      data: DeleteQuickFilterPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/KnowledgeQuickFilter/DeleteQuickFilter`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Marca os filtros rápidos como selecionado.
     *
     * @tags KnowledgeQuickFilter
     * @name SelectQuickFilters
     * @request POST:/api/v1/KnowledgeQuickFilter/SelectQuickFilters
     * @secure
     * @response `200` `boolean` OK
     */
    selectQuickFilters: (
      data: SelectQuickFiltersPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/KnowledgeQuickFilter/SelectQuickFilters`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém a Lista de Filtros Rápidos.
     *
     * @tags KnowledgeQuickFilter
     * @name GetSelectionQuickFilter
     * @request POST:/api/v1/KnowledgeQuickFilter/GetSelectionQuickFilter
     * @secure
     * @response `200` `SelectionQuickFilterResponse` OK
     */
    getSelectionQuickFilter: (
      data: GetSelectionQuickFilterPayload,
      params: RequestParams = {},
    ) =>
      this.request<SelectionQuickFilterResponse, any>({
        path: `/api/v1/KnowledgeQuickFilter/GetSelectionQuickFilter`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém a Lista de Tipos de Filtros Rápidos Customizados
     *
     * @tags KnowledgeQuickFilter
     * @name GetQuickFilterTypes
     * @request POST:/api/v1/KnowledgeQuickFilter/GetQuickFilterTypes
     * @secure
     * @response `200` `(ManagedQuickFilterTypeListResponse)[]` OK
     */
    getQuickFilterTypes: (
      data: GetQuickFilterTypesPayload,
      params: RequestParams = {},
    ) =>
      this.request<ManagedQuickFilterTypeListResponse[], any>({
        path: `/api/v1/KnowledgeQuickFilter/GetQuickFilterTypes`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém uma lista de filtros rápidos customizados.
     *
     * @tags KnowledgeQuickFilter
     * @name ManagedQuickFilter
     * @request POST:/api/v1/KnowledgeQuickFilter/ManagedQuickFilter
     * @secure
     * @response `200` `ManagedQuickFiltersListResponsePaginatedList` OK
     */
    managedQuickFilter: (
      data: ManagedQuickFilterPayload,
      params: RequestParams = {},
    ) =>
      this.request<ManagedQuickFiltersListResponsePaginatedList, any>({
        path: `/api/v1/KnowledgeQuickFilter/ManagedQuickFilter`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém as informações principais do Filtro Rápido.
     *
     * @tags KnowledgeQuickFilter
     * @name GetQuickFilter
     * @request POST:/api/v1/KnowledgeQuickFilter/GetQuickFilter
     * @secure
     * @response `200` `ManagedQuickFilterResponse` OK (May return null)
     * @response `204` `any` No Content
     */
    getQuickFilter: (data: GetQuickFilterPayload, params: RequestParams = {}) =>
      this.request<ManagedQuickFilterResponse, any>({
        path: `/api/v1/KnowledgeQuickFilter/GetQuickFilter`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  knowledgeSelectors = {
    /**
     * Papéis de canal.
     *
     * @tags KnowledgeSelectors
     * @name ChannelRoles
     * @request POST:/api/v1/KnowledgeSelectors/ChannelRoles
     * @secure
     * @response `200` `(ChannelRolesSelectorResponse)[]` OK
     */
    channelRoles: (params: RequestParams = {}) =>
      this.request<ChannelRolesSelectorResponse[], any>({
        path: `/api/v1/KnowledgeSelectors/ChannelRoles`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Canais.
     *
     * @tags KnowledgeSelectors
     * @name Channels
     * @request POST:/api/v1/KnowledgeSelectors/Channels
     * @secure
     * @response `200` `ChannelSelectorResponsePaginatedList` OK
     */
    channels: (data: ChannelsPayload, params: RequestParams = {}) =>
      this.request<ChannelSelectorResponsePaginatedList, any>({
        path: `/api/v1/KnowledgeSelectors/Channels`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Publicações.
     *
     * @tags KnowledgeSelectors
     * @name Publications
     * @request POST:/api/v1/KnowledgeSelectors/Publications
     * @secure
     * @response `200` `PublicationSelectorDtoPaginatedList` OK
     */
    publications: (data: PublicationsBody, params: RequestParams = {}) =>
      this.request<PublicationSelectorDtoPaginatedList, any>({
        path: `/api/v1/KnowledgeSelectors/Publications`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Tipos de relatos.
     *
     * @tags KnowledgeSelectors
     * @name ReportTypes
     * @request GET:/api/v1/KnowledgeSelectors/ReportTypes
     * @secure
     * @response `200` `(ReportTypesSelectorResponse)[]` OK
     */
    reportTypes: (params: RequestParams = {}) =>
      this.request<ReportTypesSelectorResponse[], any>({
        path: `/api/v1/KnowledgeSelectors/ReportTypes`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  knowledgeSettings = {
    /**
     * Obtém a lista de Callout's dos Feeds.
     *
     * @tags KnowledgeSettings
     * @name GetKnowledgeCallouts
     * @request POST:/api/v1/KnowledgeSettings/GetKnowledgeCallouts
     * @secure
     * @response `200` `(CalloutDto)[]` OK
     */
    getKnowledgeCallouts: (params: RequestParams = {}) =>
      this.request<CalloutDto[], any>({
        path: `/api/v1/KnowledgeSettings/GetKnowledgeCallouts`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Obtém Registro de configuração da Personalização do Módulo de Conhecimento.
     *
     * @tags KnowledgeSettings
     * @name GetManagedKnowledgeSettings
     * @request GET:/api/v1/KnowledgeSettings/GetManagedKnowledgeSettings
     * @secure
     * @response `200` `ManagedKnowledgeSettingsResponse` OK
     */
    getManagedKnowledgeSettings: (params: RequestParams = {}) =>
      this.request<ManagedKnowledgeSettingsResponse, any>({
        path: `/api/v1/KnowledgeSettings/GetManagedKnowledgeSettings`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Obtém Registro de configuração da opção de Promover Tópicos e Canais
     *
     * @tags KnowledgeSettings
     * @name GetManagedPromoteSettings
     * @request GET:/api/v1/KnowledgeSettings/GetManagedPromoteSettings
     * @secure
     * @response `200` `ManagePromoteSettingsResponse` OK
     */
    getManagedPromoteSettings: (params: RequestParams = {}) =>
      this.request<ManagePromoteSettingsResponse, any>({
        path: `/api/v1/KnowledgeSettings/GetManagedPromoteSettings`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Obtém as informações para premiações instantâneas.
     *
     * @tags KnowledgeSettings
     * @name GetManagedAwardSettings
     * @request GET:/api/v1/KnowledgeSettings/GetManagedAwardSettings
     * @secure
     * @response `200` `ManagedAwardSettingsQueryResponse` OK
     */
    getManagedAwardSettings: (params: RequestParams = {}) =>
      this.request<ManagedAwardSettingsQueryResponse, any>({
        path: `/api/v1/KnowledgeSettings/GetManagedAwardSettings`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Salva o registro de configuração da Personalização do Módulo de Conhecimento.
     *
     * @tags KnowledgeSettings
     * @name SaveKnowledgeSettings
     * @request POST:/api/v1/KnowledgeSettings/SaveKnowledgeSettings
     * @secure
     * @response `200` `boolean` OK
     */
    saveKnowledgeSettings: (
      data: SaveKnowledgeSettingsPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/KnowledgeSettings/SaveKnowledgeSettings`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Adiciona um tópico nas configurações para promover tópicos
     *
     * @tags KnowledgeSettings
     * @name AddTopicToPromoteSettings
     * @request POST:/api/v1/KnowledgeSettings/AddTopicToPromoteSettings
     * @secure
     * @response `200` `(TopicAutoCompleteHierarchicalModelDto)[]` OK
     */
    addTopicToPromoteSettings: (
      data: AddTopicToPromoteSettingsPayload,
      params: RequestParams = {},
    ) =>
      this.request<TopicAutoCompleteHierarchicalModelDto[], any>({
        path: `/api/v1/KnowledgeSettings/AddTopicToPromoteSettings`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Remove um tópico nas configurações para promover tópicos
     *
     * @tags KnowledgeSettings
     * @name DeleteTopicToPromoteSettings
     * @request POST:/api/v1/KnowledgeSettings/DeleteTopicToPromoteSettings
     * @secure
     * @response `200` `(TopicAutoCompleteHierarchicalModelDto)[]` OK
     */
    deleteTopicToPromoteSettings: (
      data: DeleteTopicToPromoteSettingsPayload,
      params: RequestParams = {},
    ) =>
      this.request<TopicAutoCompleteHierarchicalModelDto[], any>({
        path: `/api/v1/KnowledgeSettings/DeleteTopicToPromoteSettings`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Adiciona um canal nas configurações para promover canais
     *
     * @tags KnowledgeSettings
     * @name AddChannelToPromoteSettings
     * @request POST:/api/v1/KnowledgeSettings/AddChannelToPromoteSettings
     * @secure
     * @response `200` `(AutoCompleteDataModelDto)[]` OK
     */
    addChannelToPromoteSettings: (
      data: AddChannelToPromoteSettingsPayload,
      params: RequestParams = {},
    ) =>
      this.request<AutoCompleteDataModelDto[], any>({
        path: `/api/v1/KnowledgeSettings/AddChannelToPromoteSettings`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Remove um canal nas configurações para promover canais
     *
     * @tags KnowledgeSettings
     * @name DeleteChannelToPromoteSettings
     * @request POST:/api/v1/KnowledgeSettings/DeleteChannelToPromoteSettings
     * @secure
     * @response `200` `(AutoCompleteDataModelDto)[]` OK
     */
    deleteChannelToPromoteSettings: (
      data: DeleteChannelToPromoteSettingsPayload,
      params: RequestParams = {},
    ) =>
      this.request<AutoCompleteDataModelDto[], any>({
        path: `/api/v1/KnowledgeSettings/DeleteChannelToPromoteSettings`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Salva informações de configuração de premiações instantâneas.
     *
     * @tags KnowledgeSettings
     * @name SaveKnowledgeAwardSettings
     * @request POST:/api/v1/KnowledgeSettings/SaveKnowledgeAwardSettings
     * @secure
     * @response `200` `boolean` OK
     */
    saveKnowledgeAwardSettings: (
      data: SaveKnowledgeAwardSettingsPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/KnowledgeSettings/SaveKnowledgeAwardSettings`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  knowledgeShortVideo = {
    /**
     * Obtém uma lista de Videos Curtos que o gestor pode visualizar.
     *
     * @tags KnowledgeShortVideo
     * @name ManagedList
     * @request POST:/api/v1/KnowledgeShortVideo/ManagedList
     * @secure
     * @response `200` `ManagedShortVideoListResponsePaginatedList` OK
     */
    managedList: (data: ManagedListPayload, params: RequestParams = {}) =>
      this.request<ManagedShortVideoListResponsePaginatedList, any>({
        path: `/api/v1/KnowledgeShortVideo/ManagedList`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Verifica se o usuário com permissão KnowledgeChannelsAdmin está visualizando publicações de SHORTS com restrição de Confidencionalidade.
     *
     * @tags KnowledgeShortVideo
     * @name ManagingContainsConfidentialPublication
     * @request POST:/api/v1/KnowledgeShortVideo/ManagingContainsConfidentialPublication
     * @secure
     * @response `200` `boolean` OK
     */
    managingContainsConfidentialPublication: (
      data: ManagingContainsConfidentialPublicationPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/KnowledgeShortVideo/ManagingContainsConfidentialPublication`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém um Vídeo Curto.
     *
     * @tags KnowledgeShortVideo
     * @name GetShortVideo
     * @request POST:/api/v1/KnowledgeShortVideo/GetShortVideo
     * @secure
     * @response `200` `ShortVideoDto` OK
     */
    getShortVideo: (data: GetShortVideoPayload, params: RequestParams = {}) =>
      this.request<ShortVideoDto, any>({
        path: `/api/v1/KnowledgeShortVideo/GetShortVideo`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém uma lista de publicações que possam gerar vídeos curtos.
     *
     * @tags KnowledgeShortVideo
     * @name PublicationSelector
     * @request POST:/api/v1/KnowledgeShortVideo/PublicationSelector
     * @secure
     * @response `200` `PublicationSelectorDtoPaginatedList` OK
     */
    publicationSelector: (
      data: PublicationSelectorPayload,
      params: RequestParams = {},
    ) =>
      this.request<PublicationSelectorDtoPaginatedList, any>({
        path: `/api/v1/KnowledgeShortVideo/PublicationSelector`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Cria ou atualiza um Video Curto.
     *
     * @tags KnowledgeShortVideo
     * @name SaveShortVideo
     * @request POST:/api/v1/KnowledgeShortVideo/SaveShortVideo
     * @secure
     * @response `200` `string | null` OK (May return null)
     * @response `204` `any` No Content
     */
    saveShortVideo: (data: SaveShortVideoPayload, params: RequestParams = {}) =>
      this.request<string | null, any>({
        path: `/api/v1/KnowledgeShortVideo/SaveShortVideo`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Remove um Video Curto.
     *
     * @tags KnowledgeShortVideo
     * @name DeleteShortVideo
     * @request POST:/api/v1/KnowledgeShortVideo/DeleteShortVideo
     * @secure
     * @response `200` `boolean` OK
     */
    deleteShortVideo: (
      data: DeleteShortVideoPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/KnowledgeShortVideo/DeleteShortVideo`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  knowledgeSubcription = {
    /**
     * Obtém as últimas 8 inscrições mais acessados pelo usuário.
     *
     * @tags KnowledgeSubcription
     * @name GetQuickAccessList
     * @request POST:/api/v1/KnowledgeSubcription/GetQuickAccessList
     * @secure
     * @response `200` `(QuickAccessResponse)[]` OK
     */
    getQuickAccessList: (
      data: GetQuickAccessListPayload,
      params: RequestParams = {},
    ) =>
      this.request<QuickAccessResponse[], any>({
        path: `/api/v1/KnowledgeSubcription/GetQuickAccessList`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém a lista de inscrições para Acesso Rápido do usuário.
     *
     * @tags KnowledgeSubcription
     * @name ManagedQuickAccessList
     * @request POST:/api/v1/KnowledgeSubcription/ManagedQuickAccessList
     * @secure
     * @response `200` `(ManagedQuickAccessResponse)[]` OK
     */
    managedQuickAccessList: (
      data: ManagedQuickAccessListPayload,
      params: RequestParams = {},
    ) =>
      this.request<ManagedQuickAccessResponse[], any>({
        path: `/api/v1/KnowledgeSubcription/ManagedQuickAccessList`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém as inscrições disponíveis para CANAL.
     *
     * @tags KnowledgeSubcription
     * @name ChannelSubscriptions
     * @request POST:/api/v1/KnowledgeSubcription/ChannelSubscriptions
     * @secure
     * @response `200` `(ChannelSubscriptionResponse)[]` OK
     */
    channelSubscriptions: (
      data: ChannelSubscriptionsPayload,
      params: RequestParams = {},
    ) =>
      this.request<ChannelSubscriptionResponse[], any>({
        path: `/api/v1/KnowledgeSubcription/ChannelSubscriptions`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém as inscrições disponíveis para TÓPICO.
     *
     * @tags KnowledgeSubcription
     * @name TopicSubscriptions
     * @request POST:/api/v1/KnowledgeSubcription/TopicSubscriptions
     * @secure
     * @response `200` `(TopicSubscriptionResponse)[]` OK
     */
    topicSubscriptions: (
      data: TopicSubscriptionsPayload,
      params: RequestParams = {},
    ) =>
      this.request<TopicSubscriptionResponse[], any>({
        path: `/api/v1/KnowledgeSubcription/TopicSubscriptions`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém as inscrições disponíveis para Autor de Conteúdo.
     *
     * @tags KnowledgeSubcription
     * @name AuthorSubscriptions
     * @request POST:/api/v1/KnowledgeSubcription/AuthorSubscriptions
     * @secure
     * @response `200` `(AuthorSubscriptionResponse)[]` OK
     */
    authorSubscriptions: (
      data: AuthorSubscriptionsPayload,
      params: RequestParams = {},
    ) =>
      this.request<AuthorSubscriptionResponse[], any>({
        path: `/api/v1/KnowledgeSubcription/AuthorSubscriptions`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém as inscrições disponíveis para Listas.
     *
     * @tags KnowledgeSubcription
     * @name ListSubscriptions
     * @request POST:/api/v1/KnowledgeSubcription/ListSubscriptions
     * @secure
     * @response `200` `(ListSubscriptionResponse)[]` OK
     */
    listSubscriptions: (
      data: ListSubscriptionsPayload,
      params: RequestParams = {},
    ) =>
      this.request<ListSubscriptionResponse[], any>({
        path: `/api/v1/KnowledgeSubcription/ListSubscriptions`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Cria uma requisição de subscrição do usuário no canal.
     *
     * @tags KnowledgeSubcription
     * @name RequestChannelSubscription
     * @request POST:/api/v1/KnowledgeSubcription/RequestChannelSubscription
     * @secure
     * @response `200` `RequestChannelSubscriptionResult` OK
     */
    requestChannelSubscription: (
      data: RequestChannelSubscriptionPayload,
      params: RequestParams = {},
    ) =>
      this.request<RequestChannelSubscriptionResult, any>({
        path: `/api/v1/KnowledgeSubcription/RequestChannelSubscription`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Rejeita uma solicitação de inscrição do usuário no canal.
     *
     * @tags KnowledgeSubcription
     * @name RefuseChannelSubscription
     * @request POST:/api/v1/KnowledgeSubcription/RefuseChannelSubscription
     * @secure
     * @response `200` `boolean` OK
     */
    refuseChannelSubscription: (
      data: RefuseChannelSubscriptionPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/KnowledgeSubcription/RefuseChannelSubscription`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Aceita o usuário como membro do canal.
     *
     * @tags KnowledgeSubcription
     * @name AcceptChannelSubscription
     * @request POST:/api/v1/KnowledgeSubcription/AcceptChannelSubscription
     * @secure
     * @response `200` `boolean` OK
     */
    acceptChannelSubscription: (
      data: AcceptChannelSubscriptionPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/KnowledgeSubcription/AcceptChannelSubscription`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtem configurações do Canal para subscrição.
     *
     * @tags KnowledgeSubcription
     * @name ChannelSubscriptionsSettings
     * @request POST:/api/v1/KnowledgeSubcription/ChannelSubscriptionsSettings
     * @secure
     * @response `200` `ChannelSubscriptionsSettingsResponse` OK
     */
    channelSubscriptionsSettings: (
      data: ChannelSubscriptionsSettingsPayload,
      params: RequestParams = {},
    ) =>
      this.request<ChannelSubscriptionsSettingsResponse, any>({
        path: `/api/v1/KnowledgeSubcription/ChannelSubscriptionsSettings`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Remove a inscrição do usuário no canal.
     *
     * @tags KnowledgeSubcription
     * @name UnsubscribeChannel
     * @request POST:/api/v1/KnowledgeSubcription/UnsubscribeChannel
     * @secure
     * @response `200` `boolean` OK
     */
    unsubscribeChannel: (
      data: UnsubscribeChannelPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/KnowledgeSubcription/UnsubscribeChannel`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Inscreve o usuário no tópico.
     *
     * @tags KnowledgeSubcription
     * @name SubscribeTopic
     * @request POST:/api/v1/KnowledgeSubcription/SubscribeTopic
     * @secure
     * @response `200` `boolean` OK
     */
    subscribeTopic: (data: SubscribeTopicPayload, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/api/v1/KnowledgeSubcription/SubscribeTopic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Remove a inscrição do usuário no tópico.
     *
     * @tags KnowledgeSubcription
     * @name UnsubscribeTopic
     * @request POST:/api/v1/KnowledgeSubcription/UnsubscribeTopic
     * @secure
     * @response `200` `boolean` OK
     */
    unsubscribeTopic: (
      data: UnsubscribeTopicPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/KnowledgeSubcription/UnsubscribeTopic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Inscreve o usuário na publicação (o usuário passa a 'seguir' a publicação).
     *
     * @tags KnowledgeSubcription
     * @name SubscribePublication
     * @request POST:/api/v1/KnowledgeSubcription/SubscribePublication
     * @secure
     * @response `200` `boolean` OK
     */
    subscribePublication: (
      data: SubscribePublicationPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/KnowledgeSubcription/SubscribePublication`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Remove subscrição do usuário na publicação.
     *
     * @tags KnowledgeSubcription
     * @name UnsubscribePublication
     * @request POST:/api/v1/KnowledgeSubcription/UnsubscribePublication
     * @secure
     * @response `200` `boolean` OK
     */
    unsubscribePublication: (
      data: UnsubscribePublicationPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/KnowledgeSubcription/UnsubscribePublication`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Inscreve o usuário como 'seguidor' de Conteúdo.
     *
     * @tags KnowledgeSubcription
     * @name SubscribeUser
     * @request POST:/api/v1/KnowledgeSubcription/SubscribeUser
     * @secure
     * @response `200` `boolean` OK
     */
    subscribeUser: (data: SubscribeUserPayload, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/api/v1/KnowledgeSubcription/SubscribeUser`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Remove inscrição do usuário como 'seguidor'.
     *
     * @tags KnowledgeSubcription
     * @name UnsubscribeUser
     * @request POST:/api/v1/KnowledgeSubcription/UnsubscribeUser
     * @secure
     * @response `200` `boolean` OK
     */
    unsubscribeUser: (
      data: UnsubscribeUserPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/KnowledgeSubcription/UnsubscribeUser`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Altera a subscrição do usuário entre visível e não visível.
     *
     * @tags KnowledgeSubcription
     * @name ToggleHide
     * @request POST:/api/v1/KnowledgeSubcription/ToggleHide
     * @secure
     * @response `200` `boolean` OK
     */
    toggleHide: (data: ToggleHidePayload, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/api/v1/KnowledgeSubcription/ToggleHide`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Ativa ou desativa notificações dos usuários no canal
     *
     * @tags KnowledgeSubcription
     * @name ToggleMutedChannel
     * @request POST:/api/v1/KnowledgeSubcription/ToggleMutedChannel
     * @secure
     * @response `200` `boolean` OK
     */
    toggleMutedChannel: (
      data: ToggleMutedChannelPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/KnowledgeSubcription/ToggleMutedChannel`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Ativa ou desativa notificações dos usuários no tópico
     *
     * @tags KnowledgeSubcription
     * @name ToggleMutedTopic
     * @request POST:/api/v1/KnowledgeSubcription/ToggleMutedTopic
     * @secure
     * @response `200` `boolean` OK
     */
    toggleMutedTopic: (
      data: ToggleMutedTopicPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/KnowledgeSubcription/ToggleMutedTopic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Ativa e desativa notificações do perfil do usuário.
     *
     * @tags KnowledgeSubcription
     * @name ToggleMutedUserProfile
     * @request POST:/api/v1/KnowledgeSubcription/ToggleMutedUserProfile
     * @secure
     * @response `200` `boolean` OK
     */
    toggleMutedUserProfile: (
      data: ToggleMutedUserProfilePayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/KnowledgeSubcription/ToggleMutedUserProfile`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Silencia ou remove o silencia do perfil do usuário.
     *
     * @tags KnowledgeSubcription
     * @name ToggleSilenceProfile
     * @request POST:/api/v1/KnowledgeSubcription/ToggleSilenceProfile
     * @secure
     * @response `200` `boolean` OK
     */
    toggleSilenceProfile: (
      data: ToggleSilenceProfilePayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/KnowledgeSubcription/ToggleSilenceProfile`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Bloqueio ou desbloqueia o perfil do usuário.
     *
     * @tags KnowledgeSubcription
     * @name ToggleBlockProfile
     * @request POST:/api/v1/KnowledgeSubcription/ToggleBlockProfile
     * @secure
     * @response `200` `boolean` OK
     */
    toggleBlockProfile: (
      data: ToggleBlockProfilePayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/KnowledgeSubcription/ToggleBlockProfile`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Solicita conexão com o perfil do usuário.
     *
     * @tags KnowledgeSubcription
     * @name ProfileRequestConnection
     * @request POST:/api/v1/KnowledgeSubcription/ProfileRequestConnection
     * @secure
     * @response `200` `boolean` OK
     */
    profileRequestConnection: (
      data: ProfileRequestConnectionPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/KnowledgeSubcription/ProfileRequestConnection`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  knowledgeSuggestions = {
    /**
     * Canais disponíveis para o usuário.
     *
     * @tags KnowledgeSuggestions
     * @name Channels
     * @request POST:/api/v1/KnowledgeSuggestions/Channels
     * @secure
     * @response `200` `ChannelAutoCompleteDataModelDtoPaginatedList` OK
     */
    channels: (data: ChannelsBody, params: RequestParams = {}) =>
      this.request<ChannelAutoCompleteDataModelDtoPaginatedList, any>({
        path: `/api/v1/KnowledgeSuggestions/Channels`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Canais Gerenciados.
     *
     * @tags KnowledgeSuggestions
     * @name ManagedChannels
     * @request POST:/api/v1/KnowledgeSuggestions/ManagedChannels
     * @secure
     * @response `200` `ChannelAutoCompleteDataModelDtoPaginatedList` OK
     */
    managedChannels: (
      data: ManagedChannelsPayload,
      params: RequestParams = {},
    ) =>
      this.request<ChannelAutoCompleteDataModelDtoPaginatedList, any>({
        path: `/api/v1/KnowledgeSuggestions/ManagedChannels`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Canais para sugestão ao adicionar membros.
     *
     * @tags KnowledgeSuggestions
     * @name ChannelsAddMembers
     * @request POST:/api/v1/KnowledgeSuggestions/ChannelsAddMembers
     * @secure
     * @response `200` `ChannelAutoCompleteDataModelDtoPaginatedList` OK
     */
    channelsAddMembers: (
      data: ChannelsAddMembersPayload,
      params: RequestParams = {},
    ) =>
      this.request<ChannelAutoCompleteDataModelDtoPaginatedList, any>({
        path: `/api/v1/KnowledgeSuggestions/ChannelsAddMembers`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Moderadores de canal
     *
     * @tags KnowledgeSuggestions
     * @name ModeratorsChannel
     * @request POST:/api/v1/KnowledgeSuggestions/ModeratorsChannel
     * @secure
     * @response `200` `ModeratorChannelAutoCompleteDataModelDtoPaginatedList` OK
     */
    moderatorsChannel: (
      data: ModeratorsChannelPayload,
      params: RequestParams = {},
    ) =>
      this.request<ModeratorChannelAutoCompleteDataModelDtoPaginatedList, any>({
        path: `/api/v1/KnowledgeSuggestions/ModeratorsChannel`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Busca por canais no feeds (retorna canais que o usuário pode visualizar)
     *
     * @tags KnowledgeSuggestions
     * @name FeedChannel
     * @request POST:/api/v1/KnowledgeSuggestions/FeedChannel
     * @secure
     * @response `200` `ChannelAutoCompleteDataModelDtoPaginatedList` OK
     */
    feedChannel: (data: FeedChannelPayload, params: RequestParams = {}) =>
      this.request<ChannelAutoCompleteDataModelDtoPaginatedList, any>({
        path: `/api/v1/KnowledgeSuggestions/FeedChannel`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém uma lista expandida de todos os usuários membros do canal.
     *
     * @tags KnowledgeSuggestions
     * @name ChannelUsersMembersSuggestion
     * @request POST:/api/v1/KnowledgeSuggestions/ChannelUsersMembersSuggestion
     * @secure
     * @response `200` `AutoCompleteDataModelDtoPaginatedList` OK
     */
    channelUsersMembersSuggestion: (
      data: ChannelUsersMembersSuggestionPayload,
      params: RequestParams = {},
    ) =>
      this.request<AutoCompleteDataModelDtoPaginatedList, any>({
        path: `/api/v1/KnowledgeSuggestions/ChannelUsersMembersSuggestion`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Membros de canal do tipo Usuário.
     *
     * @tags KnowledgeSuggestions
     * @name ChannelMemberUsers
     * @request POST:/api/v1/KnowledgeSuggestions/ChannelMemberUsers
     * @secure
     * @response `200` `AutoCompleteDataModelDtoPaginatedList` OK
     */
    channelMemberUsers: (
      data: ChannelMemberUsersPayload,
      params: RequestParams = {},
    ) =>
      this.request<AutoCompleteDataModelDtoPaginatedList, any>({
        path: `/api/v1/KnowledgeSuggestions/ChannelMemberUsers`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Membros de canal do tipo Grupo.
     *
     * @tags KnowledgeSuggestions
     * @name ChannelMemberGroups
     * @request POST:/api/v1/KnowledgeSuggestions/ChannelMemberGroups
     * @secure
     * @response `200` `AutoCompleteDataModelDtoPaginatedList` OK
     */
    channelMemberGroups: (
      data: ChannelMemberGroupsPayload,
      params: RequestParams = {},
    ) =>
      this.request<AutoCompleteDataModelDtoPaginatedList, any>({
        path: `/api/v1/KnowledgeSuggestions/ChannelMemberGroups`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Grupos para recomendar publicação.
     *
     * @tags KnowledgeSuggestions
     * @name PublicationRecommendationGroups
     * @request POST:/api/v1/KnowledgeSuggestions/PublicationRecommendationGroups
     * @secure
     * @response `200` `AutoCompleteDataModelDtoPaginatedList` OK
     */
    publicationRecommendationGroups: (
      data: PublicationRecommendationGroupsPayload,
      params: RequestParams = {},
    ) =>
      this.request<AutoCompleteDataModelDtoPaginatedList, any>({
        path: `/api/v1/KnowledgeSuggestions/PublicationRecommendationGroups`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém uma lista de usuários que são autores de publicação.
     *
     * @tags KnowledgeSuggestions
     * @name PublicationAuthors
     * @request POST:/api/v1/KnowledgeSuggestions/PublicationAuthors
     * @secure
     * @response `200` `AutoCompleteDataModelDtoPaginatedList` OK
     */
    publicationAuthors: (
      data: PublicationAuthorsPayload,
      params: RequestParams = {},
    ) =>
      this.request<AutoCompleteDataModelDtoPaginatedList, any>({
        path: `/api/v1/KnowledgeSuggestions/PublicationAuthors`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  lmsDiscussion = {
    /**
     * Obtém a lista de Discussões de uma Turma.
     *
     * @tags LmsDiscussion
     * @name GetDiscussionClassroom
     * @request POST:/api/v1/LmsDiscussion/GetDiscussionClassroom
     * @secure
     * @response `200` `PaginatedDiscussion` OK
     */
    getDiscussionClassroom: (
      data: GetDiscussionClassroomPayload,
      params: RequestParams = {},
    ) =>
      this.request<PaginatedDiscussion, any>({
        path: `/api/v1/LmsDiscussion/GetDiscussionClassroom`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém a lista de Discussões de um Plano de Desenvolvimento.
     *
     * @tags LmsDiscussion
     * @name GetDiscussionDevPlan
     * @request POST:/api/v1/LmsDiscussion/GetDiscussionDevPlan
     * @secure
     * @response `200` `PaginatedDiscussion` OK
     */
    getDiscussionDevPlan: (
      data: GetDiscussionDevPlanPayload,
      params: RequestParams = {},
    ) =>
      this.request<PaginatedDiscussion, any>({
        path: `/api/v1/LmsDiscussion/GetDiscussionDevPlan`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Cria um discussão de uma turma.
     *
     * @tags LmsDiscussion
     * @name CreateDiscussionClassroom
     * @request POST:/api/v1/LmsDiscussion/CreateDiscussionClassroom
     * @secure
     * @response `200` `PaginatedDiscussion` OK (May return null)
     * @response `204` `any` No Content
     */
    createDiscussionClassroom: (
      data: CreateDiscussionClassroomPayload,
      params: RequestParams = {},
    ) =>
      this.request<PaginatedDiscussion, any>({
        path: `/api/v1/LmsDiscussion/CreateDiscussionClassroom`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Altera um item da discussão da turma.
     *
     * @tags LmsDiscussion
     * @name UpdateDiscussionClassroom
     * @request POST:/api/v1/LmsDiscussion/UpdateDiscussionClassroom
     * @secure
     * @response `200` `boolean` OK
     */
    updateDiscussionClassroom: (
      data: UpdateDiscussionClassroomPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/LmsDiscussion/UpdateDiscussionClassroom`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Exclui uma discussão de uma turma.
     *
     * @tags LmsDiscussion
     * @name DeleteDiscussionClassroom
     * @request POST:/api/v1/LmsDiscussion/DeleteDiscussionClassroom
     * @secure
     * @response `200` `DeleteDiscussionDto` OK
     */
    deleteDiscussionClassroom: (
      data: DeleteDiscussionClassroomPayload,
      params: RequestParams = {},
    ) =>
      this.request<DeleteDiscussionDto, any>({
        path: `/api/v1/LmsDiscussion/DeleteDiscussionClassroom`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Registra curtida em uma discussão de uma turma.
     *
     * @tags LmsDiscussion
     * @name LikeDiscussionClassroom
     * @request POST:/api/v1/LmsDiscussion/LikeDiscussionClassroom
     * @secure
     * @response `200` `GetDiscussionDto` OK (May return null)
     * @response `204` `any` No Content
     */
    likeDiscussionClassroom: (
      data: LikeDiscussionClassroomPayload,
      params: RequestParams = {},
    ) =>
      this.request<GetDiscussionDto, any>({
        path: `/api/v1/LmsDiscussion/LikeDiscussionClassroom`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Cria um discussão de um plano de desenvolvimento.
     *
     * @tags LmsDiscussion
     * @name CreateDiscussionDevPlan
     * @request POST:/api/v1/LmsDiscussion/CreateDiscussionDevPlan
     * @secure
     * @response `200` `PaginatedDiscussion` OK (May return null)
     * @response `204` `any` No Content
     */
    createDiscussionDevPlan: (
      data: CreateDiscussionDevPlanPayload,
      params: RequestParams = {},
    ) =>
      this.request<PaginatedDiscussion, any>({
        path: `/api/v1/LmsDiscussion/CreateDiscussionDevPlan`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Altera um item da discussão do plano de desenvolvimento.
     *
     * @tags LmsDiscussion
     * @name UpdateDiscussionDevPlan
     * @request POST:/api/v1/LmsDiscussion/UpdateDiscussionDevPlan
     * @secure
     * @response `200` `boolean` OK
     */
    updateDiscussionDevPlan: (
      data: UpdateDiscussionDevPlanPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/LmsDiscussion/UpdateDiscussionDevPlan`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Exclui uma discussão de um Plano de Desenvolvimento.
     *
     * @tags LmsDiscussion
     * @name DeleteDiscussionDevPlan
     * @request POST:/api/v1/LmsDiscussion/DeleteDiscussionDevPlan
     * @secure
     * @response `200` `DeleteDiscussionDto` OK
     */
    deleteDiscussionDevPlan: (
      data: DeleteDiscussionDevPlanPayload,
      params: RequestParams = {},
    ) =>
      this.request<DeleteDiscussionDto, any>({
        path: `/api/v1/LmsDiscussion/DeleteDiscussionDevPlan`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Registra curtida em uma discussão de um Plano de Desenvolvimento.
     *
     * @tags LmsDiscussion
     * @name LikeDiscussionDevPlan
     * @request POST:/api/v1/LmsDiscussion/LikeDiscussionDevPlan
     * @secure
     * @response `200` `GetDiscussionDto` OK (May return null)
     * @response `204` `any` No Content
     */
    likeDiscussionDevPlan: (
      data: LikeDiscussionDevPlanPayload,
      params: RequestParams = {},
    ) =>
      this.request<GetDiscussionDto, any>({
        path: `/api/v1/LmsDiscussion/LikeDiscussionDevPlan`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém lista de usuários que podem ser mencionados em discussão do plano de desenvolvimento.
     *
     * @tags LmsDiscussion
     * @name DevPlanUserDiscussionSuggestions
     * @request POST:/api/v1/LmsDiscussion/DevPlanUserDiscussionSuggestions
     * @secure
     * @response `200` `AutoCompleteDataModelDtoPaginatedList` OK
     */
    devPlanUserDiscussionSuggestions: (
      data: DevPlanUserDiscussionSuggestionsPayload,
      params: RequestParams = {},
    ) =>
      this.request<AutoCompleteDataModelDtoPaginatedList, any>({
        path: `/api/v1/LmsDiscussion/DevPlanUserDiscussionSuggestions`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém lista de usuários que podem ser mencionados em discussão do plano de desenvolvimento.
     *
     * @tags LmsDiscussion
     * @name DevPlanUserDiscussionSelector
     * @request POST:/api/v1/LmsDiscussion/DevPlanUserDiscussionSelector
     * @secure
     * @response `200` `UserSelectorResponsePaginatedList` OK
     */
    devPlanUserDiscussionSelector: (
      data: DevPlanUserDiscussionSelectorPayload,
      params: RequestParams = {},
    ) =>
      this.request<UserSelectorResponsePaginatedList, any>({
        path: `/api/v1/LmsDiscussion/DevPlanUserDiscussionSelector`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  lmsMonitoring = {
    /**
     * Lista de Inscrições pendentes de aprovação.
     *
     * @tags LmsMonitoring
     * @name WorkflowPreApproval
     * @request POST:/api/v1/LmsMonitoring/WorkflowPreApproval
     * @secure
     * @response `200` `WorkflowEnrollRequestDtoPaginatedList` OK
     */
    workflowPreApproval: (
      data: WorkflowPreApprovalPayload,
      params: RequestParams = {},
    ) =>
      this.request<WorkflowEnrollRequestDtoPaginatedList, any>({
        path: `/api/v1/LmsMonitoring/WorkflowPreApproval`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Lista de Inscrições com Formulário de Conclusão pendentes de aprovação.
     *
     * @tags LmsMonitoring
     * @name WorkflowConclusionForm
     * @request POST:/api/v1/LmsMonitoring/WorkflowConclusionForm
     * @secure
     * @response `200` `WorkflowConclusionDtoPaginatedList` OK
     */
    workflowConclusionForm: (
      data: WorkflowConclusionFormPayload,
      params: RequestParams = {},
    ) =>
      this.request<WorkflowConclusionDtoPaginatedList, any>({
        path: `/api/v1/LmsMonitoring/WorkflowConclusionForm`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Lista de treinamentos disponíveis para supervisão.
     *
     * @tags LmsMonitoring
     * @name GetSupervisorTrainings
     * @request POST:/api/v1/LmsMonitoring/GetSupervisorTrainings
     * @secure
     * @response `200` `SupervisorTrainingDtoPaginatedList` OK
     */
    getSupervisorTrainings: (
      data: GetSupervisorTrainingsPayload,
      params: RequestParams = {},
    ) =>
      this.request<SupervisorTrainingDtoPaginatedList, any>({
        path: `/api/v1/LmsMonitoring/GetSupervisorTrainings`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Lista de turmas disponíveis para supervisão.
     *
     * @tags LmsMonitoring
     * @name GetSupervisorClassrooms
     * @request POST:/api/v1/LmsMonitoring/GetSupervisorClassrooms
     * @secure
     * @response `200` `SupervisorClassroomDtoPaginatedList` OK
     */
    getSupervisorClassrooms: (
      data: GetSupervisorClassroomsPayload,
      params: RequestParams = {},
    ) =>
      this.request<SupervisorClassroomDtoPaginatedList, any>({
        path: `/api/v1/LmsMonitoring/GetSupervisorClassrooms`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Lista de avisos da turma para gerenciamento.
     *
     * @tags LmsMonitoring
     * @name GetSupervisorClassroomNotices
     * @request POST:/api/v1/LmsMonitoring/GetSupervisorClassroomNotices
     * @secure
     * @response `200` `SupervisorClassroomNoticeResponsePaginatedList` OK
     */
    getSupervisorClassroomNotices: (
      data: GetSupervisorClassroomNoticesPayload,
      params: RequestParams = {},
    ) =>
      this.request<SupervisorClassroomNoticeResponsePaginatedList, any>({
        path: `/api/v1/LmsMonitoring/GetSupervisorClassroomNotices`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Lista de turmas de supervisão com discussões não vistas.
     *
     * @tags LmsMonitoring
     * @name GetSupervisorClassroomDiscussions
     * @request POST:/api/v1/LmsMonitoring/GetSupervisorClassroomDiscussions
     * @secure
     * @response `200` `SupervisorClassroomDiscussionDtoPaginatedList` OK
     */
    getSupervisorClassroomDiscussions: (
      data: GetSupervisorClassroomDiscussionsPayload,
      params: RequestParams = {},
    ) =>
      this.request<SupervisorClassroomDiscussionDtoPaginatedList, any>({
        path: `/api/v1/LmsMonitoring/GetSupervisorClassroomDiscussions`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Lista de eventos das turmas de supervisão.
     *
     * @tags LmsMonitoring
     * @name GetSupervisorClassroomMeetings
     * @request POST:/api/v1/LmsMonitoring/GetSupervisorClassroomMeetings
     * @secure
     * @response `200` `SupervisorClassroomMeetingDtoPaginatedList` OK
     */
    getSupervisorClassroomMeetings: (
      data: GetSupervisorClassroomMeetingsPayload,
      params: RequestParams = {},
    ) =>
      this.request<SupervisorClassroomMeetingDtoPaginatedList, any>({
        path: `/api/v1/LmsMonitoring/GetSupervisorClassroomMeetings`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Resumo dos treinamentos para supervisão.
     *
     * @tags LmsMonitoring
     * @name GetSupervisorInsights
     * @request POST:/api/v1/LmsMonitoring/GetSupervisorInsights
     * @secure
     * @response `200` `SupervisorInsightsDto` OK
     */
    getSupervisorInsights: (
      data: GetSupervisorInsightsPayload,
      params: RequestParams = {},
    ) =>
      this.request<SupervisorInsightsDto, any>({
        path: `/api/v1/LmsMonitoring/GetSupervisorInsights`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Lista de inscrições de uma turma.
     *
     * @tags LmsMonitoring
     * @name GetSupervisorEnrollment
     * @request POST:/api/v1/LmsMonitoring/GetSupervisorEnrollment
     * @secure
     * @response `200` `SupervisorEnrollmentDtoPaginatedList` OK
     */
    getSupervisorEnrollment: (
      data: GetSupervisorEnrollmentPayload,
      params: RequestParams = {},
    ) =>
      this.request<SupervisorEnrollmentDtoPaginatedList, any>({
        path: `/api/v1/LmsMonitoring/GetSupervisorEnrollment`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtem informações da turma para o Card Header do monitoramento (Tutoria e Treinamento).
     *
     * @tags LmsMonitoring
     * @name GetSupervisorHeader
     * @request POST:/api/v1/LmsMonitoring/GetSupervisorHeader
     * @secure
     * @response `200` `SupervisorHeaderDto` OK (May return null)
     * @response `204` `any` No Content
     */
    getSupervisorHeader: (
      data: GetSupervisorHeaderPayload,
      params: RequestParams = {},
    ) =>
      this.request<SupervisorHeaderDto, any>({
        path: `/api/v1/LmsMonitoring/GetSupervisorHeader`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtem informações dos eventos/meeting de uma turma.
     *
     * @tags LmsMonitoring
     * @name GetSupervisorMeetings
     * @request POST:/api/v1/LmsMonitoring/GetSupervisorMeetings
     * @secure
     * @response `200` `(SupervisorMeetingDto)[]` OK
     */
    getSupervisorMeetings: (
      data: GetSupervisorMeetingsPayload,
      params: RequestParams = {},
    ) =>
      this.request<SupervisorMeetingDto[], any>({
        path: `/api/v1/LmsMonitoring/GetSupervisorMeetings`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtem informações das atividades de uma turma.
     *
     * @tags LmsMonitoring
     * @name GetSupervisorActivities
     * @request POST:/api/v1/LmsMonitoring/GetSupervisorActivities
     * @secure
     * @response `200` `(SupervisorActivityDto)[]` OK
     */
    getSupervisorActivities: (
      data: GetSupervisorActivitiesPayload,
      params: RequestParams = {},
    ) =>
      this.request<SupervisorActivityDto[], any>({
        path: `/api/v1/LmsMonitoring/GetSupervisorActivities`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém cronograma da turma.
     *
     * @tags LmsMonitoring
     * @name GetSupervisorClassroomSchedule
     * @request POST:/api/v1/LmsMonitoring/GetSupervisorClassroomSchedule
     * @secure
     * @response `200` `ClassroomScheduleResponse` OK
     */
    getSupervisorClassroomSchedule: (
      data: GetSupervisorClassroomSchedulePayload,
      params: RequestParams = {},
    ) =>
      this.request<ClassroomScheduleResponse, any>({
        path: `/api/v1/LmsMonitoring/GetSupervisorClassroomSchedule`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém as Estatísticas da Turma.
     *
     * @tags LmsMonitoring
     * @name GetSupervisorStatistics
     * @request POST:/api/v1/LmsMonitoring/GetSupervisorStatistics
     * @secure
     * @response `200` `SupervisorStatisticsDto` OK
     */
    getSupervisorStatistics: (
      data: GetSupervisorStatisticsPayload,
      params: RequestParams = {},
    ) =>
      this.request<SupervisorStatisticsDto, any>({
        path: `/api/v1/LmsMonitoring/GetSupervisorStatistics`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Drilldown dos Usuários da Estatística da Turma.
     *
     * @tags LmsMonitoring
     * @name GetSupervisorStatisticsDrill
     * @request POST:/api/v1/LmsMonitoring/GetSupervisorStatisticsDrill
     * @secure
     * @response `200` `UserEnrollStatisticsDtoPaginatedList` OK
     */
    getSupervisorStatisticsDrill: (
      data: GetSupervisorStatisticsDrillPayload,
      params: RequestParams = {},
    ) =>
      this.request<UserEnrollStatisticsDtoPaginatedList, any>({
        path: `/api/v1/LmsMonitoring/GetSupervisorStatisticsDrill`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Lista de inscrições com registro de presença e atribuição de notas dos eventos.
     *
     * @tags LmsMonitoring
     * @name GetRegisterMeetingAttended
     * @request POST:/api/v1/LmsMonitoring/GetRegisterMeetingAttended
     * @secure
     * @response `200` `(RegisterMeetingDto)[]` OK
     */
    getRegisterMeetingAttended: (
      data: GetRegisterMeetingAttendedPayload,
      params: RequestParams = {},
    ) =>
      this.request<RegisterMeetingDto[], any>({
        path: `/api/v1/LmsMonitoring/GetRegisterMeetingAttended`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Lista de inscrições com registro atribuição de notas das atividades.
     *
     * @tags LmsMonitoring
     * @name GetRegisterActivityScore
     * @request POST:/api/v1/LmsMonitoring/GetRegisterActivityScore
     * @secure
     * @response `200` `(RegisterActivityDto)[]` OK
     */
    getRegisterActivityScore: (
      data: GetRegisterActivityScorePayload,
      params: RequestParams = {},
    ) =>
      this.request<RegisterActivityDto[], any>({
        path: `/api/v1/LmsMonitoring/GetRegisterActivityScore`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Lista de inscrições com registro de presença e atribuição de notas dos eventos em modo matricial.
     *
     * @tags LmsMonitoring
     * @name GetRegisterMeetingsMatrix
     * @request POST:/api/v1/LmsMonitoring/GetRegisterMeetingsMatrix
     * @secure
     * @response `200` `RegisterMeetingMatrixResponse` OK
     */
    getRegisterMeetingsMatrix: (
      data: GetRegisterMeetingsMatrixPayload,
      params: RequestParams = {},
    ) =>
      this.request<RegisterMeetingMatrixResponse, any>({
        path: `/api/v1/LmsMonitoring/GetRegisterMeetingsMatrix`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Lista de inscrições com registro atribuição de notas das atividades em modo matricial.
     *
     * @tags LmsMonitoring
     * @name GetRegisterActivitiesMatrix
     * @request POST:/api/v1/LmsMonitoring/GetRegisterActivitiesMatrix
     * @secure
     * @response `200` `RegisterActivityMatrixResponse` OK
     */
    getRegisterActivitiesMatrix: (
      data: GetRegisterActivitiesMatrixPayload,
      params: RequestParams = {},
    ) =>
      this.request<RegisterActivityMatrixResponse, any>({
        path: `/api/v1/LmsMonitoring/GetRegisterActivitiesMatrix`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém detalhes da inscrição.
     *
     * @tags LmsMonitoring
     * @name GetSupervisorEnrollmentDetails
     * @request POST:/api/v1/LmsMonitoring/GetSupervisorEnrollmentDetails
     * @secure
     * @response `200` `SupervisorEnrollmentDetailsResponse` OK
     */
    getSupervisorEnrollmentDetails: (
      data: GetSupervisorEnrollmentDetailsPayload,
      params: RequestParams = {},
    ) =>
      this.request<SupervisorEnrollmentDetailsResponse, any>({
        path: `/api/v1/LmsMonitoring/GetSupervisorEnrollmentDetails`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém propriedades do evento para edição pelo Instrutor.
     *
     * @tags LmsMonitoring
     * @name GetSupervisorClassroomMeeting
     * @request POST:/api/v1/LmsMonitoring/GetSupervisorClassroomMeeting
     * @secure
     * @response `200` `SupervisorClassroomMeetingResponse` OK
     */
    getSupervisorClassroomMeeting: (
      data: GetSupervisorClassroomMeetingPayload,
      params: RequestParams = {},
    ) =>
      this.request<SupervisorClassroomMeetingResponse, any>({
        path: `/api/v1/LmsMonitoring/GetSupervisorClassroomMeeting`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Executa uma ação no Passo do Fluxo de Aprovação.
     *
     * @tags LmsMonitoring
     * @name WorkflowAction
     * @request POST:/api/v1/LmsMonitoring/WorkflowAction
     * @secure
     * @response `200` `WorkflowActionResult` OK
     */
    workflowAction: (data: WorkflowActionPayload, params: RequestParams = {}) =>
      this.request<WorkflowActionResult, any>({
        path: `/api/v1/LmsMonitoring/WorkflowAction`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Concede tempo adicional nas matrículas informadas.
     *
     * @tags LmsMonitoring
     * @name AddEnrollmentExtraTime
     * @request POST:/api/v1/LmsMonitoring/AddEnrollmentExtraTime
     * @secure
     * @response `200` `boolean` OK
     */
    addEnrollmentExtraTime: (
      data: AddEnrollmentExtraTimePayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/LmsMonitoring/AddEnrollmentExtraTime`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Cancela as matrículas informadas.
     *
     * @tags LmsMonitoring
     * @name CancelEnrollment
     * @request POST:/api/v1/LmsMonitoring/CancelEnrollment
     * @secure
     * @response `200` `boolean` OK
     */
    cancelEnrollment: (
      data: CancelEnrollmentBody,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/LmsMonitoring/CancelEnrollment`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Excluir aviso da turma.
     *
     * @tags LmsMonitoring
     * @name DeleteClassroomNotice
     * @request POST:/api/v1/LmsMonitoring/DeleteClassroomNotice
     * @secure
     * @response `200` `boolean` OK
     */
    deleteClassroomNotice: (
      data: DeleteClassroomNoticePayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/LmsMonitoring/DeleteClassroomNotice`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Salva os valores de presença e notas das inscrições de um evento.
     *
     * @tags LmsMonitoring
     * @name RegisterMeetingAttended
     * @request POST:/api/v1/LmsMonitoring/RegisterMeetingAttended
     * @secure
     * @response `200` `boolean` OK
     */
    registerMeetingAttended: (
      data: RegisterMeetingAttendedPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/LmsMonitoring/RegisterMeetingAttended`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Registra nota das inscrições de uma atividade.
     *
     * @tags LmsMonitoring
     * @name RegisterActivityScore
     * @request POST:/api/v1/LmsMonitoring/RegisterActivityScore
     * @secure
     * @response `200` `boolean` OK
     */
    registerActivityScore: (
      data: RegisterActivityScorePayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/LmsMonitoring/RegisterActivityScore`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Instrutor atualiza informações de um evento na TURMA.
     *
     * @tags LmsMonitoring
     * @name InstructorUpdateMeeeting
     * @request POST:/api/v1/LmsMonitoring/InstructorUpdateMeeeting
     * @secure
     * @response `200` `boolean` OK
     */
    instructorUpdateMeeeting: (
      data: InstructorUpdateMeeetingPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/LmsMonitoring/InstructorUpdateMeeeting`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Instrutor reativa evento que estava cancelado.
     *
     * @tags LmsMonitoring
     * @name InstructorUndoCancelMeeting
     * @request POST:/api/v1/LmsMonitoring/InstructorUndoCancelMeeting
     * @secure
     * @response `200` `boolean` OK
     */
    instructorUndoCancelMeeting: (
      data: InstructorUndoCancelMeetingPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/LmsMonitoring/InstructorUndoCancelMeeting`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Instrutor publica gravação do evento.
     *
     * @tags LmsMonitoring
     * @name InstructorPublishMeetingRecording
     * @request POST:/api/v1/LmsMonitoring/InstructorPublishMeetingRecording
     * @secure
     * @response `200` `boolean` OK
     */
    instructorPublishMeetingRecording: (
      data: InstructorPublishMeetingRecordingPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/LmsMonitoring/InstructorPublishMeetingRecording`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Envia mensagem direta para os usuários de uma turma.
     *
     * @tags LmsMonitoring
     * @name DirectMessageToClassroom
     * @request POST:/api/v1/LmsMonitoring/DirectMessageToClassroom
     * @secure
     * @response `200` `boolean` OK
     */
    directMessageToClassroom: (
      data: DirectMessageToClassroomPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/LmsMonitoring/DirectMessageToClassroom`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  lmsPublication = {
    /**
     * Obtém uma Publicação do Tipo 'Postagem de Treinamento'.
     *
     * @tags LmsPublication
     * @name GetPost
     * @request POST:/api/v1/LmsPublication/GetPost
     * @secure
     * @response `200` `GetTrainingPostPublicationDto` OK
     */
    getPost: (data: GetPostPayload, params: RequestParams = {}) =>
      this.request<GetTrainingPostPublicationDto, any>({
        path: `/api/v1/LmsPublication/GetPost`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém uma Publicação do Tipo 'Atividade de Treinamento'.
     *
     * @tags LmsPublication
     * @name GetActivity
     * @request POST:/api/v1/LmsPublication/GetActivity
     * @secure
     * @response `200` `GetTrainingActivityPublicationDto` OK
     */
    getActivity: (data: GetActivityPayload, params: RequestParams = {}) =>
      this.request<GetTrainingActivityPublicationDto, any>({
        path: `/api/v1/LmsPublication/GetActivity`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém uma Publicação do Tipo 'Aviso do Treinamento'.
     *
     * @tags LmsPublication
     * @name GetNotice
     * @request POST:/api/v1/LmsPublication/GetNotice
     * @secure
     * @response `200` `GetTrainingNoticePublicationDto` OK
     */
    getNotice: (data: GetNoticePayload, params: RequestParams = {}) =>
      this.request<GetTrainingNoticePublicationDto, any>({
        path: `/api/v1/LmsPublication/GetNotice`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém publicação de treinamento para preview.
     *
     * @tags LmsPublication
     * @name GetTrainingPostItem
     * @request POST:/api/v1/LmsPublication/GetTrainingPostItem
     * @secure
     * @response `200` `TrainingPublicationItemDto` OK (May return null)
     * @response `204` `any` No Content
     */
    getTrainingPostItem: (
      data: GetTrainingPostItemPayload,
      params: RequestParams = {},
    ) =>
      this.request<TrainingPublicationItemDto, any>({
        path: `/api/v1/LmsPublication/GetTrainingPostItem`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém publicação de treinamento para preview.
     *
     * @tags LmsPublication
     * @name GetActivityItem
     * @request POST:/api/v1/LmsPublication/GetActivityItem
     * @secure
     * @response `200` `TrainingActivityItemDto` OK (May return null)
     * @response `204` `any` No Content
     */
    getActivityItem: (data: GetActivityItemBody, params: RequestParams = {}) =>
      this.request<TrainingActivityItemDto, any>({
        path: `/api/v1/LmsPublication/GetActivityItem`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém a publicação de treinamento para visualização de conteúdo.
     *
     * @tags LmsPublication
     * @name GetTrainingContentPostItem
     * @request POST:/api/v1/LmsPublication/GetTrainingContentPostItem
     * @secure
     * @response `200` `TrainingPublicationItemDto` OK (May return null)
     * @response `204` `any` No Content
     */
    getTrainingContentPostItem: (
      data: GetTrainingContentPostItemPayload,
      params: RequestParams = {},
    ) =>
      this.request<TrainingPublicationItemDto, any>({
        path: `/api/v1/LmsPublication/GetTrainingContentPostItem`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtem as propriedades de uma Atividade vinculada à Turma na visão do Instrutor.
     *
     * @tags LmsPublication
     * @name GetSupervisorClassroomActivity
     * @request POST:/api/v1/LmsPublication/GetSupervisorClassroomActivity
     * @secure
     * @response `200` `GetSupervisorActivityPublicationDto` OK
     */
    getSupervisorClassroomActivity: (
      data: GetSupervisorClassroomActivityPayload,
      params: RequestParams = {},
    ) =>
      this.request<GetSupervisorActivityPublicationDto, any>({
        path: `/api/v1/LmsPublication/GetSupervisorClassroomActivity`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Cria ou Atualiza um Treinamento Exclusivo do Tipo 'Postagem de Treinamento'.
     *
     * @tags LmsPublication
     * @name CreateOrUpdatePostExclusiveTraining
     * @request POST:/api/v1/LmsPublication/CreateOrUpdatePostExclusiveTraining
     * @secure
     * @response `200` `SavePublicationResultDto` OK
     */
    createOrUpdatePostExclusiveTraining: (
      data: CreateOrUpdatePostExclusiveTrainingPayload,
      params: RequestParams = {},
    ) =>
      this.request<SavePublicationResultDto, any>({
        path: `/api/v1/LmsPublication/CreateOrUpdatePostExclusiveTraining`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Cria ou Atualiza um Treinamento Exclusivo do Tipo 'Atividade'.
     *
     * @tags LmsPublication
     * @name CreateOrUpdateActivityExclusiveTraining
     * @request POST:/api/v1/LmsPublication/CreateOrUpdateActivityExclusiveTraining
     * @secure
     * @response `200` `boolean` OK
     */
    createOrUpdateActivityExclusiveTraining: (
      data: CreateOrUpdateActivityExclusiveTrainingPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/LmsPublication/CreateOrUpdateActivityExclusiveTraining`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Copia uma publicação do Knowledge do tipo 'Postagem' para um Treinamento Exclusivo.
     *
     * @tags LmsPublication
     * @name CreatePostExclusiveTrainingFromPublication
     * @request POST:/api/v1/LmsPublication/CreatePostExclusiveTrainingFromPublication
     * @secure
     * @response `200` `boolean` OK
     */
    createPostExclusiveTrainingFromPublication: (
      data: CreatePostExclusiveTrainingFromPublicationPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/LmsPublication/CreatePostExclusiveTrainingFromPublication`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Cria ou Atualiza um Component com uma Publicação do Tipo 'Postagem de Treinamento'.
     *
     * @tags LmsPublication
     * @name CreateOrUpdatePostComponent
     * @request POST:/api/v1/LmsPublication/CreateOrUpdatePostComponent
     * @secure
     * @response `200` `SavePublicationResultDto` OK
     */
    createOrUpdatePostComponent: (
      data: CreateOrUpdatePostComponentPayload,
      params: RequestParams = {},
    ) =>
      this.request<SavePublicationResultDto, any>({
        path: `/api/v1/LmsPublication/CreateOrUpdatePostComponent`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Cria ou Atualiza um Component com uma Publicação do Tipo 'Atividade de Treinamento'.
     *
     * @tags LmsPublication
     * @name CreateOrUpdateActivityComponent
     * @request POST:/api/v1/LmsPublication/CreateOrUpdateActivityComponent
     * @secure
     * @response `200` `boolean` OK
     */
    createOrUpdateActivityComponent: (
      data: CreateOrUpdateActivityComponentPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/LmsPublication/CreateOrUpdateActivityComponent`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Copia uma publicação do Knowledge do tipo 'Postagem' para o Lms.
     *
     * @tags LmsPublication
     * @name CreatePostComponentFromPublication
     * @request POST:/api/v1/LmsPublication/CreatePostComponentFromPublication
     * @secure
     * @response `200` `boolean` OK
     */
    createPostComponentFromPublication: (
      data: CreatePostComponentFromPublicationPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/LmsPublication/CreatePostComponentFromPublication`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Cria ou Atualiza uma publicação exclusiva para o material de apoio.
     *
     * @tags LmsPublication
     * @name CreateOrUpdateMaterialListPost
     * @request POST:/api/v1/LmsPublication/CreateOrUpdateMaterialListPost
     * @secure
     * @response `200` `SavePublicationResultDto` OK
     */
    createOrUpdateMaterialListPost: (
      data: CreateOrUpdateMaterialListPostPayload,
      params: RequestParams = {},
    ) =>
      this.request<SavePublicationResultDto, any>({
        path: `/api/v1/LmsPublication/CreateOrUpdateMaterialListPost`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Cria ou Atualiza uma publicação do Tipo 'Aviso'.
     *
     * @tags LmsPublication
     * @name CreateOrUpdateNotice
     * @request POST:/api/v1/LmsPublication/CreateOrUpdateNotice
     * @secure
     * @response `200` `SavePublicationResultDto` OK
     */
    createOrUpdateNotice: (
      data: CreateOrUpdateNoticePayload,
      params: RequestParams = {},
    ) =>
      this.request<SavePublicationResultDto, any>({
        path: `/api/v1/LmsPublication/CreateOrUpdateNotice`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Supervisor atualiza informações de uma ativiade na TURMA.
     *
     * @tags LmsPublication
     * @name SupervisorUpdateActivity
     * @request POST:/api/v1/LmsPublication/SupervisorUpdateActivity
     * @secure
     * @response `200` `boolean` OK
     */
    supervisorUpdateActivity: (
      data: SupervisorUpdateActivityPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/LmsPublication/SupervisorUpdateActivity`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Supervisor cancela uma atividade da TURMA.
     *
     * @tags LmsPublication
     * @name SupervisorCancelActivity
     * @request POST:/api/v1/LmsPublication/SupervisorCancelActivity
     * @secure
     * @response `200` `boolean` OK
     */
    supervisorCancelActivity: (
      data: SupervisorCancelActivityPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/LmsPublication/SupervisorCancelActivity`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Supervisor desfaz o cancelamento de uma atividade da TURMA.
     *
     * @tags LmsPublication
     * @name SupervisorUndoCancelActivity
     * @request POST:/api/v1/LmsPublication/SupervisorUndoCancelActivity
     * @secure
     * @response `200` `boolean` OK
     */
    supervisorUndoCancelActivity: (
      data: SupervisorUndoCancelActivityPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/LmsPublication/SupervisorUndoCancelActivity`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  lmsRegistration = {
    /**
     * Executa verificações para inscrição do usuário no treinamento.
     *
     * @tags LmsRegistration
     * @name RegistrationIntoTrainingChecks
     * @request POST:/api/v1/LmsRegistration/RegistrationIntoTrainingChecks
     * @secure
     * @response `200` `RegistrationIntoTrainingChecksResults` OK
     */
    registrationIntoTrainingChecks: (
      data: RegistrationIntoTrainingChecksPayload,
      params: RequestParams = {},
    ) =>
      this.request<RegistrationIntoTrainingChecksResults, any>({
        path: `/api/v1/LmsRegistration/RegistrationIntoTrainingChecks`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Inscreve o usuário em uma turma.
     *
     * @tags LmsRegistration
     * @name CreateEnroll
     * @request POST:/api/v1/LmsRegistration/CreateEnroll
     * @secure
     * @response `200` `CreateEnrollResults` OK
     */
    createEnroll: (data: CreateEnrollPayload, params: RequestParams = {}) =>
      this.request<CreateEnrollResults, any>({
        path: `/api/v1/LmsRegistration/CreateEnroll`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Inscreve subordinados em uma turma.
     *
     * @tags LmsRegistration
     * @name EnrollSubordinates
     * @request POST:/api/v1/LmsRegistration/EnrollSubordinates
     * @secure
     * @response `200` `EnrollSubordinatesResult` OK
     */
    enrollSubordinates: (
      data: EnrollSubordinatesPayload,
      params: RequestParams = {},
    ) =>
      this.request<EnrollSubordinatesResult, any>({
        path: `/api/v1/LmsRegistration/EnrollSubordinates`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Marca que o usuário tem interesse no treinamento.
     *
     * @tags LmsRegistration
     * @name AddTrainingInterest
     * @request POST:/api/v1/LmsRegistration/AddTrainingInterest
     * @secure
     * @response `200` `boolean` OK
     */
    addTrainingInterest: (
      data: AddTrainingInterestPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/LmsRegistration/AddTrainingInterest`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Remove marcação que o usuário tem interesse no treinamento.
     *
     * @tags LmsRegistration
     * @name RemoveTrainingInterest
     * @request POST:/api/v1/LmsRegistration/RemoveTrainingInterest
     * @secure
     * @response `200` `boolean` OK
     */
    removeTrainingInterest: (
      data: RemoveTrainingInterestPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/LmsRegistration/RemoveTrainingInterest`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém a lista de usuários que tem interesse no treinamento.
     *
     * @tags LmsRegistration
     * @name TrainingUsersInterest
     * @request POST:/api/v1/LmsRegistration/TrainingUsersInterest
     * @secure
     * @response `200` `TrainingUserInterestResponsePaginatedList` OK
     */
    trainingUsersInterest: (
      data: TrainingUsersInterestPayload,
      params: RequestParams = {},
    ) =>
      this.request<TrainingUserInterestResponsePaginatedList, any>({
        path: `/api/v1/LmsRegistration/TrainingUsersInterest`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Cria matrícula ISENTA.
     *
     * @tags LmsRegistration
     * @name CreateExemptEnroll
     * @request POST:/api/v1/LmsRegistration/CreateExemptEnroll
     * @secure
     * @response `200` `boolean` OK
     */
    createExemptEnroll: (
      data: CreateExemptEnrollPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/LmsRegistration/CreateExemptEnroll`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Remove matrícula ISENTA.
     *
     * @tags LmsRegistration
     * @name DeleteExemptEnroll
     * @request POST:/api/v1/LmsRegistration/DeleteExemptEnroll
     * @secure
     * @response `200` `boolean` OK
     */
    deleteExemptEnroll: (
      data: DeleteExemptEnrollPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/LmsRegistration/DeleteExemptEnroll`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  lmsSelectors = {
    /**
     * Obtém lista de usuários inscritos em uma turma ou instrutoreas para sugestão em discussão.
     *
     * @tags LmsSelectors
     * @name UserDiscussionSelector
     * @request POST:/api/v1/LmsSelectors/UserDiscussionSelector
     * @secure
     * @response `200` `UserSelectorResponsePaginatedList` OK
     */
    userDiscussionSelector: (
      data: UserDiscussionSelectorPayload,
      params: RequestParams = {},
    ) =>
      this.request<UserSelectorResponsePaginatedList, any>({
        path: `/api/v1/LmsSelectors/UserDiscussionSelector`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém lista de opções para pré-requisitos.
     *
     * @tags LmsSelectors
     * @name PreRequisiteOptions
     * @request POST:/api/v1/LmsSelectors/PreRequisiteOptions
     * @secure
     * @response `200` `(TrainingPreReqOptionSelectorResponse)[]` OK
     */
    preRequisiteOptions: (params: RequestParams = {}) =>
      this.request<TrainingPreReqOptionSelectorResponse[], any>({
        path: `/api/v1/LmsSelectors/PreRequisiteOptions`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Obtém uma lista de treinamentos.
     *
     * @tags LmsSelectors
     * @name Training
     * @request POST:/api/v1/LmsSelectors/Training
     * @secure
     * @response `200` `TrainingSelectorDtoPaginatedList` OK
     */
    training: (data: TrainingPayload, params: RequestParams = {}) =>
      this.request<TrainingSelectorDtoPaginatedList, any>({
        path: `/api/v1/LmsSelectors/Training`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém uma lista de treinamentos para relacionamento em publicações.
     *
     * @tags LmsSelectors
     * @name TrainingRelationship
     * @request POST:/api/v1/LmsSelectors/TrainingRelationship
     * @secure
     * @response `200` `TrainingSelectorDtoPaginatedList` OK
     */
    trainingRelationship: (
      data: TrainingRelationshipPayload,
      params: RequestParams = {},
    ) =>
      this.request<TrainingSelectorDtoPaginatedList, any>({
        path: `/api/v1/LmsSelectors/TrainingRelationship`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém uma lista de treinamentos com material de apoio para cópia.
     *
     * @tags LmsSelectors
     * @name TrainingMaterialList
     * @request POST:/api/v1/LmsSelectors/TrainingMaterialList
     * @secure
     * @response `200` `TrainingSelectorDtoPaginatedList` OK
     */
    trainingMaterialList: (
      data: TrainingMaterialListPayload,
      params: RequestParams = {},
    ) =>
      this.request<TrainingSelectorDtoPaginatedList, any>({
        path: `/api/v1/LmsSelectors/TrainingMaterialList`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém uma lista de treinamento que o gestor tenha permissão de gestão de pelo menos um usuário.
     *
     * @tags LmsSelectors
     * @name TrainingEnrollment
     * @request POST:/api/v1/LmsSelectors/TrainingEnrollment
     * @secure
     * @response `200` `TrainingSelectorDtoPaginatedList` OK
     */
    trainingEnrollment: (
      data: TrainingEnrollmentPayload,
      params: RequestParams = {},
    ) =>
      this.request<TrainingSelectorDtoPaginatedList, any>({
        path: `/api/v1/LmsSelectors/TrainingEnrollment`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém lista de ranking da trilha de gamificação.
     *
     * @tags LmsSelectors
     * @name LpGameRankings
     * @request POST:/api/v1/LmsSelectors/LpGameRankings
     * @secure
     * @response `200` `LpGameRankingSelectorResponsePaginatedList` OK
     */
    lpGameRankings: (data: LpGameRankingsPayload, params: RequestParams = {}) =>
      this.request<LpGameRankingSelectorResponsePaginatedList, any>({
        path: `/api/v1/LmsSelectors/LpGameRankings`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém uma Lista de Subordinados diretos e indiretos do gerente que podem ser inscritos em treinamentos.
     *
     * @tags LmsSelectors
     * @name TrainingEnrollSubordinates
     * @request POST:/api/v1/LmsSelectors/TrainingEnrollSubordinates
     * @secure
     * @response `200` `SubordinateSelectorResponsePaginatedList` OK
     */
    trainingEnrollSubordinates: (
      data: TrainingEnrollSubordinatesPayload,
      params: RequestParams = {},
    ) =>
      this.request<SubordinateSelectorResponsePaginatedList, any>({
        path: `/api/v1/LmsSelectors/TrainingEnrollSubordinates`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém a lista de conteúdo do treinamento.
     *
     * @tags LmsSelectors
     * @name TrainingContentTypes
     * @request GET:/api/v1/LmsSelectors/TrainingContentTypes
     * @secure
     * @response `200` `(TrainingContentTypeResponse)[]` OK
     */
    trainingContentTypes: (params: RequestParams = {}) =>
      this.request<TrainingContentTypeResponse[], any>({
        path: `/api/v1/LmsSelectors/TrainingContentTypes`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  lmsSettings = {
    /**
     * Obtém a lista de Callout's do LMS.
     *
     * @tags LmsSettings
     * @name GetLmsCallouts
     * @request POST:/api/v1/LmsSettings/GetLmsCallouts
     * @secure
     * @response `200` `(CalloutDto)[]` OK
     */
    getLmsCallouts: (params: RequestParams = {}) =>
      this.request<CalloutDto[], any>({
        path: `/api/v1/LmsSettings/GetLmsCallouts`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Obtém Registro de configuração do módulo de Lms.
     *
     * @tags LmsSettings
     * @name GetLmsSettings
     * @request GET:/api/v1/LmsSettings/GetLmsSettings
     * @secure
     * @response `200` `LmsSettingsResponse` OK
     */
    getLmsSettings: (params: RequestParams = {}) =>
      this.request<LmsSettingsResponse, any>({
        path: `/api/v1/LmsSettings/GetLmsSettings`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Obtém Registro de configuração do Indice de Treinamento.
     *
     * @tags LmsSettings
     * @name GetLmSettingIndexTraining
     * @request GET:/api/v1/LmsSettings/GetLmSettingIndexTraining
     * @secure
     * @response `200` `LmsSettingIndexTrainingResponse` OK
     */
    getLmSettingIndexTraining: (params: RequestParams = {}) =>
      this.request<LmsSettingIndexTrainingResponse, any>({
        path: `/api/v1/LmsSettings/GetLmSettingIndexTraining`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Obtém Registro de configuração de Premiação para o módulo de treinamento.
     *
     * @tags LmsSettings
     * @name GetLmsSettingAward
     * @request GET:/api/v1/LmsSettings/GetLmsSettingAward
     * @secure
     * @response `200` `LmsSettingAwardResponse` OK
     */
    getLmsSettingAward: (params: RequestParams = {}) =>
      this.request<LmsSettingAwardResponse, any>({
        path: `/api/v1/LmsSettings/GetLmsSettingAward`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Obtém Registro de configuração de Desafios de Conhecimento.
     *
     * @tags LmsSettings
     * @name GetLmsSettingChallenge
     * @request GET:/api/v1/LmsSettings/GetLmsSettingChallenge
     * @secure
     * @response `200` `LmsSettingChallengeResponse` OK
     */
    getLmsSettingChallenge: (params: RequestParams = {}) =>
      this.request<LmsSettingChallengeResponse, any>({
        path: `/api/v1/LmsSettings/GetLmsSettingChallenge`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Obtém Registro de configuração de Lembretes do Módulo de Treinamento.
     *
     * @tags LmsSettings
     * @name GetLmsSettingReminder
     * @request GET:/api/v1/LmsSettings/GetLmsSettingReminder
     * @secure
     * @response `200` `LmsSettingReminderResponse` OK
     */
    getLmsSettingReminder: (params: RequestParams = {}) =>
      this.request<LmsSettingReminderResponse, any>({
        path: `/api/v1/LmsSettings/GetLmsSettingReminder`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Lista de locais de evento.
     *
     * @tags LmsSettings
     * @name GetListEventRoom
     * @request POST:/api/v1/LmsSettings/GetListEventRoom
     * @secure
     * @response `200` `MeetingRoomResponsePaginatedList` OK
     */
    getListEventRoom: (
      data: GetListEventRoomPayload,
      params: RequestParams = {},
    ) =>
      this.request<MeetingRoomResponsePaginatedList, any>({
        path: `/api/v1/LmsSettings/GetListEventRoom`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * LOcaliza um local de evento.
     *
     * @tags LmsSettings
     * @name GetMeetingRoom
     * @request POST:/api/v1/LmsSettings/GetMeetingRoom
     * @secure
     * @response `200` `MeetingRoomResponse` OK
     */
    getMeetingRoom: (data: GetMeetingRoomPayload, params: RequestParams = {}) =>
      this.request<MeetingRoomResponse, any>({
        path: `/api/v1/LmsSettings/GetMeetingRoom`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém Registro de configuração de Premiação para o módulo de treinamento.
     *
     * @tags LmsSettings
     * @name GetLmsAwardSettings
     * @request GET:/api/v1/LmsSettings/GetLmsAwardSettings
     * @secure
     * @response `200` `LmsSettingAwardResponse` OK
     */
    getLmsAwardSettings: (params: RequestParams = {}) =>
      this.request<LmsSettingAwardResponse, any>({
        path: `/api/v1/LmsSettings/GetLmsAwardSettings`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Obtém Configurações de interações.
     *
     * @tags LmsSettings
     * @name GetLmsRulesInteraction
     * @request GET:/api/v1/LmsSettings/GetLmsRulesInteraction
     * @secure
     * @response `200` `TrainingRulesInteractionDto` OK
     */
    getLmsRulesInteraction: (params: RequestParams = {}) =>
      this.request<TrainingRulesInteractionDto, any>({
        path: `/api/v1/LmsSettings/GetLmsRulesInteraction`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Obtém Configurações de ações do instrutor.
     *
     * @tags LmsSettings
     * @name GetLmsRulesInstructorAction
     * @request GET:/api/v1/LmsSettings/GetLmsRulesInstructorAction
     * @secure
     * @response `200` `TrainingRulesInstructorActionDto` OK
     */
    getLmsRulesInstructorAction: (params: RequestParams = {}) =>
      this.request<TrainingRulesInstructorActionDto, any>({
        path: `/api/v1/LmsSettings/GetLmsRulesInstructorAction`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Obtém Configurações de limites de Reinscrição.
     *
     * @tags LmsSettings
     * @name GetLmsRulesLimits
     * @request GET:/api/v1/LmsSettings/GetLmsRulesLimits
     * @secure
     * @response `200` `TrainingRulesAutoEnrollLimitsDto` OK
     */
    getLmsRulesLimits: (params: RequestParams = {}) =>
      this.request<TrainingRulesAutoEnrollLimitsDto, any>({
        path: `/api/v1/LmsSettings/GetLmsRulesLimits`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Obtém Configurações de premiação.
     *
     * @tags LmsSettings
     * @name GetLmsRulesAward
     * @request GET:/api/v1/LmsSettings/GetLmsRulesAward
     * @secure
     * @response `200` `TrainingRulesAwardDto` OK
     */
    getLmsRulesAward: (params: RequestParams = {}) =>
      this.request<TrainingRulesAwardDto, any>({
        path: `/api/v1/LmsSettings/GetLmsRulesAward`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Obtém Configurações de incrição e cancelamento.
     *
     * @tags LmsSettings
     * @name GetLmsRulesRegistration
     * @request GET:/api/v1/LmsSettings/GetLmsRulesRegistration
     * @secure
     * @response `200` `TrainingRulesRegistrationDto` OK
     */
    getLmsRulesRegistration: (params: RequestParams = {}) =>
      this.request<TrainingRulesRegistrationDto, any>({
        path: `/api/v1/LmsSettings/GetLmsRulesRegistration`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Obtém Configurações de Realização.
     *
     * @tags LmsSettings
     * @name GetLmsRulesExecution
     * @request GET:/api/v1/LmsSettings/GetLmsRulesExecution
     * @secure
     * @response `200` `TrainingRulesExecutionDto` OK
     */
    getLmsRulesExecution: (params: RequestParams = {}) =>
      this.request<TrainingRulesExecutionDto, any>({
        path: `/api/v1/LmsSettings/GetLmsRulesExecution`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Obtém Configurações de Avaliação de Reação e Eficácia.
     *
     * @tags LmsSettings
     * @name GetLmsRulesAssessment
     * @request GET:/api/v1/LmsSettings/GetLmsRulesAssessment
     * @secure
     * @response `200` `TrainingRulesAssessmentDto` OK
     */
    getLmsRulesAssessment: (params: RequestParams = {}) =>
      this.request<TrainingRulesAssessmentDto, any>({
        path: `/api/v1/LmsSettings/GetLmsRulesAssessment`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Obtém Configurações do Formulário de Conclusão (Curso Externo).
     *
     * @tags LmsSettings
     * @name GetLmsRulesConclusionForm
     * @request GET:/api/v1/LmsSettings/GetLmsRulesConclusionForm
     * @secure
     * @response `200` `TrainingRulesConclusionFormDto` OK
     */
    getLmsRulesConclusionForm: (params: RequestParams = {}) =>
      this.request<TrainingRulesConclusionFormDto, any>({
        path: `/api/v1/LmsSettings/GetLmsRulesConclusionForm`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Obtém Configurações de Reinscrição Automática (Trilha).
     *
     * @tags LmsSettings
     * @name GetLmsRulesLpReEnroll
     * @request GET:/api/v1/LmsSettings/GetLmsRulesLpReEnroll
     * @secure
     * @response `200` `LearnPathRulesReEnrollDto` OK
     */
    getLmsRulesLpReEnroll: (params: RequestParams = {}) =>
      this.request<LearnPathRulesReEnrollDto, any>({
        path: `/api/v1/LmsSettings/GetLmsRulesLpReEnroll`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Obtém Configurações de Inscrição em Componentes da Trilha.
     *
     * @tags LmsSettings
     * @name GetLmsRulesLpComponentRegistration
     * @request GET:/api/v1/LmsSettings/GetLmsRulesLpComponentRegistration
     * @secure
     * @response `200` `LearnPathRulesComponentRegistrationDto` OK
     */
    getLmsRulesLpComponentRegistration: (params: RequestParams = {}) =>
      this.request<LearnPathRulesComponentRegistrationDto, any>({
        path: `/api/v1/LmsSettings/GetLmsRulesLpComponentRegistration`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Obtém Configurações de Condições de Aprovação da Trilha.
     *
     * @tags LmsSettings
     * @name GetLmsRulesLpApproval
     * @request GET:/api/v1/LmsSettings/GetLmsRulesLpApproval
     * @secure
     * @response `200` `LearnPathRulesApprovalDto` OK
     */
    getLmsRulesLpApproval: (params: RequestParams = {}) =>
      this.request<LearnPathRulesApprovalDto, any>({
        path: `/api/v1/LmsSettings/GetLmsRulesLpApproval`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Obtém Configurações de Condições de Aprovação da Trilha.
     *
     * @tags LmsSettings
     * @name GetLmsRulesApproval
     * @request GET:/api/v1/LmsSettings/GetLmsRulesApproval
     * @secure
     * @response `200` `TrainingRulesApprovalRulesDto` OK
     */
    getLmsRulesApproval: (params: RequestParams = {}) =>
      this.request<TrainingRulesApprovalRulesDto, any>({
        path: `/api/v1/LmsSettings/GetLmsRulesApproval`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Obtém Configurações de Certificate e Validade.
     *
     * @tags LmsSettings
     * @name GetLmsRulesCertificate
     * @request GET:/api/v1/LmsSettings/GetLmsRulesCertificate
     * @secure
     * @response `200` `TrainingRulesCertificateDto` OK
     */
    getLmsRulesCertificate: (params: RequestParams = {}) =>
      this.request<TrainingRulesCertificateDto, any>({
        path: `/api/v1/LmsSettings/GetLmsRulesCertificate`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Salva o registro de configuração da Personalização do Módulo de Treinamento.
     *
     * @tags LmsSettings
     * @name SaveSettings
     * @request POST:/api/v1/LmsSettings/SaveSettings
     * @secure
     * @response `200` `boolean` OK
     */
    saveSettings: (data: SaveSettingsPayload, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/api/v1/LmsSettings/SaveSettings`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém preview do certificado padrão de treinamento.
     *
     * @tags LmsSettings
     * @name GetDefaultCertificatePreview
     * @request GET:/api/v1/LmsSettings/GetDefaultCertificatePreview
     * @secure
     * @response `200` `any` OK
     */
    getDefaultCertificatePreview: (params: RequestParams = {}) =>
      this.request<any, any>({
        path: `/api/v1/LmsSettings/GetDefaultCertificatePreview`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * Salva o registro de configuração da Personalização dos lembretes do Módulo de Treinamento.
     *
     * @tags LmsSettings
     * @name SaveReminder
     * @request POST:/api/v1/LmsSettings/SaveReminder
     * @secure
     * @response `200` `boolean` OK
     */
    saveReminder: (data: SaveReminderPayload, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/api/v1/LmsSettings/SaveReminder`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Salva o registro de configuração da Personalização de testes de conhecimento do Módulo de Treinamento.
     *
     * @tags LmsSettings
     * @name SaveKnowledgeTest
     * @request POST:/api/v1/LmsSettings/SaveKnowledgeTest
     * @secure
     * @response `200` `boolean` OK
     */
    saveKnowledgeTest: (
      data: SaveKnowledgeTestPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/LmsSettings/SaveKnowledgeTest`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Salva o registro de configuração da personalização do Indice de treinamento do Módulo de Treinamento.
     *
     * @tags LmsSettings
     * @name SaveIndexTrainingSettings
     * @request POST:/api/v1/LmsSettings/SaveIndexTrainingSettings
     * @secure
     * @response `200` `boolean` OK
     */
    saveIndexTrainingSettings: (
      data: SaveIndexTrainingSettingsPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/LmsSettings/SaveIndexTrainingSettings`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Solicita execução emergencial do índice de treinamento.
     *
     * @tags LmsSettings
     * @name RequestTrainingIndexExecution
     * @request POST:/api/v1/LmsSettings/RequestTrainingIndexExecution
     * @secure
     * @response `200` `boolean` OK
     */
    requestTrainingIndexExecution: (
      data: RequestTrainingIndexExecutionPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/LmsSettings/RequestTrainingIndexExecution`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * (Guid) Cria um local de um reunião (Evento Presencial).
     *
     * @tags LmsSettings
     * @name CreateMeetingRoom
     * @request POST:/api/v1/LmsSettings/CreateMeetingRoom
     * @secure
     * @response `200` `string | null` OK (May return null)
     * @response `204` `any` No Content
     */
    createMeetingRoom: (
      data: CreateMeetingRoomPayload,
      params: RequestParams = {},
    ) =>
      this.request<string | null, any>({
        path: `/api/v1/LmsSettings/CreateMeetingRoom`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Altera um local de um reunião (Evento Presencial).
     *
     * @tags LmsSettings
     * @name UpdateMeetingRoom
     * @request POST:/api/v1/LmsSettings/UpdateMeetingRoom
     * @secure
     * @response `200` `boolean` OK
     */
    updateMeetingRoom: (
      data: UpdateMeetingRoomPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/LmsSettings/UpdateMeetingRoom`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Exclui um local de um reunião (Evento Presencial).
     *
     * @tags LmsSettings
     * @name DeleteMeetingRoom
     * @request POST:/api/v1/LmsSettings/DeleteMeetingRoom
     * @secure
     * @response `200` `boolean` OK
     */
    deleteMeetingRoom: (
      data: DeleteMeetingRoomPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/LmsSettings/DeleteMeetingRoom`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Salva o registro de configuração de premiações do módulo de treinamento.
     *
     * @tags LmsSettings
     * @name SaveAwardSettings
     * @request POST:/api/v1/LmsSettings/SaveAwardSettings
     * @secure
     * @response `200` `boolean` OK
     */
    saveAwardSettings: (
      data: SaveAwardSettingsPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/LmsSettings/SaveAwardSettings`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Salva regras configuração padrão de Interações.
     *
     * @tags LmsSettings
     * @name SaveRulesInteractionSettings
     * @request POST:/api/v1/LmsSettings/SaveRulesInteractionSettings
     * @secure
     * @response `200` `TrainingRulesInteractionDto` OK (May return null)
     * @response `204` `any` No Content
     */
    saveRulesInteractionSettings: (
      data: SaveRulesInteractionSettingsPayload,
      params: RequestParams = {},
    ) =>
      this.request<TrainingRulesInteractionDto, any>({
        path: `/api/v1/LmsSettings/SaveRulesInteractionSettings`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Salva regras configuração padrão de Ações do Instrutor.
     *
     * @tags LmsSettings
     * @name SaveRulesInstructorActionSettings
     * @request POST:/api/v1/LmsSettings/SaveRulesInstructorActionSettings
     * @secure
     * @response `200` `TrainingRulesInstructorActionDto` OK (May return null)
     * @response `204` `any` No Content
     */
    saveRulesInstructorActionSettings: (
      data: SaveRulesInstructorActionSettingsPayload,
      params: RequestParams = {},
    ) =>
      this.request<TrainingRulesInstructorActionDto, any>({
        path: `/api/v1/LmsSettings/SaveRulesInstructorActionSettings`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Salva regras de Limites para Reinscrição do Treinamento.
     *
     * @tags LmsSettings
     * @name SaveRulesLimitsSettings
     * @request POST:/api/v1/LmsSettings/SaveRulesLimitsSettings
     * @secure
     * @response `200` `TrainingRulesAutoEnrollLimitsDto` OK (May return null)
     * @response `204` `any` No Content
     */
    saveRulesLimitsSettings: (
      data: SaveRulesLimitsSettingsPayload,
      params: RequestParams = {},
    ) =>
      this.request<TrainingRulesAutoEnrollLimitsDto, any>({
        path: `/api/v1/LmsSettings/SaveRulesLimitsSettings`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Salva configuração padrão de regras de premiação para o treinamento.
     *
     * @tags LmsSettings
     * @name SaveRulesAwardSettings
     * @request POST:/api/v1/LmsSettings/SaveRulesAwardSettings
     * @secure
     * @response `200` `TrainingRulesAwardDto` OK (May return null)
     * @response `204` `any` No Content
     */
    saveRulesAwardSettings: (
      data: SaveRulesAwardSettingsPayload,
      params: RequestParams = {},
    ) =>
      this.request<TrainingRulesAwardDto, any>({
        path: `/api/v1/LmsSettings/SaveRulesAwardSettings`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Salva regras configuração padrão de Inscrição e Cancelamento.
     *
     * @tags LmsSettings
     * @name SaveRulesRegistrationSettings
     * @request POST:/api/v1/LmsSettings/SaveRulesRegistrationSettings
     * @secure
     * @response `200` `TrainingRulesRegistrationDto` OK (May return null)
     * @response `204` `any` No Content
     */
    saveRulesRegistrationSettings: (
      data: SaveRulesRegistrationSettingsPayload,
      params: RequestParams = {},
    ) =>
      this.request<TrainingRulesRegistrationDto, any>({
        path: `/api/v1/LmsSettings/SaveRulesRegistrationSettings`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Salva regras configuração padrão de Realização.
     *
     * @tags LmsSettings
     * @name SaveRulesExecutionSettings
     * @request POST:/api/v1/LmsSettings/SaveRulesExecutionSettings
     * @secure
     * @response `200` `TrainingRulesExecutionDto` OK (May return null)
     * @response `204` `any` No Content
     */
    saveRulesExecutionSettings: (
      data: SaveRulesExecutionSettingsPayload,
      params: RequestParams = {},
    ) =>
      this.request<TrainingRulesExecutionDto, any>({
        path: `/api/v1/LmsSettings/SaveRulesExecutionSettings`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Salva regras configuração padrão de Avaliação de Reação e Eficácia.
     *
     * @tags LmsSettings
     * @name SaveRulesAssessmentSettings
     * @request POST:/api/v1/LmsSettings/SaveRulesAssessmentSettings
     * @secure
     * @response `200` `TrainingRulesAssessmentDto` OK (May return null)
     * @response `204` `any` No Content
     */
    saveRulesAssessmentSettings: (
      data: SaveRulesAssessmentSettingsPayload,
      params: RequestParams = {},
    ) =>
      this.request<TrainingRulesAssessmentDto, any>({
        path: `/api/v1/LmsSettings/SaveRulesAssessmentSettings`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Salva regras configuração padrão do Formulário de Conclusão (Curso Externo).
     *
     * @tags LmsSettings
     * @name SaveRulesConclusionFormSettings
     * @request POST:/api/v1/LmsSettings/SaveRulesConclusionFormSettings
     * @secure
     * @response `200` `TrainingRulesConclusionFormDto` OK (May return null)
     * @response `204` `any` No Content
     */
    saveRulesConclusionFormSettings: (
      data: SaveRulesConclusionFormSettingsPayload,
      params: RequestParams = {},
    ) =>
      this.request<TrainingRulesConclusionFormDto, any>({
        path: `/api/v1/LmsSettings/SaveRulesConclusionFormSettings`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Salva regras configuração padrão de Reinscrição Automática (Trilha).
     *
     * @tags LmsSettings
     * @name SaveRulesLpReEnrollSettings
     * @request POST:/api/v1/LmsSettings/SaveRulesLpReEnrollSettings
     * @secure
     * @response `200` `LearnPathRulesReEnrollDto` OK (May return null)
     * @response `204` `any` No Content
     */
    saveRulesLpReEnrollSettings: (
      data: SaveRulesLpReEnrollSettingsPayload,
      params: RequestParams = {},
    ) =>
      this.request<LearnPathRulesReEnrollDto, any>({
        path: `/api/v1/LmsSettings/SaveRulesLpReEnrollSettings`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Salva regras configuração padrão de Inscrição em Componentes da Trilha.
     *
     * @tags LmsSettings
     * @name SaveRulesLpComponentRegistrationSettings
     * @request POST:/api/v1/LmsSettings/SaveRulesLpComponentRegistrationSettings
     * @secure
     * @response `200` `LearnPathRulesComponentRegistrationDto` OK (May return null)
     * @response `204` `any` No Content
     */
    saveRulesLpComponentRegistrationSettings: (
      data: SaveRulesLpComponentRegistrationSettingsPayload,
      params: RequestParams = {},
    ) =>
      this.request<LearnPathRulesComponentRegistrationDto, any>({
        path: `/api/v1/LmsSettings/SaveRulesLpComponentRegistrationSettings`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Salva regras configuração padrão de Condições de Aprovação (Trilha).
     *
     * @tags LmsSettings
     * @name SaveRulesLpApprovalSettings
     * @request POST:/api/v1/LmsSettings/SaveRulesLpApprovalSettings
     * @secure
     * @response `200` `LearnPathRulesApprovalDto` OK (May return null)
     * @response `204` `any` No Content
     */
    saveRulesLpApprovalSettings: (
      data: SaveRulesLpApprovalSettingsPayload,
      params: RequestParams = {},
    ) =>
      this.request<LearnPathRulesApprovalDto, any>({
        path: `/api/v1/LmsSettings/SaveRulesLpApprovalSettings`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Salva regras configuração padrão de Condições de Aprovação.
     *
     * @tags LmsSettings
     * @name SaveRulesApprovalSettings
     * @request POST:/api/v1/LmsSettings/SaveRulesApprovalSettings
     * @secure
     * @response `200` `TrainingRulesApprovalRulesDto` OK (May return null)
     * @response `204` `any` No Content
     */
    saveRulesApprovalSettings: (
      data: SaveRulesApprovalSettingsPayload,
      params: RequestParams = {},
    ) =>
      this.request<TrainingRulesApprovalRulesDto, any>({
        path: `/api/v1/LmsSettings/SaveRulesApprovalSettings`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Salva regras configuração padrão de Certificado e Validade.
     *
     * @tags LmsSettings
     * @name SaveRulesCertificateSettings
     * @request POST:/api/v1/LmsSettings/SaveRulesCertificateSettings
     * @secure
     * @response `200` `TrainingRulesCertificateDto` OK (May return null)
     * @response `204` `any` No Content
     */
    saveRulesCertificateSettings: (
      data: SaveRulesCertificateSettingsPayload,
      params: RequestParams = {},
    ) =>
      this.request<TrainingRulesCertificateDto, any>({
        path: `/api/v1/LmsSettings/SaveRulesCertificateSettings`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  lmsStudent = {
    /**
     * Carrossel: Treinamentos em Andamento.
     *
     * @tags LmsStudent
     * @name GetCarouselTrainingAttending
     * @request POST:/api/v1/LmsStudent/GetCarouselTrainingAttending
     * @secure
     * @response `200` `(CardDto)[]` OK
     */
    getCarouselTrainingAttending: (
      data: GetCarouselTrainingAttendingPayload,
      params: RequestParams = {},
    ) =>
      this.request<CardDto[], any>({
        path: `/api/v1/LmsStudent/GetCarouselTrainingAttending`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Carrossel: Treinamentos Obrigatórios.
     *
     * @tags LmsStudent
     * @name GetCarouselTrainingMandatory
     * @request POST:/api/v1/LmsStudent/GetCarouselTrainingMandatory
     * @secure
     * @response `200` `(CardDto)[]` OK
     */
    getCarouselTrainingMandatory: (
      data: GetCarouselTrainingMandatoryPayload,
      params: RequestParams = {},
    ) =>
      this.request<CardDto[], any>({
        path: `/api/v1/LmsStudent/GetCarouselTrainingMandatory`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém o catálogo de treinamento para usuário logado.
     *
     * @tags LmsStudent
     * @name GetCatalog
     * @request POST:/api/v1/LmsStudent/GetCatalog
     * @secure
     * @response `200` `CardDtoPaginatedList` OK
     */
    getCatalog: (data: GetCatalogPayload, params: RequestParams = {}) =>
      this.request<CardDtoPaginatedList, any>({
        path: `/api/v1/LmsStudent/GetCatalog`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém as informações iniciais para montagem do menu do catálogo de treinamento para usuário logado.
     *
     * @tags LmsStudent
     * @name GetCatalogSetup
     * @request GET:/api/v1/LmsStudent/GetCatalogSetup
     * @secure
     * @response `200` `CatalogSetupResponse` OK
     */
    getCatalogSetup: (params: RequestParams = {}) =>
      this.request<CatalogSetupResponse, any>({
        path: `/api/v1/LmsStudent/GetCatalogSetup`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Obtém os treinamentos de um tópico.
     *
     * @tags LmsStudent
     * @name GetTopicTrainings
     * @request POST:/api/v1/LmsStudent/GetTopicTrainings
     * @secure
     * @response `200` `CardDtoPaginatedList` OK
     */
    getTopicTrainings: (
      data: GetTopicTrainingsPayload,
      params: RequestParams = {},
    ) =>
      this.request<CardDtoPaginatedList, any>({
        path: `/api/v1/LmsStudent/GetTopicTrainings`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Lista de treinamentos disponíveis para o usuário.
     *
     * @tags LmsStudent
     * @name GetAvailableTrainings
     * @request POST:/api/v1/LmsStudent/GetAvailableTrainings
     * @secure
     * @response `200` `CardDtoPaginatedList` OK
     */
    getAvailableTrainings: (
      data: GetAvailableTrainingsPayload,
      params: RequestParams = {},
    ) =>
      this.request<CardDtoPaginatedList, any>({
        path: `/api/v1/LmsStudent/GetAvailableTrainings`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Lista de treinamentos que o usuário está participando.
     *
     * @tags LmsStudent
     * @name GetAttendingTrainings
     * @request POST:/api/v1/LmsStudent/GetAttendingTrainings
     * @secure
     * @response `200` `CardDtoPaginatedList` OK
     */
    getAttendingTrainings: (
      data: GetAttendingTrainingsPayload,
      params: RequestParams = {},
    ) =>
      this.request<CardDtoPaginatedList, any>({
        path: `/api/v1/LmsStudent/GetAttendingTrainings`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Lista de treinamentos que o usuário finalizou.
     *
     * @tags LmsStudent
     * @name GetFinishedTrainings
     * @request POST:/api/v1/LmsStudent/GetFinishedTrainings
     * @secure
     * @response `200` `CardDtoPaginatedList` OK
     */
    getFinishedTrainings: (
      data: GetFinishedTrainingsPayload,
      params: RequestParams = {},
    ) =>
      this.request<CardDtoPaginatedList, any>({
        path: `/api/v1/LmsStudent/GetFinishedTrainings`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Biblioteca de treinamentos do usuário.
     *
     * @tags LmsStudent
     * @name GetLibrary
     * @request POST:/api/v1/LmsStudent/GetLibrary
     * @secure
     * @response `200` `CardDtoPaginatedList` OK
     */
    getLibrary: (data: GetLibraryPayload, params: RequestParams = {}) =>
      this.request<CardDtoPaginatedList, any>({
        path: `/api/v1/LmsStudent/GetLibrary`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Lista histórico de treinamentos.
     *
     * @tags LmsStudent
     * @name GetHistory
     * @request POST:/api/v1/LmsStudent/GetHistory
     * @secure
     * @response `200` `EnrollmentHistoryDtoPaginatedList` OK
     */
    getHistory: (data: GetHistoryPayload, params: RequestParams = {}) =>
      this.request<EnrollmentHistoryDtoPaginatedList, any>({
        path: `/api/v1/LmsStudent/GetHistory`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém item do histórico.
     *
     * @tags LmsStudent
     * @name GetHistoryItem
     * @request POST:/api/v1/LmsStudent/GetHistoryItem
     * @secure
     * @response `200` `EnrollmentHistoryDto` OK (May return null)
     * @response `204` `any` No Content
     */
    getHistoryItem: (data: GetHistoryItemPayload, params: RequestParams = {}) =>
      this.request<EnrollmentHistoryDto, any>({
        path: `/api/v1/LmsStudent/GetHistoryItem`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Calendário de eventos do usuário.
     *
     * @tags LmsStudent
     * @name GetCalendar
     * @request POST:/api/v1/LmsStudent/GetCalendar
     * @secure
     * @response `200` `(AppointmentDayDto)[]` OK
     */
    getCalendar: (data: GetCalendarBody, params: RequestParams = {}) =>
      this.request<AppointmentDayDto[], any>({
        path: `/api/v1/LmsStudent/GetCalendar`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Lista eventos do usuário.
     *
     * @tags LmsStudent
     * @name GetCalendarAppointments
     * @request POST:/api/v1/LmsStudent/GetCalendarAppointments
     * @secure
     * @response `200` `AppointmentDtoPaginatedList` OK
     */
    getCalendarAppointments: (
      data: GetCalendarAppointmentsPayload,
      params: RequestParams = {},
    ) =>
      this.request<AppointmentDtoPaginatedList, any>({
        path: `/api/v1/LmsStudent/GetCalendarAppointments`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Verifica se usuário foi/é instrutor de eventos.
     *
     * @tags LmsStudent
     * @name IsMeetingInstructor
     * @request POST:/api/v1/LmsStudent/IsMeetingInstructor
     * @secure
     * @response `200` `boolean` OK
     */
    isMeetingInstructor: (
      data: IsMeetingInstructorPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/LmsStudent/IsMeetingInstructor`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Registra interação no treinamento.
     *
     * @tags LmsStudent
     * @name UserInteraction
     * @request POST:/api/v1/LmsStudent/UserInteraction
     * @secure
     * @response `200` `boolean` OK
     */
    userInteraction: (
      data: UserInteractionPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/LmsStudent/UserInteraction`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Cria recomendação de uma publicação a usuários ou grupos.
     *
     * @tags LmsStudent
     * @name AddRecommendation
     * @request POST:/api/v1/LmsStudent/AddRecommendation
     * @secure
     * @response `200` `boolean` OK
     */
    addRecommendation: (
      data: AddRecommendationBody,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/LmsStudent/AddRecommendation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Compartilha um treinamento em uma Lista ou um Canal.
     *
     * @tags LmsStudent
     * @name ShareTraining
     * @request POST:/api/v1/LmsStudent/ShareTraining
     * @secure
     * @response `200` `boolean` OK
     */
    shareTraining: (data: ShareTrainingPayload, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/api/v1/LmsStudent/ShareTraining`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Registra acesso a Callout da área de LMS.
     *
     * @tags LmsStudent
     * @name SaveCallout
     * @request POST:/api/v1/LmsStudent/SaveCallout
     * @secure
     * @response `200` `boolean` OK
     */
    saveCallout: (data: SaveCalloutPayload, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/api/v1/LmsStudent/SaveCallout`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  lmsSuggestions = {
    /**
     * Obtém lista de treinamentos.
     *
     * @tags LmsSuggestions
     * @name Trainings
     * @request POST:/api/v1/LmsSuggestions/Trainings
     * @secure
     * @response `200` `TrainingAutoCompleteDataModelDtoPaginatedList` OK
     */
    trainings: (data: TrainingsBody, params: RequestParams = {}) =>
      this.request<TrainingAutoCompleteDataModelDtoPaginatedList, any>({
        path: `/api/v1/LmsSuggestions/Trainings`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém lista de turmas de um treinamento.
     *
     * @tags LmsSuggestions
     * @name Classrooms
     * @request POST:/api/v1/LmsSuggestions/Classrooms
     * @secure
     * @response `200` `AutoCompleteDataModelDtoPaginatedList` OK
     */
    classrooms: (data: ClassroomsPayload, params: RequestParams = {}) =>
      this.request<AutoCompleteDataModelDtoPaginatedList, any>({
        path: `/api/v1/LmsSuggestions/Classrooms`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém instrutores para o treinamento.
     *
     * @tags LmsSuggestions
     * @name TrainingInstructors
     * @request POST:/api/v1/LmsSuggestions/TrainingInstructors
     * @secure
     * @response `200` `AutoCompleteDataModelDtoPaginatedList` OK
     */
    trainingInstructors: (
      data: TrainingInstructorsPayload,
      params: RequestParams = {},
    ) =>
      this.request<AutoCompleteDataModelDtoPaginatedList, any>({
        path: `/api/v1/LmsSuggestions/TrainingInstructors`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém instrutores para a turma.
     *
     * @tags LmsSuggestions
     * @name ClassroomInstructors
     * @request POST:/api/v1/LmsSuggestions/ClassroomInstructors
     * @secure
     * @response `200` `AutoCompleteDataModelDtoPaginatedList` OK
     */
    classroomInstructors: (
      data: ClassroomInstructorsPayload,
      params: RequestParams = {},
    ) =>
      this.request<AutoCompleteDataModelDtoPaginatedList, any>({
        path: `/api/v1/LmsSuggestions/ClassroomInstructors`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém instrutores disponíveis para seleção de um coordenador de treinamento.
     *
     * @tags LmsSuggestions
     * @name SupervisorInstructors
     * @request POST:/api/v1/LmsSuggestions/SupervisorInstructors
     * @secure
     * @response `200` `AutoCompleteDataModelDtoPaginatedList` OK
     */
    supervisorInstructors: (
      data: SupervisorInstructorsPayload,
      params: RequestParams = {},
    ) =>
      this.request<AutoCompleteDataModelDtoPaginatedList, any>({
        path: `/api/v1/LmsSuggestions/SupervisorInstructors`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém a lista de componentes da Versão do Treinamento.
     *
     * @tags LmsSuggestions
     * @name TrainingVersionComponents
     * @request POST:/api/v1/LmsSuggestions/TrainingVersionComponents
     * @secure
     * @response `200` `(AutoCompleteDataModelDto)[]` OK
     */
    trainingVersionComponents: (
      data: TrainingVersionComponentsPayload,
      params: RequestParams = {},
    ) =>
      this.request<AutoCompleteDataModelDto[], any>({
        path: `/api/v1/LmsSuggestions/TrainingVersionComponents`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém lista de locais de treinamento.
     *
     * @tags LmsSuggestions
     * @name MeetingRooms
     * @request POST:/api/v1/LmsSuggestions/MeetingRooms
     * @secure
     * @response `200` `MeetingRoomAutoCompleteDataModelDtoPaginatedList` OK
     */
    meetingRooms: (data: MeetingRoomsPayload, params: RequestParams = {}) =>
      this.request<MeetingRoomAutoCompleteDataModelDtoPaginatedList, any>({
        path: `/api/v1/LmsSuggestions/MeetingRooms`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Grupo de Questões (sugestão hierárquica).
     *
     * @tags LmsSuggestions
     * @name QuestionGroupHierarchical
     * @request POST:/api/v1/LmsSuggestions/QuestionGroupHierarchical
     * @secure
     * @response `200` `AutoCompleteHierarchicalModelDtoPaginatedList` OK
     */
    questionGroupHierarchical: (
      data: QuestionGroupHierarchicalPayload,
      params: RequestParams = {},
    ) =>
      this.request<AutoCompleteHierarchicalModelDtoPaginatedList, any>({
        path: `/api/v1/LmsSuggestions/QuestionGroupHierarchical`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém lista de usuários inscritos em uma turma ou instrutoreas para sugestão em discussão.
     *
     * @tags LmsSuggestions
     * @name UserDiscussionSuggestions
     * @request POST:/api/v1/LmsSuggestions/UserDiscussionSuggestions
     * @secure
     * @response `200` `AutoCompleteDataModelDtoPaginatedList` OK
     */
    userDiscussionSuggestions: (
      data: UserDiscussionSuggestionsPayload,
      params: RequestParams = {},
    ) =>
      this.request<AutoCompleteDataModelDtoPaginatedList, any>({
        path: `/api/v1/LmsSuggestions/UserDiscussionSuggestions`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém a lista de componentes da última versão do Treinamento.
     *
     * @tags LmsSuggestions
     * @name LpGameScoreComponents
     * @request POST:/api/v1/LmsSuggestions/LpGameScoreComponents
     * @secure
     * @response `200` `(AutoCompleteDataModelDto)[]` OK
     */
    lpGameScoreComponents: (
      data: LpGameScoreComponentsPayload,
      params: RequestParams = {},
    ) =>
      this.request<AutoCompleteDataModelDto[], any>({
        path: `/api/v1/LmsSuggestions/LpGameScoreComponents`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém uma lista de usuários do público-alvo do treinamento.
     *
     * @tags LmsSuggestions
     * @name AudienceUserSuggestions
     * @request POST:/api/v1/LmsSuggestions/AudienceUserSuggestions
     * @secure
     * @response `200` `AutoCompleteDataModelDtoPaginatedList` OK
     */
    audienceUserSuggestions: (
      data: AudienceUserSuggestionsPayload,
      params: RequestParams = {},
    ) =>
      this.request<AutoCompleteDataModelDtoPaginatedList, any>({
        path: `/api/v1/LmsSuggestions/AudienceUserSuggestions`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém uma lista de Motivos de Cancelamento de Inscrições.
     *
     * @tags LmsSuggestions
     * @name CancelEnrollReasonSuggestions
     * @request POST:/api/v1/LmsSuggestions/CancelEnrollReasonSuggestions
     * @secure
     * @response `200` `AutoCompleteDataModelDtoPaginatedList` OK
     */
    cancelEnrollReasonSuggestions: (
      data: CancelEnrollReasonSuggestionsPayload,
      params: RequestParams = {},
    ) =>
      this.request<AutoCompleteDataModelDtoPaginatedList, any>({
        path: `/api/v1/LmsSuggestions/CancelEnrollReasonSuggestions`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  lmsTraining = {
    /**
     * Descobre informações do treinamento e se existe inscrição para o usuário logado.
     *
     * @tags LmsTraining
     * @name DiscoverUserTrainingInfo
     * @request POST:/api/v1/LmsTraining/DiscoverUserTrainingInfo
     * @secure
     * @response `200` `DiscoverUserTrainingInfoResponse` OK (May return null)
     * @response `204` `any` No Content
     */
    discoverUserTrainingInfo: (
      data: DiscoverUserTrainingInfoPayload,
      params: RequestParams = {},
    ) =>
      this.request<DiscoverUserTrainingInfoResponse, any>({
        path: `/api/v1/LmsTraining/DiscoverUserTrainingInfo`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém o registro do treinamento do tipo CURSO.
     *
     * @tags LmsTraining
     * @name GetTrainingView
     * @request POST:/api/v1/LmsTraining/GetTrainingView
     * @secure
     * @response `200` `TrainingViewDto` OK
     */
    getTrainingView: (
      data: GetTrainingViewPayload,
      params: RequestParams = {},
    ) =>
      this.request<TrainingViewDto, any>({
        path: `/api/v1/LmsTraining/GetTrainingView`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém preview de uma Inscrição no Treinamento.
     *
     * @tags LmsTraining
     * @name GetTrainingPreview
     * @request POST:/api/v1/LmsTraining/GetTrainingPreview
     * @secure
     * @response `200` `EnrollmentViewDto` OK
     */
    getTrainingPreview: (
      data: GetTrainingPreviewPayload,
      params: RequestParams = {},
    ) =>
      this.request<EnrollmentViewDto, any>({
        path: `/api/v1/LmsTraining/GetTrainingPreview`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém as turmas de um treinamento.
     *
     * @tags LmsTraining
     * @name GetClassroomsView
     * @request POST:/api/v1/LmsTraining/GetClassroomsView
     * @secure
     * @response `200` `(ClassroomViewDto)[]` OK
     */
    getClassroomsView: (
      data: GetClassroomsViewPayload,
      params: RequestParams = {},
    ) =>
      this.request<ClassroomViewDto[], any>({
        path: `/api/v1/LmsTraining/GetClassroomsView`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Fases da Trilha.
     *
     * @tags LmsTraining
     * @name GetLearnPathPhasesView
     * @request POST:/api/v1/LmsTraining/GetLearnPathPhasesView
     * @secure
     * @response `200` `(LearnPathViewPhaseDto)[]` OK
     */
    getLearnPathPhasesView: (
      data: GetLearnPathPhasesViewPayload,
      params: RequestParams = {},
    ) =>
      this.request<LearnPathViewPhaseDto[], any>({
        path: `/api/v1/LmsTraining/GetLearnPathPhasesView`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém lista de opiniões do treinamento.
     *
     * @tags LmsTraining
     * @name GetRatings
     * @request GET:/api/v1/LmsTraining/GetRatings
     * @secure
     * @response `200` `TrainingRatingsResponse` OK
     */
    getRatings: (
      query?: {
        /** @format uuid */
        TrainingId?: string;
        /** @format uuid */
        ClassroomId?: string;
        SearchText?: string;
        OrderBy?: TrainingRatingsOrderBy;
        /** @format int32 */
        PageNumber?: number;
        /** @format int32 */
        PageSize?: number;
        /** @format int32 */
        Offset?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<TrainingRatingsResponse, any>({
        path: `/api/v1/LmsTraining/GetRatings`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Obtém as informações para apresentar dados do content do card de avaliação.
     *
     * @tags LmsTraining
     * @name GetTrainingAssessmentItem
     * @request POST:/api/v1/LmsTraining/GetTrainingAssessmentItem
     * @secure
     * @response `200` `TrainingAssessmentItemDto` OK
     */
    getTrainingAssessmentItem: (
      data: GetTrainingAssessmentItemPayload,
      params: RequestParams = {},
    ) =>
      this.request<TrainingAssessmentItemDto, any>({
        path: `/api/v1/LmsTraining/GetTrainingAssessmentItem`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Registra o aceite do acordo de uso do treinamento pelo usuário.
     *
     * @tags LmsTraining
     * @name TrainingSetAgreement
     * @request POST:/api/v1/LmsTraining/TrainingSetAgreement
     * @secure
     * @response `200` `boolean` OK
     */
    trainingSetAgreement: (
      data: TrainingSetAgreementPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/LmsTraining/TrainingSetAgreement`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  loginBlockReason = {
    /**
     * Cria um motivo de bloqueio.
     *
     * @tags LoginBlockReason
     * @name CreteBlockReason
     * @request POST:/api/v1/LoginBlockReason/CreteBlockReason
     * @secure
     * @response `200` `string` OK
     */
    creteBlockReason: (
      data: CreteBlockReasonPayload,
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/api/v1/LoginBlockReason/CreteBlockReason`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Altera um motivo de bloqueio.
     *
     * @tags LoginBlockReason
     * @name UpdateBlockReason
     * @request PUT:/api/v1/LoginBlockReason/UpdateBlockReason
     * @secure
     * @response `200` `boolean` OK
     */
    updateBlockReason: (
      data: UpdateBlockReasonPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/LoginBlockReason/UpdateBlockReason`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Define um motivo de bloqueio como temporário ou permanente
     *
     * @tags LoginBlockReason
     * @name SetTemporaryOrPermanentBlockReason
     * @request PUT:/api/v1/LoginBlockReason/SetTemporaryOrPermanentBlockReason
     * @secure
     * @response `200` `boolean` OK
     */
    setTemporaryOrPermanentBlockReason: (
      data: SetTemporaryOrPermanentBlockReasonPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/LoginBlockReason/SetTemporaryOrPermanentBlockReason`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Remove um motivo de bloqueio.
     *
     * @tags LoginBlockReason
     * @name DeleteBlockReason
     * @request DELETE:/api/v1/LoginBlockReason/DeleteBlockReason
     * @secure
     * @response `200` `boolean` OK
     */
    deleteBlockReason: (
      query?: {
        /** @format uuid */
        BlockReasonId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/LoginBlockReason/DeleteBlockReason`,
        method: "DELETE",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Obtém uma lista de motivo de bloqueio
     *
     * @tags LoginBlockReason
     * @name ManagedBlockReason
     * @request GET:/api/v1/LoginBlockReason/ManagedBlockReason
     * @secure
     * @response `200` `ManagedBlockReasonListQueryResponsePaginatedList` OK
     */
    managedBlockReason: (
      query?: {
        /** @format int32 */
        PageNumber?: number;
        /** @format int32 */
        PageSize?: number;
        /** @format int32 */
        Offset?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<ManagedBlockReasonListQueryResponsePaginatedList, any>({
        path: `/api/v1/LoginBlockReason/ManagedBlockReason`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  mailTemplate = {
    /**
     * Obtém a lista de Templates.
     *
     * @tags MailTemplate
     * @name ManagedMailTemplates
     * @request POST:/api/v1/MailTemplate/ManagedMailTemplates
     * @secure
     * @response `200` `ManagedMailTemplateListResponsePaginatedList` OK
     */
    managedMailTemplates: (
      data: ManagedMailTemplatesPayload,
      params: RequestParams = {},
    ) =>
      this.request<ManagedMailTemplateListResponsePaginatedList, any>({
        path: `/api/v1/MailTemplate/ManagedMailTemplates`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém o registro de Template de Notificação.
     *
     * @tags MailTemplate
     * @name GetMailTemplate
     * @request POST:/api/v1/MailTemplate/GetMailTemplate
     * @secure
     * @response `200` `ManagedNotificationTemplateResponse` OK (May return null)
     * @response `204` `any` No Content
     */
    getMailTemplate: (
      data: GetMailTemplatePayload,
      params: RequestParams = {},
    ) =>
      this.request<ManagedNotificationTemplateResponse, any>({
        path: `/api/v1/MailTemplate/GetMailTemplate`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Salva o registro de Template de Notificação.
     *
     * @tags MailTemplate
     * @name SaveMailTemplate
     * @request POST:/api/v1/MailTemplate/SaveMailTemplate
     * @secure
     * @response `200` `ManagedNotificationTemplateResponse` OK
     */
    saveMailTemplate: (
      data: SaveMailTemplatePayload,
      params: RequestParams = {},
    ) =>
      this.request<ManagedNotificationTemplateResponse, any>({
        path: `/api/v1/MailTemplate/SaveMailTemplate`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  managerEfficacy = {
    /**
     * Declina as pesquisas pendentes de um usuário.
     *
     * @tags ManagerEfficacy
     * @name Decline
     * @request POST:/api/v1/ManagerEfficacy/Decline
     * @secure
     * @response `200` `boolean` OK
     */
    decline: (data: DeclinePayload, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/api/v1/ManagerEfficacy/Decline`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém a Lista de Usuários com pendência de resposta de pesquisa de eficácia do gestor.
     *
     * @tags ManagerEfficacy
     * @name ManagerEfficacyUsers
     * @request POST:/api/v1/ManagerEfficacy/ManagerEfficacyUsers
     * @secure
     * @response `200` `ManagerEfficacyUserResponsePaginatedList` OK
     */
    managerEfficacyUsers: (
      data: ManagerEfficacyUsersPayload,
      params: RequestParams = {},
    ) =>
      this.request<ManagerEfficacyUserResponsePaginatedList, any>({
        path: `/api/v1/ManagerEfficacy/ManagerEfficacyUsers`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém a lista de treinamentos de um usuário para Pesquisa de Eficácia de Gestor.
     *
     * @tags ManagerEfficacy
     * @name ManagerEfficayParticipants
     * @request POST:/api/v1/ManagerEfficacy/ManagerEfficayParticipants
     * @secure
     * @response `200` `ManagedEfficacySurveyParticipantsResponsePaginatedList` OK
     */
    managerEfficayParticipants: (
      data: ManagerEfficayParticipantsPayload,
      params: RequestParams = {},
    ) =>
      this.request<ManagedEfficacySurveyParticipantsResponsePaginatedList, any>(
        {
          path: `/api/v1/ManagerEfficacy/ManagerEfficayParticipants`,
          method: "POST",
          body: data,
          secure: true,
          type: ContentType.Json,
          format: "json",
          ...params,
        },
      ),
  };
  notification = {
    /**
     * Obtém a lista de Categorias de Notificação.
     *
     * @tags Notification
     * @name NotificationModules
     * @request GET:/api/v1/Notification/NotificationModules
     * @secure
     * @response `200` `(Int32StringKeyValueItem)[]` OK
     */
    notificationModules: (params: RequestParams = {}) =>
      this.request<Int32StringKeyValueItem[], any>({
        path: `/api/v1/Notification/NotificationModules`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Obtém a quantidade de novas mensagens na área de notificação do usuário.
     *
     * @tags Notification
     * @name GetWorkspaceNewMessagesCounter
     * @request POST:/api/v1/Notification/GetWorkspaceNewMessagesCounter
     * @secure
     * @response `200` `NotificationWorkspacecounterResponse` OK
     */
    getWorkspaceNewMessagesCounter: (
      data: GetWorkspaceNewMessagesCounterPayload,
      params: RequestParams = {},
    ) =>
      this.request<NotificationWorkspacecounterResponse, any>({
        path: `/api/v1/Notification/GetWorkspaceNewMessagesCounter`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém a lista de mensagens para exibição na área de notificação do usuário.
     *
     * @tags Notification
     * @name GetWorkspaceMessages
     * @request POST:/api/v1/Notification/GetWorkspaceMessages
     * @secure
     * @response `200` `(NotificationWorkspaceDto)[]` OK
     */
    getWorkspaceMessages: (
      data: GetWorkspaceMessagesPayload,
      params: RequestParams = {},
    ) =>
      this.request<NotificationWorkspaceDto[], any>({
        path: `/api/v1/Notification/GetWorkspaceMessages`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém a lista de usuários em uma mensagem.
     *
     * @tags Notification
     * @name GetWorkspaceMessageUsers
     * @request POST:/api/v1/Notification/GetWorkspaceMessageUsers
     * @secure
     * @response `200` `UserItemDtoPaginatedList` OK
     */
    getWorkspaceMessageUsers: (
      data: GetWorkspaceMessageUsersPayload,
      params: RequestParams = {},
    ) =>
      this.request<UserItemDtoPaginatedList, any>({
        path: `/api/v1/Notification/GetWorkspaceMessageUsers`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Esconde uma mensagem da Área de Trabalho.
     *
     * @tags Notification
     * @name HideWorkspaceNotification
     * @request POST:/api/v1/Notification/HideWorkspaceNotification
     * @secure
     * @response `200` `boolean` OK
     */
    hideWorkspaceNotification: (
      data: HideWorkspaceNotificationPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/Notification/HideWorkspaceNotification`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Esconde todas as mensagens da Área de Trabalho.
     *
     * @tags Notification
     * @name ClearWorkspaceNotifications
     * @request POST:/api/v1/Notification/ClearWorkspaceNotifications
     * @secure
     * @response `200` `boolean` OK
     */
    clearWorkspaceNotifications: (
      data: ClearWorkspaceNotificationsPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/Notification/ClearWorkspaceNotifications`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  performaIntegration = {
    /**
     * Obtém a URL da landingpage de integração com o Performa para o módulo solicitado.
     *
     * @tags PerformaIntegration
     * @name ChooseLandingpage
     * @request POST:/api/v1/PerformaIntegration/ChooseLandingpage
     * @secure
     * @response `200` `ChooseLandingpageResponse` OK
     */
    chooseLandingpage: (
      data: ChooseLandingpagePayload,
      params: RequestParams = {},
    ) =>
      this.request<ChooseLandingpageResponse, any>({
        path: `/api/v1/PerformaIntegration/ChooseLandingpage`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém os dados de integração com o Performa para o módulo de Metas.
     *
     * @tags PerformaIntegration
     * @name GetGoalDashboardPowerMinds
     * @request POST:/api/v1/PerformaIntegration/GetGoalDashboardPowerMinds
     * @secure
     * @response `200` `GoalDashboardResponse` OK
     */
    getGoalDashboardPowerMinds: (
      data: GetGoalDashboardPowerMindsPayload,
      params: RequestParams = {},
    ) =>
      this.request<GoalDashboardResponse, any>({
        path: `/api/v1/PerformaIntegration/GetGoalDashboardPowerMinds`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém os dados de integração com o Performa para o módulo de Avaliações de Desempenho.
     *
     * @tags PerformaIntegration
     * @name GetAssessmentPowerMinds
     * @request POST:/api/v1/PerformaIntegration/GetAssessmentPowerMinds
     * @secure
     * @response `200` `PerformanceReviewsResponse` OK
     */
    getAssessmentPowerMinds: (
      data: GetAssessmentPowerMindsPayload,
      params: RequestParams = {},
    ) =>
      this.request<PerformanceReviewsResponse, any>({
        path: `/api/v1/PerformaIntegration/GetAssessmentPowerMinds`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Recebe dados de integração do Performa, como metas e avaliações de desempenho dos usuários.
     *
     * @tags PerformaIntegration
     * @name ReceiveIntegrationData
     * @request POST:/api/v1/PerformaIntegration/ReceiveIntegrationData
     * @secure
     * @response `200` `(ReceiveIntegrationDataResponse)[]` OK
     */
    receiveIntegrationData: (
      data: ReceiveIntegrationDataPayload,
      params: RequestParams = {},
    ) =>
      this.request<ReceiveIntegrationDataResponse[], any>({
        path: `/api/v1/PerformaIntegration/ReceiveIntegrationData`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  publication = {
    /**
     * Obtém correspondências da busca em vídeo.
     *
     * @tags Publication
     * @name GetMatchSubtitles
     * @request POST:/api/v1/Publication/GetMatchSubtitles
     * @secure
     * @response `200` `(WordItemDto)[]` OK
     */
    getMatchSubtitles: (
      data: GetMatchSubtitlesPayload,
      params: RequestParams = {},
    ) =>
      this.request<WordItemDto[], any>({
        path: `/api/v1/Publication/GetMatchSubtitles`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  questionBank = {
    /**
     * Obtém a lista de Grupos de Questões.
     *
     * @tags QuestionBank
     * @name ManagedQuestionGroups
     * @request POST:/api/v1/QuestionBank/ManagedQuestionGroups
     * @secure
     * @response `200` `ManagedQuestionGroupListResponse` OK
     */
    managedQuestionGroups: (
      data: ManagedQuestionGroupsPayload,
      params: RequestParams = {},
    ) =>
      this.request<ManagedQuestionGroupListResponse, any>({
        path: `/api/v1/QuestionBank/ManagedQuestionGroups`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém as informações principais do Grupo de Questões para edição.
     *
     * @tags QuestionBank
     * @name ManagedGetQuestionGroup
     * @request POST:/api/v1/QuestionBank/ManagedGetQuestionGroup
     * @secure
     * @response `200` `ManagedQuestionGroupResponse` OK
     */
    managedGetQuestionGroup: (
      data: ManagedGetQuestionGroupPayload,
      params: RequestParams = {},
    ) =>
      this.request<ManagedQuestionGroupResponse, any>({
        path: `/api/v1/QuestionBank/ManagedGetQuestionGroup`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém a lista de Questões de um Grupo de Questões.
     *
     * @tags QuestionBank
     * @name ManagedQuestions
     * @request POST:/api/v1/QuestionBank/ManagedQuestions
     * @secure
     * @response `200` `ManagedQuestionListResponsePaginatedList` OK
     */
    managedQuestions: (
      data: ManagedQuestionsPayload,
      params: RequestParams = {},
    ) =>
      this.request<ManagedQuestionListResponsePaginatedList, any>({
        path: `/api/v1/QuestionBank/ManagedQuestions`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém as informações principais da questão para edição.
     *
     * @tags QuestionBank
     * @name ManagedGetQuestion
     * @request POST:/api/v1/QuestionBank/ManagedGetQuestion
     * @secure
     * @response `200` `ManagedQuestionResponse` OK
     */
    managedGetQuestion: (
      data: ManagedGetQuestionPayload,
      params: RequestParams = {},
    ) =>
      this.request<ManagedQuestionResponse, any>({
        path: `/api/v1/QuestionBank/ManagedGetQuestion`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém os dados default para criação de questões.
     *
     * @tags QuestionBank
     * @name ManagedQuestionDefaultValues
     * @request POST:/api/v1/QuestionBank/ManagedQuestionDefaultValues
     * @secure
     * @response `200` `ManagedQuestionDefaultValuesResponse` OK
     */
    managedQuestionDefaultValues: (
      data: ManagedQuestionDefaultValuesPayload,
      params: RequestParams = {},
    ) =>
      this.request<ManagedQuestionDefaultValuesResponse, any>({
        path: `/api/v1/QuestionBank/ManagedQuestionDefaultValues`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém a lista de questões ativas para seleção.
     *
     * @tags QuestionBank
     * @name GetQuestionSelect
     * @request POST:/api/v1/QuestionBank/GetQuestionSelect
     * @secure
     * @response `200` `QuestionSelectListResponsePaginatedList` OK
     */
    getQuestionSelect: (
      data: GetQuestionSelectPayload,
      params: RequestParams = {},
    ) =>
      this.request<QuestionSelectListResponsePaginatedList, any>({
        path: `/api/v1/QuestionBank/GetQuestionSelect`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém os dados totalizadores de um grupo de questões para seleção de questões.
     *
     * @tags QuestionBank
     * @name QuestionGroupSelectInfo
     * @request POST:/api/v1/QuestionBank/QuestionGroupSelectInfo
     * @secure
     * @response `200` `QuestionGroupSelectInfoResponse` OK
     */
    questionGroupSelectInfo: (
      data: QuestionGroupSelectInfoPayload,
      params: RequestParams = {},
    ) =>
      this.request<QuestionGroupSelectInfoResponse, any>({
        path: `/api/v1/QuestionBank/QuestionGroupSelectInfo`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém quantidade de questões de um grupo de questões para seleção de questões em desafios de conhecimento.
     *
     * @tags QuestionBank
     * @name QuestionGroupKnowledgeTestInfo
     * @request POST:/api/v1/QuestionBank/QuestionGroupKnowledgeTestInfo
     * @secure
     * @response `200` `QuestionGroupKnowledgeTestInfoResponse` OK
     */
    questionGroupKnowledgeTestInfo: (
      data: QuestionGroupKnowledgeTestInfoPayload,
      params: RequestParams = {},
    ) =>
      this.request<QuestionGroupKnowledgeTestInfoResponse, any>({
        path: `/api/v1/QuestionBank/QuestionGroupKnowledgeTestInfo`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém a lista de versões de uma questão.
     *
     * @tags QuestionBank
     * @name GetQuestionVersions
     * @request POST:/api/v1/QuestionBank/GetQuestionVersions
     * @secure
     * @response `200` `(ManagedQuestionVersionListResponse)[]` OK
     */
    getQuestionVersions: (
      data: GetQuestionVersionsPayload,
      params: RequestParams = {},
    ) =>
      this.request<ManagedQuestionVersionListResponse[], any>({
        path: `/api/v1/QuestionBank/GetQuestionVersions`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtem a lista de perguntas geradas pelo OPEN AI.
     *
     * @tags QuestionBank
     * @name GetOpenAiQuestions
     * @request POST:/api/v1/QuestionBank/GetOpenAIQuestions
     * @secure
     * @response `200` `GetOpenAIQuestionsResponse` OK
     */
    getOpenAiQuestions: (
      data: GetOpenAiQuestionsPayload,
      params: RequestParams = {},
    ) =>
      this.request<GetOpenAIQuestionsResponse, any>({
        path: `/api/v1/QuestionBank/GetOpenAIQuestions`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém a lista de perguntas geradas pelo OPEN AI de um conteúdo de uma publicação.
     *
     * @tags QuestionBank
     * @name GetOpenAiQuestionsFromPub
     * @request POST:/api/v1/QuestionBank/GetOpenAIQuestionsFromPub
     * @secure
     * @response `200` `GetOpenAIQuestionsResponse` OK
     */
    getOpenAiQuestionsFromPub: (
      data: GetOpenAiQuestionsFromPubPayload,
      params: RequestParams = {},
    ) =>
      this.request<GetOpenAIQuestionsResponse, any>({
        path: `/api/v1/QuestionBank/GetOpenAIQuestionsFromPub`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém a lista de Questões de um Grupos de questões para desafio de conhecimento.
     *
     * @tags QuestionBank
     * @name QuestionsChallenge
     * @request POST:/api/v1/QuestionBank/QuestionsChallenge
     * @secure
     * @response `200` `QuestionChallengeListResponsePaginatedList` OK
     */
    questionsChallenge: (
      data: QuestionsChallengePayload,
      params: RequestParams = {},
    ) =>
      this.request<QuestionChallengeListResponsePaginatedList, any>({
        path: `/api/v1/QuestionBank/QuestionsChallenge`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Cria um grupo de questões.
     *
     * @tags QuestionBank
     * @name CreateQuestionGroup
     * @request POST:/api/v1/QuestionBank/CreateQuestionGroup
     * @secure
     * @response `200` `string | null` OK (May return null)
     * @response `204` `any` No Content
     */
    createQuestionGroup: (
      data: CreateQuestionGroupPayload,
      params: RequestParams = {},
    ) =>
      this.request<string | null, any>({
        path: `/api/v1/QuestionBank/CreateQuestionGroup`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Altera um grupo de questões.
     *
     * @tags QuestionBank
     * @name UpdateQuestionGroup
     * @request POST:/api/v1/QuestionBank/UpdateQuestionGroup
     * @secure
     * @response `200` `boolean` OK
     */
    updateQuestionGroup: (
      data: UpdateQuestionGroupPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/QuestionBank/UpdateQuestionGroup`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Excluir um grupo de questões.
     *
     * @tags QuestionBank
     * @name DeleteQuestionGroup
     * @request POST:/api/v1/QuestionBank/DeleteQuestionGroup
     * @secure
     * @response `200` `boolean` OK
     */
    deleteQuestionGroup: (
      data: DeleteQuestionGroupPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/QuestionBank/DeleteQuestionGroup`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Junção entre dois grupos de questões.
     *
     * @tags QuestionBank
     * @name JoinQuestionGroup
     * @request POST:/api/v1/QuestionBank/JoinQuestionGroup
     * @secure
     * @response `200` `boolean` OK
     */
    joinQuestionGroup: (
      data: JoinQuestionGroupPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/QuestionBank/JoinQuestionGroup`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Cria ou atualiza uma questão.
     *
     * @tags QuestionBank
     * @name SaveQuestion
     * @request POST:/api/v1/QuestionBank/SaveQuestion
     * @secure
     * @response `200` `string | null` OK (May return null)
     * @response `204` `any` No Content
     */
    saveQuestion: (data: SaveQuestionPayload, params: RequestParams = {}) =>
      this.request<string | null, any>({
        path: `/api/v1/QuestionBank/SaveQuestion`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Cria questões geradas pela AI.
     *
     * @tags QuestionBank
     * @name SaveAiQuestion
     * @request POST:/api/v1/QuestionBank/SaveAIQuestion
     * @secure
     * @response `200` `boolean` OK
     */
    saveAiQuestion: (data: SaveAiQuestionPayload, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/api/v1/QuestionBank/SaveAIQuestion`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Exclui uma questão.
     *
     * @tags QuestionBank
     * @name DeleteQuestion
     * @request POST:/api/v1/QuestionBank/DeleteQuestion
     * @secure
     * @response `200` `boolean` OK
     */
    deleteQuestion: (data: DeleteQuestionPayload, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/api/v1/QuestionBank/DeleteQuestion`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Bloquer ou desbloquear uma questão.
     *
     * @tags QuestionBank
     * @name BlockOrUnblockQuestion
     * @request POST:/api/v1/QuestionBank/BlockOrUnblockQuestion
     * @secure
     * @response `200` `boolean` OK
     */
    blockOrUnblockQuestion: (
      data: BlockOrUnblockQuestionPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/QuestionBank/BlockOrUnblockQuestion`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Permite ou proibe a aplicação de questão em testes de conhecimento.
     *
     * @tags QuestionBank
     * @name AllowKnowledgeTest
     * @request POST:/api/v1/QuestionBank/AllowKnowledgeTest
     * @secure
     * @response `200` `boolean` OK
     */
    allowKnowledgeTest: (
      data: AllowKnowledgeTestPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/QuestionBank/AllowKnowledgeTest`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Altera pontuação para todas as questões de um grupo de questões.
     *
     * @tags QuestionBank
     * @name UpdateQuestionPoints
     * @request POST:/api/v1/QuestionBank/UpdateQuestionPoints
     * @secure
     * @response `200` `boolean` OK
     */
    updateQuestionPoints: (
      data: UpdateQuestionPointsPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/QuestionBank/UpdateQuestionPoints`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * /// Alterar "permitir utilização em testes de conhecimento" para todas as questões de um grupo de questões.
     *
     * @tags QuestionBank
     * @name ChangeAllowKnowledgeTestAllQuestionGroup
     * @request POST:/api/v1/QuestionBank/ChangeAllowKnowledgeTestAllQuestionGroup
     * @secure
     * @response `200` `boolean` OK
     */
    changeAllowKnowledgeTestAllQuestionGroup: (
      data: ChangeAllowKnowledgeTestAllQuestionGroupPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/QuestionBank/ChangeAllowKnowledgeTestAllQuestionGroup`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Bloquear ou desbloquear todas as questões de um grupo de questões.
     *
     * @tags QuestionBank
     * @name BlockOrUnblockAllQuestionGroup
     * @request POST:/api/v1/QuestionBank/BlockOrUnblockAllQuestionGroup
     * @secure
     * @response `200` `boolean` OK
     */
    blockOrUnblockAllQuestionGroup: (
      data: BlockOrUnblockAllQuestionGroupPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/QuestionBank/BlockOrUnblockAllQuestionGroup`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Importa arquivo Txt de questões.
     *
     * @tags QuestionBank
     * @name ImportQuestionFile
     * @request POST:/api/v1/QuestionBank/ImportQuestionFile
     * @secure
     * @response `200` `(StringImportedItemModel)[]` OK
     */
    importQuestionFile: (
      data: ImportQuestionFilePayload,
      params: RequestParams = {},
    ) =>
      this.request<StringImportedItemModel[], any>({
        path: `/api/v1/QuestionBank/ImportQuestionFile`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Copia as questões para um novo grupo de questões.
     *
     * @tags QuestionBank
     * @name CopyQuestionsToNewGroup
     * @request POST:/api/v1/QuestionBank/CopyQuestionsToNewGroup
     * @secure
     * @response `200` `boolean` OK
     */
    copyQuestionsToNewGroup: (
      data: CopyQuestionsToNewGroupPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/QuestionBank/CopyQuestionsToNewGroup`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  report = {
    /**
     * Obtém a Lista de Relatórios.
     *
     * @tags Report
     * @name GetManagedReportList
     * @request POST:/api/v1/Report/GetManagedReportList
     * @secure
     * @response `200` `ManagedReportListResponsePaginatedList` OK
     */
    getManagedReportList: (
      data: GetManagedReportListPayload,
      params: RequestParams = {},
    ) =>
      this.request<ManagedReportListResponsePaginatedList, any>({
        path: `/api/v1/Report/GetManagedReportList`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém o relatório criação ou edição.
     *
     * @tags Report
     * @name GetManagedReport
     * @request POST:/api/v1/Report/GetManagedReport
     * @secure
     * @response `200` `ManagedReportResponse` OK
     */
    getManagedReport: (
      data: GetManagedReportPayload,
      params: RequestParams = {},
    ) =>
      this.request<ManagedReportResponse, any>({
        path: `/api/v1/Report/GetManagedReport`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém o relatório criação ou edição.
     *
     * @tags Report
     * @name GetReportGroupsSelector
     * @request POST:/api/v1/Report/GetReportGroupsSelector
     * @secure
     * @response `200` `(ReportGroupSelectorResponse)[]` OK
     */
    getReportGroupsSelector: (params: RequestParams = {}) =>
      this.request<ReportGroupSelectorResponse[], any>({
        path: `/api/v1/Report/GetReportGroupsSelector`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Obtém uma lista de tipos de parâmetro para seleção.
     *
     * @tags Report
     * @name GetReportParamTypesSelector
     * @request POST:/api/v1/Report/GetReportParamTypesSelector
     * @secure
     * @response `200` `(ReportParamTypesSelectorResponse)[]` OK
     */
    getReportParamTypesSelector: (params: RequestParams = {}) =>
      this.request<ReportParamTypesSelectorResponse[], any>({
        path: `/api/v1/Report/GetReportParamTypesSelector`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Obtém uma lista de tipos de objeto para seleção.
     *
     * @tags Report
     * @name GetReportParamObjectSelectors
     * @request POST:/api/v1/Report/GetReportParamObjectSelectors
     * @secure
     * @response `200` `ReportParamObjectSelectorResponse` OK
     */
    getReportParamObjectSelectors: (params: RequestParams = {}) =>
      this.request<ReportParamObjectSelectorResponse, any>({
        path: `/api/v1/Report/GetReportParamObjectSelectors`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Cria ou Atualiza a Definição de um Relatório.
     *
     * @tags Report
     * @name CreateOrUpdateReport
     * @request POST:/api/v1/Report/CreateOrUpdateReport
     * @secure
     * @response `200` `string` OK
     */
    createOrUpdateReport: (
      data: CreateOrUpdateReportPayload,
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/api/v1/Report/CreateOrUpdateReport`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Exclui um relatório.
     *
     * @tags Report
     * @name DeleteReport
     * @request POST:/api/v1/Report/DeleteReport
     * @secure
     * @response `200` `boolean` OK
     */
    deleteReport: (data: DeleteReportPayload, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/api/v1/Report/DeleteReport`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Executa um Relatório no modo Preview.
     *
     * @tags Report
     * @name ExecutePreview
     * @request POST:/api/v1/Report/ExecutePreview
     * @secure
     * @response `200` `ReportExecutePreviewResponse` OK
     */
    executePreview: (data: ExecutePreviewPayload, params: RequestParams = {}) =>
      this.request<ReportExecutePreviewResponse, any>({
        path: `/api/v1/Report/ExecutePreview`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém agendamento do Relatório.
     *
     * @tags Report
     * @name GetSchedule
     * @request POST:/api/v1/Report/GetSchedule
     * @secure
     * @response `200` `ReportScheduleDto` OK
     */
    getSchedule: (data: GetSchedulePayload, params: RequestParams = {}) =>
      this.request<ReportScheduleDto, any>({
        path: `/api/v1/Report/GetSchedule`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Cria ou altera agendamento.
     *
     * @tags Report
     * @name CreateOrUpdateSchedule
     * @request POST:/api/v1/Report/CreateOrUpdateSchedule
     * @secure
     * @response `200` `string | null` OK (May return null)
     * @response `204` `any` No Content
     */
    createOrUpdateSchedule: (
      data: CreateOrUpdateSchedulePayload,
      params: RequestParams = {},
    ) =>
      this.request<string | null, any>({
        path: `/api/v1/Report/CreateOrUpdateSchedule`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Cria ou altera agendamento.
     *
     * @tags Report
     * @name UpdateScheduleReportParams
     * @request POST:/api/v1/Report/UpdateScheduleReportParams
     * @secure
     * @response `200` `boolean` OK
     */
    updateScheduleReportParams: (
      data: UpdateScheduleReportParamsPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/Report/UpdateScheduleReportParams`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Cria ou altera agendamento.
     *
     * @tags Report
     * @name DeleteSchedule
     * @request POST:/api/v1/Report/DeleteSchedule
     * @secure
     * @response `200` `boolean` OK
     */
    deleteSchedule: (data: DeleteSchedulePayload, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/api/v1/Report/DeleteSchedule`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  reportGroup = {
    /**
     * Obtem a lista de Grupos de Relatórios
     *
     * @tags ReportGroup
     * @name GetManagedReportGroupList
     * @request POST:/api/v1/ReportGroup/GetManagedReportGroupList
     * @secure
     * @response `200` `(ManagedReportGroupResponse)[]` OK
     */
    getManagedReportGroupList: (params: RequestParams = {}) =>
      this.request<ManagedReportGroupResponse[], any>({
        path: `/api/v1/ReportGroup/GetManagedReportGroupList`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Cria ou Atualiza a Definição de um Relatório.
     *
     * @tags ReportGroup
     * @name AddOrUpdateReportGroup
     * @request POST:/api/v1/ReportGroup/AddOrUpdateReportGroup
     * @secure
     * @response `200` `string` OK
     */
    addOrUpdateReportGroup: (
      data: AddOrUpdateReportGroupPayload,
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/api/v1/ReportGroup/AddOrUpdateReportGroup`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Exclui um Grupo de Relatório.
     *
     * @tags ReportGroup
     * @name DeleteReportGroup
     * @request POST:/api/v1/ReportGroup/DeleteReportGroup
     * @secure
     * @response `200` `boolean` OK
     */
    deleteReportGroup: (
      data: DeleteReportGroupPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/ReportGroup/DeleteReportGroup`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  scheduler = {
    /**
     * Obtém a lista de Tarefas em Segundo Plano e seu estado de execução.
     *
     * @tags Scheduler
     * @name SchedulerJobsStatus
     * @request POST:/api/v1/Scheduler/SchedulerJobsStatus
     * @secure
     * @response `200` `SchedulerTaskResponsePaginatedList` OK
     */
    schedulerJobsStatus: (
      data: SchedulerJobsStatusPayload,
      params: RequestParams = {},
    ) =>
      this.request<SchedulerTaskResponsePaginatedList, any>({
        path: `/api/v1/Scheduler/SchedulerJobsStatus`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém o Log de uma Tarefa.
     *
     * @tags Scheduler
     * @name SchedulerTaskLog
     * @request POST:/api/v1/Scheduler/SchedulerTaskLog
     * @secure
     * @response `200` `SchedulerTaskLogResponsePaginatedList` OK
     */
    schedulerTaskLog: (
      data: SchedulerTaskLogPayload,
      params: RequestParams = {},
    ) =>
      this.request<SchedulerTaskLogResponsePaginatedList, any>({
        path: `/api/v1/Scheduler/SchedulerTaskLog`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém o Log das Tarefas Agendadas.
     *
     * @tags Scheduler
     * @name JobProcesses
     * @request POST:/api/v1/Scheduler/JobProcesses
     * @secure
     * @response `200` `JobProcessResponsePaginatedList` OK
     */
    jobProcesses: (data: JobProcessesPayload, params: RequestParams = {}) =>
      this.request<JobProcessResponsePaginatedList, any>({
        path: `/api/v1/Scheduler/JobProcesses`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém os detalhes de execução de uma tarefa.
     *
     * @tags Scheduler
     * @name JobProcessDetail
     * @request POST:/api/v1/Scheduler/JobProcessDetail
     * @secure
     * @response `200` `SchedulerTaskLogResults` OK (May return null)
     * @response `204` `any` No Content
     */
    jobProcessDetail: (
      data: JobProcessDetailPayload,
      params: RequestParams = {},
    ) =>
      this.request<SchedulerTaskLogResults, any>({
        path: `/api/v1/Scheduler/JobProcessDetail`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém os eventos em Fila para execução.
     *
     * @tags Scheduler
     * @name QueueEvents
     * @request POST:/api/v1/Scheduler/QueueEvents
     * @secure
     * @response `200` `QueueEventResponsePaginatedList` OK
     */
    queueEvents: (data: QueueEventsPayload, params: RequestParams = {}) =>
      this.request<QueueEventResponsePaginatedList, any>({
        path: `/api/v1/Scheduler/QueueEvents`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém os detalhes de execução de um item da fila.
     *
     * @tags Scheduler
     * @name QueueEventDetail
     * @request POST:/api/v1/Scheduler/QueueEventDetail
     * @secure
     * @response `200` `string` OK (May return null)
     * @response `204` `any` No Content
     */
    queueEventDetail: (
      data: QueueEventDetailPayload,
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/api/v1/Scheduler/QueueEventDetail`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém os eventos das Filas de Carga de Dados.
     *
     * @tags Scheduler
     * @name LoadDataQueue
     * @request POST:/api/v1/Scheduler/LoadDataQueue
     * @secure
     * @response `200` `QueueEventResponsePaginatedList` OK
     */
    loadDataQueue: (data: LoadDataQueuePayload, params: RequestParams = {}) =>
      this.request<QueueEventResponsePaginatedList, any>({
        path: `/api/v1/Scheduler/LoadDataQueue`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém a lista de itens de uma fila de notificação.
     *
     * @tags Scheduler
     * @name MessagingQueue
     * @request POST:/api/v1/Scheduler/MessagingQueue
     * @secure
     * @response `200` `MessagingQueueResponsePaginatedList` OK
     */
    messagingQueue: (data: MessagingQueuePayload, params: RequestParams = {}) =>
      this.request<MessagingQueueResponsePaginatedList, any>({
        path: `/api/v1/Scheduler/MessagingQueue`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Scheduler
     * @name DownloadImportFile
     * @request GET:/api/v1/Scheduler/DownloadImportFile
     * @secure
     * @response `200` `any` OK
     */
    downloadImportFile: (
      query?: {
        /** @format uuid */
        queueId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<any, any>({
        path: `/api/v1/Scheduler/DownloadImportFile`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * Reprocessa itens da fila que terminaram com falha.
     *
     * @tags Scheduler
     * @name ReprocessQueue
     * @request POST:/api/v1/Scheduler/ReprocessQueue
     * @secure
     * @response `200` `boolean` OK
     */
    reprocessQueue: (data: ReprocessQueuePayload, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/api/v1/Scheduler/ReprocessQueue`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  scormDebug = {
    /**
     * Obtém a lista de Treinamentos SCORM em modo DEBUG.
     *
     * @tags ScormDebug
     * @name GetTrainings
     * @request POST:/api/v1/ScormDebug/GetTrainings
     * @secure
     * @response `200` `ScormDebugTrainingsListResponsePaginatedList` OK
     */
    getTrainings: (data: GetTrainingsPayload, params: RequestParams = {}) =>
      this.request<ScormDebugTrainingsListResponsePaginatedList, any>({
        path: `/api/v1/ScormDebug/GetTrainings`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Lista de Treinamentos que possuem Pacote Scorm e não estão em modo DEPURAÇÃO.
     *
     * @tags ScormDebug
     * @name TrainingSelector
     * @request POST:/api/v1/ScormDebug/TrainingSelector
     * @secure
     * @response `200` `TrainingSelectorDtoPaginatedList` OK
     */
    trainingSelector: (
      data: TrainingSelectorBody,
      params: RequestParams = {},
    ) =>
      this.request<TrainingSelectorDtoPaginatedList, any>({
        path: `/api/v1/ScormDebug/TrainingSelector`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Lista o Log do Treinamento SCORM.
     *
     * @tags ScormDebug
     * @name GetLog
     * @request POST:/api/v1/ScormDebug/GetLog
     * @secure
     * @response `200` `ScormLogResponsePaginatedList` OK
     */
    getLog: (data: GetLogPayload, params: RequestParams = {}) =>
      this.request<ScormLogResponsePaginatedList, any>({
        path: `/api/v1/ScormDebug/GetLog`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Coloca ou Retira um Treinamento Scorm do modo Depuração.
     *
     * @tags ScormDebug
     * @name ChangeDebug
     * @request POST:/api/v1/ScormDebug/ChangeDebug
     * @secure
     * @response `200` `boolean` OK
     */
    changeDebug: (data: ChangeDebugPayload, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/api/v1/ScormDebug/ChangeDebug`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  secondaryManagerType = {
    /**
     * Obtém um lista de tipos de gerentes
     *
     * @tags SecondaryManagerType
     * @name GetManagedList
     * @request GET:/api/v1/SecondaryManagerType/GetManagedList
     * @secure
     * @response `200` `ManagedManagerTypeListQueryResponsePaginatedList` OK
     */
    getManagedList: (
      query?: {
        /** @format int32 */
        PageNumber?: number;
        /** @format int32 */
        PageSize?: number;
        /** @format int32 */
        Offset?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<ManagedManagerTypeListQueryResponsePaginatedList, any>({
        path: `/api/v1/SecondaryManagerType/GetManagedList`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Cria ou Atualiza um tipo de gerente
     *
     * @tags SecondaryManagerType
     * @name CreateOrUpdate
     * @request POST:/api/v1/SecondaryManagerType/CreateOrUpdate
     * @secure
     * @response `200` `string` OK
     */
    createOrUpdate: (data: CreateOrUpdatePayload, params: RequestParams = {}) =>
      this.request<string, any>({
        path: `/api/v1/SecondaryManagerType/CreateOrUpdate`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Cria ou altera o Código Externo de um tipo de gerente secundário.
     *
     * @tags SecondaryManagerType
     * @name UpdateExternalCode
     * @request PUT:/api/v1/SecondaryManagerType/UpdateExternalCode
     * @secure
     * @response `200` `boolean` OK
     */
    updateExternalCode: (
      data: UpdateExternalCodePayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/SecondaryManagerType/UpdateExternalCode`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Exclui um tipo de gerente
     *
     * @tags SecondaryManagerType
     * @name Delete
     * @request DELETE:/api/v1/SecondaryManagerType/Delete
     * @secure
     * @response `200` `boolean` OK
     */
    delete: (
      query?: {
        /** @format uuid */
        ManagerTypeId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/SecondaryManagerType/Delete`,
        method: "DELETE",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  securityRoleManagement = {
    /**
     * Obtém a lista de Papeís de Segurança para gerenciamento.
     *
     * @tags SecurityRoleManagement
     * @name ManagedRoles
     * @request POST:/api/v1/SecurityRoleManagement/ManagedRoles
     * @secure
     * @response `200` `ManagedRoleResponsePaginatedList` OK
     */
    managedRoles: (data: ManagedRolesPayload, params: RequestParams = {}) =>
      this.request<ManagedRoleResponsePaginatedList, any>({
        path: `/api/v1/SecurityRoleManagement/ManagedRoles`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém o registro do Papel de Segurança.
     *
     * @tags SecurityRoleManagement
     * @name GetRole
     * @request POST:/api/v1/SecurityRoleManagement/GetRole
     * @secure
     * @response `200` `ManagedRoleQueryResponse` OK (May return null)
     * @response `204` `any` No Content
     */
    getRole: (data: GetRolePayload, params: RequestParams = {}) =>
      this.request<ManagedRoleQueryResponse, any>({
        path: `/api/v1/SecurityRoleManagement/GetRole`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Cria um papel de segurança.
     *
     * @tags SecurityRoleManagement
     * @name CreateRole
     * @request POST:/api/v1/SecurityRoleManagement/CreateRole
     * @secure
     * @response `200` `string | null` OK (May return null)
     * @response `204` `any` No Content
     */
    createRole: (data: CreateRolePayload, params: RequestParams = {}) =>
      this.request<string | null, any>({
        path: `/api/v1/SecurityRoleManagement/CreateRole`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Atualiza um papel de segurança.
     *
     * @tags SecurityRoleManagement
     * @name UpdateRole
     * @request POST:/api/v1/SecurityRoleManagement/UpdateRole
     * @secure
     * @response `200` `boolean` OK
     */
    updateRole: (data: UpdateRolePayload, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/api/v1/SecurityRoleManagement/UpdateRole`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Remove um papel de segurança.
     *
     * @tags SecurityRoleManagement
     * @name DeleteRole
     * @request POST:/api/v1/SecurityRoleManagement/DeleteRole
     * @secure
     * @response `200` `boolean` OK
     */
    deleteRole: (data: DeleteRolePayload, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/api/v1/SecurityRoleManagement/DeleteRole`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Clona um Papel de Segurança.
     *
     * @tags SecurityRoleManagement
     * @name CloneRole
     * @request POST:/api/v1/SecurityRoleManagement/CloneRole
     * @secure
     * @response `200` `boolean` OK
     */
    cloneRole: (data: CloneRolePayload, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/api/v1/SecurityRoleManagement/CloneRole`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém a Lista Paginada de usuários registrados no Papel de Segurança.
     *
     * @tags SecurityRoleManagement
     * @name GetUsers
     * @request POST:/api/v1/SecurityRoleManagement/GetUsers
     * @secure
     * @response `200` `ManagedRoleUserQueryResponsePaginatedList` OK
     */
    getUsers: (data: GetUsersBody, params: RequestParams = {}) =>
      this.request<ManagedRoleUserQueryResponsePaginatedList, any>({
        path: `/api/v1/SecurityRoleManagement/GetUsers`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Lista de usuários que ainda não possuem o Papel.
     *
     * @tags SecurityRoleManagement
     * @name GetUserSuggestions
     * @request POST:/api/v1/SecurityRoleManagement/GetUserSuggestions
     * @secure
     * @response `200` `AutoCompleteDataModelDtoPaginatedList` OK
     */
    getUserSuggestions: (
      data: GetUserSuggestionsPayload,
      params: RequestParams = {},
    ) =>
      this.request<AutoCompleteDataModelDtoPaginatedList, any>({
        path: `/api/v1/SecurityRoleManagement/GetUserSuggestions`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Adiciona um usuário ao papel de segurança.
     *
     * @tags SecurityRoleManagement
     * @name AddUser
     * @request POST:/api/v1/SecurityRoleManagement/AddUser
     * @secure
     * @response `200` `(ManagedRoleUserQueryResponse)[]` OK (May return null)
     * @response `204` `any` No Content
     */
    addUser: (data: AddUserPayload, params: RequestParams = {}) =>
      this.request<ManagedRoleUserQueryResponse[], any>({
        path: `/api/v1/SecurityRoleManagement/AddUser`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Remove um papel de segurança do usuário.
     *
     * @tags SecurityRoleManagement
     * @name DeleteUser
     * @request POST:/api/v1/SecurityRoleManagement/DeleteUser
     * @secure
     * @response `200` `boolean` OK
     */
    deleteUser: (data: DeleteUserPayload, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/api/v1/SecurityRoleManagement/DeleteUser`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Reativa um papel atribuído dinamicamente ao usuário e que foi bloqueado.
     *
     * @tags SecurityRoleManagement
     * @name ReactivateUser
     * @request POST:/api/v1/SecurityRoleManagement/ReactivateUser
     * @secure
     * @response `200` `boolean` OK
     */
    reactivateUser: (data: ReactivateUserPayload, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/api/v1/SecurityRoleManagement/ReactivateUser`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Bloqueia um papel atribuído dinamicamente ao usuário.
     *
     * @tags SecurityRoleManagement
     * @name DesactivateUser
     * @request POST:/api/v1/SecurityRoleManagement/DesactivateUser
     * @secure
     * @response `200` `boolean` OK
     */
    desactivateUser: (
      data: DesactivateUserPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/SecurityRoleManagement/DesactivateUser`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Lista de permissões customizadas do papel de segurança para um usuário.
     *
     * @tags SecurityRoleManagement
     * @name GetUserConstraints
     * @request POST:/api/v1/SecurityRoleManagement/GetUserConstraints
     * @secure
     * @response `200` `ManagedRoleUserConstraintsQueryResponse` OK
     */
    getUserConstraints: (
      data: GetUserConstraintsPayload,
      params: RequestParams = {},
    ) =>
      this.request<ManagedRoleUserConstraintsQueryResponse, any>({
        path: `/api/v1/SecurityRoleManagement/GetUserConstraints`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém uma Lista dos Grupos Dinâmicos atribuídos ao usuário via Papel de Seguranca.
     *
     * @tags SecurityRoleManagement
     * @name GetUserGroupsAssigned
     * @request POST:/api/v1/SecurityRoleManagement/GetUserGroupsAssigned
     * @secure
     * @response `200` `ManagedRoleUserGroupsAssignedQueryResponsePaginatedList` OK
     */
    getUserGroupsAssigned: (
      data: GetUserGroupsAssignedPayload,
      params: RequestParams = {},
    ) =>
      this.request<
        ManagedRoleUserGroupsAssignedQueryResponsePaginatedList,
        any
      >({
        path: `/api/v1/SecurityRoleManagement/GetUserGroupsAssigned`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Salva as permissões customizadas do papel de segurança para um usuário.
     *
     * @tags SecurityRoleManagement
     * @name SaveUserConstraints
     * @request POST:/api/v1/SecurityRoleManagement/SaveUserConstraints
     * @secure
     * @response `200` `boolean` OK
     */
    saveUserConstraints: (
      data: SaveUserConstraintsPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/SecurityRoleManagement/SaveUserConstraints`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém o método de resolução de conflitos das permissões do usuário.
     *
     * @tags SecurityRoleManagement
     * @name GetUserConflitResolution
     * @request POST:/api/v1/SecurityRoleManagement/GetUserConflitResolution
     * @secure
     * @response `200` `ManagedRoleUserConflitResolutionResponse` OK
     */
    getUserConflitResolution: (
      data: GetUserConflitResolutionPayload,
      params: RequestParams = {},
    ) =>
      this.request<ManagedRoleUserConflitResolutionResponse, any>({
        path: `/api/v1/SecurityRoleManagement/GetUserConflitResolution`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Salva o método de resolução de conflitos das permissões do usuário.
     *
     * @tags SecurityRoleManagement
     * @name SaveUserConflitResolution
     * @request POST:/api/v1/SecurityRoleManagement/SaveUserConflitResolution
     * @secure
     * @response `200` `boolean` OK
     */
    saveUserConflitResolution: (
      data: SaveUserConflitResolutionPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/SecurityRoleManagement/SaveUserConflitResolution`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém a lista de grupos para edição.
     *
     * @tags SecurityRoleManagement
     * @name GetGroups
     * @request POST:/api/v1/SecurityRoleManagement/GetGroups
     * @secure
     * @response `200` `ManagedRoleGroupQueryResponsePaginatedList` OK
     */
    getGroups: (data: GetGroupsBody, params: RequestParams = {}) =>
      this.request<ManagedRoleGroupQueryResponsePaginatedList, any>({
        path: `/api/v1/SecurityRoleManagement/GetGroups`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Adiciona uma lista de grupos ao papel de segurança.
     *
     * @tags SecurityRoleManagement
     * @name AddGroups
     * @request POST:/api/v1/SecurityRoleManagement/AddGroups
     * @secure
     * @response `200` `boolean` OK
     */
    addGroups: (data: AddGroupsPayload, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/api/v1/SecurityRoleManagement/AddGroups`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Remove um grupo do papel de segurança. <param name="cancellationToken"></param>
     *
     * @tags SecurityRoleManagement
     * @name DeleteGroup
     * @request POST:/api/v1/SecurityRoleManagement/DeleteGroup
     * @secure
     * @response `200` `boolean` OK
     */
    deleteGroup: (data: DeleteGroupInput, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/api/v1/SecurityRoleManagement/DeleteGroup`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Lista de permissões customizadas do papel de segurança para um grupo.
     *
     * @tags SecurityRoleManagement
     * @name GetGroupConstraints
     * @request POST:/api/v1/SecurityRoleManagement/GetGroupConstraints
     * @secure
     * @response `200` `ManagedRoleGroupConstraintsQueryResponse` OK
     */
    getGroupConstraints: (
      data: GetGroupConstraintsPayload,
      params: RequestParams = {},
    ) =>
      this.request<ManagedRoleGroupConstraintsQueryResponse, any>({
        path: `/api/v1/SecurityRoleManagement/GetGroupConstraints`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Salva as permissões customizadas do papel de segurança para um grupo.
     *
     * @tags SecurityRoleManagement
     * @name SaveGroupConstraints
     * @request POST:/api/v1/SecurityRoleManagement/SaveGroupConstraints
     * @secure
     * @response `200` `boolean` OK
     */
    saveGroupConstraints: (
      data: SaveGroupConstraintsPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/SecurityRoleManagement/SaveGroupConstraints`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém o método de resolução de conflitos das permissões entre grupos.
     *
     * @tags SecurityRoleManagement
     * @name GetGroupConflitResolution
     * @request POST:/api/v1/SecurityRoleManagement/GetGroupConflitResolution
     * @secure
     * @response `200` `ManagedRoleGroupConflitResolutionResponse` OK
     */
    getGroupConflitResolution: (
      data: GetGroupConflitResolutionPayload,
      params: RequestParams = {},
    ) =>
      this.request<ManagedRoleGroupConflitResolutionResponse, any>({
        path: `/api/v1/SecurityRoleManagement/GetGroupConflitResolution`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Salva o método de resolução de conflitos das permissões entre grupos.
     *
     * @tags SecurityRoleManagement
     * @name SaveGroupConflitResolution
     * @request POST:/api/v1/SecurityRoleManagement/SaveGroupConflitResolution
     * @secure
     * @response `200` `boolean` OK
     */
    saveGroupConflitResolution: (
      data: SaveGroupConflitResolutionPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/SecurityRoleManagement/SaveGroupConflitResolution`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  selectors = {
    /**
     * Tipos de unidades administrativas
     *
     * @tags Selectors
     * @name UnitTypes
     * @request POST:/api/v1/Selectors/UnitTypes
     * @secure
     * @response `200` `(UnitTypeResponse)[]` OK
     */
    unitTypes: (params: RequestParams = {}) =>
      this.request<UnitTypeResponse[], any>({
        path: `/api/v1/Selectors/UnitTypes`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Grupos
     *
     * @tags Selectors
     * @name Groups
     * @request POST:/api/v1/Selectors/Groups
     * @secure
     * @response `200` `GroupSelectorResponsePaginatedList` OK
     */
    groups: (data: GroupsPayload, params: RequestParams = {}) =>
      this.request<GroupSelectorResponsePaginatedList, any>({
        path: `/api/v1/Selectors/Groups`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Usuários
     *
     * @tags Selectors
     * @name Users
     * @request POST:/api/v1/Selectors/Users
     * @secure
     * @response `200` `UserSelectorResponsePaginatedList` OK
     */
    users: (data: UsersBody, params: RequestParams = {}) =>
      this.request<UserSelectorResponsePaginatedList, any>({
        path: `/api/v1/Selectors/Users`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Gerentes
     *
     * @tags Selectors
     * @name Managers
     * @request POST:/api/v1/Selectors/Managers
     * @secure
     * @response `200` `ManagerSelectorResponsePaginatedList` OK
     */
    managers: (data: ManagersPayload, params: RequestParams = {}) =>
      this.request<ManagerSelectorResponsePaginatedList, any>({
        path: `/api/v1/Selectors/Managers`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém uma Lista de Subordinados diretos e indiretos do gerente.
     *
     * @tags Selectors
     * @name Subordinates
     * @request POST:/api/v1/Selectors/Subordinates
     * @secure
     * @response `200` `SubordinateSelectorResponsePaginatedList` OK
     */
    subordinates: (data: SubordinatesPayload, params: RequestParams = {}) =>
      this.request<SubordinateSelectorResponsePaginatedList, any>({
        path: `/api/v1/Selectors/Subordinates`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Permissões
     *
     * @tags Selectors
     * @name Permissions
     * @request POST:/api/v1/Selectors/Permissions
     * @secure
     * @response `200` `(PermissionSelectorResponse)[]` OK
     */
    permissions: (data: PermissionsPayload, params: RequestParams = {}) =>
      this.request<PermissionSelectorResponse[], any>({
        path: `/api/v1/Selectors/Permissions`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Categorias de permissões
     *
     * @tags Selectors
     * @name PermissionCategories
     * @request POST:/api/v1/Selectors/PermissionCategories
     * @secure
     * @response `200` `(PermissionCategorySelectorReponse)[]` OK
     */
    permissionCategories: (params: RequestParams = {}) =>
      this.request<PermissionCategorySelectorReponse[], any>({
        path: `/api/v1/Selectors/PermissionCategories`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Unidades administrativas (em árvore)
     *
     * @tags Selectors
     * @name UnitsTree
     * @request POST:/api/v1/Selectors/UnitsTree
     * @secure
     * @response `200` `(UnitSelectionTreeResponse)[]` OK
     */
    unitsTree: (data: UnitsTreePayload, params: RequestParams = {}) =>
      this.request<UnitSelectionTreeResponse[], any>({
        path: `/api/v1/Selectors/UnitsTree`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Campos de especificação de grupos dinâmicos
     *
     * @tags Selectors
     * @name DynamicGroupsFieldsSpec
     * @request POST:/api/v1/Selectors/DynamicGroupsFieldsSpec
     * @secure
     * @response `200` `(DynamicGroupsFieldsSpecSelectorResponse)[]` OK
     */
    dynamicGroupsFieldsSpec: (params: RequestParams = {}) =>
      this.request<DynamicGroupsFieldsSpecSelectorResponse[], any>({
        path: `/api/v1/Selectors/DynamicGroupsFieldsSpec`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Motivos de bloqueio de usuário
     *
     * @tags Selectors
     * @name LoginBlockReasons
     * @request GET:/api/v1/Selectors/LoginBlockReasons
     * @secure
     * @response `200` `(BlockReasonSelectorResponse)[]` OK
     */
    loginBlockReasons: (params: RequestParams = {}) =>
      this.request<BlockReasonSelectorResponse[], any>({
        path: `/api/v1/Selectors/LoginBlockReasons`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Tipo de dados de campos customizados
     *
     * @tags Selectors
     * @name CustomFieldTypes
     * @request GET:/api/v1/Selectors/CustomFieldTypes
     * @secure
     * @response `200` `(CustomFieldTypeSelectorResponse)[]` OK
     */
    customFieldTypes: (params: RequestParams = {}) =>
      this.request<CustomFieldTypeSelectorResponse[], any>({
        path: `/api/v1/Selectors/CustomFieldTypes`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Tipo de uso de campos customizados
     *
     * @tags Selectors
     * @name CustomFieldUsages
     * @request GET:/api/v1/Selectors/CustomFieldUsages
     * @secure
     * @response `200` `(CustomFieldUsageSelectorResponse)[]` OK
     */
    customFieldUsages: (params: RequestParams = {}) =>
      this.request<CustomFieldUsageSelectorResponse[], any>({
        path: `/api/v1/Selectors/CustomFieldUsages`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Áreas de exibição de campos customizados para usuário
     *
     * @tags Selectors
     * @name CustomFieldUserDisplayArea
     * @request GET:/api/v1/Selectors/CustomFieldUserDisplayArea
     * @secure
     * @response `200` `(CustomFieldUserDisplayAreaSelectorResponse)[]` OK
     */
    customFieldUserDisplayArea: (params: RequestParams = {}) =>
      this.request<CustomFieldUserDisplayAreaSelectorResponse[], any>({
        path: `/api/v1/Selectors/CustomFieldUserDisplayArea`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Restrições para preenchimento de campos customizados
     *
     * @tags Selectors
     * @name CustomFieldFillConstraint
     * @request GET:/api/v1/Selectors/CustomFieldFillConstraint
     * @secure
     * @response `200` `(CustomFieldFillConstraintSelectorResponse)[]` OK
     */
    customFieldFillConstraint: (params: RequestParams = {}) =>
      this.request<CustomFieldFillConstraintSelectorResponse[], any>({
        path: `/api/v1/Selectors/CustomFieldFillConstraint`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Restrições para preenchimento de campos customizados
     *
     * @tags Selectors
     * @name CustomFieldWidth
     * @request GET:/api/v1/Selectors/CustomFieldWidth
     * @secure
     * @response `200` `(CustomFieldWidthSelectorResponse)[]` OK
     */
    customFieldWidth: (params: RequestParams = {}) =>
      this.request<CustomFieldWidthSelectorResponse[], any>({
        path: `/api/v1/Selectors/CustomFieldWidth`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Tipos de objetos de seleção para campos customizados
     *
     * @tags Selectors
     * @name CustomFieldObjectType
     * @request GET:/api/v1/Selectors/CustomFieldObjectType
     * @secure
     * @response `200` `(CustomFieldObjectTypeSelectorResponse)[]` OK
     */
    customFieldObjectType: (params: RequestParams = {}) =>
      this.request<CustomFieldObjectTypeSelectorResponse[], any>({
        path: `/api/v1/Selectors/CustomFieldObjectType`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Tipos de validação de um campo numérico
     *
     * @tags Selectors
     * @name CustomFieldPreDefinedTypes
     * @request GET:/api/v1/Selectors/CustomFieldPreDefinedTypes
     * @secure
     * @response `200` `(CustomFieldPredefinedTypeSelectorResponse)[]` OK
     */
    customFieldPreDefinedTypes: (params: RequestParams = {}) =>
      this.request<CustomFieldPredefinedTypeSelectorResponse[], any>({
        path: `/api/v1/Selectors/CustomFieldPreDefinedTypes`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Membros
     *
     * @tags Selectors
     * @name ManagedMember
     * @request POST:/api/v1/Selectors/ManagedMember
     * @secure
     * @response `200` `ManagedMemberSelectorResponsePaginatedList` OK
     */
    managedMember: (data: ManagedMemberPayload, params: RequestParams = {}) =>
      this.request<ManagedMemberSelectorResponsePaginatedList, any>({
        path: `/api/v1/Selectors/ManagedMember`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Tags
     *
     * @tags Selectors
     * @name Tags
     * @request POST:/api/v1/Selectors/Tags
     * @secure
     * @response `200` `TagSelectorResponsePaginatedList` OK
     */
    tags: (data: TagsPayload, params: RequestParams = {}) =>
      this.request<TagSelectorResponsePaginatedList, any>({
        path: `/api/v1/Selectors/Tags`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Group Usages
     *
     * @tags Selectors
     * @name GroupUsages
     * @request POST:/api/v1/Selectors/GroupUsages
     * @secure
     * @response `200` `(GroupUsagesSelectorResponse)[]` OK
     */
    groupUsages: (data: GroupUsagesPayload, params: RequestParams = {}) =>
      this.request<GroupUsagesSelectorResponse[], any>({
        path: `/api/v1/Selectors/GroupUsages`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Tipos de telefone do usuário
     *
     * @tags Selectors
     * @name UserPhoneTypes
     * @request GET:/api/v1/Selectors/UserPhoneTypes
     * @secure
     * @response `200` `(UserPhoneTypeSelectorResponse)[]` OK
     */
    userPhoneTypes: (params: RequestParams = {}) =>
      this.request<UserPhoneTypeSelectorResponse[], any>({
        path: `/api/v1/Selectors/UserPhoneTypes`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Tipos de credenciais do usuário
     *
     * @tags Selectors
     * @name UserCredentialTypes
     * @request GET:/api/v1/Selectors/UserCredentialTypes
     * @secure
     * @response `200` `(UserCredentialTypeSelectorResponse)[]` OK
     */
    userCredentialTypes: (params: RequestParams = {}) =>
      this.request<UserCredentialTypeSelectorResponse[], any>({
        path: `/api/v1/Selectors/UserCredentialTypes`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Papéis
     *
     * @tags Selectors
     * @name Roles
     * @request POST:/api/v1/Selectors/Roles
     * @secure
     * @response `200` `RoleSelectorResponsePaginatedList` OK
     */
    roles: (data: RolesPayload, params: RequestParams = {}) =>
      this.request<RoleSelectorResponsePaginatedList, any>({
        path: `/api/v1/Selectors/Roles`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Campos customizados por tipo de uso
     *
     * @tags Selectors
     * @name CustomFieldsByUsage
     * @request POST:/api/v1/Selectors/CustomFieldsByUsage
     * @secure
     * @response `200` `(CustomFieldValueDto)[]` OK
     */
    customFieldsByUsage: (
      data: CustomFieldsByUsagePayload,
      params: RequestParams = {},
    ) =>
      this.request<CustomFieldValueDto[], any>({
        path: `/api/v1/Selectors/CustomFieldsByUsage`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Períodos do dia.
     *
     * @tags Selectors
     * @name PeriodsOfDay
     * @request GET:/api/v1/Selectors/PeriodsOfDay
     * @secure
     * @response `200` `(HolidayPeriodOfDaySelectorResponse)[]` OK
     */
    periodsOfDay: (params: RequestParams = {}) =>
      this.request<HolidayPeriodOfDaySelectorResponse[], any>({
        path: `/api/v1/Selectors/PeriodsOfDay`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Obtém uma lista de Tópicos para seleção hierárquica.
     *
     * @tags Selectors
     * @name TopicsHierarchical
     * @request POST:/api/v1/Selectors/TopicsHierarchical
     * @secure
     * @response `200` `TopicSelectorHierarchicalResponsePaginatedList` OK
     */
    topicsHierarchical: (
      data: TopicsHierarchicalPayload,
      params: RequestParams = {},
    ) =>
      this.request<TopicSelectorHierarchicalResponsePaginatedList, any>({
        path: `/api/v1/Selectors/TopicsHierarchical`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Categorias de Tópicos.
     *
     * @tags Selectors
     * @name TopicCategory
     * @request POST:/api/v1/Selectors/TopicCategory
     * @secure
     * @response `200` `(TopicCategorySelectorResponse)[]` OK
     */
    topicCategory: (data: TopicCategoryPayload, params: RequestParams = {}) =>
      this.request<TopicCategorySelectorResponse[], any>({
        path: `/api/v1/Selectors/TopicCategory`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Motivos de Ausência.
     *
     * @tags Selectors
     * @name AbsenceTypes
     * @request POST:/api/v1/Selectors/AbsenceTypes
     * @secure
     * @response `200` `(AbsenceTypeSelectorResponse)[]` OK
     */
    absenceTypes: (data: AbsenceTypesPayload, params: RequestParams = {}) =>
      this.request<AbsenceTypeSelectorResponse[], any>({
        path: `/api/v1/Selectors/AbsenceTypes`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Rótulos para filtro avançado
     *
     * @tags Selectors
     * @name StickerAdvFilter
     * @request POST:/api/v1/Selectors/StickerAdvFilter
     * @secure
     * @response `200` `(StickerSelectorAdvFilterResponse)[]` OK
     */
    stickerAdvFilter: (
      data: StickerAdvFilterPayload,
      params: RequestParams = {},
    ) =>
      this.request<StickerSelectorAdvFilterResponse[], any>({
        path: `/api/v1/Selectors/StickerAdvFilter`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém lista de tempo de experiência no exterior.
     *
     * @tags Selectors
     * @name AbroadExperienceTime
     * @request GET:/api/v1/Selectors/AbroadExperienceTime
     * @secure
     * @response `200` `(UserIdiomAbroadExperienceTimeSelectorResponse)[]` OK
     */
    abroadExperienceTime: (params: RequestParams = {}) =>
      this.request<UserIdiomAbroadExperienceTimeSelectorResponse[], any>({
        path: `/api/v1/Selectors/AbroadExperienceTime`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Obtém lista de idiomas.
     *
     * @tags Selectors
     * @name UserIdiomProficiencTypes
     * @request GET:/api/v1/Selectors/UserIdiomProficiencTypes
     * @secure
     * @response `200` `(UserIdiomProficiencyTypesSelectorResponse)[]` OK
     */
    userIdiomProficiencTypes: (params: RequestParams = {}) =>
      this.request<UserIdiomProficiencyTypesSelectorResponse[], any>({
        path: `/api/v1/Selectors/UserIdiomProficiencTypes`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Termos de Acordo de Uso para Treinamentos.
     *
     * @tags Selectors
     * @name TrainingAgreements
     * @request POST:/api/v1/Selectors/TrainingAgreements
     * @secure
     * @response `200` `(AgreementDto)[]` OK
     */
    trainingAgreements: (params: RequestParams = {}) =>
      this.request<AgreementDto[], any>({
        path: `/api/v1/Selectors/TrainingAgreements`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  sticker = {
    /**
     * Obtém uma lista de stickers para gerenciamento.
     *
     * @tags Sticker
     * @name ManagedStickers
     * @request POST:/api/v1/Sticker/ManagedStickers
     * @secure
     * @response `200` `ManagedStickerListQueryResponsePaginatedList` OK
     */
    managedStickers: (
      query?: {
        ApplyTo?: StickerAppliesTo;
        /** @format int32 */
        PageNumber?: number;
        /** @format int32 */
        PageSize?: number;
        /** @format int32 */
        Offset?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<ManagedStickerListQueryResponsePaginatedList, any>({
        path: `/api/v1/Sticker/ManagedStickers`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Obtém um rótulo
     *
     * @tags Sticker
     * @name ManagedGetSticker
     * @request POST:/api/v1/Sticker/ManagedGetSticker
     * @secure
     * @response `200` `ManagedStickerResponse` OK
     */
    managedGetSticker: (
      data: ManagedGetStickerPayload,
      params: RequestParams = {},
    ) =>
      this.request<ManagedStickerResponse, any>({
        path: `/api/v1/Sticker/ManagedGetSticker`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém uma lista de tipos de aplicações de rótulos.
     *
     * @tags Sticker
     * @name StickerAppliesToListQuery
     * @request GET:/api/v1/Sticker/StickerAppliesToListQuery
     * @secure
     * @response `200` `(StickerAppliesToListQueryResponse)[]` OK
     */
    stickerAppliesToListQuery: (params: RequestParams = {}) =>
      this.request<StickerAppliesToListQueryResponse[], any>({
        path: `/api/v1/Sticker/StickerAppliesToListQuery`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Obtém uma lista de rótulos disponíveis para aplicação.
     *
     * @tags Sticker
     * @name AvailableStickers
     * @request GET:/api/v1/Sticker/AvailableStickers
     * @secure
     * @response `200` `(StickerDto)[]` OK
     */
    availableStickers: (
      query?: {
        ApplyTo?: StickerAppliesTo;
        /** @format int32 */
        PageNumber?: number;
        /** @format int32 */
        PageSize?: number;
        /** @format int32 */
        Offset?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<StickerDto[], any>({
        path: `/api/v1/Sticker/AvailableStickers`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Cria um rótulo.
     *
     * @tags Sticker
     * @name CreateSticker
     * @request POST:/api/v1/Sticker/CreateSticker
     * @secure
     * @response `200` `string` OK
     */
    createSticker: (data: CreateStickerPayload, params: RequestParams = {}) =>
      this.request<string, any>({
        path: `/api/v1/Sticker/CreateSticker`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Altera um rótulo.
     *
     * @tags Sticker
     * @name UpdateSticker
     * @request PUT:/api/v1/Sticker/UpdateSticker
     * @secure
     * @response `200` `boolean` OK
     */
    updateSticker: (data: UpdateStickerPayload, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/api/v1/Sticker/UpdateSticker`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Exclui um sticker.
     *
     * @tags Sticker
     * @name DeleteSticker
     * @request DELETE:/api/v1/Sticker/DeleteSticker
     * @secure
     * @response `200` `boolean` OK
     */
    deleteSticker: (
      query?: {
        /** @format uuid */
        StickerId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/Sticker/DeleteSticker`,
        method: "DELETE",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Altera a ordem de exibição dentro do grupo de importância de um rótulo.
     *
     * @tags Sticker
     * @name ChangePriorityOrderSticker
     * @request POST:/api/v1/Sticker/ChangePriorityOrderSticker
     * @secure
     * @response `200` `boolean` OK
     */
    changePriorityOrderSticker: (
      query?: {
        /** @format uuid */
        StickerId?: string;
        PriorityOption?: ChangeStickerPriorityOption;
      },
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/Sticker/ChangePriorityOrderSticker`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Junta um rótulo a outro.
     *
     * @tags Sticker
     * @name JoinStickers
     * @request POST:/api/v1/Sticker/JoinStickers
     * @secure
     * @response `200` `boolean` OK
     */
    joinStickers: (data: JoinStickersPayload, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/api/v1/Sticker/JoinStickers`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  suggestions = {
    /**
     * Tags
     *
     * @tags Suggestions
     * @name Tags
     * @request POST:/api/v1/Suggestions/Tags
     * @secure
     * @response `200` `TagsSuggestionAutoCompletePaginatedList` OK
     */
    tags: (data: TagsBody, params: RequestParams = {}) =>
      this.request<TagsSuggestionAutoCompletePaginatedList, any>({
        path: `/api/v1/Suggestions/Tags`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Agreements
     *
     * @tags Suggestions
     * @name Agreements
     * @request POST:/api/v1/Suggestions/Agreements
     * @secure
     * @response `200` `AgreementAutoCompleteDataModelDtoPaginatedList` OK
     */
    agreements: (data: AgreementsPayload, params: RequestParams = {}) =>
      this.request<AgreementAutoCompleteDataModelDtoPaginatedList, any>({
        path: `/api/v1/Suggestions/Agreements`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Membros (Usuários e Grupos)
     *
     * @tags Suggestions
     * @name ManagedMember
     * @request POST:/api/v1/Suggestions/ManagedMember
     * @secure
     * @response `200` `MemberAutoCompleteDataModelDtoPaginatedList` OK
     */
    managedMember: (data: ManagedMemberBody, params: RequestParams = {}) =>
      this.request<MemberAutoCompleteDataModelDtoPaginatedList, any>({
        path: `/api/v1/Suggestions/ManagedMember`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Membros (Usuários e Grupos)
     *
     * @tags Suggestions
     * @name ChannelMember
     * @request POST:/api/v1/Suggestions/ChannelMember
     * @secure
     * @response `200` `MemberAutoCompleteDataModelDtoPaginatedList` OK
     */
    channelMember: (data: ChannelMemberPayload, params: RequestParams = {}) =>
      this.request<MemberAutoCompleteDataModelDtoPaginatedList, any>({
        path: `/api/v1/Suggestions/ChannelMember`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Membros (Usuários e Grupos)
     *
     * @tags Suggestions
     * @name GroupUsages
     * @request GET:/api/v1/Suggestions/GroupUsages
     * @secure
     * @response `200` `(AutoCompleteDataModelDto)[]` OK
     */
    groupUsages: (params: RequestParams = {}) =>
      this.request<AutoCompleteDataModelDto[], any>({
        path: `/api/v1/Suggestions/GroupUsages`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Unidades Administrativas em que o Usuário pode Registrar Grupos.
     *
     * @tags Suggestions
     * @name GroupUnitSuggestions
     * @request POST:/api/v1/Suggestions/GroupUnitSuggestions
     * @secure
     * @response `200` `UnitAutoCompleteHierarchicalModelDtoPaginatedList` OK
     */
    groupUnitSuggestions: (
      data: GroupUnitSuggestionsPayload,
      params: RequestParams = {},
    ) =>
      this.request<UnitAutoCompleteHierarchicalModelDtoPaginatedList, any>({
        path: `/api/v1/Suggestions/GroupUnitSuggestions`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Status de Login para regra de grupos
     *
     * @tags Suggestions
     * @name GroupRuleLoginStatus
     * @request POST:/api/v1/Suggestions/GroupRuleLoginStatus
     * @secure
     * @response `200` `GroupRuleLoginStatusSuggestionsResponsePaginatedList` OK
     */
    groupRuleLoginStatus: (
      data: GroupRuleLoginStatusPayload,
      params: RequestParams = {},
    ) =>
      this.request<GroupRuleLoginStatusSuggestionsResponsePaginatedList, any>({
        path: `/api/v1/Suggestions/GroupRuleLoginStatus`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Tags Permite anomymois porque é utilizado em autoregistro de usuários
     *
     * @tags Suggestions
     * @name Workplaces
     * @request POST:/api/v1/Suggestions/Workplaces
     * @secure
     * @response `200` `AutoCompleteDataModelDtoPaginatedList` OK
     */
    workplaces: (data: WorkplacesPayload, params: RequestParams = {}) =>
      this.request<AutoCompleteDataModelDtoPaginatedList, any>({
        path: `/api/v1/Suggestions/Workplaces`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Security Role
     *
     * @tags Suggestions
     * @name SecurityRoles
     * @request POST:/api/v1/Suggestions/SecurityRoles
     * @secure
     * @response `200` `AutoCompleteDataModelDtoPaginatedList` OK
     */
    securityRoles: (data: SecurityRolesPayload, params: RequestParams = {}) =>
      this.request<AutoCompleteDataModelDtoPaginatedList, any>({
        path: `/api/v1/Suggestions/SecurityRoles`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Grupos
     *
     * @tags Suggestions
     * @name Groups
     * @request POST:/api/v1/Suggestions/Groups
     * @secure
     * @response `200` `AutoCompleteDataModelDtoPaginatedList` OK
     */
    groups: (data: GroupsBody, params: RequestParams = {}) =>
      this.request<AutoCompleteDataModelDtoPaginatedList, any>({
        path: `/api/v1/Suggestions/Groups`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Usuários
     *
     * @tags Suggestions
     * @name Users
     * @request POST:/api/v1/Suggestions/Users
     * @secure
     * @response `200` `AutoCompleteDataModelDtoPaginatedList` OK
     */
    users: (data: UsersInput, params: RequestParams = {}) =>
      this.request<AutoCompleteDataModelDtoPaginatedList, any>({
        path: `/api/v1/Suggestions/Users`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Gerentes
     *
     * @tags Suggestions
     * @name Managers
     * @request POST:/api/v1/Suggestions/Managers
     * @secure
     * @response `200` `ManagerAutoCompleteDataModelDtoPaginatedList` OK
     */
    managers: (data: ManagersBody, params: RequestParams = {}) =>
      this.request<ManagerAutoCompleteDataModelDtoPaginatedList, any>({
        path: `/api/v1/Suggestions/Managers`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém uma Lista de Gerentes Diretos disponíveis para o Usuário Corrente.
     *
     * @tags Suggestions
     * @name DirectManagers
     * @request POST:/api/v1/Suggestions/DirectManagers
     * @secure
     * @response `200` `ManagerAutoCompleteDataModelDtoPaginatedList` OK
     */
    directManagers: (data: DirectManagersPayload, params: RequestParams = {}) =>
      this.request<ManagerAutoCompleteDataModelDtoPaginatedList, any>({
        path: `/api/v1/Suggestions/DirectManagers`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém AutoComplete de Subordinados do Gerente.
     *
     * @tags Suggestions
     * @name Subordinates
     * @request POST:/api/v1/Suggestions/Subordinates
     * @secure
     * @response `200` `SubordinaterAutoCompleteDataModelDtoPaginatedList` OK
     */
    subordinates: (data: SubordinatesBody, params: RequestParams = {}) =>
      this.request<SubordinaterAutoCompleteDataModelDtoPaginatedList, any>({
        path: `/api/v1/Suggestions/Subordinates`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Unidade Administrativa
     *
     * @tags Suggestions
     * @name Units
     * @request POST:/api/v1/Suggestions/Units
     * @secure
     * @response `200` `UnitAutoCompleteDataModelDtoPaginatedList` OK
     */
    units: (data: UnitsPayload, params: RequestParams = {}) =>
      this.request<UnitAutoCompleteDataModelDtoPaginatedList, any>({
        path: `/api/v1/Suggestions/Units`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Unidade Administrativa
     *
     * @tags Suggestions
     * @name UnitHierarchical
     * @request POST:/api/v1/Suggestions/UnitHierarchical
     * @secure
     * @response `200` `UnitAutoCompleteHierarchicalModelDtoPaginatedList` OK
     */
    unitHierarchical: (
      data: UnitHierarchicalPayload,
      params: RequestParams = {},
    ) =>
      this.request<UnitAutoCompleteHierarchicalModelDtoPaginatedList, any>({
        path: `/api/v1/Suggestions/UnitHierarchical`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Permissions
     *
     * @tags Suggestions
     * @name Permissions
     * @request POST:/api/v1/Suggestions/Permissions
     * @secure
     * @response `200` `AutoCompleteDataModelDtoPaginatedList` OK
     */
    permissions: (data: PermissionsBody, params: RequestParams = {}) =>
      this.request<AutoCompleteDataModelDtoPaginatedList, any>({
        path: `/api/v1/Suggestions/Permissions`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Calendários de feriados
     *
     * @tags Suggestions
     * @name Calendars
     * @request POST:/api/v1/Suggestions/Calendars
     * @secure
     * @response `200` `AutoCompleteDataModelDtoPaginatedList` OK
     */
    calendars: (data: CalendarsPayload, params: RequestParams = {}) =>
      this.request<AutoCompleteDataModelDtoPaginatedList, any>({
        path: `/api/v1/Suggestions/Calendars`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Rótulos
     *
     * @tags Suggestions
     * @name Stickers
     * @request POST:/api/v1/Suggestions/Stickers
     * @secure
     * @response `200` `AutoCompleteDataModelDtoPaginatedList` OK
     */
    stickers: (data: StickersPayload, params: RequestParams = {}) =>
      this.request<AutoCompleteDataModelDtoPaginatedList, any>({
        path: `/api/v1/Suggestions/Stickers`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Tópicos
     *
     * @tags Suggestions
     * @name Topics
     * @request POST:/api/v1/Suggestions/Topics
     * @secure
     * @response `200` `TopicAutoCompleteDataModelDtoPaginatedList` OK
     */
    topics: (data: TopicsPayload, params: RequestParams = {}) =>
      this.request<TopicAutoCompleteDataModelDtoPaginatedList, any>({
        path: `/api/v1/Suggestions/Topics`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Tópicos (sugestão hierárquica)
     *
     * @tags Suggestions
     * @name TopicHierarchical
     * @request POST:/api/v1/Suggestions/TopicHierarchical
     * @secure
     * @response `200` `TopicAutoCompleteHierarchicalModelDtoPaginatedList` OK
     */
    topicHierarchical: (
      data: TopicHierarchicalPayload,
      params: RequestParams = {},
    ) =>
      this.request<TopicAutoCompleteHierarchicalModelDtoPaginatedList, any>({
        path: `/api/v1/Suggestions/TopicHierarchical`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Tópicos
     *
     * @tags Suggestions
     * @name UserTagInterests
     * @request POST:/api/v1/Suggestions/UserTagInterests
     * @secure
     * @response `200` `AutoCompleteDataModelDtoPaginatedList` OK
     */
    userTagInterests: (
      data: UserTagInterestsPayload,
      params: RequestParams = {},
    ) =>
      this.request<AutoCompleteDataModelDtoPaginatedList, any>({
        path: `/api/v1/Suggestions/UserTagInterests`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém uma lista com Sugestões de Tipo de Unidade Administrativa.
     *
     * @tags Suggestions
     * @name UnitTypes
     * @request POST:/api/v1/Suggestions/UnitTypes
     * @secure
     * @response `200` `AutoCompleteDataModelDtoPaginatedList` OK
     */
    unitTypes: (data: UnitTypesBody, params: RequestParams = {}) =>
      this.request<AutoCompleteDataModelDtoPaginatedList, any>({
        path: `/api/v1/Suggestions/UnitTypes`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Idiomas.
     *
     * @tags Suggestions
     * @name Idioms
     * @request GET:/api/v1/Suggestions/Idioms
     * @secure
     * @response `200` `AutoCompleteDataModelDtoPaginatedList` OK
     */
    idioms: (
      query?: {
        SearchText?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AutoCompleteDataModelDtoPaginatedList, any>({
        path: `/api/v1/Suggestions/Idioms`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Tipo de Fila de Execução
     *
     * @tags Suggestions
     * @name ScheduleQueueTypes
     * @request GET:/api/v1/Suggestions/ScheduleQueueTypes
     * @secure
     * @response `200` `(AutoCompleteDataModelDto)[]` OK
     */
    scheduleQueueTypes: (
      query?: {
        SearchText?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AutoCompleteDataModelDto[], any>({
        path: `/api/v1/Suggestions/ScheduleQueueTypes`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Usuários para Mensagens Diretas
     *
     * @tags Suggestions
     * @name UsersDirectMessage
     * @request POST:/api/v1/Suggestions/UsersDirectMessage
     * @secure
     * @response `200` `AutoCompleteDataModelDtoPaginatedList` OK
     */
    usersDirectMessage: (
      data: UsersDirectMessagePayload,
      params: RequestParams = {},
    ) =>
      this.request<AutoCompleteDataModelDtoPaginatedList, any>({
        path: `/api/v1/Suggestions/UsersDirectMessage`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  system = {
    /**
     * Sobre MicroPower PowerMinds.
     *
     * @tags System
     * @name AboutInfo
     * @request GET:/api/v1/System/AboutInfo
     * @secure
     * @response `200` `AboutInfoDto` OK
     */
    aboutInfo: (params: RequestParams = {}) =>
      this.request<AboutInfoDto, any>({
        path: `/api/v1/System/AboutInfo`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Obtém a Lista de Release Notes do Locatário.
     *
     * @tags System
     * @name GetReleaseNotes
     * @request GET:/api/v1/System/GetReleaseNotes
     * @secure
     * @response `200` `(ReleaseNoteDto)[]` OK
     */
    getReleaseNotes: (params: RequestParams = {}) =>
      this.request<ReleaseNoteDto[], any>({
        path: `/api/v1/System/GetReleaseNotes`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Obtém um Release Note
     *
     * @tags System
     * @name GetReleaseNote
     * @request GET:/api/v1/System/GetReleaseNote
     * @secure
     * @response `200` `string` OK (May return null)
     * @response `204` `any` No Content
     */
    getReleaseNote: (
      query?: {
        releaseNumber?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/api/v1/System/GetReleaseNote`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Verifica limite de uso do sistema.
     *
     * @tags System
     * @name CheckSystemUsages
     * @request GET:/api/v1/System/CheckSystemUsages
     * @secure
     * @response `200` `SystemUsageDto` OK
     */
    checkSystemUsages: (params: RequestParams = {}) =>
      this.request<SystemUsageDto, any>({
        path: `/api/v1/System/CheckSystemUsages`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  tagManagement = {
    /**
     * Obtem os dados para edição de uma Tag.
     *
     * @tags TagManagement
     * @name ManagedTag
     * @request POST:/api/v1/TagManagement/ManagedTag
     * @secure
     * @response `200` `ManagedTagResponse` OK
     */
    managedTag: (data: ManagedTagPayload, params: RequestParams = {}) =>
      this.request<ManagedTagResponse, any>({
        path: `/api/v1/TagManagement/ManagedTag`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém a lista de Tags.
     *
     * @tags TagManagement
     * @name ManagedTags
     * @request POST:/api/v1/TagManagement/ManagedTags
     * @secure
     * @response `200` `ManagedTagListResponsePaginatedList` OK
     */
    managedTags: (data: ManagedTagsPayload, params: RequestParams = {}) =>
      this.request<ManagedTagListResponsePaginatedList, any>({
        path: `/api/v1/TagManagement/ManagedTags`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém a lista de Uso das tags
     *
     * @tags TagManagement
     * @name ManagedTagUsage
     * @request POST:/api/v1/TagManagement/ManagedTagUsage
     * @secure
     * @response `200` `(ManagedTagUsageListResponse)[]` OK
     */
    managedTagUsage: (params: RequestParams = {}) =>
      this.request<ManagedTagUsageListResponse[], any>({
        path: `/api/v1/TagManagement/ManagedTagUsage`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Obtém a lista de tipos de restrições das tags
     *
     * @tags TagManagement
     * @name ManagedTagRestriction
     * @request POST:/api/v1/TagManagement/ManagedTagRestriction
     * @secure
     * @response `200` `(ManagedTagRestrictionListResponse)[]` OK
     */
    managedTagRestriction: (params: RequestParams = {}) =>
      this.request<ManagedTagRestrictionListResponse[], any>({
        path: `/api/v1/TagManagement/ManagedTagRestriction`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Obtém a lista de unidades administrativas associadas a uma tag
     *
     * @tags TagManagement
     * @name GetTagAssociatedUnits
     * @request POST:/api/v1/TagManagement/GetTagAssociatedUnits
     * @secure
     * @response `200` `UnitItemDtoPaginatedList` OK
     */
    getTagAssociatedUnits: (
      data: GetTagAssociatedUnitsPayload,
      params: RequestParams = {},
    ) =>
      this.request<UnitItemDtoPaginatedList, any>({
        path: `/api/v1/TagManagement/GetTagAssociatedUnits`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém a lista de grupos associados a uma tag
     *
     * @tags TagManagement
     * @name GetTagAssociatedGroups
     * @request POST:/api/v1/TagManagement/GetTagAssociatedGroups
     * @secure
     * @response `200` `GroupItemDtoPaginatedList` OK
     */
    getTagAssociatedGroups: (
      data: GetTagAssociatedGroupsPayload,
      params: RequestParams = {},
    ) =>
      this.request<GroupItemDtoPaginatedList, any>({
        path: `/api/v1/TagManagement/GetTagAssociatedGroups`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém a lista de usuários associados a uma tag
     *
     * @tags TagManagement
     * @name GetTagAssociatedUsers
     * @request POST:/api/v1/TagManagement/GetTagAssociatedUsers
     * @secure
     * @response `200` `UserItemDtoPaginatedList` OK
     */
    getTagAssociatedUsers: (
      data: GetTagAssociatedUsersPayload,
      params: RequestParams = {},
    ) =>
      this.request<UserItemDtoPaginatedList, any>({
        path: `/api/v1/TagManagement/GetTagAssociatedUsers`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém a lista de tópicos associados a uma tag
     *
     * @tags TagManagement
     * @name GetTagAssociatedTopics
     * @request POST:/api/v1/TagManagement/GetTagAssociatedTopics
     * @secure
     * @response `200` `TopicItemDtoPaginatedList` OK
     */
    getTagAssociatedTopics: (
      data: GetTagAssociatedTopicsPayload,
      params: RequestParams = {},
    ) =>
      this.request<TopicItemDtoPaginatedList, any>({
        path: `/api/v1/TagManagement/GetTagAssociatedTopics`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém a lista de treinamentos associados a uma tag
     *
     * @tags TagManagement
     * @name GetTagAssociatedTrainings
     * @request POST:/api/v1/TagManagement/GetTagAssociatedTrainings
     * @secure
     * @response `200` `TrainingItemDtoPaginatedList` OK
     */
    getTagAssociatedTrainings: (
      data: GetTagAssociatedTrainingsPayload,
      params: RequestParams = {},
    ) =>
      this.request<TrainingItemDtoPaginatedList, any>({
        path: `/api/v1/TagManagement/GetTagAssociatedTrainings`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém a lista de Tags associadas à Avaliações/Pesquisas.
     *
     * @tags TagManagement
     * @name GetTagAssociatedAssessments
     * @request POST:/api/v1/TagManagement/GetTagAssociatedAssessments
     * @secure
     * @response `200` `AssessmentItemDtoPaginatedList` OK
     */
    getTagAssociatedAssessments: (
      data: GetTagAssociatedAssessmentsPayload,
      params: RequestParams = {},
    ) =>
      this.request<AssessmentItemDtoPaginatedList, any>({
        path: `/api/v1/TagManagement/GetTagAssociatedAssessments`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Cria uma tag
     *
     * @tags TagManagement
     * @name CreateTag
     * @request POST:/api/v1/TagManagement/CreateTag
     * @secure
     * @response `200` `string | null` OK
     */
    createTag: (data: CreateTagPayload, params: RequestParams = {}) =>
      this.request<string | null, any>({
        path: `/api/v1/TagManagement/CreateTag`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Atualiza uma Tag
     *
     * @tags TagManagement
     * @name UpdateTag
     * @request POST:/api/v1/TagManagement/UpdateTag
     * @secure
     * @response `200` `boolean` OK
     */
    updateTag: (data: UpdateTagPayload, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/api/v1/TagManagement/UpdateTag`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Exclui uma Tag e a referência de onde ela é utilizada
     *
     * @tags TagManagement
     * @name DeleteTag
     * @request POST:/api/v1/TagManagement/DeleteTag
     * @secure
     * @response `200` `boolean` OK
     */
    deleteTag: (data: DeleteTagPayload, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/api/v1/TagManagement/DeleteTag`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Junta duas tags
     *
     * @tags TagManagement
     * @name JoinTags
     * @request POST:/api/v1/TagManagement/JoinTags
     * @secure
     * @response `200` `boolean` OK
     */
    joinTags: (data: JoinTagsPayload, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/api/v1/TagManagement/JoinTags`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Alterar a restrição das tags proíbidas
     *
     * @tags TagManagement
     * @name ChangeRestrictionTag
     * @request POST:/api/v1/TagManagement/ChangeRestrictionTag
     * @secure
     * @response `200` `boolean` OK
     */
    changeRestrictionTag: (
      data: ChangeRestrictionTagPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/TagManagement/ChangeRestrictionTag`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  topic = {
    /**
     * Obtém uma lista de usuários associados ao tópico.
     *
     * @tags Topic
     * @name GetUsers
     * @request POST:/api/v1/Topic/GetUsers
     * @secure
     * @response `200` `UserItemDtoPaginatedList` OK
     */
    getUsers: (data: GetUsersInput, params: RequestParams = {}) =>
      this.request<UserItemDtoPaginatedList, any>({
        path: `/api/v1/Topic/GetUsers`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  topicChallenge = {
    /**
     * Obtém a lista de Tópicos de Desafios.
     *
     * @tags TopicChallenge
     * @name TopicsChallenge
     * @request POST:/api/v1/TopicChallenge/TopicsChallenge
     * @secure
     * @response `200` `TopicChallengeResponsePaginatedList` OK
     */
    topicsChallenge: (
      data: TopicsChallengePayload,
      params: RequestParams = {},
    ) =>
      this.request<TopicChallengeResponsePaginatedList, any>({
        path: `/api/v1/TopicChallenge/TopicsChallenge`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém os dados para edição do desafio de um tópico.
     *
     * @tags TopicChallenge
     * @name ManageTopicChallenge
     * @request POST:/api/v1/TopicChallenge/ManageTopicChallenge
     * @secure
     * @response `200` `ManagedTopicChallengeRequest` OK
     */
    manageTopicChallenge: (
      data: ManageTopicChallengePayload,
      params: RequestParams = {},
    ) =>
      this.request<ManagedTopicChallengeRequest, any>({
        path: `/api/v1/TopicChallenge/ManageTopicChallenge`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Adiciona um tópico para aplicação de desafios.
     *
     * @tags TopicChallenge
     * @name AddTopicChallenge
     * @request POST:/api/v1/TopicChallenge/AddTopicChallenge
     * @secure
     * @response `200` `boolean` OK
     */
    addTopicChallenge: (
      data: AddTopicChallengePayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/TopicChallenge/AddTopicChallenge`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Altera as informações de público-alvo do desafio de um tópico.
     *
     * @tags TopicChallenge
     * @name UpdateTopicChallenge
     * @request POST:/api/v1/TopicChallenge/UpdateTopicChallenge
     * @secure
     * @response `200` `boolean` OK
     */
    updateTopicChallenge: (
      data: UpdateTopicChallengePayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/TopicChallenge/UpdateTopicChallenge`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Remove um tópico da aplicação de desafios.
     *
     * @tags TopicChallenge
     * @name RemoveTopicChallenge
     * @request POST:/api/v1/TopicChallenge/RemoveTopicChallenge
     * @secure
     * @response `200` `boolean` OK
     */
    removeTopicChallenge: (
      data: RemoveTopicChallengePayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/TopicChallenge/RemoveTopicChallenge`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Ativa ou Desativa os desafios do tópico.
     *
     * @tags TopicChallenge
     * @name ChangeChallengeStatus
     * @request POST:/api/v1/TopicChallenge/ChangeChallengeStatus
     * @secure
     * @response `200` `boolean` OK
     */
    changeChallengeStatus: (
      data: ChangeChallengeStatusPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/TopicChallenge/ChangeChallengeStatus`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  topicManagement = {
    /**
     * Cria um tópico.
     *
     * @tags TopicManagement
     * @name CreateTopic
     * @request POST:/api/v1/TopicManagement/CreateTopic
     * @secure
     * @response `200` `string` OK
     */
    createTopic: (data: CreateTopicPayload, params: RequestParams = {}) =>
      this.request<string, any>({
        path: `/api/v1/TopicManagement/CreateTopic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Altera um tópico.
     *
     * @tags TopicManagement
     * @name UpdateTopic
     * @request POST:/api/v1/TopicManagement/UpdateTopic
     * @secure
     * @response `200` `boolean` OK
     */
    updateTopic: (data: UpdateTopicPayload, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/api/v1/TopicManagement/UpdateTopic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Exclui um tópico.
     *
     * @tags TopicManagement
     * @name DeleteTopic
     * @request POST:/api/v1/TopicManagement/DeleteTopic
     * @secure
     * @response `200` `boolean` OK
     */
    deleteTopic: (data: DeleteTopicPayload, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/api/v1/TopicManagement/DeleteTopic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Adiciona um usuário ao tópico.
     *
     * @tags TopicManagement
     * @name AddUserToTopic
     * @request POST:/api/v1/TopicManagement/AddUserToTopic
     * @secure
     * @response `200` `boolean` OK
     */
    addUserToTopic: (data: AddUserToTopicPayload, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/api/v1/TopicManagement/AddUserToTopic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Remove um usuário do tópico.
     *
     * @tags TopicManagement
     * @name RemoveUserFromTopic
     * @request POST:/api/v1/TopicManagement/RemoveUserFromTopic
     * @secure
     * @response `200` `boolean` OK
     */
    removeUserFromTopic: (
      data: RemoveUserFromTopicPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/TopicManagement/RemoveUserFromTopic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Altera o tipo de vínculo do usuário.
     *
     * @tags TopicManagement
     * @name ChangeUserLink
     * @request POST:/api/v1/TopicManagement/ChangeUserLink
     * @secure
     * @response `200` `boolean` OK
     */
    changeUserLink: (data: ChangeUserLinkPayload, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/api/v1/TopicManagement/ChangeUserLink`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Adiciona um grupo dinâmico ao tópico.
     *
     * @tags TopicManagement
     * @name AddDynamicGroupToTopic
     * @request POST:/api/v1/TopicManagement/AddDynamicGroupToTopic
     * @secure
     * @response `200` `boolean` OK
     */
    addDynamicGroupToTopic: (
      data: AddDynamicGroupToTopicPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/TopicManagement/AddDynamicGroupToTopic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Remove um grupo dinâmico do tópico.
     *
     * @tags TopicManagement
     * @name RemoveDynamicGroupFromTopic
     * @request POST:/api/v1/TopicManagement/RemoveDynamicGroupFromTopic
     * @secure
     * @response `200` `boolean` OK
     */
    removeDynamicGroupFromTopic: (
      data: RemoveDynamicGroupFromTopicPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/TopicManagement/RemoveDynamicGroupFromTopic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Relaciona um tópico.
     *
     * @tags TopicManagement
     * @name AddTopicRelation
     * @request POST:/api/v1/TopicManagement/AddTopicRelation
     * @secure
     * @response `200` `boolean` OK
     */
    addTopicRelation: (
      data: AddTopicRelationPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/TopicManagement/AddTopicRelation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Remove um tópico relacionado.
     *
     * @tags TopicManagement
     * @name RemoveTopicRelation
     * @request POST:/api/v1/TopicManagement/RemoveTopicRelation
     * @secure
     * @response `200` `boolean` OK
     */
    removeTopicRelation: (
      data: RemoveTopicRelationPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/TopicManagement/RemoveTopicRelation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Junção entre dois tópicos.
     *
     * @tags TopicManagement
     * @name JoinTopic
     * @request POST:/api/v1/TopicManagement/JoinTopic
     * @secure
     * @response `200` `boolean` OK
     */
    joinTopic: (data: JoinTopicPayload, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/api/v1/TopicManagement/JoinTopic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém a lista de Tópicos.
     *
     * @tags TopicManagement
     * @name ManagedTopics
     * @request POST:/api/v1/TopicManagement/ManagedTopics
     * @secure
     * @response `200` `ManagedTopicListResponsePaginatedList` OK
     */
    managedTopics: (data: ManagedTopicsPayload, params: RequestParams = {}) =>
      this.request<ManagedTopicListResponsePaginatedList, any>({
        path: `/api/v1/TopicManagement/ManagedTopics`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém as informações principais do Tópico para edição.
     *
     * @tags TopicManagement
     * @name ManagedGetTopic
     * @request POST:/api/v1/TopicManagement/ManagedGetTopic
     * @secure
     * @response `200` `ManagedTopicResponse` OK
     */
    managedGetTopic: (
      data: ManagedGetTopicPayload,
      params: RequestParams = {},
    ) =>
      this.request<ManagedTopicResponse, any>({
        path: `/api/v1/TopicManagement/ManagedGetTopic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém uma lista de usuários associados ao tópico.
     *
     * @tags TopicManagement
     * @name GetUsers
     * @request POST:/api/v1/TopicManagement/GetUsers
     * @secure
     * @response `200` `ManagedTopicUsersQueryResponsePaginatedList` OK
     */
    getUsers: (data: GetUsersBody1, params: RequestParams = {}) =>
      this.request<ManagedTopicUsersQueryResponsePaginatedList, any>({
        path: `/api/v1/TopicManagement/GetUsers`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém uma Lista de sugestões de usuários para associar ao tópico.
     *
     * @tags TopicManagement
     * @name GetUsersLinkSuggestion
     * @request POST:/api/v1/TopicManagement/GetUsersLinkSuggestion
     * @secure
     * @response `200` `AutoCompleteDataModelDtoPaginatedList` OK
     */
    getUsersLinkSuggestion: (
      data: GetUsersLinkSuggestionPayload,
      params: RequestParams = {},
    ) =>
      this.request<AutoCompleteDataModelDtoPaginatedList, any>({
        path: `/api/v1/TopicManagement/GetUsersLinkSuggestion`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém uma lista de grupos associados ao tópico.
     *
     * @tags TopicManagement
     * @name GetGroups
     * @request POST:/api/v1/TopicManagement/GetGroups
     * @secure
     * @response `200` `ManagedTopicGroupsQueryResponsePaginatedList` OK
     */
    getGroups: (data: GetGroupsInput, params: RequestParams = {}) =>
      this.request<ManagedTopicGroupsQueryResponsePaginatedList, any>({
        path: `/api/v1/TopicManagement/GetGroups`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém uma lista de tópicos relacionados.
     *
     * @tags TopicManagement
     * @name GetRelations
     * @request POST:/api/v1/TopicManagement/GetRelations
     * @secure
     * @response `200` `ManagedTopicRelationsQueryResponsePaginatedList` OK
     */
    getRelations: (data: GetRelationsPayload, params: RequestParams = {}) =>
      this.request<ManagedTopicRelationsQueryResponsePaginatedList, any>({
        path: `/api/v1/TopicManagement/GetRelations`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém a lista de usuários que endossaram o usuário em um tópico.
     *
     * @tags TopicManagement
     * @name GetEndorserUsers
     * @request POST:/api/v1/TopicManagement/GetEndorserUsers
     * @secure
     * @response `200` `UserItemDtoPaginatedList` OK
     */
    getEndorserUsers: (
      data: GetEndorserUsersPayload,
      params: RequestParams = {},
    ) =>
      this.request<UserItemDtoPaginatedList, any>({
        path: `/api/v1/TopicManagement/GetEndorserUsers`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags TopicManagement
     * @name GetAssociatedGroups
     * @request POST:/api/v1/TopicManagement/GetAssociatedGroups
     * @secure
     * @response `200` `GroupItemDtoPaginatedList` OK
     */
    getAssociatedGroups: (
      data: GetAssociatedGroupsPayload,
      params: RequestParams = {},
    ) =>
      this.request<GroupItemDtoPaginatedList, any>({
        path: `/api/v1/TopicManagement/GetAssociatedGroups`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  trainingManagement = {
    /**
     * No description
     *
     * @tags TrainingManagement
     * @name ExportSpreadSheetImportTraining
     * @request GET:/api/v1/TrainingManagement/ExportSpreadSheetImportTraining
     * @secure
     * @response `200` `any` OK
     */
    exportSpreadSheetImportTraining: (params: RequestParams = {}) =>
      this.request<any, any>({
        path: `/api/v1/TrainingManagement/ExportSpreadSheetImportTraining`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * Obtém lista de gerenciamentos que podem ser gerenciados pelo usuário logado.
     *
     * @tags TrainingManagement
     * @name ManagedTrainingsList
     * @request POST:/api/v1/TrainingManagement/ManagedTrainingsList
     * @secure
     * @response `200` `ManagedTrainingsListResponsePaginatedList` OK
     */
    managedTrainingsList: (
      data: ManagedTrainingsListPayload,
      params: RequestParams = {},
    ) =>
      this.request<ManagedTrainingsListResponsePaginatedList, any>({
        path: `/api/v1/TrainingManagement/ManagedTrainingsList`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém um treinamento do tipo CURSO para edição das informações básicas.
     *
     * @tags TrainingManagement
     * @name GetCourseTraining
     * @request POST:/api/v1/TrainingManagement/GetCourseTraining
     * @secure
     * @response `200` `GetCourseTrainingDto` OK
     */
    getCourseTraining: (
      data: GetCourseTrainingPayload,
      params: RequestParams = {},
    ) =>
      this.request<GetCourseTrainingDto, any>({
        path: `/api/v1/TrainingManagement/GetCourseTraining`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém um treinamento do tipo CURSO EXTERNO para edição das informações básicas.
     *
     * @tags TrainingManagement
     * @name GetExternalCourseTraining
     * @request POST:/api/v1/TrainingManagement/GetExternalCourseTraining
     * @secure
     * @response `200` `GetExternalCourseTrainingDto` OK
     */
    getExternalCourseTraining: (
      data: GetExternalCourseTrainingPayload,
      params: RequestParams = {},
    ) =>
      this.request<GetExternalCourseTrainingDto, any>({
        path: `/api/v1/TrainingManagement/GetExternalCourseTraining`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém um treinamento do tipo TRILHA para edição das informações básicas.
     *
     * @tags TrainingManagement
     * @name GetLearnPathTraining
     * @request POST:/api/v1/TrainingManagement/GetLearnPathTraining
     * @secure
     * @response `200` `GetLearnPathTrainingDto` OK
     */
    getLearnPathTraining: (
      data: GetLearnPathTrainingPayload,
      params: RequestParams = {},
    ) =>
      this.request<GetLearnPathTrainingDto, any>({
        path: `/api/v1/TrainingManagement/GetLearnPathTraining`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém lista de componentes do curso.
     *
     * @tags TrainingManagement
     * @name GetCourseComponents
     * @request POST:/api/v1/TrainingManagement/GetCourseComponents
     * @secure
     * @response `200` `(TrainingComponentDto)[]` OK
     */
    getCourseComponents: (
      data: GetCourseComponentsPayload,
      params: RequestParams = {},
    ) =>
      this.request<TrainingComponentDto[], any>({
        path: `/api/v1/TrainingManagement/GetCourseComponents`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém lista de componentes da trilha.
     *
     * @tags TrainingManagement
     * @name GetLearnPathComponents
     * @request POST:/api/v1/TrainingManagement/GetLearnPathComponents
     * @secure
     * @response `200` `(TrainingComponentDto)[]` OK
     */
    getLearnPathComponents: (
      data: GetLearnPathComponentsPayload,
      params: RequestParams = {},
    ) =>
      this.request<TrainingComponentDto[], any>({
        path: `/api/v1/TrainingManagement/GetLearnPathComponents`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtem os dados da Avaliação Exclusiva de um componente do treinamento.
     *
     * @tags TrainingManagement
     * @name GetEvaluationComponent
     * @request POST:/api/v1/TrainingManagement/GetEvaluationComponent
     * @secure
     * @response `200` `GetEvaluationDto` OK (May return null)
     * @response `204` `any` No Content
     */
    getEvaluationComponent: (
      data: GetEvaluationComponentPayload,
      params: RequestParams = {},
    ) =>
      this.request<GetEvaluationDto, any>({
        path: `/api/v1/TrainingManagement/GetEvaluationComponent`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtem os dados para edição de uma reunião (evento presencial ou online).
     *
     * @tags TrainingManagement
     * @name GetMeetingComponent
     * @request POST:/api/v1/TrainingManagement/GetMeetingComponent
     * @secure
     * @response `200` `ManagedMeetingDto` OK (May return null)
     * @response `204` `any` No Content
     */
    getMeetingComponent: (
      data: GetMeetingComponentPayload,
      params: RequestParams = {},
    ) =>
      this.request<ManagedMeetingDto, any>({
        path: `/api/v1/TrainingManagement/GetMeetingComponent`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém pesos e escalas dos componentes do curso.
     *
     * @tags TrainingManagement
     * @name GetCourseComponentWeights
     * @request POST:/api/v1/TrainingManagement/GetCourseComponentWeights
     * @secure
     * @response `200` `(CourseComponentWeightsResponse)[]` OK
     */
    getCourseComponentWeights: (
      data: GetCourseComponentWeightsPayload,
      params: RequestParams = {},
    ) =>
      this.request<CourseComponentWeightsResponse[], any>({
        path: `/api/v1/TrainingManagement/GetCourseComponentWeights`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém lista de pesos dos componentes da trilha.
     *
     * @tags TrainingManagement
     * @name GetLearnPathComponentWeights
     * @request POST:/api/v1/TrainingManagement/GetLearnPathComponentWeights
     * @secure
     * @response `200` `(LearnPathComponentWeightsResponse)[]` OK
     */
    getLearnPathComponentWeights: (
      data: GetLearnPathComponentWeightsPayload,
      params: RequestParams = {},
    ) =>
      this.request<LearnPathComponentWeightsResponse[], any>({
        path: `/api/v1/TrainingManagement/GetLearnPathComponentWeights`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém lista de versões do treinamento.
     *
     * @tags TrainingManagement
     * @name GetTrainingVersions
     * @request POST:/api/v1/TrainingManagement/GetTrainingVersions
     * @secure
     * @response `200` `(TrainingVersionDto)[]` OK
     */
    getTrainingVersions: (
      data: GetTrainingVersionsPayload,
      params: RequestParams = {},
    ) =>
      this.request<TrainingVersionDto[], any>({
        path: `/api/v1/TrainingManagement/GetTrainingVersions`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Verifica se a versão do treinamento possui matrículas finalizadas.
     *
     * @tags TrainingManagement
     * @name CheckVersionFreezed
     * @request POST:/api/v1/TrainingManagement/CheckVersionFreezed
     * @secure
     * @response `200` `boolean` OK
     */
    checkVersionFreezed: (
      data: CheckVersionFreezedPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/TrainingManagement/CheckVersionFreezed`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém público-alvo do treinamento.
     *
     * @tags TrainingManagement
     * @name GetTrainingAudience
     * @request POST:/api/v1/TrainingManagement/GetTrainingAudience
     * @secure
     * @response `200` `AudienceDto` OK
     */
    getTrainingAudience: (
      data: GetTrainingAudiencePayload,
      params: RequestParams = {},
    ) =>
      this.request<AudienceDto, any>({
        path: `/api/v1/TrainingManagement/GetTrainingAudience`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém lista de usuários previstos para o público-alvo do treinamento.
     *
     * @tags TrainingManagement
     * @name GetTrainingAudiencePreviewUsers
     * @request POST:/api/v1/TrainingManagement/GetTrainingAudiencePreviewUsers
     * @secure
     * @response `200` `UserItemDtoPaginatedList` OK
     */
    getTrainingAudiencePreviewUsers: (
      data: GetTrainingAudiencePreviewUsersPayload,
      params: RequestParams = {},
    ) =>
      this.request<UserItemDtoPaginatedList, any>({
        path: `/api/v1/TrainingManagement/GetTrainingAudiencePreviewUsers`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém lista de usuários que compõe o público-alvo do treinamento.
     *
     * @tags TrainingManagement
     * @name GetTrainingAudienceUsers
     * @request POST:/api/v1/TrainingManagement/GetTrainingAudienceUsers
     * @secure
     * @response `200` `UserItemDtoPaginatedList` OK
     */
    getTrainingAudienceUsers: (
      data: GetTrainingAudienceUsersPayload,
      params: RequestParams = {},
    ) =>
      this.request<UserItemDtoPaginatedList, any>({
        path: `/api/v1/TrainingManagement/GetTrainingAudienceUsers`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém as regras do treinamento do tipo Curso.
     *
     * @tags TrainingManagement
     * @name GetCourseRules
     * @request POST:/api/v1/TrainingManagement/GetCourseRules
     * @secure
     * @response `200` `CourseRulesDto` OK
     */
    getCourseRules: (data: GetCourseRulesPayload, params: RequestParams = {}) =>
      this.request<CourseRulesDto, any>({
        path: `/api/v1/TrainingManagement/GetCourseRules`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém as regras do treinamento do tipo Trilha.
     *
     * @tags TrainingManagement
     * @name GetLearnPathRules
     * @request POST:/api/v1/TrainingManagement/GetLearnPathRules
     * @secure
     * @response `200` `LearnPathRulesDto` OK
     */
    getLearnPathRules: (
      data: GetLearnPathRulesPayload,
      params: RequestParams = {},
    ) =>
      this.request<LearnPathRulesDto, any>({
        path: `/api/v1/TrainingManagement/GetLearnPathRules`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém as regras do treinamento do tipo Curso Externo.
     *
     * @tags TrainingManagement
     * @name GetExternalCourseRules
     * @request POST:/api/v1/TrainingManagement/GetExternalCourseRules
     * @secure
     * @response `200` `ExternalCourseRulesDto` OK
     */
    getExternalCourseRules: (
      data: GetExternalCourseRulesPayload,
      params: RequestParams = {},
    ) =>
      this.request<ExternalCourseRulesDto, any>({
        path: `/api/v1/TrainingManagement/GetExternalCourseRules`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém informações do pacote.
     *
     * @tags TrainingManagement
     * @name GetScormPackageInfo
     * @request POST:/api/v1/TrainingManagement/GetScormPackageInfo
     * @secure
     * @response `200` `PackageScormDto` OK (May return null)
     * @response `204` `any` No Content
     */
    getScormPackageInfo: (
      data: GetScormPackageInfoPayload,
      params: RequestParams = {},
    ) =>
      this.request<PackageScormDto, any>({
        path: `/api/v1/TrainingManagement/GetScormPackageInfo`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags TrainingManagement
     * @name DownloadOriginalScorm
     * @request GET:/api/v1/TrainingManagement/DownloadOriginalScorm
     * @secure
     * @response `200` `any` OK
     */
    downloadOriginalScorm: (
      query?: {
        /** @format uuid */
        trainingId?: string;
        /** @format int32 */
        version?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<any, any>({
        path: `/api/v1/TrainingManagement/DownloadOriginalScorm`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * Obtém a Configuração do Player Scorm na versão do treinamento.
     *
     * @tags TrainingManagement
     * @name GetScormPlayerSettings
     * @request POST:/api/v1/TrainingManagement/GetScormPlayerSettings
     * @secure
     * @response `200` `ScormPlayerProps` OK
     */
    getScormPlayerSettings: (
      data: GetScormPlayerSettingsPayload,
      params: RequestParams = {},
    ) =>
      this.request<ScormPlayerProps, any>({
        path: `/api/v1/TrainingManagement/GetScormPlayerSettings`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtem os dados default para criar uma reunião (evento presencial ou online).
     *
     * @tags TrainingManagement
     * @name GetManagedMeetingDefault
     * @request POST:/api/v1/TrainingManagement/GetManagedMeetingDefault
     * @secure
     * @response `200` `MeetingDefaultResponse` OK
     */
    getManagedMeetingDefault: (
      data: GetManagedMeetingDefaultPayload,
      params: RequestParams = {},
    ) =>
      this.request<MeetingDefaultResponse, any>({
        path: `/api/v1/TrainingManagement/GetManagedMeetingDefault`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtem as listas de material de apoio de um treinamento ou turma.
     *
     * @tags TrainingManagement
     * @name TrainingMaterialLists
     * @request POST:/api/v1/TrainingManagement/TrainingMaterialLists
     * @secure
     * @response `200` `(TrainingMaterialListResponse)[]` OK
     */
    trainingMaterialLists: (
      data: TrainingMaterialListsPayload,
      params: RequestParams = {},
    ) =>
      this.request<TrainingMaterialListResponse[], any>({
        path: `/api/v1/TrainingManagement/TrainingMaterialLists`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém os items material de apoio de um treinamento ou turma.
     *
     * @tags TrainingManagement
     * @name TrainingMaterialListItems
     * @request POST:/api/v1/TrainingManagement/TrainingMaterialListItems
     * @secure
     * @response `200` `(TrainingMaterialListItemResponse)[]` OK
     */
    trainingMaterialListItems: (
      data: TrainingMaterialListItemsPayload,
      params: RequestParams = {},
    ) =>
      this.request<TrainingMaterialListItemResponse[], any>({
        path: `/api/v1/TrainingManagement/TrainingMaterialListItems`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtem as publicações de uma material de apoio para reordenar.
     *
     * @tags TrainingManagement
     * @name GetTrainingMaterialListItemReorder
     * @request POST:/api/v1/TrainingManagement/GetTrainingMaterialListItemReorder
     * @secure
     * @response `200` `(TrainingMaterialListItemReorderResponse)[]` OK
     */
    getTrainingMaterialListItemReorder: (
      data: GetTrainingMaterialListItemReorderPayload,
      params: RequestParams = {},
    ) =>
      this.request<TrainingMaterialListItemReorderResponse[], any>({
        path: `/api/v1/TrainingManagement/GetTrainingMaterialListItemReorder`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém o registro do treinamento para informações do material de apoio do tipo CURSO.
     *
     * @tags TrainingManagement
     * @name MaterialListTrainingOptions
     * @request POST:/api/v1/TrainingManagement/MaterialListTrainingOptions
     * @secure
     * @response `200` `MaterialListTrainingOptionsResponse` OK
     */
    materialListTrainingOptions: (
      data: MaterialListTrainingOptionsPayload,
      params: RequestParams = {},
    ) =>
      this.request<MaterialListTrainingOptionsResponse, any>({
        path: `/api/v1/TrainingManagement/MaterialListTrainingOptions`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém o registro do treinamento para informações do material de apoio do tipo CURSO.
     *
     * @tags TrainingManagement
     * @name MaterialListClassroomOptions
     * @request POST:/api/v1/TrainingManagement/MaterialListClassroomOptions
     * @secure
     * @response `200` `MaterialListClassroomOptionsResponse` OK
     */
    materialListClassroomOptions: (
      data: MaterialListClassroomOptionsPayload,
      params: RequestParams = {},
    ) =>
      this.request<MaterialListClassroomOptionsResponse, any>({
        path: `/api/v1/TrainingManagement/MaterialListClassroomOptions`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Retorna dados básicos da lista de material de uma turma.
     *
     * @tags TrainingManagement
     * @name GetMaterialListInfo
     * @request POST:/api/v1/TrainingManagement/GetMaterialListInfo
     * @secure
     * @response `200` `MaterialListInfoResponse` OK (May return null)
     * @response `204` `any` No Content
     */
    getMaterialListInfo: (
      data: GetMaterialListInfoPayload,
      params: RequestParams = {},
    ) =>
      this.request<MaterialListInfoResponse, any>({
        path: `/api/v1/TrainingManagement/GetMaterialListInfo`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém as propriedades da postagem na versão do treinamento.
     *
     * @tags TrainingManagement
     * @name GetPostProps
     * @request POST:/api/v1/TrainingManagement/GetPostProps
     * @secure
     * @response `200` `GetPostPropsDto` OK
     */
    getPostProps: (data: GetPostPropsPayload, params: RequestParams = {}) =>
      this.request<GetPostPropsDto, any>({
        path: `/api/v1/TrainingManagement/GetPostProps`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém as propriedades de um SCO na versão do treinamento.
     *
     * @tags TrainingManagement
     * @name GetScoProps
     * @request POST:/api/v1/TrainingManagement/GetScoProps
     * @secure
     * @response `200` `GetScoPropsDto` OK
     */
    getScoProps: (data: GetScoPropsPayload, params: RequestParams = {}) =>
      this.request<GetScoPropsDto, any>({
        path: `/api/v1/TrainingManagement/GetScoProps`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém as propriedades de uma AVALIAÇÃO na versão do treinamento.
     *
     * @tags TrainingManagement
     * @name GetAssessmentProps
     * @request POST:/api/v1/TrainingManagement/GetAssessmentProps
     * @secure
     * @response `200` `GetAssessmentPropsDto` OK
     */
    getAssessmentProps: (
      data: GetAssessmentPropsPayload,
      params: RequestParams = {},
    ) =>
      this.request<GetAssessmentPropsDto, any>({
        path: `/api/v1/TrainingManagement/GetAssessmentProps`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém as propriedades do curso em uma versão do treinamento.
     *
     * @tags TrainingManagement
     * @name GetCourseProps
     * @request POST:/api/v1/TrainingManagement/GetCourseProps
     * @secure
     * @response `200` `CoursePropsDto` OK
     */
    getCourseProps: (data: GetCoursePropsPayload, params: RequestParams = {}) =>
      this.request<CoursePropsDto, any>({
        path: `/api/v1/TrainingManagement/GetCourseProps`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém as propriedades da FASE DA TRILHA na versão do treinamento.
     *
     * @tags TrainingManagement
     * @name GetLearnPathPhaseProps
     * @request POST:/api/v1/TrainingManagement/GetLearnPathPhaseProps
     * @secure
     * @response `200` `GetPhasePropsDto` OK
     */
    getLearnPathPhaseProps: (
      data: GetLearnPathPhasePropsPayload,
      params: RequestParams = {},
    ) =>
      this.request<GetPhasePropsDto, any>({
        path: `/api/v1/TrainingManagement/GetLearnPathPhaseProps`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém as propriedades do COMPONENTE DA TRILHA na versão do treinamento.
     *
     * @tags TrainingManagement
     * @name GetLearnPathComponentProps
     * @request POST:/api/v1/TrainingManagement/GetLearnPathComponentProps
     * @secure
     * @response `200` `GetComponentPropsDto` OK
     */
    getLearnPathComponentProps: (
      data: GetLearnPathComponentPropsPayload,
      params: RequestParams = {},
    ) =>
      this.request<GetComponentPropsDto, any>({
        path: `/api/v1/TrainingManagement/GetLearnPathComponentProps`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém uma lista de usuário que finalizaram o treinamento em uma determinada versão.
     *
     * @tags TrainingManagement
     * @name GetUsersFinishedEnrollments
     * @request POST:/api/v1/TrainingManagement/GetUsersFinishedEnrollments
     * @secure
     * @response `200` `UserItemDtoPaginatedList` OK
     */
    getUsersFinishedEnrollments: (
      data: GetUsersFinishedEnrollmentsPayload,
      params: RequestParams = {},
    ) =>
      this.request<UserItemDtoPaginatedList, any>({
        path: `/api/v1/TrainingManagement/GetUsersFinishedEnrollments`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém uma lista de usuários que cursando o treinamento.
     *
     * @tags TrainingManagement
     * @name GetUsersActiveEnrollments
     * @request POST:/api/v1/TrainingManagement/GetUsersActiveEnrollments
     * @secure
     * @response `200` `UserItemDtoPaginatedList` OK
     */
    getUsersActiveEnrollments: (
      data: GetUsersActiveEnrollmentsPayload,
      params: RequestParams = {},
    ) =>
      this.request<UserItemDtoPaginatedList, any>({
        path: `/api/v1/TrainingManagement/GetUsersActiveEnrollments`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtem os dados para preview de uma reunião (evento presencial ou online).
     *
     * @tags TrainingManagement
     * @name GetMeetingItem
     * @request POST:/api/v1/TrainingManagement/GetMeetingItem
     * @secure
     * @response `200` `TrainingMeetingItemDto` OK (May return null)
     * @response `204` `any` No Content
     */
    getMeetingItem: (data: GetMeetingItemBody, params: RequestParams = {}) =>
      this.request<TrainingMeetingItemDto, any>({
        path: `/api/v1/TrainingManagement/GetMeetingItem`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém informações básicas de um treinamento.
     *
     * @tags TrainingManagement
     * @name GetTrainingBasicInfo
     * @request POST:/api/v1/TrainingManagement/GetTrainingBasicInfo
     * @secure
     * @response `200` `TrainingBasicInfoResponse` OK
     */
    getTrainingBasicInfo: (
      data: GetTrainingBasicInfoPayload,
      params: RequestParams = {},
    ) =>
      this.request<TrainingBasicInfoResponse, any>({
        path: `/api/v1/TrainingManagement/GetTrainingBasicInfo`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém preview do certificado do treinamento.
     *
     * @tags TrainingManagement
     * @name GetTrainingCertificatePreview
     * @request GET:/api/v1/TrainingManagement/GetTrainingCertificatePreview
     * @secure
     * @response `200` `any` OK
     */
    getTrainingCertificatePreview: (
      query?: {
        /** @format uuid */
        TrainingId?: string;
        /** @format uuid */
        ClassroomId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<any, any>({
        path: `/api/v1/TrainingManagement/GetTrainingCertificatePreview`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * Obtém o dados de configuração de gamificação do treinamento do tipo TRILHA.
     *
     * @tags TrainingManagement
     * @name GetLearnPathGame
     * @request POST:/api/v1/TrainingManagement/GetLearnPathGame
     * @secure
     * @response `200` `LearnPathGameResponse` OK
     */
    getLearnPathGame: (
      data: GetLearnPathGamePayload,
      params: RequestParams = {},
    ) =>
      this.request<LearnPathGameResponse, any>({
        path: `/api/v1/TrainingManagement/GetLearnPathGame`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém lista de fases da trilha para gamificação.
     *
     * @tags TrainingManagement
     * @name LearnPathGamePhases
     * @request POST:/api/v1/TrainingManagement/LearnPathGamePhases
     * @secure
     * @response `200` `(LearnPathGamePhasesListResponse)[]` OK
     */
    learnPathGamePhases: (
      data: LearnPathGamePhasesPayload,
      params: RequestParams = {},
    ) =>
      this.request<LearnPathGamePhasesListResponse[], any>({
        path: `/api/v1/TrainingManagement/LearnPathGamePhases`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém lista de ranking da trilha para gamificação.
     *
     * @tags TrainingManagement
     * @name LearnPathGameRankings
     * @request POST:/api/v1/TrainingManagement/LearnPathGameRankings
     * @secure
     * @response `200` `(LpGameRankingListResponse)[]` OK
     */
    learnPathGameRankings: (
      data: LearnPathGameRankingsPayload,
      params: RequestParams = {},
    ) =>
      this.request<LpGameRankingListResponse[], any>({
        path: `/api/v1/TrainingManagement/LearnPathGameRankings`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtem os dados do ranking da gamificação para edição.
     *
     * @tags TrainingManagement
     * @name GetLpGameRanking
     * @request POST:/api/v1/TrainingManagement/GetLpGameRanking
     * @secure
     * @response `200` `LpGameRankingResponse` OK
     */
    getLpGameRanking: (
      data: GetLpGameRankingPayload,
      params: RequestParams = {},
    ) =>
      this.request<LpGameRankingResponse, any>({
        path: `/api/v1/TrainingManagement/GetLpGameRanking`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém lista de usuários que compõem o público-alvo do treinamento para o ranking.
     *
     * @tags TrainingManagement
     * @name GetLpGameRankingAudienceUsers
     * @request POST:/api/v1/TrainingManagement/GetLpGameRankingAudienceUsers
     * @secure
     * @response `200` `UserItemDtoPaginatedList` OK
     */
    getLpGameRankingAudienceUsers: (
      data: GetLpGameRankingAudienceUsersPayload,
      params: RequestParams = {},
    ) =>
      this.request<UserItemDtoPaginatedList, any>({
        path: `/api/v1/TrainingManagement/GetLpGameRankingAudienceUsers`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém lista de componentes da trilha com pontuação redefinida.
     *
     * @tags TrainingManagement
     * @name LearnPathGameScores
     * @request POST:/api/v1/TrainingManagement/LearnPathGameScores
     * @secure
     * @response `200` `(LpGameScoreListResponse)[]` OK
     */
    learnPathGameScores: (
      data: LearnPathGameScoresPayload,
      params: RequestParams = {},
    ) =>
      this.request<LpGameScoreListResponse[], any>({
        path: `/api/v1/TrainingManagement/LearnPathGameScores`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém lista de premiação por ranking da trilha de gamificação.
     *
     * @tags TrainingManagement
     * @name LearnPathGameAwardRankings
     * @request POST:/api/v1/TrainingManagement/LearnPathGameAwardRankings
     * @secure
     * @response `200` `(LpGameAwardRankingListResponse)[]` OK
     */
    learnPathGameAwardRankings: (
      data: LearnPathGameAwardRankingsPayload,
      params: RequestParams = {},
    ) =>
      this.request<LpGameAwardRankingListResponse[], any>({
        path: `/api/v1/TrainingManagement/LearnPathGameAwardRankings`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém as informações de mapa e vídeos da gamificação.
     *
     * @tags TrainingManagement
     * @name LearnPathGameMap
     * @request POST:/api/v1/TrainingManagement/LearnPathGameMap
     * @secure
     * @response `200` `LearnPathGameMapResponse` OK
     */
    learnPathGameMap: (
      data: LearnPathGameMapPayload,
      params: RequestParams = {},
    ) =>
      this.request<LearnPathGameMapResponse, any>({
        path: `/api/v1/TrainingManagement/LearnPathGameMap`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtem o total de pontuação do treinamento para apresentação de mensagem na edição de redefinicão.
     *
     * @tags TrainingManagement
     * @name LearnPathGameAwardComponenPoints
     * @request POST:/api/v1/TrainingManagement/LearnPathGameAwardComponenPoints
     * @secure
     * @response `200` `number | null` OK (May return null)
     * @response `204` `any` No Content
     */
    learnPathGameAwardComponenPoints: (
      data: LearnPathGameAwardComponenPointsPayload,
      params: RequestParams = {},
    ) =>
      this.request<number | null, any>({
        path: `/api/v1/TrainingManagement/LearnPathGameAwardComponenPoints`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Coloca um Arquivo de Importação na Fila de Execução.
     *
     * @tags TrainingManagement
     * @name ImportTraining
     * @request POST:/api/v1/TrainingManagement/ImportTraining
     * @secure
     * @response `200` `boolean` OK
     */
    importTraining: (data: ImportTrainingPayload, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/api/v1/TrainingManagement/ImportTraining`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Cria ou Atualiza um treinamento do tipo CURSO.
     *
     * @tags TrainingManagement
     * @name CreateOrUpdateCourseTraining
     * @request POST:/api/v1/TrainingManagement/CreateOrUpdateCourseTraining
     * @secure
     * @response `200` `SaveTrainingResultDto` OK
     */
    createOrUpdateCourseTraining: (
      data: CreateOrUpdateCourseTrainingPayload,
      params: RequestParams = {},
    ) =>
      this.request<SaveTrainingResultDto, any>({
        path: `/api/v1/TrainingManagement/CreateOrUpdateCourseTraining`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Cria ou Atualiza um treinamento do tipo CURSO EXTERNO.
     *
     * @tags TrainingManagement
     * @name CreateOrUpdateExternalCourseTraining
     * @request POST:/api/v1/TrainingManagement/CreateOrUpdateExternalCourseTraining
     * @secure
     * @response `200` `SaveTrainingResultDto` OK
     */
    createOrUpdateExternalCourseTraining: (
      data: CreateOrUpdateExternalCourseTrainingPayload,
      params: RequestParams = {},
    ) =>
      this.request<SaveTrainingResultDto, any>({
        path: `/api/v1/TrainingManagement/CreateOrUpdateExternalCourseTraining`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Cria ou Atualiza um treinamento do tipo TRILHA.
     *
     * @tags TrainingManagement
     * @name CreateOrUpdateLearnPathTraining
     * @request POST:/api/v1/TrainingManagement/CreateOrUpdateLearnPathTraining
     * @secure
     * @response `200` `SaveTrainingResultDto` OK
     */
    createOrUpdateLearnPathTraining: (
      data: CreateOrUpdateLearnPathTrainingPayload,
      params: RequestParams = {},
    ) =>
      this.request<SaveTrainingResultDto, any>({
        path: `/api/v1/TrainingManagement/CreateOrUpdateLearnPathTraining`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Exclui um treinamento.
     *
     * @tags TrainingManagement
     * @name DeleteTraining
     * @request POST:/api/v1/TrainingManagement/DeleteTraining
     * @secure
     * @response `200` `boolean` OK
     */
    deleteTraining: (data: DeleteTrainingPayload, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/api/v1/TrainingManagement/DeleteTraining`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Publica o treinamento.
     *
     * @tags TrainingManagement
     * @name PublishTraining
     * @request POST:/api/v1/TrainingManagement/PublishTraining
     * @secure
     * @response `200` `boolean` OK
     */
    publishTraining: (
      data: PublishTrainingPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/TrainingManagement/PublishTraining`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Remove um componente do treinamento.
     *
     * @tags TrainingManagement
     * @name DeleteComponent
     * @request POST:/api/v1/TrainingManagement/DeleteComponent
     * @secure
     * @response `200` `boolean` OK
     */
    deleteComponent: (
      data: DeleteComponentPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/TrainingManagement/DeleteComponent`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Cria um curso exclusivo do tipo SCORM.
     *
     * @tags TrainingManagement
     * @name CreateExclusiveScormCourse
     * @request POST:/api/v1/TrainingManagement/CreateExclusiveScormCourse
     * @secure
     * @response `200` `boolean` OK
     */
    createExclusiveScormCourse: (
      data: CreateExclusiveScormCoursePayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/TrainingManagement/CreateExclusiveScormCourse`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Adiciona um componente do tipo 'Avaliação Exclusiva' ao treinamento.
     *
     * @tags TrainingManagement
     * @name CreateOrUpdateEvaluationComponent
     * @request POST:/api/v1/TrainingManagement/CreateOrUpdateEvaluationComponent
     * @secure
     * @response `200` `boolean` OK
     */
    createOrUpdateEvaluationComponent: (
      data: CreateOrUpdateEvaluationComponentPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/TrainingManagement/CreateOrUpdateEvaluationComponent`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Adiciona um componente do tipo 'Avaliação Exclusiva' ao treinamento.
     *
     * @tags TrainingManagement
     * @name CreateOrUpdateEvaluationExclusiveTraining
     * @request POST:/api/v1/TrainingManagement/CreateOrUpdateEvaluationExclusiveTraining
     * @secure
     * @response `200` `boolean` OK
     */
    createOrUpdateEvaluationExclusiveTraining: (
      data: CreateOrUpdateEvaluationExclusiveTrainingPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/TrainingManagement/CreateOrUpdateEvaluationExclusiveTraining`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Cria avaliação exclusiva do treinamento com as questões geradas pela AI.
     *
     * @tags TrainingManagement
     * @name CreateEvaluationAiQuestion
     * @request POST:/api/v1/TrainingManagement/CreateEvaluationAIQuestion
     * @secure
     * @response `200` `boolean` OK
     */
    createEvaluationAiQuestion: (
      data: CreateEvaluationAiQuestionPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/TrainingManagement/CreateEvaluationAIQuestion`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Adiciona um componente do tipo 'Módulo' ao treinamento.
     *
     * @tags TrainingManagement
     * @name CreateOrUpdateModuleComponent
     * @request POST:/api/v1/TrainingManagement/CreateOrUpdateModuleComponent
     * @secure
     * @response `200` `boolean` OK
     */
    createOrUpdateModuleComponent: (
      data: CreateOrUpdateModuleComponentPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/TrainingManagement/CreateOrUpdateModuleComponent`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Adiciona um componente do tipo 'Fase' ao treinamento.
     *
     * @tags TrainingManagement
     * @name CreateOrUpdatePhaseComponent
     * @request POST:/api/v1/TrainingManagement/CreateOrUpdatePhaseComponent
     * @secure
     * @response `200` `boolean` OK
     */
    createOrUpdatePhaseComponent: (
      data: CreateOrUpdatePhaseComponentPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/TrainingManagement/CreateOrUpdatePhaseComponent`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Adiciona um componente do tipo 'Etapa' na trilha.
     *
     * @tags TrainingManagement
     * @name CreateOrUpdatePhaseLearnPath
     * @request POST:/api/v1/TrainingManagement/CreateOrUpdatePhaseLearnPath
     * @secure
     * @response `200` `boolean` OK
     */
    createOrUpdatePhaseLearnPath: (
      data: CreateOrUpdatePhaseLearnPathPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/TrainingManagement/CreateOrUpdatePhaseLearnPath`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Salva as propriedades de um componente da trilha.
     *
     * @tags TrainingManagement
     * @name SaveLearnPathComponentProps
     * @request POST:/api/v1/TrainingManagement/SaveLearnPathComponentProps
     * @secure
     * @response `200` `boolean` OK
     */
    saveLearnPathComponentProps: (
      data: SaveLearnPathComponentPropsPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/TrainingManagement/SaveLearnPathComponentProps`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Adiciona um componente do tipo 'Treinamento' à Trilha.
     *
     * @tags TrainingManagement
     * @name CreateLearnPathTrainingComponent
     * @request POST:/api/v1/TrainingManagement/CreateLearnPathTrainingComponent
     * @secure
     * @response `200` `boolean` OK
     */
    createLearnPathTrainingComponent: (
      data: CreateLearnPathTrainingComponentPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/TrainingManagement/CreateLearnPathTrainingComponent`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Adiciona uma avaliação no conteúdo do treinamento.
     *
     * @tags TrainingManagement
     * @name AddAssessmentComponent
     * @request POST:/api/v1/TrainingManagement/AddAssessmentComponent
     * @secure
     * @response `200` `boolean` OK
     */
    addAssessmentComponent: (
      data: AddAssessmentComponentPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/TrainingManagement/AddAssessmentComponent`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Adiciona uma avaliação com um Treinamento Exclusivo.
     *
     * @tags TrainingManagement
     * @name AddAssessmentExclusiveTraining
     * @request POST:/api/v1/TrainingManagement/AddAssessmentExclusiveTraining
     * @secure
     * @response `200` `boolean` OK
     */
    addAssessmentExclusiveTraining: (
      data: AddAssessmentExclusiveTrainingPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/TrainingManagement/AddAssessmentExclusiveTraining`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Salva uma reunião (evento) como um componente do curso.
     *
     * @tags TrainingManagement
     * @name CreateOrUpdateMeetingComponent
     * @request POST:/api/v1/TrainingManagement/CreateOrUpdateMeetingComponent
     * @secure
     * @response `200` `boolean` OK
     */
    createOrUpdateMeetingComponent: (
      data: CreateOrUpdateMeetingComponentPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/TrainingManagement/CreateOrUpdateMeetingComponent`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Salva uma reunião (evento) como um Curso Exclusivo.
     *
     * @tags TrainingManagement
     * @name CreateOrUpdateMeetingExclusiveTraining
     * @request POST:/api/v1/TrainingManagement/CreateOrUpdateMeetingExclusiveTraining
     * @secure
     * @response `200` `boolean` OK
     */
    createOrUpdateMeetingExclusiveTraining: (
      data: CreateOrUpdateMeetingExclusiveTrainingPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/TrainingManagement/CreateOrUpdateMeetingExclusiveTraining`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Atualiza o Link de Reunião do ZOOM para instrutores.
     *
     * @tags TrainingManagement
     * @name UpdateZoomInstructorLinkCommand
     * @request POST:/api/v1/TrainingManagement/UpdateZoomInstructorLinkCommand
     * @secure
     * @response `200` `string` OK (May return null)
     * @response `204` `any` No Content
     */
    updateZoomInstructorLinkCommand: (
      data: UpdateZoomInstructorLinkCommandPayload,
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/api/v1/TrainingManagement/UpdateZoomInstructorLinkCommand`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Salva pesos e escalas dos componentes do treinamento.
     *
     * @tags TrainingManagement
     * @name SaveTrainingComponentsWeights
     * @request POST:/api/v1/TrainingManagement/SaveTrainingComponentsWeights
     * @secure
     * @response `200` `boolean` OK
     */
    saveTrainingComponentsWeights: (
      data: SaveTrainingComponentsWeightsPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/TrainingManagement/SaveTrainingComponentsWeights`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Adiciona um componentes do tipo 'Sco' ao treinamento.
     *
     * @tags TrainingManagement
     * @name CreateOrUpdateScoModules
     * @request POST:/api/v1/TrainingManagement/CreateOrUpdateScoModules
     * @secure
     * @response `200` `boolean` OK
     */
    createOrUpdateScoModules: (
      data: CreateOrUpdateScoModulesPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/TrainingManagement/CreateOrUpdateScoModules`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Move todos os SCOs da Versão do treinamento para um Módulo.
     *
     * @tags TrainingManagement
     * @name MoveAllScosToPhase
     * @request POST:/api/v1/TrainingManagement/MoveAllScosToPhase
     * @secure
     * @response `200` `boolean` OK
     */
    moveAllScosToPhase: (
      data: MoveAllScosToPhasePayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/TrainingManagement/MoveAllScosToPhase`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Remove todos os SCO's da versão do treinamento.
     *
     * @tags TrainingManagement
     * @name RemoveAllScosComponents
     * @request POST:/api/v1/TrainingManagement/RemoveAllScosComponents
     * @secure
     * @response `200` `boolean` OK
     */
    removeAllScosComponents: (
      data: RemoveAllScosComponentsPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/TrainingManagement/RemoveAllScosComponents`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Configura o Player Scorm.
     *
     * @tags TrainingManagement
     * @name CreateOrUpdateScormPlayerSettings
     * @request POST:/api/v1/TrainingManagement/CreateOrUpdateScormPlayerSettings
     * @secure
     * @response `200` `boolean` OK
     */
    createOrUpdateScormPlayerSettings: (
      data: CreateOrUpdateScormPlayerSettingsPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/TrainingManagement/CreateOrUpdateScormPlayerSettings`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Move um Componente da Versão do treinamento.
     *
     * @tags TrainingManagement
     * @name MoveComponent
     * @request POST:/api/v1/TrainingManagement/MoveComponent
     * @secure
     * @response `200` `boolean` OK
     */
    moveComponent: (data: MoveComponentPayload, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/api/v1/TrainingManagement/MoveComponent`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Move um Componente da Versão do treinamento para uma outra Fase/Módulo.
     *
     * @tags TrainingManagement
     * @name MoveComponentToPhase
     * @request POST:/api/v1/TrainingManagement/MoveComponentToPhase
     * @secure
     * @response `200` `boolean` OK
     */
    moveComponentToPhase: (
      data: MoveComponentToPhasePayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/TrainingManagement/MoveComponentToPhase`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Reordena a Lista de Componentes da versão do treinamento.
     *
     * @tags TrainingManagement
     * @name ReorderComponents
     * @request POST:/api/v1/TrainingManagement/ReorderComponents
     * @secure
     * @response `200` `boolean` OK
     */
    reorderComponents: (
      data: ReorderComponentsPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/TrainingManagement/ReorderComponents`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Ping na versão rascunho do treinamento.
     *
     * @tags TrainingManagement
     * @name PingDraftContent
     * @request POST:/api/v1/TrainingManagement/PingDraftContent
     * @secure
     * @response `200` `boolean` OK
     */
    pingDraftContent: (
      data: PingDraftContentPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/TrainingManagement/PingDraftContent`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Cria uma nova versão do conteúdo do treinamento.
     *
     * @tags TrainingManagement
     * @name CreateNewTrainingVersion
     * @request POST:/api/v1/TrainingManagement/CreateNewTrainingVersion
     * @secure
     * @response `200` `boolean` OK
     */
    createNewTrainingVersion: (
      data: CreateNewTrainingVersionPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/TrainingManagement/CreateNewTrainingVersion`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Descarta a última Versão corrente do treinamento.
     *
     * @tags TrainingManagement
     * @name DiscardTrainingContent
     * @request POST:/api/v1/TrainingManagement/DiscardTrainingContent
     * @secure
     * @response `200` `DiscardTrainingContentResponse` OK
     */
    discardTrainingContent: (
      data: DiscardTrainingContentPayload,
      params: RequestParams = {},
    ) =>
      this.request<DiscardTrainingContentResponse, any>({
        path: `/api/v1/TrainingManagement/DiscardTrainingContent`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Publica a versão corrente do treinamento.
     *
     * @tags TrainingManagement
     * @name PublishTrainingContent
     * @request POST:/api/v1/TrainingManagement/PublishTrainingContent
     * @secure
     * @response `200` `TrainingVersionDto` OK
     */
    publishTrainingContent: (
      data: PublishTrainingContentPayload,
      params: RequestParams = {},
    ) =>
      this.request<TrainingVersionDto, any>({
        path: `/api/v1/TrainingManagement/PublishTrainingContent`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Cria uma lista de material de apoio para o treinamento.
     *
     * @tags TrainingManagement
     * @name CreateTrainingMaterialList
     * @request POST:/api/v1/TrainingManagement/CreateTrainingMaterialList
     * @secure
     * @response `200` `string` OK
     */
    createTrainingMaterialList: (
      data: CreateTrainingMaterialListPayload,
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/api/v1/TrainingManagement/CreateTrainingMaterialList`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Cria uma lista de material de apoio para uma turma.
     *
     * @tags TrainingManagement
     * @name CreateClassroomMaterialList
     * @request POST:/api/v1/TrainingManagement/CreateClassroomMaterialList
     * @secure
     * @response `200` `string` OK
     */
    createClassroomMaterialList: (
      data: CreateClassroomMaterialListPayload,
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/api/v1/TrainingManagement/CreateClassroomMaterialList`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Excluir lista de material de apoio do treinamento.
     *
     * @tags TrainingManagement
     * @name DeleteTrainingMaterialList
     * @request POST:/api/v1/TrainingManagement/DeleteTrainingMaterialList
     * @secure
     * @response `200` `boolean` OK
     */
    deleteTrainingMaterialList: (
      data: DeleteTrainingMaterialListPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/TrainingManagement/DeleteTrainingMaterialList`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Excluir lista de material de apoio do treinamento da turma.
     *
     * @tags TrainingManagement
     * @name DeleteClassroomMaterialList
     * @request POST:/api/v1/TrainingManagement/DeleteClassroomMaterialList
     * @secure
     * @response `200` `boolean` OK
     */
    deleteClassroomMaterialList: (
      data: DeleteClassroomMaterialListPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/TrainingManagement/DeleteClassroomMaterialList`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Altera uma lista de material de apoio.
     *
     * @tags TrainingManagement
     * @name UpdateMaterialList
     * @request POST:/api/v1/TrainingManagement/UpdateMaterialList
     * @secure
     * @response `200` `boolean` OK
     */
    updateMaterialList: (
      data: UpdateMaterialListPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/TrainingManagement/UpdateMaterialList`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Altera dados das opções do material de apoio do treinamento.
     *
     * @tags TrainingManagement
     * @name UpdateMaterialListTrainingOptions
     * @request POST:/api/v1/TrainingManagement/UpdateMaterialListTrainingOptions
     * @secure
     * @response `200` `boolean` OK
     */
    updateMaterialListTrainingOptions: (
      data: UpdateMaterialListTrainingOptionsPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/TrainingManagement/UpdateMaterialListTrainingOptions`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Altera dados das opções do material de apoio da turma.
     *
     * @tags TrainingManagement
     * @name UpdateMaterialListClassroomOptions
     * @request POST:/api/v1/TrainingManagement/UpdateMaterialListClassroomOptions
     * @secure
     * @response `200` `boolean` OK
     */
    updateMaterialListClassroomOptions: (
      data: UpdateMaterialListClassroomOptionsPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/TrainingManagement/UpdateMaterialListClassroomOptions`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Adiciona uma publicação na lista de material de apoio.
     *
     * @tags TrainingManagement
     * @name AddMaterialListItem
     * @request POST:/api/v1/TrainingManagement/AddMaterialListItem
     * @secure
     * @response `200` `boolean` OK
     */
    addMaterialListItem: (
      data: AddMaterialListItemPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/TrainingManagement/AddMaterialListItem`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Ordendar os itens de uma lista de material de apoio.
     *
     * @tags TrainingManagement
     * @name ReorderMaterialListItem
     * @request POST:/api/v1/TrainingManagement/ReorderMaterialListItem
     * @secure
     * @response `200` `boolean` OK
     */
    reorderMaterialListItem: (
      data: ReorderMaterialListItemPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/TrainingManagement/ReorderMaterialListItem`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Exclui um item da lista de material de apoio do treinamento.
     *
     * @tags TrainingManagement
     * @name DeleteTrainingMaterialListItem
     * @request POST:/api/v1/TrainingManagement/DeleteTrainingMaterialListItem
     * @secure
     * @response `200` `boolean` OK
     */
    deleteTrainingMaterialListItem: (
      data: DeleteTrainingMaterialListItemPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/TrainingManagement/DeleteTrainingMaterialListItem`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Exclui um item da lista de material de apoio da turma.
     *
     * @tags TrainingManagement
     * @name DeleteClassroomMaterialListItem
     * @request POST:/api/v1/TrainingManagement/DeleteClassroomMaterialListItem
     * @secure
     * @response `200` `boolean` OK
     */
    deleteClassroomMaterialListItem: (
      data: DeleteClassroomMaterialListItemPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/TrainingManagement/DeleteClassroomMaterialListItem`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Ordendar uma lista de material de apoio.
     *
     * @tags TrainingManagement
     * @name ReorderMaterialList
     * @request POST:/api/v1/TrainingManagement/ReorderMaterialList
     * @secure
     * @response `200` `boolean` OK
     */
    reorderMaterialList: (
      data: ReorderMaterialListPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/TrainingManagement/ReorderMaterialList`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Copia as listas de materias de apoio de um treinamento para outro.
     *
     * @tags TrainingManagement
     * @name CopyMaterialList
     * @request POST:/api/v1/TrainingManagement/CopyMaterialList
     * @secure
     * @response `200` `boolean` OK
     */
    copyMaterialList: (
      data: CopyMaterialListPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/TrainingManagement/CopyMaterialList`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Bloquea ou desbloquea uma lista de material de apoio da turma.
     *
     * @tags TrainingManagement
     * @name BlockOrUnblockMaterialList
     * @request POST:/api/v1/TrainingManagement/BlockOrUnblockMaterialList
     * @secure
     * @response `200` `boolean` OK
     */
    blockOrUnblockMaterialList: (
      data: BlockOrUnblockMaterialListPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/TrainingManagement/BlockOrUnblockMaterialList`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Bloqueia ou desbloqueia um item da lista de material de apoio da turma.
     *
     * @tags TrainingManagement
     * @name BlockOrUnblockMaterialListItem
     * @request POST:/api/v1/TrainingManagement/BlockOrUnblockMaterialListItem
     * @secure
     * @response `200` `boolean` OK
     */
    blockOrUnblockMaterialListItem: (
      data: BlockOrUnblockMaterialListItemPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/TrainingManagement/BlockOrUnblockMaterialListItem`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Salva as regras de Inscrição do treinamento.
     *
     * @tags TrainingManagement
     * @name SaveTrainingRulesRegistration
     * @request POST:/api/v1/TrainingManagement/SaveTrainingRulesRegistration
     * @secure
     * @response `200` `TrainingRulesRegistrationDto` OK (May return null)
     * @response `204` `any` No Content
     */
    saveTrainingRulesRegistration: (
      data: SaveTrainingRulesRegistrationPayload,
      params: RequestParams = {},
    ) =>
      this.request<TrainingRulesRegistrationDto, any>({
        path: `/api/v1/TrainingManagement/SaveTrainingRulesRegistration`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Salva regras de Avaliações de reação e eficácia do Treinamento.
     *
     * @tags TrainingManagement
     * @name SaveTrainingRulesAssessment
     * @request POST:/api/v1/TrainingManagement/SaveTrainingRulesAssessment
     * @secure
     * @response `200` `TrainingRulesAssessmentDto` OK (May return null)
     * @response `204` `any` No Content
     */
    saveTrainingRulesAssessment: (
      data: SaveTrainingRulesAssessmentPayload,
      params: RequestParams = {},
    ) =>
      this.request<TrainingRulesAssessmentDto, any>({
        path: `/api/v1/TrainingManagement/SaveTrainingRulesAssessment`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Salva as regras de Execução do treinamento.
     *
     * @tags TrainingManagement
     * @name SaveTrainingRulesExecution
     * @request POST:/api/v1/TrainingManagement/SaveTrainingRulesExecution
     * @secure
     * @response `200` `TrainingRulesExecutionDto` OK (May return null)
     * @response `204` `any` No Content
     */
    saveTrainingRulesExecution: (
      data: SaveTrainingRulesExecutionPayload,
      params: RequestParams = {},
    ) =>
      this.request<TrainingRulesExecutionDto, any>({
        path: `/api/v1/TrainingManagement/SaveTrainingRulesExecution`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Salva as regras de Ações do Instrutor do curso..
     *
     * @tags TrainingManagement
     * @name SaveTrainingRulesInstructorAction
     * @request POST:/api/v1/TrainingManagement/SaveTrainingRulesInstructorAction
     * @secure
     * @response `200` `TrainingRulesInstructorActionDto` OK (May return null)
     * @response `204` `any` No Content
     */
    saveTrainingRulesInstructorAction: (
      data: SaveTrainingRulesInstructorActionPayload,
      params: RequestParams = {},
    ) =>
      this.request<TrainingRulesInstructorActionDto, any>({
        path: `/api/v1/TrainingManagement/SaveTrainingRulesInstructorAction`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Salva as regras de Aprovação e Finalização do curso.
     *
     * @tags TrainingManagement
     * @name SaveTrainingRulesApproval
     * @request POST:/api/v1/TrainingManagement/SaveTrainingRulesApproval
     * @secure
     * @response `200` `TrainingRulesApprovalRulesDto` OK (May return null)
     * @response `204` `any` No Content
     */
    saveTrainingRulesApproval: (
      data: SaveTrainingRulesApprovalPayload,
      params: RequestParams = {},
    ) =>
      this.request<TrainingRulesApprovalRulesDto, any>({
        path: `/api/v1/TrainingManagement/SaveTrainingRulesApproval`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Salva as regras de Pré-Requisitos do treinamento.
     *
     * @tags TrainingManagement
     * @name SaveTrainingPreReqs
     * @request POST:/api/v1/TrainingManagement/SaveTrainingPreReqs
     * @secure
     * @response `200` `TrainingRulesPreRequisitesDto` OK (May return null)
     * @response `204` `any` No Content
     */
    saveTrainingPreReqs: (
      data: SaveTrainingPreReqsPayload,
      params: RequestParams = {},
    ) =>
      this.request<TrainingRulesPreRequisitesDto, any>({
        path: `/api/v1/TrainingManagement/SaveTrainingPreReqs`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Salva as regras de Premiações do treinamento.
     *
     * @tags TrainingManagement
     * @name SaveTrainingRulesAward
     * @request POST:/api/v1/TrainingManagement/SaveTrainingRulesAward
     * @secure
     * @response `200` `TrainingRulesAwardDto` OK (May return null)
     * @response `204` `any` No Content
     */
    saveTrainingRulesAward: (
      data: SaveTrainingRulesAwardPayload,
      params: RequestParams = {},
    ) =>
      this.request<TrainingRulesAwardDto, any>({
        path: `/api/v1/TrainingManagement/SaveTrainingRulesAward`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Salva as regras de Vagas e Reservas do treinamento.
     *
     * @tags TrainingManagement
     * @name SaveTrainingRulesSeats
     * @request POST:/api/v1/TrainingManagement/SaveTrainingRulesSeats
     * @secure
     * @response `200` `TrainingRulesSeatsDto` OK (May return null)
     * @response `204` `any` No Content
     */
    saveTrainingRulesSeats: (
      data: SaveTrainingRulesSeatsPayload,
      params: RequestParams = {},
    ) =>
      this.request<TrainingRulesSeatsDto, any>({
        path: `/api/v1/TrainingManagement/SaveTrainingRulesSeats`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Salva as regras de Limites para Reinscrição do treinamento.
     *
     * @tags TrainingManagement
     * @name SaveTrainingRulesLimits
     * @request POST:/api/v1/TrainingManagement/SaveTrainingRulesLimits
     * @secure
     * @response `200` `TrainingRulesAutoEnrollLimitsDto` OK (May return null)
     * @response `204` `any` No Content
     */
    saveTrainingRulesLimits: (
      data: SaveTrainingRulesLimitsPayload,
      params: RequestParams = {},
    ) =>
      this.request<TrainingRulesAutoEnrollLimitsDto, any>({
        path: `/api/v1/TrainingManagement/SaveTrainingRulesLimits`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Salva as regras de Certificado e Validade do treinamento.
     *
     * @tags TrainingManagement
     * @name SaveTrainingRulesCertificate
     * @request POST:/api/v1/TrainingManagement/SaveTrainingRulesCertificate
     * @secure
     * @response `200` `TrainingRulesCertificateDto` OK (May return null)
     * @response `204` `any` No Content
     */
    saveTrainingRulesCertificate: (
      data: SaveTrainingRulesCertificatePayload,
      params: RequestParams = {},
    ) =>
      this.request<TrainingRulesCertificateDto, any>({
        path: `/api/v1/TrainingManagement/SaveTrainingRulesCertificate`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Salva as regras de Interações do treinamento.
     *
     * @tags TrainingManagement
     * @name SaveTrainingRulesInteraction
     * @request POST:/api/v1/TrainingManagement/SaveTrainingRulesInteraction
     * @secure
     * @response `200` `TrainingRulesInteractionDto` OK (May return null)
     * @response `204` `any` No Content
     */
    saveTrainingRulesInteraction: (
      data: SaveTrainingRulesInteractionPayload,
      params: RequestParams = {},
    ) =>
      this.request<TrainingRulesInteractionDto, any>({
        path: `/api/v1/TrainingManagement/SaveTrainingRulesInteraction`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Salva as regras de Termo de Aceitação do treinamento.
     *
     * @tags TrainingManagement
     * @name SaveTrainingRulesAgreement
     * @request POST:/api/v1/TrainingManagement/SaveTrainingRulesAgreement
     * @secure
     * @response `200` `TrainingRulesAgreementDto` OK (May return null)
     * @response `204` `any` No Content
     */
    saveTrainingRulesAgreement: (
      data: SaveTrainingRulesAgreementPayload,
      params: RequestParams = {},
    ) =>
      this.request<TrainingRulesAgreementDto, any>({
        path: `/api/v1/TrainingManagement/SaveTrainingRulesAgreement`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Salva as regras de Aprovação da Trilha.
     *
     * @tags TrainingManagement
     * @name SaveLearnPathRulesApproval
     * @request POST:/api/v1/TrainingManagement/SaveLearnPathRulesApproval
     * @secure
     * @response `200` `LearnPathRulesApprovalDto` OK (May return null)
     * @response `204` `any` No Content
     */
    saveLearnPathRulesApproval: (
      data: SaveLearnPathRulesApprovalPayload,
      params: RequestParams = {},
    ) =>
      this.request<LearnPathRulesApprovalDto, any>({
        path: `/api/v1/TrainingManagement/SaveLearnPathRulesApproval`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Salva as regras de Formulário de Conclusão do treinamento do tipo Curso Externo.
     *
     * @tags TrainingManagement
     * @name SaveTrainingRulesConclusionForm
     * @request POST:/api/v1/TrainingManagement/SaveTrainingRulesConclusionForm
     * @secure
     * @response `200` `TrainingRulesConclusionFormDto` OK (May return null)
     * @response `204` `any` No Content
     */
    saveTrainingRulesConclusionForm: (
      data: SaveTrainingRulesConclusionFormPayload,
      params: RequestParams = {},
    ) =>
      this.request<TrainingRulesConclusionFormDto, any>({
        path: `/api/v1/TrainingManagement/SaveTrainingRulesConclusionForm`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Salva as regras de Inscrição dos Componentes da Trilha.
     *
     * @tags TrainingManagement
     * @name SaveLearnPathRulesComponentRegistration
     * @request POST:/api/v1/TrainingManagement/SaveLearnPathRulesComponentRegistration
     * @secure
     * @response `200` `LearnPathRulesComponentRegistrationDto` OK (May return null)
     * @response `204` `any` No Content
     */
    saveLearnPathRulesComponentRegistration: (
      data: SaveLearnPathRulesComponentRegistrationPayload,
      params: RequestParams = {},
    ) =>
      this.request<LearnPathRulesComponentRegistrationDto, any>({
        path: `/api/v1/TrainingManagement/SaveLearnPathRulesComponentRegistration`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Salva as regras de Reinscrição da Trilha.
     *
     * @tags TrainingManagement
     * @name SaveLearnPathRulesReEnrollment
     * @request POST:/api/v1/TrainingManagement/SaveLearnPathRulesReEnrollment
     * @secure
     * @response `200` `LearnPathRulesReEnrollDto` OK (May return null)
     * @response `204` `any` No Content
     */
    saveLearnPathRulesReEnrollment: (
      data: SaveLearnPathRulesReEnrollmentPayload,
      params: RequestParams = {},
    ) =>
      this.request<LearnPathRulesReEnrollDto, any>({
        path: `/api/v1/TrainingManagement/SaveLearnPathRulesReEnrollment`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém lista de instrutores que possuem alocação de agenda no mesmo horário.
     *
     * @tags TrainingManagement
     * @name GetMeetingInstructorConflits
     * @request POST:/api/v1/TrainingManagement/GetMeetingInstructorConflits
     * @secure
     * @response `200` `(MeetingInstructorConflitsResponse)[]` OK
     */
    getMeetingInstructorConflits: (
      data: GetMeetingInstructorConflitsPayload,
      params: RequestParams = {},
    ) =>
      this.request<MeetingInstructorConflitsResponse[], any>({
        path: `/api/v1/TrainingManagement/GetMeetingInstructorConflits`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Atualiza o público-alvo do treinamento ou da turma.
     *
     * @tags TrainingManagement
     * @name UpdateAudience
     * @request POST:/api/v1/TrainingManagement/UpdateAudience
     * @secure
     * @response `200` `boolean` OK
     */
    updateAudience: (data: UpdateAudiencePayload, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/api/v1/TrainingManagement/UpdateAudience`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Salva as propriedades de um componente do tipo POST na versão no treinamento.
     *
     * @tags TrainingManagement
     * @name SavePostProps
     * @request POST:/api/v1/TrainingManagement/SavePostProps
     * @secure
     * @response `200` `boolean` OK
     */
    savePostProps: (data: SavePostPropsPayload, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/api/v1/TrainingManagement/SavePostProps`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Salva as propriedades de um componente do tipo SCO na versão no treinamento.
     *
     * @tags TrainingManagement
     * @name SaveScoProps
     * @request POST:/api/v1/TrainingManagement/SaveScoProps
     * @secure
     * @response `200` `boolean` OK
     */
    saveScoProps: (data: SaveScoPropsPayload, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/api/v1/TrainingManagement/SaveScoProps`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Salva as propriedades de um componente do tipo AVALIAÇÃO na versão no treinamento.
     *
     * @tags TrainingManagement
     * @name SaveAssessmentProps
     * @request POST:/api/v1/TrainingManagement/SaveAssessmentProps
     * @secure
     * @response `200` `boolean` OK
     */
    saveAssessmentProps: (
      data: SaveAssessmentPropsPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/TrainingManagement/SaveAssessmentProps`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Salva as propriedades do curso em uma versão do treinamento.
     *
     * @tags TrainingManagement
     * @name SaveCourseProps
     * @request POST:/api/v1/TrainingManagement/SaveCourseProps
     * @secure
     * @response `200` `boolean` OK
     */
    saveCourseProps: (
      data: SaveCoursePropsPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/TrainingManagement/SaveCourseProps`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém a lista de turmas de um treinamento.
     *
     * @tags TrainingManagement
     * @name GetClassrooms
     * @request POST:/api/v1/TrainingManagement/GetClassrooms
     * @secure
     * @response `200` `ManagedClassroomsListResponsePaginatedList` OK
     */
    getClassrooms: (data: GetClassroomsPayload, params: RequestParams = {}) =>
      this.request<ManagedClassroomsListResponsePaginatedList, any>({
        path: `/api/v1/TrainingManagement/GetClassrooms`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Transfere as regras do treinamento para turmas que possuem inscrição em aberto.
     *
     * @tags TrainingManagement
     * @name TransferTrainingRulesToOpenedClassrooms
     * @request POST:/api/v1/TrainingManagement/TransferTrainingRulesToOpenedClassrooms
     * @secure
     * @response `200` `number` OK
     */
    transferTrainingRulesToOpenedClassrooms: (
      data: TransferTrainingRulesToOpenedClassroomsPayload,
      params: RequestParams = {},
    ) =>
      this.request<number, any>({
        path: `/api/v1/TrainingManagement/TransferTrainingRulesToOpenedClassrooms`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Marca turmas do treinamento para reprocessar nova pontuação.
     *
     * @tags TrainingManagement
     * @name ProcessAwardRuleTraining
     * @request POST:/api/v1/TrainingManagement/ProcessAwardRuleTraining
     * @secure
     * @response `200` `boolean` OK
     */
    processAwardRuleTraining: (
      data: ProcessAwardRuleTrainingPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/TrainingManagement/ProcessAwardRuleTraining`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Marca turmas do treinamento para reprocessar novo certificado e prazos.
     *
     * @tags TrainingManagement
     * @name ProcessCertificateRuleTraining
     * @request POST:/api/v1/TrainingManagement/ProcessCertificateRuleTraining
     * @secure
     * @response `200` `boolean` OK
     */
    processCertificateRuleTraining: (
      data: ProcessCertificateRuleTrainingPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/TrainingManagement/ProcessCertificateRuleTraining`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Salva as configurações de gamificação.
     *
     * @tags TrainingManagement
     * @name SaveLearnPathGameConfig
     * @request POST:/api/v1/TrainingManagement/SaveLearnPathGameConfig
     * @secure
     * @response `200` `boolean` OK
     */
    saveLearnPathGameConfig: (
      data: SaveLearnPathGameConfigPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/TrainingManagement/SaveLearnPathGameConfig`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Salva as configurações da fase do jogo.
     *
     * @tags TrainingManagement
     * @name SaveLearnPathGamePhaseConfig
     * @request POST:/api/v1/TrainingManagement/SaveLearnPathGamePhaseConfig
     * @secure
     * @response `200` `boolean` OK
     */
    saveLearnPathGamePhaseConfig: (
      data: SaveLearnPathGamePhaseConfigPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/TrainingManagement/SaveLearnPathGamePhaseConfig`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Cria ou atualiza Ranking da gamificação.
     *
     * @tags TrainingManagement
     * @name CreateOrUpdateLearnPathGameRanking
     * @request POST:/api/v1/TrainingManagement/CreateOrUpdateLearnPathGameRanking
     * @secure
     * @response `200` `boolean` OK
     */
    createOrUpdateLearnPathGameRanking: (
      data: CreateOrUpdateLearnPathGameRankingPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/TrainingManagement/CreateOrUpdateLearnPathGameRanking`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Exclui Ranking da gamificação.
     *
     * @tags TrainingManagement
     * @name DeleteLearnPathGameRanking
     * @request POST:/api/v1/TrainingManagement/DeleteLearnPathGameRanking
     * @secure
     * @response `200` `boolean` OK
     */
    deleteLearnPathGameRanking: (
      data: DeleteLearnPathGameRankingPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/TrainingManagement/DeleteLearnPathGameRanking`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Cria ou atualiza a pontuação para o componente do Game.
     *
     * @tags TrainingManagement
     * @name CreateOrUpdateLpGameScore
     * @request POST:/api/v1/TrainingManagement/CreateOrUpdateLpGameScore
     * @secure
     * @response `200` `boolean` OK
     */
    createOrUpdateLpGameScore: (
      data: CreateOrUpdateLpGameScorePayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/TrainingManagement/CreateOrUpdateLpGameScore`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Exclui a pontuação para o componente do Game.
     *
     * @tags TrainingManagement
     * @name DeleteLpGameScore
     * @request POST:/api/v1/TrainingManagement/DeleteLpGameScore
     * @secure
     * @response `200` `boolean` OK
     */
    deleteLpGameScore: (
      data: DeleteLpGameScorePayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/TrainingManagement/DeleteLpGameScore`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Atualiza se o ranking tem award, se for false, remove as pontuações definidas.
     *
     * @tags TrainingManagement
     * @name UpdateLpGameAwardRanking
     * @request POST:/api/v1/TrainingManagement/UpdateLpGameAwardRanking
     * @secure
     * @response `200` `boolean` OK
     */
    updateLpGameAwardRanking: (
      data: UpdateLpGameAwardRankingPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/TrainingManagement/UpdateLpGameAwardRanking`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Cria e atualiza pontuação em premiação do ranking.
     *
     * @tags TrainingManagement
     * @name CreateOrUpdateLpGameAwardRanking
     * @request POST:/api/v1/TrainingManagement/CreateOrUpdateLpGameAwardRanking
     * @secure
     * @response `200` `boolean` OK
     */
    createOrUpdateLpGameAwardRanking: (
      data: CreateOrUpdateLpGameAwardRankingPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/TrainingManagement/CreateOrUpdateLpGameAwardRanking`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Remove pontuação em premiação do ranking.
     *
     * @tags TrainingManagement
     * @name DeleteLpGameAwardRanking
     * @request POST:/api/v1/TrainingManagement/DeleteLpGameAwardRanking
     * @secure
     * @response `200` `boolean` OK
     */
    deleteLpGameAwardRanking: (
      data: DeleteLpGameAwardRankingPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/TrainingManagement/DeleteLpGameAwardRanking`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Salva as definições de mapa do jogo.
     *
     * @tags TrainingManagement
     * @name SaveLpGameMap
     * @request POST:/api/v1/TrainingManagement/SaveLpGameMap
     * @secure
     * @response `200` `boolean` OK
     */
    saveLpGameMap: (data: SaveLpGameMapPayload, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/api/v1/TrainingManagement/SaveLpGameMap`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  unitManagement = {
    /**
     * No description
     *
     * @tags UnitManagement
     * @name ExportSpreadSheetImportUnit
     * @request GET:/api/v1/UnitManagement/ExportSpreadSheetImportUnit/{unitTypeId}
     * @secure
     * @response `200` `any` OK
     */
    exportSpreadSheetImportUnit: (
      unitTypeId: string,
      params: RequestParams = {},
    ) =>
      this.request<any, any>({
        path: `/api/v1/UnitManagement/ExportSpreadSheetImportUnit/${unitTypeId}`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * Obtém a lista de Unidades.
     *
     * @tags UnitManagement
     * @name ManagedUnits
     * @request POST:/api/v1/UnitManagement/ManagedUnits
     * @secure
     * @response `200` `ManagedUnitListResponsePaginatedList` OK
     */
    managedUnits: (data: ManagedUnitsPayload, params: RequestParams = {}) =>
      this.request<ManagedUnitListResponsePaginatedList, any>({
        path: `/api/v1/UnitManagement/ManagedUnits`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém as permissões gerais do cadastro de unidades administrativas.
     *
     * @tags UnitManagement
     * @name ManagedUnitPermission
     * @request GET:/api/v1/UnitManagement/ManagedUnitPermission
     * @secure
     * @response `200` `ManagedUnitPermissionResponse` OK
     */
    managedUnitPermission: (params: RequestParams = {}) =>
      this.request<ManagedUnitPermissionResponse, any>({
        path: `/api/v1/UnitManagement/ManagedUnitPermission`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Obtém as informações principais da Unidade para edição.
     *
     * @tags UnitManagement
     * @name ManagedGetUnit
     * @request POST:/api/v1/UnitManagement/ManagedGetUnit
     * @secure
     * @response `200` `ManagedUnitResponse` OK
     */
    managedGetUnit: (data: ManagedGetUnitPayload, params: RequestParams = {}) =>
      this.request<ManagedUnitResponse, any>({
        path: `/api/v1/UnitManagement/ManagedGetUnit`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém a lista de usuários diretos ou diretos + indiretos da unidade.
     *
     * @tags UnitManagement
     * @name ManagedGetUsersUnit
     * @request POST:/api/v1/UnitManagement/ManagedGetUsersUnit
     * @secure
     * @response `200` `UserItemDtoPaginatedList` OK
     */
    managedGetUsersUnit: (
      data: ManagedGetUsersUnitPayload,
      params: RequestParams = {},
    ) =>
      this.request<UserItemDtoPaginatedList, any>({
        path: `/api/v1/UnitManagement/ManagedGetUsersUnit`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Verifica se a unidade está contida na árvore root.
     *
     * @tags UnitManagement
     * @name ManagedUnitContainsDesc
     * @request POST:/api/v1/UnitManagement/ManagedUnitContainsDesc
     * @secure
     * @response `200` `boolean` OK
     */
    managedUnitContainsDesc: (
      data: ManagedUnitContainsDescPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/UnitManagement/ManagedUnitContainsDesc`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Coloca um Arquivo de Importação na Fila de Execução.
     *
     * @tags UnitManagement
     * @name ImportUnit
     * @request POST:/api/v1/UnitManagement/ImportUnit
     * @secure
     * @response `200` `boolean` OK
     */
    importUnit: (data: ImportUnitPayload, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/api/v1/UnitManagement/ImportUnit`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Cria uma unidade administrativa
     *
     * @tags UnitManagement
     * @name CreateUnit
     * @request POST:/api/v1/UnitManagement/CreateUnit
     * @secure
     * @response `200` `string | null` OK
     */
    createUnit: (data: CreateUnitPayload, params: RequestParams = {}) =>
      this.request<string | null, any>({
        path: `/api/v1/UnitManagement/CreateUnit`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Atualiza uma unidade administrativa
     *
     * @tags UnitManagement
     * @name UpdateUnit
     * @request POST:/api/v1/UnitManagement/UpdateUnit
     * @secure
     * @response `200` `boolean` OK
     */
    updateUnit: (data: UpdateUnitPayload, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/api/v1/UnitManagement/UpdateUnit`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Exclui uma unidade administrativa
     *
     * @tags UnitManagement
     * @name DeleteUnit
     * @request POST:/api/v1/UnitManagement/DeleteUnit
     * @secure
     * @response `200` `boolean` OK
     */
    deleteUnit: (data: DeleteUnitPayload, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/api/v1/UnitManagement/DeleteUnit`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  unitType = {
    /**
     * Obtém os tipos de unidades administrativas
     *
     * @tags UnitType
     * @name GetUnitTypes
     * @request GET:/api/v1/UnitType/GetUnitTypes
     * @secure
     * @response `200` `(UnitTypeResponse)[]` OK
     */
    getUnitTypes: (params: RequestParams = {}) =>
      this.request<UnitTypeResponse[], any>({
        path: `/api/v1/UnitType/GetUnitTypes`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  unitTypeManagement = {
    /**
     * Obtém as informações principais do Tipo de Unidade para edição.
     *
     * @tags UnitTypeManagement
     * @name ManagedGetUnitType
     * @request POST:/api/v1/UnitTypeManagement/ManagedGetUnitType
     * @secure
     * @response `200` `ManagedUnitTypeResponse` OK
     */
    managedGetUnitType: (
      data: ManagedGetUnitTypePayload,
      params: RequestParams = {},
    ) =>
      this.request<ManagedUnitTypeResponse, any>({
        path: `/api/v1/UnitTypeManagement/ManagedGetUnitType`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Cria um tipo de unidade administrativa
     *
     * @tags UnitTypeManagement
     * @name CreateUnitType
     * @request POST:/api/v1/UnitTypeManagement/CreateUnitType
     * @secure
     * @response `200` `string | null` OK
     */
    createUnitType: (data: CreateUnitTypePayload, params: RequestParams = {}) =>
      this.request<string | null, any>({
        path: `/api/v1/UnitTypeManagement/CreateUnitType`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Atualiza um tipo de unidade administrativa
     *
     * @tags UnitTypeManagement
     * @name UpdateUnitType
     * @request POST:/api/v1/UnitTypeManagement/UpdateUnitType
     * @secure
     * @response `200` `boolean` OK
     */
    updateUnitType: (data: UpdateUnitTypePayload, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/api/v1/UnitTypeManagement/UpdateUnitType`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Exclui um tipo de unidade administrativa
     *
     * @tags UnitTypeManagement
     * @name DeleteUnitType
     * @request POST:/api/v1/UnitTypeManagement/DeleteUnitType
     * @secure
     * @response `200` `boolean` OK
     */
    deleteUnitType: (data: DeleteUnitTypePayload, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/api/v1/UnitTypeManagement/DeleteUnitType`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  urlParser = {
    /**
     * Obtém os metadados de uma URL.
     *
     * @tags UrlParser
     * @name GetMetadata
     * @request GET:/api/v1/UrlParser/GetMetadata
     * @secure
     * @response `200` `ContentMetadata` OK (May return null)
     * @response `204` `any` No Content
     */
    getMetadata: (
      query?: {
        url?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ContentMetadata, any>({
        path: `/api/v1/UrlParser/GetMetadata`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  user = {
    /**
     * No description
     *
     * @tags User
     * @name SaveSelectionHistory
     * @request POST:/api/v1/User/SaveSelectionHistory
     * @secure
     * @response `200` `boolean` OK
     */
    saveSelectionHistory: (
      data: SaveSelectionHistoryPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/User/SaveSelectionHistory`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name SaveSelectionHistoryClick
     * @request POST:/api/v1/User/SaveSelectionHistoryClick
     * @secure
     * @response `200` `boolean` OK
     */
    saveSelectionHistoryClick: (
      data: SaveSelectionHistoryClickPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/User/SaveSelectionHistoryClick`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém uma Lista Subordinados Ascendentes do usuário.
     *
     * @tags User
     * @name UserOrganogramManagers
     * @request POST:/api/v1/User/UserOrganogramManagers
     * @secure
     * @response `200` `UserOrganogramManagersResponse` OK
     */
    userOrganogramManagers: (
      data: UserOrganogramManagersPayload,
      params: RequestParams = {},
    ) =>
      this.request<UserOrganogramManagersResponse, any>({
        path: `/api/v1/User/UserOrganogramManagers`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém uma Lista Paginada de Subordinados do usuário.
     *
     * @tags User
     * @name ManagerSubordinates
     * @request POST:/api/v1/User/ManagerSubordinates
     * @secure
     * @response `200` `UserMainManagerSubordinatesResponse` OK
     */
    managerSubordinates: (
      data: ManagerSubordinatesPayload,
      params: RequestParams = {},
    ) =>
      this.request<UserMainManagerSubordinatesResponse, any>({
        path: `/api/v1/User/ManagerSubordinates`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Altera a senha do usuário corrente.
     *
     * @tags User
     * @name ChangePassword
     * @request POST:/api/v1/User/ChangePassword
     * @secure
     * @response `200` `boolean` OK
     */
    changePassword: (data: ChangePasswordPayload, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/api/v1/User/ChangePassword`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém o perfil do usuário
     *
     * @tags User
     * @name GetEditProfile
     * @request POST:/api/v1/User/GetEditProfile
     * @secure
     * @response `200` `UserEditProfileResponse` OK
     */
    getEditProfile: (data: GetEditProfilePayload, params: RequestParams = {}) =>
      this.request<UserEditProfileResponse, any>({
        path: `/api/v1/User/GetEditProfile`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Atualiza o perfil do usuário.
     *
     * @tags User
     * @name UpdateProfile
     * @request POST:/api/v1/User/UpdateProfile
     * @secure
     * @response `200` `UpdateProfileResponse` OK (May return null)
     * @response `204` `any` No Content
     */
    updateProfile: (data: UpdateProfilePayload, params: RequestParams = {}) =>
      this.request<UpdateProfileResponse, any>({
        path: `/api/v1/User/UpdateProfile`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Reseta configuração de 2FA do usuário.
     *
     * @tags User
     * @name ResetTwoFactorApp
     * @request POST:/api/v1/User/ResetTwoFactorApp
     * @secure
     * @response `200` `boolean` OK
     */
    resetTwoFactorApp: (
      data: ResetTwoFactorAppPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/User/ResetTwoFactorApp`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém os interesses pessoais do próprio usuário.
     *
     * @tags User
     * @name GetPersonalInterests
     * @request POST:/api/v1/User/GetPersonalInterests
     * @secure
     * @response `200` `(UserPersonalInterestsResponse)[]` OK
     */
    getPersonalInterests: (
      data: GetPersonalInterestsPayload,
      params: RequestParams = {},
    ) =>
      this.request<UserPersonalInterestsResponse[], any>({
        path: `/api/v1/User/GetPersonalInterests`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Usuário declara um interesse pessoal.
     *
     * @tags User
     * @name AddPersonalInterest
     * @request POST:/api/v1/User/AddPersonalInterest
     * @secure
     * @response `200` `UserPersonalInterestsResponse` OK (May return null)
     * @response `204` `any` No Content
     */
    addPersonalInterest: (
      data: AddPersonalInterestPayload,
      params: RequestParams = {},
    ) =>
      this.request<UserPersonalInterestsResponse, any>({
        path: `/api/v1/User/AddPersonalInterest`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Usuário remove um interesse pessoal.
     *
     * @tags User
     * @name RemovePersonalInterest
     * @request POST:/api/v1/User/RemovePersonalInterest
     * @secure
     * @response `200` `boolean` OK
     */
    removePersonalInterest: (
      data: RemovePersonalInterestPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/User/RemovePersonalInterest`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém a configuração das notificações do usuário.
     *
     * @tags User
     * @name GetNotificationsConfig
     * @request POST:/api/v1/User/GetNotificationsConfig
     * @secure
     * @response `200` `UserNotificationConfigDto` OK
     */
    getNotificationsConfig: (params: RequestParams = {}) =>
      this.request<UserNotificationConfigDto, any>({
        path: `/api/v1/User/GetNotificationsConfig`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Altera a configuração de um Grupo de Notificações.
     *
     * @tags User
     * @name UpdateNotificationConfig
     * @request POST:/api/v1/User/UpdateNotificationConfig
     * @secure
     * @response `200` `boolean` OK
     */
    updateNotificationConfig: (
      data: UpdateNotificationConfigPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/User/UpdateNotificationConfig`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém o último motivo ativo de ausência para um usuário.
     *
     * @tags User
     * @name GetAbsence
     * @request POST:/api/v1/User/GetAbsence
     * @secure
     * @response `200` `UserAbsenceResponse` OK
     */
    getAbsence: (data: GetAbsencePayload, params: RequestParams = {}) =>
      this.request<UserAbsenceResponse, any>({
        path: `/api/v1/User/GetAbsence`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Atualiza a Imagem de fundo do perfil do usuário.
     *
     * @tags User
     * @name UpdateBackgroundImage
     * @request POST:/api/v1/User/UpdateBackgroundImage
     * @secure
     * @response `200` `boolean` OK
     */
    updateBackgroundImage: (
      data: UpdateBackgroundImagePayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/User/UpdateBackgroundImage`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Remove a Imagem de fundo do perfil do usuário.
     *
     * @tags User
     * @name RemoveBackgroundImage
     * @request POST:/api/v1/User/RemoveBackgroundImage
     * @secure
     * @response `200` `boolean` OK
     */
    removeBackgroundImage: (
      data: RemoveBackgroundImagePayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/User/RemoveBackgroundImage`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtem o e-mail do usuário logado.
     *
     * @tags User
     * @name GetUserEmail
     * @request GET:/api/v1/User/GetUserEmail
     * @secure
     * @response `200` `UserEmailResponse` OK
     */
    getUserEmail: (params: RequestParams = {}) =>
      this.request<UserEmailResponse, any>({
        path: `/api/v1/User/GetUserEmail`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Preenche ou atualiza o e-mail do usuário.
     *
     * @tags User
     * @name ChangeEmail
     * @request POST:/api/v1/User/ChangeEmail
     * @secure
     * @response `200` `boolean` OK
     */
    changeEmail: (data: ChangeEmailPayload, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/api/v1/User/ChangeEmail`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém uma requisação de Autorização de Login para Suporte Técnico.
     *
     * @tags User
     * @name GetSpyLoginAuth
     * @request POST:/api/v1/User/GetSpyLoginAuth
     * @secure
     * @response `200` `SpyLoginAuthDto` OK
     */
    getSpyLoginAuth: (
      data: GetSpyLoginAuthPayload,
      params: RequestParams = {},
    ) =>
      this.request<SpyLoginAuthDto, any>({
        path: `/api/v1/User/GetSpyLoginAuth`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém uma requisação de Autorização de Login para Suporte Técnico.
     *
     * @tags User
     * @name RequestSpyAuthorization
     * @request POST:/api/v1/User/RequestSpyAuthorization
     * @secure
     * @response `200` `SpyLoginAuthDto` OK
     */
    requestSpyAuthorization: (
      data: RequestSpyAuthorizationPayload,
      params: RequestParams = {},
    ) =>
      this.request<SpyLoginAuthDto, any>({
        path: `/api/v1/User/RequestSpyAuthorization`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém a URL de acesso para Suporte Técnico.
     *
     * @tags User
     * @name RequestSupportAuthorization
     * @request POST:/api/v1/User/RequestSupportAuthorization
     * @secure
     * @response `200` `string` OK (May return null)
     * @response `204` `any` No Content
     */
    requestSupportAuthorization: (
      data: RequestSupportAuthorizationPayload,
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/api/v1/User/RequestSupportAuthorization`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém as Restrições de Acesso de uma permissão específica para o usuário logado.
     *
     * @tags User
     * @name UserPermissionConstraintQuery
     * @request POST:/api/v1/User/UserPermissionConstraintQuery
     * @secure
     * @response `200` `PermissionConstraintDto` OK
     */
    userPermissionConstraintQuery: (
      data: UserPermissionConstraintQueryPayload,
      params: RequestParams = {},
    ) =>
      this.request<PermissionConstraintDto, any>({
        path: `/api/v1/User/UserPermissionConstraintQuery`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  userManagement = {
    /**
     * Obtém os dados de Bloqueio de Login.
     *
     * @tags UserManagement
     * @name GetChangeLoginBlock
     * @request POST:/api/v1/UserManagement/GetChangeLoginBlock
     * @secure
     * @response `200` `ManagedChangeLoginBlockQueryResponse` OK
     */
    getChangeLoginBlock: (
      data: GetChangeLoginBlockPayload,
      params: RequestParams = {},
    ) =>
      this.request<ManagedChangeLoginBlockQueryResponse, any>({
        path: `/api/v1/UserManagement/GetChangeLoginBlock`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém uma senha sugerida para conta do usuário.
     *
     * @tags UserManagement
     * @name ManagerChangePasswordSettings
     * @request POST:/api/v1/UserManagement/ManagerChangePasswordSettings
     * @secure
     * @response `200` `ManagerChangePasswordResponse` OK
     */
    managerChangePasswordSettings: (
      data: ManagerChangePasswordSettingsPayload,
      params: RequestParams = {},
    ) =>
      this.request<ManagerChangePasswordResponse, any>({
        path: `/api/v1/UserManagement/ManagerChangePasswordSettings`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém a lista de Usuários
     *
     * @tags UserManagement
     * @name ManagedUsers
     * @request POST:/api/v1/UserManagement/ManagedUsers
     * @secure
     * @response `200` `ManageUserListResponse` OK
     */
    managedUsers: (data: ManagedUsersPayload, params: RequestParams = {}) =>
      this.request<ManageUserListResponse, any>({
        path: `/api/v1/UserManagement/ManagedUsers`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém as informações principais do Usuário para edição.
     *
     * @tags UserManagement
     * @name GetUser
     * @request POST:/api/v1/UserManagement/GetUser
     * @secure
     * @response `200` `ManagedUserQueryResponse` OK (May return null)
     * @response `204` `any` No Content
     */
    getUser: (data: GetUserPayload, params: RequestParams = {}) =>
      this.request<ManagedUserQueryResponse, any>({
        path: `/api/v1/UserManagement/GetUser`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém a árvore de subordinados de um gerente.
     *
     * @tags UserManagement
     * @name ManagerTree
     * @request POST:/api/v1/UserManagement/ManagerTree
     * @secure
     * @response `200` `ManagerTreeNode` OK (May return null)
     * @response `204` `any` No Content
     */
    managerTree: (data: ManagerTreePayload, params: RequestParams = {}) =>
      this.request<ManagerTreeNode, any>({
        path: `/api/v1/UserManagement/ManagerTree`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Cria um usuário.
     *
     * @tags UserManagement
     * @name CreateUser
     * @request POST:/api/v1/UserManagement/CreateUser
     * @secure
     * @response `200` `string` OK
     */
    createUser: (data: CreateUserPayload, params: RequestParams = {}) =>
      this.request<string, any>({
        path: `/api/v1/UserManagement/CreateUser`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Atualiza um usuário.
     *
     * @tags UserManagement
     * @name UpdateUser
     * @request POST:/api/v1/UserManagement/UpdateUser
     * @secure
     * @response `200` `string` OK
     */
    updateUser: (data: UpdateUserPayload, params: RequestParams = {}) =>
      this.request<string, any>({
        path: `/api/v1/UserManagement/UpdateUser`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Exclui um usuário.
     *
     * @tags UserManagement
     * @name DeleteUser
     * @request POST:/api/v1/UserManagement/DeleteUser
     * @secure
     * @response `200` `DeleteUserCommandResponse` OK
     */
    deleteUser: (data: DeleteUserBody, params: RequestParams = {}) =>
      this.request<DeleteUserCommandResponse, any>({
        path: `/api/v1/UserManagement/DeleteUser`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Coloca um Arquivo de Importação de Usuário na Fila de Execução.
     *
     * @tags UserManagement
     * @name ImportUserAdhoc
     * @request POST:/api/v1/UserManagement/ImportUserAdhoc
     * @secure
     * @response `200` `boolean` OK
     */
    importUserAdhoc: (
      data: ImportUserAdhocPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/UserManagement/ImportUserAdhoc`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Altera o status do usuário.
     *
     * @tags UserManagement
     * @name ChangeUserStatus
     * @request POST:/api/v1/UserManagement/ChangeUserStatus
     * @secure
     * @response `200` `boolean` OK
     */
    changeUserStatus: (
      data: ChangeUserStatusPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/UserManagement/ChangeUserStatus`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Altera a senha do usuário.
     *
     * @tags UserManagement
     * @name ChangePassword
     * @request POST:/api/v1/UserManagement/ChangePassword
     * @secure
     * @response `200` `boolean` OK
     */
    changePassword: (data: ChangePasswordBody, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/api/v1/UserManagement/ChangePassword`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém a lista de papéis do usuário.
     *
     * @tags UserManagement
     * @name GetRoles
     * @request POST:/api/v1/UserManagement/GetRoles
     * @secure
     * @response `200` `ManagedUserRolesQueryResponsePaginatedList` OK
     */
    getRoles: (data: GetRolesPayload, params: RequestParams = {}) =>
      this.request<ManagedUserRolesQueryResponsePaginatedList, any>({
        path: `/api/v1/UserManagement/GetRoles`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém permissões para gerenciar papéis e permissões do usuário.
     *
     * @tags UserManagement
     * @name GetRolePermissions
     * @request POST:/api/v1/UserManagement/GetRolePermissions
     * @secure
     * @response `200` `ManagedUserRolePermissionsResponse` OK
     */
    getRolePermissions: (
      data: GetRolePermissionsPayload,
      params: RequestParams = {},
    ) =>
      this.request<ManagedUserRolePermissionsResponse, any>({
        path: `/api/v1/UserManagement/GetRolePermissions`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Sugestões de Papéis para o usuário.
     *
     * @tags UserManagement
     * @name GetRoleSuggestions
     * @request POST:/api/v1/UserManagement/GetRoleSuggestions
     * @secure
     * @response `200` `AutoCompleteDataModelDtoPaginatedList` OK
     */
    getRoleSuggestions: (
      data: GetRoleSuggestionsPayload,
      params: RequestParams = {},
    ) =>
      this.request<AutoCompleteDataModelDtoPaginatedList, any>({
        path: `/api/v1/UserManagement/GetRoleSuggestions`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Adiciona um usuário ao papel de segurança.
     *
     * @tags UserManagement
     * @name AddRole
     * @request POST:/api/v1/UserManagement/AddRole
     * @secure
     * @response `200` `ManagedUserRolesQueryResponse` OK
     */
    addRole: (data: AddRolePayload, params: RequestParams = {}) =>
      this.request<ManagedUserRolesQueryResponse, any>({
        path: `/api/v1/UserManagement/AddRole`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Remove um papel de segurança do usuário.
     *
     * @tags UserManagement
     * @name DeleteRole
     * @request POST:/api/v1/UserManagement/DeleteRole
     * @secure
     * @response `200` `boolean` OK
     */
    deleteRole: (data: DeleteRoleBody, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/api/v1/UserManagement/DeleteRole`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Reativa um papel atribuído dinamicamente  do usuário que foi bloqueado.
     *
     * @tags UserManagement
     * @name ReactivateRole
     * @request POST:/api/v1/UserManagement/ReactivateRole
     * @secure
     * @response `200` `boolean` OK
     */
    reactivateRole: (data: ReactivateRolePayload, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/api/v1/UserManagement/ReactivateRole`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Bloqueia um papel atribuído dinamicamente ao usuário.
     *
     * @tags UserManagement
     * @name DesactivateRole
     * @request POST:/api/v1/UserManagement/DesactivateRole
     * @secure
     * @response `200` `boolean` OK
     */
    desactivateRole: (
      data: DesactivateRolePayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/UserManagement/DesactivateRole`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Lista de Permissões do Usuário.
     *
     * @tags UserManagement
     * @name GetPermissionsList
     * @request POST:/api/v1/UserManagement/GetPermissionsList
     * @secure
     * @response `200` `(ManagedUserPermissionsQueryResponse)[]` OK
     */
    getPermissionsList: (
      data: GetPermissionsListPayload,
      params: RequestParams = {},
    ) =>
      this.request<ManagedUserPermissionsQueryResponse[], any>({
        path: `/api/v1/UserManagement/GetPermissionsList`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserManagement
     * @name ExportSpreadSheetImportUser
     * @request GET:/api/v1/UserManagement/ExportSpreadSheetImportUser
     * @secure
     * @response `200` `any` OK
     */
    exportSpreadSheetImportUser: (params: RequestParams = {}) =>
      this.request<any, any>({
        path: `/api/v1/UserManagement/ExportSpreadSheetImportUser`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * Obtém a lista de grupos do usuário.
     *
     * @tags UserManagement
     * @name GetGroups
     * @request POST:/api/v1/UserManagement/GetGroups
     * @secure
     * @response `200` `ManagedUserGroupsQueryResponsePaginatedList` OK
     */
    getGroups: (data: GetGroupsPayload1, params: RequestParams = {}) =>
      this.request<ManagedUserGroupsQueryResponsePaginatedList, any>({
        path: `/api/v1/UserManagement/GetGroups`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Sugestões de Papéis para o usuário.
     *
     * @tags UserManagement
     * @name GetGroupSuggestions
     * @request POST:/api/v1/UserManagement/GetGroupSuggestions
     * @secure
     * @response `200` `AutoCompleteDataModelDtoPaginatedList` OK
     */
    getGroupSuggestions: (
      data: GetGroupSuggestionsPayload,
      params: RequestParams = {},
    ) =>
      this.request<AutoCompleteDataModelDtoPaginatedList, any>({
        path: `/api/v1/UserManagement/GetGroupSuggestions`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém a lista de tópicos de interesse do usuário.
     *
     * @tags UserManagement
     * @name GetTopics
     * @request POST:/api/v1/UserManagement/GetTopics
     * @secure
     * @response `200` `PaginatedUserTopics` OK
     */
    getTopics: (data: GetTopicsPayload, params: RequestParams = {}) =>
      this.request<PaginatedUserTopics, any>({
        path: `/api/v1/UserManagement/GetTopics`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Concede selo de Especialista em um Tópico por um Gestor.
     *
     * @tags UserManagement
     * @name GrantSpecialistSeal
     * @request POST:/api/v1/UserManagement/GrantSpecialistSeal
     * @secure
     * @response `200` `boolean` OK
     */
    grantSpecialistSeal: (
      data: GrantSpecialistSealPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/UserManagement/GrantSpecialistSeal`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Revoga o selo de especialista do usuário em um Tópico.
     *
     * @tags UserManagement
     * @name RevokeSpecialistSeal
     * @request POST:/api/v1/UserManagement/RevokeSpecialistSeal
     * @secure
     * @response `200` `boolean` OK
     */
    revokeSpecialistSeal: (
      data: RevokeSpecialistSealPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/UserManagement/RevokeSpecialistSeal`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Concede ensosso a um usuário em um Tópico.
     *
     * @tags UserManagement
     * @name AddTopicEndorment
     * @request POST:/api/v1/UserManagement/AddTopicEndorment
     * @secure
     * @response `200` `boolean` OK
     */
    addTopicEndorment: (
      data: AddTopicEndormentPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/UserManagement/AddTopicEndorment`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Remove ensosso do usuário em um Tópico.
     *
     * @tags UserManagement
     * @name DeleteTopicEndorment
     * @request POST:/api/v1/UserManagement/DeleteTopicEndorment
     * @secure
     * @response `200` `boolean` OK
     */
    deleteTopicEndorment: (
      data: DeleteTopicEndormentPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/UserManagement/DeleteTopicEndorment`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Adiciona uma ausência para um usuário.
     *
     * @tags UserManagement
     * @name AddAbsence
     * @request POST:/api/v1/UserManagement/AddAbsence
     * @secure
     * @response `200` `string | null` OK (May return null)
     * @response `204` `any` No Content
     */
    addAbsence: (data: AddAbsencePayload, params: RequestParams = {}) =>
      this.request<string | null, any>({
        path: `/api/v1/UserManagement/AddAbsence`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Altera uma ausência para um usuário.
     *
     * @tags UserManagement
     * @name UpdateAbsence
     * @request POST:/api/v1/UserManagement/UpdateAbsence
     * @secure
     * @response `200` `boolean` OK
     */
    updateAbsence: (data: UpdateAbsencePayload, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/api/v1/UserManagement/UpdateAbsence`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Desativa uma ausência para um usuário.
     *
     * @tags UserManagement
     * @name DesactivateAbsence
     * @request POST:/api/v1/UserManagement/DesactivateAbsence
     * @secure
     * @response `200` `boolean` OK
     */
    desactivateAbsence: (
      data: DesactivateAbsencePayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/UserManagement/DesactivateAbsence`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Adiciona ou altera credential do usuário.
     *
     * @tags UserManagement
     * @name AddOrUpdateCredential
     * @request POST:/api/v1/UserManagement/AddOrUpdateCredential
     * @secure
     * @response `200` `string | null` OK (May return null)
     * @response `204` `any` No Content
     */
    addOrUpdateCredential: (
      data: AddOrUpdateCredentialPayload,
      params: RequestParams = {},
    ) =>
      this.request<string | null, any>({
        path: `/api/v1/UserManagement/AddOrUpdateCredential`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Remove credential do usuário.
     *
     * @tags UserManagement
     * @name DeleteCredential
     * @request POST:/api/v1/UserManagement/DeleteCredential
     * @secure
     * @response `200` `boolean` OK
     */
    deleteCredential: (
      data: DeleteCredentialPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/UserManagement/DeleteCredential`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém lista de credenciais do usuário.
     *
     * @tags UserManagement
     * @name GetCredentials
     * @request POST:/api/v1/UserManagement/GetCredentials
     * @secure
     * @response `200` `PaginatedUserCredentials` OK
     */
    getCredentials: (data: GetCredentialsPayload, params: RequestParams = {}) =>
      this.request<PaginatedUserCredentials, any>({
        path: `/api/v1/UserManagement/GetCredentials`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém a lista de arquivos de prontuário do usuário.
     *
     * @tags UserManagement
     * @name GetRecordFiles
     * @request POST:/api/v1/UserManagement/GetRecordFiles
     * @secure
     * @response `200` `ManagedUserRecordFilesResponsePaginatedList` OK
     */
    getRecordFiles: (data: GetRecordFilesPayload, params: RequestParams = {}) =>
      this.request<ManagedUserRecordFilesResponsePaginatedList, any>({
        path: `/api/v1/UserManagement/GetRecordFiles`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Adiciona arquivo aos arquivos de prontuário do usuário.
     *
     * @tags UserManagement
     * @name AddRecordFile
     * @request POST:/api/v1/UserManagement/AddRecordFile
     * @secure
     * @response `200` `boolean` OK
     */
    addRecordFile: (data: AddRecordFilePayload, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/api/v1/UserManagement/AddRecordFile`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Remove arquivos dos arquivos de prontuário do usuário.
     *
     * @tags UserManagement
     * @name DeleteRecordFile
     * @request POST:/api/v1/UserManagement/DeleteRecordFile
     * @secure
     * @response `200` `boolean` OK
     */
    deleteRecordFile: (
      data: DeleteRecordFilePayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/UserManagement/DeleteRecordFile`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém a lista de proficiência em idiomas do usuário.
     *
     * @tags UserManagement
     * @name GetIdioms
     * @request GET:/api/v1/UserManagement/GetIdioms
     * @secure
     * @response `200` `(ManagedUserIdiomsResponse)[]` OK
     */
    getIdioms: (
      query?: {
        /** @format uuid */
        UserId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ManagedUserIdiomsResponse[], any>({
        path: `/api/v1/UserManagement/GetIdioms`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Adiciona e altera proficiência em idiomas do usuário.
     *
     * @tags UserManagement
     * @name AddOrUpdateIdioms
     * @request POST:/api/v1/UserManagement/AddOrUpdateIdioms
     * @secure
     * @response `200` `boolean` OK
     */
    addOrUpdateIdioms: (
      data: AddOrUpdateIdiomsPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/UserManagement/AddOrUpdateIdioms`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém auto-cadastramento pendentes.
     *
     * @tags UserManagement
     * @name AutoRegisterPendingApprovals
     * @request POST:/api/v1/UserManagement/AutoRegisterPendingApprovals
     * @secure
     * @response `200` `ManagedAutoRegisterPendingApprovalDtoPaginatedList` OK
     */
    autoRegisterPendingApprovals: (
      data: AutoRegisterPendingApprovalsPayload,
      params: RequestParams = {},
    ) =>
      this.request<ManagedAutoRegisterPendingApprovalDtoPaginatedList, any>({
        path: `/api/v1/UserManagement/AutoRegisterPendingApprovals`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Aprova ou rejeita o auto-cadastramento de um usuário.
     *
     * @tags UserManagement
     * @name ModerateAutoRegister
     * @request POST:/api/v1/UserManagement/ModerateAutoRegister
     * @secure
     * @response `200` `boolean` OK
     */
    moderateAutoRegister: (
      data: ModerateAutoRegisterPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/UserManagement/ModerateAutoRegister`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  userOperation = {
    /**
     * Obtém configurações para realizar manutenção em lote de usuários.
     *
     * @tags UserOperation
     * @name GetSettings
     * @request POST:/api/v1/UserOperation/GetSettings
     * @secure
     * @response `200` `UserOperationSettingsResponse` OK
     */
    getSettings: (data: GetSettingsBody, params: RequestParams = {}) =>
      this.request<UserOperationSettingsResponse, any>({
        path: `/api/v1/UserOperation/GetSettings`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém lista de usuário disponíveis para seleção (conforme operação).
     *
     * @tags UserOperation
     * @name GetSelectableUsers
     * @request POST:/api/v1/UserOperation/GetSelectableUsers
     * @secure
     * @response `200` `UserInfoDtoPaginatedList` OK
     */
    getSelectableUsers: (
      data: GetSelectableUsersPayload,
      params: RequestParams = {},
    ) =>
      this.request<UserInfoDtoPaginatedList, any>({
        path: `/api/v1/UserOperation/GetSelectableUsers`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Obtém lista de usuários selecionados.
     *
     * @tags UserOperation
     * @name GetSelectedUsers
     * @request POST:/api/v1/UserOperation/GetSelectedUsers
     * @secure
     * @response `200` `UserInfoDtoPaginatedList` OK
     */
    getSelectedUsers: (
      data: GetSelectedUsersPayload,
      params: RequestParams = {},
    ) =>
      this.request<UserInfoDtoPaginatedList, any>({
        path: `/api/v1/UserOperation/GetSelectedUsers`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Adiciona usuário na operação.
     *
     * @tags UserOperation
     * @name AddUser
     * @request POST:/api/v1/UserOperation/AddUser
     * @secure
     * @response `200` `boolean` OK
     */
    addUser: (data: AddUserBody, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/api/v1/UserOperation/AddUser`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Adiciona todos usuários do filtro na operação.
     *
     * @tags UserOperation
     * @name AddAllUsers
     * @request POST:/api/v1/UserOperation/AddAllUsers
     * @secure
     * @response `200` `boolean` OK
     */
    addAllUsers: (data: AddAllUsersPayload, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/api/v1/UserOperation/AddAllUsers`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Remove usuário na operação.
     *
     * @tags UserOperation
     * @name RemoveUser
     * @request POST:/api/v1/UserOperation/RemoveUser
     * @secure
     * @response `200` `boolean` OK
     */
    removeUser: (data: RemoveUserPayload, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/api/v1/UserOperation/RemoveUser`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Limpa lista de usuários selecionados.
     *
     * @tags UserOperation
     * @name ClearUsers
     * @request POST:/api/v1/UserOperation/ClearUsers
     * @secure
     * @response `200` `boolean` OK
     */
    clearUsers: (data: ClearUsersPayload, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/api/v1/UserOperation/ClearUsers`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Executa operação.
     *
     * @tags UserOperation
     * @name ExecuteUserOperation
     * @request POST:/api/v1/UserOperation/ExecuteUserOperation
     * @secure
     * @response `200` `UserOperationResults` OK (May return null)
     * @response `204` `any` No Content
     */
    executeUserOperation: (
      data: ExecuteUserOperationPayload,
      params: RequestParams = {},
    ) =>
      this.request<UserOperationResults, any>({
        path: `/api/v1/UserOperation/ExecuteUserOperation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Importa lista de usuário para seleção de usuários.
     *
     * @tags UserOperation
     * @name ImportUserList
     * @request POST:/api/v1/UserOperation/ImportUserList
     * @secure
     * @response `200` `(StringImportedItemModel)[]` OK
     */
    importUserList: (data: ImportUserListPayload, params: RequestParams = {}) =>
      this.request<StringImportedItemModel[], any>({
        path: `/api/v1/UserOperation/ImportUserList`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Importa arquivo Excel ou Txt de usuário para seleção de usuários.
     *
     * @tags UserOperation
     * @name ImportUserFile
     * @request POST:/api/v1/UserOperation/ImportUserFile
     * @secure
     * @response `200` `(StringImportedItemModel)[]` OK
     */
    importUserFile: (data: ImportUserFilePayload, params: RequestParams = {}) =>
      this.request<StringImportedItemModel[], any>({
        path: `/api/v1/UserOperation/ImportUserFile`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Limpa seleção de usuários importados
     *
     * @tags UserOperation
     * @name ClearImportedUsers
     * @request POST:/api/v1/UserOperation/ClearImportedUsers
     * @secure
     * @response `200` `boolean` OK
     */
    clearImportedUsers: (
      data: ClearImportedUsersPayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/UserOperation/ClearImportedUsers`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  webSearch = {
    /**
     * Executa busca de image utilizando a API do Microsoft Azure.
     *
     * @tags WebSearch
     * @name ImageSearch
     * @request POST:/api/v1/WebSearch/ImageSearch
     * @secure
     * @response `200` `GoogleSearchImageResult` OK
     */
    imageSearch: (data: ImageSearchPayload, params: RequestParams = {}) =>
      this.request<GoogleSearchImageResult, any>({
        path: `/api/v1/WebSearch/ImageSearch`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Proxy para obtenção de uma IMAGEM fora do domínio do site.
     *
     * @tags WebSearch
     * @name ImageProxy
     * @request GET:/api/v1/WebSearch/ImageProxy
     * @secure
     * @response `200` `any` OK
     */
    imageProxy: (
      query?: {
        url?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<any, any>({
        path: `/api/v1/WebSearch/ImageProxy`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),
  };
  workplace = {
    /**
     * Cria um local de trabalho
     *
     * @tags Workplace
     * @name CreateWorkplace
     * @request POST:/api/v1/Workplace/CreateWorkplace
     * @secure
     * @response `200` `string` OK
     */
    createWorkplace: (
      data: CreateWorkplacePayload,
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: `/api/v1/Workplace/CreateWorkplace`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Altera um local de trabalho
     *
     * @tags Workplace
     * @name UpdateWorkplace
     * @request PUT:/api/v1/Workplace/UpdateWorkplace
     * @secure
     * @response `200` `boolean` OK
     */
    updateWorkplace: (
      data: UpdateWorkplacePayload,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/Workplace/UpdateWorkplace`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Remove um local de trabalho
     *
     * @tags Workplace
     * @name DeleteWorkplace
     * @request DELETE:/api/v1/Workplace/DeleteWorkplace
     * @secure
     * @response `200` `boolean` OK
     */
    deleteWorkplace: (
      query?: {
        /** @format uuid */
        WorkplaceId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/Workplace/DeleteWorkplace`,
        method: "DELETE",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Obtém uma lista de locais de trabalho
     *
     * @tags Workplace
     * @name ManagedWorkplaces
     * @request GET:/api/v1/Workplace/ManagedWorkplaces
     * @secure
     * @response `200` `ManagedWorkplaceListQueryResponsePaginatedList` OK
     */
    managedWorkplaces: (
      query?: {
        /** @format int32 */
        PageNumber?: number;
        /** @format int32 */
        PageSize?: number;
        /** @format int32 */
        Offset?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<ManagedWorkplaceListQueryResponsePaginatedList, any>({
        path: `/api/v1/Workplace/ManagedWorkplaces`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
}
